import { EMAIL_SUPPORT } from "../../utils/constants";
import {
  BID_CONTROL_PLACEHOLDER,
  HIGHEST_VOLUME_PLACEHOLDER,
  SAVE_LOCATION_SET_TITLE,
  SAVE_LOCATION_SET_NAME_LABEL,
  SAVE_LOCATION_SET_SAVE_BUTTON,
  SAVE_LOCATION_SET_SAVING_BUTTON,
  SAVE_LOCATION_SET_CANCEL_BUTTON,
  SAVED_LOCATION_SETS_TITLE,
  SAVED_LOCATION_SETS_CLOSE_BUTTON,
  FIELD_OPEN_MAP_RADIUS_SELECT_TITLE,
  FIELD_OPEN_MAP_RADIUS_SELECT_DESCRIPTION,
  LOAD_LOCATION_SET_BUTTON,
  SAVE_LOCATION_SET_BUTTON,
  SAVE_LOCATION_SET_SUCCESS,
  SAVE_LOCATION_SET_ERROR,
  LOAD_LOCATION_SETS_ERROR,
  SAVE_LOCATION_SET_DUPLICATE_ERROR,
  CUSTOMER_ACQUISITION_TITLE,
  CUSTOMER_ACQUISITION_SWITCH_LABEL,
  CUSTOMER_ACQUISITION_ACCOUNT_LEVEL,
  CUSTOMER_ACQUISITION_CAMPAIGN_LEVEL,
  CUSTOMER_ACQUISITION_NEW_CUSTOMER_VALUE,
  CUSTOMER_ACQUISITION_NEW_CUSTOMER_HIGH_VALUE,
  ALERT_PLATFORM_STATUS_BANNER,
  ALERT_REBRAND_BANNER,
  ALERT_REBRAND_BANNER_DISCORD_BODY,
  DISCORD_LINK,
  ALERT_REBRAND_BANNER_APPSUMO_REVIEW_BODY,
  ALERT_REBRAND_BANNER_AFFILIATE_BODY,
  ALERT_REBRAND_BANNER_AFFILIATE_LINK,
  APPSUMO_REVIEW_BANNER_LINK,
  ALERT_REBRAND_BANNER_CAROUSEL_PREVIOUS,
  ALERT_REBRAND_BANNER_CAROUSEL_NEXT,
  MODAL_REBRAND_ADLE_TITLE,
  MODAL_REBRAND_ADLE_DESCRIPTION,
  MODAL_REBRAND_ADLE_GO_TO_ADLE_BUTTON,
  ADS_CONFIGURATION_APPS_TITLE,
  ADS_CONFIGURATION_DESTINATION_TITLE,
  ADS_CAMPAIGN_PREVIEW,
  SEARCH,
  LOADING_INFORMATION,
  AUDIENCE,
  AUDIENCE_TITLE_EXPLANATION,
  AUDIENCE_EXPLANATION,
  ENGAGEMENT,
  ENGAGEMENT_TITLE_EXPLANATION,
  ENGAGEMENT_EXPLANATION,
  RECORDS_IN_TABLE,
  SHOP_DEACTIVATE_ALERT_DESCRIPTION,
  PAGE_IN_TABLE,
  BUTTON_RETRY,
  BUTTON_RETRY_PUBLISHING,
  BUTTON_INVITE,
  BUTTON_EDIT_INVITE,
  BUTTON_VIEW_REQUEST,
  BUTTON_START_NOW,
  BUTTON_REJECT_REQUEST,
  BUTTON_ORDER_IN_PROCESS,
  BUTTON_VIEW_COLLABORATION,
  NEW_CREATORS_CATEGORY,
  CREATORS_TITLE,
  CREATOR_DESCRIPTION,
  SEARCH_BAR_TEXT_CREATORS,
  TAB_CREATORS,
  TAB_REQUESTS,
  TAB_SUGGESTED,
  CREATORS_TABLE_COLUMN_NAME,
  CREATORS_TABLE_COLUMN_CITY,
  CREATORS_TABLE_COLUMN_AUDIENCE,
  CREATORS_TABLE_COLUMN_ENGAGEMENT,
  CREATORS_TABLE_COLUMN_DATE,
  CREATORS_TABLE_COLUMN_CATEGORIES,
  CREATORS_TABLE_COLUMN_SCORE,
  CREATORS_TABLE_COLUMN_ACTIVITY,
  BUTTON_VIEW_INVITE,
  DATE_SHORT,
  CALENDAR_MONTH,
  CALENDAR_WEEK,
  CALENDAR_DAY,
  CALENDAR_TODAY,
  CALENDAR_TOMORROW,
  CALENDAR_NEXT,
  CALENDAR_PREVIOUS,
  CALENDAR_AGENDA,
  CALENDAR_SHOW_MORE,
  VIEW_CALENDAR,
  POST_TITLE,
  CALENDAR_POST_TITLE,
  CALENDAR_INVALID_DATE_ERROR,
  EVENT_DETAILS_DESCRIPTION,
  EVENT_DETAILS_DATE_AND_TIME,
  EVENT_DETAILS_SOCIAL_NETWORK,
  EVENT_DETAILS_STATUS,
  EVENT_DETAILS_STATUS_DRAFT,
  EVENT_DETAILS_STATUS_SCHEDULED,
  EVENT_DETAILS_STATUS_PUBLISHED,
  GALLERY_MAX_SELECTIONS_REACHED,
  GALLERY_PUBLISHED_ON_PLATFORMS,
  GALLERY_PLATFORM_STATUSES_LABEL,
  GALLERY_STATUS_PUBLISHED_DIRECT,
  GALLERY_STATUS_PUBLISHED_DIRECT_UNKNOWN,
  GALLERY_STATUS_SCHEDULED,
  GALLERY_STATUS_SCHEDULED_UNKNOWN,
  GALLERY_STATUS_PUBLISHED_SCHEDULE,
  GALLERY_STATUS_PUBLISHED_SCHEDULE_UNKNOWN,
  GALLERY_STATUS_FAILED,
  GALLERY_STATUS_FAILED_UNKNOWN,
  GALLERY_STATUS_PUBLISHED_LEGACY,
  SHARE_MODAL_PLATFORM_ALREADY_PUBLISHED,
  EVENT_DETAILS_STATUS_FAILED,
  EVENT_DETAILS_NETWORK_INSTAGRAM,
  EVENT_DETAILS_NETWORK_FACEBOOK,
  EVENT_DETAILS_NETWORK_TIKTOK,
  EVENT_DETAILS_NETWORK_LINKEDIN,
  EVENT_DETAILS_NETWORK_YOUTUBE,
  EVENT_DETAILS_CONTENT,
  ORGANIC_PUBLISH_RETRY_CONFIRM_TITLE,
  ORGANIC_PUBLISH_RETRY_CONFIRM_DESCRIPTION,
  ORGANIC_PUBLISH_RETRY_ALERT_ARIA_LABEL,
  ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_PLATFORM,
  ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_MESSAGE,
  ORGANIC_PUBLISH_RETRY_ERROR,
  ORGANIC_PUBLISH_PARTIAL_STATUS,
  BUTTON_VIEW_METRICS,
  QUALITY_AUDIENCE,
  QUALITY_CONTENT,
  CONTENT,
  ANALYTIC,
  EMPTY_COMMENTS,
  COMMENTS,
  SHOW_COMMENTS,
  BUTTON_CANCEL_INVITE,
  ADVANCED_CONFIGURATION,
  MENU_PLATFORM,
  MENU_ACTIONS,
  MENU_CONFIGURATION,
  MENU_ADMINISTRATION,
  SUB_MENU_CREATORS,
  SUB_MENU_PUBLICATIONS,
  SUB_MENU_EVENTS,
  SUB_MENU_CAMPAIGNS,
  SUB_MENU_REPORTS,
  SUB_MENU_REDEEM_CODE,
  SUB_MENU_ORDERS,
  SUB_MENU_ACCOUNT,
  SUB_MENU_STORES,
  SUB_MENU_MENU,
  SUB_MENU_USERS,
  SUB_MENU_BILLING_AND_PAYMENTS,
  SUB_MENU_BILLING_DASHBOARD,
  SUB_MENU_BILLING_DATA,
  SUB_MENU_USERS_OWNER,
  SUB_MENU_BRANDS,
  SUB_MENU_BRAND_SIGNUPS,
  SUB_MENU_CREATORS_OWNER,
  SUB_MENU_CREATORS_EXTERNALS,
  SUB_MENU_PAY_CREATORS,
  SUB_MENU_CREATOR_SIGNUPS,
  SUB_MENU_CONTENTS,
  SUB_MENU_DELIVERIES,
  SUB_MENU_REPORTS_OWNER,
  SUB_MENU_FEEDBACK,
  SUB_MENU_PAYMENTS_FAILED,
  SUB_MENU_DISCOVERY,
  SUB_MENU_GALLERY,
  REQUEST_REJECTED,
  REQUEST_REJECTED_DESCRIPTION,
  REPORTED_CONTENT_STATUS_REJECTED,
  REPORTED_CONTENT_STATUS_PENDING,
  REPORTED_CONTENT_STATUS_APPROVED,
  HELP,
  CREDITS,
  COST_OF_ACTION,
  COST_OF_CAMPAIGN,
  COST_OF_RESIZE,
  CURRENT,
  CURRENT_BALANCE,
  BALANCE_AFTER,
  DEACTIVATE,
  ACTIVATE,
  BRAND,
  NOTIFICATIONS,
  LOGOUT,
  LOADING_SUGGESTED_INFORMATION,
  ALERT_AD_CPA_LOW_LABEL,
  ALERT_AD_CPA_MEDIUM_LABEL,
  ALERT_AD_CPA_HIGH_LABEL,
  ALERT_ASSET_GROUP_CPA_LOW_LABEL,
  ALERT_ASSET_GROUP_CPA_MEDIUM_LABEL,
  ALERT_ASSET_GROUP_CPA_HIGH_LABEL,
  ALERT_AD_GROUP_CPA_LOW_LABEL,
  ALERT_AD_GROUP_CPA_MEDIUM_LABEL,
  ALERT_AD_GROUP_CPA_HIGH_LABEL,
  ALERT_AD_CPA_LOW_TABLE_LABEL,
  ALERT_AD_CPA_MEDIUM_TABLE_LABEL,
  ALERT_AD_CPA_HIGH_TABLE_LABEL,
  ALERT_ASSET_GROUP_CPA_LOW_TABLE_LABEL,
  ALERT_ASSET_GROUP_CPA_MEDIUM_TABLE_LABEL,
  ALERT_ASSET_GROUP_CPA_HIGH_TABLE_LABEL,
  ALERT_AD_GROUP_CPA_LOW_TABLE_LABEL,
  ALERT_AD_GROUP_CPA_MEDIUM_TABLE_LABEL,
  ALERT_AD_GROUP_CPA_HIGH_TABLE_LABEL,
  ALERT_CREATIVE_FATIGUE_MEDIUM_LABEL,
  ALERT_CREATIVE_FATIGUE_HIGH_LABEL,
  ALERT_CREATIVE_FATIGUE_MEDIUM_TABLE_LABEL,
  ALERT_CREATIVE_FATIGUE_HIGH_TABLE_LABEL,
  GO_TO_PROFILE,
  CREATORS_SUGGESTED_EMPTY,
  WARNING,
  WAIT,
  ERROR,
  ERROR_DESCRIPTION_GENERIC,
  LIST_CREATORS_WITH_AUDIENCE_SIMILAR,
  LAST_UPDATE_DATE,
  BUTTON_INIT_CHAT,
  UPDATE,
  INFORMATION_INVALID_ACCESS,
  FOLLOWERS,
  AVG_LIKES,
  AVG_COMMENTS,
  ANALYTICS,
  AVG_VIEWS,
  AUDIENCE_INFORMATION,
  AUDIENCE_CREDIBILITY,
  AUDIENCE_CREDIBILITY_TITLE_EXPLANATION,
  AUDIENCE_CREDIBILITY_DESCRIPTION_EXPLANATION,
  AUDIENCE_BY_COUNTRY,
  AUDIENCE_BY_CITIES,
  AUDIENCE_BY_BRAND_AFFINITY,
  AUDIENCE_BY_INTERESTS,
  FEMALES,
  MALES,
  AUDIENCE_BY_DISTRIBUTION_AGE,
  AUDIENCE_BY_PERCENTAGE_GENDERS,
  BUTTON_USE_AS_REFERENCE_PROFILE,
  AUDIENCE_BY_SIMILAR_AUDIENCE,
  PROFILE,
  PUBLISHED_DATE,
  GALLERY_CONTENT_BUZZLY,
  EMPTY_CONTENT_SHOW,
  LOADING_SIMILAR_PROFILES_INFORMATION,
  EMPTY_SIMILAR_PROFILES_SHOW,
  FIELD_REQUIRED,
  FIELD_MUST_BE_SELECT_AT_LEAST_PRODUCTS,
  EMPTY_RESULTS_SHOW,
  DISCOVER_NEW_CREATORS,
  BUTTON_DOWNLOAD,
  START_DATE_PLACEHOLDER,
  END_DATE_PLACEHOLDER,
  BUTTON_CALCULATE,
  BUTTON_ENTERPRISE_CALCULATE,
  LOADING_REPORT_INFORMATION,
  COLLABORATIONS,
  LIKES,
  SHARES,
  UNKNOWN_FORMAT,
  COLLABORATION,
  CATEGORY,
  REDEEM_CODE_TITLE,
  REDEEM_CODE_DESCRIPTION,
  REDEEM_CODE_SEARCHBAR_PLACEHOLDER,
  BUTTON_REDEEM_CODE,
  BUTTON_ADD_STORE,
  SELECT_STORE,
  STORE,
  EMPTY_STORES,
  REDEEM_CODE_TABLE_COLUMN_VALUE,
  REDEEM_CODE_TABLE_COLUMN_DATE,
  REDEEM_CODE_TABLE_COLUMN_CODE,
  FIELD_NUMERIC,
  FIELD_TEXT,
  FIELD_ALPHANUMERIC,
  CODE_REDEEMED,
  VALUE_CODE_REDEEMED,
  CODE_NO_EXIST,
  CODE_NO_REDEEM_BEFORE_DATE,
  EVENT_NO_EXIST,
  EVENT_DISABLED,
  ORDERS_SEARCHBAR_PLACEHOLDER,
  ORDERS_DESCRIPTION,
  ORDERS_TITLE,
  NEW_ORDER,
  ORDERS_TAB_TO_BE_ACCEPTED,
  ORDERS_TAB_IN_PREPARATION,
  ORDERS_TAB_TO_BE_DELIVERED,
  ORDERS_TAB_TO_BE_ACCEPTED_DESCRIPTION,
  ORDERS_TAB_IN_PREPARATION_DESCRIPTION,
  ORDERS_TAB_TO_BE_DELIVERED_DESCRIPTION,
  NEW,
  MINUTE_LETTER_COUNT_DOWN,
  HOUR_LETTER_COUNT_DOWN,
  DAY_LETTER_COUNT_DOWN,
  WEEK_LETTER_COUNT_DOWN,
  DELIVERY_INTERN,
  DELIVERY_ON_THE_WAY,
  ORDER_ACCEPTED,
  ORDER_ACCEPTED_DESCRIPTION,
  ORDER_READY,
  ORDER_READY_DESCRIPTION,
  ORDER_TO_BE_DELIVERED_CONFIRMATION,
  ORDER_TO_BE_DELIVERED_CONFIRMATION_BUTTON,
  ORDER_DELIVERED,
  ORDER_DELIVERED_DESCRIPTION,
  DELIVERY_SELECTED,
  ORDER_REJECTED,
  ORDER_REJECTED_DESCRIPTION,
  DELIVERY_SELECTED_DESCRIPTION,
  ORDER_TOTAL_VALUE,
  ORDER_LIST_OF_PRODUCTS,
  VALUE_WITH_CURRENCY,
  NUMBER_CURRENCY,
  ORDER_OPTIONS,
  CLIENT,
  ADDRESS,
  IDENTIFICATION_NUMBER,
  PHONE_NUMBER,
  NAME,
  BUTTON_ACCEPT_ORDER,
  BUTTON_REJECT_ORDER,
  DATE_LONG,
  MINUTES,
  HOURS,
  DAYS,
  WEEKS,
  ORDER_TIME_PREPARATION_TITLE,
  MIN_VALUE_PREPARATION_ORDER,
  MAX_VALUE_PREPARATION_ORDER,
  INVALID_TIME_PREPARATION,
  TIME_PREPARATION_VALUES_VALIDATION,
  GO,
  BUTTON_READY_ORDER,
  GUIDE_NUMBER_REQUIRED,
  DELIVERY_TYPE_DUPLICATE,
  SELECT_DELIVERY_TYPE,
  SELECT_DELIVERY_TYPE_OTHER,
  GUIDE_NUMBER,
  DELIVERY_DATA,
  BUTTON_DELIVER_ORDER,
  BUTTON_CANCEL,
  BUTTON_CREATE_CAMPAIGN,
  CAMPAIGNS_TITLE,
  CAMPAIGNS_DESCRIPTION,
  CAMPAIGNS_SEARCHBAR_PLACEHOLDER,
  CAMPAIGNS_TABLE_COLUMN_NAME,
  CAMPAIGNS_TABLE_COLUMN_PLATFORMS,
  CAMPAIGNS_TABLE_COLUMN_STATUS,
  CAMPAIGN_ACTIVATE,
  CAMPAIGN_DEACTIVATE,
  CAMPAIGN_ACTIVATE_TIME_CONFIRMATION,
  CAMPAIGN_DEACTIVATE_TIME,
  CAMPAIGN_DEACTIVATE_APPLICANTS_ACCEPTED,
  CAMPAIGN_ACTIVATE_FIELDS_REQUIRED,
  CAMPAIGN_ACTIVATE_MIN_BUDGET_CREATOR,
  CAMPAIGN_ACTIVATE_TRAFFIC_LINK,
  CAMPAIGN_ACTIVATE_HAS_COLLABORATION_USER_NAME_INSTAGRAM,
  CAMPAIGN_ACTIVATE_ATTACHMENT_LINK,
  CREATE_CAMPAIGN_QUESTION,
  CREATE_CAMPAIGN_ACCEPT_TERMS_DISCLAIMER,
  CREATE_CAMPAIGN_NAME_REQUIRED,
  CREATE_CAMPAIGN_DESCRIPTION_REQUIRED,
  CREATE_CAMPAIGN_BUDGET_REQUIRED,
  CREATE_CAMPAIGN_BUDGET_MIN_VALUE,
  CREATE_CAMPAIGN_PLATFORMS_REQUIRED,
  CREATE_CAMPAIGN_TYPE_CONTENT,
  CREATE_CAMPAIGN_TRAFFIC_LINK_REQUIRED,
  CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_REQUIRED,
  CREATE_CAMPAIGN_MESSAGE_CONTENT_REQUIRED,
  CREATE_CAMPAIGN_DATES_REQUIRED,
  CREATE_CAMPAIGN_REPOST_HAS_COLLABORATION,
  CREATE_CAMPAIGN_AUDIENCE_LOCATION_REQUIRED,
  CREATE_CAMPAIGN_ATTACHMENT_LINK,
  CREATE_CAMPAIGN_HAS_BEEN_ACTIVATE,
  CREATE_CAMPAIGN_HAS_BEEN_SAVE,
  CREATE_CAMPAIGN_SAVE_PROGRESS_NAME_REQUIRED,
  CREATE_CAMPAIGN_SAVE_PROGRESS,
  BUTTON_SAVE_PROGRESS,
  QUESTION,
  CREATE_CAMPAIGN_NAME_EXAMPLE,
  BUTTON_NEXT,
  BUTTON_PREVIOUS,
  BUTTON_ADVANCED_CONFIGURATION,
  BUTTON_FINISH,
  CREATE_CAMPAIGN_NAME_QUESTION,
  CREATE_CAMPAIGN_NAME_PLACEHOLDER,
  CREATE_CAMPAIGN_DESCRIPTION_QUESTION,
  CREATE_CAMPAIGN_DESCRIPTION_PLACEHOLDER,
  CREATE_CAMPAIGN_BUDGET_QUESTION,
  CREATE_CAMPAIGN_BUDGET_DESCRIPTION,
  CREATE_CAMPAIGN_PLATFORMS,
  CREATE_CAMPAIGN_TYPE_CONTENT_QUESTION,
  CREATE_CAMPAIGN_COPYWRITING_QUESTION,
  CREATE_CAMPAIGN_COPYWRITING_PLACEHOLDER,
  CREATE_CAMPAIGN_TRAFFIC_LINK_QUESTION,
  CREATE_CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER,
  CREATE_CAMPAIGN_HAS_COLLABORATION_QUESTION,
  CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_QUESTION,
  CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_PLACEHOLDER,
  CREATE_CAMPAIGN_MESSAGE_CONTENT_QUESTION,
  CREATE_CAMPAIGN_MESSAGE_CONTENT_PLACEHOLDER,
  CREATE_CAMPAIGN_DATES_QUESTION,
  CREATE_CAMPAIGN_DATES_DESCRIPTION,
  CREATE_CAMPAIGN_DATES_START_DATE_PLACEHOLDER,
  CREATE_CAMPAIGN_DATES_END_DATE_PLACEHOLDER,
  CREATE_CAMPAIGN_REPOST_QUESTION,
  CREATE_CAMPAIGN_AUDIENCE_LOCATION_QUESTION,
  CREATE_CAMPAIGN_AUDIENCE_LOCATION_PLACEHOLDER,
  CREATE_CAMPAIGN_AUDIENCE_LOCATION_ALL_OPTION,
  CREATE_CAMPAIGN_AGE_RANGE_QUESTION,
  CREATE_CAMPAIGN_BRIEF_QUESTION,
  CREATE_CAMPAIGN_BRIEF_DESCRIPTION,
  CREATE_CAMPAIGN_UPLOAD_BRIEF,
  CREATE_CAMPAIGN_REMOVED_BRIEF,
  CREATE_CAMPAIGN_ATTACHMENT_FILE_QUESTION,
  CREATE_CAMPAIGN_ATTACHMENT_FILE_DESCRIPTION,
  CREATE_CAMPAIGN_ATTACHMENT_LINK_QUESTION,
  CREATE_CAMPAIGN_ATTACHMENT_LINK_DESCRIPTION,
  CREATE_CAMPAIGN_ATTACHMENT_LINK_PLACEHOLDER,
  CREATE_CAMPAIGN_QUANTITY_GENDER_QUESTION,
  CREATE_CAMPAIGN_REFERENCE_PROFILES_QUESTION,
  CREATE_CAMPAIGN_REFERENCE_PROFILES_PLACEHOLDER,
  CREATE_CAMPAIGN_HASHTAG_QUESTION,
  CREATE_CAMPAIGN_HASHTAG_PLACEHOLDER,
  CREATE_CAMPAIGN_MESSAGE_TONE_QUESTION,
  CREATE_CAMPAIGN_MESSAGE_TONE_PLACEHOLDER,
  CREATE_CAMPAIGN_ENVIRONMENT_QUESTION,
  CREATE_CAMPAIGN_ENVIRONMENT_PLACEHOLDER,
  CREATE_CAMPAIGN_COLORS_CONTENT_QUESTION,
  CREATE_CAMPAIGN_COLORS_CONTENT_PLACEHOLDER,
  CREATE_CAMPAIGN_PROHIBITED_COLORS_CONTENT_QUESTION,
  CREATE_CAMPAIGN_PROHIBITED_COLORS_CONTENT_PLACEHOLDER,
  CREATE_CAMPAIGN_KEY_WORDS_QUESTION,
  CREATE_CAMPAIGN_PROHIBITED_WORDS_QUESTION,
  CREATE_CAMPAIGN_PROHIBITED_WORDS_PLACEHOLDER,
  CREATE_CAMPAIGN_OUTFIT_QUESTION,
  CREATE_CAMPAIGN_OUTFIT_PLACEHOLDER,
  BUTTON_UPLOAD_CONTENT,
  BUTTON_UPLOAD_DOCUMENT,
  BUTTON_REMOVE_CONTENT,
  DELETE_CONTENT_CONFIRMATION_TITLE,
  DELETE_CONTENT_CONFIRMATION_DESCRIPTION,
  DELETE_SCHEDULED_CONTENT_CONFIRMATION_TITLE,
  DELETE_SCHEDULED_CONTENT_CONFIRMATION_DESCRIPTION,
  DELETE_SCHEDULED_CONTENT_ERROR_DESCRIPTION,
  DELETE_SCHEDULED_CONTENT_SUCCESS,
  DELETE_MULTIPLE_CONTENT_CONFIRMATION_TITLE,
  DELETE_MULTIPLE_CONTENT_CONFIRMATION_DESCRIPTION,
  BUTTON_DELETE_CONTENT,
  CREATE_CAMPAIGN_KEY_WORDS_PLACEHOLDER,
  READY,
  FIELD_HAS_NO_VALUE_TO_COPY,
  BUTTON_FINISHED_CAMPAIGN,
  CAMPAIGN_FINISHED_CONFIRMATION,
  BUTTON_SAVE_CAMPAIGN,
  BUTTON_DEACTIVATE_CAMPAIGN,
  BUTTON_ACTIVATE_CAMPAIGN,
  CAMPAIGN_HAS_BEEN_FINISHED,
  CAMPAIGN_DETAIL_TITLE,
  CAMPAIGN_DETAIL_APPLICANTS_ACCEPTED_TITLE,
  CAMPAIGN_DETAIL_CREATORS_INVITED_TITLE,
  CAMPAIGN_DETAIL_CAMPAIGN_INFORMATION_TITLE,
  ACTIONS,
  STATUS,
  CITIES,
  CATEGORIES,
  CAMPAIGN_FINISH_APPLICANTS_ACCEPTED,
  PAYMENT_SUCCESSFUL,
  UPGRADE_SUBSCRIPTION_SUCCESSFUL,
  BUTTON_SEND_INVITE,
  CAMPAIGN_DETAIL_APPLICANT_PAYMENT_DESCRIPTION,
  CAMPAIGN_DETAIL_APPLICANT_PAYMENT_ADDITIONAL_DESCRIPTION,
  CAMPAIGN_DETAIL_REJECT_APPLICANT_CONFIRMATION,
  BUTTON_REJECT,
  LIST_OF_CREATORS,
  CAMPAIGN_FIELDS_REQUIRED,
  CAMPAIGN_NAME_PLACEHOLDER,
  CAMPAIGN_DESCRIPTION_PLACEHOLDER,
  CAMPAIGN_BUDGET_PLACEHOLDER,
  CAMPAIGN_PLATFORMS_PLACEHOLDER,
  CAMPAIGN_TYPE_CONTENT_PLACEHOLDER,
  CAMPAIGN_COPY_POST_PLACEHOLDER,
  CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER,
  CAMPAIGN_HAS_COLLABORATION_PLACEHOLDER,
  CAMPAIGN_PRODUCT_ATTRIBUTES_PLACEHOLDER,
  CAMPAIGN_MESSAGE_CONTENT_PLACEHOLDER,
  CAMPAIGN_DATES_START_DATE_PLACEHOLDER,
  CAMPAIGN_DATES_END_DATE_PLACEHOLDER,
  CAMPAIGN_REPOST_PLACEHOLDER,
  CAMPAIGN_AUDIENCE_LOCATION_PLACEHOLDER,
  CAMPAIGN_AGE_RANGE_PLACEHOLDER,
  CAMPAIGN_BRIEF_PLACEHOLDER,
  CAMPAIGN_BRIEF_DESCRIPTION,
  CAMPAIGN_ATTACHMENT_FILE_PLACEHOLDER,
  CAMPAIGN_ATTACHMENT_FILE_DESCRIPTION,
  CAMPAIGN_ATTACHMENT_LINK_TITLE,
  CAMPAIGN_ATTACHMENT_LINK_DESCRIPTION,
  CAMPAIGN_ATTACHMENT_LINK_PLACEHOLDER,
  CAMPAIGN_GENDERS_PLACEHOLDER,
  CAMPAIGN_REFERENCE_PROFILES_PLACEHOLDER,
  CAMPAIGN_HASHTAG_PLACEHOLDER,
  CAMPAIGN_MESSAGE_TONE_PLACEHOLDER,
  CAMPAIGN_ENVIRONMENT_PLACEHOLDER,
  CAMPAIGN_COLORS_CONTENT_PLACEHOLDER,
  CAMPAIGN_PROHIBITED_COLORS_CONTENT_PLACEHOLDER,
  CAMPAIGN_KEY_WORDS_PLACEHOLDER,
  CAMPAIGN_PROHIBITED_KEY_WORDS_PLACEHOLDER,
  CAMPAIGN_OUTFIT_PLACEHOLDER,
  BUTTON_ASSIGN_INVITE,
  BUTTON_REVIEW_CONTENT,
  BUTTON_ACCEPT,
  BUTTON_VIEW_PRELIMINARY_CONTENT,
  BUTTON_VIEW_APPLICANT,
  BUTTON_ACCEPT_AND_PAY,
  PAYMENT_METHOD,
  PAYMENT_METHODS,
  CONTENT_CREATOR,
  PRICE_TO_BE_PAID,
  PAYMENT_METHODS_SECURE,
  PAYMENT_METHODS_SECURE_EXPLANATION,
  PAYMENT_METHODS_ENCRYPTED,
  PAY,
  PAYMENT_METHODS_EMPTY,
  MAIN_PAYMENT_METHOD,
  OTHERS_PAYMENT_METHODS_EMPTY,
  OTHERS_PAYMENT_METHODS,
  ADD_CARD,
  VERIFY_SUBSCRIPTION_TITLE,
  VERIFY_SUBSCRIPTION_DESCRIPTION,
  VERIFY_SUBSCRIPTION_CTA,
  SAVE_CONFIGURATION,
  ADD,
  NAME_PLACEHOLDER,
  EMAIL_PLACEHOLDER,
  PASSWORD_PLACEHOLDER,
  PASSWORD_CONFIRMATION_PLACEHOLDER,
  CARD_INFORMATION_EXPLANATION_TITLE,
  CARD_INFORMATION_NUMBER_CARD_EXPLANATION_DESCRIPTION,
  CARD_INFORMATION_NUMBER_CARD_EXPLANATION_TITLE,
  CARD_INFORMATION_EXPIRATION_DATE_EXPLANATION_TITLE,
  CARD_INFORMATION_EXPIRATION_DATE_EXPLANATION_DESCRIPTION,
  CARD_INFORMATION_CVV_EXPLANATION_TITLE,
  CARD_INFORMATION_CVV_EXPLANATION_DESCRIPTION,
  APPLICANTS_STATUS_PENDING,
  APPLICANTS_STATUS_ACCEPTED,
  APPLICANTS_STATUS_REJECTED,
  APPLICANTS_STATUS_CONTENT_SUBMITTED,
  APPLICANTS_STATUS_CONTENT_REVISIONS,
  APPLICANTS_STATUS_CONTENT_PENDING_SOCIAL,
  APPLICANTS_STATUS_CONTENT_PENDING_ANALYTICS,
  APPLICANTS_STATUS_DELIVERED,
  BUTTON_REVIEW,
  APPLICANT_CONTENT_OF_CREATOR,
  APPLICANT_REVISION_PLACEHOLDER,
  BUTTON_ACCEPT_CONTENT,
  BUTTON_REJECT_CONTENT,
  BUTTON_SEND_REVIEW,
  BUTTON_CONTINUE,
  BUTTON_SIGN_UP,
  BUTTON_MORE_QUESTIONS,
  BUTTON_UNDERSTOOD,
  WARNING_MOBILE_TUTORIAL,
  FAQ_DESCRIPTION,
  EMPTY_QUESTIONS_SHOW,
  BUTTON_INIT_TUTORIAL,
  FAQ_QUESTION_WHAT_IS_BUZZLY,
  FAQ_QUESTION_WHAT_IS_BUZZLY_DESCRIPTION,
  FAQ_QUESTION_WHAT_IS_REQUEST,
  FAQ_QUESTION_WHAT_IS_REQUEST_DESCRIPTION,
  FAQ_QUESTION_WHAT_IS_PUBLICATION,
  FAQ_QUESTION_WHAT_IS_PUBLICATION_DESCRIPTION,
  FAQ_QUESTION_WHAT_IS_CAMPAIGN,
  FAQ_QUESTION_WHAT_IS_CAMPAIGN_DESCRIPTION,
  FAQ_QUESTION_WHAT_IS_ORDER,
  FAQ_QUESTION_WHAT_IS_ORDER_DESCRIPTION,
  FAQ_QUESTION_WHAT_IS_STORE,
  FAQ_QUESTION_WHAT_IS_STORE_DESCRIPTION,
  FAQ_QUESTION_WHAT_ROLES_EXISTS,
  FAQ_QUESTION_WHAT_ROLES_EXISTS_DESCRIPTION,
  FAQ_QUESTION_ADDITIONAL_ACTIONS_DELIVERED_PRODUCTS,
  FAQ_QUESTION_ADDITIONAL_ACTIONS_DELIVERED_PRODUCTS_DESCRIPTION,
  FAQ_QUESTION_MUST_CALL_ADMIN,
  FAQ_QUESTION_MUST_CALL_ADMIN_DESCRIPTION,
  FAQ_QUESTION_CREATOR_REDEEM_CODE_WITH_MINOR_VALUE,
  FAQ_QUESTION_CREATOR_REDEEM_CODE_WITH_MINOR_VALUE_DESCRIPTION,
  BUTTON_PAYMENTS,
  BUTTON_BROADCAST,
  BUTTON_SAVE,
  RECURRENT_FIELDS_DEFAULT_TITLE,
  RECURRENT_FIELD_REPEAT_COUNT_MIN_VALIDATION,
  RECURRENT_FIELD_REPEAT_COUNT_PLACEHOLDER,
  RECURRENT_FIELD_REPEAT_COUNT_MAX_VALIDATION,
  RECURRENT_FIELD_FREQUENCY_PLACEHOLDER,
  RECURRENT_FIELD_DAY_AN_PLACEHOLDER,
  RECURRENT_FIELD_DAY_ALL_PLACEHOLDER,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
  SUNDAY,
  SELECT_A_OPTION,
  WEEK,
  MONTH,
  MONTHS,
  MODAL_BROADCAST_ARIAL_LABEL,
  MODAL_BROADCAST_TITLE,
  MODAL_BROADCAST_SELECT_USER_PLACEHOLDER,
  MODAL_BROADCAST_SELECT_USER_REQUIRED,
  MODAL_BROADCAST_MESSAGE_PLACEHOLDER,
  BROADCAST_MESSAGE_SENT,
  BUTTON_SEND_MESSAGE,
  BUTTON_UPLOAD_FILE,
  BUTTON_REMOVE_FILE,
  FILE_SELECTED,
  SELECT_PAYMENT_METHOD,
  YOU_WILL_PAY,
  DAY,
  HOUR,
  MINUTE,
  SECOND,
  SECONDS,
  PUBLICATION_TITLE,
  NUMBER_PUBLICATION,
  FEEDBACK_TITLE,
  PUBLICATION_FINISH_ONBOARDING_NEW_BRANDS_DESCRIPTION,
  PUBLICATION_FINISH_DESCRIPTION,
  FEEDBACK_PLACEHOLDER,
  FIELD_MIN_LENGTH,
  PUBLICATIONS_TITLE,
  PUBLICATIONS_DESCRIPTION,
  PUBLICATIONS_TABLE_ARIA_LABEL,
  PUBLICATIONS_TABLE_COLUMN_DATE,
  PUBLICATION_STATUS_PENDING,
  PUBLICATIONS_STATUS_PENDING_ANALYTICS,
  PUBLICATIONS_STATUS_SENT,
  PUBLICATIONS_STATUS_FEEDBACK,
  PUBLICATIONS_STATUS_VERIFIED,
  FEEDBACK_REASON,
  FEEDBACK_COMMENT,
  ANALYTICS_EXPLANATION_TITLE,
  ANALYTICS_EXPLANATION_DESCRIPTION,
  ANALYTICS_EXPLANATION_DESCRIPTION_2,
  ANALYTICS_EXPLANATION_ACCOUNTS_REACHED_DESCRIPTION,
  ANALYTICS_EXPLANATION_ENGAGEMENT_DESCRIPTION,
  ANALYTICS_EXPLANATION_STICKERS_TAPS_DESCRIPTION,
  ANALYTICS_EXPLANATION_NAVIGATION_DESCRIPTION,
  EMPTY_ANALYTICS,
  BUTTON_VERIFY_PUBLICATION,
  FEEDBACK_REASON_ABOUT,
  YES,
  NO,
  RECURRENT_VALUE_NOT_FOUND,
  MODAL_REVIEW_ARIA_LABEL,
  MODAL_REVIEW_DISCLAIMER,
  MODAL_REVIEW_SCORE_CONTENT_PLACEHOLDER,
  MODAL_REVIEW_SCORE_CONTENT_MIN_VALUE,
  MODAL_REVIEW_SCORE_CONTENT_EXPLANATION_TITLE,
  MODAL_REVIEW_SCORE_CONTENT_EXPLANATION_DESCRIPTION,
  MODAL_REVIEW_SCORE_ENGAGEMENT_PLACEHOLDER,
  MODAL_REVIEW_SCORE_ENGAGEMENT_MIN_VALUE,
  MODAL_REVIEW_COMMENT_PLACEHOLDER,
  LOADING_DOWNLOAD_PROFILES,
  BUTTON_SEARCH,
  BUTTON_METRICS_READY,
  IMAGES,
  VIDEOS,
  LOADING_CONTENT,
  MODAL_GALLERY_ARIA_LABEL,
  MODAL_GALLERY_EMPTY_CONTENT,
  SELECT_ACCOUNT_TO_LOAD_GALLERY_CONTENT,
  SELECT_YOUTUBE_ACCOUNT_TO_LOAD_GALLERY_CONTENT,
  MODAL_GALLERY_NO_MORE_CONTENT,
  MODAL_MEDIA_ARIA_LABEL,
  BUTTON_UPLOAD_TIKTOK,
  MODAL_UPLOAD_TIKTOK_ARIA_LABEL,
  MODAL_UPLOAD_TIKTOK_TITLE,
  MODAL_UPLOAD_FAILED_GET_CONFIGURATION,
  LOADING_CONFIGURATION,
  BUTTON_VIEW_PROFILE,
  BUTTON_GENERATE_DESCRIPTION,
  MODAL_UPLOAD_CONTENT_UPLOADED,
  MODAL_UPLOAD_TIKTOK_VIDEO_UPLOADED_DESCRIPTION,
  MODAL_UPLOAD_FAILED_GENERATE_DESCRIPTION,
  MODAL_UPLOAD_TIKTOK_DESCRIPTION_LABEL,
  MODAL_UPLOAD_TIKTOK_DESCRIPTION_PLACEHOLDER,
  MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_LABEL,
  MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_PUBLIC_OPTION,
  MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_FOLLOWERS_OPTION,
  MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_ONLY_I_OPTION,
  MODAL_UPLOAD_TIKTOK_ALLOW_USERS_PLACEHOLDER,
  MODAL_UPLOAD_TIKTOK_ALLOW_USERS_COMMENT_OPTION,
  MODAL_UPLOAD_TIKTOK_ALLOW_USERS_DUOS_OPTION,
  MODAL_UPLOAD_TIKTOK_ALLOW_USERS_CUT_OPTION,
  ACCOUNT_TITLE,
  ACCOUNT_DESCRIPTION,
  BUTTON_UPLOAD_IMAGE,
  BUTTON_REMOVE_IMAGE,
  FIELD_IMAGE_REQUIRED,
  FIELD_IMAGE_FORMAT_VALID,
  FIELD_IMAGE_SIZE_VALID,
  FIELD_FILE_REQUIRED,
  FIELD_FILE_SIZE_VALID,
  FIELD_URL_VALID,
  FIELD_URL_ADLE_APP_DOMAIN,
  COMPANY_INFORMATION_TITLE,
  COMPANY_INFORMATION_SUBCATEGORY_DUPLICATE,
  COMPANY_INFORMATION_TYPE_ID_PLACEHOLDER,
  COMPANY_INFORMATION_ID_NUMBER_PLACEHOLDER,
  COMPANY_INFORMATION_ID_NUMBER_MIN_LENGTH,
  COMPANY_INFORMATION_ID_NUMBER_TYPE,
  COMPANY_INFORMATION_BRAND_NAME_PLACEHOLDER,
  COMPANY_INFORMATION_BUSINESS_NAME_PLACEHOLDER,
  COMPANY_INFORMATION_ADDRESS_PLACEHOLDER,
  COMPANY_INFORMATION_AVERAGE_TICKET_PLACEHOLDER,
  COMPANY_INFORMATION_AVERAGE_TICKET_MIN_VALUE,
  COMPANY_INFORMATION_SOCIAL_NETWORK_PLACEHOLDER,
  COMPANY_INFORMATION_SECOND_SOCIAL_NETWORK_PLACEHOLDER,
  COMPANY_INFORMATION_TRAFFIC_URL_PLACEHOLDER,
  COMPANY_INFORMATION_CATEGORY_PLACEHOLDER,
  COMPANY_INFORMATION_SUBCATEGORY_PLACEHOLDER,
  COMPANY_INFORMATION_NEW_SUBCATEGORY,
  COMPANY_INFORMATION_SHORT_DESCRIPTION_PLACEHOLDER,
  COMPANY_INFORMATION_ADMIN_PHONE_PLACEHOLDER,
  COMPANY_INFORMATION_RESERVATION_URL_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_LOGO_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_LOGO_DESCRIPTION_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_COVER_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_COVER_DESCRIPTION_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_REGULATORY_DOCUMENT_PLACEHOLDER,
  COMPANY_INFORMATION_UPLOAD_REGULATORY_DOCUMENT_DESCRIPTION_PLACEHOLDER,
  COMPANY_INFORMATION_VIEW_DOCUMENT,
  COMPANY_INFORMATION_SHOP_ID_COPIED,
  BUTTON_SAVE_CHANGES,
  BUTTON_UPLOAD_VIDEO,
  BUTTON_REMOVE_VIDEO,
  BUTTON_DISCONNECT,
  BUTTON_CONNECT_TIKTOK,
  PLATFORMS_CONNECTED_TITLE,
  SCHEDULE_TITLE,
  SCHEDULE_ECOMMERCE_ALERT_TITLE,
  SCHEDULE_ECOMMERCE_ALERT_DESCRIPTION,
  SCHEDULE_ONE_DAY_WITH_TURN,
  SCHEDULE_EMPTY_TURN,
  SCHEDULE_OPEN_AND_CLOSE_HOUR_VALIDATION,
  SCHEDULE_MAX_CLOSE_HOUR,
  BUTTON_BE_ECOMMERCE,
  BUTTON_NOT_BE_ECOMMERCE,
  BUTTON_ADD_TURN,
  SCHEDULE_TABLE_ARIA_LABEL,
  SCHEDULE_TABLE_COLUMN_OPEN,
  SCHEDULE_TABLE_COLUMN_CLOSE,
  SCHEDULE_SAVED,
  LEGAL_REPRESENTATIVE_TITLE,
  LEGAL_REPRESENTATIVE_NAME_PLACEHOLDER,
  LEGAL_REPRESENTATIVE_LAST_NAME_PLACEHOLDER,
  LEGAL_REPRESENTATIVE_TYPE_ID_PLACEHOLDER,
  LEGAL_REPRESENTATIVE_ID_NUMBER_PLACEHOLDER,
  LEGAL_REPRESENTATIVE_PHONE_PLACEHOLDER,
  LEGAL_REPRESENTATIVE_SAVED,
  PASSWORD_TITLE,
  PASSWORD_CURRENT_PASSWORD_PLACEHOLDER,
  PASSWORD_NEW_PASSWORD_PLACEHOLDER,
  PASSWORD_CONFIRM_PASSWORD_PLACEHOLDER,
  PASSWORD_FORMAT_DESCRIPTION,
  PASSWORD_FORMAT_SUGGESTION1,
  PASSWORD_FORMAT_SUGGESTION2,
  PASSWORD_FORMAT_SUGGESTION3,
  PASSWORD_FORMAT_SUGGESTION4,
  PASSWORD_INSECURE,
  PASSWORDS_NOT_MATCH,
  PASSWORD_CHANGED,
  PASSWORD_CURRENT_INVALID,
  PASSWORD_ACCOUNT_DISABLED_FOR_MORE_INTENTS,
  OK,
  BUTTON_DELETE,
  BUTTON_CREATE,
  MODAL_STORE_ARIA_LABEL,
  MODAL_STORE_TYPE_PLACEHOLDER,
  MODAL_STORE_HOW_TO_INTEGRATE_STORE,
  MODAL_STORE_NAME_PLACEHOLDER,
  MODAL_STORE_DESCRIPTION_PLACEHOLDER,
  MODAL_STORE_ADDRESS_PLACEHOLDER,
  MODAL_STORE_CITY_PLACEHOLDER,
  MODAL_STORE_PHONE_PLACEHOLDER,
  MODAL_STORE_LINK_STORE_SPECIAL_PLACEHOLDER,
  MODAL_STORE_NAME_SHOPIFY_PLACEHOLDER,
  MODAL_STORE_LOOK_NAME_SHOPIFY,
  MODAL_STORE_LOOK_NAME_SHOPIFY_HELPER_TEXT,
  MODAL_STORE_ACCESS_TOKEN_FOR_BUZZLY_PLACEHOLDER,
  MODAL_STORE_DO_CREATE_DISCOUNT_SHIPPING_PLACEHOLDER,
  MODAL_STORE_CITIES_PLACEHOLDER,
  MODAL_STORE_ORDERS_METHODS_PLACEHOLDER,
  MODAL_STORE_ORDERS_METHODS_DELIVERY_OPTION,
  MODAL_STORE_ORDERS_METHODS_IN_STORE_OPTION,
  MODAL_STORE_PRODUCT_AVAILABILITY_PLACEHOLDER,
  MODAL_STORE_PRODUCT_AVAILABILITY_NATIONAL_OPTION,
  MODAL_STORE_PRODUCT_AVAILABILITY_LOCAL_OPTION,
  MODAL_STORE_COVERAGE_RADIUS_PLACEHOLDER,
  FIELD_EMAIL_VALID,
  FIELD_SPACES_VALID,
  MODAL_STORE_TYPE_REGULAR_OPTION,
  FIELD_PHONE_VALID,
  BUTTON_CREATE_USER,
  BUTTON_CREATE_ACCOUNT,
  MODAL_CREATE_ACCOUNT_TITLE,
  MODAL_CREATE_ACCOUNT_DESCRIPTION,
  FILTER,
  OPERATOR,
  ADMIN,
  USERS_TITLE,
  USERS_DESCRIPTION,
  USERS_TABS_ARIA_LABEL,
  USERS_PORTAL_TAB,
  USERS_CONTACTS_TAB,
  USERS_EMAIL_DUPLICATE,
  USERS_USER_CREATED,
  USERS_USER_SAVED,
  USERS_USER_DELETE_CONFIRMATION_TITLE,
  USERS_USER_DELETE_CONFIRMATION_DESCRIPTION,
  USERS_USER_DELETING,
  USERS_USER_DELETED,
  USERS_LIMIT_REACHED,
  ADVERTISERS_LIMIT_REACHED,
  USERS_ONBOARDING_FINISH,
  USERS_USER_SEARCH_BAR_PLACEHOLDER,
  USERS_TABLE_ARIA_LABEL,
  USERS_TABLE_COLUMN_NAME,
  USERS_TABLE_COLUMN_EMAIL,
  USERS_TABLE_COLUMN_STORE,
  USERS_TABLE_COLUMN_ROLE,
  MODAL_USER_ARIA_LABEL,
  MODAL_USER_TITLE,
  MODAL_USER_NAME_PLACEHOLDER,
  MODAL_USER_ROLE_PLACEHOLDER,
  MODAL_USER_ROLE_OPERATOR_EXPLANATION,
  MODAL_USER_STORE_PLACEHOLDER,
  MODAL_USER_PASSWORD_PLACEHOLDER,
  MODAL_USER_REPEAT_PASSWORD_PLACEHOLDER,
  FIELD_ALL_REQUIRED,
  FIELD_PASSWORDS_NO_MATCH,
  FIELD_PASSWORD_MIN_LENGTH,
  BUTTON_CREATE_CONTACT,
  USERS_CONTACT_CREATED,
  USERS_CONTACT_SAVED,
  USERS_CONTACT_DELETE_CONFIRMATION_TITLE,
  USERS_CONTACT_DELETE_CONFIRMATION_DESCRIPTION,
  USERS_CONTACT_DELETED,
  USERS_CONTACT_SEARCH_BAR_PLACEHOLDER,
  USERS_CONTACT_TABLE_ARIA_LABEL,
  USERS_CONTACT_TABLE_COLUMN_PHONE,
  MODAL_CONTACT_ARIA_LABEL,
  MODAL_CONTACT_TITLE,
  MODAL_CONTACT_PHONE_PLACEHOLDER,
  STORAGE_USAGE_TITLE,
  STORAGE_USAGE_LABEL,
  STORAGE_FULL_TITLE,
  STORAGE_FULL_MESSAGE,
  STORAGE_FULL_BUTTON_DELETE,
  STORAGE_FULL_BUTTON_UPGRADE,
  BILLING_DATA_TITLE,
  BILLING_DATA_DESCRIPTION,
  BILLING_DATA_SAVED,
  BILLING_DATA_PERSONAL_INFORMATION_DESCRIPTION,
  BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_PLACEHOLDER,
  BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_NATURE_OPTION,
  BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_LEGAL_OPTION,
  BILLING_DATA_PERSONAL_INFORMATION_BUSINESS_NAME_PLACEHOLDER,
  BILLING_DATA_PERSONAL_INFORMATION_NAME_PLACEHOLDER,
  BILLING_DATA_PERSONAL_INFORMATION_LAST_NAME_PLACEHOLDER,
  BILLING_DATA_PERSONAL_INFORMATION_TYPE_ID_PLACEHOLDER,
  BILLING_DATA_PERSONAL_INFORMATION_ID_NUMBER_PLACEHOLDER,
  BILLING_DATA_CONTACT_INFORMATION_DESCRIPTION,
  BILLING_DATA_CONTACT_INFORMATION_EMAIL_BILLING_PLACEHOLDER,
  BILLING_DATA_CONTACT_INFORMATION_ADDRESS_PLACEHOLDER,
  BILLING_DATA_CONTACT_INFORMATION_PHONE_PLACEHOLDER,
  BILLING_AND_PAYMENTS_TITLE,
  BILLING_AND_PAYMENTS_DESCRIPTION,
  BUTTON_VIEW_DETAILS,
  BUTTON_DOWNLOAD_INVOICE,
  BUTTON_CLOSE,
  TOTAL,
  BILLING_AND_PAYMENTS_TABLE_ARIA_LABEL,
  BILLING_AND_PAYMENTS_TABLE_COLUMN_PAID_DATE,
  BILLING_AND_PAYMENTS_TABLE_COLUMN_DUE_DATE,
  BILLING_AND_PAYMENTS_TABLE_COLUMN_VALUE,
  BILLING_AND_PAYMENTS_TABLE_COLUMN_REASON,
  BILLING_AND_PAYMENTS_TABLE_COLUMN_STATUS,
  PAYMENT_REASON_COLLABORATION,
  PAYMENT_REASON_APPLICANT,
  PAYMENT_REASON_CLAPP_CREDITS,
  PAYMENT_REASON_PACKAGE,
  PAYMENT_REASON_PLAN,
  PAYMENT_PAID,
  PAYMENT_PENDING,
  MODAL_INVOICE_ARIA_LABEL,
  MODAL_INVOICE_TITLE,
  MODAL_INVOICE_DISCLAIMER,
  MODAL_INVOICE_NUMBER_CREDITS,
  PURCHASE_CREDITS,
  PURCHASE_VIDEOS,
  PURCHASE_X_CREDITS,
  MODAL_INVOICE_ORDER_TO_COLLECT,
  MODAL_INVOICE_APPLICANT_CAMPAIGN_PAID,
  MODAL_PAY_INVOICE_ARIA_LABEL,
  MODAL_PAY_INVOICE_TITLE,
  MODAL_PAY_INVOICE_WILL_PAY,
  MODAL_PAY_SUBSCRIPTION_PENDING_INVOICE_MESSAGE,
  MODAL_PAY_SUBSCRIPTION_PAY_NOW,
  MODAL_PAY_SUBSCRIPTION_PENDING_PAYMENT_TITLE,
  BILLING_PENDING_SUBSCRIPTION_PAYMENT_DESCRIPTION,
  NO_HAVE,
  ADD_PAYMENT_METHOD,
  SUPPORT,
  CONTACT_US,
  BILLING_AND_PAYMENT_CHANGE_YOUR_PLAN,
  BILLING_AND_PAYMENT_ACTIVATE_PLAN,
  BILLING_AND_PAYMENT_SELECT_PLAN,
  BILLING_AND_PAYMENT_NO_HAVE_PLAN,
  BILLING_AND_PAYMENT_PLAN_EXPIRED,
  BILLING_AND_PAYMENT_PLAN_NAME,
  BILLING_AND_PAYMENT_MODEL_USAGE_COLLABORATION_COST,
  BILLING_AND_PAYMENT_MODEL_USAGE_WHAT_BENEFITS,
  BILLING_AND_PAYMENT_MODEL_USAGE_SHOW_BENEFTIS,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT1,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT2,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT3,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT4,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT5,
  BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT6,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_NAME,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_CHANGE,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_COLLECT_COST_COLLABORATION,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_ADD_PAYMENT_METHOD_TO_ACTIVATE,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_EXPIRED,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_NO_HAVE_PACKAGE,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_ACTIVATE_PACKAGE,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_SELECT_PACKAGE,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_CANCEL_PACKAGE,
  MODAL_SELECT_PACKAGE_ARIA_LABEL,
  MODAL_SELECT_PACKAGE_AND_PAYMENT_METHOD_REQUIRED,
  MODAL_SELECT_PACKAGE_UPLOAD_GROWTH,
  MODAL_SELECT_PACKAGE_PRICING_HERO_TITLE,
  MODAL_SELECT_PACKAGE_PRICING_DISCOVER_BUZZLY,
  MODAL_SELECT_PACKAGE_UPLOAD_GROWTH_DESCRIPTION,
  MODAL_SELECT_PACKAGE_PRICING_HERO_DESCRIPTION,
  MODAL_SELECT_PACKAGE_VALUE_EXPRESSED,
  MODAL_SELECT_PACKAGE_PRICE,
  MODAL_SELECT_PACKAGE_PRICE_UPLOAD_GROWTH,
  MODAL_SELECT_PACKAGE_ACCORDING_TO_THE_REQUIREMENT,
  MODAL_SELECT_PACKAGE_BUY_PACKAGE_NAME,
  MODAL_SELECT_PACKAGE_COST_COLLABORATION,
  MODAL_SELECT_PACKAGE_BENEFIT_CATALOG,
  MODAL_SELECT_PACKAGE_BENEFIT_AUTOMATIZATION,
  MODAL_SELECT_PACKAGE_BENEFIT_SUPPORT_TICKETS,
  MODAL_SELECT_PACKAGE_BENEFIT_ALL_BASIC,
  MODAL_SELECT_PACKAGE_BENEFIT_KAM,
  MODAL_SELECT_PACKAGE_BENEFIT_DISCOVERY,
  MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_CHAT,
  MODAL_SELECT_PACKAGE_BENEFIT_ASSISTANCE_MARKETING,
  MODAL_SELECT_PACKAGE_BENEFIT_ALL_GROWTH,
  MODAL_SELECT_PACKAGE_BENEFIT_BRANDS_UNLIMITED,
  MODAL_SELECT_PACKAGE_BENEFIT_PERSONALIZED_INTEGRATIONS,
  MODAL_SELECT_PACKAGE_BENEFIT_IMPLEMENTATIONS_TECHNOLOGICAL,
  MODAL_SELECT_PACKAGE_BENEFIT_PRIORITIZED_SUPPORT,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_WHAT_BENEFITS,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_COST_COLLABORATION,
  BILLING_AND_PAYMENT_MODEL_PACKAGE_CANCEL_DISCLAIMER,
  COMPANY_INFORMATION_ONBOARDING_FINISH_DESCRIPTION,
  MODAL_FREE_TRIAL_TITLE,
  MODAL_FREE_TRIAL_DESCRIPTION,
  MODAL_FREE_TRIAL_BUTTON,
  ACCEPT_TERMS_PAY,
  DELETE_PAYMENT_METHOD_CONFIRMATION_TITLE,
  QUANTITY_TO_PAY,
  BLOCK_PAYMENT_FAILED_TITLE,
  BLOCK_TRIAL_END_TITLE,
  BLOCK_PLAN_BUTTON,
  MODAL_BUY_CREDITS_ARIA_LABEL,
  MODAL_BUY_CREDITS_TITLE,
  MODAL_BUY_CREDITS_DESCRIPTION,
  MODAL_BUY_CREDITS_CREDIT_FOR_COLLABORATION,
  MODAL_BUY_CREDITS_HOW_MANY_CREDITS_BUY,
  MODAL_BUY_CREDITS_REDEEMED_ESTIMATED_TIME,
  MODAL_BUY_CREDITS_ADDITIONAL_CREDITS,
  MODAL_BUY_CREDITS_LAST_TEXT_PAY,
  MODAL_BUY_CREDITS_AMOUNT_FOR_PRICE,
  MODAL_BUY_CREDITS_AND_PAYMENT_METHOD_REQUIRED,
  MODAL_BUY_CREDITS_NEGATIVE,
  MODAL_BUY_CREDITS_PURCHASED,
  MODAL_BUY_CREDITS_PURCHASED_DESCRIPTION,
  MODAL_BUY_VIDEOS_PURCHASED,
  MODAL_BUY_VIDEOS_PURCHASED_DESCRIPTION,
  MODAL_BUY_CREDITS_GIFT_CREDITS,
  MODAL_PURCHASE_CREDITS_TITLE,
  MODAL_PURCHASE_CREDITS_ARIA_LABEL,
  MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_TITLE,
  MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_1,
  MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_2,
  MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_3,
  MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_3_LINK,
  MODAL_PURCHASE_CREDITS_SELECT_AMOUNT,
  MODAL_PURCHASE_CREDITS_CREDITS_LABEL,
  MODAL_PURCHASE_CREDITS_PRICE_PER_CREDIT,
  MODAL_PURCHASE_CREDITS_CREDIT_PACKAGES_TITLE,
  MODAL_PURCHASE_CREDITS_VIDEO_PACKAGES_TITLE,
  MODAL_PURCHASE_CREDITS_VIDEO_PACKAGES_SUBTITLE,
  MODAL_PURCHASE_CREDITS_VIDEO_ON_SCREEN_TEXT_LANGUAGES,
  MODAL_PURCHASE_CREDITS_VIDEOS_LABEL,
  MODAL_PURCHASE_CREDITS_PRICE_PER_VIDEO,
  MODAL_PURCHASE_CREDITS_PURCHASE_VIDEOS_BUTTON,
  MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLES_TITLE,
  MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLE,
  VIDEO_INSUFFICIENT_CREDITS_ALERT_TITLE,
  VIDEO_INSUFFICIENT_CREDITS_ALERT_INTRO,
  VIDEO_INSUFFICIENT_CREDITS_ALERT_INSTRUCTION,
  VIDEO_INSUFFICIENT_CREDITS_ALERT_OPTION_PURCHASE,
  VIDEO_INSUFFICIENT_CREDITS_ALERT_OPTION_UPGRADE,
  MODAL_PURCHASE_CREDITS_MINIMUM_AMOUNT,
  MODAL_PURCHASE_CREDITS_CUSTOM_AMOUNT_PLACEHOLDER,
  MODAL_PURCHASE_CREDITS_UPGRADE_PLAN,
  MODAL_PURCHASE_CREDITS_PURCHASE_BUTTON,
  MODAL_PURCHASE_CREDITS_PAYMENT_SUMMARY,
  SECTION_COMPETITORS_TITLE,
  SECTION_COMPETITORS_SUBTITLE_SINGULAR,
  SECTION_COMPETITORS_SUBTITLE_PLURAL,
  SECTION_SOCIAL_TITLE,
  SECTION_SOCIAL_SUBTITLE_SINGULAR,
  SECTION_SOCIAL_SUBTITLE_PLURAL,
  SECTION_VOICE_TITLE,
  SECTION_VOICE_SUBTITLE,
  SECTION_VOICE_TONE_DESCRIPTION,
  SECTION_VOICE_ATTRIBUTES_LABEL,
  SECTION_OFFER_TITLE,
  SECTION_OFFER_SUBTITLE,
  SECTION_OFFER_TYPE_LABEL,
  SECTION_OFFER_VISUAL_STYLE_LABEL,
  SECTION_OFFER_DEFAULT_VALUE,
  SECTION_COUNTRY_TITLE,
  SECTION_COUNTRY_SUBTITLE,
  SECTION_COUNTRY_LABEL,
  SECTION_COUNTRY_DEFAULT_VALUE,
  SECTION_TYPOGRAPHY_TITLE,
  SECTION_TYPOGRAPHY_SUBTITLE,
  SECTION_TYPOGRAPHY_FONT_FAMILY_LABEL,
  SECTION_TYPOGRAPHY_TITLE_FONT_LABEL,
  SECTION_TYPOGRAPHY_SUBTITLE_FONT_LABEL,
  SECTION_TYPOGRAPHY_BODY_FONT_LABEL,
  SECTION_TYPOGRAPHY_ADD_TYPOGRAPHY,
  SECTION_TYPOGRAPHY_FONT_SIZES_LABEL,
  SECTION_TYPOGRAPHY_HEADING_LABEL,
  SECTION_TYPOGRAPHY_SUBHEADING_LABEL,
  SECTION_TYPOGRAPHY_BODY_LABEL,
  SECTION_TYPOGRAPHY_PX_UNIT,
  SECTION_TYPOGRAPHY_GENERATING_PREVIEW,
  SECTION_TYPOGRAPHY_ADD_FONT,
  SECTION_LOGO_TITLE,
  SECTION_LOGO_SUBTITLE,
  SECTION_COLORS_TITLE,
  SECTION_COLORS_SUBTITLE,
  SECTION_COLORS_ADD_COLOR,
  SECTION_TARGET_AUDIENCE_TITLE,
  SECTION_TARGET_AUDIENCE_SUBTITLE,
  SECTION_TARGET_AUDIENCE_ICP_LABEL,
  SECTION_PRODUCT_IMAGES_TITLE,
  SECTION_PRODUCT_IMAGES_SUBTITLE,
  BUTTON_UPLOAD_PRODUCT_IMAGES,
  BUTTON_DELETE_PRODUCT_IMAGE,
  SECTION_ADDITIONAL_ASSETS_TITLE,
  SECTION_ADDITIONAL_ASSETS_SUBTITLE,
  SECTION_ADDITIONAL_ASSETS_PROMPT_LABEL,
  SECTION_ADDITIONAL_ASSETS_PROMPT_PLACEHOLDER,
  SECTION_ADDITIONAL_ASSETS_PROMPT_REQUIRED,
  BUTTON_UPLOAD_ADDITIONAL_ASSET,
  SECTION_ADDITIONAL_ASSETS_MAX_ERROR,
  SECTION_ADDITIONAL_ASSETS_ASSET_LABEL,
  SECTION_ADDITIONAL_ASSETS_MAX_TOOLTIP,
  SECTION_ADDITIONAL_ASSETS_DELETE_CONFIRM,
  SECTION_ADDITIONAL_ASSETS_DELETE_CONFIRM_TITLE,
  SECTION_ADDITIONAL_ASSETS_INCOMPLETE_PAIR,
  SECTION_ADDITIONAL_ASSETS_IS_CONDITIONAL_LABEL,
  SECTION_ADDITIONAL_ASSETS_IS_CONDITIONAL_HELP,
  SECTION_ADDITIONAL_ASSETS_VARIABLE_INFO_LABEL,
  SECTION_ADDITIONAL_ASSETS_VARIABLE_INFO_HELP,
  SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_LABEL,
  SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_HELP,
  SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_PLACEHOLDER,
  MODAL_ADDITIONAL_ASSET_TITLE,
  BUTTON_CHANGE_ADDITIONAL_ASSET_IMAGE,
  SECTION_BUYER_PERSONA_TITLE,
  SECTION_BUYER_PERSONA_SUBTITLE,
  SECTION_BUYER_PERSONA_LABEL,
  BUTTON_UPLOAD_CATALOG,
  BUTTON_COPY_CATALOG,
  BUTTON_DOWNLOAD_FORMAT,
  BUTTON_EDIT,
  BUTTON_DUPLICATE,
  BUTTON_DUPLICATE_IN_SAME_GROUP,
  BUTTON_DUPLICATE_IN_OTHER_AD_GROUP,
  DUPLICATE_AD_OTHER_GROUP_MODAL_TITLE,
  DUPLICATE_AD_OTHER_GROUP_MODAL_DESCRIPTION,
  DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_CHANGE_WARNING,
  DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_LABEL,
  DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_PLACEHOLDER,
  DUPLICATE_AD_OTHER_GROUP_AD_GROUP_LABEL,
  DUPLICATE_AD_OTHER_GROUP_AD_GROUP_PLACEHOLDER,
  DUPLICATE_AD_OTHER_GROUP_EMPTY_AD_GROUPS,
  BUTTON_DUPLICATE_IN_SAME_CAMPAIGN,
  BUTTON_DUPLICATE_IN_OTHER_CAMPAIGN,
  DUPLICATE_AD_GROUP_MODAL_TITLE,
  DUPLICATE_AD_GROUP_MODAL_DESCRIPTION,
  DUPLICATE_AD_GROUP_CAMPAIGN_CHANGE_WARNING,
  DUPLICATE_AD_GROUP_CAMPAIGN_TYPE_MISMATCH,
  DUPLICATE_CAMPAIGN_AD_FORMAT_MISMATCH,
  DUPLICATE_ASSETS_GROUP_MODAL_TITLE,
  DUPLICATE_ASSETS_GROUP_MODAL_DESCRIPTION,
  DUPLICATE_ASSETS_GROUP_CAMPAIGN_CHANGE_WARNING,
  BUTTON_MOVE_OTHER_CATEGORY,
  MENU_TITLE,
  MENU_DESCRIPTION,
  MENU_EMPTY_STORES,
  MODAL_COPY_MENU_ARIA_LABEL,
  MODAL_COPY_MENU_TITLE,
  MODAL_COPY_MENU_SAME_STORE,
  MODAL_COPY_MENU_CONFIRM_ALERT_TITLE,
  MODAL_COPY_MENU_CONFIRM_ALERT_DESCRIPTION,
  MODAL_COPY_MENU_COPIED,
  SELECT_CATALOG,
  MODAL_UPLOAD_MENU_ARIA_LABEL,
  MODAL_UPLOAD_MENU_TITLE,
  MODAL_UPLOAD_MENU_DESCRIPTION,
  MODAL_UPLOAD_MENU_FILE_PLACEHOLDER,
  MODAL_UPLOAD_MENU_ERROR_FORMAT,
  MODAL_UPLOAD_MENU_MIN_PRICE_PRODUCT,
  MODAL_UPLOAD_MENU_CONFIRM_ALERT_TITLE,
  MODAL_UPLOAD_MENU_CONFIRM_ALERT_DESCRIPTION,
  MODAL_UPLOAD_MENU_UPLOADED,
  MENU_ADD_CATEGORY,
  MENU_CATEGORY_NAME_PLACEHOLDER,
  MENU_CATEGORY_REQUIRED,
  MENU_ADD_PRODUCT,
  MENU_PRODUCT_MIN_VALUE,
  MENU_CREATE_PRODUCT_TITLE,
  MENU_PRODUCT_NAME_PLACEHOLDER,
  MENU_PRODUCT_DESCRIPTION_PLACEHOLDER,
  MENU_PRODUCT_PRICE_PLACEHOLDER,
  MENU_PRODUCT_TYPE_PRODUCT_PLACEHOLDER,
  MENU_PRODUCT_TYPE_PRODUCT_EXPLANATION,
  MENU_PRODUCT_ACCOMPANIMENTS_TYPE_TITLE,
  MENU_PRODUCT_ACCOMPANIMENTS_TYPE_DESCRIPTION,
  MENU_PRODUCT_ADD_ACCOMPANIMENT_TYPE_PLACEHOLDER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_IS_MANDATORY_PLACEHOLDER,
  MENU_PRODUCT_ADD_ACCOMPANIMENT_PLACEHOLDER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_AND_MAX_NUMBER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_NUMBER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_NAME_PLACEHOLDER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_OPTIONS_PLACEHOLDER,
  MENU_PRODUCT_ACCOMPANIMENT_TYPE_MAX_OPTIONS_PLACEHOLDER,
  BUTTON_COPY,
  FIELD_NUMBER_NEGATIVE,
  FIELD_IS_DYNAMIC_CREATIVE_ONLY_ONE_AD,
  FIELD_SCHEDULE_REQUIRED_WHEN_CAMPAIGN_BUDGET_OTHERS_HAVE,
  FIELD_BID_GOAL_REQUIRED_WHEN_CAMPAIGN_BUDGET_OTHERS_HAVE,
  MENU_PRODUCT_ACCOMPANIMENT_PRICE_PLACEHOLDER,
  MENU_PRODUCT_ACCOMPANIMENT_NAME_PLACEHOLDER,
  PRODUCT,
  PRODUCTS,
  MODAL_MOVE_PRODUCT_ARIA_LABEL,
  MODAL_MOVE_PRODUCT_CATEGORY_OBJECTIVE,
  MODAL_MOVE_PRODUCT_CATEGORY_REQUIRED,
  MODAL_MOVE_PRODUCT_BUTTON,
  MODAL_COPY_ACCOMPANIMENT_TYPE_ARIA_LABEL,
  MODAL_COPY_ACCOMPANIMENT_TYPE_CATEGORY_OBJECTIVE,
  MODAL_COPY_ACCOMPANIMENT_TYPE_PRODUCT_OBJECTIVE,
  MODAL_COPY_ACCOMPANIMENT_TYPE_OBJECTIVE,
  MODAL_COPY_ACCOMPANIMENT_TYPE_OBJECTIVE_PLACEHOLDER,
  MODAL_COPY_ACCOMPANIMENT_TYPE_CATEGORY_REQUIRED,
  MODAL_COPY_ACCOMPANIMENT_TYPE_PRODUCT_REQUIRED,
  MODAL_COPY_ACCOMPANIMENT_TYPE_REQUIRED,
  MENU_ONBOARDING_TEST_CATEGORY,
  MENU_ONBOARDING_TEST_PRODUCT,
  MENU_ONBOARDING_TEST_PRODUCT_DESCRIPTION,
  MENU_ONBOARDING_FINISH_DESCRIPTION,
  MENU_ONBOARDING_FINISH_ADDITIONAL_DESCRIPTION,
  MENU_CATEGORY_DUPLICATE,
  MENU_CATEGORY_DUPLICATE_DESCRIPTION,
  MENU_CATEGORY_CREATED,
  MENU_CATEGORY_SAVED,
  MENU_CATEGORY_DELETE_CONFIRMATION_TITLE,
  MENU_CATEGORY_DELETE_CONFIRMATION_DESCRIPTION,
  MENU_CATEGORY_DELETING,
  MENU_CATEGORY_DELETED,
  MENU_PRODUCT_DUPLICATE,
  MENU_PRODUCT_DUPLICATE_DESCRIPTION,
  MENU_PRODUCT_CREATED,
  MENU_PRODUCT_SAVED,
  MENU_PRODUCT_DELETE_CONFIRMATION_TITLE,
  MENU_PRODUCT_DELETE_CONFIRMATION_DESCRIPTION,
  MENU_PRODUCT_DELETING,
  MENU_PRODUCT_DELETED,
  MENU_PRODUCT_MOVE_SAME_CATEGORY,
  MENU_PRODUCT_MOVED,
  MENU_PRODUCT_CHANGE_STATUS,
  MENU_ACCOMPANIMENT_TYPE_DUPLICATE,
  MENU_ACCOMPANIMENT_TYPE_DUPLICATE_DESCRIPTION,
  MENU_ACCOMPANIMENT_TYPE_COPIED,
  MENU_ACCOMPANIMENT_DUPLICATED,
  MENU_ACCOMPANIMENT_DUPLICATED_DESCRIPTION,
  FIELD_EMAIL_REQUIRED,
  FORGOT_PASSWORD,
  NO_HAVE_ACCOUNT,
  REGISTER_HERE,
  LOG_IN,
  AUTH_LAYOUT_HERO_TITLE,
  AUTH_LAYOUT_HERO_DESCRIPTION,
  AUTH_LAYOUT_PREVIEW_PLACEHOLDER,
  AUTH_LAYOUT_PREVIEW_IMAGE_ALT,
  AUTH_LAYOUT_FEATURE_AI_TITLE,
  AUTH_LAYOUT_FEATURE_AI_DESCRIPTION,
  AUTH_LAYOUT_FEATURE_ANALYTICS_TITLE,
  AUTH_LAYOUT_FEATURE_ANALYTICS_DESCRIPTION,
  AUTH_LAYOUT_FEATURE_SCHEDULING_TITLE,
  AUTH_LAYOUT_FEATURE_SCHEDULING_DESCRIPTION,
  LOG_GROUP_AUDIENCE_NETWORK,
  LOG_GROUP_FEEDS,
  LOG_GROUP_REELS_STORIES,
  ACCOUNT_ROLE_INVALID,
  ERROR_INTERNAL,
  AUTH_INVALID_PASSWORD,
  AUTH_WRONG_PASSWORD,
  AUTH_MANY_REQUESTS,
  AUTH_USER_NOT_FOUND,
  AUTH_EMAIL_ALREADY_EXISTS,
  PHONE_ALREADY_REGISTERED,
  STRIPE_CARD_DECLINED,
  STRIPE_EXPIRED_CARD,
  STRIPE_INCORRECT_CVC,
  STRIPE_PROCESSING_ERROR,
  STRIPE_INCORRECT_NUMBER,
  STRIPE_GENERIC_DECLINE,
  STRIPE_INSUFFICIENT_FUNDS,
  STRIPE_LOST_CARD,
  STRIPE_STOLEN_CARD,
  STRIPE_PROFILE_NOT_FOUND,
  STRIPE_INTENT_AUTH_FAILURE,
  NIT_VALID,
  BUSINESS_NAME_VALID,
  BRAND_NAME_VALID,
  ADDRESS_VALID,
  CATEGORY_VALID,
  SUBCATEGORIES_VALID,
  SHORT_DESCRIPTION_VALID,
  ORDERS_METHODS_VALID,
  LOGO_IMG_VALID,
  COVER_IMG_VALID,
  SCHEDULE_VALID,
  STORES_VALID,
  IS_PLAN_ACTIVE_VALID,
  MENUS_VALID,
  DEFAULT_PAYMENT_METHOD_VALID,
  HAS_DEBT_VALID,
  SUBSCRIPTION_PLAN_VALID,
  REGISTER_COUNTRY_ANSWER,
  REGISTER_COUNTRY_PLACEHOLDER,
  REGISTER_NAME_ANSWER,
  REGISTER_PHONE_ANSWER,
  REGISTER_EMAIL_ANSWER,
  REGISTER_BUSINESS_NAME_ANSWER,
  REGISTER_CATEGORY_ANSWER,
  REGISTER_SOCIAL_NETWORK_ANSWER,
  REGISTER_SOCIAL_NETWORK_ANSWER_DESCRIPTION,
  REGISTER_WEBSITE_ANSWER,
  REGISTER_WEBSITE_ANSWER_DESCRIPTION,
  REGISTER_MONTHLY_SALES_ANSWER,
  REGISTER_BUDGET_MARKETING_ANSWER,
  REGISTER_EMPLOYEES_ANSWER,
  REGISTER_PRODUCT_AVAILABILITY_ANSWER,
  REGISTER_RUT_ANSWER,
  REGISTER_INVIMA_ANSWER,
  REGISTER_ICA_ANSWER,
  REGISTER_YOU_MEET_ANSWER,
  REGISTER_WRITE_PLACEHOLDER,
  REGISTER_SELECT_PLACEHOLDER,
  BUTTON_REGISTER,
  BUTTON_NO_HAVE_DOCUMENT,
  BUTTON_UPLOAD_AFTER,
  REGISTER_COUNTRY_REQUIRED,
  REGISTER_NAME_REQUIRED,
  REGISTER_PHONE_REQUIRED,
  REGISTER_PHONE_NUMERIC_REQUIRED,
  REGISTER_BUSINESS_NAME_REQUIRED,
  REGISTER_CATEGORY_REQUIRED,
  REGISTER_SOCIAL_NETWORK_REQUIRED,
  REGISTER_WEB_SITE_REQUIRED,
  REGISTER_MONTHLY_SALES_REQUIRED,
  REGISTER_BUDGET_MARKETING_REQUIRED,
  REGISTER_EMPLOYEES_REQUIRED,
  REGISTER_PRODUCT_AVAILABILITY_REQUIRED,
  REGISTER_RUT_REQUIRED,
  REGISTER_INVIMA_REQUIRED,
  REGISTER_ICA_REQUIRED,
  REGISTER_YOU_MEET_REQUIRED,
  REGISTER_NO_HAVE_DOCUMENTS_ALERT_TITLE,
  REGISTER_NO_HAVE_DOCUMENTS_ALERT_DESCRIPTION,
  REGISTER_REGISTERED_ALERT_DESCRIPTION,
  RESTAURANTS,
  FOODS,
  TRAVEL,
  ENTERTAINMENT,
  TECHNOLOGY,
  FITNESS,
  FASHION,
  BEAUTY,
  PETS,
  HOME,
  EMPLOYEES_2_10,
  EMPLOYEES_10_20,
  EMPLOYEES_20_50,
  EMPLOYEES_50_100,
  EMPLOYEES_100_THAN,
  PRODUCT_AVAILABILITY_LOCAL,
  PRODUCT_AVAILABILITY_NATIONAL,
  PRODUCT_AVAILABILITY_INTERNATIONAL,
  INSTAGRAM,
  TIKTOK,
  LINKEDIN,
  GOOGLE,
  YOUTUBE,
  DARK_KITCHEN,
  OTHERS,
  PLEASE_SELECT_COUNTRY,
  BLOCK_PLAN_BUTTON_ACTIVATE_PLAN,
  BLOCK_PACKAGE_TITLE,
  BLOCK_PACKAGE_DESCRIPTION,
  BILLING_AND_PAYMENT_PLAN_TRIAL,
  BILLING_AND_PAYMENT_PLAN_TRIAL_DESCRIPTION,
  BILLING_AND_PAYMENT_PLAN_DEACTIVATE,
  BUTTON_INVITED,
  MAIN_FUNCTIONALITY_STEP_1,
  MAIN_FUNCTIONALITY_STEP_2,
  MAIN_FUNCTIONALITY_STEP_3,
  PUBLICATIONS_FUNCTIONALITY_STEP_1,
  PUBLICATIONS_FUNCTIONALITY_STEP_2,
  PUBLICATIONS_FUNCTIONALITY_STEP_3,
  PUBLICATIONS_FUNCTIONALITY_STEP_4,
  PUBLICATION_FUNCTIONALITY_STEP_1,
  PUBLICATION_FUNCTIONALITY_STEP_2,
  PUBLICATION_FUNCTIONALITY_STEP_3,
  REVIEW_FUNCTIONALITY_STEP_1,
  REVIEW_FUNCTIONALITY_STEP_2,
  REVIEW_FUNCTIONALITY_STEP_3,
  REVIEW_FUNCTIONALITY_STEP_4,
  REVIEW_FUNCTIONALITY_STEP_5,
  MENU_FUNCTIONALITY_STEP_1,
  MENU_FUNCTIONALITY_STEP_2,
  MENU_FUNCTIONALITY_STEP_3,
  MENU_FUNCTIONALITY_STEP_4,
  MENU_FUNCTIONALITY_STEP_5,
  MENU_FUNCTIONALITY_STEP_6,
  MENU_FUNCTIONALITY_STEP_7,
  MENU_FUNCTIONALITY_STEP_8,
  MENU_FUNCTIONALITY_STEP_9,
  MENU_FUNCTIONALITY_STEP_10,
  MENU_FUNCTIONALITY_STEP_11,
  MENU_FUNCTIONALITY_STEP_12,
  USERS_FUNCTIONALITY_STEP_1,
  USERS_FUNCTIONALITY_STEP_2,
  USERS_FUNCTIONALITY_STEP_3,
  USERS_FUNCTIONALITY_STEP_4,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_1,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_2,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_3,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_4,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_5,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_6,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_7,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_8,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_9,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_10,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_11,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_12,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_13,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_14,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_15,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_16,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_17,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_18,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_19,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_20,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_21,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_22,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_23,
  MAIN_FUNCTIONALITY_OPERATOR_STEP_24,
  CAMPAIGNS_FUNCTIONALITY_STEP_1,
  CAMPAIGNS_FUNCTIONALITY_STEP_2,
  CAMPAIGNS_FUNCTIONALITY_STEP_3,
  CAMPAIGNS_FUNCTIONALITY_STEP_4,
  CAMPAIGNS_FUNCTIONALITY_STEP_5,
  CAMPAIGNS_FUNCTIONALITY_STEP_6,
  CAMPAIGNS_FUNCTIONALITY_STEP_7,
  CAMPAIGNS_FUNCTIONALITY_STEP_8,
  CAMPAIGNS_FUNCTIONALITY_STEP_9,
  CAMPAIGNS_FUNCTIONALITY_STEP_10,
  CAMPAIGNS_FUNCTIONALITY_STEP_11,
  CAMPAIGNS_FUNCTIONALITY_STEP_12,
  CAMPAIGNS_FUNCTIONALITY_STEP_13,
  CAMPAIGNS_FUNCTIONALITY_STEP_14,
  CAMPAIGNS_FUNCTIONALITY_STEP_15,
  CAMPAIGNS_FUNCTIONALITY_STEP_16,
  CAMPAIGNS_FUNCTIONALITY_STEP_17,
  AUTH_SENT_EMAIL_RESET_PASSWORD,
  EMAIL_UNSUBSCRIBE_SUCCESS_TITLE,
  EMAIL_UNSUBSCRIBE_SUCCESS_TEXT,
  EMAIL_UNSUBSCRIBE_ERROR_TITLE,
  EMAIL_UNSUBSCRIBE_ERROR_TEXT,
  AUTH_PAGE_DOCUMENT_TITLE_LOGIN,
  AUTH_PAGE_DOCUMENT_TITLE_LOGIN_OWNER,
  AUTH_LOGIN_OWNER_CHIP_LABEL,
  AUTH_LOGIN_OWNER_SUBMIT,
  AUTH_LOGIN_OWNER_NOT_OWNER,
  AUTH_LOGIN_OWNER_GO_TO_LOGIN,
  AUTH_PAGE_DOCUMENT_TITLE_REGISTER,
  AUTH_PAGE_DOCUMENT_TITLE_RESET_PASSWORD,
  AUTH_PAGE_BRANDING_LOGO_ALT,
  AUTH_LOGIN_DEMO_EXISTING_ACCOUNT_BANNER,
  EVENT_RECURRENT_REQUIRED,
  EVENT_HAS_FIELDS_REQUIRED,
  BILLING_AND_PAYMENT_PLAN_CANCELLED,
  COMPANY_INFORMATION_SAVED,
  ALERT_INACTIVE_SHOP_TITLE,
  ALERT_INACTIVE_SHOP_DESCRIPTION,
  ALERT_OPERATOR_ACTION_UNAUTHORIZED_DESCRIPTION,
  BUTTON_YES_I_SURE,
  ERROR_COMPONENT_TITLE,
  ERROR_COMPONENT_DESCRIPTION,
  ERROR_COMPONENT_BUTTON_RELOAD_PAGE,
  ERROR_COMPONENT_CURRENT_ROUTE,
  LESS_500K,
  BETWEEN_500K_1M,
  BETWEEN_1M_2_5M,
  BETWEEN_2_5M_5M,
  MORE_5M,
  LESS_1M,
  BETWEEN_1M_5M,
  BETWEEN_5M_15M,
  BETWEEN_15M_30M,
  BETWEEN_30M_100M,
  MORE_100M,
  LESS_150,
  BETWEEN_150_250,
  BETWEEN_250_650,
  BETWEEN_650_1250,
  MORE_1250,
  LESS_250,
  BETWEEN_250_1250,
  BETWEEN_1250_3750,
  BETWEEN_3750_7500,
  BETWEEN_7500_25K,
  MORE_25K,
  DOCUMENT_CC,
  DOCUMENT_CE,
  DOCUMENT_NUIP,
  DOCUMENT_NIT,
  DOCUMENT_CI,
  DOCUMENT_PASSPORT,
  DOCUMENT_ID,
  DOCUMENT_RUC,
  MISSING_PARAMETERS,
  PASSWORD_INVALID,
  INVALID_SEARCH,
  USER_ID_REQUIRED,
  SHOP_ID_REQUIRED,
  LAST_USER_NOT_DELETED,
  PLAN_TRIAL_USER_USED,
  ORDERS_NOT_FOUND_IN_INTERVAL,
  TYPE_REPORT_NOT_FOUND,
  SHOP_NOT_FOUND,
  PAYMENT_MODEL_INVALID,
  SHOP_NOT_HAS_SOCIAL_NETWORK,
  NO_VALID_PLATFORM_FOUND,
  GETTING_STATISTICS,
  SHOP_BUSINESS_NAME_NOT_FOUND,
  REFERENCE_PROFILES_REQUIRED,
  DECRYPTING_PASSWORD,
  USER_ID_AND_PAYMENT_ID,
  MESSAGES_REQUIRED,
  PLAN_IS_NO_ACTIVE,
  USER_BANNED,
  GETTING_LOCALES,
  GETTING_PROFILE,
  PRODUCTS_NOT_SENT,
  ACCOUNT_NOT_FOUND,
  COLLECTING_INFORMATION_RETRY_AFTER,
  ERROR_OCCURRED,
  FREE_BOT_MESSAGES_LIMIT_REACHED,
  TEXT_REGENERATION_LIMIT_REACHED,
  REFERENCE_VIDEO_ANALYSIS_UNAVAILABLE,
  ACTION_COULD_NOT_BE_COMPLETED,
  PLATFORM_NOT_SENT,
  PLATFORM_APP_REQUEST_LIMIT_REACHED,
  VERIFICATION_CODE_NOT_FOUND,
  ORDER_NOT_FOUND,
  TYPE_OR_PATH_NOT_SENT,
  ID_OR_PATH_NOT_SENT,
  IDS_NOT_SENT,
  ANALYTIC_URL_NOT_SENT,
  ANALYTIC_URL_INVALID,
  EXTRACTING_ANALYTICS,
  CREDENTIALS_INVALID,
  COLLABORATION_PRICE_NOT_BE_NEGATIVE,
  CREDITS_NOT_BE_NEGATIVE,
  PACKAGES_PRICES_NOT_BE_NEGATIVE,
  ROL_REQUIRED,
  SHOP_ID_AND_STORE_ID_REQUIRED,
  PASSWORD_MUST_BE_6_CHARACTERS,
  ALL_USERS_NOT_DELETE,
  SHOP_APPLICANT_NOT_FOUND,
  USER_PASSWORD_NOT_FOUND,
  PLAN_NOT_FOUND,
  SUBSCRIPTION_NOT_CREATED,
  ID_SUBSCRIPTION_NOT_FOUND,
  SUBSCRIPTION_REACTIVATE,
  CUSTOMER_ID_NOT_FOUND,
  APPLICANT_NOT_FOUND,
  SHOP_COUNTRY_NOT_FOUND,
  FINAL_PRICE_NOT_FOUND,
  PAYMENT_FAILED,
  CREDITS_MUST_BE_GREATER_THAN_ZERO,
  CSRF_INVALID,
  INTEGRATION_INFORMATION_NOT_FOUND,
  GETTING_VIDEO,
  UPLOAD_URL_NOT_FOUND,
  UPLOADING_VIDEO,
  STORE_NOT_FOUND,
  NAME_REQUIRED,
  PRICE_REQUIRED,
  CURRENCY_REQUIRED,
  RECURRING_REQUIRED,
  CREATING_PRODUCT,
  CREATING_PRICE,
  CREATING_PAYMENT_LINK,
  GETTING_PAYMENT_LINK,
  MODAL_REVIEW_SCORE_PLACEHOLDER,
  SCORE,
  CHAT_EMAIL_NO_PERMITTED,
  CHAT_WRITE_MESSAGE_HERE,
  CHAT_WRITE_QUESTION_HERE,
  CHAT_DO_PAYMENT,
  CHAT_ERROR_SENT_MESSAGE,
  RESET_PASSWORD_EMAIL_SENT,
  RESET_PASSWORD,
  RESET_PASSWORD_GET_TOKEN_FAILED,
  RESET_PASSWORD_SAVED,
  TOKEN_INVALID,
  TOKEN_EXPIRED,
  NOTIFICATIONS_CHECK_NOTIFICATION,
  NOTIFICATIONS_NO_MORE,
  NOTIFICATIONS_EMPTY,
  NOTIFICATIONS_MARK_READS,
  NOTIFICATIONS_TITLE,
  ONE_SECOND_AGO,
  DATE_DISTANCE,
  CAMPAIGN_FINISH_ONBOARDING,
  CHAT_FIRST_MESSAGE_BOT,
  OWN_DELIVERY,
  CHAT_NO_MORE,
  PUBLICATION_STATUS_PENDING_CONTENT,
  PUBLICATION_STATUS_PENDING_APPROVAL,
  BUTTON_SEND_REVISION,
  BUTTON_APPROVE_CONTENT,
  REVISION_COUNT,
  ONE,
  TWO,
  THREE,
  DATE_HOUR,
  ORDER_CANCELLED_CONFIRMATION,
  ORDER_CANCELLED_CONFIRMATION_BUTTON,
  COMPANY_INFORMATION_WEBSITE_URL_PLACEHOLDER,
  IG_ACCOUNT_NOT_FOUND,
  IG_DATA_NOT_FOUND,
  BUTTON_UPLOAD_INSTAGRAM,
  BUTTON_CONNECT_INSTAGRAM,
  PLATFORMS_CONNECTED_INSTAGRAM_FAILED,
  PLATFORMS_CONNECTED_FACEBOOK_SDK_UNAVAILABLE,
  PLATFORMS_CONNECTED_META_BLOCKED_TITLE,
  PLATFORMS_CONNECTED_META_POPUP_BLOCKED,
  PLATFORMS_CONNECTED_META_BLOCKED_STEP_DISABLE_BLOCKER,
  PLATFORMS_CONNECTED_META_BLOCKED_STEP_ALLOW_POPUPS,
  PLATFORMS_CONNECTED_META_BLOCKED_STEP_RETRY,
  MODAL_UPLOAD_INSTAGRAM_ARIA_LABEL,
  MODAL_UPLOAD_INSTAGRAM_TITLE,
  MODAL_UPLOAD_INSTAGRAM_CONTENT_UPLOADED_DESCRIPTION,
  MODAL_UPLOAD_INSTAGRAM_DESCRIPTION_LABEL,
  MODAL_UPLOAD_INSTAGRAM_DESCRIPTION_PLACEHOLDER,
  PLATFORMS_TOKEN_EXPIRED,
  INTEGRATIONS_TERMS_TITLE,
  INTEGRATIONS_TERMS_DESCRIPTION,
  INTEGRATIONS_TERMS_CONTENT,
  LESS_1000,
  BETWEEN_1000_5000,
  BETWEEN_5000_15K,
  BETWEEN_15K_30K,
  BETWEEN_30K_60K,
  MORE_60K,
  BETWEEN_1000_2000,
  BETWEEN_2000_5000,
  BETWEEN_5000_10K,
  MORE_10K,
  DOCUMENT_EIN,
  MENU_SERVICES,
  BILLING_AND_PAYMENT_MODEL_USAGE_COLLABORATION_TITLE,
  RESTAURANTS_SUBCATEGORY_FOOD,
  RESTAURANTS_SUBCATEGORY_DRINKS,
  RESTAURANTS_SUBCATEGORY_DESSERTS,
  RESTAURANTS_SUBCATEGORY_COFFEE,
  RESTAURANTS_SUBCATEGORY_HOT_DRINKS,
  RESTAURANTS_SUBCATEGORY_COLD_DRINKS,
  RESTAURANTS_SUBCATEGORY_SOFT_DRINKS,
  RESTAURANTS_SUBCATEGORY_FROZEN_DRINKS,
  RESTAURANTS_SUBCATEGORY_SUSHI,
  RESTAURANTS_SUBCATEGORY_ASIAN,
  RESTAURANTS_SUBCATEGORY_JAPANESE,
  RESTAURANTS_SUBCATEGORY_CHINESE,
  RESTAURANTS_SUBCATEGORY_ITALIAN,
  RESTAURANTS_SUBCATEGORY_MEXICAN,
  RESTAURANTS_SUBCATEGORY_HEALTHY,
  RESTAURANTS_SUBCATEGORY_VEGAN,
  RESTAURANTS_SUBCATEGORY_VEGETARIAN,
  FOODS_SUBCATEGORY_SEASONINGS,
  FOODS_SUBCATEGORY_FOOD,
  FOODS_SUBCATEGORY_GRANOLA,
  FOODS_SUBCATEGORY_DRIED_FRUITS,
  FOODS_SUBCATEGORY_HEALTHY,
  TRAVEL_SUBCATEGORY_BEACH_SUN_TOURISM,
  TRAVEL_SUBCATEGORY_RURAL_TOURISM,
  TRAVEL_SUBCATEGORY_GASTRONOMIC_TOURISM,
  TRAVEL_SUBCATEGORY_NATURE_TOURISM,
  TRAVEL_SUBCATEGORY_CULTURAL_TOURISM,
  TRAVEL_SUBCATEGORY_HEALTH_TOURISM,
  ENTERTAINMENT_SUBCATEGORY_ENTERTAINMENT,
  TECHNOLOGY_SUBCATEGORY_PHONES,
  TECHNOLOGY_SUBCATEGORY_COMPUTERS,
  TECHNOLOGY_SUBCATEGORY_VIDEO_GAME_CONSOLES,
  TECHNOLOGY_SUBCATEGORY_ACCESSORIES,
  TECHNOLOGY_SUBCATEGORY_PERIPHERALS,
  TECHNOLOGY_SUBCATEGORY_ELECTRONICS,
  FITNESS_SUBCATEGORY_SPORTSWEAR,
  FITNESS_SUBCATEGORY_SPORTS_ACCESSORIES,
  FITNESS_SUBCATEGORY_DIETARY_SUPPLEMENTS,
  FITNESS_SUBCATEGORY_TRAINING_EQUIPMENT,
  FASHION_SUBCATEGORY_HAUTE_COUTURE,
  FASHION_SUBCATEGORY_HIPSTER,
  FASHION_SUBCATEGORY_CASUAL,
  FASHION_SUBCATEGORY_CLASSIC,
  FASHION_SUBCATEGORY_ROMANTIC,
  FASHION_SUBCATEGORY_SPORTSWEAR,
  FASHION_SUBCATEGORY_PREPPY,
  FASHION_SUBCATEGORY_GRUNGE,
  FASHION_SUBCATEGORY_VINTAGE,
  BEAUTY_SUBCATEGORY_COSMETICS,
  BEAUTY_SUBCATEGORY_EYE_CARE,
  BEAUTY_SUBCATEGORY_FEMININE_HYGIENE,
  BEAUTY_SUBCATEGORY_FIRST_AID,
  BEAUTY_SUBCATEGORY_HAIR_CARE,
  BEAUTY_SUBCATEGORY_MEDICAL_DEVICES,
  BEAUTY_SUBCATEGORY_MOBILITY_EQUIPMENT,
  BEAUTY_SUBCATEGORY_NUTRITIONAL_SUPPLEMENTS,
  BEAUTY_SUBCATEGORY_MEDICATIONS,
  BEAUTY_SUBCATEGORY_PERSONAL_HYGIENE,
  BEAUTY_SUBCATEGORY_SCALES,
  BEAUTY_SUBCATEGORY_SKIN_CARE,
  BEAUTY_SUBCATEGORY_VITAMINS,
  BEAUTY_SUBCATEGORY_FACIAL_TISSUES,
  PETS_SUBCATEGORY_FOOD,
  PETS_SUBCATEGORY_COSMETICS,
  PETS_SUBCATEGORY_ACCESSORIES,
  PETS_SUBCATEGORY_CLOTHING,
  PETS_SUBCATEGORY_MEDICATIONS,
  HOME_SUBCATEGORY_TEXTILES_CARPETS,
  HOME_SUBCATEGORY_ART_PRINTS,
  HOME_SUBCATEGORY_STORAGE_ORGANIZATION,
  HOME_SUBCATEGORY_PLANT_DECOR,
  HOME_SUBCATEGORY_CURTAINS_BLINDS,
  UPLOAD_NEW_CONTENT,
  MODAL_UPLOAD_INSTAGRAM_TYPE_LABEL,
  MODAL_UPLOAD_INSTAGRAM_TYPE_REEL_LABEL,
  MODAL_UPLOAD_INSTAGRAM_TYPE_STORY_LABEL,
  MODAL_UPLOAD_INSTAGRAM_TYPE_POST_LABEL,
  BUTTON_RELOAD_PAGE,
  NEW_VERSION_TITLE,
  NEW_VERSION_DESCRIPTION,
  DELIVERY_INTERN_ON_THE_WAY,
  FIELD_EMAIL_REGISTERED,
  MODAL_DISSATISFACTION_COLLABORATION_TITLE,
  MODAL_DISSATISFACTION_COLLABORATION_DESCRIPTION,
  MODAL_DISSATISFACTION_COLLABORATION_BUTTON,
  MODAL_DISSATISFACTION_COLLABORATION_EXPLANATION_CREDIT,
  REVIEW_NOT_FOUND,
  REVIEW_IS_NOT_ONE_START,
  DISSATISFACTION_CREDIT_ALREADY_EXISTS,
  MODAL_DISSATISFACTION_COLLABORATION_CREDIT_RECEIVED,
  BUTTON_REPLACE_IMAGE,
  ADD_URL_PUBLICATION,
  VALUE_EXPRESSED_IN,
  ANY,
  GENDER,
  FIELD_SEARCH_CHATS_MORE_3_CHARACTERS,
  MODAL_SUBSCRIPTION_PRO_ARIA_LABEL,
  MODAL_SUBSCRIPTION_PRO_TITLE_HERO,
  MODAL_SUBSCRIPTION_PRO_DESCRIPTION_HERO,
  MODAL_SUBSCRIPTION_PRO_TITLE,
  MODAL_SUBSCRIPTION_PRO_SUB_HEADER,
  MODAL_SUBSCRIPTION_PRO_BENEFIT_1,
  MODAL_SUBSCRIPTION_PRO_BUY_BUTTON,
  PAYMENT_REASON_SUBSCRIPTION_PRO,
  NO_ADDED,
  BUTTON_SEE_PUBLICATION_ON,
  REVISIONS,
  CURRENT_CONTENT,
  CURRENT_CONTENT_EMPTY,
  MALE,
  FEMALE,
  COMMENT,
  NO_SEND_CONTENT_FEEDBACK,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_PERCENTAGE_PLACEHOLDER,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_CODE_PLACEHOLDER,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_TITLE,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_DESCRIPTION,
  FIELD_NUMBER_0_OR_NEGATIVE,
  FIELD_NUMBER_100_GREATER,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_EXPLANATION_1,
  COMPANY_INFORMATION_GENERAL_DISCOUNT_EXPLANATION_2,
  VALUE_GENERAL_CODE_REDEEMED,
  VALUE_WITH_PERCENTAGE,
  FIELD_NUMBER_LESS_THAN,
  FIELD_NUMBER_GREATER_THAN,
  BUTTON_ADD_USER,
  SUPER_ADMIN,
  SELECT_BUSINESS_PLACEHOLDER,
  NAME_BUSINESS_PLACEHOLDER,
  SELECT_BRANDS_PLACEHOLDER,
  MAIN_BRAND_PLACEHOLDER,
  SELECT_BRAND_PLACEHOLDER,
  SELECT_STORE_PLACEHOLDER,
  NAME_AND_LAST_NAME_PLACEHOLDER,
  FIELD_PASSWORD_CHANGE_MIN_LENGTH,
  ORDER_TOTAL_VALUE_DISCOUNT,
  GO_TO_ACCOUNT,
  ORDER,
  CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_PLACEHOLDER,
  CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_DESCRIPTION,
  CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_QUESTION,
  CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_REQUIRED,
  CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_PLACEHOLDER,
  CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_UGC_OPTION,
  SELECT_TYPE_PLAN_PLACEHOLDER,
  COST_COLLABORATION_PLACEHOLDER,
  CREDITS_PLACEHOLDER,
  TRIAL_DAYS_PLACEHOLDER,
  TYPE_PACKAGE_PLACEHOLDER,
  PRICE_BASIC_PLACEHOLDER,
  COST_COLLABORATION_BASIC_PLACEHOLDER,
  PRICE_GROWTH_PLACEHOLDER,
  COST_COLLABORATION_GROWTH_PLACEHOLDER,
  PLAN_PAY_PER_USE,
  PLAN_PACKAGE,
  PLAN_REGULAR,
  PLAN_ENTERPRISE,
  COLUMN_NAME_BRAND,
  COLUMN_NAME_AGENCY,
  COLUMN_NAME_ADVERTISER,
  COLUMN_NAME_USER,
  COLUMN_NAME_CATEGORY,
  COLUMN_NAME_IS_LOGGED,
  COLUMN_NAME_IS_ACTIVE,
  COLUMN_NAME_PACKAGE,
  COLUMN_NAME_EMAIL,
  COLUMN_NAME_NAME,
  COLUMN_NAME_PHONE,
  COLUMN_NAME_STAFF,
  COLUMN_NAME_ACCEPTED,
  COLUMN_NAME_MONTHLY_SALES,
  COLUMN_NAME_BUDGET_MARKETING,
  COLUMN_NAME_EMPLOYEES,
  COLUMN_NAME_PRODUCT_AVAILABILITY,
  COLUMN_NAME_SOCIAL_NETWORK,
  COLUMN_NAME_WEB_SITE,
  COLUMN_NAME_YOU_MEET,
  COLUMN_NAME_DATE,
  COMMERCIAL_PLACEHOLDER,
  ADD_NEW_OPTION,
  MODAL_COMMERCIAL_TITLE_CREATE,
  MODAL_COMMERCIAL_TITLE_EDIT,
  MODAL_COMMERCIAL_CREATE_COMMERCIAL,
  MODAL_COMMERCIAL_ALREADY_EXIST,
  BUTTON_ADD_SHOP,
  COLUMN_NAME_PLAN,
  COLUMN_NAME_PAYMENT_METHOD,
  COLUMN_NAME_COST_COLLABORATION,
  COLUMN_NAME_COUNTRY,
  COLUMN_NAME_CREDITS,
  PLAN_PAY_PER_USE_NAME,
  PLAN_PACKAGE_NAME,
  BUSINESS_NAME_PLACEHOLDER,
  USERS,
  FIELD_CREDITS_NOT_BE_NEGATIVE,
  FIELD_COST_COLLABORATION_NOT_BE_NEGATIVE,
  FIELD_TRIAL_MONTHS_NOT_BE_NEGATIVE,
  FIELD_PLAN_PRICES_NOT_BE_NEGATIVE,
  FIELD_STAFF_IS_REQUIRED,
  STORES,
  PLAN,
  AUTOMATIC_RENOVATION,
  DEACTIVATED,
  ACTIVE,
  MODAL_CREATE_PAYMENT_LINK_TITLE,
  MODAL_CREATE_PAYMENT_LINK_ARIA_LABEL,
  MODAL_CREATE_PAYMENT_LINK_LINKS,
  MODAL_CREATE_PAYMENT_LINK_LINKS_EMPTY,
  MODAL_CREATE_PAYMENT_LINK_NAME,
  DESCRIPTION_OPTIONAL_PLACEHOLDER,
  PRICE_PLACEHOLDER,
  CURRENCY_PLACEHOLDER,
  IS_RECURRENCE_PLACEHOLDER,
  RECURRENCE_PLACEHOLDER,
  RECURRENT_OPTION,
  RECURRING_DAYS,
  RECURRING_WEEKS,
  RECURRING_MONTHS,
  RECURRING_YEARS,
  FIELD_BOTH_DATES_REQUIRED,
  FIELD_START_DATE_GREATER_THAN_END_DATE,
  SOMETHING_ERROR_GENERATING_STATISTICS,
  BUTTON_DOWNLOAD_REPORT,
  META_INTEGRATION_UNLINKED_PAGES_ERROR,
  EDIT,
  MENU_MEDIA,
  CREATE_CAMPAIGN_TYPE_CONTENT_MEDIA,
  CREATE_CAMPAIGN_TYPE_CONTENT_MEDIA_QUESTION,
  CAMPAIGN_TYPE_CONTENT_MEDIA_PLACEHOLDER,
  THIS_CREATOR_IS_FAVORITE,
  ADD_TO_FAVORITES,
  REMOVE_FROM_FAVORITES,
  REDEEM_CODE_TABLE_COLUMN_TERMS,
  BUTTON_GENERATE_COMMENT,
  FAVORITES_CATEGORY,
  EMAIL,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_ARIA_LABEL,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_TITLE,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_LABEL,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_TOP_FIVE_OPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_EDUCATION_OPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_QUOTES_OPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_CURIOUS_FACTS_OPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_RHYMES_OR_POEMS_OPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_HUMOR_OPTION,
  BUTTON_GENERATE_CONTENT,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_EMPTY_CONTENT,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_GENERATING_CONTENT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ARIA_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_TITLE,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_TONES_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_COLOR_TEXT_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_COLOR_BACKGROUND_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_CONTENTS_REQUIRED,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_SCHEDULE_BUTTON,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_SCHEDULED_CONTENT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_DESCRIPTION,
  BUTTON_UPLOAD_LOGO,
  BUTTON_REPLACE_LOGO,
  BUTTON_UPLOAD_BACKGROUND,
  BUTTON_REPLACE_BACKGROUND,
  BUTTON_REMOVE_BACKGROUND,
  BUTTON_REGENERATE_CONTENT,
  SUB_MENU_SOCIAL_FEED,
  CAMPAIGN_DETAIL_APPLICANTS_PENDING_TITLE,
  ORDERS_REMEMBER_MARK_AS_DELIVERED,
  BUTTON_CONTINUOUS,
  CREATE_CAMPAIGN_GOAL_QUESTION,
  CREATE_CAMPAIGN_GOAL_PLACEHOLDER,
  CREATE_CAMPAIGN_GOAL_BRAND_AWARENESS_OPTION,
  CREATE_CAMPAIGN_GOAL_ENGAGEMENT_OPTION,
  CREATE_CAMPAIGN_GOAL_LEADS_OPTION,
  CREATE_CAMPAIGN_GOAL_SALES_OPTION,
  CREATE_CAMPAIGN_GOAL_REQUIRED,
  CAMPAIGN_GOAL_PLACEHOLDER,
  MODAL_SELECT_PACKAGE_BENEFIT_COLLABORATE_WITH_CREATOR,
  MODAL_SELECT_PACKAGE_BENEFIT_LAUNCH_CAMPAIGNS,
  MODAL_SELECT_PACKAGE_BENEFIT_DOWNLOAD_CONTENT,
  MODAL_SELECT_PACKAGE_BENEFIT_ANALYZE_METRICS,
  CAMPAIGN_REPOST_PLACEHOLDER_ITEM,
  PAYMENT_METHOD_NOT_FOUND,
  HAS_PENDING_PAYMENTS,
  CREATE_CAMPAIGN_TRAFFIC_LINK_VALID,
  ORDER_ID,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_LANGUAGE_LABEL,
  ENGLISH,
  SPANISH,
  CAMPAIGN_FINISHED_TIME,
  DATE_SHORT_LOCALIZED,
  DATE_LONG_LOCALIZED,
  VIEW,
  CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_TITLE,
  CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_SCRIPT_LABEL,
  FIELD_MAX_LENGTH,
  CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_TITLE_GENERATING,
  BUTTON_GENERATE_OTHER,
  MODAL_INVOICE_SUBSCRIPTION,
  MODAL_INVOICE_APPLICANT,
  MODAL_INVOICE_FEE,
  MODAL_INVOICE_IVA,
  MODAL_INVOICE_COLLABORATION,
  MODAL_INVOICE_CREDITS,
  MODAL_INVOICE_PLAN_ENTERPRISE_WITH_CREDITS,
  BUTTON_SUBSCRIBE_NOW,
  FIELD_TRIAL_DAYS_NOT_BE_NEGATIVE,
  ACCEPTED,
  PENDING,
  ARE_YOU_SURE,
  ARE_YOU_SURE_TO_DISCONNECT_ACCOUNT,
  CHANGE,
  BUTTON_PASS_TO_SUBSCRIPTION_BASIC,
  COLUMN_NAME_CREATOR_NAME,
  COLUMN_NAME_CITY,
  COLUMN_NAME_AUDIENCE,
  COLUMN_NAME_ENGAGEMENT,
  COLUMN_NAME_CATEGORIES,
  COLUMN_NAME_SCORE,
  COLUMN_NAME_ACTIVITY,
  COLUMN_NAME_CREATOR_PLATFORM,
  COLUMN_NAME_ACTIONS,
  COLUMN_NAME_STATUS,
  COLUMN_NAME_REDEEMED_DATE,
  COLUMN_NAME_TERMS,
  COLUMN_NAME_TYPE,
  COLUMN_NAME_ADDRESS,
  COLUMN_NAME_STORE,
  COLUMN_NAME_ROLE,
  COLUMN_NAME_PAID_DATE,
  COLUMN_NAME_DUE_DATE,
  COLUMN_NAME_REASON,
  COLUMN_NAME_VALUE,
  COLUMN_NAME_ID,
  COLUMN_NAME_CREATOR,
  COLUMN_NAME_CREATED_DATE,
  COLUMN_NAME_ACCEPTED_DATE,
  COLUMN_NAME_DETAILS,
  COLUMN_NAME_DELIVERY,
  COLUMN_NAME_CODE_VERIFICATION,
  COLUMN_NAME_ACCOUNT_NAME,
  COLUMN_NAME_IS_HIDDEN,
  COLUMN_NAME_COMMENT,
  BUTTON_EXTEND,
  REPORT_REQUESTS,
  REQUESTS_ACCEPTED,
  REQUESTS_REJECTED,
  REQUESTS_ACTIVE,
  CODE,
  IS_AUTOMATIC,
  REDEEMED,
  EXPIRED,
  REDEEMED_SINGULAR,
  EXPIRED_SINGULAR,
  EMPTY_RESULTS_SHOW_ON_THIS_PAGE,
  CONTENT_TITLE,
  REPORTS_TITLE,
  REPORTS_DESCRIPTION,
  REPORTS_ERROR_GENERATING,
  REPORTS_REQUESTS_ACTIVE,
  REPORTS_REQUESTS_INACTIVE,
  REPORTS_TYPE_USERS,
  REPORTS_NUMBER_USERS,
  REPORTS_TYPE_ORDER,
  REPORTS_NUMBER_ORDER,
  REJECTED,
  ROLE,
  REPORTS_MODAL_DESCRIPTION,
  REPORTS_MODAL_ONLY_BRANDS_ACTIVE,
  REPORTS_MODAL_TYPE_REPORT_LABEL,
  REPORTS_MODAL_TYPE_REPORT_BRANDS,
  REPORTS_MODAL_TYPE_REPORT_CREATORS,
  REPORTS_MODAL_TYPE_REPORT_ORDERS,
  BUTTON_ARCHIVE,
  BUTTON_UNARCHIVE,
  TRANSACTION_CONCEPT_LABEL,
  TRANSACTION_TYPE,
  TRANSACTION_TYPE_CREDIT,
  TRANSACTION_TYPE_DEBIT,
  TRANSACTION_STATUS,
  TRANSACTION_STATUS_PENDING,
  TRANSACTION_STATUS_PENDING_RELEASE,
  TRANSACTION_STATUS_IN_PROCESS_RELEASE,
  TRANSACTION_STATUS_RELEASED,
  TRANSACTION_STATUS_PENDING_SENT,
  TRANSACTION_IN_TRANSIT,
  TRANSACTION_STATUS_PAID,
  UNKNOWN,
  BUTTON_CREATE_TRANSACTION,
  TRANSACTION_WAS_PAID,
  BUTTON_UPDATE_STATISTICS,
  MODAL_CREATE_TRANSACTION,
  MODAL_CREATE_TRANSACTION_AMOUNT_LABEL,
  MODAL_CREATE_TRANSACTION_CONCEPT_LABEL,
  MODAL_CREATE_TRANSACTION_CONCEPT_APPLICANT,
  MODAL_CREATE_TRANSACTION_CONCEPT_ORDER,
  MODAL_CREATE_TRANSACTION_CONCEPT_REFERRAL,
  MODAL_CREATE_TRANSACTION_CONCEPT_ID,
  FIELD_END_DATE_GREATER_NOW,
  BUTTON_SEND_PAYMENT,
  BUTTON_VIEW_REPORT,
  REVIEWS,
  REVIEW,
  SHOW_REVIEWS,
  EMPTY_REVIEWS,
  DESCRIPTION_SEND_MESSAGE,
  DESCRIPTION_SEND_PAYMENT,
  SELECT_CAMPAIGN_PLACEHOLDER,
  CAMPAIGN_DETAIL_APPLICANTS_INVITED_TITLE,
  MODAL_PAY_CREATOR_AMOUNT_LABEL,
  FIELD_MIN_AMOUNT_PAY,
  REGISTER_PASSWORD_ANSWER,
  FIELD_PASSWORD_INSECURE,
  BLOCK_TRIAL_ACTIVE_TITLE,
  BLOCK_TRIAL_ACTIVE_DESCRIPTION,
  BLOCK_TRIAL_ACTIVE_BUTTON,
  MODAL_FREE_TRIAL_START_ALERT_DESCRIPTION,
  TRIAL_CONFIGURING_EXPERIENCE,
  TRIAL_PREPARING_PLATFORM,
  TRIAL_RETRY_ACCESS,
  BLOCK_CONTACT_YOUR_ADMINISTRATOR_TITLE,
  FIELD_BOTH_PASSWORD_REQUIRED,
  MODAL_FREE_TRIAL_CAPTION,
  BUTTON_ADD_AS_REFERENCE,
  BUTTON_ADDED,
  BUTTON_CREATE_CAMPAIGN2,
  BUTTON_LAUNCH_AD,
  BUTTON_CREATOR_CHAT,
  BUTTON_SEND_FILE,
  COLUMN_NAME_ACTION,
  BUTTON_SEE_MORE,
  BUTTON_SEE_LESS,
  BUTTON_SEND,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTEXT_LABEL,
  RIGHT,
  LEFT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_HAS_TEXT_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_FONT_FAMILY_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALIGN_TEXT_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALIGN_LOGO_LABEL,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_ALL_WITH_TEXT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_SOME_WITH_TEXT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_WITHOUT_TEXT,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_HAS_TEXTS_LABEL,
  LOGO,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTEXT_PLACEHOLDER,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_WEBSITE_URL_LABEL,
  FIELD_FILE_VALID_REQUIRED,
  FIELD_FILE_MAX_SIZE,
  MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_TITLE,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_DESCRIPTION,
  MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_TEXT_LABEL,
  BUTTON_YOU_HAVE_DOUBTS,
  BUTTON_WATCH_DEMO,
  CANCEL_ANYTIME,
  NO_IMAGES_FOUND_ON_PAGE,
  FIELD_URL_HTTPS_VALID,
  FIELD_URL_REPEATED,
  ADD_BRAND,
  MODAL_ADD_BRAND_SUPER_ADMIN_TITLE,
  MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_FROM_COLLABORATIONS_OPTION,
  MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_UPLOAD_OPTION,
  MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_EMPTY,
  DATE_LONG_TEXT,
  DATE,
  BUTTON_SAVE_CONTENT,
  BUTTON_REGENERATE_TEXT,
  DATE_LONG_TEXT_WITH_HOUR,
  DATE_LONG_TEXT_2,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALREADY_CONTENT_ON_THIS_DATE,
  NO_CREATE_DISCOUNT_SHOPIFY,
  NO_CREATE_WEBHOOK_ORDER_CREATED_SHOPIFY,
  NO_CREATE_WEBHOOK_FULFILLMENT_CREATED_SHOPIFY,
  NO_CREATE_WEBHOOK_FULFILLMENT_UPDATED_SHOPIFY,
  FIELD_ACCESS_TOKEN_SHOPIFY_VALID,
  BUTTON_SEND_BROADCAST,
  MODAL_BROADCAST_CONFIRM_TITLE,
  MODAL_BROADCAST_CONFIRM_DESCRIPTION,
  NAME_BUSINESS_BOT,
  SERVICE_FEE,
  TOTAL_PAYMENT,
  MODAL_USER_TITLE_EDIT,
  MODAL_USER_DESCRIPTION_EDIT,
  MODAL_USER_DESCRIPTION,
  MODAL_CONTACT_TITLE_EDIT,
  MODAL_CONTACT_DESCRIPTION,
  MODAL_CONTACT_DESCRIPTION_EDIT,
  MODAL_STORE_TITLE,
  MODAL_STORE_TITLE_EDIT,
  MODAL_STORE_DESCRIPTION,
  MODAL_STORE_DESCRIPTION_EDIT,
  MODAL_BROADCAST_DESCRIPTION,
  MODAL_COPY_MENU_DESCRIPTION,
  DESIGNER,
  MODAL_CREATE_PAYMENT_LINK_DESCRIPTION,
  BUTTON_ADD_REFERENCE_PROFILE,
  AUDIENCE_BY_SIMILAR_AUDIENCE_NOT_FOUND,
  OPTION_UGC_FORMAT_GRWM,
  OPTION_UGC_FORMAT_GRWM_EXPLANATION,
  OPTION_UGC_FORMAT_OODT,
  OPTION_UGC_FORMAT_OODT_EXPLANATION,
  OPTION_UGC_FORMAT_HAULS,
  OPTION_UGC_FORMAT_HAULS_EXPLANATION,
  OPTION_UGC_FORMAT_DIYS,
  OPTION_UGC_FORMAT_DIYS_EXPLANATION,
  OPTION_UGC_FORMAT_UNBOXING,
  OPTION_UGC_FORMAT_UNBOXING_EXPLANATION,
  OPTION_UGC_FORMAT_CHALLENGES,
  OPTION_UGC_FORMAT_CHALLENGES_EXPLANATION,
  OPTION_UGC_FORMAT_REVIEWS,
  OPTION_UGC_FORMAT_REVIEWS_EXPLANATION,
  OPTION_UGC_FORMAT_VLOGS,
  OPTION_UGC_FORMAT_VLOGS_EXPLANATION,
  OPTION_UGC_FORMAT_QA,
  OPTION_UGC_FORMAT_QA_EXPLANATION,
  OPTION_UGC_FORMAT_STORYTIME,
  OPTION_UGC_FORMAT_STORYTIME_EXPLANATION,
  OPTION_UGC_FORMAT_ROOM_TOURS,
  OPTION_UGC_FORMAT_ROOM_TOURS_EXPLANATION,
  OPTION_UGC_FORMAT_WHATS_IN_MY_BAG,
  OPTION_UGC_FORMAT_WHATS_IN_MY_BAG_EXPLANATION,
  OPTION_UGC_FORMAT_COOKING,
  OPTION_UGC_FORMAT_COOKING_EXPLANATION,
  OPTION_UGC_FORMAT_FITNESS_ROUTINES,
  OPTION_UGC_FORMAT_FITNESS_ROUTINES_EXPLANATION,
  OPTION_UGC_FORMAT_ASMR,
  OPTION_UGC_FORMAT_ASMR_EXPLANATION,
  OPTION_UGC_FORMAT_PLAN_WITH_ME,
  OPTION_UGC_FORMAT_PLAN_WITH_ME_EXPLANATION,
  OPTION_UGC_FORMAT_MUKBANG,
  OPTION_UGC_FORMAT_MUKBANG_EXPLANATION,
  OPTION_UGC_FORMAT_DAY_IN_THE_LIFE,
  OPTION_UGC_FORMAT_DAY_IN_THE_LIFE_EXPLANATION,
  OPTION_UGC_FORMAT_BEHIND_THE_SCENES,
  OPTION_UGC_FORMAT_BEHIND_THE_SCENES_EXPLANATION,
  OPTION_UGC_FORMAT_TRAVEL_DIARIES,
  OPTION_UGC_FORMAT_TRAVEL_DIARIES_EXPLANATION,
  SELECT_UGC_CONTENT_FORMAT,
  CREATE_CAMPAIGN_UGC_CONTENT_FORMAT_QUESTION,
  CREATE_CAMPAIGN_UGC_CONTENT_FORMAT_PLACEHOLDER,
  SUB_MENU_CONTENT_APPLICATION,
  CONTENT_APPLICATION_TITLE,
  COLUMN_NAME_URLS,
  CONTENT_APPLICATION_ACCEPT_TITLE,
  CONTENT_APPLICATION_ACCEPT_DESCRIPTION,
  CONTENT_APPLICATION_REJECT_TITLE,
  CONTENT_APPLICATION_REJECT_DESCRIPTION,
  BUTTON_CONNECT_WOOCOMMERCE,
  FAQ_QUESTION_ENSURE_CREATORS_UNDERSTAND_ACCEPT_EXCHANGE_TERMS_DESCRIPTION,
  FAQ_QUESTION_ENSURE_CREATORS_UNDERSTAND_ACCEPT_EXCHANGE_TERMS,
  FAQ_QUESTION_DIFFERENCE_BETWEEN_EXCHANGES_AND_CAMPAIGNS_DESCRIPTION,
  FAQ_QUESTION_DIFFERENCE_BETWEEN_EXCHANGES_AND_CAMPAIGNS,
  BUTTON_ADD_CONTENT,
  BUTTON_SEE_ALL_APPLICANTS,
  REQUEST_REJECT_CONFIRMATION_DESCRIPTION,
  REQUEST_APPROVE_CONFIRMATION_DESCRIPTION,
  MAIN_FUNCTIONALITY_STEP_4,
  MAIN_FUNCTIONALITY_ONBOARDING_FINISH,
  GETTING_INFORMATION_FROM_SHOPIFY_URL,
  LAST_COLLABORATION,
  REGISTER_PROFILE_CREATOR_PLATFORMS_ANSWER,
  REGISTER_PROFILE_CREATOR_CATEGORIES_ANSWER,
  REGISTER_PROFILE_CREATOR_GENDER_ANSWER,
  REGISTER_PROFILE_CREATOR_AGE_ANSWER,
  REGISTER_PROFILE_CREATOR_AGE_RANGE_REQUIRED,
  REGISTER_PROFILE_CREATOR_GENDER_REQUIRED,
  REGISTER_PROFILE_CREATOR_CATEGORIES_REQUIRED,
  REGISTER_PROFILE_CREATOR_PLATFORMS_REQUIRED,
  SELECT_SOME_OPTIONS,
  REGISTER_PROFILE_CREATOR_CITIES_ANSWER,
  REGISTER_PROFILE_CREATOR_CITIES_REQUIRED,
  RATE_DAILY_LIMIT_AI,
  RATE_DAILY_LIMIT_AI_CHAT,
  BUTTON_GO_BACK,
  TOP_RATED_CATEGORY,
  BUTTON_CLEAR_FILTERS,
  PERSONALIZED_INSTRUCTIONS,
  EMPTY_REQUESTS,
  EMPTY_CAMPAIGNS,
  EMPTY_ORDERS,
  EMPTY_REDEEM_CODES,
  EMPTY_USERS,
  EMPTY_CONTACTS,
  EMPTY_INVOICES,
  EMPTY_APPLICANTS_PENDING,
  EMPTY_APPLICANTS_ACCEPTED,
  PERMISSIONS_OR_CONFIGURATION_ACCOUNT_CHANGE_META,
  ACCOUNT_IS_NOT_TYPE_BUSINESS_OR_NO_ACCEPTED_ALL_PERMISSIONS,
  AUTH_TIKTOK_VERIFICATION_LOADING,
  AUTH_TIKTOK_VERIFICATION_SUCCESS,
  AUTH_TIKTOK_VERIFICATION_FAILED,
  DOCUMENT_ID_EMIRATES,
  DOCUMENT_TRN,
  ADS_CAMPAIGNS_TITLE,
  ADS_CAMPAIGNS_DESCRIPTION,
  EMPTY_ADS_CAMPAIGNS,
  FIELD_INTERESTS_REQUIRED,
  FIELD_GENDERS_REQUIRED,
  FIELD_LOCATIONS_REQUIRED,
  FIELD_CURRENCY_MIN_VALUE,
  FIELD_BUDGET_REQUIRED,
  FIELD_TYPE_BUDGET_REQUIRED,
  FIELD_OBJECTIVE_REQUIRED,
  FIELD_NAME_REQUIRED,
  CREATE_ADS_CAMPAIGN_NAME_QUESTION,
  CREATE_ADS_CAMPAIGN_NAME_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_OBJECTIVE_QUESTION,
  CREATE_ADS_CAMPAIGN_OBJECTIVE_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_TYPE_BUDGET_QUESTION,
  CREATE_ADS_CAMPAIGN_TYPE_BUDGET_DAILY_RADIO_LABEL,
  CREATE_ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_RADIO_LABEL,
  CREATE_ADS_CAMPAIGN_BUDGET_DAILY_QUESTION,
  CREATE_ADS_CAMPAIGN_BUDGET_TOTAL_QUESTION,
  CREATE_ADS_CAMPAIGN_BUDGET_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_LOCATIONS_QUESTION,
  CREATE_ADS_CAMPAIGN_AGE_RANGE_QUESTION,
  CREATE_ADS_CAMPAIGN_GENDERS_QUESTION,
  CREATE_ADS_CAMPAIGN_INTERESTS_QUESTION,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_LINKEDIN,
  ADS_CAMPAIGN_OBJECTIVE_SALES,
  ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS,
  ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY,
  ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_DESCRIPTION_EXPLANATION,
  FIELD_PLATFORMS_REQUIRED,
  CREATE_ADS_CAMPAIGN_PLATFORM_QUESTION,
  CREATE_ADS_CAMPAIGN_DESCRIPTION_QUESTION,
  CTR,
  CLICKS,
  IMPRESSIONS,
  REPORTS,
  PLATFORMS,
  AGES,
  GENDERS,
  LOCATIONS,
  TARGET_CAMPAIGN,
  ADS_CAMPAIGN_TITLE,
  ADS_CAMPAIGN_HAS_BEEN_FINISHED,
  DESCRIPTION_PLACEHOLDER,
  INTERESTS_PLACEHOLDER,
  GENDERS_PLACEHOLDER,
  AGE_RANGE_PLACEHOLDER,
  LOCATIONS_PLACEHOLDER,
  EXCLUDED_LOCATIONS_PLACEHOLDER,
  INDUSTRIES_PLACEHOLDER,
  JOB_FUNCTIONS_PLACEHOLDER,
  SENIORITIES_PLACEHOLDER,
  JOB_TITLES_PLACEHOLDER,
  COMPANY_SIZES_PLACEHOLDER,
  COMPANIES_PLACEHOLDER,
  DEGREES_PLACEHOLDER,
  FIELDS_OF_STUDY_PLACEHOLDER,
  SCHOOLS_PLACEHOLDER,
  SKILLS_PLACEHOLDER,
  MEMBER_TRAITS_PLACEHOLDER,
  MEMBER_BEHAVIORS_PLACEHOLDER,
  MEMBER_GROUPS_PLACEHOLDER,
  AUDIENCE_ATTRIBUTES_PLACEHOLDER,
  DEGREES_SEARCH_PLACEHOLDER,
  FIELDS_OF_STUDY_SEARCH_PLACEHOLDER,
  INTERESTS_SEARCH_PLACEHOLDER,
  SCHOOLS_SEARCH_PLACEHOLDER,
  SKILLS_SEARCH_PLACEHOLDER,
  COMPANIES_SEARCH_PLACEHOLDER,
  INDUSTRIES_SEARCH_PLACEHOLDER,
  COMPANY_SIZES_SEARCH_PLACEHOLDER,
  JOB_FUNCTIONS_SEARCH_PLACEHOLDER,
  JOB_TITLES_SEARCH_PLACEHOLDER,
  SENIORITIES_SEARCH_PLACEHOLDER,
  MEMBER_BEHAVIORS_SEARCH_PLACEHOLDER,
  DAILY_BUDGET_PLACEHOLDER,
  PLATFORMS_PLACEHOLDER,
  OBJECTIVE_PLACEHOLDER,
  ADS_CAMPAIGN_HAS_BEEN_ACTIVATE,
  ADS_CAMPAIGN_HAS_BEEN_SAVE,
  CREATE_ADS_CAMPAIGN_INTERESTS_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_DESCRIPTION_PLACEHOLDER,
  FIELD_DESCRIPTION_REQUIRED,
  TYPE_LEAST_CHARACTERS,
  LOADING,
  META,
  META_FACEBOOK_AND_INSTAGRAM,
  PLATFORM,
  FIELD_PLATFORM_REQUIRED,
  ALERT_CREATE_SECOND_ADS_CAMPAIGN,
  ALERT_CREATE_SECOND_ADS_CAMPAIGN_DESCRIPTION,
  BUTTON_META_BILLING,
  BUTTON_TIKTOK_BILLING,
  PLATFORM_PLACEHOLDER,
  SUB_MENU_ADS_CAMPAIGNS,
  OBJECTIVE,
  AWARENESS,
  TRAFFIC,
  SALES,
  DOWNLOADS,
  LEADS,
  INTERACTIONS,
  FIELD_VIDEO_REQUIRED,
  FIELD_CREATIVE_MUST_BE_VIDEO_NOT_IMAGE,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_QUESTION,
  BUTTON_REPLACE_CONTENT,
  TIKTOK_CAMPAIGN,
  META_CAMPAIGN,
  ADS_CAMPAIGN_HAS_BEEN_DUPLICATE,
  BUTTON_REPLACE_VIDEO,
  BUTTON_SELECT_VIDEO,
  CONTENT_TO_ADVERTISE,
  FIELD_BEHAVIORS_REQUIRED,
  CREATE_ADS_CAMPAIGN_BEHAVIORS_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_BEHAVIORS_QUESTION,
  CREATE_ADS_CAMPAIGN_DEMOGRAPHICS_QUESTION,
  CREATE_ADS_CAMPAIGN_DEMOGRAPHICS_PLACEHOLDER,
  BEHAVIORS_PLACEHOLDER,
  DEMOGRAPHICS_PLACEHOLDER,
  BUTTON_SELECT_THIS_CONTENT,
  BUTTON_REMOVE_SELECTION,
  FACEBOOK_PAGE_ID_NOT_FOUND,
  META_BUSINESS_ACCOUNT_NOT_FOUND,
  IG_BUSINESS_ACCOUNT_NOT_FOUND,
  CREATE_ADS_CAMPAIGN_TRACKING_QUESTION,
  EMPTY_TRACKING_IDS_META,
  FIELD_META_TRACKING_ID_REQUIRED,
  TRACKING_META_ID_PLACEHOLDER,
  FINISHED,
  ACCOUNT_TIKTOK_AUTH_NOT_MATCH,
  ACCOUNT_TOKEN_META_NOT_FOUND,
  ACCOUNT_ID_BUSINESS_META_NOT_FOUND,
  OBJECTIVE_CAMPAIGN_META_INVALID,
  SPECIAL_CATEGORY_CAMPAIGN_META_INVALID,
  CAMPAIGN_META_NOT_DELETED,
  CAMPAIGN_META_NOT_CREATED,
  ADS_CAMPAIGN_NOT_FOUND,
  NO_PIXELS_FOUND,
  NO_PIXELS_ACTIVE,
  CAMPAIGN_META_NOT_FOUND,
  CAMPAIGN_META_NOT_UPDATED,
  CAMPAIGN_AD_SET_META_NOT_CREATED,
  CAMPAIGN_AD_SET_META_NOT_UPDATED,
  CAMPAIGN_INFORMATION_UPDATE_FAILED_RATE_LIMIT,
  CAMPAIGN_MEDIA_META_NOT_CREATED,
  CAMPAIGN_MEDIA_THUMBNAIL_META_NOT_FOUND,
  CAMPAIGN_CREATIVE_AD_META_NOT_CREATED,
  CAMPAIGN_CREATIVE_AD_META_NOT_UPDATED,
  CAMPAIGN_CREATIVE_AD_META_NOT_FOUND,
  CAMPAIGN_MESSAGE_TEMPLATE_META_NOT_FOUND,
  CAMPAIGN_AD_META_NOT_CREATED,
  CAMPAIGN_AD_META_NOT_UPDATED,
  CAMPAIGN_METRICS_META_NOT_FOUND,
  BUTTON_CONNECT_TIKTOK_BUSINESS,
  TIKTOK_BUSINESS,
  EMPTY_TRACKING_IDS_TIKTOK,
  TIKTOK_PRIVACY_LEVEL_PUBLIC_TO_EVERYONE,
  TIKTOK_PRIVACY_LEVEL_MUTUAL_FOLLOW_FRIENDS,
  TIKTOK_PRIVACY_LEVEL_FOLLOWER_OF_CREATOR,
  TIKTOK_PRIVACY_LEVEL_SELF_ONLY,
  TIKTOK_PRIVACY_LEVEL_LABEL,
  TIKTOK_ACCOUNT_LABEL,
  TIKTOK_DISABLE_DUET_LABEL,
  TIKTOK_DISABLE_DUET_DESCRIPTION,
  TIKTOK_DISABLE_STITCH_LABEL,
  TIKTOK_DISABLE_STITCH_DESCRIPTION,
  TIKTOK_DISABLE_COMMENT_LABEL,
  TIKTOK_DISABLE_COMMENT_DESCRIPTION,
  TIKTOK_IS_AIGC_LABEL,
  TIKTOK_IS_AIGC_DESCRIPTION,
  SHORT_TIME_HAS_PASSED_SINCE_ACTIVATION_STATISTICS,
  CREATE_ADS_CAMPAIGN_DESTINATION_URL_QUESTION,
  FIELD_DESTINATION_URL_REQUIRED,
  FIELD_DESTINATION_URL_NOT_FOUND_IN_EVENTS_PIXEL,
  FIELD_DESTINATION_URL_NOT_FOUND_IN_EVENTS_PIXEL_REQUIRED,
  CREATE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE,
  ACTIVE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE,
  BUTTON_RECHARGE_BALANCE,
  ALERT_REMEMBER_IF_RECHARGE_ACCOUNT_PLATFORM,
  INFORMATION,
  DESTINATION_URL_PLACEHOLDER,
  CAMPAIGN_AUDIENCE_IS_TOO_NARROW,
  CAMPAIGN_BUDGET_IS_TOO_LOW,
  PRICE_PRO_PLACEHOLDER,
  COST_COLLABORATION_PRO_PLACEHOLDER,
  MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_CHAT_WITH_CREATORS,
  MODAL_SELECT_PACKAGE_BENEFIT_CONTENT_CURATION,
  MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_PUBLICATION_PLATFORM,
  MODAL_SELECT_PACKAGE_LICENSED_PRICE,
  MODAL_SELECT_PACKAGE_LICENSED_FEE,
  MODAL_SELECT_PACKAGE_COST_CONTENT,
  SHOPIFY,
  WOOCOMMERCE,
  BUTTON_CONNECT_SHOPIFY,
  MODAL_STORE_BUTTON_CREATE_INTEGRATE_WOOCOMMERCE,
  MODAL_STORE_DESCRIPTION_CREATE_INTEGRATE_WOOCOMMERCE,
  MODAL_STORE_TITLE_CREATE_INTEGRATE_WOOCOMMERCE,
  MODAL_STORE_BUTTON_CREATE_INTEGRATE_SHOPIFY,
  MODAL_STORE_DESCRIPTION_CREATE_INTEGRATE_SHOPIFY,
  MODAL_STORE_TITLE_CREATE_INTEGRATE_SHOPIFY,
  MODAL_STORE_DESCRIPTION_DISCONNECT_SHOPIFY,
  MODAL_STORE_DESCRIPTION_DISCONNECT_WOOCOMMERCE,
  ALERT_DESCRIPTION_DISCONNECT_TIKTOK,
  ALERT_DESCRIPTION_DISCONNECT_FACEBOOK,
  MODAL_SELECT_PACKAGE_BENEFIT_VOLUME_CONTENT,
  MODAL_SELECT_PACKAGE_LICENSED_FEE_ENTERPRISE,
  MODAL_SELECT_PACKAGE_CONTENT_ENTERPRISE,
  ALERT_DESCRIPTION_DISCONNECT_TIKTOK_BUSINESS,
  VIDEO_ERROR_ILLEGAL_DURATION,
  VIDEO_ERROR_BLACK_EDGE,
  VIDEO_ERROR_ASPECT_RATIO,
  VIDEO_ERROR_NO_BACKGROUND_AUDIO,
  IDENTITY_NOT_FOUND,
  VIDEO_ERROR_LOW_RESOLUTION,
  TRACKING_TIKTOK_ID_PLACEHOLDER,
  BUTTON_CONNECT_META,
  FIELD_TIKTOK_TRACKING_ID_REQUIRED,
  PUBLICATION_STATUS_PENDING_SOCIAL,
  ADD_NEW_STYLE,
  WANTS_SOCIAL_MEDIA_POST,
  DOES_NOT_WANTS_SOCIAL_MEDIA_POST,
  BUTTON_CONTACT_AN_ADVISOR,
  ENGAGEMENT_ABBREVIATED,
  FOLLOWERS_ABBREVIATED,
  NO_MORE_RESULTS_TO_SHOW,
  BUTTON_GENERATE_SCRIPT,
  EXPLANATION_SEND_ONE_REVISION,
  I_NEED_HELP,
  REVISION_OPTION_GOOD,
  REVISION_OPTION_REGULAR,
  REVISION_OPTION_BAD,
  BUTTON_VIEW_INVOICE,
  MODAL_INVOICE_LICENSE,
  CREATOR_BODY_BUILD_PLACEHOLDER,
  CREATOR_CLOTHING_STYLE_PLACEHOLDER,
  CREATOR_CONTENT_STYLE_PLACEHOLDER,
  CREATOR_DISTINGUISHING_FEATURES_PLACEHOLDER,
  BODY_BUILD_THIN,
  BODY_BUILD_AVERAGE,
  BODY_BUILD_WIDE,
  BODY_BUILD_MUSCULAR,
  BODY_BUILD_CURVY,
  BODY_BUILD_ATHLETIC,
  CLOTHING_STYLE_CASUAL,
  CLOTHING_STYLE_FORMAL,
  CLOTHING_STYLE_SPORTY,
  CLOTHING_STYLE_BUSINESS,
  CLOTHING_STYLE_ELEGANT,
  CLOTHING_STYLE_TRENDY,
  CLOTHING_STYLE_STREETWEAR,
  CLOTHING_STYLE_TRADITIONAL,
  CLOTHING_STYLE_VINTAGE,
  CLOTHING_STYLE_BOHEMIAN,
  CLOTHING_STYLE_HIPSTER,
  CLOTHING_STYLE_PUNK,
  CLOTHING_STYLE_GOTHIC,
  DISTINGUISHING_FEATURES_TATTOOS,
  DISTINGUISHING_FEATURES_SCARS,
  DISTINGUISHING_FEATURES_BIRTHMARKS,
  DISTINGUISHING_FEATURES_FRECKLES,
  DISTINGUISHING_FEATURES_MOLES,
  DISTINGUISHING_FEATURES_PIERCINGS,
  DISTINGUISHING_FEATURES_DIMPLES,
  DISTINGUISHING_FEATURES_WRINKLES,
  DISTINGUISHING_FEATURES_GLASSES,
  DISTINGUISHING_FEATURES_BRACES,
  DISTINGUISHING_FEATURES_MAKEUP,
  DISTINGUISHING_FEATURES_HAIR_ACCESSORIES,
  DISTINGUISHING_FEATURES_BEARD,
  DISTINGUISHING_FEATURES_MUSTACHE,
  CONTENT_STYLE_ELEGANT,
  CONTENT_STYLE_AESTHETIC,
  CONTENT_STYLE_RAW,
  CONTENT_STYLE_MINIMALISTIC,
  CONTENT_STYLE_ARTISTIC,
  CONTENT_STYLE_VINTAGE,
  CONTENT_STYLE_MODERN,
  CONTENT_STYLE_PLAYFUL,
  CONTENT_STYLE_RUSTIC,
  CONTENT_STYLE_MONOCHROMATIC,
  REGISTER_PROFILE_CREATOR_CONTENT_STYLE,
  REGISTER_PROFILE_CREATOR_DISTINGUISHING_FEATURES,
  REGISTER_PROFILE_CREATOR_CLOTHING_STYLE,
  REGISTER_PROFILE_CREATOR_BODY_BUILD,
  REGISTER_PROFILE_CREATOR_BODY_BUILD_REQUIRED,
  REGISTER_PROFILE_CREATOR_CLOTHING_STYLE_REQUIRED,
  REGISTER_PROFILE_CREATOR_DISTINGUISHING_FEATURES_REQUIRED,
  REGISTER_PROFILE_CREATOR_CONTENT_STYLE_REQUIRED,
  BUTTON_ADJUST_PREFERENCES,
  FIELD_MAX_LENGTH_SELECT,
  FIELD_MIN_LENGTH_SELECT,
  CREATE_ADS_CAMPAIGN_LOADING_FINALIZING_DETAILS,
  CREATE_ADS_CAMPAIGN_LOADING_CREATING_INSTANT_FORM,
  CREATE_ADS_CAMPAIGN_LOADING_GENERATING_RECOMMENDATIONS,
  CREATE_ADS_CAMPAIGN_LOADING_ANALYZING_INFORMATION,
  CREATE_ADS_CAMPAIGN_LOADING_GETTING_REQUIRED_INFORMATION,
  CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION,
  CREATE_ADS_CAMPAIGN_CONTEXT_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_CONTEXT_PLACEHOLDER,
  BUTTON_GENERATE_AGAIN,
  BUTTON_CREATE_ADS_CAMPAIGN,
  WHY_THESE_RECOMMENDED_SETTINGS,
  ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE,
  ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION,
  BUTTON_EDIT_BUDGET,
  CALL_TO_ACTION_PLACEHOLDER,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MENU,
  ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP,
  ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE,
  ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_APPLY,
  ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_QUOTE,
  ADS_CAMPAIGN_CALL_TO_ACTION_JOIN,
  ADS_CAMPAIGN_CALL_TO_ACTION_ATTEND,
  ADS_CAMPAIGN_CALL_TO_ACTION_REQUEST_DEMO,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_REGISTER,
  ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_CALL_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US,
  ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD,
  ADS_CAMPAIGN_CALL_TO_ACTION_UNLOCK_FULL_DOCUMENT,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_DIRECTIONS,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES,
  ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE_INSTAGRAM,
  ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_REQUEST_TIME,
  ADS_CAMPAIGN_CALL_TO_ACTION_SAVE,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_OFFER,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_PROMOTIONS,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_ACCESS,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_UPDATES,
  ADS_CAMPAIGN_CALL_TO_ACTION_INQUIRE_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_BUY_TICKETS,
  ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME,
  ADS_CAMPAIGN_CALL_TO_ACTION_EXPLORE_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_INSTALL_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_USE_APP,
  ADS_CAMPAIGN_CAMPAIGN_INFORMATION_SUB_TITLE,
  ADS_CAMPAIGN_BUDGET_INFORMATION_SUB_TITLE,
  ADS_CAMPAIGN_SEGMENTATION_SUB_TITLE,
  BUTTON_PUBLISH_CAMPAIGN,
  CREATE_ADS_CAMPAIGN_INTRO_CALL_TO_ACTION_BUTTON,
  CREATE_ADS_CAMPAIGN_INTRO_CALL_TO_ACTION_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_INTRO_FEATURE_ALL_IN_ONE_PLACE,
  CREATE_ADS_CAMPAIGN_INTRO_FEATURE_ANALYZE_PERFORMANCE,
  CREATE_ADS_CAMPAIGN_INTRO_FEATURE_MANAGE_SIMPLE,
  CREATE_ADS_CAMPAIGN_INTRO_FEATURE_OPTIMIZE_WITH_AI,
  CREATE_ADS_CAMPAIGN_INTRO_FEATURE_CREATE_CAMPAIGN,
  CREATE_ADS_CAMPAIGN_INTRO_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_INTRO_TITLE,
  PIXEL_REQUIRED,
  ADS_CAMPAIGN_CONTEXT,
  CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_PRODUCT_ADVERTISE,
  CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_COMMUNICATE,
  CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_SEGMENTATION,
  BUTTON_START_CHAT,
  FIELD_WEBSITE_URL_REQUIRED,
  CREATE_ADS_CAMPAIGN_WEBSITE_URL_QUESTION,
  BUTTON_SELECT_CONTENT,
  BUTTON_SELECT_DOCUMENT,
  BUTTON_SELECT_POST,
  FIELD_CONTENT_REQUIRED,
  TYPE_BUDGET_PLACEHOLDER,
  LIFETIME_BUDGET_PLACEHOLDER,
  DRAFT,
  BUTTON_CREATE_WITH_CANVA,
  BUTTON_CONNECT_CANVA,
  CANVA,
  ALERT_DESCRIPTION_DISCONNECT_CANVA,
  MODAL_CANVA_DESCRIPTION,
  MODAL_CANVA_TITLE,
  MODAL_CANVA_ARIA_LABEL,
  MODAL_CANVA_CREATING_DESIGN,
  MODAL_CANVA_DESIGN_NOT_CREATED,
  MODAL_CANVA_DESIGN_NOT_RETRIEVED,
  MODAL_CANVA_IS_EDITING_IN_CANVA,
  MODAL_CANVA_IS_GETTING_YOUR_DESIGN,
  BUTTON_USE_THIS_CONTENT,
  MODAL_CANVA_INFORMATION_SAVE_DESIGN,
  MODAL_CANVA_IMPORT_IMAGES_ONLY_WARNING_DESCRIPTION,
  MODAL_CANVA_IMAGE_CONFIG_TITLE,
  MODAL_CANVA_IMAGE_CONFIG_DESCRIPTION,
  MODAL_CANVA_IMAGE_CONFIG_TYPE_LABEL,
  MODAL_CANVA_IMAGE_CONFIG_WIDTH_LABEL,
  MODAL_CANVA_IMAGE_CONFIG_HEIGHT_LABEL,
  MODAL_CANVA_IMAGE_CONFIG_CREATE_BUTTON,
  MODAL_CANVA_IMAGE_CONFIG_CANCEL_BUTTON,
  MODAL_CANVA_ACCOUNT_LABEL,
  MODAL_GOOGLE_DRIVE_ACCOUNT_LABEL,
  MODAL_GOOGLE_DRIVE_ACCOUNT_TITLE,
  MODAL_GOOGLE_DRIVE_ACCOUNT_DESCRIPTION,
  MODAL_GOOGLE_DRIVE_ACCOUNT_CONFIRM_BUTTON,
  GOOGLE_DRIVE_CONFIGURING_FILE_SELECTOR,
  GOOGLE_DRIVE_OPENING_SELECTOR,
  GOOGLE_DRIVE_IMPORTING_FILES,
  MODAL_CANVA_FOLDER_LABEL,
  MODAL_CANVA_IMAGE_CONFIG_EDIT_BUTTON,
  MODAL_CANVA_IMAGE_CONFIG_EDIT_TITLE,
  MODAL_CANVA_IMAGE_CONFIG_EDIT_DESCRIPTION,
  MODAL_CANVA_DISCONNECT_TITLE,
  MODAL_CANVA_DISCONNECT_DESCRIPTION,
  MODAL_CANVA_DISCONNECT_BUTTON,
  ERROR_WIDTH_RANGE,
  ERROR_HEIGHT_RANGE,
  CONNECTED_ACCOUNTS,
  CONNECTED_ACCOUNTS_ACCORDION_COLLAPSE,
  CONNECTED_ACCOUNTS_ACCORDION_EXPAND,
  SLIDE_MENU_COLLAPSE,
  SLIDE_MENU_EXPAND,
  CONNECTED_ACCOUNTS_CONNECT_MORE_PLATFORMS,
  CONNECTED_ACCOUNTS_BUTTON_CONNECT,
  CONNECTED_ACCOUNTS_EMPTY_HINT,
  CONNECTED_ACCOUNTS_INTEGRATIONS_COUNT,
  CONNECTED_ACCOUNTS_INTEGRATIONS_COUNT_SINGULAR,
  CONNECTED_ACCOUNTS_PLATFORM_GOOGLE,
  CONNECTED_ACCOUNTS_PLATFORM_LINKEDIN,
  CONNECTED_ACCOUNTS_PLATFORM_META,
  CONNECTED_ACCOUNTS_PLATFORM_TIKTOK_BUSINESS,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_TITLE,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_SUCCESS,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_ERROR,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_LOADING,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_AD_FORMAT_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_PROMOTION_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CAMPAIGN_TYPE_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CATALOG_FOR_APP_INSTALL_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CATALOG_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DEEP_LINK_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DESTINATION_TYPE_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DESTINATION_URL_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_IDENTITIES_ACCOUNTS_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_MERCHANT_ID_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_OBJECTIVE_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_TIKTOK_CAMPAIGN_TYPE_LABEL,
  ADS_CAMPAIGN_USE_GENERAL_BUDGET,
  AD_GROUP,
  AD,
  ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_SUB_TITLE,
  ADS_CAMPAIGN_AD_GROUP_INFORMATION_SUB_TITLE,
  NUMBER_ITEM,
  DESCRIPTIONS,
  HEADLINES,
  TITLES,
  TITLE_PLACEHOLDER,
  HEADLINE_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_START_END_DATE_QUESTION,
  FIELD_START_AND_END_DATES_REQUIRED,
  WEBSITE_URL_PLACEHOLDER,
  COMING_SOON,
  BUTTON_CONNECT_GOOGLE,
  BUTTON_CONNECT_GOOGLE_DRIVE,
  LANGUAGE_CAMPAIGN_PLACEHOLDER,
  FIELD_LANGUAGE_REQUIRED,
  CREATE_ADS_LANGUAGE_QUESTION,
  CREATE_ADS_PLATFORMS_QUESTION,
  BUTTON_SELECT,
  BUTTON_DESELECT,
  BUTTON_SEND_CODE,
  VERIFICATION_CODE_PLACEHOLDER,
  ENTER_CODE,
  AUTH_INVALID_VERIFICATION_CODE,
  BUTTON_VERIFY_CODE,
  WE_SEND_VERIFICATION_CODE_TO_YOUR_PHONE,
  MODIFY_PHONE_NUMBER,
  OTP_VERIFICATION_TITLE,
  OTP_VERIFICATION_EMAIL_SENT,
  OTP_BACK_TO_EMAIL,
  ERROR_GETTING_URL_INFORMATION_BY_PROTECTED,
  META_TOGGLE_DESCRIPTION,
  GOOGLE_TOGGLE_DESCRIPTION,
  TIKTOK_TOGGLE_DESCRIPTION,
  NOT_AVAILABLE,
  BUTTON_CONNECTED,
  EDIT_INSTRUCTIONS,
  PROMPT,
  BUTTON_ADD_RE_TARGETING,
  MODAL_CUSTOM_AUDIENCES_DESCRIPTION,
  MODAL_CUSTOM_AUDIENCES_TITLE,
  MODAL_CUSTOM_AUDIENCES_ARIA_LABEL,
  MODAL_CUSTOM_AUDIENCES_EMPTY_TEXT,
  TYPE,
  RETENTION_DAYS,
  ERRORS,
  OPERATION_STATUS,
  DELIVERY_STATUS,
  MODAL_CREATE_CUSTOM_AUDIENCE_DESCRIPTION,
  MODAL_CREATE_CUSTOM_AUDIENCE_TITLE,
  MODAL_CREATE_CUSTOM_AUDIENCE_ARIA_LABEL,
  RETENTION_DAYS_PLACEHOLDER,
  TYPE_PLACEHOLDER,
  ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_WEBSITE,
  ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST,
  ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_TITLE_EXPLANATION,
  ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_TITLE_EXPLANATION,
  MODAL_CREATE_CUSTOM_AUDIENCE_UPLOAD_CSV_CUSTOMER_LIST,
  ADS_SUBSCRIPTION_BENEFIT_PLATFORMS_CAMPAIGNS,
  ADS_SUBSCRIPTION_BENEFIT_CAMPAIGNS,
  ADS_SUBSCRIPTION_BENEFIT_OPTIMIZATIONS,
  ADS_SUBSCRIPTION_BENEFIT_USERS,
  ADS_SUBSCRIPTION_BENEFIT_STORAGE,
  ADS_SUBSCRIPTION_BENEFIT_STORAGE_CUSTOM,
  ADS_SUBSCRIPTION_BENEFIT_EMAIL_SUPPORT,
  ADS_SUBSCRIPTION_BENEFIT_CHAT_SUPPORT,
  ADS_SUBSCRIPTION_BENEFIT_PRIORITY_SUPPORT,
  ADS_SUBSCRIPTION_BENEFIT_DEDICATED_ACCOUNT_MANAGER,
  VALUE_SUBSCRIPTION_MONTHLY,
  BUTTON_BUY_PLAN,
  MOST_POPULAR,
  PRICING_HERO_TITLE_PACKAGES,
  PRICING_HERO_TITLE_CREDITS,
  PRICING_HERO_DESCRIPTION,
  PRICING_APPSUMO_CREDITS_STACK_TITLE,
  PRICING_APPSUMO_CREDITS_STACK_DESCRIPTION,
  PRICING_CREDIT_USAGE_TITLE,
  PRICING_CREDIT_USAGE_CAMPAIGN,
  PRICING_CREDIT_USAGE_IMAGE,
  PRICING_CREDIT_USAGE_VIDEO,
  PRICING_CREDIT_USAGE_ANIMATE_IMAGE,
  PRICING_CREDIT_USAGE_ANALYZE_IMAGE_LAYERS,
  PRICING_CREDIT_USAGE_CUSTOM_REPORT,
  PRICING_CREDIT_USAGE_CUSTOM_REPORT_DECK,
  PRICING_CREDIT_USAGE_OPTIMIZATION,
  PRICING_CREDIT_USAGE_SCHEDULED_POST,
  PRICING_CREDIT_USAGE_PER,
  PRICING_CREDIT_USAGE_CREDIT,
  PRICING_CREDIT_USAGE_CREDITS,
  CREDIT_COST_ITEM,
  MANUAL_SEGMENTATION,
  RE_TARGETING_SEGMENTATION,
  BUTTON_ADD,
  BUTTON_UPLOAD_CONTENT_FROM_ADS_PLATFORMS,
  ADS_CAMPAIGNS_PIXELS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGNS_PIXELS_TITLE_EXPLANATION,
  BUTTON_UPDATE,
  UPDATING_INFORMATION,
  ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_READ_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_INTERESTED,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_TICKETS_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_EXPERIENCE_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_PRE_ORDER_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_VISIT_STORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_PROFILE,
  FIELD_CALL_TO_ACTION_VALID_BY_OBJECTIVE,
  TITLE,
  IDENTITIES_TIK_TOK_EMPTY,
  IDENTITY_TIK_TOK_PLACEHOLDER,
  ADD_NEW_IDENTITY,
  PROFILE_IMAGE_PLACEHOLDER,
  PROFILE_NAME_PLACEHOLDER,
  ALERT_TIK_TOK_BUSINESS_NEEDS_CREATE_IDENTITY_TITLE,
  ALERT_TIK_TOK_BUSINESS_NEEDS_CREATE_IDENTITY_DESCRIPTION,
  MENU_CONNECTED_ACCOUNTS,
  GENERAL_INFORMATION,
  CONTEXT,
  FIELD_TRACKING_IDS_REQUIRED,
  CREATE_ADS_CAMPAIGN_TRACKINGS_QUESTION,
  AUTH_INVALID_APP_CREDENTIAL,
  LOADING_METRICS_FROM_PLATFORMS,
  CAMPAIGN_HAS_NEVER_BEEN_ACTIVATED,
  HOW_IS_YOUR_CAMPAIGN_GOING,
  AN_ERROR_OCCURRED_GETTING_THE_REPORT,
  META_ERROR_GETTING_USER_INFORMATION,
  META_ERROR_GETTING_BUSINESS_ACCOUNTS_INFORMATION,
  META_ERROR_GETTING_ACCOUNTS_INFORMATION,
  META_OAUTH_PERMISSIONS_ERROR,
  META_ACCOUNT_AUTHENTICATION_REQUIRED,
  AD_ACCOUNTS,
  FACEBOOK_PAGES,
  INSTAGRAM_ACCOUNTS,
  AD_ACCOUNT_META_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_AD_ACCOUNTS_QUESTION,
  CREATE_ADS_CAMPAIGN_AD_ACCOUNT_QUESTION,
  AD_ACCOUNT_TIKTOK_PLACEHOLDER,
  FIELD_AD_ACCOUNTS_REQUIRED,
  INSTAGRAM_ACCOUNT_PLACEHOLDER,
  USE_FB_PAGE_AS_IG,
  YOUTUBE_ACCOUNT_PLACEHOLDER,
  YOUTUBE_PRIVACY_LEVEL_PUBLIC,
  YOUTUBE_PRIVACY_LEVEL_UNLISTED,
  YOUTUBE_PRIVACY_LEVEL_PRIVATE,
  YOUTUBE_PRIVACY_LEVEL_LABEL,
  YOUTUBE_TITLE_LABEL,
  YOUTUBE_DESCRIPTION_LABEL,
  YOUTUBE_NOTIFY_SUBSCRIBERS_LABEL,
  YOUTUBE_MADE_FOR_KIDS_LABEL,
  PAGE_FACEBOOK_PLACEHOLDER,
  META_AD_ACCOUNT_HAVE_NOT_PAYMENT_METHOD,
  META_AD_ACCOUNT_IS_NOT_ACTIVE,
  FIELD_CONTENT_IS_BEING_PROCESSED,
  ALERT_CONNECT_ACCOUNT_FOR_CREATE_CAMPAIGN_DESCRIPTION,
  ALERT_CONNECT_ACCOUNT_FOR_CREATE_CAMPAIGN_TITLE,
  BUTTON_CONNECT_ACCOUNT,
  CREATE_ADS_CAMPAIGN_BUDGET_DESCRIPTION_QUESTION,
  CREATE_ADS_CAMPAIGN_IDENTITIES_ACCOUNTS_QUESTION,
  META_GENERATE_CAMPAIGN_IDENTITIES_PLACEMENTS_HINT,
  MODAL_CLOSE_UNSAVED_WARNING_DESCRIPTION,
  MODAL_CLOSE_UNSAVED_CONFIRM,
  META_ADAPT_PLACEMENTS_CONFIRM_TITLE,
  META_ADAPT_PLACEMENTS_CONFIRM_TEXT,
  META_ADAPT_PLACEMENTS_CONFIRM_YES,
  META_ADAPT_PLACEMENTS_CONFIRM_NO,
  META_ADAPT_PLACEMENTS_CHECKBOX_LABEL,
  META_ADAPT_PLACEMENTS_CHECKBOX_COST,
  ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_CART,
  ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_WISHLIST,
  ADS_CAMPAIGN_CUSTOM_EVENT_COMPLETE_REGISTRATION,
  ADS_CAMPAIGN_CUSTOM_EVENT_DONATE,
  ADS_CAMPAIGN_CUSTOM_EVENT_INITIATED_CHECKOUT,
  ADS_CAMPAIGN_CUSTOM_EVENT_PURCHASE,
  ADS_CAMPAIGN_CUSTOM_EVENT_SEARCH,
  ADS_CAMPAIGN_CUSTOM_EVENT_START_TRIAL,
  ADS_CAMPAIGN_CUSTOM_EVENT_SUBSCRIBE,
  ADS_CAMPAIGN_CUSTOM_EVENT_CONTACT,
  ADS_CAMPAIGN_CUSTOM_EVENT_FIND_LOCATION,
  ADS_CAMPAIGN_CUSTOM_EVENT_LEAD,
  ADS_CAMPAIGN_CUSTOM_EVENT_SCHEDULE,
  ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_APPLICATION,
  ADS_CAMPAIGN_CUSTOM_EVENT_CONTENT_VIEW,
  ADS_CAMPAIGN_CUSTOM_EVENT_ADD_PAYMENT_INFO,
  TRACKING_CUSTOM_EVENT_ID_META_PLACEHOLDER,
  TRACKING_CUSTOM_EVENT_ID_TIKTOK_PLACEHOLDER,
  ADS_CAMPAIGN_CUSTOM_EVENT_CUSTOMIZE_PRODUCT,
  CREATE_ADS_CAMPAIGN_TRACKING_CUSTOM_EVENTS_QUESTION,
  CREATE_ADS_CAMPAIGN_TRACKING_CUSTOM_EVENT_QUESTION,
  LAST_UPDATE,
  DATE_RELATIVE,
  LAST_UPDATE_DATE_SHORT,
  BUTTON_RESEND_CODE,
  FIELD_MIN_TOTAL_BUDGET_ONE_DOLLAR,
  LAST_RECORDED_EVENT_ON,
  NEVER,
  PIXEL_HAS_NO_RECORDED_EVENTS,
  DATE_SHORT_2,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_FEED,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_REEL,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STORY,
  ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_SINGLE_VIDEO,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STANDARD,
  FORMAT_PLACEHOLDER,
  BUTTON_REPLACE,
  BUTTON_SUPPORT,
  ADS_SUBSCRIPTION_TITLE,
  ADS_SUBSCRIPTION_DESCRIPTION,
  SPEND_FEE,
  IN_A_FEW_MINUTES_YOUR_INVOICE_WILL_BE_AVAILABLE,
  BUTTON_REACTIVATE_SUBSCRIPTION,
  BUTTON_CANCEL_SUBSCRIPTION,
  BUTTON_CHANGE_PAYMENT_METHODS,
  ALERT_REACTIVATE_SUBSCRIPTION_TITLE,
  ALERT_PAYMENT_METHOD_CHANGED_TITLE,
  ALERT_CANCEL_SUBSCRIPTION_DESCRIPTION,
  ALERT_CANCEL_SUBSCRIPTION_TITLE,
  ALERT_CANCEL_SUBSCRIPTION_TITLE_CONFIRMATION,
  ALERT_CANCEL_SUBSCRIPTION_DESCRIPTION_CONFIRMATION,
  ADVERTISER_CURRENCY_NOT_FOUND_TIK_TOK,
  CURRENCY_MISMATCH,
  ADVERTISER_ID_NOT_FOUND_TIK_TOK,
  ALERT_CONNECT_ACCOUNT_SECURE_DESCRIPTION,
  RETRIEVING_INSTAGRAM_ACCOUNTS,
  RETRIEVING_FACEBOOK_PAGES,
  RETRIEVING_AD_ACCOUNTS,
  RETRIEVING_GENERAL_INFORMATION,
  ENDING_CONNECTION,
  ALERT_POPUP_BLOCKED_DESCRIPTION,
  ALERT_POPUP_BLOCKED_TITLE,
  VERIFYING_YOUR_SESSION,
  ALREADY_HAVE_AN_ACCOUNT,
  GETTING_REQUIRED_INFORMATION,
  VERIFYING_PLATFORMS_INFORMATION,
  CREATING_CAMPAIGN,
  CREATING_AD_GROUPS,
  UPLOADING_CONTENTS,
  CREATING_ADS,
  SAVING_INFORMATION,
  ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_FORM,
  ADS_CAMPAIGN_CUSTOM_EVENT_CLICK_BUTTON,
  ADS_CAMPAIGN_CUSTOM_EVENT_PLACE_ORDER,
  INACTIVE,
  CUSTOM_EVENT,
  CREATE_ADS_CAMPAIGN_MODE_QUESTION,
  CREATE_ADS_CAMPAIGN_ADVANCED_MODE_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_ADVANCED_MODE,
  CREATE_ADS_CAMPAIGN_QUICK_MODE_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_QUICK_MODE,
  FAST,
  EASY,
  AUTOMATED,
  FULL_CONTROL,
  CUSTOMIZE,
  TAILORED,
  ERROR_GETTING_URL_META_DATA_AND_IMAGES,
  ALERT_DELETE_PLATFORM_CAMPAIGN_DESCRIPTION,
  BUTTON_DELETE_PLATFORM,
  MODAL_CONNECT_ACCOUNTS_DESCRIPTION,
  MODAL_CONNECT_ACCOUNTS_TITLE,
  TURKISH,
  PORTUGUESE,
  FRENCH,
  RUSSIAN,
  JAPANESE,
  MANDARIN,
  HINDI,
  ARABIC,
  BENGALI,
  PUNJABI,
  GERMAN,
  JAVANESE,
  KOREAN,
  INDONESIAN,
  ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_CAROUSEL_ADS,
  ADVERTISER_SELECTOR_BRANDS_COUNT,
  ADVERTISER_SELECTOR_NO_RESULTS,
  ADVERTISER_SELECTOR_SEARCH_PLACEHOLDER,
  ADVERTISER_SELECTOR_TRY_ANOTHER_NAME,
  ADVERTISER_SELECTOR_CONFIGURE_LIMITS_BUTTON,
  SELECT_ADVERTISER_ID_PLACEHOLDER,
  ADVERTISER_ID_TO_CHANGE_NO_PERMISSION,
  CANNOT_DELETE_MAIN_ADVERTISER,
  RETARGETING_EMPTY_SEGMENTATION_CLARIFICATION,
  ALERT_DUPLICATE_CAMPAIGN_TITLE,
  ALERT_DUPLICATE_CAMPAIGN_DESCRIPTION,
  MODAL_ERRORS_CAMPAIGNS_DESCRIPTION,
  MODAL_ERRORS_CAMPAIGNS_TITLE,
  CAMPAIGN_CREATED,
  CREATIFY_VIDEO_PREVIEW_CLARIFICATION,
  CREATIFY_VIDEO_ERROR_RENDER_CLARIFICATION,
  CREATIFY_VIDEO_RENDERING_CLARIFICATION,
  COPY,
  CREATIFY_VIDEO_RENDERING_CLARIFICATION_AND_CREATE_CAMPAIGN,
  BUTTON_GENERATE_WITH_AI,
  GENERATING_VIDEO_MESSAGE,
  TASK_ALERT_ESTIMATED_TIME,
  CROATIAN,
  SLOVAK,
  BULGARIAN,
  CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_QUESTION,
  BUTTON_CHANGE_CONTENT,
  BUTTON_EDIT_CONTENT,
  BUTTON_CHANGE_SLIDE,
  PLATFORM_ONLY_ACCEPTS_VIDEOS,
  CREATE_ADS_CAMPAIGN_SOCIAL_NETWORK_QUESTION,
  SOCIAL_NETWORK_URL_PLACEHOLDER,
  DISCOUNT_CODE_PLACEHOLDER,
  DO_YOU_HAVE_DISCOUNT_CODE,
  DISCOUNT_CODE_NOT_FOUND,
  DISCOUNT_CODE_NOT_APPLICABLE_TO_THIS_PRODUCT,
  DISCOUNT_VALUE,
  NORMAL_PRICE,
  CONTENT_NUMERATION,
  ALERT_DELETE_CAMPAIGN_DESCRIPTION,
  ALERT_DELETE_CAMPAIGN_TITLE,
  ALERT_DELETE_CAMPAIGN_ERROR_TITLE,
  ALERT_DELETE_CAMPAIGN_ERROR_TEXT,
  FIELD_URL_INSTAGRAM,
  CREATE_ADS_CAMPAIGN_SOCIAL_NETWORK_PLACEHOLDER,
  BRAND_INSTAGRAM_PROFILE_URL_PLACEHOLDER,
  LANGUAGE_PLACEHOLDER,
  SCRIPT_PLACEHOLDER,
  BUTTON_CHANGE_AVATAR,
  BUTTON_SELECT_AVATAR,
  WE_CANT_GET_AVATARS,
  CONTENT_GENERATOR,
  SELECT_BACKGROUND_CONTENT_CLARIFICATION,
  SELECT_BACKGROUND_CONTENT,
  CUSTOM,
  BUTTON_CONTACT_US,
  BUTTON_GENERATE,
  BUTTON_GENERATE_RANDOM,
  SCRIPT_IS_TOO_SHORT,
  FIELD_MIN_CONTENT,
  BUTTON_ADD_SELECTED_CONTENT,
  INSTAGRAM_PROFILE_URL_PLACEHOLDER,
  WEBSITE_AND_SOCIAL_NETWORK_CANT_ANALYZED,
  DANISH,
  BUTTON_LOG_IN_WITH_GOOGLE,
  BUTTON_REGISTER_WITH_GOOGLE,
  EMAIL_PROVIDER_IS_NOT_EQUAL_TO_EMAIL_FORM,
  CREATE_ADS_CAMPAIGN_LOCATIONS_PLACEHOLDER,
  OAUTH_IN_WINDOW_NO_COMPLETED,
  OAUTH_CALLBACK_ACCOUNT_CONNECTED_TITLE,
  OAUTH_CALLBACK_ACCOUNT_CONNECTED_TEXT,
  BUTTON_CHANGE_LOGO,
  ERROR_PROCESSING_REQUEST,
  ERROR_PROCESSING_CAMPAIGNS,
  ERROR_ANALYZING_LINK_CREATIFY,
  GENERATE_AI_FREE_VIDEO_LIMIT,
  NOT_HAVE_ENOUGH_USAGE_VALUE,
  USAGE_VALUE_NOT_FOUND,
  FAL_AI_CREDENTIALS_INVALID,
  HEYGEN_CREDENTIALS_INVALID,
  GETTING_CREATIFY_VIDEO_DATA,
  COINS,
  VALUE_NUMBER,
  PER_MONTH,
  ACTION_CONFIRM_TEXT,
  BUTTON_UPGRADE_PLAN,
  LABEL_CURRENT_SUBSCRIPTION_PLAN,
  COINS_VALUE,
  CREDITS_VALUE,
  ADS_SUBSCRIPTION_CREDITS_BENEFIT,
  ADS_SUBSCRIPTION_COINS_BENEFIT,
  VALUE_SUBSCRIPTION_PRORATED,
  VALUE_SUBSCRIPTION_AFTER_PRORATED,
  RENEWED_ON,
  EXPIRE_ON,
  YOUR_TRIAL_CREDITS_END,
  YOUR_TRIAL_COINS_END,
  BUTTON_UPGRADE_TO_PAID_PLAN,
  CURRENT_USAGE_TYPE,
  LOADING_PLAN_INFORMATION,
  YOUR_TRIAL_END,
  ALERT_PUBLISH_ACTIVE_OR_DEACTIVATE_CAMPAIGN_TITLE,
  CREATE_ACTIVATED,
  CREATE_DEACTIVATED,
  FIELD_TRAFFIC_URL_NOT_BE_LINK_INSTAGRAM,
  FIELD_TRAFFIC_URL_NOT_BE_LINK_FACEBOOK,
  FIELD_AD_FORMAT_REQUIRED_AD_PREVIEW,
  FIELD_CALL_TO_ACTION_REQUIRED_AD_PREVIEW,
  FIELD_PAGE_ID_REQUIRED_AD_PREVIEW,
  FIELD_SPONSOR_PAGE_ID_REQUIRED_AD_PREVIEW,
  FIELD_INSTAGRAM_ID_REQUIRED_AD_PREVIEW,
  FIELD_IDENTITY_TIK_TOK_ID_REQUIRED_AD_PREVIEW,
  BUTTON_UPGRADE_PLAN_2,
  FIELD_TRAFFIC_URL_NOT_BE_LINK_WHATSAPP,
  ALERT_DESCRIPTION_DISCONNECT_GOOGLE,
  EMPTY_TRACKING_IDS_GOOGLE,
  TRACKING_GOOGLE_ID_PLACEHOLDER,
  AD_ACCOUNT_GOOGLE_PLACEHOLDER,
  TRACKING_CUSTOM_EVENT_ID_GOOGLE_PLACEHOLDER,
  COINS_EXPLANATION,
  CREDITS_EXPLANATION,
  KEYWORDS_PLACEHOLDER,
  ADS_CAMPAIGN_TYPE_VIDEO,
  ADS_CAMPAIGN_TYPE_SHOPPING,
  ADS_CAMPAIGN_TYPE_SEARCH,
  ADS_CAMPAIGN_TYPE_VIDEO_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_VIDEO_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_SHOPPING_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_SHOPPING_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_SEARCH_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_SEARCH_TITLE_EXPLANATION,
  CAMPAIGN_TYPE_PLACEHOLDER,
  ADS_META_DESTINATION_TYPE_INSTAGRAM_PROFILE,
  ADS_META_DESTINATION_TYPE_WEBSITE,
  META_DESTINATION_TYPE_PLACEHOLDER,
  META_DESTINATION_TYPE_INSTAGRAM_PROFILE_CLARIFICATION,
  CREATE_ADS_CAMPAIGN_DESTINATION_TYPE_QUESTION,
  ADVERTISER,
  MARKETER,
  VIEWER,
  DELETED,
  ROLE_PLACEHOLDER,
  VIEWER_ROLE_DESCRIPTION_EXPLANATION,
  VIEWER_ROLE_READ_ONLY_CAPABILITY,
  VIEWER_ROLE_TITLE_EXPLANATION,
  VIEWER_CAPABILITY_VIEW_CAMPAIGNS,
  VIEWER_CAPABILITY_VIEW_CONTENT,
  VIEWER_CAPABILITY_VIEW_CALENDAR,
  VIEWER_CAPABILITY_VIEW_REPORTS,
  MARKETER_ROLE_DESCRIPTION_EXPLANATION,
  MARKETER_ROLE_TILE_EXPLANATION,
  ADVERTISER_ROLE_DESCRIPTION_EXPLANATION,
  ADVERTISER_ROLE_TITLE_EXPLANATION,
  DESIGNER_ROLE_TITLE_EXPLANATION,
  ROLE_CAPABILITY_CAN_MANAGE_USERS,
  ROLE_CAPABILITY_CAN_ACCESS_SETTINGS_ACCOUNTS,
  ROLE_CAPABILITY_CAN_CREATE_CAMPAIGN,
  ROLE_CAPABILITY_CAN_EDIT_CAMPAIGN,
  ROLE_CAPABILITY_CAN_USE_CAMPAIGN_AGENT,
  ROLE_CAPABILITY_CAN_EDIT_GALLERY,
  ROLE_CAPABILITY_CAN_POST,
  ROLE_CAPABILITY_CAN_EDIT_BRAND_SETUP,
  ROLE_CAPABILITY_CAN_EDIT_BILLING,
  PASSWORD_CLARIFICATION_IN_EDIT_USER,
  CREATED_AT,
  CREATED_BY,
  ALERT_GOOGLE_ACCOUNT_NO_REGISTERED_TITLE,
  ALERT_GOOGLE_ACCOUNT_NO_REGISTERED_DESCRIPTION,
  BUTTON_BOOK_A_DEMO,
  YEARLY,
  SEMIYEARLY,
  QUARTERLY,
  MONTHLY,
  CPA,
  CPA_CLARIFICATION,
  MAIN_STATISTIC_CPM_CLARIFICATION,
  MAIN_STATISTIC_CLICK_CLARIFICATION,
  MAIN_STATISTIC_POST_ENGAGEMENT_CLARIFICATION,
  MAIN_STATISTIC_LEAD_CLARIFICATION,
  MAIN_STATISTIC_PURCHASE_CLARIFICATION,
  MAIN_STATISTIC_AD_RECALL_CLARIFICATION,
  MAIN_STATISTIC_VIDEO_VIEW_CLARIFICATION,
  MAIN_STATISTICS_INSTAGRAM_PROFILE_CLARIFICATION,
  MAIN_STATISTIC_VALUE_CPM_CLARIFICATION,
  MAIN_STATISTIC_VALUE_CLICK_CLARIFICATION,
  MAIN_STATISTIC_VALUE_POST_ENGAGEMENT_CLARIFICATION,
  MAIN_STATISTIC_VALUE_LEAD_CLARIFICATION,
  MAIN_STATISTIC_VALUE_PURCHASE_CLARIFICATION,
  MAIN_STATISTIC_VALUE_AD_RECALL_CLARIFICATION,
  MAIN_STATISTIC_VALUE_VIDEO_VIEW_CLARIFICATION,
  MAIN_STATISTIC_VALUE_INSTAGRAM_PROFILE_CLARIFICATION,
  GENERATING_OPTIMIZATIONS,
  COMPARING_RESULTS_OBTAINED,
  ANALYZING_CAMPAIGN_STATISTICS,
  CAMPAIGN_OPTIMIZED_NAME,
  CAMPAIGN_OPTIMIZED_GENERATED,
  BUTTON_APPLY_OPTIMIZATIONS,
  BUTTON_DISCARD_OPTIMIZATIONS,
  ERROR_NETWORK_CONNECTION,
  FIELD_START_DATE_LESS_THAN_NOW,
  FIELD_END_DATE_LESS_THAN_NOW,
  CAMPAIGN_UPDATED,
  ERROR_ON_AD_ID_OF_AD_GROUP_ID,
  ERROR_ON_AD_GROUP_ID,
  CAMPAIGN_OPTIMIZED,
  APPLYING_OPTIMIZATIONS,
  ADS_CAMPAIGN_STATISTICS_CURRENT_STATE_TITLE,
  DATE_DAY_AND_MONTH_SHORT,
  SPEND,
  RESULTS,
  CPC,
  CPM,
  CLICK,
  AVERAGE,
  PERIOD,
  MAIN_ACTIONS_BY_PLATFORM,
  CLICKS_BY_PLATFORM,
  IMPRESSIONS_BY_PLATFORM,
  RECOMMENDATIONS,
  CONCLUSION,
  WEEK_COUNT,
  DAY_COUNT,
  ADS_CAMPAIGN_REPORT_BREAKDOWN_DAILY,
  EMPTY_STATISTICS_FOR_DETAILED_REPORT,
  VALUE_WITH_CURRENCY_MANUAL_FORMAT,
  LOCATIONS_TIK_TOK_EMPTY,
  CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_QUESTION,
  CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_QUESTION,
  CHAT_DO_A_QUESTION,
  CHAT_ASK_A_QUESTION_ABOUT_YOUR_CAMPAIGN,
  CHAT_CAMPAIGN_OPEN_AUTO_SUMMARY_QUESTION,
  CHAT_CAMPAIGN_OPEN_ANALYZING_SUGGESTIONS,
  CHAT_BOT_NAME,
  CHAT_BOT_DESCRIPTION,
  CHAT_BOT_WELCOME_MESSAGE,
  CHAT_BOT_WELCOME_MESSAGE_STATISTICS,
  CHAT_BOT_WELCOME_DESCRIPTION_STATISTICS,
  CHAT_BOT_WELCOME_MESSAGE_OWNER,
  CHAT_BOT_WELCOME_DESCRIPTION_OWNER,
  CHAT_ASK_A_QUESTION_OWNER,
  CHAT_REASONING_ANALYZING_USER_MESSAGE,
  CHAT_REASONING_PROCESSING_CAMPAIGN_DATA,
  CHAT_REASONING_GETTING_PERFORMANCE_METRICS,
  CHAT_REASONING_ANALYZING_BEST_PRACTICES,
  CHAT_REASONING_GENERATING_RECOMMENDATIONS,
  PRODUCT_OR_SERVICE_CONTEXT,
  TARGET_AUDIENCE_CONTEXT,
  REQUEST_TIME_OUT,
  TIME_OUT_FOR_PROVIDER,
  ADS_META_DESTINATION_TYPE_ON_POST,
  ADS_META_DESTINATION_TYPE_ON_VIDEO,
  FIELD_POST_ID_REQUIRED_AD_PREVIEW,
  FACEBOOK,
  WHATSAPP_BUSINESS_NUMBER_PLACEHOLDER,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEND_WHATSAPP_MESSAGE,
  ADS_CAMPAIGN_ADDITIONAL_CONFIGURATION_AD_GROUP_SUB_TITLE,
  ADS_META_DESTINATION_TYPE_WHATSAPP,
  WELCOME_MESSAGE_TEMPLATE_PLACEHOLDER,
  MESSAGE_TEMPLATE_UNSUPPORTED_TITLE,
  MESSAGE_TEMPLATE_UNSUPPORTED_DESCRIPTION,
  BUTTON_CREATE_TEMPLATE,
  MODAL_MESSAGE_TEMPLATE_DESCRIPTION,
  MODAL_MESSAGE_TEMPLATE_TITLE,
  GREETING_MESSAGE_PLACEHOLDER,
  CUSTOMER_TYPE_MESSAGE_PLACEHOLDER,
  CUSTOMER_TYPE_PREFILL_MESSAGE,
  CUSTOMER_TYPE_QUICK_QUESTIONS_MESSAGE,
  CUSTOMER_TEXT_PLACEHOLDER,
  CUSTOMER_TEXTS_PLACEHOLDER,
  LOG_MESSAGE_TEMPLATE_CUSTOMER_TEXTS,
  FIRST_USER_MESSAGE,
  GREETING,
  BUTTON_EDIT_TEMPLATE,
  ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM,
  ADS_META_DESTINATION_TYPE_MESSAGES_ON_MESSENGER,
  ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER,
  ADS_META_DESTINATION_TYPE_INSTANT_FORM,
  BUTTON_VIEW_DETAILED_REPORT,
  IS_CAROUSEL,
  CARD,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_REELS_MOBILE,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_MOBILE_FEED_STANDARD,
  FIELD_MIN_CARDS_AD_CAROUSEL,
  BUTTON_SELECT_INSTANT_FORM,
  FORM,
  MODAL_INSTANT_FORMS_LIST_TITLE,
  MODAL_INSTANT_FORMS_LIST_DESCRIPTION,
  INSTANT_FORM_PLACEHOLDER,
  TIKTOK_LEAD_DESTINATION_WEBSITE,
  TIKTOK_LEAD_DESTINATION_INSTANT_FORM,
  TIKTOK_INSTANT_FORM_EDITOR_HINT,
  TIKTOK_INSTANT_FORM_CREATE,
  TIKTOK_INSTANT_FORM_EDITOR_FAILED,
  INTEGRATION_MISSING_PERMISSION,
  TIKTOK_INSTANT_FORM_LOCKED_DESTINATION,
  TIKTOK_CAROUSEL_REQUIRES_TIKTOK_PLACEMENT,
  TIKTOK_INSTANT_FORM_PREVIEW_NAME,
  CREATE_ADS_CAMPAIGN_TIKTOK_LEAD_DESTINATION_QUESTION,
  CREATE_ADS_CAMPAIGN_TIKTOK_INSTANT_FORM_QUESTION,
  MODAL_INSTANT_FORMS_EMPTY_TEXT,
  FORMS,
  MODAL_CREATE_INSTANT_FORM_TITLE,
  MODAL_CREATE_INSTANT_FORM_DESCRIPTION,
  MODAL_CREATE_INSTANT_FORM_TYPE_MORE_VOLUME,
  MODAL_CREATE_INSTANT_FORM_TYPE_MORE_VOLUME_DESCRIPTION,
  MODAL_CREATE_INSTANT_FORM_TYPE_HIGHER_INTENT,
  MODAL_CREATE_INSTANT_FORM_TYPE_HIGHER_INTENT_DESCRIPTION,
  MODAL_CREATE_INSTANT_FORM_QUESTIONS_HEADLINE,
  MODAL_CREATE_INSTANT_FORM_CONTACT_FIELDS,
  MODAL_CREATE_INSTANT_FORM_CONTACT_FULL_NAME,
  MODAL_CREATE_INSTANT_FORM_CONTACT_WORK_EMAIL,
  MODAL_CREATE_INSTANT_FORM_MAX_QUESTIONS,
  MODAL_CREATE_INSTANT_FORM_PRIVACY_LINK_TEXT,
  MODAL_CREATE_INSTANT_FORM_ADDITIONAL_ACTION,
  MODAL_CREATE_INSTANT_FORM_ACTION_VIEW_WEBSITE,
  MODAL_CREATE_INSTANT_FORM_ACTION_VIEW_WEBSITE_DESCRIPTION,
  MODAL_CREATE_INSTANT_FORM_ACTION_BOOK_TIME,
  MODAL_CREATE_INSTANT_FORM_ACTION_BOOK_TIME_DESCRIPTION,
  MODAL_CREATE_INSTANT_FORM_WEBSITE_URL,
  MODAL_CREATE_INSTANT_FORM_SCHEDULING_LINK,
  MODAL_CREATE_INSTANT_FORM_SCHEDULING_PROVIDER,
  MODAL_CREATE_INSTANT_FORM_BOOK_TIME_HINT,
  MODAL_CREATE_INSTANT_FORM_BUTTON_TEXT,
  LEAD_FORM_RECOMMENDATION_GENERATING,
  LEAD_FORM_RECOMMENDATION_CANCEL,
  LEAD_FORM_RECOMMENDATION_FAILED,
  LEAD_FORM_RECOMMENDATION_CAMPAIGN_GENERATING,
  QUESTIONS,
  ENTER_ANSWER_PLACEHOLDER,
  ANSWERS,
  ANSWER,
  FACEBOOK_PAGE_NEED_CONNECTED_WHATSAPP_NUMBER,
  YOUR_FACEBOOK_PAGE_MUST_BE_IN_BUSINESS_PORTFOLIO_OWN_WHATSAPP,
  MODAL_VERIFY_INTEGRATION_SCOPES_DESCRIPTION,
  MODAL_VERIFY_INTEGRATION_SCOPES_TITLE,
  BUTTON_RECONNECT_ACCOUNT,
  BUTTON_RECONNECT,
  ADS_SUBSCRIPTION_BENEFIT_AI_CAMPAIGNS,
  ADS_SUBSCRIPTION_BENEFIT_AI_AUDIENCE_SEGMENTATION,
  ADS_SUBSCRIPTION_BENEFIT_AI_CONTENT,
  ADS_SUBSCRIPTION_BENEFIT_POSTS,
  ADS_SUBSCRIPTION_BENEFIT_AI_ADVANCED_INSIGHTS_AND_REPORTS,
  ADS_SUBSCRIPTION_CREDITS_YEARLY_BENEFIT,
  ADS_SUBSCRIPTION_CREDITS_SEMIANNUALLY_BENEFIT,
  ADS_SUBSCRIPTION_CREDITS_QUARTERLY_BENEFIT,
  ADS_SUBSCRIPTION_CREDITS_MONTHLY_BENEFIT,
  CONVERSION_ACTIONS_PLACEHOLDER,
  SEARCH_KEYWORDS_PLACEHOLDER,
  GOOGLE_BROAD_KEYWORD_EXPLANATION,
  GOOGLE_BROAD_KEYWORD,
  GOOGLE_EXACT_KEYWORD_EXPLANATION,
  GOOGLE_EXACT_KEYWORD,
  GOOGLE_PHRASE_KEYWORD_EXPLANATION,
  GOOGLE_PHRASE_KEYWORD,
  GOOGLE_KEYWORDS_EXPLANATION,
  GOOGLE_SEARCH_AD_GROUP_TYPE_LABEL,
  GOOGLE_SEARCH_AD_GROUP_TYPE_STANDARD,
  GOOGLE_SEARCH_AD_GROUP_TYPE_DSA,
  GOOGLE_WEBPAGE_CRITERIA_TITLE,
  GOOGLE_WEBPAGE_CRITERIA_EXPLANATION,
  GOOGLE_WEBPAGE_CRITERION_OPERATOR_LABEL,
  GOOGLE_WEBPAGE_CRITERION_VALUE_LABEL,
  GOOGLE_WEBPAGE_CRITERION_URL_EQUALS,
  GOOGLE_WEBPAGE_CRITERION_URL_CONTAINS,
  FIELD_WEBPAGE_CRITERIA_REQUIRED,
  FIELD_WEBPAGE_CRITERIA_REPEATED,
  GOOGLE_SEARCH_AD_GROUP_DSA_NO_KEYWORDS_STATS,
  GOOGLE_DSA_SETTINGS_TITLE,
  GOOGLE_DSA_SETTINGS_EXPLANATION,
  GOOGLE_DSA_DOMAIN_LABEL,
  GOOGLE_DSA_LANGUAGE_LABEL,
  GOOGLE_WEBPAGES_NOT_ADDED,
  GOOGLE_WEBPAGE_ADD_TITLE,
  GOOGLE_WEBPAGE_EDIT_TITLE,
  GOOGLE_WEBPAGE_URL_LABEL,
  COLUMN_NAME_URL,
  ALERT_DELETE_WEBPAGE_TITLE,
  ALERT_DELETE_WEBPAGE_DESCRIPTION,
  ALERT_DELETE_WEBPAGES_TITLE,
  ALERT_DELETE_WEBPAGES_DESCRIPTION,
  ADS_CAMPAIGN_AD_FORMAT_GOOGLE_SEARCH,
  BUTTON_ADD_CONVERSION_ACTION,
  FIELD_MAX_CONTENT,
  IMAGES_OF_CAMPAIGN_PLACEHOLDER,
  LOGO_OF_THE_BRAND_PLACEHOLDER,
  FIELD_TEXT_ONLY_HAS_LETTERS_NUMBERS_DOTS_COMMAS,
  NETWORK_DISPLAY_SETTING_PLACEHOLDER,
  GOOGLE_NETWORK_SETTING_PARTNER_SEARCH_NETWORK,
  GOOGLE_NETWORK_SETTING_CONTENT_NETWORK,
  GOOGLE_NETWORK_SETTING_SEARCH_NETWORK,
  GOOGLE_NETWORK_SETTING_GOOGLE_SEARCH,
  GOOGLE_AI_MAX_ENABLE_QUESTION,
  GOOGLE_AI_MAX_ACTIVATED,
  GOOGLE_AI_MAX_DEACTIVATED,
  ADS_CAMPAIGN_PLATFORM_BRAND_CONFIGURATION_SUB_TITLE,
  COLUMN_NAME_CPA,
  COLUMN_NAME_CPM,
  COLUMN_NAME_CPC,
  COLUMN_NAME_CONVERSIONS,
  COLUMN_NAME_CTR,
  COLUMN_NAME_CLICKS,
  COLUMN_NAME_IMPRESSIONS,
  COLUMN_NAME_KEYWORD,
  COLUMN_NAME_SEARCH_TERM,
  GOOGLE_SEARCH_TERMS_TITLE,
  GOOGLE_SEARCH_TERMS_DESCRIPTION,
  GOOGLE_SEARCH_TERMS_EMPTY,
  SEARCH_TERM_MATCH_TYPE_BROAD,
  SEARCH_TERM_MATCH_TYPE_PHRASE,
  SEARCH_TERM_MATCH_TYPE_EXACT,
  SEARCH_TERM_MATCH_TYPE_NEAR_PHRASE,
  SEARCH_TERM_MATCH_TYPE_NEAR_EXACT,
  SEARCH_TERM_MATCH_TYPE_AI_MAX,
  EMPTY_KEYWORDS,
  TOP_KEYWORDS,
  BETA,
  ALERT_CONNECT_GOOGLE_BETA_DESCRIPTION,
  ALERT_CONNECT_GOOGLE_BETA_TITLE,
  SAVING_MEDIA,
  PROCESSING_MEDIA_TO_USE,
  TUTORIAL,
  SELECT_RANGE_DATE,
  TO,
  ADS_CAMPAIGN_REPORT_BREAKDOWN_MONTHLY,
  ADS_CAMPAIGN_REPORT_BREAKDOWN_WEEKLY,
  REPORT_BREAKDOWN_PLACEHOLDER,
  MONTH_COUNT,
  BUTTON_FILTER,
  BUTTON_CONNECT_LINKEDIN,
  LINKEDIN_TOGGLE_DESCRIPTION,
  FIELD_TEXT_REPEATED,
  FIELD_IMAGES_REPEATED,
  FIELD_VIDEOS_REPEATED,
  FIELD_MEDIA_FILE_MIN_DIMENSIONS,
  ERROR_WITH_MOBILE_PROVIDER,
  FIELD_KEYWORDS_REPEATED,
  FIELD_KEYWORDS_MAX_LENGTH,
  ADS_CAMPAIGN_CONTEXT_PLACEHOLDER,
  ADS_CAMPAIGN_CONTEXT_EXAMPLE,
  ADS_CAMPAIGN_LANGUAGE_PLACEHOLDER,
  ADS_CAMPAIGN_LANGUAGE_SELECT_PLACEHOLDER,
  ADS_CAMPAIGN_LOCATION_PLACEHOLDER,
  ADS_CAMPAIGN_LOCATION_EXAMPLE,
  ADS_CAMPAIGN_PLATFORMS_PLACEHOLDER,
  FIELDS_REQUIRED,
  BUDGET_PLACEHOLDER,
  WRITE_INSTRUCTIONS_TO_CREATE_YOUR_CAMPAIGN,
  BUTTON_REMOVE,
  ADD_PLATFORMS,
  BUTTON_TRY_AGAIN,
  ERROR_GENERATING_CAMPAIGN,
  BUTTON_PUBLISH_CHANGES,
  FIELD_MIN_DAILY_BUDGET,
  BUTTON_ANALYZE,
  BRAND_SETUP_TITLE,
  BUSINESS_DESCRIPTION_PLACEHOLDER,
  SOCIAL_NETWORKS_PLACEHOLDER,
  SOCIAL_NETWORK_EXAMPLE,
  BUSINESS_TEXT_STYLE_PLACEHOLDER,
  THIS_ITEM_HAS_ERRORS,
  FIND_A_LOCATION_PLACEHOLDER,
  BUTTON_DROP_PIN,
  CREATIVE_TYPE_PLACEHOLDER,
  CAROUSEL,
  INDIVIDUAL,
  BUTTON_EDIT_PLACEMENTS,
  MODAL_EDIT_PLACEMENTS_META_DESCRIPTION,
  MODAL_EDIT_PLACEMENTS_META_TITLE,
  MODAL_EDIT_GROUP_CREATIVE_META_TITLE,
  MODAL_EDIT_GROUP_CREATIVE_META_DESCRIPTION,
  PLACEMENT_META_USE,
  PLACEMENT_META_RESIZE,
  PLACEMENT_META_SELECT_OTHER_CONTENT,
  FIELD_TWO_CARDS_REQUIRED_FOR_GENERATE_PREVIEW,
  MARKER_NUMBER_LIST,
  MARKER_LIST,
  MARKER_TYPE,
  MARKER_LNG,
  MARKER_LAT,
  MARKER_RADIUS,
  RADIUS,
  AROUND,
  ADVANTAGE_CREATIVE_ENHANCES_PLACEHOLDER,
  BUTTON_EDIT_ADVANTAGE_ENHANCES,
  ADVANTAGE_ENHANCES_ACTIVE_COUNT,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_AUTO_CROP_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_AUTO_CROP_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_TEXT_OPTIMIZATIONS_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_TEXT_OPTIMIZATIONS_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_INLINE_COMMENT_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_INLINE_COMMENT_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_ENHANCE_CTA_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_ENHANCE_CTA_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_TEMPLATES_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_TEMPLATES_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_ANIMATION_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_ANIMATION_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_CV_TRANSFORMATION_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_CV_TRANSFORMATION_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_IMAGE_BRIGHTNESS_AND_CONTRAST_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_IMAGE_BRIGHTNESS_AND_CONTRAST_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_VIDEO_FILTERING_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_VIDEO_FILTERING_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_STANDARD_ENHANCES_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_STANDARD_ENHANCES_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_CAROUSEL_TO_VIDEO_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_CAROUSEL_TO_VIDEO_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_MEDIA_ORDER_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_MEDIA_ORDER_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_PROFILE_CARD_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_PROFILE_CARD_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_DESCRIPTION_AUTOMATION_DESCRIPTION,
  MODAL_EDIT_ADVANTAGE_ENHANCES_DESCRIPTION_AUTOMATION_TITLE,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_STORY,
  UKRAINIAN,
  ALERT_FILL_BRAND_SETUP_TITLE,
  ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_CAMPAIGN,
  BUTTON_COMPLETE_INFORMATION,
  KEYWORDS_NEGATIVE_PLACEHOLDER,
  FIELD_KEYWORDS_AND_KEYWORDS_NEGATIVE_REPEATED,
  ADS_CAMPAIGN_PLATFORM_ADDITIONAL_CONFIGURATION_SUB_TITLE,
  SITE_LINK_FINAL_URL_PLACEHOLDER,
  SITE_LINK_DESCRIPTION_PLACEHOLDER,
  SITE_LINK_TEXT_PLACEHOLDER,
  SITE_LINKS_PLACEHOLDER,
  SITE_LINK_DESCRIPTIONS_PLACEHOLDER,
  SITE_LINK_PLACEHOLDER,
  CALLOUT_TEXT_PLACEHOLDER,
  CALLOUTS_PLACEHOLDER,
  GOOGLE_KEYWORDS_NEGATIVE_EXPLANATION,
  CREATE_ADS_CAMPAIGN_TYPE_QUESTION,
  WE_ARE_SYNCHRONIZING_INFORMATION_WITH_PLATFORMS,
  OPTIONAL,
  CREATE_ADS_CAMPAIGN_DATES_QUESTION,
  CREATE_ADS_CAMPAIGN_AD_FORMAT_QUESTION,
  FIELD_CAMPAIGN_MUST_HAVE_ONE_DAY_ACTIVE,
  COLUMN_NAME_MATCH_TYPE,
  KEYWORD_BROAD_MATCH_TYPE_OPTION,
  KEYWORD_PHRASE_MATCH_TYPE_OPTION,
  KEYWORD_EXACT_MATCH_TYPE_OPTION,
  KEYWORD_PLACEHOLDER,
  KEYWORD_MATCH_TYPE_PLACEHOLDER,
  KEYWORD_TYPE_NORMAL,
  KEYWORD_TYPE_NEGATIVE,
  BUTTON_ADD_KEYWORDS,
  MODAL_EDIT_KEYWORD_TITLE,
  MODAL_ADD_KEYWORDS_TITLE,
  ALERT_DELETE_KEYWORD_DESCRIPTION,
  ALERT_DELETE_KEYWORD_TITLE,
  KEYWORDS_NOT_ADDED,
  KEYWORDS_NEGATIVE_NOT_ADDED,
  FIELD_THIS_KEYWORD_ALREADY_EXIST_IN_YOUR_LIST,
  CREATE_ADS_CAMPAIGN_GOOGLE_CONVERSION_ACTIONS_QUESTION,
  CREATE_ADS_CAMPAIGN_GOOGLE_CONVERSION_ACTIONS_DESCRIPTION,
  ENTER_ONE_KEYWORD_PER_LINE,
  BUTTON_SELECT_POST_FROM_SOCIAL_NETWORKS,
  ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_DESCRIPTION,
  ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_TITLE,
  ALERT_IS_DYNAMIC_CREATIVE_ON_TITLE,
  ALERT_IS_DYNAMIC_CREATIVE_ON_DESCRIPTION,
  ALERT_IS_DYNAMIC_CREATIVE_OFF_TITLE,
  ALERT_IS_DYNAMIC_CREATIVE_OFF_DESCRIPTION,
  FIELD_MEDIA_URL_REQUIRED_AD_PREVIEW,
  FIELD_AD_PREVIEW_CONTENT_CHANGE_WARNING_DRAFT,
  FIELD_AD_PREVIEW_CONTENT_CHANGE_WARNING_CREATED,
  META_AD_PREVIEW_AD_BLOCKER_NOTICE,
  FROM_PLACEHOLDER,
  KEYWORDS,
  KEYWORDS_NEGATIVE,
  COLUMN_NAME_SPEND,
  ALERT_CHANGE_AD_ACCOUNT_GENERAL_TITLE,
  ALERT_CHANGE_AD_ACCOUNT_META_DESCRIPTION,
  ALERT_CHANGE_AD_ACCOUNT_TIKTOK_DESCRIPTION,
  ALERT_CHANGE_AD_ACCOUNT_GOOGLE_DESCRIPTION,
  ALERT_CHANGE_AD_ACCOUNT_LINKEDIN_DESCRIPTION,
  ADS_CAMPAIGN_STATISTICS_SLIDE_MENU_OVERVIEW,
  ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_METRICS,
  ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_INSIGHTS,
  ADS_CAMPAIGNS_STATISTICS_PERFORMANCE_TRENDS,
  COLUMN_NAME_PLATFORM,
  COLUMN_NAME_RESULTS,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_GROUP,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_KEYWORDS,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_VIDEOS,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_IMAGES,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_HEADLINES,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_LONG_HEADLINES,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_DESCRIPTIONS,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_AUDIENCE_BREAKDOWN,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_HIGHEST_PERFORMING,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_AGE_RANGE_LABEL,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_PLAY_VIDEO,
  ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPM,
  ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPC,
  ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPA,
  TOTAL_IMPRESSIONS,
  TOTAL_CLICKS,
  TOTAL_CLICK,
  TOTAL_RESULTS,
  TOTAL_SPEND,
  CUSTOM_AUDIENCES,
  CREATIVE,
  BUTTON_CREATE_NEW,
  FIELD_START_DATE_REQUIRED,
  SELECTED,
  ALERT_DELETE_KEYWORDS_TITLE,
  ALERT_DELETE_KEYWORDS_DESCRIPTION,
  ROAS,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_TITLE,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_DESCRIPTION,
  ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_PERFORMING_ASSETS,
  FORECAST,
  ACTION,
  MODAL_PREVIEW_OPTIMIZATIONS_TITLE,
  MODAL_PREVIEW_OPTIMIZATIONS_DESCRIPTION,
  WHY_THIS_OPTIMIZATION,
  BUTTON_PREVIEW_OPTIMIZATION,
  COLUMN_NAME_FIELD,
  COLUMN_NAME_CURRENT_VALUE,
  COLUMN_NAME_NEW_VALUE,
  DELETE,
  INSIGHTS,
  CHANGE_CONTENT_FOR_OPTIMIZATION_AD_INSIGHT,
  BUTTON_CHANGE_CREATIVE,
  BUTTON_APPLIED,
  CREATE_ADS_CAMPAIGN_VIDEO_URLS_QUESTION,
  CREATE_ADS_CAMPAIGN_VIDEO_URLS_DESCRIPTION,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_APP,
  ADS_CAMPAIGN_TYPE_APP_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_APP_DESCRIPTION_EXPLANATION,
  CREATE_ADS_CAMPAIGN_IMAGE_URLS_QUESTION,
  CREATE_ADS_CAMPAIGN_IMAGE_URLS_DESCRIPTION_QUESTION,
  LONG_HEADLINES,
  VIDEOS_OF_CAMPAIGN_PLACEHOLDER,
  LONG_HEADLINE_PLACEHOLDER,
  LOGO_URLS_PLACEHOLDER,
  ADS_CAMPAIGN_PLATFORM_ASSETS_CONFIGURATION_SUB_TITLE,
  ADS_CAMPAIGNS_PLATFORM_TEXTS_SUB_TITLE,
  SEARCH_THEMES_PLACEHOLDER,
  PRESS_ENTER_TO_ADD_OPTION,
  GOOGLE_P_MAX,
  GOOGLE_SEARCH,
  BUTTON_SKIP,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_ASSETS_GROUP,
  ASSETS_GROUP,
  DO_NOT_UPLOAD_VIDEO_ON_YOUTUBE_HELPER_TEXT,
  YOUTUBE_VIDEO_SOURCE_YOUTUBE,
  YOUTUBE_VIDEO_SOURCE_GALLERY,
  YOUTUBE_VIDEO_SOURCE_URL,
  MODAL_GALLERY_YOUTUBE_TITLE,
  MODAL_GALLERY_YOUTUBE_EMPTY,
  BUTTON_SELECT_FROM_YOUTUBE,
  BUTTON_PUBLISH_VIDEO_ON_YOUTUBE,
  MODAL_UPLOAD_YOUTUBE_VIDEO_TITLE,
  MODAL_UPLOAD_YOUTUBE_VIDEO_DURATION_INVALID,
  YOUTUBE_VIDEO_LINK,
  FIELD_VIDEO_YOUTUBE_URL_INVALID,
  FIELD_MAX_VIDEOS_YOUTUBE_VALID,
  FIELD_YOUTUBE_VIDEO_NOT_PUBLIC,
  FIELD_YOUTUBE_VIDEO_DURATION_INVALID,
  FIELD_YOUTUBE_VIDEO_NOT_PUBLIC_AND_DURATION_INVALID,
  FIELD_MAX_IMAGES_VALID,
  FIELD_MIN_TEXTS_VALID,
  FIELD_MAX_TEXTS_VALID,
  REQUIRED_IMAGES_GOOGLE_ASSETS_GROUP_HELPER_TEXT,
  REQUIRED_IMAGES_GOOGLE_SQUARE_IMAGE,
  REQUIRED_IMAGES_GOOGLE_HORIZONTAL_IMAGE,
  BUTTON_ADD_VIDEO,
  ERROR_ON_ASSETS_GROUP_ID,
  BUTTON_CREATE_FROM_SCRATCH,
  BUTTON_CREATE_FROM_TEMPLATES,
  BUTTON_IMPORT_FROM_PLATFORM,
  BUTTON_IMPORT_FROM_GOOGLE_DRIVE,
  MODAL_IMPORT_ADS_CAMPAIGN_TITLE,
  MODAL_IMPORT_ADS_CAMPAIGN_DESCRIPTION,
  MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_TITLE,
  MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_DESCRIPTION,
  ALERT_IMPORTED_CAMPAIGN_READONLY_DESCRIPTION,
  BUTTON_IMPORT_CAMPAIGN,
  BUTTON_DUPLICATE_FROM_PLATFORM,
  BUTTON_DUPLICATE_CAMPAIGN,
  MODAL_DUPLICATE_ADS_CAMPAIGN_TITLE,
  MODAL_DUPLICATE_ADS_CAMPAIGN_DESCRIPTION,
  MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_TITLE,
  MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_DESCRIPTION,
  MODAL_IMPORT_ADS_CAMPAIGN_SUPPORTED_TYPES,
  MODAL_DUPLICATE_ADS_CAMPAIGN_SUPPORTED_TYPES,
  STATUS_PLACEHOLDER,
  CAMPAIGNS_NOT_FOUND,
  CAMPAIGNS_TABLE_EXPAND_ROW,
  CAMPAIGNS_TABLE_COLLAPSE_ROW,
  CAMPAIGNS_TABLE_EXPAND_GROUP,
  CAMPAIGNS_TABLE_COLLAPSE_GROUP,
  CAMPAIGNS_TABLE_TREE_EMPTY,
  CAMPAIGNS_TABLE_TREE_ERROR,
  CAMPAIGNS_TABLE_TREE_METRICS_ERROR,
  CAMPAIGNS_TABLE_TREE_ADS_EMPTY,
  CAMPAIGNS_TABLE_SHOW_MORE_ADS,
  CAMPAIGN_SELECTED,
  ALREADY_IMPORTED,
  CREATE_A_CAMPAIGN,
  CREATE_A_CAMPAIGN_FOR_BRAND_NAME,
  BUTTON_SAVE_AND_PUBLISH,
  MODAL_EXCLUDED_CUSTOM_AUDIENCES_ARIA_LABEL,
  MODAL_EXCLUDED_CUSTOM_AUDIENCES_TITLE,
  MODAL_EXCLUDED_CUSTOM_AUDIENCES_DESCRIPTION,
  AD_ACCOUNTS_TITLE,
  SETTINGS_TITLE,
  API_KEYS_TAB_TITLE,
  BYOK_SETTINGS_DESCRIPTION,
  BYOK_DEFAULT_PAYMENT_MODE_LABEL,
  BYOK_DEFAULT_PAYMENT_MODE_HELPER,
  BYOK_PAYMENT_MODE_CREDITS,
  BYOK_PAYMENT_MODE_BYOK,
  BYOK_CONFIGURED_PREVIEW,
  BYOK_NOT_CONFIGURED,
  BYOK_PROVIDER_INPUT_LABEL,
  BYOK_PROVIDER_INPUT_PLACEHOLDER,
  BYOK_SAVE_BUTTON,
  BYOK_SAVING_BUTTON,
  BYOK_SAVE_SUCCESS_TITLE,
  BYOK_SAVE_SUCCESS_DESCRIPTION,
  BYOK_SAVE_ERROR,
  BYOK_PROVIDER_KEYS_TITLE,
  BYOK_PROVIDERS_COUNTER,
  BYOK_KEY_CONFIGURED_STATUS,
  BYOK_NO_KEY_CONFIGURED_STATUS,
  BYOK_REPLACE_KEY,
  BYOK_DELETE_KEY,
  BYOK_DELETE_KEY_TITLE,
  BYOK_DELETE_KEY_DESCRIPTION,
  BYOK_DELETE_KEY_ERROR,
  BYOK_DELETE_KEY_SUCCESS_TITLE,
  BYOK_DELETE_KEY_SUCCESS_DESCRIPTION,
  BYOK_KEY_ENCRYPTED_NOTICE,
  BYOK_DEFAULT_PAYMENT_MODE_DESCRIPTION,
  BYOK_PROVIDERS_WILL_BE_USED,
  BYOK_CONFIGURE_MISSING_PROVIDERS,
  MODAL_API_KEYS_ARIA_LABEL,
  BUSINESS_COMPETITORS_PLACEHOLDER,
  COPY_VALUE_IN_OTHER_ADS,
  COPY_VALUES_IN_OTHER_ADS,
  COPY_VALUE_IN_OTHER_ADGROUPS,
  COPY_VALUES_IN_OTHER_ADGROUPS,
  REST_CAMPAIGNS,
  REST_CREATIVES,
  CREATIVES_REMAINING_SHORT,
  FIELD_TITLES_REQUIRED_AD_PREVIEW,
  FIELD_TITLES_REQUIRED_AD_PREVIEW_TIKTOK,
  FIELD_HEADLINES_REQUIRED_AD_PREVIEW,
  FIELD_DESCRIPTIONS_REQUIRED_AD_PREVIEW,
  USE_CAMPAIGN_BUDGET_PLACEHOLDER,
  GENERATING_REPORT,
  GETTING_METRICS,
  ADS_META_DESTINATION_TYPE_NONE,
  DESTINATION_TYPE_AD_PLACEHOLDER,
  EXPORT_COPIES_TO_GOOGLE_DRIVE,
  COPIES_OF_AD,
  ALL_COPIES_OF_PLATFORM,
  ADVERTISER_ID_NOT_FOUND_GOOGLE,
  CONFIGURED_SITE_LINKS,
  MODAL_SITE_LINKS_TITLE,
  MODAL_SITE_LINKS_DESCRIPTION,
  MODAL_SITE_LINK_TITLE,
  MODAL_SITE_LINK_IMAGE_URL,
  MODAL_SITE_LINK_URL,
  BUTTON_ADD_SITE_LINK,
  BUTTON_EDIT_SITE_LINKS,
  ADS_CAMPAIGN_CALL_TO_ACTION_DYNAMIC,
  ALERT_CHANGE_CUSTOM_AUDIENCES_CAMPAIGN_TITLE,
  ALERT_CHANGE_CUSTOM_AUDIENCES_CAMPAIGN_DESCRIPTION,
  ALERT_CHANGE_CUSTOM_AUDIENCES_GROUPS_TITLE,
  ALERT_CHANGE_CUSTOM_AUDIENCES_GROUPS_DESCRIPTION,
  MODAL_UPLOAD_CUSTOM_AUDIENCES_GOOGLE_DESCRIPTION,
  MODAL_UPLOAD_CUSTOM_AUDIENCES_GOOGLE_TITLE,
  DATA_TYPE_PLACEHOLDER,
  BUTTON_SELECT_CSV_FILE,
  DATA_TYPE_CRM_ID_OPTION,
  DATA_TYPE_CONTACT_INFORMATION_OPTION,
  ALL_CUSTOMERS,
  PURCHASERS,
  HIGH_VALUE_CUSTOMERS,
  QUALIFIED_LEADS,
  CONVERTED_LEADS,
  DISENGAGED_CUSTOMERS,
  PAID_SUBSCRIBERS,
  LOYALTY_SIGN_UPS,
  CART_ABANDONERS,
  CUSTOMER_TYPES_PLACEHOLDER,
  FIRST_NAME_PLACEHOLDER,
  LAST_NAME_PLACEHOLDER,
  COUNTRY_CODE_PLACEHOLDER,
  POSTAL_CODE_PLACEHOLDER,
  PHONE_PLACEHOLDER,
  NO_HEADERS_TABLE_VALID_NOT_MODIFY_HEADERS_GOOGLE_CUSTOM_AUDIENCE,
  BUTTON_DOWNLOAD_TEMPLATE,
  FIELD_MIN_BUDGET,
  VALUE_SUBSCRIPTION_YEARLY_UNIQUE_PAYMENT,
  ADS_SUBSCRIPTION_ENTERPRISE_CAMPAIGNS_CUSTOM,
  ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS,
  ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS_CUSTOM,
  WITH_OUT_PLAN,
  CONFIRMATION_USAGE_TEXT,
  BUSINESS_LOGO,
  MODAL_CREATE_IDENTITY_TIKTOK_BUSINESS_TITLE,
  MODAL_CREATE_IDENTITY_TIKTOK_BUSINESS_DESCRIPTION,
  TIKTOK_CREATE_AD_ACCOUNT_OPTION,
  TIKTOK_CREDIT_BANNER_EYEBROW,
  TIKTOK_CREDIT_BANNER_TITLE,
  TIKTOK_CREDIT_BANNER_DESCRIPTION_PREFIX,
  TIKTOK_CREDIT_BANNER_DESCRIPTION_HIGHLIGHT,
  TIKTOK_CREDIT_BANNER_CTA,
  TIKTOK_CREDIT_BADGE_TOOLTIP,
  AD_ACCOUNT_CREATED_FROM_BUSINESS,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_TITLE,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_DESCRIPTION,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_BUSINESS_CENTER,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_NAME,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_COMPANY,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_INDUSTRY,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_COUNTRY,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_CURRENCY,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_CURRENCY_HELPER,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_TIMEZONE,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_REVIEW_NOTE,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_CREDIT_ALERT,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_NO_BUSINESS_CENTERS,
  MODAL_CREATE_AD_ACCOUNT_TIKTOK_SUCCESS_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_EYEBROW,
  GUIDE_TIKTOK_AD_ACCOUNT_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_INTRO,
  GUIDE_TIKTOK_AD_ACCOUNT_BACK,
  GUIDE_TIKTOK_AD_ACCOUNT_LINK,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP,
  GUIDE_TIKTOK_AD_ACCOUNT_PATH_SETTINGS,
  GUIDE_TIKTOK_AD_ACCOUNT_PATH_AD_ACCOUNTS,
  GUIDE_TIKTOK_AD_ACCOUNT_PATH_CONNECT,
  GUIDE_TIKTOK_AD_ACCOUNT_PATH_CREATE,
  GUIDE_TIKTOK_AD_ACCOUNT_PATH_ADS_MANAGER,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_BODY,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_ALT,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_AUTH_ALT,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_BODY,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_ALT,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_BODY,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_ALT,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_4_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_4_BODY,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_BODY,
  GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_ALT,
  GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_TITLE,
  GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_WEBSITE,
  GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_BILLING,
  GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_PAYMENT,
  CREATE_ADS_CAMPAIGN_PROJECTION_QUESTION,
  BUTTON_UPLOAD_GOOGLE_ASSET_LIBRARY,
  SQUARE_FORMAT,
  VERTICAL_FORMAT,
  SELECT_RANGE_DATE_PLACEHOLDER,
  CAMPAIGN,
  ADS_CAMPAIGNS_LOGS_TITLE,
  CHANGES,
  EMPTY_CHANGES,
  AD_GROUPS,
  ADS,
  ASSETS_GROUPS,
  CUSTOM_AUDIENCES_PLACEHOLDER,
  CUSTOM_PLACEMENTS_PLACEHOLDER,
  EXCLUDED_CUSTOM_AUDIENCES_PLACEHOLDER,
  MEDIA_URLS_PLACEHOLDER,
  ADDED,
  REMOVED,
  IT_WAS_CREATED,
  HISTORICAL_CHANGES,
  STATUS_DEACTIVATED,
  STATUS_ACTIVE,
  STATUS_FINISHED,
  MODAL_STEP_DATA_TITLE,
  BUTTON_MARK_AS_DONE,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_PRODUCT,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_SERVICE,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_WITH_OUT_CAROUSEL,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_DOCUMENTS,
  LINKEDIN_DOCUMENT_PDF_PREVIEW_LOADING,
  LINKEDIN_DOCUMENT_PDF_PREVIEW_ERROR,
  LINKEDIN_DOCUMENT_PDF_PREVIEW_ALT,
  LINKEDIN_DOCUMENT_PREVIEW_PREV,
  LINKEDIN_DOCUMENT_PREVIEW_NEXT,
  LINKEDIN_DOCUMENT_PREVIEW_PAGE_COUNT,
  LINKEDIN_DOCUMENT_PREVIEW_OPEN_NEW_TAB,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_CAROUSEL,
  CREATE_ADS_CAMPAIGN_TEMPLATE_QUESTION,
  CREATE_ADS_CAMPAIGN_TEMPLATE_SINGULAR,
  CREATE_ADS_CAMPAIGN_TEMPLATE_MULTIPLE,
  BUTTON_ADD_PRODUCT,
  N_NUMBER_SELECTED,
  CALL_TO_ACTIONS_PLACEHOLDER,
  FILTER_BY_STATUS,
  CREATE_ADS_CAMPAIGN_CATALOG_QUESTION,
  ADS_META_DESTINATION_TYPE_CATALOG,
  CATALOG_PLACEHOLDER,
  IS_CATALOG_CAMPAIGN_PLACEHOLDER,
  PROMOTED_PRODUCTS_PLACEHOLDER,
  ADS_CAMPAIGN_AD_GROUP_PRODUCTS_SUB_TITLE,
  SELECT_CATALOG_IN_CAMPAIGN_LEVEL,
  PRODUCT_SET_AUDIENCE_BUILDER_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_PROSPECTING_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_RETARGETING_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_TIKTOK_PROSPECTING_SEGMENT,
  PRODUCT_SET_AUDIENCE_BUILDER_TIKTOK_RETARGETING_SEGMENT,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_INCLUSIONS_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_INCLUSIONS_ADD_BUTTON,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_EXCLUSIONS_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_EXCLUSIONS_ADD_BUTTON,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_IN_THE_LAST,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_DAYS,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_SELECT_PRODUCT_SET_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_SELECT_PRODUCT_SET_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_SELECT_PRODUCT_SET_LABEL,
  PRODUCT_SET,
  PRODUCT_SET_PLACEHOLDER,
  PRODUCT_CONFIGURATION_PLACEHOLDER,
  PRODUCT_LIST,
  PRODUCT_LIST_PLACEHOLDER,
  BUTTON_ADD_PRODUCTS,
  MODAL_PRODUCT_LIST_TIKTOK_TITLE,
  MODAL_PRODUCT_LIST_TIKTOK_DESCRIPTION,
  SEARCH_PRODUCT_PLACEHOLDER,
  BRAND_PLACEHOLDER,
  RETAILER_ID_PLACEHOLDER,
  SHORT_DESCRIPTION_PLACEHOLDER,
  CURRENT_PRICE_PLACEHOLDER,
  UNIT_PRICE_PLACEHOLDER,
  CUSTOM_LABEL_NUMBER_PLACEHOLDER,
  CUSTOM_NUMBER_PLACEHOLDER,
  URL_PLACEHOLDER,
  INTRO_CARD,
  CATALOG_CARD,
  PROFILE_CARD,
  CREATIVE_FROM_PLACEHOLDER,
  SLIDES_SHOW,
  SINGLE_IMAGE,
  EDIT_CREATIVE_TOOLS_PLACEHOLDER,
  MODIFY_CATALOG_LABELS,
  MODIFY_PRODUCT_TAGS,
  OVERLAY_TYPE_PLACEHOLDER,
  OVERLAY_POSITION_PLACEHOLDER,
  OVERLAY_SHAPE_PLACEHOLDER,
  OVERLAY_COLOR_PLACEHOLDER,
  OVERLAY_OPACITY_PLACEHOLDER,
  OVERLAY_FONT_PLACEHOLDER,
  PRICE_LABEL_PLACEHOLDER,
  AUTO_SHOW_LABEL_PLACEHOLDER,
  SOLID,
  TRANSPARENT,
  MODAL_CATALOG_LABELS_TITLE,
  MODAL_CATALOG_LABELS_DESCRIPTION,
  LABEL_TEXT_PLACEHOLDER,
  AUTOMATIC_LABELS,
  MANUAL_LABEL,
  STRIKETHROUGH_PRICE_PLACEHOLDER,
  PERCENTAGE_OFF_PLACEHOLDER,
  FREE_SHIPPING_PLACEHOLDER,
  RECTANGLE,
  PILL,
  CIRCLE,
  TRIANGLE,
  TOP_LEFT,
  TOP_RIGHT,
  BOTTOM_LEFT,
  BOTTOM_RIGHT,
  OVERLAY_TEXT_COLOR_PLACEHOLDER,
  OVERLAY_TEXT_FONT_PLACEHOLDER,
  MODAL_PRODUCT_TAGS_TITLE_META,
  MODAL_PRODUCT_TAGS_DESCRIPTION_META,
  AUTOMATICALLY_TAG_PRODUCTS,
  ONLY_SHOW_LABEL_WHEN_INCREASE_ENGAGEMENT,
  APP_PLACEHOLDER,
  ANDROID_DEEP_LINK_PLACEHOLDER,
  IOS_DEEP_LINK_PLACEHOLDER,
  INSTANT_EXPERIENCE,
  BUTTON_SELECT_INSTANT_EXPERIENCE,
  INSTANT_EXPERIENCE_PLACEHOLDER,
  MODAL_INSTANT_EXPERIENCE_LIST_TITLE,
  MODAL_INSTANT_EXPERIENCE_LIST_DESCRIPTION,
  MODAL_INSTANT_EXPERIENCE_EMPTY_TEXT,
  FIELD_INSTANT_EXPERIENCE_REQUIRED_AD_PREVIEW,
  FIELD_PRODUCT_SET_ID_REQUIRED_AD_PREVIEW,
  FIELD_ALMOST_ONE_INCLUSION_OR_EXCLUSION,
  FIELD_CONTENT_INTRO_CARD_IS_REQUIRED_AD_PREVIEW,
  FILTER_BY_NAME,
  CREATE_ADS_CAMPAIGN_APP_ID_QUESTION,
  ADS_META_DESTINATION_TYPE_GOOGLE_PLAY,
  ADS_META_DESTINATION_TYPE_APP_STORE,
  DEEP_DESTINATION_APP_URL_PLACEHOLDER,
  CUSTOM_STORE_LISTING_ID_PLACEHOLDER,
  CUSTOM_PRODUCT_PAGE_ID_PLACEHOLDER,
  IOS_14_CAMPAIGN_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_CATALOG_FOR_APP_INSTALL_QUESTION,
  CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_QUESTION,
  CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_WEBSITE,
  CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_APP,
  UTM_PARAMETERS_PLACEHOLDER,
  ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_INSTALL,
  ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_RETARGETING,
  BUTTON_DISCONNECTED,
  CREATE_ADS_CAMPAIGN_MERCHANT_ID_QUESTION,
  MERCHANT_CENTER_ID_PLACEHOLDER,
  ALL_PRODUCTS,
  PRODUCTS_TO_PROMOTE_PLACEHOLDER,
  ADS_CAMPAIGN_PRODUCTS_CONFIGURATION_SUB_TITLE,
  MODAL_EDIT_PRODUCTS_CONFIGURATION_TITLE,
  MODAL_EDIT_PRODUCTS_CONFIGURATION_DESCRIPTION,
  PRODUCTS_CONFIGURATION_SYNC_DELAY_CAPTION,
  CATEGORY_ANIMALS_PET_SUPPLIES,
  CATEGORY_ARTS_ENTERTAINMENT,
  CATEGORY_BUSINESS_INDUSTRIAL,
  CATEGORY_CAMERAS_OPTICS,
  CATEGORY_CLOTHING_ACCESSORIES,
  CATEGORY_ELECTRONICS,
  CATEGORY_FOOD_BEVERAGES,
  CATEGORY_FURNITURE,
  CATEGORY_HEALTH_BEAUTY,
  CATEGORY_HOME_GARDEN,
  CATEGORY_BABY_TODDLER,
  CATEGORY_HARDWARE,
  CATEGORY_MATURE,
  CATEGORY_MEDIA,
  CATEGORY_VEHICLES_PARTS,
  CATEGORY_OFFICE_SUPPLIES,
  CATEGORY_SPORTING_GOODS,
  CATEGORY_TOYS_GAMES,
  CATEGORY_SOFTWARE,
  CATEGORY_LUGGAGE_BAGS,
  CATEGORY_RELIGIOUS_CEREMONIAL,
  USE_A_SELECTION_OF_PRODUCTS,
  SELECT_PRODUCTS_BY,
  CONDITION,
  PRODUCT_TYPE,
  CHANNEL,
  CUSTOM_LABEL,
  CONDITION_NEW,
  CONDITION_USED,
  CONDITION_REFURBISHED,
  CHANNEL_ONLINE,
  CHANNEL_LOCAL,
  ITEM_ID,
  SELECT_ALL,
  RECOMMENDED_ACTIONS,
  BUTTON_VIEW_ACTION,
  BUTTON_CREATE_CUSTOM_AUDIENCE,
  COLUMN_NAME_CAMPAIGN,
  COLUMN_NAME_BUDGET,
  COLUMN_NAME_CREATED_BY,
  CAMPAIGNS_TABLE_ARIA_LABEL,
  CAMPAIGNS_TABLE_TITLE,
  CAMPAIGNS_STATUS_DRAFT,
  DAY_SLASH_TIME,
  DRAG_THE_MOUSE_TO_SELECT_THE_TIME_PERIOD,
  SELECTED_TIME_PERIOD,
  NO_SELECTION,
  BUTTON_CLEAR_ALL,
  BUTTON_RESET_TO_BASIC_METRICS,
  ADS_SCHEDULE_PLACEHOLDER,
  ADS_SCHEDULE_ALWAYS_ON,
  TIMEZONE_PLACEHOLDER,
  USER_TIMEZONE,
  AD_ACCOUNT_TIMEZONE,
  AD_SCHEDULE_PLACEHOLDER,
  DEMOGRAPHICS_BASIC_PLACEHOLDER,
  BUDGET_CONFIGURATION_PLACEHOLDER,
  DESTINATION_TYPE_PLACEHOLDER,
  ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_GENERAL,
  SEARCH_BY_NAME_PLACEHOLDER,
  PLACEMENTS_PLACEHOLDER,
  META_ADGROUP_PLACEMENTS_TYPE_ADVANTAGE,
  META_ADGROUP_PLACEMENTS_TYPE_ADVANTAGE_DESCRIPTION,
  META_ADGROUP_PLACEMENTS_TYPE_MANUAL,
  META_ADGROUP_PLACEMENTS_TYPE_MANUAL_DESCRIPTION,
  DEVICES_PLACEHOLDER,
  FIELD_META_PLACEMENT_FACEBOOK_PROFILE_FEED_REQUIRED,
  FIELD_META_PLACEMENT_FACEBOOK_MARKETPLACE_REQUIRED,
  FIELD_META_PLACEMENT_MESSENGER_INBOX_REQUIRED,
  FIELD_META_PLACEMENT_FACEBOOK_NOTIFICATIONS_REQUIRED,
  FIELD_META_PLACEMENT_FACEBOOK_STORIES_REQUIRED,
  FIELD_META_PLACEMENT_AUDIENCE_NETWORK_NATIVE_BANNER_INTERSTITIAL_REQUIRED,
  FIELD_META_PLACEMENT_AUDIENCE_NETWORK_REWARDED_VIDEOS_REQUIRED,
  FIELD_META_PLACEMENT_ADS_ON_FACEBOOK_REELS_REQUIRED,
  FIELD_META_PLACEMENT_FACEBOOK_INSTREAM_VIDEOS_REQUIRED,
  FIELD_META_PLACEMENT_FACEBOOK_SEARCH_RESULTS_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_STORIES_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_PROFILE_FEED_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_SEARCH_RESULTS_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_EXPLORE_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_EXPLORE_HOME_REQUIRED,
  FIELD_META_PLACEMENT_INSTAGRAM_PROFILE_REELS_REQUIRED,
  CAMPAIGNS_STATUS_FINISHED,
  ADS_META_DESTINATION_TYPE_APP,
  ADVANTAGE_CATALOG_PLACEHOLDER,
  MANUAL_UPLOAD_PLACEHOLDER,
  FROM_CATALOG,
  MANUAL_UPLOAD,
  PUBLICATION_DESCRIPTION,
  CREATIVE_SOURCE_PLACEHOLDER,
  ADS_CAMPAIGN_META_FALLBACK_CATALOG,
  ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK,
  ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY_LABEL,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK_LABEL,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK_LABEL,
  DESTINATION_FALLBACK_CONFIGURATION_TITLE,
  ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_QUESTION,
  ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_DESCRIPTION,
  ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_ABOUT_LINK,
  ADS_CAMPAIGN_META_AD_SETUP,
  ADS_CAMPAIGN_META_AD_SETUP_CREATE_AD,
  ADS_CAMPAIGN_META_AD_SETUP_USE_POST,
  ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD,
  ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD_HINT,
  MODAL_META_REUSE_CREATIVES_TITLE,
  MODAL_META_REUSE_CREATIVES_DESCRIPTION,
  MODAL_META_REUSE_CREATIVES_EMPTY,
  MODAL_META_REUSE_CREATIVES_VALID,
  MODAL_META_REUSE_CREATIVES_INVALID,
  MODAL_META_REUSE_CREATIVES_FILTER_ACTIVE,
  MODAL_META_REUSE_CREATIVES_CLEAR_FILTER,
  MODAL_META_REUSE_CREATIVES_OPTIMIZATION_WARN,
  MODAL_META_REUSE_CREATIVES_COLUMN_COMPATIBILITY,
  MODAL_META_REUSE_CREATIVES_COLUMN_TEXTS,
  MODAL_META_REUSE_CREATIVES_COLUMN_ENGAGEMENT,
  ADS_CAMPAIGN_META_PARTNERSHIP_AD_SECTION,
  ADS_CAMPAIGN_META_PARTNERSHIP_AD_TOGGLE,
  ADS_CAMPAIGN_META_PARTNERSHIP_IDENTITY_ORDER,
  ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_FIRST,
  ADS_CAMPAIGN_META_PARTNERSHIP_PARTNER_NAME_FALLBACK,
  ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_CAMPAIGN_FIRST,
  ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_PARTNER_FIRST_LABEL,
  ADS_CAMPAIGN_META_PARTNERSHIP_SPONSOR_PAGE,
  ADS_CAMPAIGN_META_PARTNERSHIP_APPROVAL_WARNING,
  ADS_CAMPAIGN_META_PARTNERSHIP_SPONSOR_INSTAGRAM,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_QUESTION,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_DESCRIPTION,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_HOUSING,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_FINANCIAL_PRODUCTS_SERVICES,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_ISSUES_ELECTIONS_POLITICS,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_PLACEHOLDER,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_HOUSING,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_CREDIT,
  DESTINATION_DEEP_LINK_CONFIGURATION_PLACEHOLDER,
  SUGGESTION_BUDGET_TITLE,
  SUGGESTION_BUDGET_TEXT,
  SUGGESTION_BUDGET_PREVIOUS,
  SUGGESTION_BUDGET_CURRENT,
  SUGGESTION_BUDGET_APPLY,
  SUGGESTION_BUDGET_CANCEL,
  SUGGESTION_BUDGET_MINIMUM,
  TITLE_CAMPAIGN_INSTRUCTIONS,
  DOCUMENTS_ATTACHMENT_LABEL,
  MODAL_INSTANT_EXPERIENCE_CREATE_TITLE,
  MODAL_INSTANT_EXPERIENCE_CREATE_DESCRIPTION,
  COVER_CONTENT_PLACEHOLDER,
  ERROR_CREATING_INSTANT_EXPERIENCE,
  ALERT_ARCHIVE_CAMPAIGN_TITLE,
  ALERT_ARCHIVE_CAMPAIGN_DESCRIPTION,
  BUTTON_ARCHIVE_CAMPAIGN,
  CAMPAIGN_REQUEST_ABORTED,
  GOOGLE_ORIGIN_APP,
  GOOGLE_ORIGIN_CALL_FROM_ADS,
  GOOGLE_ORIGIN_GOOGLE_HOSTED,
  GOOGLE_ORIGIN_STORE,
  GOOGLE_ORIGIN_WEBSITE,
  GOOGLE_ORIGIN_YOUTUBE_HOSTED,
  GOOGLE_CATEGORY_ADD_TO_CART,
  GOOGLE_CATEGORY_BEGIN_CHECKOUT,
  GOOGLE_CATEGORY_BOOK_APPOINTMENT,
  GOOGLE_CATEGORY_CONTACT,
  GOOGLE_CATEGORY_CONVERTED_LEAD,
  GOOGLE_CATEGORY_DEFAULT,
  GOOGLE_CATEGORY_DOWNLOAD,
  GOOGLE_CATEGORY_ENGAGEMENT,
  GOOGLE_CATEGORY_GET_DIRECTIONS,
  GOOGLE_CATEGORY_IMPORTED_LEAD,
  GOOGLE_CATEGORY_OUTBOUND_CLICK,
  GOOGLE_CATEGORY_PAGE_VIEW,
  GOOGLE_CATEGORY_PHONE_CALL_LEAD,
  GOOGLE_CATEGORY_PURCHASE,
  GOOGLE_CATEGORY_QUALIFIED_LEAD,
  GOOGLE_CATEGORY_REQUEST_QUOTE,
  GOOGLE_CATEGORY_SIGNUP,
  GOOGLE_CATEGORY_STORE_SALE,
  GOOGLE_CATEGORY_STORE_VISIT,
  GOOGLE_CATEGORY_SUBMIT_LEAD_FORM,
  GOOGLE_CATEGORY_SUBSCRIBE_PAID,
  SEARCH_PLACEHOLDER,
  ADS_CAMPAIGN_AD_APP_CONFIGURATION_SUB_TITLE,
  TRACKING_WEBSITE_EVENTS,
  ADS_TIKTOK_APP_EVENT_ACTIVE_OPTION,
  ADS_TIKTOK_APP_EVENT_DOWNLOAD_START_OPTION,
  ADS_TIKTOK_APP_EVENT_ACTIVE_REGISTER_OPTION,
  ADS_TIKTOK_APP_EVENT_ACTIVE_PAY_OPTION,
  ADS_TIKTOK_APP_EVENT_IN_APP_ORDER_OPTION,
  ADS_TIKTOK_APP_EVENT_IN_APP_CART_OPTION,
  ADS_TIKTOK_APP_EVENT_IN_APP_DETAIL_UV_OPTION,
  ADS_TIKTOK_APP_EVENT_NEXT_DAY_OPEN_OPTION,
  ADS_TIKTOK_APP_EVENT_LOGIN_OPTION,
  ADS_TIKTOK_APP_EVENT_LAUNCH_APP_OPTION,
  ADS_TIKTOK_APP_EVENT_COMPLETE_TUTORIAL_OPTION,
  ADS_TIKTOK_APP_EVENT_SEARCH_OPTION,
  ADS_TIKTOK_APP_EVENT_START_TRIAL_OPTION,
  ADS_TIKTOK_APP_EVENT_SUBSCRIBE_OPTION,
  CHOOSE_AN_ADDRESS_PLACEHOLDER,
  FIELD_ADDRESS_REQUIRED_AD_PREVIEW,
  FIELD_DATE_IN_PAST,
  FIELD_DATE_AT_LEAST_FIFTEEN_MINUTES_FUTURE,
  FIELD_DATE_AT_LEAST_FIVE_MINUTES_FUTURE,
  FIELD_DESTINATION_URL_REQUIRED_AD_PREVIEW,
  FIELD_DESTINATION_URL_IN_YOUR_CAROUSEL_REQUIRED_AD_PREVIEW,
  OFFLINE_EVENTS_PLACEHOLDER,
  DEEP_LINK_PLACEHOLDER,
  TRACKING_EVENTS,
  COLUMN_NAME_CONFIGURE_COLUMNS,
  CAMPAIGNS_TABLE_FILTER_COLUMNS_TITLE,
  FIELD_IMAGES_MIN_REQUIRED,
  APP_URL_NOT_FOUND,
  SIZE_FOR_DISPLAY_PLACEHOLDER,
  SIZE_FOR_SEARCH_PLACEHOLDER,
  VALID,
  INVALID,
  SIZE_PLACEHOLDER,
  INSIGHT,
  NOT_READY,
  INSIGHT_APPLIED,
  MAXIMIZE_CONVERSIONS,
  MAXIMIZE_CONVERSION_VALUE,
  MAXIMUM_COST_PER_CLICK_PLACEHOLDER,
  TARGET_CPA_PLACEHOLDER,
  TARGET_ROAS_PLACEHOLDER,
  BIDDING_STRATEGY_TYPE_PLACEHOLDER,
  ADVERTISERS_AVAILABLE_PLACEHOLDER,
  ALL_CONVERSIONS,
  ALL_CONVERSIONS_FROM_INTERACTIONS_RATE,
  ALL_CONVERSIONS_VALUE,
  APP_EVENT_ADD_TO_CART,
  APP_INSTALL,
  AVERAGE_CART_SIZE,
  AVERAGE_COST,
  AVERAGE_CPC,
  AVERAGE_ORDER_VALUE_MICROS,
  CHECKOUT,
  COMMENTS_METRICS,
  CONVERSION_RATE,
  CONVERSIONS_FROM_INTERACTIONS_RATE,
  CONVERSIONS_VALUE,
  COST_OF_GOODS_SOLD_MICROS,
  COST_PER_ALL_CONVERSIONS,
  COST_PER_APP_EVENT_ADD_TO_CART,
  COST_PER_APP_INSTALL,
  COST_PER_CHECKOUT,
  COST_PER_CONVERSION,
  COST_PER_PURCHASE,
  COST_PER_VIEW_CONTENT,
  CROSS_DEVICE_CONVERSIONS,
  CROSS_DEVICE_CONVERSIONS_VALUE_MICROS,
  CROSS_SELL_COST_OF_GOODS_SOLD_MICROS,
  CROSS_SELL_GROSS_PROFIT_MICROS,
  CROSS_SELL_REVENUE_MICROS,
  CROSS_SELL_UNITS_SOLD,
  ENGAGEMENT_RATE,
  FOLLOWS,
  GROSS_PROFIT_MARGIN,
  GROSS_PROFIT_MICROS,
  INTERACTION_RATE,
  INTERACTIONS_METRICS,
  LEAD_COST_OF_GOODS_SOLD_MICROS,
  LEAD_GROSS_PROFIT_MICROS,
  LEAD_REVENUE_MICROS,
  LEAD_UNITS_SOLD,
  LIKES_METRICS,
  ORDERS_METRICS,
  PROFILE_VISITS,
  PURCHASE,
  REVENUE_MICROS,
  SHARES_METRICS,
  VALUE_PER_ALL_CONVERSIONS,
  VALUE_PER_CONVERSION,
  VIDEO_VIEWS_P100,
  VIEW_CONTENT,
  VIEW_THROUGH_CONVERSIONS,
  ACTION_VALUES,
  ACTIONS_METRICS,
  COST_PER_ADD_TO_CART_META,
  ADD_TO_CART_META,
  COST_PER_WEB_IN_STORE_PURCHASE_META,
  WEB_IN_STORE_PURCHASE_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META,
  OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META,
  COST_PER_LINK_CLICK_META,
  LINK_CLICK_META,
  COST_PER_PAGE_ENGAGEMENT_META,
  PAGE_ENGAGEMENT_META,
  COST_PER_PURCHASE_META,
  PURCHASE_META,
  COST_PER_LANDING_PAGE_VIEW_META,
  LANDING_PAGE_VIEW_META,
  COST_PER_POST_ENGAGEMENT_META,
  POST_ENGAGEMENT_META,
  COST_PER_ONSITE_WEB_VIEW_CONTENT_META,
  ONSITE_WEB_VIEW_CONTENT_META,
  COST_PER_ONSITE_WEB_ADD_TO_CART_META,
  ONSITE_WEB_ADD_TO_CART_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META,
  OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META,
  COST_PER_COMMENT_META,
  COMMENT_META,
  COST_PER_ONSITE_WEB_APP_PURCHASE_META,
  ONSITE_WEB_APP_PURCHASE_META,
  COST_PER_OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META,
  OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META,
  COST_PER_VIEW_CONTENT_META,
  VIEW_CONTENT_META,
  COST_PER_WEB_APP_IN_STORE_PURCHASE_META,
  WEB_APP_IN_STORE_PURCHASE_META,
  COST_PER_ONSITE_WEB_APP_ADD_TO_CART_META,
  ONSITE_WEB_APP_ADD_TO_CART_META,
  COST_PER_OFFSITE_SEARCH_ADD_META_LEADS_META,
  OFFSITE_SEARCH_ADD_META_LEADS_META,
  COST_PER_POST_META,
  POST_META,
  COST_PER_ONSITE_CONVERSION_POST_SAVE_META,
  ONSITE_CONVERSION_POST_SAVE_META,
  COST_PER_ONSITE_WEB_INITIATE_CHECKOUT_META,
  ONSITE_WEB_INITIATE_CHECKOUT_META,
  COST_PER_ONSITE_CONVERSION_POST_NET_SAVE_META,
  ONSITE_CONVERSION_POST_NET_SAVE_META,
  COST_PER_ONSITE_WEB_APP_VIEW_CONTENT_META,
  ONSITE_WEB_APP_VIEW_CONTENT_META,
  COST_PER_POST_INTERACTION_GROSS_META,
  POST_INTERACTION_GROSS_META,
  COST_PER_ONSITE_WEB_PURCHASE_META,
  ONSITE_WEB_PURCHASE_META,
  COST_PER_ADD_PAYMENT_INFO_META,
  ADD_PAYMENT_INFO_META,
  COST_PER_SEARCH_META,
  SEARCH_META,
  COST_PER_VIDEO_VIEW_META,
  VIDEO_VIEW_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META,
  OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META,
  OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META,
  COST_PER_POST_REACTION_META,
  POST_REACTION_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META,
  OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META,
  OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META,
  COST_PER_INITIATE_CHECKOUT_META,
  INITIATE_CHECKOUT_META,
  COST_PER_LIKE_META,
  LIKE_META,
  AD_CLICK_ACTIONS,
  AD_IMPRESSION_ACTIONS,
  AUCTION_BID,
  AUCTION_COMPETITIVENESS,
  AUCTION_MAX_COMPETITOR_BID,
  CANVAS_AVG_VIEW_PERCENT,
  CANVAS_AVG_VIEW_TIME,
  CATALOG_SEGMENT_ACTIONS,
  CATALOG_SEGMENT_VALUE,
  CATALOG_SEGMENT_VALUE_MOBILE_PURCHASE_ROAS,
  CATALOG_SEGMENT_VALUE_OMNI_PURCHASE_ROAS,
  CATALOG_SEGMENT_VALUE_WEBSITE_PURCHASE_ROAS,
  CONVERSION_VALUES,
  CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE,
  CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE,
  CONVERTED_PRODUCT_OFFLINE_PURCHASE,
  CONVERTED_PRODUCT_OFFLINE_PURCHASE_VALUE,
  CONVERTED_PRODUCT_OMNI_PURCHASE,
  CONVERTED_PRODUCT_OMNI_PURCHASE_VALUES,
  CONVERTED_PRODUCT_QUANTITY,
  CONVERTED_PRODUCT_VALUE,
  CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE,
  CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE,
  CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE,
  CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE_VALUE,
  CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE_VALUES,
  CONVERTED_PROMOTED_PRODUCT_QUANTITY,
  CONVERTED_PROMOTED_PRODUCT_VALUE,
  CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE,
  COST_PER_15SEC_VIDEO_VIEW,
  COST_PER_15_SEC_VIDEO_VIEW,
  COST_PER_2SEC_CONTINUOUS_VIDEO_VIEW,
  COST_PER_ACTION_TYPE,
  COST_PER_AD_CLICK,
  COST_PER_DDA_COUNT_BY_CONVS,
  COST_PER_ESTIMATED_AD_RECALLERS,
  COST_PER_INLINE_LINK_CLICK,
  COST_PER_INLINE_POST_ENGAGEMENT,
  COST_PER_OBJECTIVE_RESULT,
  COST_PER_ONE_THOUSAND_AD_IMPRESSION,
  COST_PER_OUTBOUND_CLICK,
  COST_PER_RESULT,
  COST_PER_THRUPLAY,
  COST_PER_UNIQUE_ACTION_TYPE,
  COST_PER_UNIQUE_CLICK,
  COST_PER_UNIQUE_CONVERSION,
  COST_PER_UNIQUE_INLINE_LINK_CLICK,
  COST_PER_UNIQUE_OUTBOUND_CLICK,
  CPP,
  DDA_COUNT_BY_CONVS,
  DDA_RESULTS,
  ESTIMATED_AD_RECALLERS,
  INSTAGRAM_PROFILE_FOLLOW,
  FULL_VIEW_IMPRESSIONS,
  FULL_VIEW_REACH,
  INLINE_LINK_CLICK_CTR,
  INLINE_LINK_CLICKS,
  INLINE_POST_ENGAGEMENT,
  INSTANT_EXPERIENCE_CLICKS_TO_OPEN,
  INSTANT_EXPERIENCE_CLICKS_TO_START,
  INSTANT_EXPERIENCE_OUTBOUND_CLICKS,
  INTERACTIVE_COMPONENT_TAP,
  LANDING_PAGE_VIEW_PER_LINK_CLICK,
  MARKETING_MESSAGES_DELIVERY_RATE,
  OBJECTIVE_RESULT_RATE,
  OBJECTIVE_RESULTS,
  OUTBOUND_CLICKS,
  OUTBOUND_CLICKS_CTR,
  PURCHASE_PER_LANDING_PAGE_VIEW,
  QUALIFYING_QUESTION_QUALIFY_ANSWER_RATE,
  RESULT_RATE,
  RESULTS_METRICS,
  ROAS_METRICS,
  SHOPS_ASSISTED_PURCHASES,
  SOCIAL_SPEND,
  TOTAL_CARD_VIEW,
  VIDEO_30SEC_WATCHED_ACTIONS,
  VIDEO_30_SEC_WATCHED_ACTIONS,
  VIDEO_AVG_TIME_WATCHED_ACTIONS,
  VIDEO_CONTINUOUS_2SEC_WATCHED_ACTIONS,
  VIDEO_P100_WATCHED_ACTIONS,
  VIDEO_P25_WATCHED_ACTIONS,
  VIDEO_P50_WATCHED_ACTIONS,
  VIDEO_P75_WATCHED_ACTIONS,
  VIDEO_P95_WATCHED_ACTIONS,
  VIDEO_PLAY_ACTIONS,
  VIDEO_PLAY_CURVE_ACTIONS,
  VIDEO_PLAY_RETENTION_0_TO_15S_ACTIONS,
  VIDEO_PLAY_RETENTION_20_TO_60S_ACTIONS,
  VIDEO_PLAY_RETENTION_GRAPH_ACTIONS,
  VIDEO_TIME_WATCHED_ACTIONS,
  WEBSITE_CTR,
  WEBSITE_PURCHASE_ROAS,
  BILLED_COST,
  GROSS_IMPRESSIONS,
  CONVERSION_RATE_TIKTOK,
  RESULT_RATE_TIKTOK,
  VIDEO_VIEWS_P100_TIKTOK,
  AVERAGE_VIDEO_PLAY,
  ENGAGEMENT_RATE_TIKTOK,
  FOLLOWS_TIKTOK,
  LIKES_TIKTOK,
  COMMENTS_TIKTOK,
  SHARES_TIKTOK,
  PROFILE_VISITS_TIKTOK,
  COMMENTS_LINKEDIN,
  COMPANY_PAGE_CLICKS_LINKEDIN,
  EXTERNAL_WEBSITE_CONVERSIONS_LINKEDIN,
  FOLLOWS_LINKEDIN,
  FULL_SCREEN_PLAYS_LINKEDIN,
  LANDING_PAGE_CLICKS_LINKEDIN,
  LIKES_LINKEDIN,
  REACTIONS_LINKEDIN,
  RETURN_ON_AD_SPEND_LINKEDIN,
  SHARES_LINKEDIN,
  TOTAL_ENGAGEMENTS_LINKEDIN,
  VIDEO_COMPLETIONS_LINKEDIN,
  VIDEO_STARTS_LINKEDIN,
  VIDEO_VIEWS_LINKEDIN,
  ONE_CLICK_LEADS_LINKEDIN,
  ONE_CLICK_LEAD_FORM_OPENS_LINKEDIN,
  LEAD_FORM_COMPLETION_RATE_LINKEDIN,
  VALID_WORK_EMAIL_LEADS_LINKEDIN,
  DOWNLOAD_CLICKS_LINKEDIN,
  DOCUMENT_FIRST_QUARTILE_COMPLETIONS_LINKEDIN,
  DOCUMENT_MIDPOINT_COMPLETIONS_LINKEDIN,
  DOCUMENT_THIRD_QUARTILE_COMPLETIONS_LINKEDIN,
  DOCUMENT_COMPLETIONS_LINKEDIN,
  LIVE_VIEWS,
  APP_INSTALL_TIKTOK,
  COST_PER_APP_INSTALL_TIKTOK,
  REGISTRATION,
  COST_PER_REGISTRATION,
  PURCHASE_TIKTOK,
  COST_PER_PURCHASE_TIKTOK,
  PURCHASE_RATE,
  TOTAL_PURCHASE_VALUE,
  APP_EVENT_ADD_TO_CART_TIKTOK,
  COST_PER_APP_EVENT_ADD_TO_CART_TIKTOK,
  CHECKOUT_TIKTOK,
  COST_PER_CHECKOUT_TIKTOK,
  VIEW_CONTENT_TIKTOK,
  COST_PER_VIEW_CONTENT_TIKTOK,
  NEXT_DAY_OPEN,
  DAY7_RETENTION,
  CASH_SPEND,
  VOUCHER_SPEND,
  COST_PER_1000_REACHED,
  CONVERSION_RATE_V2,
  REAL_TIME_CONVERSION,
  REAL_TIME_COST_PER_CONVERSION,
  REAL_TIME_CONVERSION_RATE,
  REAL_TIME_CONVERSION_RATE_V2,
  REAL_TIME_RESULT,
  REAL_TIME_COST_PER_RESULT,
  REAL_TIME_RESULT_RATE,
  SECONDARY_GOAL_RESULT,
  COST_PER_SECONDARY_GOAL_RESULT,
  SECONDARY_GOAL_RESULT_RATE,
  VIDEO_PLAY_ACTIONS_TIKTOK,
  VIDEO_WATCHED_2S,
  VIDEO_WATCHED_6S,
  VIDEO_VIEWS_P25,
  VIDEO_VIEWS_P50,
  VIDEO_VIEWS_P75,
  AVERAGE_VIDEO_PLAY_PER_USER,
  PAID_ENGAGED_VIEW,
  PAID_ENGAGEMENT_ENGAGED_VIEW,
  ENGAGED_VIEW_15S,
  PAID_ENGAGED_VIEW_15S,
  PAID_ENGAGEMENT_ENGAGED_VIEW_15S,
  CLICKS_ON_MUSIC_DISC,
  DUET_CLICKS,
  STITCH_CLICKS,
  SOUND_USAGE_CLICKS,
  MUSIC_UPLOAD_TITLE,
  MUSIC_UPLOAD_BUTTON,
  MUSIC_REMOVE_BUTTON,
  MUSIC_UPLOAD_DESCRIPTION,
  ANCHOR_CLICKS,
  ANCHOR_CLICK_RATE,
  CLICKS_ON_HASHTAG_CHALLENGE,
  PROFILE_VISITS_RATE,
  TT_PLAYLIST_VISIT,
  TT_PLAYLIST_VISIT_RATE,
  LIVE_UNIQUE_VIEWS,
  LIVE_EFFECTIVE_VIEWS,
  LIVE_PRODUCT_CLICKS,
  INTERACTIVE_ADD_ON_IMPRESSIONS,
  INTERACTIVE_ADD_ON_DESTINATION_CLICKS,
  INTERACTIVE_ADD_ON_ACTIVITY_CLICKS,
  INTERACTIVE_ADD_ON_OPTION_A_CLICKS,
  INTERACTIVE_ADD_ON_OPTION_B_CLICKS,
  COUNTDOWN_STICKER_RECALL_CLICKS,
  IX_PAGE_DURATION_AVG,
  IX_PAGE_VIEWRATE_AVG,
  IX_VIDEO_VIEWS,
  IX_VIDEO_VIEWS_P25,
  IX_VIDEO_VIEWS_P50,
  IX_VIDEO_VIEWS_P75,
  IX_VIDEO_VIEWS_P100,
  IX_AVERAGE_VIDEO_PLAY,
  REAL_TIME_APP_INSTALL,
  REAL_TIME_APP_INSTALL_COST,
  REGISTRATION_RATE,
  TOTAL_REGISTRATION,
  COST_PER_TOTAL_REGISTRATION,
  TOTAL_PURCHASE,
  COST_PER_TOTAL_PURCHASE,
  VALUE_PER_TOTAL_PURCHASE,
  TOTAL_ACTIVE_PAY_ROAS,
  TOTAL_PURCHASE_ROAS_DAY0,
  TOTAL_PURCHASE_ROAS_DAY2,
  TOTAL_PURCHASE_ROAS_DAY6,
  TOTAL_PURCHASE_VALUE_DAY0,
  TOTAL_PURCHASE_VALUE_DAY2,
  TOTAL_PURCHASE_VALUE_DAY6,
  APP_EVENT_ADD_TO_CART_RATE,
  TOTAL_APP_EVENT_ADD_TO_CART,
  COST_PER_TOTAL_APP_EVENT_ADD_TO_CART,
  VALUE_PER_TOTAL_APP_EVENT_ADD_TO_CART,
  TOTAL_APP_EVENT_ADD_TO_CART_VALUE,
  CHECKOUT_RATE,
  TOTAL_CHECKOUT,
  COST_PER_TOTAL_CHECKOUT,
  VALUE_PER_CHECKOUT,
  TOTAL_CHECKOUT_VALUE,
  VIEW_CONTENT_RATE,
  TOTAL_VIEW_CONTENT,
  COST_PER_TOTAL_VIEW_CONTENT,
  VALUE_PER_TOTAL_VIEW_CONTENT,
  TOTAL_VIEW_CONTENT_VALUE,
  COST_PER_NEXT_DAY_OPEN,
  NEXT_DAY_OPEN_RATE,
  TOTAL_NEXT_DAY_OPEN,
  COST_PER_TOTAL_NEXT_DAY_OPEN,
  COST_PER_DAY7_RETENTION,
  DAY7_RETENTION_RATE,
  TOTAL_DAY7_RETENTION,
  COST_PER_TOTAL_DAY7_RETENTION,
  VALUE_PER_TOTAL_DAY7_RETENTION,
  TOTAL_DAY7_RETENTION_VALUE,
  ADD_PAYMENT_INFO,
  COST_PER_ADD_PAYMENT_INFO,
  ADD_PAYMENT_INFO_RATE,
  TOTAL_ADD_PAYMENT_INFO,
  COST_TOTAL_ADD_PAYMENT_INFO,
  ADD_TO_WISHLIST,
  COST_PER_ADD_TO_WISHLIST,
  ADD_TO_WISHLIST_RATE,
  TOTAL_ADD_TO_WISHLIST,
  COST_PER_TOTAL_ADD_TO_WISHLIST,
  VALUE_PER_TOTAL_ADD_TO_WISHLIST,
  TOTAL_ADD_TO_WISHLIST_VALUE,
  LAUNCH_APP,
  COST_PER_LAUNCH_APP,
  LAUNCH_APP_RATE,
  TOTAL_LAUNCH_APP,
  COST_PER_TOTAL_LAUNCH_APP,
  COMPLETE_TUTORIAL,
  COST_PER_COMPLETE_TUTORIAL,
  COMPLETE_TUTORIAL_RATE,
  TOTAL_COMPLETE_TUTORIAL,
  COST_PER_TOTAL_COMPLETE_TUTORIAL,
  VALUE_PER_TOTAL_COMPLETE_TUTORIAL,
  TOTAL_COMPLETE_TUTORIAL_VALUE,
  CREATE_GROUP,
  COST_PER_CREATE_GROUP,
  CREATE_GROUP_RATE,
  TOTAL_CREATE_GROUP,
  COST_PER_TOTAL_CREATE_GROUP,
  VALUE_PER_TOTAL_CREATE_GROUP,
  TOTAL_CREATE_GROUP_VALUE,
  JOIN_GROUP,
  COST_PER_JOIN_GROUP,
  JOIN_GROUP_RATE,
  TOTAL_JOIN_GROUP,
  COST_PER_TOTAL_JOIN_GROUP,
  VALUE_PER_TOTAL_JOIN_GROUP,
  TOTAL_JOIN_GROUP_VALUE,
  CREATE_GAMEROLE,
  COST_PER_CREATE_GAMEROLE,
  CREATE_GAMEROLE_RATE,
  TOTAL_CREATE_GAMEROLE,
  COST_PER_TOTAL_CREATE_GAMEROLE,
  VALUE_PER_TOTAL_CREATE_GAMEROLE,
  TOTAL_CREATE_GAMEROLE_VALUE,
  SPEND_CREDITS,
  COST_PER_SPEND_CREDITS,
  SPEND_CREDITS_RATE,
  TOTAL_SPEND_CREDITS,
  COST_PER_TOTAL_SPEND_CREDITS,
  VALUE_PER_TOTAL_SPEND_CREDITS,
  TOTAL_SPEND_CREDITS_VALUE,
  ACHIEVE_LEVEL,
  COST_PER_ACHIEVE_LEVEL,
  ACHIEVE_LEVEL_RATE,
  TOTAL_ACHIEVE_LEVEL,
  COST_PER_TOTAL_ACHIEVE_LEVEL,
  VALUE_PER_TOTAL_ACHIEVE_LEVEL,
  TOTAL_ACHIEVE_LEVEL_VALUE,
  UNLOCK_ACHIEVEMENT,
  COST_PER_UNLOCK_ACHIEVEMENT,
  UNLOCK_ACHIEVEMENT_RATE,
  TOTAL_UNLOCK_ACHIEVEMENT,
  COST_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  VALUE_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  TOTAL_UNLOCK_ACHIEVEMENT_VALUE,
  SALES_LEAD,
  COST_PER_SALES_LEAD,
  SALES_LEAD_RATE,
  TOTAL_SALES_LEAD,
  COST_PER_TOTAL_SALES_LEAD,
  VALUE_PER_TOTAL_SALES_LEAD,
  TOTAL_SALES_LEAD_VALUE,
  IN_APP_AD_CLICK,
  COST_PER_IN_APP_AD_CLICK,
  IN_APP_AD_CLICK_RATE,
  TOTAL_IN_APP_AD_CLICK,
  COST_PER_TOTAL_IN_APP_AD_CLICK,
  VALUE_PER_TOTAL_IN_APP_AD_CLICK,
  TOTAL_IN_APP_AD_CLICK_VALUE,
  IN_APP_AD_IMPR,
  COST_PER_IN_APP_AD_IMPR,
  IN_APP_AD_IMPR_RATE,
  TOTAL_IN_APP_AD_IMPR,
  COST_PER_TOTAL_IN_APP_AD_IMPR,
  VALUE_PER_TOTAL_IN_APP_AD_IMPR,
  TOTAL_IN_APP_AD_IMPR_VALUE,
  LOAN_APPLY,
  COST_PER_LOAN_APPLY,
  LOAN_APPLY_RATE,
  TOTAL_LOAN_APPLY,
  COST_PER_TOTAL_LOAN_APPLY,
  LOAN_CREDIT,
  COST_PER_LOAN_CREDIT,
  LOAN_CREDIT_RATE,
  TOTAL_LOAN_CREDIT,
  COST_PER_TOTAL_LOAN_CREDIT,
  LOAN_DISBURSEMENT,
  COST_PER_LOAN_DISBURSEMENT,
  LOAN_DISBURSEMENT_RATE,
  TOTAL_LOAN_DISBURSEMENT,
  COST_PER_TOTAL_LOAN_DISBURSEMENT,
  LOGIN,
  COST_PER_LOGIN,
  LOGIN_RATE,
  TOTAL_LOGIN,
  COST_PER_TOTAL_LOGIN,
  RATINGS,
  GALLERY_VIEW_SCORES,
  GALLERY_CREATE_CAMPAIGN_LEAVE_FLOW_TITLE,
  GALLERY_CREATE_CAMPAIGN_LEAVE_FLOW_DESCRIPTION,
  GALLERY_SELECTED_COUNT_SINGULAR,
  GALLERY_SELECTED_COUNT_PLURAL,
  GALLERY_FOLDERS_ALL,
  GALLERY_FOLDERS_CREATE_TITLE,
  GALLERY_FOLDERS_NAME,
  GALLERY_FOLDERS_DUPLICATE,
  GALLERY_FOLDERS_CREATE_SUCCESS,
  GALLERY_FOLDERS_MOVE_SUCCESS,
  GALLERY_FOLDERS_CREATE_ERROR,
  GALLERY_FOLDERS_MOVE_ERROR,
  GALLERY_FOLDERS_BAR_ARIA_LABEL,
  GALLERY_FOLDERS_NEW_INLINE,
  GALLERY_UPLOAD_FOLDER_EMPTY,
  GALLERY_FOLDERS_UNASSIGN_SUCCESS,
  GALLERY_FOLDERS_UNASSIGN_ERROR,
  GALLERY_FOLDERS_CREATE_IN,
  GALLERY_FOLDERS_MOVE,
  GALLERY_FOLDERS_MOVE_TITLE,
  GALLERY_FOLDERS_MOVE_DESCRIPTION,
  GALLERY_FOLDERS_DESTINATION,
  GALLERY_FOLDERS_SELECT,
  GALLERY_FOLDERS_DESTINATION_PATH,
  GALLERY_FOLDERS_RENAME_TITLE,
  GALLERY_FOLDERS_RENAME_SUCCESS,
  GALLERY_FOLDERS_RENAME_ERROR,
  GALLERY_FOLDERS_RENAME_ARIA_LABEL,
  GALLERY_FOLDERS_DELETE_ARIA_LABEL,
  GALLERY_FOLDERS_DELETE_TITLE,
  GALLERY_FOLDERS_DELETE_TEXT,
  GALLERY_FOLDERS_DELETE_SUCCESS,
  GALLERY_FOLDERS_DELETE_ERROR,
  GALLERY_FOLDERS_REMOVE_FROM_FOLDER,
  GALLERY_FOLDERS_REMOVE_FROM_FOLDER_TITLE,
  GALLERY_FOLDERS_REMOVE_FROM_FOLDER_TEXT,
  GALLERY_FILTER_APPROVAL_STATUS,
  CAMPAIGNS_FOLDER_EMPTY,
  CAMPAIGNS_MOVE_SELECTED,
  CAMPAIGNS_FOLDERS_MOVE,
  CAMPAIGNS_FOLDERS_MOVE_TITLE,
  CAMPAIGNS_FOLDERS_MOVE_DESCRIPTION,
  CAMPAIGNS_FOLDERS_MOVE_SUCCESS,
  CAMPAIGNS_FOLDERS_MOVE_ERROR,
  CAMPAIGNS_FOLDERS_UNASSIGN_SUCCESS,
  CAMPAIGNS_FOLDERS_UNASSIGN_ERROR,
  CAMPAIGNS_SELECT_ROW,
  COST_PER_RATINGS,
  RATINGS_RATE,
  TOTAL_RATINGS,
  COST_PER_TOTAL_RATINGS,
  VALUE_PER_TOTAL_RATINGS,
  TOTAL_RATINGS_VALUE,
  SEARCH_TIKTOK,
  COST_PER_SEARCH,
  SEARCH_RATE,
  TOTAL_SEARCH,
  COST_PER_TOTAL_SEARCH,
  START_TRIAL,
  COST_PER_START_TRIAL,
  START_TRIAL_RATE,
  TOTAL_START_TRIAL,
  COST_PER_TOTAL_START_TRIAL,
  SUBSCRIBE,
  COST_PER_SUBSCRIBE,
  SUBSCRIBE_RATE,
  TOTAL_SUBSCRIBE,
  COST_PER_TOTAL_SUBSCRIBE,
  VALUE_PER_TOTAL_SUBSCRIBE,
  TOTAL_SUBSCRIBE_VALUE,
  UNIQUE_CUSTOM_APP_EVENTS,
  COST_PER_UNIQUE_CUSTOM_APP_EVENT,
  CUSTOM_APP_EVENT_RATE,
  CUSTOM_APP_EVENTS,
  COST_PER_CUSTOM_APP_EVENT,
  VALUE_PER_CUSTOM_APP_EVENT,
  CUSTOM_APP_EVENTS_VALUE,
  UNIQUE_AD_IMPRESSION_EVENTS,
  COST_PER_UNIQUE_AD_IMPRESSION_EVENT,
  CUSTOMIZED_AD_IMPRESSION_EVENT_RATE,
  ADS_IMPRESSION_EVENTS,
  COST_PRE_AD_IMPRESSION_EVENT,
  VALUE_PER_AD_IMPRESSION_EVENT,
  TOTAL_AD_IMPRESSION_EVENTS_VALUE,
  TOTAL_AD_IMPRESSION_ROAS,
  AD_IMPRESSION_AD_REVENUE_ROAS_DAY0,
  AD_IMPRESSION_AD_REVENUE_ROAS_DAY2,
  AD_IMPRESSION_AD_REVENUE_ROAS_DAY6,
  AD_IMPRESSION_AD_REVENUE_DAY0,
  AD_IMPRESSION_AD_REVENUE_DAY2,
  AD_IMPRESSION_AD_REVENUE_DAY6,
  COMPLETE_PAYMENT_ROAS,
  COMPLETE_PAYMENT,
  COST_PER_COMPLETE_PAYMENT,
  COMPLETE_PAYMENT_RATE,
  VALUE_PER_COMPLETE_PAYMENT,
  TOTAL_COMPLETE_PAYMENT_RATE,
  TOTAL_LANDING_PAGE_VIEW,
  COST_PER_LANDING_PAGE_VIEW,
  LANDING_PAGE_VIEW_RATE,
  TOTAL_PAGEVIEW,
  COST_PER_PAGEVIEW,
  PAGEVIEW_RATE,
  AVG_VALUE_PER_PAGEVIEW,
  TOTAL_VALUE_PER_PAGEVIEW,
  PAGE_BROWSE_VIEW,
  COST_PER_PAGE_BROWSE_VIEW,
  PAGE_BROWSE_VIEW_RATE,
  TOTAL_PAGE_BROWSE_VIEW_VALUE,
  VALUE_PER_PAGE_BROWSE_VIEW,
  BUTTON_CLICK,
  COST_PER_BUTTON_CLICK,
  BUTTON_CLICK_RATE,
  VALUE_PER_BUTTON_CLICK,
  TOTAL_BUTTON_CLICK_VALUE,
  ONLINE_CONSULT,
  COST_PER_ONLINE_CONSULT,
  ONLINE_CONSULT_RATE,
  VALUE_PER_ONLINE_CONSULT,
  TOTAL_ONLINE_CONSULT_VALUE,
  USER_REGISTRATION,
  COST_PER_USER_REGISTRATION,
  USER_REGISTRATION_RATE,
  VALUE_PER_USER_REGISTRATION,
  TOTAL_USER_REGISTRATION_VALUE,
  PAGE_CONTENT_VIEW_EVENTS,
  COST_PER_PAGE_CONTENT_VIEW_EVENT,
  PAGE_CONTENT_VIEW_EVENT_RATE,
  VALUE_PER_PAGE_CONTENT_VIEW_EVENT,
  TOTAL_PAGE_VIEW_CONTENT_EVENTS_VALUE,
  PRODUCT_DETAILS_PAGE_BROWSE,
  COST_PER_PRODUCT_DETAILS_PAGE_BROWSE,
  PRODUCT_DETAILS_PAGE_BROWSE_RATE,
  VALUE_PER_PRODUCT_DETAILS_PAGE_BROWSE,
  TOTAL_PRODUCT_DETAILS_PAGE_BROWSE_VALUE,
  WEB_EVENT_ADD_TO_CART,
  COST_PER_WEB_EVENT_ADD_TO_CART,
  WEB_EVENT_ADD_TO_CART_RATE,
  VALUE_PER_WEB_EVENT_ADD_TO_CART,
  TOTAL_WEB_EVENT_ADD_TO_CART_VALUE,
  ON_WEB_ORDER,
  COST_PER_ON_WEB_ORDER,
  ON_WEB_ORDER_RATE,
  VALUE_PER_ON_WEB_ORDER,
  TOTAL_ON_WEB_ORDER_VALUE,
  INITIATE_CHECKOUT,
  COST_PER_INITIATE_CHECKOUT,
  INITIATE_CHECKOUT_RATE,
  VALUE_PER_INITIATE_CHECKOUT,
  TOTAL_INITIATE_CHECKOUT_VALUE,
  ADD_BILLING,
  COST_PER_ADD_BILLING,
  ADD_BILLING_RATE,
  VALUE_PER_ADD_BILLING,
  TOTAL_ADD_BILLING_VALUE,
  PAGE_EVENT_SEARCH,
  COST_PER_PAGE_EVENT_SEARCH,
  PAGE_EVENT_SEARCH_RATE,
  VALUE_PER_PAGE_EVENT_SEARCH,
  TOTAL_PAGE_EVENT_SEARCH_VALUE,
  FORM_TIKTOK,
  COST_PER_FORM,
  FORM_RATE,
  VALUE_PER_FORM,
  TOTAL_FORM_VALUE,
  DOWNLOAD_START,
  COST_PER_DOWNLOAD_START,
  DOWNLOAD_START_RATE,
  VALUE_PER_DOWNLOAD_START,
  TOTAL_DOWNLOAD_START_VALUE,
  ON_WEB_ADD_TO_WISHLIST,
  COST_PER_ON_WEB_ADD_TO_WISHLIST,
  ON_WEB_ADD_TO_WISHLIST_PER_CLICK,
  VALUE_PER_ON_WEB_ADD_TO_WISHLIST,
  TOTAL_ON_WEB_ADD_TO_WISHLIST_VALUE,
  ON_WEB_SUBSCRIBE,
  COST_PER_ON_WEB_SUBSCRIBE,
  ON_WEB_SUBSCRIBE_PER_CLICK,
  VALUE_PER_ON_WEB_SUBSCRIBE,
  TOTAL_ON_WEB_SUBSCRIBE_VALUE,
  WEBSITE_TOTAL_FIND_LOCATION,
  WEBSITE_COST_PER_FIND_LOCATION,
  WEBSITE_FIND_LOCATION_RATE,
  WEBSITE_VALUE_PER_FIND_LOCATION,
  WEBSITE_TOTAL_FIND_LOCATION_VALUE,
  WEBSITE_TOTAL_SCHEDULE,
  WEBSITE_COST_PER_SCHEDULE,
  WEBSITE_SCHEDULE_RATE,
  WEBSITE_VALUE_PER_SCHEDULE,
  WEBSITE_TOTAL_SCHEDULE_VALUE,
  WEBSITE_TOTAL_CUSTOMIZE_PRODUCT,
  WEBSITE_COST_PER_CUSTOMIZE_PRODUCT,
  WEBSITE_CUSTOMIZE_PRODUCT_RATE,
  WEBSITE_VALUE_PER_CUSTOMIZE_PRODUCT,
  WEBSITE_TOTAL_CUSTOMIZE_PRODUCT_VALUE,
  CUSTOM_PAGE_EVENTS,
  COST_PER_CUSTOM_PAGE_EVENT,
  CUSTOM_PAGE_EVENT_RATE,
  VALUE_PER_CUSTOM_PAGE_EVENT,
  CUSTOM_PAGE_EVENTS_VALUE,
  ONSITE_PURCHASES_ROAS,
  ONSITE_TOTAL_PURCHASE,
  ONSITE_COST_PER_PURCHASE,
  ONSITE_PURCHASE_RATE,
  ONSITE_VALUE_PER_PURCHASE,
  ONSITE_TOTAL_PURCHASE_VALUE,
  ONSITE_TOTAL_CHECKOUT_INITIATION,
  ONSITE_COST_PER_CHECKOUT_INITIATION,
  ONSITE_CHECKOUT_INITIATION_RATE,
  ONSITE_VALUE_PER_CHECKOUT_INITIATION,
  ONSITE_TOTAL_CHECKOUT_INITIATION_VALUE,
  ONSITE_TOTAL_ADD_TO_CART,
  ONSITE_COST_PER_ADD_TO_CART,
  ONSITE_ADD_TO_CART_RATE,
  ONSITE_VALUE_PER_ADD_TO_CART,
  ONSITE_TOTAL_ADD_TO_CART_VALUE,
  ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW,
  ONSITE_COST_PER_PRODUCT_DETAILS_PAGE_VIEW,
  ONSITE_PRODUCT_DETAILS_PAGE_VIEW_RATE,
  ONSITE_VALUE_PER_PRODUCT_DETAILS_PAGE_VIEW,
  ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW_VALUE,
  ONSITE_ADD_TO_WISHLIST,
  COST_PER_ONSITE_ADD_TO_WISHLIST,
  ONSITE_ADD_TO_WISHLIST_RATE,
  VALUE_PER_ONSITE_ADD_TO_WISHLIST,
  TOTAL_ONSITE_ADD_TO_WISHLIST_VALUE,
  ONSITE_ADD_BILLING,
  COST_PER_ONSITE_ADD_BILLING,
  ONSITE_ADD_BILLING_RATE,
  VALUE_PER_ONSITE_ADD_BILLING,
  TOTAL_ONSITE_ADD_BILLING_VALUE,
  ONSITE_FORM,
  COST_PER_ONSITE_FORM,
  ONSITE_FORM_RATE,
  VALUE_PER_ONSITE_FORM,
  TOTAL_ONSITE_FORM_VALUE,
  ONSITE_TOTAL_FILTERED_OUT_FORM_SUBMISSION,
  ONSITE_DOWNLOAD_START,
  COST_PER_ONSITE_DOWNLOAD_START,
  ONSITE_DOWNLOAD_START_RATE,
  ONSITE_DESTINATION_VISITS,
  COST_PER_ONSITE_DESTINATION_VISIT,
  ONSITE_DESTINATION_VISIT_RATE,
  IX_PAGE_VIEW_COUNT,
  COST_PER_IX_PAGE_VIEW_COUNT,
  IX_PAGE_VIEW_COUNT_RATE,
  IX_BUTTON_CLICK_COUNT,
  COST_PER_IX_BUTTON_CLICK_COUNT,
  IX_BUTTON_CLICK_COUNT_RATE,
  IX_PRODUCT_CLICK_COUNT,
  COST_PER_IX_PRODUCT_CLICK_COUNT,
  IX_PRODUCT_CLICK_COUNT_RATE,
  OFFLINE_TOTAL_CRM_EVENTS,
  OFFLINE_COST_PER_CRM_EVENT,
  OFFLINE_CRM_EVENT_RATE,
  OFFLINE_VALUE_PER_CRM_EVENT,
  OFFLINE_CRM_EVENT_VALUE,
  OFFLINE_SHOPPING_EVENTS,
  COST_PER_OFFLINE_SHOPPING_EVENT,
  OFFLINE_SHOPPING_EVENT_RATE,
  VALUE_PER_OFFLINE_SHOPPING_EVENT,
  OFFLINE_SHOPPING_EVENTS_VALUE,
  OFFLINE_SHOPPING_EVENTS_ROAS,
  OFFLINE_CONTACT_EVENTS,
  COST_PER_OFFLINE_CONTACT_EVENT,
  OFFLINE_CONTACT_EVENT_RATE,
  VALUE_PER_OFFLINE_CONTACT_EVENT,
  OFFLINE_CONTACT_EVENTS_VALUE,
  OFFLINE_SUBSCRIBE_EVENTS,
  COST_PER_OFFLINE_SUBSCRIBE_EVENT,
  OFFLINE_SUBSCRIBE_EVENT_RATE,
  VALUE_PER_OFFLINE_SUBSCRIBE_EVENT,
  OFFLINE_SUBSCRIBE_EVENTS_VALUE,
  OFFLINE_FORM_EVENTS,
  COST_PER_OFFLINE_FORM_EVENT,
  OFFLINE_FORM_EVENT_RATE,
  VALUE_PER_OFFLINE_FORM_EVENT,
  OFFLINE_FORM_EVENTS_VALUE,
  OFFLINE_ADD_PAYMENT_INFO_EVENTS,
  COST_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT,
  OFFLINE_ADD_PAYMENT_INFO_EVENT_RATE,
  VALUE_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT,
  OFFLINE_ADD_PAYMENT_INFO_EVENTS_VALUE,
  OFFLINE_ADD_TO_CART_EVENTS,
  COST_PER_OFFLINE_ADD_TO_CART_EVENT,
  OFFLINE_ADD_TO_CART_EVENT_RATE,
  VALUE_PER_OFFLINE_ADD_TO_CART_EVENT,
  OFFLINE_ADD_TO_CART_EVENTS_VALUE,
  OFFLINE_ADD_TO_WISHLIST_EVENTS,
  COST_PER_OFFLINE_ADD_TO_WISHLIST_EVENT,
  OFFLINE_ADD_TO_WISHLIST_EVENT_RATE,
  VALUE_PER_OFFLINE_ADD_TO_WISHLIST_EVENT,
  OFFLINE_ADD_TO_WISHLIST_EVENTS_VALUE,
  OFFLINE_CLICK_BUTTON_EVENTS,
  COST_PER_OFFLINE_CLICK_BUTTON_EVENT,
  OFFLINE_CLICK_BUTTON_EVENT_RATE,
  VALUE_PER_OFFLINE_CLICK_BUTTON_EVENT,
  OFFLINE_CLICK_BUTTON_EVENTS_VALUE,
  OFFLINE_COMPLETE_REGISTRATION_EVENTS,
  COST_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT,
  OFFLINE_COMPLETE_REGISTRATION_EVENT_RATE,
  VALUE_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT,
  OFFLINE_COMPLETE_REGISTRATION_EVENTS_VALUE,
  OFFLINE_DOWNLOAD_EVENTS,
  COST_PER_OFFLINE_DOWNLOAD_EVENT,
  OFFLINE_DOWNLOAD_EVENT_RATE,
  VALUE_PER_OFFLINE_DOWNLOAD_EVENT,
  OFFLINE_DOWNLOAD_EVENTS_VALUE,
  OFFLINE_INITIATE_CHECKOUT_EVENTS,
  COST_PER_OFFLINE_INITIATE_CHECKOUT_EVENT,
  OFFLINE_INITIATE_CHECKOUT_EVENT_RATE,
  VALUE_PER_OFFLINE_INITIATE_CHECKOUT_EVENT,
  OFFLINE_INITIATE_CHECKOUT_EVENTS_VALUE,
  OFFLINE_PLACE_ORDER_EVENTS,
  COST_PER_OFFLINE_PLACE_ORDER_EVENT,
  OFFLINE_PLACE_ORDER_EVENT_RATE,
  VALUE_PER_OFFLINE_PLACE_ORDER_EVENT,
  OFFLINE_PLACE_ORDER_EVENTS_VALUE,
  OFFLINE_SEARCH_EVENTS,
  COST_PER_OFFLINE_SEARCH_EVENT,
  OFFLINE_SEARCH_EVENT_RATE,
  VALUE_PER_OFFLINE_SEARCH_EVENT,
  OFFLINE_SEARCH_EVENTS_VALUE,
  OFFLINE_VIEW_CONTENT_EVENTS,
  COST_PER_OFFLINE_VIEW_CONTENT_EVENT,
  OFFLINE_VIEW_CONTENT_EVENT_RATE,
  VALUE_PER_OFFLINE_VIEW_CONTENT_EVENT,
  OFFLINE_VIEW_CONTENT_EVENTS_VALUE,
  OFFLINE_PREFERRED_LEADS,
  OFFLINE_COST_PER_PREFERRED_LEAD,
  OFFLINE_PREFERRED_LEAD_RATE,
  OFFLINE_TOTAL_FIND_LOCATION,
  OFFLINE_COST_PER_FIND_LOCATION,
  OFFLINE_FIND_LOCATION_RATE,
  OFFLINE_VALUE_PER_FIND_LOCATION,
  OFFLINE_TOTAL_FIND_LOCATION_VALUE,
  OFFLINE_TOTAL_SCHEDULE,
  OFFLINE_COST_PER_SCHEDULE,
  OFFLINE_SCHEDULE_RATE,
  OFFLINE_VALUE_PER_SCHEDULE,
  OFFLINE_TOTAL_SCHEDULE_VALUE,
  OFFLINE_TOTAL_CUSTOMIZE_PRODUCT,
  OFFLINE_COST_PER_CUSTOMIZE_PRODUCT,
  OFFLINE_CUSTOMIZE_PRODUCT_RATE,
  OFFLINE_VALUE_PER_CUSTOMIZE_PRODUCT,
  OFFLINE_TOTAL_CUSTOMIZE_PRODUCT_VALUE,
  OFFLINE_TOTAL_CUSTOM_EVENTS,
  OFFLINE_COST_PER_CUSTOM_EVENT,
  OFFLINE_CUSTOM_EVENT_RATE,
  OFFLINE_VALUE_PER_CUSTOM_EVENT,
  OFFLINE_TOTAL_CUSTOM_EVENT_VALUE,
  MESSAGING_TOTAL_CONVERSATION_TIKTOK_DIRECT_MESSAGE,
  MESSAGING_COST_PER_CONVERSATION_TIKTOK_DIRECT_MESSAGE,
  MESSAGING_CONVERSATION_RATE_TIKTOK_DIRECT_MESSAGE,
  MESSAGING_TOTAL_CONVERSATION_INSTANT_MESSAGING_APP,
  MESSAGING_COST_PER_CONVERSATION_INSTANT_MESSAGING_APP,
  MESSAGING_CONVERSATION_RATE_INSTANT_MESSAGING_APP,
  ONSITE_SHOPPING_ROAS,
  ONSITE_SHOPPING,
  COST_PER_ONSITE_SHOPPING,
  ONSITE_SHOPPING_RATE,
  VALUE_PER_ONSITE_SHOPPING,
  TOTAL_ONSITE_SHOPPING_VALUE,
  SHOP_TOTAL_PURCHASE_BY_ORDER_SUBMISSION,
  SHOP_GROSS_REVENUE_BY_ORDER_SUBMISSION,
  SHOP_TOTAL_ITEMS_PURCHASED,
  ONSITE_INITIATE_CHECKOUT_COUNT,
  COST_PER_ONSITE_INITIATE_CHECKOUT_COUNT,
  ONSITE_INITIATE_CHECKOUT_COUNT_RATE,
  VALUE_PER_ONSITE_INITIATE_CHECKOUT_COUNT,
  TOTAL_ONSITE_INITIATE_CHECKOUT_COUNT_VALUE,
  ONSITE_ON_WEB_DETAIL,
  COST_PER_ONSITE_ON_WEB_DETAIL,
  ONSITE_ON_WEB_DETAIL_RATE,
  VALUE_PER_ONSITE_ON_WEB_DETAIL,
  TOTAL_ONSITE_ON_WEB_DETAIL_VALUE,
  ONSITE_ON_WEB_CART,
  COST_PER_ONSITE_ON_WEB_CART,
  ONSITE_ON_WEB_CART_RATE,
  VALUE_PER_ONSITE_ON_WEB_CART,
  TOTAL_ONSITE_ON_WEB_CART_VALUE,
  VTA_CONVERSION,
  COST_PER_VTA_CONVERSION,
  CTA_CONVERSION,
  COST_PER_CTA_CONVERSION,
  ENGAGED_VIEW_THROUGH_CONVERSIONS,
  COST_PER_ENGAGED_VIEW_THROUGH_CONVERSION,
  VTA_APP_INSTALL,
  COST_PER_VTA_APP_INSTALL,
  CTA_APP_INSTALL,
  COST_PER_CTA_APP_INSTALL,
  EVTA_APP_INSTALL,
  COST_PER_EVTA_APP_INSTALL,
  VTA_REGISTRATION,
  COST_PER_VTA_REGISTRATION,
  CTA_REGISTRATION,
  COST_PER_CTA_REGISTRATION,
  EVTA_REGISTRATION,
  COST_PER_EVTA_REGISTRATION,
  VTA_PURCHASE,
  COST_PER_VTA_PURCHASE,
  CTA_PURCHASE,
  COST_PER_CTA_PURCHASE,
  EVTA_PURCHASE,
  COST_PER_EVTA_PURCHASE,
  VTA_COMPLETE_PAYMENT,
  COST_PER_VTA_PAYMENTS_COMPLETED,
  EVTA_PAYMENTS_COMPLETED,
  COST_PER_EVTA_PAYMENTS_COMPLETED,
  VTA_COMPLETE_PAYMENT_VALUE,
  VTA_COMPLETE_PAYMENT_ROAS,
  SKAN_RESULT,
  SKAN_COST_PER_RESULT,
  SKAN_RESULT_RATE,
  SKAN_CONVERSION,
  SKAN_COST_PER_CONVERSION,
  SKAN_CONVERSION_RATE,
  SKAN_CONVERSION_RATE_V2,
  SKAN_CLICK_TIME_CONVERSION,
  SKAN_CLICK_TIME_COST_PER_CONVERSION,
  SKAN_CLICK_TIME_CONVERSION_RATE,
  SKAN_CLICK_TIME_CONVERSION_RATE_V2,
  SKAN_APP_INSTALL,
  SKAN_COST_PER_APP_INSTALL,
  SKAN_APP_INSTALL_WITHHELD,
  SKAN_REGISTRATION,
  SKAN_COST_PER_REGISTRATION,
  SKAN_REGISTRATION_RATE,
  SKAN_TOTAL_REGISTRATION,
  SKAN_COST_PER_TOTAL_REGISTRATION,
  SKAN_PURCHASE,
  SKAN_COST_PER_PURCHASE,
  SKAN_PURCHASE_RATE,
  SKAN_TOTAL_PURCHASE,
  SKAN_COST_PER_TOTAL_PURCHASE,
  SKAN_TOTAL_PURCHASE_VALUE,
  SKAN_TOTAL_REPETITIVE_ACTIVE_PAY_ROAS,
  SKAN_ADD_TO_CART,
  SKAN_COST_PER_ADD_TO_CART,
  SKAN_ADD_TO_CART_RATE,
  SKAN_TOTAL_ADD_TO_CART,
  SKAN_COST_PER_TOTAL_ADD_TO_CART,
  SKAN_TOTAL_ADD_TO_CART_VALUE,
  SKAN_CHECKOUT,
  SKAN_COST_PER_CHECKOUT,
  SKAN_CHECKOUT_RATE,
  SKAN_TOTAL_CHECKOUT,
  SKAN_COST_PER_TOTAL_CHECKOUT,
  SKAN_TOTAL_CHECKOUT_VALUE,
  SKAN_VIEW_CONTENT,
  SKAN_COST_PER_VIEW_CONTENT,
  SKAN_VIEW_CONTENT_RATE,
  SKAN_TOTAL_VIEW_CONTENT,
  SKAN_COST_PER_TOTAL_VIEW_CONTENT,
  SKAN_TOTAL_VIEW_CONTENT_VALUE,
  SKAN_ADD_PAYMENT_INFO,
  SKAN_COST_PER_ADD_PAYMENT_INFO,
  SKAN_ADD_PAYMENT_INFO_RATE,
  SKAN_TOTAL_ADD_PAYMENT_INFO,
  SKAN_COST_TOTAL_ADD_PAYMENT_INFO,
  SKAN_ADD_TO_WISHLIST,
  SKAN_COST_PER_ADD_TO_WISHLIST,
  SKAN_ADD_TO_WISHLIST_RATE,
  SKAN_TOTAL_ADD_TO_WISHLIST,
  SKAN_COST_PER_TOTAL_ADD_TO_WISHLIST,
  SKAN_TOTAL_ADD_TO_WISHLIST_VALUE,
  SKAN_LAUNCH_APP,
  SKAN_COST_PER_LAUNCH_APP,
  SKAN_LAUNCH_APP_RATE,
  SKAN_TOTAL_LAUNCH_APP,
  SKAN_COST_PER_TOTAL_LAUNCH_APP,
  SKAN_COMPLETE_TUTORIAL,
  SKAN_COST_PER_COMPLETE_TUTORIAL,
  SKAN_COMPLETE_TUTORIAL_RATE,
  SKAN_TOTAL_COMPLETE_TUTORIAL,
  SKAN_COST_PER_TOTAL_COMPLETE_TUTORIAL,
  SKAN_TOTAL_COMPLETE_TUTORIAL_VALUE,
  SKAN_CREATE_GROUP,
  SKAN_COST_PER_CREATE_GROUP,
  SKAN_CREATE_GROUP_RATE,
  SKAN_TOTAL_CREATE_GROUP,
  SKAN_COST_PER_TOTAL_CREATE_GROUP,
  SKAN_TOTAL_CREATE_GROUP_VALUE,
  SKAN_JOIN_GROUP,
  SKAN_COST_PER_JOIN_GROUP,
  SKAN_JOIN_GROUP_RATE,
  SKAN_TOTAL_JOIN_GROUP,
  SKAN_COST_PER_TOTAL_JOIN_GROUP,
  SKAN_TOTAL_JOIN_GROUP_VALUE,
  SKAN_CREATE_GAMEROLE,
  SKAN_COST_PER_CREATE_GAMEROLE,
  SKAN_CREATE_GAMEROLE_RATE,
  SKAN_TOTAL_CREATE_GAMEROLE,
  SKAN_COST_PER_TOTAL_CREATE_GAMEROLE,
  SKAN_TOTAL_CREATE_GAMEROLE_VALUE,
  SKAN_SPEND_CREDITS,
  SKAN_COST_PER_SPEND_CREDITS,
  SKAN_SPEND_CREDITS_RATE,
  SKAN_TOTAL_SPEND_CREDITS,
  SKAN_COST_PER_TOTAL_SPEND_CREDITS,
  SKAN_TOTAL_SPEND_CREDITS_VALUE,
  SKAN_ACHIEVE_LEVEL,
  SKAN_COST_PER_ACHIEVE_LEVEL,
  SKAN_ACHIEVE_LEVEL_RATE,
  SKAN_TOTAL_ACHIEVE_LEVEL,
  SKAN_COST_PER_TOTAL_ACHIEVE_LEVEL,
  SKAN_TOTAL_ACHIEVE_LEVEL_VALUE,
  SKAN_UNLOCK_ACHIEVEMENT,
  SKAN_COST_PER_UNLOCK_ACHIEVEMENT,
  SKAN_UNLOCK_ACHIEVEMENT_RATE,
  SKAN_TOTAL_UNLOCK_ACHIEVEMENT,
  SKAN_COST_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  SKAN_TOTAL_UNLOCK_ACHIEVEMENT_VALUE,
  SKAN_SALES_LEAD,
  SKAN_COST_PER_SALES_LEAD,
  SKAN_SALES_LEAD_RATE,
  SKAN_TOTAL_SALES_LEAD,
  SKAN_COST_PER_TOTAL_SALES_LEAD,
  SKAN_TOTAL_SALES_LEAD_VALUE,
  SKAN_IN_APP_AD_CLICK,
  SKAN_COST_PER_IN_APP_AD_CLICK,
  SKAN_IN_APP_AD_CLICK_RATE,
  SKAN_TOTAL_IN_APP_AD_CLICK,
  SKAN_COST_PER_TOTAL_IN_APP_AD_CLICK,
  SKAN_TOTAL_IN_APP_AD_CLICK_VALUE,
  SKAN_IN_APP_AD_IMPR,
  SKAN_COST_PER_IN_APP_AD_IMPR,
  SKAN_IN_APP_AD_IMPR_RATE,
  SKAN_TOTAL_IN_APP_AD_IMPR,
  SKAN_COST_PER_TOTAL_IN_APP_AD_IMPR,
  SKAN_TOTAL_IN_APP_AD_IMPR_VALUE,
  SKAN_LOAN_APPLY,
  SKAN_COST_PER_LOAN_APPLY,
  SKAN_LOAN_APPLY_RATE,
  SKAN_TOTAL_LOAN_APPLY,
  SKAN_COST_PER_TOTAL_LOAN_APPLY,
  SKAN_LOAN_CREDIT,
  SKAN_COST_PER_LOAN_CREDIT,
  SKAN_LOAN_CREDIT_RATE,
  SKAN_TOTAL_LOAN_CREDIT,
  SKAN_COST_PER_TOTAL_LOAN_CREDIT,
  SKAN_LOAN_DISBURSEMENT,
  SKAN_COST_PER_LOAN_DISBURSEMENT,
  SKAN_LOAN_DISBURSEMENT_RATE,
  SKAN_TOTAL_LOAN_DISBURSEMENT,
  SKAN_COST_PER_TOTAL_LOAN_DISBURSEMENT,
  SKAN_LOGIN,
  SKAN_COST_PER_LOGIN,
  SKAN_LOGIN_RATE,
  SKAN_TOTAL_LOGIN,
  SKAN_COST_PER_TOTAL_LOGIN,
  SKAN_RATINGS,
  SKAN_COST_PER_RATINGS,
  SKAN_RATINGS_RATE,
  SKAN_TOTAL_RATINGS,
  SKAN_COST_PER_TOTAL_RATINGS,
  SKAN_TOTAL_RATINGS_VALUE,
  SKAN_SEARCH,
  SKAN_COST_PER_SEARCH,
  SKAN_SEARCH_RATE,
  SKAN_TOTAL_SEARCH,
  SKAN_COST_PER_TOTAL_SEARCH,
  SKAN_START_TRIAL,
  SKAN_COST_PER_START_TRIAL,
  SKAN_START_TRIAL_RATE,
  SKAN_TOTAL_START_TRIAL,
  SKAN_COST_PER_TOTAL_START_TRIAL,
  SKAN_SUBSCRIBE,
  SKAN_COST_PER_SUBSCRIBE,
  SKAN_SUBSCRIBE_RATE,
  SKAN_TOTAL_SUBSCRIBE,
  SKAN_COST_PER_TOTAL_SUBSCRIBE,
  SKAN_TOTAL_SUBSCRIBE_VALUE,
  SKAN_VTA_CONVERSION,
  SKAN_COST_PER_VTA_CONVERSION,
  SKAN_VTA_APP_INSTALL,
  SKAN_COST_PER_VTA_APP_INSTALL,
  SKAN_VTA_REGISTRATION,
  SKAN_COST_PER_VTA_REGISTRATION,
  SKAN_VTA_PURCHASE,
  SKAN_COST_PER_VTA_PURCHASE,
  SKAN_CTA_CONVERSION,
  SKAN_COST_PER_CTA_CONVERSION,
  SKAN_CTA_APP_INSTALL,
  SKAN_COST_PER_CTA_APP_INSTALL,
  SKAN_CTA_REGISTRATION,
  SKAN_COST_PER_CTA_REGISTRATION,
  SKAN_CTA_PURCHASE,
  SKAN_COST_PER_CTA_PURCHASE,
  REACH,
  FREQUENCY,
  CPM_METRICS,
  CPC_METRICS,
  METRICS_NOT_FOUND_MESSAGE,
  SEARCH_METRICS_PLACEHOLDER,
  CONFIGURE_METRICS,
  GENERAL_METRIC,
  PREVIOUS_PERIOD,
  LOADING_CONFIGURATION_METRICS,
  IN_CURRENCY,
  BID_GOAL_EXPLANATION,
  TARGET_CPA_EXPLANATION,
  OPTIMIZATION_GOAL_CONVERSATIONS,
  OPTIMIZATION_GOAL_VISIT_INSTAGRAM_PROFILE,
  OPTIMIZATION_GOAL_LINK_CLICKS,
  OPTIMIZATION_GOAL_THRUPLAY,
  OPTIMIZATION_GOAL_LANDING_PAGE_VIEWS,
  OPTIMIZATION_GOAL_OPTION_REACH,
  OPTIMIZATION_GOAL_OPTION_THRUPLAY,
  OPTIMIZATION_GOAL_OPTION_LINK_CLICKS,
  OPTIMIZATION_GOAL_OPTION_LANDING_PAGE_VIEWS,
  OPTIMIZATION_GOAL_PLACEHOLDER,
  OPTIMIZATION_GOAL_POST_ENGAGEMENT,
  OPTIMIZATION_GOAL_OFFSITE_CONVERSIONS,
  OPTIMIZATION_GOAL_LEAD_GENERATION,
  OPTIMIZATION_GOAL_APP_INSTALLS,
  OPTIMIZATION_GOAL_CPM,
  OPTIMIZATION_GOAL_CLICK_TO_APP,
  OPTIMIZATION_GOAL_CONVERSION_IN_APP,
  PUBLISHING_ALERT_SUCCESS_TITLE,
  PUBLISHING_ALERT_ERROR_TITLE,
  PUBLISHING_ALERT_TITLE,
  PUBLISHING_ALERT_RETRY_BUTTON,
  HIDE_ALERTS,
  SHOW_ALERTS,
  ACTIVITY,
  NO_TASKS,
  NO_TASKS_DESCRIPTION,
  GLOBAL_ALERTS_PANEL_TITLE,
  GLOBAL_ALERTS_EMPTY,
  GLOBAL_ALERTS_EMPTY_DESCRIPTION,
  GLOBAL_ALERTS_BELL_ARIA,
  TITLES_META,
  GENERATING_CAMPAIGN,
  CAMPAIGN_GENERATED_SUCCESS,
  CAMPAIGN_GENERATED_ERROR,
  CAMPAIGN_GENERATED_ERROR_DESCRIPTION,
  TOTAL_ROAS_GOOGLE,
  TOTAL_ROAS_TIK_TOK,
  TOTAL_ROAS_META,
  ADS_CAMPAIGN_BUYING_TYPE_RESERVED,
  ADS_CAMPAIGN_BUYING_TYPE_AUCTION,
  BUYING_TYPE_PLACEHOLDER,
  CHANGE_BUYING_TYPE_TO_RESERVED_TITLE,
  CHANGE_BUYING_TYPE_TO_RESERVED_DESCRIPTION,
  ESTIMATED_AUDIENCE_SIZE,
  REACH_AT_TARGET_FREQUENCY,
  AUDIENCE_SIZE,
  POTENTIAL_REACH,
  ESTIMATED_DAILY_RESULTS,
  AUDIENCE_ESTIMATES,
  TIMES_EVERY,
  FREQUENCY_CAP_EXPLANATION,
  FREQUENCY_SPECS_CONTROL_PLACEHOLDER,
  FREQUENCY_SPECS_CAP_EXPLANATION,
  FREQUENCY_SPECS_CAP_DESCRIPTION,
  BUTTON_DISCARD,
  BUTTON_VIEW,
  SEARCH_SPECIFIC_LOCATION_PLACEHOLDER,
  SEARCH_SPECIFIC_LOCATION_EXAMPLE,
  CREATE_ADS_CAMPAIGN_APP_PROMOTION_QUESTION,
  ADS_CAMPAIGN_APP_PROMOTION_ANDROID,
  ADS_CAMPAIGN_APP_PROMOTION_IOS,
  ADS_CAMPAIGN_APP_PROMOTION_BOTH,
  SYNCING_INFORMATION_NO_EDIT_CLARIFICATION,
  WAIT_FOR_CAMPAIGN_SYNC,
  INSIGHT_DISCARDED,
  BUTTON_DISCARD_OPTIMIZATIONS_DESCRIPTION,
  BUTTON_GO_TO_BILLING,
  BRAND_GUIDELINES_ENABLED_CLARIFICATION,
  MODAL_BRAND_SETUP_TITLE,
  MODAL_BRAND_SETUP_DESCRIPTION,
  METRICS,
  BUTTON_WHY_THIS_RECOMMENDATION,
  ADS_CAMPAIGNS_LOGS_CONTEXT_TITLE,
  BUTTON_REVERT_CHANGE,
  REVERT_CHANGE_CONFIRM_TITLE,
  REVERT_CHANGE_CONFIRM_TEXT,
  REVERT_CHANGE_SUCCESS,
  REVERT_CHANGE_ERROR,
  ENGLISH_US,
  ENGLISH_UK,
  SPANISH_SPAIN,
  PORTUGUESE_BRAZIL,
  PORTUGUESE_PORTUGAL,
  FRENCH_FRANCE,
  FRENCH_CANADA,
  TRADITIONAL_CHINESE_HONG_KONG,
  TRADITIONAL_CHINESE_TAIWAN,
  JAPANESE_KANSAI,
  NORWEGIAN_BOKMAL,
  NORWEGIAN_NYNORSK,
  CATALAN,
  CZECH,
  WELSH,
  BASQUE,
  FINNISH,
  GALICIAN,
  HUNGARIAN,
  ITALIAN,
  DUTCH,
  FRISIAN,
  POLISH,
  ROMANIAN,
  SLOVENIAN,
  SWEDISH,
  FLEMISH,
  ESPERANTO,
  ESTONIAN,
  FAROESE,
  GREEK,
  ICELANDIC,
  IRISH,
  LATVIAN,
  LITHUANIAN,
  MACEDONIAN,
  THAI,
  VIETNAMESE,
  KHMER,
  FILIPINO,
  MALAY,
  GUJARATI,
  KANNADA,
  TAMIL,
  TELUGU,
  MALAYALAM,
  URDU,
  HEBREW,
  PERSIAN,
  NORTHERN_KURDISH_KURMANJI,
  ARMENIAN,
  AZERBAIJANI,
  BELARUSIAN,
  BOSNIAN,
  GEORGIAN,
  KAZAKH,
  MONGOLIAN,
  SERBIAN,
  TAJIK,
  UZBEK,
  AFRIKAANS,
  SWAHILI,
  ALBANIAN,
  CEBUANO,
  GUARANI,
  MARATHI,
  NEPALI,
  PASHTO,
  SINHALA,
  CHINESE,
  LANGUAGES_PLACEHOLDER,
  ASSAMESE,
  HARYANAVI,
  BIHARI,
  ORIYA,
  RAJASTHANI,
  NORWEGIAN,
  ALERT_CHANGE_ADVERTISER_TITLE,
  CHAT_QUESTION_1,
  CHAT_QUESTION_2,
  CHAT_QUESTION_3,
  CHAT_QUESTION_4,
  CHAT_QUESTION_5,
  CHAT_QUESTION_6,
  CHAT_QUESTION_7,
  CHAT_QUESTION_8,
  CHAT_QUESTION_9,
  TARGET,
  TARGET_FREQUENCY_EXPLANATION,
  CAP,
  CAP_FREQUENCY_EXPLANATION,
  FREQUENCY_TARGET_EXPLANATION,
  FIELD_ESTIMATION_ID_REQUIRED,
  RESERVATION_ESTIMATES,
  FIELD_ESTIMATION_BUDGET_REQUIRED,
  FIELD_ESTIMATION_START_END_DATE_REQUIRED,
  FIELD_ESTIMATION_FREQUENCY_REQUIRED,
  FIELD_ESTIMATION_LOCATION_REQUIRED,
  RESERVATION_STATUS_1,
  RESERVATION_STATUS_2,
  RESERVATION_STATUS_3,
  RESERVATION_STATUS_4,
  RESERVATION_STATUS_5,
  RESERVATION_STATUS_6,
  RESERVATION_STATUS_7,
  RESERVATION_STATUS_8,
  RESERVATION_STATUS_9,
  RESERVATION_STATUS_10,
  RESERVATION_STATUS_11,
  RESERVATION_STATUS_12,
  RESERVATION_STATUS_13,
  RESERVATION_STATUS_14,
  RESERVATION_STATUS_15,
  RESERVATION_STATUS_16,
  RESERVATION_STATUS_17,
  RESERVATION_STATUS_18,
  RESERVATION_STATUS_19,
  RESERVATION_STATUS_20,
  RESERVATION_STATUS_21,
  RESERVATION_STATUS_23,
  RESERVATION_STATUS_24,
  RESERVATION_STATUS_25,
  RESERVATION_STATUS_26,
  RESERVATION_STATUS_27,
  RESERVATION_STATUS_28,
  RESERVATION_STATUS_29,
  RESERVATION_STATUS_30,
  RESERVATION_STATUS_31,
  RESERVATION_STATUS_32,
  RESERVATION_STATUS_35,
  RESERVATION_STATUS_36,
  RESERVATION_STATUS_37,
  RESERVATION_STATUS_39,
  RESERVATION_STATUS_40,
  RESERVATION_STATUS_41,
  RESERVATION_STATUS_42,
  RESERVATION_STATUS_44,
  RESERVATION_STATUS_45,
  RESERVATION_STATUS_50,
  RESERVATION_STATUS_53,
  RESERVATION_STATUS_60,
  RESERVATION_STATUS_66,
  RESERVATION_STATUS_69,
  RESERVATION_STATUS_100,
  FREQUENCY_CONTROL_PLACEHOLDER,
  LOADING_LOCATIONS_IN_MAP,
  EXPORTING_LOCATIONS_TO_FORM,
  SUGGESTED_LOCATIONS_TITLE,
  LOADING_SUGGESTED_LOCATIONS,
  SUGGESTED_LOCATIONS_COUNT,
  ADD_ALL_LOCATIONS,
  ESTIMATED_DAILY_REACH,
  AVERAGE_AUDIENCE_SIZE,
  NO_ESTIMATION_AVAILABLE,
  CHAT_SUMMARY_OVERVIEW_TEXT,
  ADS_CAMPAIGN_STATISTICS_SLIDE_MENU_STATISTICS,
  REPORT_DATE_GENERATED,
  REPORT_GENERATED_BY_BUZZLY_AI,
  AI_GENERATED_SECTION_CHIP,
  AI_GENERATED_SECTION_CHIP_ARIA,
  DOWNLOADING_PDF,
  PDF_DOWNLOADED_SUCCESSFULLY,
  OPTIMIZATION,
  BUTTON_DOWNLOAD_PDF,
  OVERVIEW_REPORT_GENERATING_SUMMARY,
  OVERVIEW_REPORT_SUMMARY_NOT_GENERATED,
  MONTH_SHORT,
  FILTER_BY_USERS_PLACEHOLDER,
  FILTER_BY_DATES_PLACEHOLDER,
  BUTTON_CLEAR_DATES,
  ALL_USERS,
  ALL_TIME,
  ERROR_CAMPAIGN_NOT_FOUND_TO_DUPLICATE,
  APPLY_OPTIMIZATIONS_WITH_NAME,
  BUTTON_OPTIMIZATION_APPLIED,
  MODAL_WELCOME_TITLE,
  MODAL_WELCOME_SUBTITLE,
  MODAL_WELCOME_PLAN_NAME,
  MODAL_WELCOME_BUTTON,
  VALUE_SUBSCRIPTION_3_DAYS_FREE,
  FIRST_USER_MESSAGE_BRAND_SETUP,
  CONNECTING_TO_PLATFORM,
  MODAL_CANCEL_SUBSCRIPTION_TITLE,
  MODAL_CANCEL_SUBSCRIPTION_SUBTITLE,
  MODAL_CANCEL_SUBSCRIPTION_SUBTITLE_WARNING,
  MODAL_CANCEL_SUBSCRIPTION_CONFIRM_BUTTON,
  MODAL_CANCEL_SUBSCRIPTION_REASON_TITLE,
  MODAL_CANCEL_SUBSCRIPTION_REASON_PLACEHOLDER,
  MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT,
  MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT_MIN_CHARS,
  MODAL_CANCEL_SUBSCRIPTION_WARNING_MESSAGE,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_LIMITED_OFFER,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_TITLE,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_INTRO,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_CAMPAIGNS,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_GALLERY,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_DATA,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_API_CONNECTIONS,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_INTRO,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_DOWNLOAD_GALLERY,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_EXPORT_REPORTS,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_DUPLICATE_CAMPAIGNS,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_NO_RECOVERY,
  MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_CONFIRM_PROMPT,
  MODAL_CANCEL_SUBSCRIPTION_CONFIRM_WORD,
  BUTTON_KEEP_MY_ACCOUNT,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_INTRO,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_PRICING_FROM_DATE,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_PRICING_NO_DATE,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_IMMEDIATE_CREDITS,
  MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_TAKE_OFFER_BUTTON,
  MODAL_CANCEL_SUBSCRIPTION_RETENTION_OFFER_REDEEMED_SUCCESS,
  BUTTON_CANCEL_PLAN_AND_DELETE_CAMPAIGNS,
  CANCELLATION_REASON_SELECT_LABEL,
  CANCELLATION_REASON_TOO_EXPENSIVE,
  CANCELLATION_REASON_NOT_FREQUENT_USE,
  CANCELLATION_REASON_BETTER_ALTERNATIVE,
  CANCELLATION_REASON_TECHNICAL_ISSUES,
  CANCELLATION_REASON_NOT_MEET_NEEDS,
  CANCELLATION_REASON_DIFFICULT_TO_USE,
  CANCELLATION_REASON_SITUATION_CHANGED,
  CANCELLATION_REASON_TEMPORARY_NEED,
  CANCELLATION_REASON_SECURITY_CONCERNS,
  CANCELLATION_REASON_OTHER,
  CREATE_ADS_CAMPAIGN_TARGET_CPA_QUESTION,
  BUTTON_NEW_CAMPAIGN,
  FILTERS_GALLERY_IMAGE,
  FILTERS_GALLERY_VIDEO,
  FILTERS_GALLERY_HORIZONTAL,
  FILTERS_GALLERY_VERTICAL,
  FILTERS_GALLERY_SQUARE,
  FILTERS_GALLERY_TODAY,
  FILTERS_GALLERY_WEEK,
  FILTERS_GALLERY_MONTH,
  FILTERS_GALLERY_YEAR,
  FILTERS_GALLERY_RESET_FILTERS,
  FILTERS_GALLERY_RESULTS_COUNTER,
  GALLERY_SOURCE_MY_CONTENT,
  GALLERY_SOURCE_GOOGLE,
  GALLERY_SOURCE_AD_ACCOUNT,
  GALLERY_SOURCE_AD_ACCOUNT_EMPTY,
  GALLERY_SOURCE_GOOGLE_DRIVE,
  GALLERY_SOURCE_SOCIAL_POSTS,
  GALLERY_SOCIAL_POSTS_DESCRIPTION,
  GALLERY_VIDEO_THUMBNAIL_FALLBACK_TOOLTIP,
  GALLERY_SELECT_SOURCE,
  GALLERY_ASSETS_TITLE,
  GALLERY_ASSETS_RENAME_TITLE,
  GALLERY_ASSETS_RENAME_SUCCESS,
  GALLERY_ASSETS_RENAME_ERROR,
  GALLERY_ASSETS_RENAME_ARIA_LABEL,
  GALLERY_ASSETS_NAME_LABEL,
  GALLERY_UPLOADING_ASSETS,
  GALLERY_GOOGLE_NOT_CONNECTED,
  GALLERY_META_NOT_CONNECTED,
  GALLERY_CONTENT_TYPE,
  GALLERY_DIMENSIONS,
  GALLERY_DATE_RANGE,
  GALLERY_TITLE_DIMENSIONS,
  FIELD_SEARCH_THEMES_MAX_WORDS,
  BUDGET_CAMPAIGN_DATES_PLACEHOLDER,
  CAROUSEL_IMAGES_MANAGER_TITLE,
  CAROUSEL_IMAGES_MANAGER_DELETE_ALL,
  CAROUSEL_IMAGES_MANAGER_NO_IMAGES,
  CAROUSEL_IMAGES_MANAGER_ADD_IMAGE,
  CAROUSEL_IMAGES_MANAGER_DIMENSIONS_HELP,
  FIELD_MUSIC_URL_REQUIRED_AD_PREVIEW,
  MAP_TRADUCCIONES_STATUS,
  MAP_TRADUCCIONES_PLATFORM,
  MAP_TRADUCCIONES_TITLES,
  MAP_TRADUCCIONES_CTA,
  MAP_TRADUCCIONES_CTAS,
  MAP_TRADUCCIONES_CTA_ID,
  MAP_TRADUCCIONES_CALL_TO_ACTION,
  MAP_TRADUCCIONES_CALL_TO_ACTIONS,
  MAP_TRADUCCIONES_CALL_TO_ACTION_ID,
  CAMPAIGN_SYNCING_STATUS,
  MAP_TRADUCCIONES_MEDIA_URLS,
  MAP_TRADUCCIONES_MEDIA_DATA,
  MAP_TRADUCCIONES_MUSIC_URL,
  MAP_TRADUCCIONES_IS_CAROUSEL,
  MAP_TRADUCCIONES_OBJECTIVE,
  MAP_TRADUCCIONES_INTEGRATION_ID,
  MAP_TRADUCCIONES_AD_ACCOUNT_ID,
  MAP_TRADUCCIONES_PAGE_ID,
  MAP_TRADUCCIONES_INSTAGRAM_ID,
  MAP_TRADUCCIONES_USE_CAMPAIGN_BUDGET,
  MAP_TRADUCCIONES_TYPE_BUDGET,
  MAP_TRADUCCIONES_BUDGET,
  MAP_TRADUCCIONES_IS_CATALOG_CAMPAIGN,
  MAP_TRADUCCIONES_WHATSAPP_BUSINESS_NUMBER,
  MAP_TRADUCCIONES_MESSAGE_TEMPLATE,
  MAP_TRADUCCIONES_INSTANT_FORM,
  MAP_TRADUCCIONES_TRACKING_ID,
  MAP_TRADUCCIONES_TRACKING_CUSTOM_EVENT_ID,
  MAP_TRADUCCIONES_CATALOG_ID,
  MAP_TRADUCCIONES_IS_IOS14_CAMPAIGN,
  MAP_TRADUCCIONES_APP_ID,
  MAP_TRADUCCIONES_BUYING_TYPE,
  MAP_TRADUCCIONES_DESCRIPTIONS,
  MAP_TRADUCCIONES_ADS,
  MAP_TRADUCCIONES_KEYWORDS,
  MAP_TRADUCCIONES_KEYWORDS_NEGATIVE,
  MAP_TRADUCCIONES_START_DATE,
  MAP_TRADUCCIONES_END_DATE,
  MAP_TRADUCCIONES_AGE_RANGE,
  MAP_TRADUCCIONES_GENDERS,
  MAP_TRADUCCIONES_LOCATIONS,
  MAP_TRADUCCIONES_INTERESTS,
  MAP_TRADUCCIONES_BEHAVIORS,
  MAP_TRADUCCIONES_CUSTOM_AUDIENCES,
  MAP_TRADUCCIONES_EXCLUDED_CUSTOM_AUDIENCES,
  MAP_TRADUCCIONES_BID_GOAL,
  MAP_TRADUCCIONES_OPTIMIZATION_GOAL,
  MAP_TRADUCCIONES_IDENTITY_TIKTOK_ID,
  MAP_TRADUCCIONES_TYPE,
  MAP_TRADUCCIONES_ID,
  MAP_TRADUCCIONES_DESTINATION_URL,
  MAP_TRADUCCIONES_BUSINESS_NAME,
  MAP_TRADUCCIONES_LOGO_URLS,
  MAP_TRADUCCIONES_IMAGE_URLS,
  MAP_TRADUCCIONES_VIDEO_URLS,
  MAP_TRADUCCIONES_LONG_HEADLINES,
  MAP_TRADUCCIONES_SEARCH_THEMES,
  MAP_STATUS_ACTIVE,
  MAP_STATUS_DEACTIVATED,
  BUTTON_OPTIMIZE_CAMPAIGN,
  BUTTON_OPTIMIZE_CAMPAIGN_MESSAGE,
  START_DATE_AND_END_DATE_VALIDATION,
  ADD_CHANGES,
  UPDATE_CHANGES,
  REMOVE_CHANGES,
  BUTTON_DISCONNECT_ACCOUNT,
  DISCONNECTED_ACCOUNT,
  CAMPAIGN_ALREADY_BEING_CREATED,
  CAMPAIGN_ALREADY_BEING_UPDATED,
  GALLERY_SOURCE_CANVA,
  IMAGE_TYPE_PORTRAIT_LABEL,
  IMAGE_TYPE_LANDSCAPE_LABEL,
  IMAGE_TYPE_SQUARE_LABEL,
  ALERT_SHARE_INSTAGRAM_ERROR,
  ALERT_SHARE_SUCCESS,
  ALERT_SHARE_SCHEDULED_SUCCESS,
  BUTTON_SHARE_MEDIA,
  BUTTON_SHARE_LOADING,
  BUTTON_SCHEDULE_MEDIA,
  BUTTON_SCHEDULING_MEDIA,
  BUTTON_PUBLISH_NOW,
  SCHEDULE_DATE_MIN_FUTURE_ERROR,
  SUGGESTED_PUBLISH_SCHEDULE_LOADING,
  DESCRIPTION_INSTAGRAM_LABEL,
  TYPE_CONTENT_INSTAGRAM_LABEL,
  INSTAGRAM_COLLABORATORS_LABEL,
  INSTAGRAM_COLLABORATORS_PLACEHOLDER,
  INSTAGRAM_COLLABORATORS_HELPER,
  IMAGE_NO_CONTENT_TO_SHOW,
  NO_SUPPORTED_FILE,
  MODAL_SHARE_TITLE,
  MODAL_SHARE_SELECT_PLATFORMS_TITLE,
  MODAL_CANVA_IMAGE_CONFIG_CONTENT_TYPE_LABEL,
  VIDEO,
  IMAGE,
  MODAL_CANVA_IS_GETTING_YOUR_FINAL_DESIGN,
  MODAL_CREATE_WITH_IA_TITLE,
  MODAL_CREATE_WITH_IA_SUBTITLE,
  MODAL_CREATE_WITH_IA_GENERATED_CREATIVES,
  BUTTON_CREATE_WITH_IA,
  MODAL_CREATE_WITH_IA_ADD_URL,
  MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_EMPTY,
  MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_SUBTITLE,
  MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_TOGGLE_ARIA,
  MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_PREVIEW_ARIA,
  MODAL_CREATE_WITH_IA_EXTRACT_URL,
  MODAL_CREATE_WITH_IA_IMPORT_PHOTOS_URL_HINT,
  MODAL_CREATE_WITH_IA_DESCRIPTION,
  MODAL_CREATE_WITH_IA_UPLOAD_IMAGE,
  MODAL_CREATE_WITH_IA_EMPTY_STATE_TITLE,
  MODAL_CREATE_WITH_IA_EMPTY_STATE_SUBTITLE,
  MODAL_IMAGE_EDIT_EMPTY_STATE_TITLE,
  MODAL_IMAGE_EDIT_EMPTY_STATE_DESCRIPTION,
  MODAL_IMAGE_EDIT_TITLE,
  MODAL_IMAGE_EDIT_SUBTITLE,
  MODAL_IMAGE_EDIT_PROCESSING_MESSAGE,
  MODAL_IMAGE_EDIT_ERROR_CONVERT_BASE64,
  MODAL_IMAGE_EDIT_ERROR_EDITING,
  MODAL_IMAGE_EDIT_ERROR_PROCESSING,
  MODAL_IMAGE_EDIT_INPUT_PLACEHOLDER,
  MODAL_IMAGE_EDIT_EDITING_LABEL,
  MODAL_IMAGE_EDIT_LOADING_LABEL,
  MODAL_IMAGE_EDIT_IMAGE_NOT_FOUND,
  MODAL_IMAGE_EDIT_START_CREATING,
  MODAL_IMAGE_EDIT_IMAGE_ALT,
  MODAL_IMAGE_EDIT_VERSION_FORMAT,
  MODAL_IMAGE_EDIT_ORIGINAL_IMAGE_LABEL,
  MODAL_IMAGE_EDIT_EDITED_IMAGE_LABEL,
  MODAL_IMAGE_EDIT_SAVE_ALERT_TITLE,
  MODAL_IMAGE_EDIT_SAVE_ALERT_DESCRIPTION,
  MODAL_IMAGE_EDIT_REPLACE_BUTTON,
  MODAL_VIDEO_EDITOR_TITLE,
  MODAL_VIDEO_EDITOR_EDIT_VIDEO,
  MODAL_VIDEO_EDITOR_ADD_VIDEO,
  MODAL_VIDEO_EDITOR_ADD_IMAGE,
  MODAL_VIDEO_EDITOR_ADD_AUDIO,
  MODAL_VIDEO_EDITOR_ADD_SUBTITLES,
  MODAL_VIDEO_EDITOR_EXPORTING,
  MODAL_VIDEO_EDITOR_SAVE_ERROR,
  MODAL_VIDEO_EDITOR_SPLIT_HINT,
  MODAL_VIDEO_EDITOR_ARIA_LABEL,
  MODAL_VIDEO_EDITOR_TRACK_VIDEO,
  MODAL_VIDEO_EDITOR_TRACK_IMAGE,
  MODAL_VIDEO_EDITOR_TRACK_AUDIO,
  MODAL_VIDEO_EDITOR_CLIP_DURATION,
  MODAL_VIDEO_EDITOR_SPLIT_CLIP,
  MODAL_VIDEO_EDITOR_CLIP_ACTIONS,
  MODAL_VIDEO_EDITOR_BRAND,
  MODAL_VIDEO_EDITOR_EMPTY_STAGE_TITLE,
  MODAL_VIDEO_EDITOR_EMPTY_STAGE_HINT,
  MODAL_VIDEO_EDITOR_DROP_HINT,
  MODAL_VIDEO_EDITOR_PLAY,
  MODAL_VIDEO_EDITOR_PAUSE,
  MODAL_VIDEO_EDITOR_DEFAULT_PROJECT_NAME,
  MODAL_VIDEO_EDITOR_TIMELINE_ARIA,
  MODAL_VIDEO_EDITOR_TIMELINE_RESIZE,
  MODAL_VIDEO_EDITOR_INSERT_START,
  MODAL_VIDEO_EDITOR_INSERT_END,
  MODAL_VIDEO_EDITOR_ANALYZING_SUBTITLES,
  MODAL_VIDEO_EDITOR_TRACK_SUBTITLE,
  MODAL_VIDEO_EDITOR_CAPTIONS_ARIA,
  MODAL_VIDEO_EDITOR_CAPTIONS_DISABLE,
  MODAL_VIDEO_EDITOR_CAPTIONS_ENABLE,
  MODAL_VIDEO_EDITOR_SAVE_ALERT_TITLE,
  MODAL_VIDEO_EDITOR_SAVE_ALERT_DESCRIPTION,
  MODAL_VIDEO_EDITOR_ANALYZE_SUBTITLES_ERROR,
  MODAL_VIDEO_EDITOR_PROPERTIES_TITLE,
  MODAL_VIDEO_EDITOR_PROPERTIES_EMPTY,
  MODAL_VIDEO_EDITOR_PROPERTIES_NAME,
  MODAL_VIDEO_EDITOR_PROPERTIES_VOLUME,
  MODAL_VIDEO_EDITOR_PROPERTIES_MIXED,
  MODAL_VIDEO_EDITOR_PROPERTIES_SELECTED_COUNT,
  MODAL_VIDEO_EDITOR_PROPERTIES_POSITION,
  MODAL_VIDEO_EDITOR_PROPERTIES_SIZE,
  MODAL_VIDEO_EDITOR_PROPERTIES_X,
  MODAL_VIDEO_EDITOR_PROPERTIES_Y,
  MODAL_VIDEO_EDITOR_PROPERTIES_WIDTH,
  MODAL_VIDEO_EDITOR_PROPERTIES_HEIGHT,
  MODAL_IMAGE_EDIT_SAVE_AS_NEW_BUTTON,
  MODAL_IMAGE_EDIT_WORK_MODE_LABEL,
  MODAL_IMAGE_EDIT_GENERATIVE_TITLE,
  MODAL_IMAGE_EDIT_GENERATIVE_DESCRIPTION,
  MODAL_IMAGE_EDIT_LAYERS_TITLE,
  MODAL_IMAGE_EDIT_LAYERS_DESCRIPTION,
  MODAL_IMAGE_EDIT_LAYERS_BADGE_NEW,
  MODAL_IMAGE_EDIT_LAYERS_EMPTY_TITLE,
  MODAL_IMAGE_EDIT_LAYERS_EMPTY_DESCRIPTION,
  MODAL_IMAGE_EDIT_LAYERS_ERROR_TITLE,
  MODAL_IMAGE_EDIT_LAYERS_ERROR_DESCRIPTION,
  MODAL_IMAGE_EDIT_LAYERS_ADD,
  MODAL_IMAGE_EDIT_LAYERS_LIST_TITLE,
  MODAL_IMAGE_EDIT_LAYERS_TYPE_IMAGE,
  MODAL_IMAGE_EDIT_LAYERS_TYPE_OBJECT,
  MODAL_IMAGE_EDIT_LAYERS_TYPE_TEXT,
  MODAL_IMAGE_EDIT_LAYERS_TYPE_LOGO,
  MODAL_IMAGE_EDIT_LAYERS_BACKGROUND,
  MODAL_IMAGE_EDIT_LAYERS_FALLBACK_NAME,
  MODAL_IMAGE_EDIT_LAYERS_ANALYZING,
  MODAL_IMAGE_EDIT_AI_LOSES_LAYERS_TITLE,
  MODAL_IMAGE_EDIT_AI_LOSES_LAYERS_DESCRIPTION,
  MODAL_IMAGE_EDIT_CLOSE_TITLE,
  MODAL_IMAGE_EDIT_CLOSE_DESCRIPTION,
  ANALYZE_LAYERS_EDIT_TEXT_TITLE,
  ANALYZE_LAYERS_EDIT_TEXT_DESCRIPTION,
  ANALYZE_LAYERS_EXTRACT_TEXT_ENABLE_BUTTON,
  ANALYZE_LAYERS_EXTRACT_TEXT_DISABLE_BUTTON,
  MODAL_CREATE_WITH_IA_MEDIA_TYPE_IMAGE,
  MODAL_CREATE_WITH_IA_MEDIA_TYPE_VIDEO,
  MODAL_CREATE_WITH_IA_MEDIA_TYPE_VIDEO_BETA,
  MODAL_CREATE_WITH_IA_MEDIA_TYPE_CAROUSEL,
  MODAL_CREATE_WITH_IA_IMAGE_TYPE_REALISTA,
  MODAL_CREATE_WITH_IA_IMAGE_TYPE_PRODUCTO,
  MODAL_CREATE_WITH_IA_LANGUAGE_ES,
  MODAL_CREATE_WITH_IA_LANGUAGE_EN,
  MODAL_CREATE_WITH_IA_LANGUAGE_FR,
  MODAL_CREATE_WITH_IA_LANGUAGE_DE,
  MODAL_CREATE_WITH_IA_LANGUAGE_IT,
  MODAL_CREATE_WITH_IA_DIMENSION_SQUARE,
  MODAL_CREATE_WITH_IA_DIMENSION_HORIZONTAL,
  MODAL_CREATE_WITH_IA_DIMENSION_VERTICAL,
  MODAL_CREATE_WITH_IA_LABEL_MEDIA_TYPE,
  MODAL_CREATE_WITH_IA_LABEL_IMAGE_TYPE,
  MODAL_CREATE_WITH_IA_LABEL_LANGUAGE,
  MODAL_CREATE_WITH_IA_LABEL_ACCENT,
  MODAL_CREATE_WITH_IA_LABEL_LOCATION,
  MODAL_CREATE_WITH_IA_LABEL_DIMENSIONS,
  MODAL_CREATE_WITH_IA_LABEL_PLATFORM,
  MODAL_CREATE_WITH_IA_PLATFORM_DEFAULT,
  MODAL_CREATE_WITH_IA_LABEL_CAROUSEL,
  MODAL_CREATE_WITH_IA_LABEL_NUMBER_OF_IMAGES,
  MODAL_CREATE_WITH_IA_PLACEHOLDER_NUMBER_OF_IMAGES,
  MODAL_CREATE_WITH_IA_PLATFORM_META,
  MODAL_CREATE_WITH_IA_PLATFORM_TIKTOK,
  MODAL_CREATE_WITH_IA_PLATFORM_GOOGLE,
  MODAL_CREATE_WITH_IA_PLACEHOLDER_DESCRIPTION,
  MODAL_CREATE_WITH_IA_PLACEHOLDER_DESCRIPTION_VIDEO,
  MODAL_CREATE_WITH_IA_PLACEHOLDER_IMAGE_URL,
  MODAL_CREATE_WITH_IA_PLACEHOLDER_WEBSITE_URL,
  MODAL_CREATE_WITH_IA_WARNING_REFERENCE_IMAGE,
  MODAL_CREATE_WITH_IA_URLS_ADDED,
  MODAL_CREATE_WITH_IA_IMAGES_COUNT,
  MODAL_CREATE_WITH_IA_SERVICE_IMAGES_COUNT,
  MODAL_CREATE_WITH_IA_GENERATING,
  MODAL_CREATE_WITH_IA_GENERATE_WITH_AI,
  MODAL_CREATE_WITH_IA_IMAGES_CREATED,
  MODAL_CREATE_WITH_IA_GENERATING_IMAGES,
  MODAL_CREATE_WITH_IA_YOU_CAN_LEAVE_THE_PAGE,
  MODAL_CREATE_WITH_IA_GENERATIONS_IN_PROGRESS,
  MODAL_CREATE_WITH_IA_GENERATION_FAILED,
  MODAL_CREATE_WITH_IA_MAX_CONCURRENT_GENERATIONS,
  MODAL_CREATE_WITH_IA_ERROR_LOADING_IMAGE,
  MODAL_CREATE_WITH_IA_GENERATED_IMAGE_ALT,
  MODAL_CREATE_WITH_IA_SAVE_TO_GALLERY,
  MODAL_CREATE_WITH_IA_SAVE_TO_GALLERY_NO_COUNT,
  MODAL_CREATE_WITH_IA_DOWNLOAD_ALL,
  MODAL_CREATE_WITH_IA_MORE_VARIATIONS,
  MODAL_CREATE_WITH_IA_ARIA_LABEL,
  MODAL_CREATE_WITH_IA_CONFIGURATION_BASIC,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE,
  MODAL_CREATE_WITH_IA_REFERENCE_AD_TITLE,
  MODAL_CREATE_WITH_IA_REFERENCE_AD_STYLE_GUIDE_CHIP,
  MODAL_CREATE_WITH_IA_REFERENCE_AD_SOURCE_LOCAL,
  MODAL_CREATE_WITH_IA_REFERENCE_AD_SOURCE_SEARCH,
  MODAL_CREATE_WITH_IA_REFERENCE_IMAGE_ASSETS_CHIP,
  MODAL_CREATE_WITH_IA_REFERENCE_AD_DESCRIPTION,
  MODAL_CREATE_WITH_IA_REFERENCE_VIDEO_FORCES_CUSTOM,
  MODAL_CREATE_WITH_IA_PHYSICAL_NO_REFERENCE_IMAGES_DESCRIPTION,
  MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_REQUIRED_TITLE,
  MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_REQUIRED_DESCRIPTION,
  MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_OPTIONAL_DESCRIPTION,
  MODAL_CREATE_WITH_IA_CONFIGURATION_INSTRUCTIONS,
  MODAL_CREATE_WITH_IA_CONFIGURATION_THEME,
  MODAL_CREATE_WITH_IA_CONFIGURATION_ADVANCED,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_LABEL,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_LABEL_VIDEO,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_HELPER,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NONE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_WHATSAPP,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_IG_STORY,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_APOLOGY,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_NEWS,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_TEXT_POST,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_COMMENT_THREAD,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_REVIEW_CAPTURE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_SEARCH_AUTOCOMPLETE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_CHECKLIST,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_EMAIL_CAPTURE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_TEXT_POST,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_COMMENT_THREAD,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_REVIEW_CAPTURE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_SEARCH_AUTOCOMPLETE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_CHECKLIST,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_EMAIL_CAPTURE,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_LOAD_ERROR,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_RECOMMENDED_RATIO,
  MODAL_CREATE_WITH_IA_AD_TEMPLATE_RECOMMENDED_RATIO_ACTION,
  MODAL_CREATE_WITH_IA_GALLERY_BUTTON,
  MODAL_CREATE_WITH_IA_IMPORT_META_AD_LIBRARY,
  COMPETITOR_SCOPE_MENU_ITEM,
  COMPETITOR_SCOPE_MODAL_TITLE,
  ALERT_COMPETITOR_SCOPE_TITLE,
  ALERT_COMPETITOR_SCOPE_DESCRIPTION,
  ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_TITLE,
  ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_DESCRIPTION,
  BUTTON_CONFIGURE_BRAND,
  BUTTON_CONFIGURE_COMPETITORS,
  MODAL_COMPETITORS_CONFIRM_REFERENCE_TITLE,
  MODAL_COMPETITORS_CONFIRM_REFERENCE_DESCRIPTION,
  MODAL_COMPETITORS_PREPARING_REFERENCE,
  MODAL_COMPETITORS_SHOW_FAVORITES_ONLY,
  MODAL_COMPETITORS_SHOW_ALL_ADS,
  MODAL_COMPETITORS_FAVORITES_EMPTY,
  MODAL_COMPETITORS_SAVED_TO_FAVORITES,
  MODAL_COMPETITORS_SAVED_TO_FOLDER,
  MODAL_COMPETITORS_REMOVED_FROM_FOLDER,
  MODAL_COMPETITORS_SELECT_FOLDER_TITLE,
  MODAL_COMPETITORS_CHANGE_LOCATION,
  MODAL_COMPETITORS_REMOVED_FROM_FAVORITES,
  MODAL_COMPETITORS_ADD_OPTION,
  MODAL_COMPETITORS_EDIT_BUTTON,
  MODAL_COMPETITORS_EDIT_TITLE,
  MODAL_COMPETITORS_EDIT_SUBTITLE,
  MODAL_COMPETITORS_EDIT_COUNT_ARIA,
  MODAL_COMPETITORS_STRONG_SIGNAL,
  MODAL_COMPETITORS_AD_LIBRARY_CTA_LABEL,
  MODAL_CREATE_WITH_IA_META_AD_LIBRARY_LOADING,
  MODAL_GALLERY_META_AD_LIBRARY_EMPTY_CONTENT,
  MODAL_META_AD_LIBRARY_COMPETITOR_FILTER_LABEL,
  MODAL_META_AD_LIBRARY_COMPETITOR_ALL,
  MODAL_META_AD_LIBRARY_PLATFORM_ALL,
  MODAL_META_AD_LIBRARY_DURATION_HOURS,
  MODAL_META_AD_LIBRARY_DURATION_DAYS,
  MODAL_META_AD_LIBRARY_VIEW_ONLY_TOOLTIP,
  MODAL_META_AD_LIBRARY_LOADING_RESOLVING_COMPETITORS,
  MODAL_META_AD_LIBRARY_LOADING_FETCHING_ADS,
  MODAL_META_AD_LIBRARY_LOADING_PREPARING_GALLERY,
  MODAL_CREATE_WITH_IA_CLOSE_CONFIRMATION_TITLE,
  MODAL_CREATE_WITH_IA_CLOSE_CONFIRMATION_TEXT,
  MODAL_CREATE_WITH_IA_SAVING_TO_GALLERY,
  MODAL_CREATE_WITH_IA_SAVED_SUCCESSFULLY,
  MODAL_CREATE_WITH_IA_MAX_IMAGES_MESSAGE,
  BUSINESS_LOOK_AND_FEEL_PLACEHOLDER,
  BUSINESS_OFFERING_PLACEHOLDER,
  BUSINESS_OFFERING_PHYSICAL_PRODUCT_PLACEHOLDER,
  BUSINESS_OFFERING_SERVICES_PLACEHOLDER,
  DESCRIPTION_INSTAGRAM_GENERATING,
  MODAL_FILTERS_LABEL,
  FIELD_CONSECUTIVE_UPPERCASE,
  FIELD_EMOJI_NOT_ALLOWED,
  ADS_CAMPAIGNS_TITLE_DASHBOARD,
  OVERVIEW_HOME_STATISTICS,
  KPI_TARGET_CPA_ABOVE_PLATFORM,
  KPI_TARGET_CPA_ALERTS_TITLE,
  OVERVIEW_HOME_STATISTICS_VIEW_MORE,
  STATISTICS_ONLY_BUZZLY_CAMPAIGNS,
  VIEW_SPEND_BREAKDOWN,
  LIST_TABLE_CAMPAIGNS_TITLE,
  DASHBOARD_METRICS_DELAY_WARNING,
  TRIAL_CONTENT_CTA_MESSAGE,
  TRIAL_CONTENT_CTA_BUTTON_SHARE_INSTAGRAM,
  TRIAL_CONTENT_CTA_BUTTON_SHARE_TIKTOK,
  TRIAL_CONTENT_CTA_BUTTON_MORE_OPTIONS,
  CAMPAIGNS,
  GALLERY_TITLE,
  BUTTON_SELECT_ALL,
  BUTTON_DESELECT_ALL,
  AVERAGE_CTR,
  TRACKING_OFFLINE_EVENTS_PLACEHOLDER,
  ALERT_CAMPAIGN_CPA_HIGH_LABEL,
  ALERT_CAMPAIGN_STARTED_LABEL,
  ALERT_PIXEL_NOT_FIRED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_LABEL,
  ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_GENERATE_CREATIVES,
  BUTTON_CREATE_CONTENT,
  MODAL_REDIRECT_BRAND_SETUP_TITLE,
  MODAL_REDIRECT_BRAND_SETUP_SUBTITLE,
  MODAL_REDIRECT_BRAND_SETUP_BUTTON,
  MODAL_SUCCESS_BRAND_SETUP_TITLE,
  MODAL_SUCCESS_BRAND_SETUP_SUBTITLE,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_CAMPAIGN_TITLE,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_CAMPAIGN_DESCRIPTION,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_ADS_TITLE,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_ADS_DESCRIPTION,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_POST_TITLE,
  MODAL_SUCCESS_BRAND_SETUP_OPTION_CALENDAR_DESCRIPTION,
  MODAL_SUCCESS_BRAND_SETUP_BUTTON_START,
  MODAL_SUCCESS_BRAND_SETUP_BUTTON_LATER,
  ONBOARDING_CHECKLIST_HEADER_TITLE,
  ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_TITLE,
  ONBOARDING_CHECKLIST_ITEM_CREATIVES_TITLE,
  ONBOARDING_CHECKLIST_ITEM_PUBLISH_TITLE,
  ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_TITLE,
  ONBOARDING_CHECKLIST_FOOTER_COMPLETED,
  ONBOARDING_CHECKLIST_SUBTITLE,
  ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_DESCRIPTION,
  ONBOARDING_CHECKLIST_ITEM_CREATIVES_DESCRIPTION,
  ONBOARDING_CHECKLIST_ITEM_PUBLISH_DESCRIPTION,
  ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_DESCRIPTION,
  ONBOARDING_CHECKLIST_PROGRESS_COMPLETED,
  ONBOARDING_CHECKLIST_SKIP_GUIDE,
  ADS_SUBSCRIPTION_BENEFIT_CREATIVES,
  ADS_SUBSCRIPTION_BENEFIT_VIDEOS,
  ADS_SUBSCRIPTION_BENEFIT_CREDITS_PER_MONTH,
  ADS_SUBSCRIPTION_BENEFIT_VIDEOS_AI,
  ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS_UP_TO,
  ADS_SUBSCRIPTION_BENEFIT_USERS_UP_TO,
  ADS_SUBSCRIPTION_BENEFIT_USER,
  ADS_SUBSCRIPTION_BENEFIT_UNLIMITED_SOCIAL_POSTS,
  ADS_SUBSCRIPTION_BENEFIT_SUPPORT_CHAT_AND_EMAIL,
  ADS_SUBSCRIPTION_BENEFIT_WHITE_LABEL_OPTIONAL,
  ADS_SUBSCRIPTION_BENEFIT_CREATIVES_CUSTOM,
  TEXT_IN_IMAGE,
  LOGO_IN_IMAGE,
  LOGO_IN_VIDEO,
  LOGO_IN_VIDEO_DESCRIPTION_LEAD,
  FIELD_MAX_LENGTH_SHORT,
  COLUMN_NAME_ENTITY,
  UNKNOWN_VALUE,
  ADS_SUBSCRIPTION_BENEFIT_CAMPAIGN,
  I_DONT_HAVE_A_WEBSITE,
  SET_UP_BRAND,
  CHAT_BOT_WELCOME_DESCRIPTION,
  CARD_GENERATE_COPY,
  CARD_GENERATE_COPY_DESCRIPTION,
  CARD_GENERATE_COPY_QUESTION,
  CARD_GET_CAMPAIGN_LEARNINGS,
  CARD_GET_CAMPAIGN_LEARNINGS_DESCRIPTION,
  CARD_GET_CAMPAIGN_LEARNINGS_QUESTION,
  CARD_OPTIMIZE_GENERAL,
  CARD_OPTIMIZE_GENERAL_DESCRIPTION,
  CARD_OPTIMIZE_GENERAL_QUESTION,
  CARD_MANAGE_BUDGET,
  CARD_MANAGE_BUDGET_DESCRIPTION,
  CARD_MANAGE_BUDGET_QUESTION,
  CARD_OWNER_CLIENT_HEALTH,
  CARD_OWNER_CLIENT_HEALTH_DESCRIPTION,
  CARD_OWNER_CLIENT_HEALTH_QUESTION,
  CARD_OWNER_INSIGHTS,
  CARD_OWNER_INSIGHTS_DESCRIPTION,
  CARD_OWNER_INSIGHTS_QUESTION,
  CARD_OWNER_ACCOUNTS,
  CARD_OWNER_ACCOUNTS_DESCRIPTION,
  CARD_OWNER_ACCOUNTS_QUESTION,
  CARD_OWNER_BILLING,
  CARD_OWNER_BILLING_DESCRIPTION,
  CARD_OWNER_BILLING_QUESTION,
  CARD_OWNER_SUPPORT,
  CARD_OWNER_SUPPORT_DESCRIPTION,
  CARD_OWNER_SUPPORT_QUESTION,
  CARD_OWNER_CLIENTS_ACCOUNTS,
  CARD_OWNER_CLIENTS_ACCOUNTS_DESCRIPTION,
  CARD_OWNER_CLIENTS_ACCOUNTS_QUESTION,
  CARD_OWNER_BRANDS,
  CARD_OWNER_BRANDS_DESCRIPTION,
  CARD_OWNER_BRANDS_QUESTION,
  CARD_OWNER_PLANS_MRR,
  CARD_OWNER_PLANS_MRR_DESCRIPTION,
  CARD_OWNER_PLANS_MRR_QUESTION,
  DATE_RANGE_PRESET_TODAY,
  DATE_RANGE_PRESET_YESTERDAY,
  DATE_RANGE_PRESET_LAST_7,
  DATE_RANGE_PRESET_LAST_14,
  DATE_RANGE_PRESET_LAST_30,
  DATE_RANGE_PRESET_THIS_WEEK,
  DATE_RANGE_PRESET_LAST_WEEK,
  DATE_RANGE_PRESET_THIS_MONTH,
  DATE_RANGE_PRESET_LAST_MONTH,
  DATE_RANGE_PRESET_THIS_YEAR,
  DATE_RANGE_PRESET_LAST_YEAR,
  PRESETS_DATE_PLACEHOLDER,
  LOOK_AND_FEEL_PLACEHOLDER,
  MODAL_INTEGRATION_NOT_FOUND_TITLE,
  MODAL_INTEGRATION_NOT_FOUND_DESCRIPTION,
  MODAL_INTEGRATION_NOT_FOUND_COLUMN_PLATFORM,
  MODAL_INTEGRATION_NOT_FOUND_COLUMN_CAMPAIGN,
  MODAL_INTEGRATION_NOT_FOUND_COLUMN_AD_ACCOUNT,
  MODAL_INTEGRATION_NOT_FOUND_COLUMN_REASON,
  MODAL_INTEGRATION_NOT_FOUND_COLUMN_INTEGRATION,
  MODAL_INTEGRATION_NOT_FOUND_ROW_DISABLED,
  MODAL_INTEGRATION_NOT_FOUND_ROW_LOADING,
  MODAL_INTEGRATION_NOT_FOUND_ROW_ERROR,
  MODAL_INTEGRATION_NOT_FOUND_SELECT_PLACEHOLDER,
  MODAL_INTEGRATION_NOT_FOUND_SAVE,
  DATE_RANGE_PRESET_CUSTOM,
  NPS_FORM_TITLE,
  NPS_LABEL_NOT_LIKELY_AT_ALL,
  NPS_LABEL_EXTREMELY_LIKELY,
  NPS_SAVING_RATING,
  NPS_THANK_YOU_TITLE,
  NPS_THANK_YOU_DESCRIPTION,
  OVERLAPS_WITH,
  MODAL_OVERLAP_CONFLICTS_TITLE,
  MODAL_OVERLAP_CONFLICTS_DESCRIPTION,
  BUTTON_PREVIEW_CHANGES,
  BUTTON_APPLY_CHANGES,
  BUTTON_CHANGES_APPLIED,
  ALERT_ARCHIVE_CAMPAIGN_TITLE_ACTIVE,
  ADS_SUBSCRIPTION_BENEFIT_ADVERTISER,
  TOTAL_ADVERTISERS_COUNT,
  TOTAL_ADVERTISER_COUNT,
  CONFIGURATION_PANEL_TITLE_IMAGE_PHYSICAL_PRODUCT,
  CONFIGURATION_PANEL_SUBTITLE_IMAGE_PHYSICAL_PRODUCT,
  CONFIGURATION_PANEL_ADD_MULTIPLE_PERSPECTIVES_TIP,
  CONFIGURATION_PANEL_WEBSITE_URL_TITLE,
  CONFIGURATION_PANEL_WEBSITE_URL_DESCRIPTION,
  FORMAT_OPTIONS_TOOLTIP,
  EDIT_WITH_CANVA,
  EDIT_WITH_IA,
  ANIMATE_IMAGE_WITH_AI,
  ANIMATE_IMAGE_CONFIRMATION_TITLE,
  ANIMATE_IMAGE_CONFIRMATION_DESCRIPTION,
  MODAL_ANIMATE_IMAGE_PREVIEW_TITLE,
  MODAL_ANIMATE_IMAGE_PROMPT_LABEL,
  MODAL_ANIMATE_IMAGE_PROMPT_PLACEHOLDER,
  MODAL_ANIMATE_IMAGE_PROMPT_HELPER,
  MODAL_ANIMATE_IMAGE_PROMPT_MAX_LENGTH,
  ANIMATE_IMAGE_OUTRO_LABEL,
  ANIMATE_IMAGE_OUTRO_HELPER,
  ANIMATE_IMAGE_OUTRO_NONE,
  ANIMATE_IMAGE_SAVE_OUTRO,
  ANIMATE_IMAGE_SAVE_OUTRO_TITLE,
  ANIMATE_IMAGE_SAVE_OUTRO_SUCCESS,
  ANIMATE_IMAGE_SAVE_OUTRO_ERROR,
  ANIMATE_IMAGE_OUTRO_FILE,
  ANIMATE_IMAGE_OUTRO_FILE_HINT,
  ANIMATE_IMAGE_IMPORT_OUTRO,
  ANIMATE_IMAGE_IMPORT_OUTRO_TITLE,
  ANIMATE_IMAGE_IMPORT_OUTRO_EMPTY,
  ANIMATE_IMAGE_IMPORT_OUTRO_ERROR,
  ANIMATE_IMAGE_DELETE_OUTRO,
  ANIMATE_IMAGE_DELETE_OUTRO_ERROR,
  ANIMATE_IMAGE_OUTRO_CLEAR,
  ANIMATE_IMAGE_OUTRO_TOO_LARGE,
  ANIMATE_IMAGE_OUTRO_TOO_LONG,
  ANIMATE_IMAGE_OUTRO_INVALID_TYPE,
  ANIMATE_IMAGE_USE_SELECTED,
  SELECT_CONTENT_CONFIRMATION_TEXT,
  RESIZE_TO_HORIZONTAL,
  RESIZE_TO_VERTICAL,
  RESIZE_TO_SQUARE,
  RESIZE_TO_FEED,
  RESIZE_MENU_LABEL,
  RESIZING_IMAGES_BATCH_MESSAGE,
  MULTI_FORMAT_RESIZE_FORMATS_COUNT,
  MULTI_FORMAT_RESIZE_CREDITS_COUNT,
  MULTI_FORMAT_RESIZE_ONE_FORMAT,
  MULTI_FORMAT_RESIZE_ONE_CREDIT,
  HORIZONTAL_FORMAT,
  ALERT_RESIZE_IMAGE_FAILED_DESCRIPTION,
  CAMPAIGNS_STATUS_DELETED,
  PAGE_NUMBER,
  ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE_UPDATE,
  ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION_UPDATE,
  MAX_TOTAL_BUDGET_PLACEHOLDER,
  MIN_TOTAL_BUDGET_PLACEHOLDER,
  MAX_DAILY_BUDGET_PLACEHOLDER,
  MIN_DAILY_BUDGET_PLACEHOLDER,
  TABLE_ADMIN_DASHBOARD_CLIENT,
  TABLE_ADMIN_DASHBOARD_RENEW_DATE,
  TABLE_ADMIN_DASHBOARD_RENEW_DATE_VALUE,
  TABLE_ADMIN_DASHBOARD_DISCOVERY_SOURCE,
  TABLE_ADMIN_DASHBOARD_HEALTH_SCORE,
  TABLE_ADMIN_DASHBOARD_CAMPAIGNS,
  TABLE_ADMIN_DASHBOARD_KPI,
  TABLE_ADMIN_DASHBOARD_SPEND,
  TABLE_ADMIN_DASHBOARD_CPA,
  TABLE_ADMIN_DASHBOARD_TARGET_CPA,
  TABLE_ADMIN_DASHBOARD_ROAS,
  TABLE_ADMIN_DASHBOARD_LAST_LOGIN,
  TABLE_ADMIN_DASHBOARD_LOGINS,
  TABLE_ADMIN_DASHBOARD_USERS,
  TABLE_ADMIN_DASHBOARD_AUTOMATION,
  TABLE_ADMIN_DASHBOARD_MRR,
  TABLE_ADMIN_DASHBOARD_PLAN,
  TABLE_ADMIN_DASHBOARD_CREATIVES,
  TABLE_ADMIN_DASHBOARD_INVOICE_OVERDUE,
  TABLE_ADMIN_DASHBOARD_SHOWING_CLIENTS,
  TABLE_ADMIN_DASHBOARD_LOADING_MORE,
  TABLE_ADMIN_CREATIVES_UTILIZED,
  TABLE_ADMIN_CREATIVE_UTILIZED,
  TABLE_ADMIN_DASHBOARD_CAMPAIGNS_ACTIVE,
  TABLE_ADMIN_LAST_LOGIN_DAYS,
  TABLE_ADMIN_DASHBOARD_NPS,
  TABLE_ADMIN_CANCELLATION_REASON_SUBTITLE,
  TABLE_ADMIN_CANCELLATION_REASON_BUTTON,
  TABLE_ADMIN_CANCELLED_BADGE,
  TABLE_ADMIN_ADD_ADVERTISER_BUTTON,
  TABLE_ADMIN_ADD_CREDITS_BUTTON,
  TABLE_ADMIN_ACTIONS_BUTTON,
  TABLE_ADMIN_ACTIVATE_PLAN_BUTTON,
  TABLE_ADMIN_DEACTIVATE_PLAN_BUTTON,
  TABLE_ADMIN_CONFIRM_ACTIVATE_PLAN_TITLE,
  TABLE_ADMIN_CONFIRM_ACTIVATE_PLAN_MESSAGE,
  TABLE_ADMIN_CONFIRM_DEACTIVATE_PLAN_TITLE,
  TABLE_ADMIN_CONFIRM_DEACTIVATE_PLAN_MESSAGE,
  TABLE_ADMIN_MARK_DEMO_BUTTON,
  TABLE_ADMIN_CONFIRM_MARK_DEMO_TITLE,
  TABLE_ADMIN_CONFIRM_MARK_DEMO_MESSAGE,
  TABLE_ADMIN_CREDITS_USAGE,
  TABLE_ADMIN_PENDING_PAYMENT_BADGE,
  TABLE_ADMIN_PRIORITY_BADGE,
  TABLE_ADMIN_SEND_EMAIL_BODY_LABEL,
  TABLE_ADMIN_SEND_EMAIL_BUTTON,
  TABLE_ADMIN_LOGIN_AS_CLIENT_BUTTON,
  OWNER_LOGIN_AS_USER_OPTION,
  OWNER_LOGIN_AS_USER_OPTION_EMAIL,
  OWNER_LOGIN_AS_CONNECTING,
  OWNER_LOGIN_AS_ERROR_TITLE,
  OWNER_LOGIN_AS_ERROR_EXPIRED,
  OWNER_LOGIN_AS_ERROR_INVALID,
  OWNER_LOGIN_AS_ERROR_MISSING_PARAMS,
  OWNER_LOGIN_AS_ERROR_GENERIC,
  OWNER_LOGIN_AS_ERROR_USER_NOT_FOUND,
  OWNER_LOGIN_AS_ERROR_INVALID_EMAIL,
  OWNER_LOGIN_AS_ERROR_FORBIDDEN,
  OWNER_LOGIN_AS_ERROR_UNAUTHORIZED,
  SUPPORT_SESSION_BANNER_TITLE,
  SUPPORT_SESSION_BANNER_DESCRIPTION,
  SUPPORT_SESSION_ENDED_TITLE,
  SUPPORT_SESSION_ENDED_DESCRIPTION,
  TABLE_ADMIN_SEND_EMAIL_MODAL_TITLE,
  TABLE_ADMIN_SEND_EMAIL_RECIPIENTS_LABEL,
  TABLE_ADMIN_SEND_EMAIL_RECIPIENTS_PLACEHOLDER,
  TABLE_ADMIN_SEND_EMAIL_SELECT_ALL,
  TABLE_ADMIN_SEND_EMAIL_SEND_BUTTON,
  TABLE_ADMIN_SEND_EMAIL_SUBJECT_LABEL,
  TABLE_ADMIN_SEND_EMAIL_SUCCESS,
  TABLE_ADMIN_MODIFY_KPI_CPA_BUTTON,
  TABLE_ADMIN_ENABLE_FEATURES_BUTTON,
  TABLE_ADMIN_FEATURE_TYPOGRAPHIC_FIDELITY,
  TABLE_ADMIN_FEATURE_MINIMUM_TERM_CONTRACT,
  TABLE_ADMIN_AI_IMAGE_MODEL_BUTTON,
  TABLE_ADMIN_AI_IMAGE_PROVIDER_GOOGLE,
  TABLE_ADMIN_AI_IMAGE_PROVIDER_OPENAI,
  TABLE_ADMIN_AI_IMAGE_PROVIDER_SEEDREAM,
  MODAL_MODIFY_KPI_CPA_TITLE,
  MODAL_MODIFY_KPI_CPA_PRIMARY_LABEL,
  MODAL_MODIFY_KPI_CPA_TARGET_LABEL,
  MODAL_MODIFY_KPI_CPA_CURRENCY_LABEL,
  MODAL_MODIFY_KPI_CPA_SAVE_SUCCESS,
  MODAL_MODIFY_KPI_CPA_VOLUMEN_LABEL,
  MODAL_CAMPAIGN_KPI_CPA_TITLE,
  MODAL_CAMPAIGN_KPI_CPA_INHERIT_HINT,
  MODAL_CAMPAIGN_KPI_CPA_WEEKLY_VOLUME_LABEL,
  ADMIN_KPI_PRIMARY_LEADS,
  ADMIN_KPI_PRIMARY_SALES,
  ADMIN_KPI_PRIMARY_MESSAGES,
  ADMIN_KPI_PRIMARY_INTERACTIONS,
  ADMIN_KPI_PRIMARY_TRAFFIC,
  ADMIN_KPI_PRIMARY_CONVERSIONS,
  ADMIN_KPI_PRIMARY_DOWNLOADS,
  ADMIN_KPI_PRIMARY_APP_INSTALLS,
  ADMIN_KPI_PRIMARY_VIDEO_VIEWS,
  ADMIN_KPI_PRIMARY_AWARENESS,
  ADMIN_KPI_PRIMARY_REACH,
  ADMIN_KPI_PRIMARY_ENGAGEMENT,
  ADMIN_KPI_PRIMARY_STORE_VISITS,
  ADMIN_KPI_PRIMARY_WEBSITE_CONVERSIONS,
  ADMIN_KPI_PRIMARY_CATALOG_SALES,
  ADMIN_KPI_PRIMARY_SIGNUPS,
  ADMIN_DASHBOARD_TITLE,
  OWNER_DASHBOARD_NAV_FORM,
  OWNER_DASHBOARD_NAV_REPORTED_CONTENT,
  OWNER_DASHBOARD_NAV_PROMOTIONAL_CODES,
  OWNER_DASHBOARD_NAV_GLOBAL_NOTIFICATIONS,
  OWNER_DASHBOARD_NAV_AD_SPEND,
  OWNER_AD_SPEND_TITLE,
  OWNER_AD_SPEND_DESCRIPTION,
  OWNER_AD_SPEND_PRESET_HISTORIC,
  OWNER_AD_SPEND_PRESET_LAST_7,
  OWNER_AD_SPEND_PRESET_LAST_30,
  OWNER_AD_SPEND_PRESET_LAST_90,
  OWNER_AD_SPEND_PRESET_THIS_MONTH,
  OWNER_AD_SPEND_PRESET_LAST_MONTH,
  OWNER_AD_SPEND_PRESET_CUSTOM,
  OWNER_AD_SPEND_CUSTOM_PENDING,
  OWNER_AD_SPEND_ACCURACY_WARNING,
  OWNER_AD_SPEND_ACCURACY_WARNING_ESTIMATED,
  OWNER_AD_SPEND_KPI_TOTAL,
  OWNER_AD_SPEND_KPI_ADVERTISERS,
  OWNER_AD_SPEND_KPI_COUNTRIES,
  OWNER_AD_SPEND_VS_PREVIOUS_PERIOD,
  OWNER_AD_SPEND_CHART_TITLE,
  OWNER_AD_SPEND_CHART_DAILY,
  OWNER_AD_SPEND_CHART_MONTHLY,
  OWNER_AD_SPEND_PLATFORMS_TITLE,
  OWNER_AD_SPEND_TOP_ADVERTISERS_TITLE,
  OWNER_AD_SPEND_TOP_COUNTRIES_TITLE,
  OWNER_AD_SPEND_TOP_ADVERTISERS_ARIA,
  OWNER_AD_SPEND_TOP_COUNTRIES_ARIA,
  OWNER_AD_SPEND_COLUMN_ADVERTISER,
  OWNER_AD_SPEND_COLUMN_COUNTRY,
  OWNER_AD_SPEND_COLUMN_SPEND,
  OWNER_AD_SPEND_COLUMN_SHARE,
  OWNER_AD_SPEND_COLUMN_PLATFORMS,
  OWNER_AD_SPEND_UNASSIGNED_COUNTRY,
  OWNER_AD_SPEND_TREND_NEW,
  OWNER_AD_SPEND_ESTIMATED_BADGE,
  OWNER_AD_SPEND_EMPTY_TITLE,
  OWNER_AD_SPEND_EMPTY_DESCRIPTION,
  OWNER_AD_SPEND_MOCK_BADGE,
  OWNER_DASHBOARD_NAV_CREATE_USER,
  OWNER_DASHBOARD_NAV_OPTIONS,
  OWNER_GLOBAL_NOTIFICATIONS_TITLE,
  OWNER_GLOBAL_NOTIFICATIONS_FIELD_TITLE,
  OWNER_GLOBAL_NOTIFICATIONS_FIELD_BODY,
  OWNER_GLOBAL_NOTIFICATIONS_FIELD_CTA,
  OWNER_GLOBAL_NOTIFICATIONS_FIELD_LINK,
  OWNER_GLOBAL_NOTIFICATIONS_FIELD_LINK_HELPER,
  OWNER_GLOBAL_NOTIFICATIONS_CTA_LINK_PAIR_ERROR,
  OWNER_GLOBAL_NOTIFICATIONS_PUBLISH_BUTTON,
  OWNER_GLOBAL_NOTIFICATIONS_PUBLISH_SUCCESS,
  MODAL_CREATE_OWNER_USER_ARIA_LABEL,
  MODAL_CREATE_OWNER_USER_TITLE,
  MODAL_CREATE_OWNER_USER_DESCRIPTION,
  MODAL_CREATE_OWNER_USER_SUCCESS,
  REGISTER_PROMOTIONAL_CODE_LABEL,
  REGISTER_PROMOTIONAL_CODE_PLACEHOLDER,
  REGISTER_DISCOVERY_SOURCE_LABEL,
  OWNER_PROMOTIONAL_CODES_CREATE_TITLE,
  OWNER_PROMOTIONAL_CODES_CREATE_BUTTON,
  OWNER_PROMOTIONAL_CODES_MODAL_SUBTITLE,
  OWNER_PROMOTIONAL_CODES_GENERATE_CODE_TOOLTIP,
  OWNER_PROMOTIONAL_CODES_FIELD_CODE,
  OWNER_PROMOTIONAL_CODES_FIELD_MAX_REDEMPTIONS,
  OWNER_PROMOTIONAL_CODES_FIELD_APP_SUMO,
  OWNER_PROMOTIONAL_CODES_FIELD_TIER,
  OWNER_PROMOTIONAL_CODES_TIER_OPTION_1,
  OWNER_PROMOTIONAL_CODES_TIER_OPTION_2,
  OWNER_PROMOTIONAL_CODES_TIER_OPTION_3,
  OWNER_PROMOTIONAL_CODES_COLUMN_CODE,
  OWNER_PROMOTIONAL_CODES_COLUMN_CREATED,
  OWNER_PROMOTIONAL_CODES_COLUMN_REGISTERED,
  OWNER_PROMOTIONAL_CODES_COLUMN_MAX_REDEMPTIONS,
  OWNER_PROMOTIONAL_CODES_COLUMN_TYPE,
  OWNER_PROMOTIONAL_CODES_TYPE_VALUE_APP_SUMO,
  OWNER_PROMOTIONAL_CODES_TYPE_APP_SUMO_TIER_SUFFIX,
  OWNER_PROMOTIONAL_CODES_TYPE_VALUE_STANDARD,
  OWNER_PROMOTIONAL_CODES_TYPE_VALUE_STRIPE_DISCOUNT,
  OWNER_PROMOTIONAL_CODES_FIELD_STRIPE_CODE,
  OWNER_PROMOTIONAL_CODES_FIELD_DISCOUNT,
  OWNER_PROMOTIONAL_CODES_FIELD_DISCOUNT_TYPE,
  OWNER_PROMOTIONAL_CODES_DISCOUNT_TYPE_FIXED,
  OWNER_PROMOTIONAL_CODES_DISCOUNT_TYPE_PERCENTAGE,
  OWNER_PROMOTIONAL_CODES_ERROR_INVALID_STRIPE_DISCOUNT,
  PRICING_PROMO_DISCOUNT_APPLIED,
  OWNER_PROMOTIONAL_CODES_COLUMN_STATUS,
  OWNER_PROMOTIONAL_CODES_STATUS_ACTIVE,
  OWNER_PROMOTIONAL_CODES_STATUS_INACTIVE,
  OWNER_PROMOTIONAL_CODES_CREATE_SUCCESS,
  OWNER_PROMOTIONAL_CODES_ERROR_DUPLICATE,
  OWNER_PROMOTIONAL_CODES_ERROR_INVALID,
  PROMOTIONAL_CODE_NOT_FOUND,
  PROMOTIONAL_CODE_INACTIVE,
  PROMOTIONAL_CODE_MAX_REDEMPTIONS_REACHED,
  ADMIN_DASHBOARD_SUBTITLE,
  ADMIN_DASHBOARD_SEARCH_PLACEHOLDER,
  ADMIN_DASHBOARD_FILTER_STATUS_PLACEHOLDER,
  ADMIN_DASHBOARD_HEALTH_SUMMARY_TITLE,
  ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_HEALTHY,
  ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_WATCHLIST,
  ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_AT_RISK,
  CREATE_BRAND_BUTTON,
  ADMIN_DASHBOARD_CREATE_BRAND_BUTTON,
  ANNOTATIONS_SIDEBAR_AGENCY_HEADER,
  ANNOTATIONS_SIDEBAR_ADVERTISER_HEADER,
  ANNOTATIONS_SIDEBAR_EMPTY_TITLE,
  ANNOTATIONS_SIDEBAR_EMPTY_SUBTITLE,
  ANNOTATIONS_SIDEBAR_INPUT_PLACEHOLDER,
  ANNOTATIONS_SIDEBAR_YOU_LABEL,
  ANNOTATIONS_SIDEBAR_LOADING,
  ANNOTATIONS_SIDEBAR_CLOSE,
  ANNOTATIONS_UNREAD_BADGE_ARIA,
  ANNOTATIONS_UNREAD_COUNT,
  ANNOTATIONS_MENTION_ALL,
  ANNOTATIONS_MENTION_MENU_ARIA,
  ANNOTATIONS_MESSAGE_EDIT,
  ANNOTATIONS_MESSAGE_DELETE,
  ANNOTATIONS_MESSAGE_DELETE_CONFIRM,
  ANNOTATIONS_MESSAGE_EDITING,
  ANNOTATIONS_MESSAGE_CANCEL_EDIT,
  ANNOTATIONS_MESSAGE_MENU_ARIA,
  ADMIN_DASHBOARD_CREATE_BRAND_MODAL_TITLE,
  ADMIN_DASHBOARD_CREATE_BRAND_MODAL_SUBTITLE,
  ADMIN_DASHBOARD_CREATE_BRAND_PLAN_ACTIVE_LABEL,
  ADMIN_DASHBOARD_USER_CREATED_SUCCESS,
  ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_YES,
  ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_NO,
  ADMIN_DASHBOARD_CREATE_BRAND_PLAN_RECURRENT_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_PLAN_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_HAS_ADDON_SPEND_FEE_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_FEATURES_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_AD_SPEND_FEE_PERCENTAGE_LABEL,
  ADMIN_DASHBOARD_CREATE_BRAND_STRIPE_SUBSCRIPTION_ID_LABEL,
  ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_TITLE,
  ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_BRAND_NAME_LABEL,
  ADMIN_DASHBOARD_ADVERTISER_CREATED_SUCCESS,
  DELETE_BRAND_CONFIRMATION_TITLE,
  DELETE_BRAND_CONFIRMATION_DESCRIPTION,
  DELETE_BRAND_SUCCESS,
  DELETE_BRAND_ERROR,
  DELETE_BRAND_MAIN_CANNOT_DELETE,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_TITLE,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_LABEL,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_PLACEHOLDER,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MIN_ERROR,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MAX_ERROR,
  ADMIN_DASHBOARD_CREDITS_ADDED_SUCCESS,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_MODAL_TITLE,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_CREDITS_LABEL,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_VIDEOS_LABEL,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_CONSUMED_LABEL,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_PLAN_MAX_HINT,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_REMOVE_HINT,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_TOTAL_ASSIGNED_LABEL,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_PLAN_MAX_LABEL,
  ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_SUCCESS,
  NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE,
  NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE_DESCRIPTION,
  BRAND_USAGE_LIMIT_ALERT_EDIT_LIMITS_BUTTON,
  BRAND_USAGE_ALLOCATION_EXCEEDS_PLAN,
  BRAND_USAGE_ALLOCATION_BELOW_CONSUMED,
  HEALTH_SCORE_LABEL,
  ADS_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE,
  VIDEO_LANGUAGE,
  GENERATION_FAILED,
  ASPECT_RATIO_PLACEHOLDER,
  ASPECT_RATIO_9_16,
  ASPECT_RATIO_16_9,
  ASPECT_RATIO_1_1,
  ASPECT_RATIO_4_5,
  GENERATING_CREATIVE_SUCCESS,
  GENERATING_CREATIVE_ERROR,
  ALERT_GENERIC_ERROR_TITLE,
  GENERATING_CREATIVE_TITLE,
  GENERATING_CUSTOM_REPORT_MESSAGE,
  GENERATING_CUSTOM_REPORT_SUCCESS,
  GENERATING_CUSTOM_REPORT_ERROR,
  ANALYZING_IMAGE_LAYERS_MESSAGE,
  ANALYZING_IMAGE_LAYERS_SUCCESS,
  ANALYZING_IMAGE_LAYERS_ERROR,
  ANALYZING_CREATIVE_TEMPLATE_MESSAGE,
  ANALYZING_CREATIVE_TEMPLATE_SUCCESS,
  ANALYZING_CREATIVE_TEMPLATE_ERROR,
  PRODUCING_CREATIVE_TEMPLATE_MESSAGE,
  PRODUCING_CREATIVE_TEMPLATE_PREVIEW_MESSAGE,
  PRODUCING_CREATIVE_TEMPLATE_PREVIEW_SUCCESS,
  PRODUCING_CREATIVE_TEMPLATE_PREVIEW_ERROR,
  PRODUCING_CREATIVE_TEMPLATE_SUCCESS,
  PRODUCING_CREATIVE_TEMPLATE_PARTIAL,
  PRODUCING_CREATIVE_TEMPLATE_PARTIAL_SINGULAR,
  PRODUCING_CREATIVE_TEMPLATE_ERROR,
  EDITING_IMAGE_TITLE,
  EDITING_IMAGE_SUCCESS,
  EDITING_IMAGE_ERROR,
  RESIZING_IMAGE_TITLE,
  RESIZING_IMAGE_SUCCESS,
  RESIZING_IMAGE_ERROR,
  MODAL_CREATE_WITH_IA_LABEL_VIDEO_TYPE,
  VIDEO_TYPE_UNBOXING,
  VIDEO_TYPE_PRODUCT_SHOWCASE,
  VIDEO_TYPE_UGC,
  VIDEO_TYPE_LIFESTYLE,
  VIDEO_TYPE_TESTIMONIALS_REVIEWS,
  VIDEO_TYPE_TESTIMONIAL,
  VIDEO_TYPE_EMOTIONAL_STORYTELLING,
  VIDEO_TYPE_CASE_STUDY,
  VIDEO_TYPE_CORPORATE,
  AGENT_LABEL,
  REST_VIDEOS,
  VIDEOS_REMAINING_SHORT,
  REST_CREATIVE_SINGULAR,
  REST_VIDEO_SINGULAR,
  REST_CREDITS,
  CREATIVES_REMAINING_SHORT_SINGULAR,
  SUGGESTED_CREATIVES_COUNT,
  VIDEOS_REMAINING_SHORT_SINGULAR,
  FIELD_APP_ID_REQUIRED_AD_PREVIEW,
  FIELD_URL_VALID_WITH_PROTOCOL,
  INVALID_APP_DEEP_LINK,
  CONNECTING_TO_PLATFORM_DESCRIPTION,
  MODAL_SAVED_AUDIENCES_DESCRIPTION,
  MODAL_SAVED_AUDIENCES_TITLE,
  BUTTON_USE_SAVED_AUDIENCE,
  ADS_CAMPAIGN_SAVED_AUDIENCE_SUB_TITLE,
  YOUR_CAMPAIGN_HAS_SOME_DISAPPROVALS,
  GENERATION_VIDEO_REJECTED,
  VIDEO_INPUT_REAL_PERSON_REJECTED,
  IMAGE_LAYERS_CONTENT_POLICY_VIOLATION,
  AI_PROVIDER_CREDENTIALS_INVALID,
  AI_PROVIDER_CREDENTIALS_INVALID_GENERIC,
  AI_REQUEST_TIMEOUT,
  DARK_POST_DESCRIPTION_PLACEHOLDER,
  DARK_POST_PLACEHOLDER,
  IS_ADVANTAGE_AUDIENCE_ACTIVE_DESCRIPTION_PLACEHOLDER,
  IS_ADVANTAGE_AUDIENCE_ACTIVE_PLACEHOLDER,
  ALERT_AD_ACCOUNT_STATUS_DISABLED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_UNSETTLED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_RISK_REVIEW_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_SETTLEMENT_LABEL,
  ALERT_AD_ACCOUNT_STATUS_IN_GRACE_PERIOD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_CLOSURE_LABEL,
  ALERT_AD_ACCOUNT_STATUS_CLOSED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_ANY_CLOSED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_LIMITED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_FINAL_LABEL,
  ALERT_AD_ACCOUNT_STATUS_MODIFY_REVIEW_FAILED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_REVIEW_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_VERIFICATION_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_MODIFY_REVIEW_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_CRM_REVIEW_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_PUBLIC_AUTH_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_QUALIFICATION_LABEL,
  ALERT_AD_ACCOUNT_STATUS_CONTRACT_PENDING_LABEL,
  ALERT_AD_ACCOUNT_STATUS_DRAFT_LABEL,
  ALERT_AD_ACCOUNT_STATUS_BILLING_HOLD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_TOTAL_BUDGET_HOLD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_END_DATE_HOLD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_RESTRICTED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_INTERNAL_HOLD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_STOPPED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_SUSPENDED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_CANCELED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_BILLING_PENDING_LABEL,
  ALERT_AD_ACCOUNT_STATUS_BILLING_CANCELLED_LABEL,
  ALERT_MERCHANT_NO_ELIGIBLE_PRODUCTS_LABEL,
  ALERT_MERCHANT_PRODUCTS_PARTIAL_ISSUES_LABEL,
  FILE_UPLOADED,
  CHAT_THINKING,
  GO_TO_DASHBOARD,
  IMAGES_MODERATION_BLOCKED,
  MALFORMED_FUNCTION_CALL,
  ALERT_DELETE_CAMPAIGN_ACTIVE_TITLE,
  ADS_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE,
  ADS_META_DESTINATION_TYPE_WEBSITE_AND_APP,
  RESET_CHAT_ALERT_DESCRIPTION,
  RESET_CHAT_ALERT_TITLE,
  DISCARD_OPTIMIZATION_ALERT_DESCRIPTION,
  DISCARD_OPTIMIZATION_ALERT_TITLE,
  DISCARD_GENERATING_CREATIVE_ALERT_DESCRIPTION,
  DISCARD_GENERATING_VIDEO_ALERT_DESCRIPTION,
  DISCARD_IMAGE_ANIMATION_ALERT_DESCRIPTION,
  DISCARD_GENERATING_CUSTOM_REPORT_ALERT_DESCRIPTION,
  DISCARD_ANALYZING_IMAGE_LAYERS_ALERT_DESCRIPTION,
  DISCARD_ANALYZING_CREATIVE_TEMPLATE_ALERT_DESCRIPTION,
  DISCARD_PRODUCING_CREATIVE_TEMPLATE_ALERT_DESCRIPTION,
  BUTTON_DISCARD_ALL,
  DISCARD_ALL_ACTIVITIES_TITLE,
  DISCARD_ALL_ACTIVITIES_DESCRIPTION,
  ALERT_MARKETING_OBJECTIVE_GOOGLE_NOT_SET_LABEL,
  VIDEO_GENERATION_FAILED_BY_PROVIDER,
  AI_RATE_LIMITED,
  AI_PROVIDER_UNAVAILABLE,
  AI_GENERATION_FAILED,
  AGENT_REQUEST_COULD_NOT_BE_PROCESSED,
  CREDITS_RETURNED_SUFFIX,
  CREATIVE_UNEXPECTED_IMAGE_PROVIDER_ERROR,
  CREATIVE_UNEXPECTED_VIDEO_PROVIDER_ERROR,
  CREATIVE_UNEXPECTED_AI_PROVIDER_ERROR,
  CREATIVE_TIMEOUT_IMAGE_PROVIDER_ERROR,
  CREATIVE_TIMEOUT_VIDEO_PROVIDER_ERROR,
  CREATIVE_TIMEOUT_AI_PROVIDER_ERROR,
  CREATE_ADS_CAMPAIGN_DEEP_LINK_QUESTION,
  APP_STORE_ANDROID,
  APP_STORE_IOS,
  APP_STORE_PLACEHOLDER,
  GOOGLE_APP,
  MODAL_CREATE_WITH_IA_LABEL_WITH_SUBTITLES,
  MODAL_CREATE_WITH_IA_LABEL_AI_WATERMARK,
  MODAL_CREATE_WITH_IA_AI_WATERMARK_DESCRIPTION,
  MODAL_SUBTITLE_OPTIONS_TITLE,
  MODAL_SUBTITLE_OPTIONS_PERSONALIZE,
  MODAL_SUBTITLE_OPTIONS_FONT_FAMILY,
  MODAL_SUBTITLE_OPTIONS_FONT_STYLE,
  MODAL_SUBTITLE_OPTIONS_FONT_STYLE_NORMAL,
  MODAL_SUBTITLE_OPTIONS_FONT_STYLE_BOLD,
  MODAL_SUBTITLE_OPTIONS_FONT_STYLE_ITALIC,
  MODAL_SUBTITLE_OPTIONS_FONT_STYLE_BOLD_ITALIC,
  MODAL_SUBTITLE_OPTIONS_SUBTITLE_COLOR,
  MODAL_SUBTITLE_OPTIONS_DO_HIGHLIGHT,
  MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_COLOR,
  MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE,
  MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE_KARAOKE,
  MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE_WORD,
  MODAL_SUBTITLE_OPTIONS_PRESET,
  MODAL_SUBTITLE_OPTIONS_PRESET_KARAOKE,
  MODAL_SUBTITLE_OPTIONS_PRESET_HIGHLIGHT,
  MODAL_SUBTITLE_OPTIONS_PRESET_BOXED,
  MODAL_SUBTITLE_OPTIONS_BOX_COLOR,
  MODAL_SUBTITLE_OPTIONS_HAS_BACKGROUND,
  MODAL_SUBTITLE_OPTIONS_BACKGROUND_COLOR,
  MODAL_SUBTITLE_OPTIONS_PREVIEW_LABEL,
  ACCENT_ES_ARGENTINO,
  ACCENT_ES_COLOMBIANO,
  ACCENT_ES_CHILENO,
  ACCENT_ES_MEXICANO,
  ACCENT_ES_ESPANOL_ESPANA,
  ACCENT_ES_PERUANO,
  ACCENT_ES_VENEZOLANO,
  ACCENT_ES_CARIBENO,
  ACCENT_ES_NEUTRAL,
  ACCENT_ES_PUERTORRIQUENO,
  ACCENT_EN_AMERICAN,
  ACCENT_EN_BRITISH,
  ACCENT_EN_AUSTRALIAN,
  ACCENT_EN_NEUTRAL,
  REQUIRED_VIDEOS_GOOGLE_ASSETS_GROUP_HELPER_TEXT,
  ANALYZING_CONTENT,
  CONTENT_RECOMMENDATIONS,
  NO_CONTENT_RECOMMENDATIONS,
  CONTENT_WARNING_TITLE,
  CONTENT_RECOMMENDATIONS_SUBTITLE,
  CONTENT_RECOMMENDATION_OPEN_CREATE_WITH_IA,
  CONTENT_RECOMMENDATIONS_BANNER_TITLE,
  CONTENT_RECOMMENDATIONS_BANNER_DESCRIPTION,
  CONTENT_RECOMMENDATIONS_VIEW_ALL,
  CONTENT_RECOMMENDATIONS_COMPLETED_PROGRESS,
  CONTENT_RECOMMENDATION_GENERATED,
  CONTENT_RECOMMENDATION_GENERATE_ARIA,
  CONTENT_RECOMMENDATIONS_ALL_COMPLETED,
  CREATE_ADS_CAMPAIGN_MULTIPLE_PRODUCTS_QUESTION,
  CREATE_ADS_CAMPAIGN_MULTIPLE_PRODUCTS_DESCRIPTION,
  CREATE_ADS_CAMPAIGN_MULTIPLE_SERVICES_QUESTION,
  CREATE_ADS_CAMPAIGN_MULTIPLE_SERVICES_DESCRIPTION,
  BUTTON_ADD_SERVICE,
  PRODUCT_URL_PLACEHOLDER,
  SERVICE_URL_PLACEHOLDER,
  PRODUCT_LABEL,
  SERVICE_LABEL,
  PRODUCT_FIELDS_REQUIRED,
  SERVICE_FIELDS_REQUIRED,
  PRODUCT_URL_INVALID,
  SERVICE_URL_INVALID,
  MEDIA_URLS_TAB_SINGULAR_PRODUCT,
  MEDIA_URLS_TAB_SINGULAR_SERVICE,
  MEDIA_URLS_TAB_MULTIPLE_PRODUCTS,
  MEDIA_URLS_TAB_MULTIPLE_SERVICES,
  MEDIA_URLS_MODE_EXPLANATION_PRODUCTS,
  MEDIA_URLS_MODE_EXPLANATION_SERVICES,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_SERVICES_QUESTION,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DOCUMENTS_QUESTION,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_POSTS_QUESTION,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_PRODUCTS_QUESTION,
  CONFIGURATION_PANEL_CLARIFICATION_INPUT_IMAGES,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENTS_TITLE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENTS_INTRO,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_HIGH_QUALITY,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_PROMINENT,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SIZE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SAME_COLOR_AND_MODEL,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_COMPLETE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_LIGHTING,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_NO_PEOPLE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_TITLE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_LIST,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_EXAMPLES_TITLE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_PEOPLE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_WARNING_DISTORTION,
  PARTNERSHIP,
  VIDEO_TYPE_OTHER,
  BAD,
  REGULAR,
  GOOD,
  VERY_GOOD,
  EXCELLENT,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_PRODUCT_SINGLE,
  CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_SERVICE_SINGLE,
  FIELD,
  EMPTY_TRACKING_IDS_LINKEDIN,
  TRACKING_CUSTOM_EVENT_ID_LINKEDIN_PLACEHOLDER,
  AD_ACCOUNT_LINKEDIN_PLACEHOLDER,
  LINKEDIN_ACCOUNT_SHARE_PLACEHOLDER,
  LINKEDIN_PUBLISH_AS_PERSONAL_LABEL,
  LINKEDIN_PUBLISH_AS_COMPANY_PAGE_LABEL,
  TRACKING_LINKEDIN_ID_PLACEHOLDER,
  ALERT_DESCRIPTION_DISCONNECT_LINKEDIN,
  BUTTON_UPLOAD,
  BUTTON_UPLOAD_FILES,
  BUTTON_UPLOAD_FOLDER,
  BUTTON_URL,
  CONFIGURATION_PANEL_SERVICE_WEBSITE_URL_TITLE,
  CONFIGURATION_PANEL_SERVICE_WEBSITE_URL_DESCRIPTION,
  ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_IMAGE,
  ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_VIDEO,
  ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_CAROUSEL,
  ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_DOCUMENT,
  ADS_CAMPAIGN_LINKEDIN_AD_SETUP,
  ADS_CAMPAIGN_LINKEDIN_AD_SETUP_CREATE_AD,
  ADS_CAMPAIGN_LINKEDIN_AD_SETUP_USE_POST,
  ADS_CAMPAIGN_LINKEDIN_USE_POST_VIDEO_DOWNLOAD_URL_MISSING,
  AD_FORMAT_PLACEHOLDER,
  SELECT_AD_FORMAT_TO_CONTINUE,
  INVALID_UPDATE_STATUS_CREATIVE_IN_REVIEW,
  MODAL_LEAD_FORMS_LIST_TITLE,
  MODAL_LEAD_FORMS_LIST_DESCRIPTION,
  MODAL_LEAD_FORMS_EMPTY_TEXT,
  MODAL_LEAD_FORMS_DUPLICATE_AND_EDIT,
  MODAL_LEAD_FORMS_VIEW,
  MODAL_LEAD_FORMS_COPY_NAME_PREFIX,
  MODAL_CREATE_LEAD_FORM_TITLE,
  MODAL_VIEW_LEAD_FORM_TITLE,
  INSTANT_FORM_PREVIEW_MORE,
  MODAL_CREATE_LEAD_FORM_DESCRIPTION,
  MODAL_VIEW_LEAD_FORM_DESCRIPTION,
  MODAL_VIEW_LEAD_FORM_LOAD_ERROR,
  MODAL_CREATE_LEAD_FORM_LOCALE_WARNING,
  MODAL_CREATE_LEAD_FORM_NAME,
  MODAL_CREATE_LEAD_FORM_HEADLINE,
  MODAL_CREATE_LEAD_FORM_DETAILS,
  MODAL_CREATE_LEAD_FORM_SECTION_FORM,
  MODAL_CREATE_LEAD_FORM_SECTION_CONTACT,
  MODAL_CREATE_LEAD_FORM_SECTION_PRIVACY,
  MODAL_CREATE_LEAD_FORM_SECTION_CONFIRMATION,
  MODAL_CREATE_LEAD_FORM_PROFILE_FIELDS,
  MODAL_CREATE_LEAD_FORM_PROFILE_FIRST_NAME,
  MODAL_CREATE_LEAD_FORM_PROFILE_LAST_NAME,
  MODAL_CREATE_LEAD_FORM_PROFILE_EMAIL,
  MODAL_CREATE_LEAD_FORM_PROFILE_PHONE,
  MODAL_CREATE_LEAD_FORM_PROFILE_CITY,
  MODAL_CREATE_LEAD_FORM_PROFILE_STATE,
  MODAL_CREATE_LEAD_FORM_PROFILE_COUNTRY,
  MODAL_CREATE_LEAD_FORM_PROFILE_ZIP,
  MODAL_CREATE_LEAD_FORM_PROFILE_JOB_TITLE,
  MODAL_CREATE_LEAD_FORM_PROFILE_COMPANY,
  MODAL_CREATE_LEAD_FORM_PROFILE_LINKEDIN,
  MODAL_CREATE_LEAD_FORM_CUSTOM_QUESTIONS,
  MODAL_CREATE_LEAD_FORM_ADD_CUSTOM_QUESTION,
  MODAL_CREATE_LEAD_FORM_CUSTOM_QUESTION_HINT,
  MODAL_CREATE_LEAD_FORM_QUESTION_TITLE,
  MODAL_CREATE_LEAD_FORM_QUESTION_TYPE,
  MODAL_CREATE_LEAD_FORM_QUESTION_TYPE_TEXT,
  MODAL_CREATE_LEAD_FORM_QUESTION_TYPE_MULTIPLE_CHOICE,
  MODAL_CREATE_LEAD_FORM_ADD_OPTION,
  MODAL_CREATE_LEAD_FORM_OPTION,
  MODAL_CREATE_LEAD_FORM_PRIVACY_POLICY_URL,
  MODAL_CREATE_LEAD_FORM_PRIVACY_POLICY_TEXT,
  MODAL_CREATE_LEAD_FORM_THANK_YOU_MESSAGE,
  MODAL_CREATE_LEAD_FORM_LANDING_PAGE_URL,
  MODAL_CREATE_LEAD_FORM_CTA,
  MODAL_CREATE_LEAD_FORM_CTA_VISIT_COMPANY_WEBSITE,
  MODAL_CREATE_LEAD_FORM_CTA_LEARN_MORE,
  MODAL_CREATE_LEAD_FORM_CTA_VIEW_NOW,
  MODAL_CREATE_LEAD_FORM_CTA_DOWNLOAD_NOW,
  MODAL_CREATE_LEAD_FORM_CTA_TRY_NOW,
  MODAL_CREATE_LEAD_FORM_MIN_OPTIONS,
  MODAL_CREATE_LEAD_FORM_MAX_CUSTOM_QUESTIONS,
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_CONTENT_WILL_BE_PUBLISHED_IMMEDIATELY,
  CAMPAIGN_LEARNINGS_TITLE,
  CAMPAIGN_LEARNINGS_SUBTITLE,
  CAMPAIGN_LEARNINGS_KEY_LEARNINGS,
  CAMPAIGN_LEARNINGS_WHAT_WORKED,
  CAMPAIGN_LEARNINGS_WHAT_DIDNT_WORK,
  PLATFORM_META,
  PLATFORM_GOOGLE,
  TABLE_ADMIN_DASHBOARD_RESULTS,
  TABLE_ADMIN_DASHBOARD_CAMPAIGNS_ACTIVE_SINGLE,
  TABLE_ADMIN_DASHBOARD_AI_CREATIVES_LAST_30_DAYS,
  SUGGESTED_CREATIVES_PROGRESS,
  LOGO_DESCRIPTION,
  CALENDAR_MULTIPLE_POST_TITLE,
  BENEFICIARY_OR_PAYER_NOT_FOUND,
  MODAL_BRAND_SETUP_CONFIRM_TITLE,
  MODAL_BRAND_SETUP_CONFIRM_DESCRIPTION,
  MODAL_BRAND_SETUP_CONFIRM_BUTTON,
  MODAL_BRAND_SETUP_REVIEW_BUTTON,
  MODAL_UPLOAD_FACEBOOK_TYPE_LABEL,
  TYPE_CONTENT_FACEBOOK_LABEL,
  MODAL_UPLOAD_FACEBOOK_TYPE_POST_LABEL,
  MODAL_UPLOAD_FACEBOOK_TYPE_STORY_LABEL,
  MODAL_UPLOAD_FACEBOOK_TYPE_REEL_LABEL,
  CALENDAR_STORIES_TITLE,
  CALENDAR_REELS_TITLE,
  MODAL_SELECT_CREDITS_ARIA_LABEL,
  ADS_SUBSCRIPTION_BENEFIT_CREDITS,
  ADS_SUBSCRIPTION_BENEFIT_CREDITS_PER_YEAR,
  APPSUMO_SUBSCRIPTION_TIER_1,
  APPSUMO_SUBSCRIPTION_TIER_2,
  APPSUMO_SUBSCRIPTION_TIER_3,
  VALUE_SUBSCRIPTION_ONE_TIME,
  BUTTON_APPSUMO_VIEW_PLANS,
  VIDEO_HOOK_RATE,
  VIDEO_RETENTION_RATE,
  BUY_CREDITS,
  SECTION_OFFER_BUSINESS_VALUE_PROPOSITION_LABEL,
  BRAND_SETUP_EXTRACTION_WARNING_MESSAGE,
  LINKEDIN_ARTICLE_DEFAULT_TEXT,
  CREDIT_REWARD_MODAL_TITLE,
  CREDIT_REWARD_MODAL_SUBTITLE,
  CREDIT_REWARD_MODAL_ARIA_LABEL,
  CREDIT_REWARD_MODAL_REWARD,
  CREDIT_REWARD_MODAL_REWARD_DESCRIPTION,
  CREDIT_REWARD_MODAL_ARTICLE_CONTENT_LABEL,
  CREDIT_REWARD_MODAL_ARTICLE_CONTENT_PLACEHOLDER,
  CREDIT_REWARD_MODAL_VERIFICATION_NOTICE,
  CREDIT_REWARD_MODAL_BUTTON_CANCEL,
  CREDIT_REWARD_MODAL_BUTTON_PUBLISH,
  CREDIT_REWARD_MODAL_BUTTON_PUBLISHING,
  CREDIT_REWARD_MODAL_BUTTON_RETRY,
  CREDIT_REWARD_MODAL_LOADING_TITLE,
  CREDIT_REWARD_MODAL_LOADING_DESCRIPTION,
  CREDIT_REWARD_MODAL_SUCCESS_TITLE,
  CREDIT_REWARD_MODAL_SUCCESS_TEXT,
  CREDIT_REWARD_MODAL_ERROR_TITLE,
  CREDIT_REWARD_MODAL_ERROR_TEXT,
  CREDIT_REWARD_MODAL_BUTTON_TEXT,
  ALERT_CANCEL_PLAN_TITLE,
  X,
  THREADS,
  INSTAGRAM_FEED_ASPECT_RATIO_WARNING,
  CAROUSEL_MIN_IMAGES_WARNING,
  CAROUSEL_MAX_IMAGES_WARNING,
  CAROUSEL_DRAG_TO_REORDER,
  CAROUSEL_ADD_MORE_IMAGES,
  CAROUSEL_IMAGES_SELECTED,
  CAROUSEL_MAIN_IMAGE,
  TYPE_CONTENT_TIKTOK_LABEL,
  MODAL_UPLOAD_TIKTOK_TYPE_POST_LABEL,
  TIKTOK_AUTO_ADD_MUSIC_LABEL,
  CONTENT_TYPE_CAROUSEL,
  CONFIRM_CHANGE_CONTENT_TYPE_TITLE,
  CONFIRM_CHANGE_CONTENT_TYPE_MESSAGE_CAROUSEL,
  CONFIRM_CHANGE_CONTENT_TYPE_MESSAGE_POST,
  CONFIRM_REGENERATE_TEXTS_AFTER_CREATIVE_CHANGE_TITLE,
  BUTTON_KEEP_TEXTS,
  REGENERATING_AD_TEXTS_OVERLAY_MESSAGE,
  BRAND_SETUP_SECTION_BRAND_NAME,
  BRAND_SETUP_SECTION_BRAND_DESCRIPTION,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_PLACEHOLDER,
  BRAND_SETUP_SECTION_BRAND_NAME_PLACEHOLDER,
  BRAND_SETUP_SECTION_BRAND_DESCRIPTION_PLACEHOLDER,
  ANONYMOUS_USER,
  LINKEDIN_STAFF_COUNT_MYSELF_ONLY,
  LINKEDIN_STAFF_COUNT_2_10,
  LINKEDIN_STAFF_COUNT_11_50,
  LINKEDIN_STAFF_COUNT_51_200,
  LINKEDIN_STAFF_COUNT_201_500,
  LINKEDIN_STAFF_COUNT_501_1000,
  LINKEDIN_STAFF_COUNT_1001_5000,
  LINKEDIN_STAFF_COUNT_5001_10000,
  LINKEDIN_STAFF_COUNT_10001_PLUS,
  LINKEDIN_JOB_FUNCTION_ACCOUNTING,
  LINKEDIN_JOB_FUNCTION_ADMINISTRATIVE,
  LINKEDIN_JOB_FUNCTION_ARTS_AND_DESIGN,
  LINKEDIN_JOB_FUNCTION_BUSINESS_DEVELOPMENT,
  LINKEDIN_JOB_FUNCTION_COMMUNITY_AND_SOCIAL_SERVICES,
  LINKEDIN_JOB_FUNCTION_CONSULTING,
  LINKEDIN_JOB_FUNCTION_EDUCATION,
  LINKEDIN_JOB_FUNCTION_ENGINEERING,
  LINKEDIN_JOB_FUNCTION_ENTREPRENEURSHIP,
  LINKEDIN_JOB_FUNCTION_FINANCE,
  LINKEDIN_JOB_FUNCTION_HEALTHCARE_SERVICES,
  LINKEDIN_JOB_FUNCTION_HUMAN_RESOURCES,
  LINKEDIN_JOB_FUNCTION_INFORMATION_TECHNOLOGY,
  LINKEDIN_JOB_FUNCTION_LEGAL,
  LINKEDIN_JOB_FUNCTION_MARKETING,
  LINKEDIN_JOB_FUNCTION_MEDIA_AND_COMMUNICATION,
  LINKEDIN_JOB_FUNCTION_MILITARY_AND_PROTECTIVE_SERVICES,
  LINKEDIN_JOB_FUNCTION_OPERATIONS,
  LINKEDIN_JOB_FUNCTION_PRODUCT_MANAGEMENT,
  LINKEDIN_JOB_FUNCTION_PROGRAM_AND_PROJECT_MANAGEMENT,
  LINKEDIN_JOB_FUNCTION_PURCHASING,
  LINKEDIN_JOB_FUNCTION_QUALITY_ASSURANCE,
  LINKEDIN_JOB_FUNCTION_REAL_ESTATE,
  LINKEDIN_JOB_FUNCTION_RESEARCH,
  LINKEDIN_JOB_FUNCTION_SALES,
  LINKEDIN_JOB_FUNCTION_CUSTOMER_SUCCESS_AND_SUPPORT,
  LINKEDIN_SENIORITY_UNPAID,
  LINKEDIN_SENIORITY_TRAINING,
  LINKEDIN_SENIORITY_ENTRY,
  LINKEDIN_SENIORITY_SENIOR,
  LINKEDIN_SENIORITY_MANAGER,
  LINKEDIN_SENIORITY_DIRECTOR,
  LINKEDIN_SENIORITY_VP,
  LINKEDIN_SENIORITY_CXO,
  LINKEDIN_SENIORITY_PARTNER,
  LINKEDIN_SENIORITY_OWNER,
  LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_TRAVELERS,
  LINKEDIN_MEMBER_BEHAVIOR_JOB_SEEKERS,
  LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_EDUCATION,
  LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_CONTRIBUTORS,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_PROMOTED,
  LINKEDIN_MEMBER_BEHAVIOR_CAREER_CHANGERS,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_SWITCHED_JOBS,
  LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION,
  LINKEDIN_MEMBER_BEHAVIOR_EXPAT,
  LINKEDIN_MEMBER_BEHAVIOR_MOBILE_USERS,
  LINKEDIN_MEMBER_BEHAVIOR_DESKTOP_LAPTOP_USERS,
  LINKEDIN_MEMBER_BEHAVIOR_DOMESTIC_FREQUENT_TRAVELERS,
  LINKEDIN_MEMBER_BEHAVIOR_INTERNATIONAL_FREQUENT_TRAVELERS,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_DOMESTIC,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_INTERNATIONAL,
  LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_DOMESTIC,
  LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_INTERNATIONAL,
  LINKEDIN_MEMBER_BEHAVIOR_ANDROID_USERS,
  LINKEDIN_MEMBER_BEHAVIOR_WINDOWS,
  LINKEDIN_MEMBER_BEHAVIOR_MAC,
  LINKEDIN_MEMBER_BEHAVIOR_LINUX,
  RETRIEVING_YOUTUBE_CHANNEL,
  RETRIEVING_TIKTOK_PROFILE,
  ESTABLISHING_CONNECTION_WITH_PLATFORM,
  RETRIEVING_AUTHORIZATION_DATA,
  OPENING_AUTHORIZATION_WINDOW,
  CONNECTING_CANVA_VERIFYING_AUTHORIZATION,
  CONNECTING_CANVA_LINKING_ACCOUNT,
  MODAL_CREATE_WITH_IA_PROMPT_OPTIONAL,
  MODAL_CREATE_WITH_IA_PROMPT_THEME_OPTIONAL,
  FILTERS_GALLERY_CAROUSEL,
  GALLERY_CREATE_CAROUSEL,
  FILTERS_GALLERY_FEED,
  MODAL_UPLOAD_TIKTOK_TYPE_VIDEO_LABEL,
  MODAL_FEEDBACK_TITLE,
  MODAL_FEEDBACK_DESCRIPTION,
  MODAL_FEEDBACK_PLACEHOLDER,
  MODAL_FEEDBACK_LIKE_LABEL,
  MODAL_FEEDBACK_DISLIKE_LABEL,
  MODAL_REPORT_CONTENT_TITLE,
  MODAL_REPORT_CONTENT_DESCRIPTION,
  MODAL_REPORT_CONTENT_PLACEHOLDER,
  MODAL_REPORT_CONTENT_SUCCESS,
  BUTTON_REPORT_CONTENT,
  DASHBOARD_METRICS_DELAY_DISMISS,
  ALERT_DELETE_ELEMENT_TITLE,
  ALERT_DELETE_ELEMENT_DESCRIPTION,
  DELETE_OPERATION_NOT_ALLOWED_FOR_CAMPAIGN,
  BUTTON_DELETE_LOGO,
  LINKEDIN_PARTNERSHIP_CREDITS_ALREADY_CLAIMED,
  MODAL_EDIT_URL_PARAMETERS_TITLE,
  MODAL_EDIT_URL_PARAMETERS_DESCRIPTION,
  MODAL_EDIT_URL_PARAMETERS_UTM_SECTION_LABEL,
  MODAL_EDIT_URL_PARAMETERS_CUSTOM_SECTION_LABEL,
  MODAL_EDIT_URL_PARAMETERS_PREVIEW_LABEL,
  MODAL_EDIT_URL_PARAMETERS_ENTER_PARAM_NAME,
  MODAL_EDIT_URL_PARAMETERS_ENTER_PARAM_VALUE,
  MODAL_EDIT_URL_PARAMETERS_CONFIGURED,
  MODAL_EDIT_URL_PARAMETERS_BUTTON_APPLY,
  MODAL_EDIT_URL_PARAMETERS_BUTTON_CONFIGURE,
  MODAL_EDIT_URL_PARAMETERS_CUSTOM_KEY_RESERVED,
  MODAL_EDIT_URL_PARAMETERS_BUILD_LABEL,
  URL_EXAMPLE_PLACEHOLDER,
  WHY_WOULD_IT_WORK,
  INSTANT_FORM_SECTION_FORM_TYPE,
  INSTANT_FORM_SECTION_INTRO,
  INSTANT_FORM_SECTION_QUESTIONS,
  INSTANT_FORM_SECTION_END,
  INSTANT_FORM_FIELD_HEADLINE,
  INSTANT_FORM_FIELD_DESCRIPTION,
  INSTANT_FORM_FIELD_CTA,
  ADMIN_DASHBOARD_CREATE_BRAND_PLAN_TYPE_LABEL,
  BUTTON_CONTINUE_WITHOUT_CHANGES,
  BUTTON_RESIZE_AND_CONTINUE,
  ANIMATING_IMAGE_TITLE,
  ANIMATING_IMAGE_SUCCESS,
  ANIMATING_IMAGE_ERROR,
  CAMPAIGN_IS_GENERATING,
  INVALID_JOB_TYPE,
  JOB_CANCELLED_OR_FAILED,
  JOB_TIMEOUT,
  CUSTOM_REPORT_NO_ACTIVE_CAMPAIGNS_IN_PERIOD,
  VIDEO_TYPE_SURREAL,
  VIDEO_TYPE_MEGA_CREATIVE,
  SECTION_BUYER_PERSONA_PLACEHOLDER_NAME,
  SECTION_BUYER_PERSONA_PLACEHOLDER_DESCRIPTION,
  ALL,
  SET_PASSWORD,
  COUNTRY_ANDORRA,
  COUNTRY_UNITED_ARAB_EMIRATES,
  COUNTRY_AFGHANISTAN,
  COUNTRY_ANTIGUA_AND_BARBUDA,
  COUNTRY_ANGUILLA,
  COUNTRY_ALBANIA,
  COUNTRY_ARMENIA,
  COUNTRY_ANGOLA,
  COUNTRY_ANTARCTICA,
  COUNTRY_ARGENTINA,
  COUNTRY_AMERICAN_SAMOA,
  COUNTRY_AUSTRIA,
  COUNTRY_AUSTRALIA,
  COUNTRY_ARUBA,
  COUNTRY_ALLAND_ISLANDS,
  COUNTRY_AZERBAIJAN,
  COUNTRY_BOSNIA_AND_HERZEGOVINA,
  COUNTRY_BARBADOS,
  COUNTRY_BANGLADESH,
  COUNTRY_BELGIUM,
  COUNTRY_BURKINA_FASO,
  COUNTRY_BULGARIA,
  COUNTRY_BAHRAIN,
  COUNTRY_BURUNDI,
  COUNTRY_BENIN,
  COUNTRY_SAINT_BARTHELEMY,
  COUNTRY_BERMUDA,
  COUNTRY_BRUNEI_DARUSSALAM,
  COUNTRY_BOLIVIA,
  COUNTRY_BRAZIL,
  COUNTRY_BAHAMAS,
  COUNTRY_BHUTAN,
  COUNTRY_BOUVET_ISLAND,
  COUNTRY_BOTSWANA,
  COUNTRY_BELARUS,
  COUNTRY_BELIZE,
  COUNTRY_CANADA,
  COUNTRY_COCOS_KEELING_ISLANDS,
  COUNTRY_CONGO_DEMOCRATIC_REPUBLIC_OF_THE,
  COUNTRY_CENTRAL_AFRICAN_REPUBLIC,
  COUNTRY_CONGO_REPUBLIC_OF_THE,
  COUNTRY_SWITZERLAND,
  COUNTRY_COTE_D_IVOIRE,
  COUNTRY_COOK_ISLANDS,
  COUNTRY_CHILE,
  COUNTRY_CAMEROON,
  COUNTRY_CHINA,
  COUNTRY_COLOMBIA,
  COUNTRY_COSTA_RICA,
  COUNTRY_CUBA,
  COUNTRY_CAPE_VERDE,
  COUNTRY_CURACAO,
  COUNTRY_CHRISTMAS_ISLAND,
  COUNTRY_CYPRUS,
  COUNTRY_CZECH_REPUBLIC,
  COUNTRY_GERMANY,
  COUNTRY_DJIBOUTI,
  COUNTRY_DENMARK,
  COUNTRY_DOMINICA,
  COUNTRY_DOMINICAN_REPUBLIC,
  COUNTRY_ALGERIA,
  COUNTRY_ECUADOR,
  COUNTRY_ESTONIA,
  COUNTRY_EGYPT,
  COUNTRY_WESTERN_SAHARA,
  COUNTRY_ERITREA,
  COUNTRY_SPAIN,
  COUNTRY_ETHIOPIA,
  COUNTRY_FINLAND,
  COUNTRY_FIJI,
  COUNTRY_FALKLAND_ISLANDS_MALVINAS,
  COUNTRY_MICRONESIA_FEDERATED_STATES_OF,
  COUNTRY_FAROE_ISLANDS,
  COUNTRY_FRANCE,
  COUNTRY_GABON,
  COUNTRY_UNITED_KINGDOM,
  COUNTRY_GRENADA,
  COUNTRY_GEORGIA,
  COUNTRY_FRENCH_GUIANA,
  COUNTRY_GUERNSEY,
  COUNTRY_GHANA,
  COUNTRY_GIBRALTAR,
  COUNTRY_GREENLAND,
  COUNTRY_GAMBIA,
  COUNTRY_GUINEA,
  COUNTRY_GUADELOUPE,
  COUNTRY_EQUATORIAL_GUINEA,
  COUNTRY_GREECE,
  COUNTRY_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  COUNTRY_GUATEMALA,
  COUNTRY_GUAM,
  COUNTRY_GUINEA_BISSAU,
  COUNTRY_GUYANA,
  COUNTRY_HONG_KONG,
  COUNTRY_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  COUNTRY_HONDURAS,
  COUNTRY_CROATIA,
  COUNTRY_HAITI,
  COUNTRY_HUNGARY,
  COUNTRY_INDONESIA,
  COUNTRY_IRELAND,
  COUNTRY_ISRAEL,
  COUNTRY_ISLE_OF_MAN,
  COUNTRY_INDIA,
  COUNTRY_BRITISH_INDIAN_OCEAN_TERRITORY,
  COUNTRY_IRAQ,
  COUNTRY_IRAN_ISLAMIC_REPUBLIC_OF,
  COUNTRY_ICELAND,
  COUNTRY_ITALY,
  COUNTRY_JERSEY,
  COUNTRY_JAMAICA,
  COUNTRY_JORDAN,
  COUNTRY_JAPAN,
  COUNTRY_KENYA,
  COUNTRY_KYRGYZSTAN,
  COUNTRY_CAMBODIA,
  COUNTRY_KIRIBATI,
  COUNTRY_COMOROS,
  COUNTRY_SAINT_KITTS_AND_NEVIS,
  COUNTRY_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
  COUNTRY_KOREA_REPUBLIC_OF,
  COUNTRY_KUWAIT,
  COUNTRY_CAYMAN_ISLANDS,
  COUNTRY_KAZAKHSTAN,
  COUNTRY_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
  COUNTRY_LEBANON,
  COUNTRY_SAINT_LUCIA,
  COUNTRY_LIECHTENSTEIN,
  COUNTRY_SRI_LANKA,
  COUNTRY_LIBERIA,
  COUNTRY_LESOTHO,
  COUNTRY_LITHUANIA,
  COUNTRY_LUXEMBOURG,
  COUNTRY_LATVIA,
  COUNTRY_LIBYA,
  COUNTRY_MOROCCO,
  COUNTRY_MONACO,
  COUNTRY_MOLDOVA_REPUBLIC_OF,
  COUNTRY_MONTENEGRO,
  COUNTRY_SAINT_MARTIN_FRENCH_PART,
  COUNTRY_MADAGASCAR,
  COUNTRY_MARSHALL_ISLANDS,
  COUNTRY_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
  COUNTRY_MALI,
  COUNTRY_MYANMAR,
  COUNTRY_MONGOLIA,
  COUNTRY_MACAO,
  COUNTRY_NORTHERN_MARIANA_ISLANDS,
  COUNTRY_MARTINIQUE,
  COUNTRY_MAURITANIA,
  COUNTRY_MONTSERRAT,
  COUNTRY_MALTA,
  COUNTRY_MAURITIUS,
  COUNTRY_MALDIVES,
  COUNTRY_MALAWI,
  COUNTRY_MEXICO,
  COUNTRY_MALAYSIA,
  COUNTRY_MOZAMBIQUE,
  COUNTRY_NAMIBIA,
  COUNTRY_NEW_CALEDONIA,
  COUNTRY_NIGER,
  COUNTRY_NORFOLK_ISLAND,
  COUNTRY_NIGERIA,
  COUNTRY_NICARAGUA,
  COUNTRY_NETHERLANDS,
  COUNTRY_NORWAY,
  COUNTRY_NEPAL,
  COUNTRY_NAURU,
  COUNTRY_NIUE,
  COUNTRY_NEW_ZEALAND,
  COUNTRY_OMAN,
  COUNTRY_PANAMA,
  COUNTRY_PERU,
  COUNTRY_FRENCH_POLYNESIA,
  COUNTRY_PAPUA_NEW_GUINEA,
  COUNTRY_PHILIPPINES,
  COUNTRY_PAKISTAN,
  COUNTRY_POLAND,
  COUNTRY_SAINT_PIERRE_AND_MIQUELON,
  COUNTRY_PITCAIRN,
  COUNTRY_PUERTO_RICO,
  COUNTRY_PALESTINE_STATE_OF,
  COUNTRY_PORTUGAL,
  COUNTRY_PALAU,
  COUNTRY_PARAGUAY,
  COUNTRY_QATAR,
  COUNTRY_REUNION,
  COUNTRY_ROMANIA,
  COUNTRY_SERBIA,
  COUNTRY_RUSSIAN_FEDERATION,
  COUNTRY_RWANDA,
  COUNTRY_SAUDI_ARABIA,
  COUNTRY_SOLOMON_ISLANDS,
  COUNTRY_SEYCHELLES,
  COUNTRY_SUDAN,
  COUNTRY_SWEDEN,
  COUNTRY_SINGAPORE,
  COUNTRY_SAINT_HELENA,
  COUNTRY_SLOVENIA,
  COUNTRY_SVALBARD_AND_JAN_MAYEN,
  COUNTRY_SLOVAKIA,
  COUNTRY_SIERRA_LEONE,
  COUNTRY_SAN_MARINO,
  COUNTRY_SENEGAL,
  COUNTRY_SOMALIA,
  COUNTRY_SURINAME,
  COUNTRY_SOUTH_SUDAN,
  COUNTRY_SAO_TOME_AND_PRINCIPE,
  COUNTRY_EL_SALVADOR,
  COUNTRY_SINT_MAARTEN_DUTCH_PART,
  COUNTRY_SYRIAN_ARAB_REPUBLIC,
  COUNTRY_SWAZILAND,
  COUNTRY_TURKS_AND_CAICOS_ISLANDS,
  COUNTRY_CHAD,
  COUNTRY_FRENCH_SOUTHERN_TERRITORIES,
  COUNTRY_TOGO,
  COUNTRY_THAILAND,
  COUNTRY_TAJIKISTAN,
  COUNTRY_TOKELAU,
  COUNTRY_TIMOR_LESTE,
  COUNTRY_TURKMENISTAN,
  COUNTRY_TUNISIA,
  COUNTRY_TONGA,
  COUNTRY_TURKEY,
  COUNTRY_TRINIDAD_AND_TOBAGO,
  COUNTRY_TUVALU,
  COUNTRY_TAIWAN,
  COUNTRY_UNITED_REPUBLIC_OF_TANZANIA,
  COUNTRY_UKRAINE,
  COUNTRY_UGANDA,
  COUNTRY_UNITED_STATES,
  COUNTRY_URUGUAY,
  COUNTRY_UZBEKISTAN,
  COUNTRY_HOLY_SEE_VATICAN_CITY_STATE,
  COUNTRY_SAINT_VINCENT_AND_THE_GRENADINES,
  COUNTRY_VENEZUELA,
  COUNTRY_BRITISH_VIRGIN_ISLANDS,
  COUNTRY_US_VIRGIN_ISLANDS,
  COUNTRY_VIETNAM,
  COUNTRY_VANUATU,
  COUNTRY_WALLIS_AND_FUTUNA,
  COUNTRY_SAMOA,
  COUNTRY_KOSOVO,
  COUNTRY_YEMEN,
  COUNTRY_MAYOTTE,
  COUNTRY_SOUTH_AFRICA,
  COUNTRY_ZAMBIA,
  COUNTRY_ZIMBABWE,
  BRAND_SETUP_LOADING_GETTING_WEBSITE_INFORMATION,
  BRAND_SETUP_LOADING_ANALYZING_BRAND,
  BRAND_SETUP_LOADING_GENERATING_BRAND_PROFILE,
  BRAND_SETUP_LOADING_FINALIZING_DETAILS,
  BRAND_SETUP_GENERATION_PROMPT_LABEL,
  BRAND_SETUP_GENERATION_PROMPT_PLACEHOLDER,
  BRAND_SETUP_GENERATION_ATTACH_PDF,
  BRAND_SETUP_GENERATION_PDF_HINT,
  BRAND_SETUP_GENERATION_REMOVE_PDF,
  BRAND_SETUP_GENERATION_PDF_INVALID,
  BRAND_SETUP_GENERATION_PDF_TOO_LARGE,
  BRAND_SETUP_GENERATION_SHOW_ADVANCED,
  BRAND_SETUP_GENERATION_HIDE_ADVANCED,
  BRAND_SETUP_VERSION_CURRENT,
  BRAND_SETUP_VERSION_LABEL,
  BRAND_SETUP_VERSION_PLACEHOLDER,
  BRAND_SETUP_GROUP_VISUAL_IDENTITY_TITLE,
  BRAND_SETUP_GROUP_VISUAL_IDENTITY_DESCRIPTION,
  BRAND_SETUP_GROUP_AUDIENCE_TITLE,
  BRAND_SETUP_GROUP_AUDIENCE_DESCRIPTION,
  BRAND_SETUP_GROUP_COPY_TITLE,
  BRAND_SETUP_GROUP_COPY_DESCRIPTION,
  BRAND_INSIGHTS_TAB_TITLE,
  BRAND_INSIGHTS_PAGE_TITLE,
  BRAND_INSIGHTS_PAGE_DESCRIPTION,
  BRAND_INSIGHTS_POSITIVE_TITLE,
  BRAND_INSIGHTS_NEGATIVE_TITLE,
  BRAND_INSIGHTS_POSITIVE_SUBTITLE,
  BRAND_INSIGHTS_NEGATIVE_SUBTITLE,
  BRAND_INSIGHTS_TOPIC_ANGLE,
  BRAND_INSIGHTS_TOPIC_COPY,
  BRAND_INSIGHTS_TOPIC_CTA,
  BRAND_INSIGHTS_TOPIC_TONE,
  BRAND_INSIGHTS_TOPIC_AESTHETIC,
  BRAND_INSIGHTS_TOPIC_VALUE_PROP,
  BRAND_INSIGHTS_EMPTY,
  BRAND_INSIGHTS_REVIEW_CHANGE,
  BRAND_INSIGHTS_DISMISS,
  BRAND_INSIGHTS_DISMISS_ALERT_TITLE,
  BRAND_INSIGHTS_DISMISS_ALERT_DESCRIPTION,
  BRAND_INSIGHTS_COUNT,
  BRAND_INSIGHTS_UNREAD_ONE,
  BRAND_INSIGHTS_UNREAD_OTHER,
  BRAND_INSIGHTS_APPLY_TITLE,
  BRAND_INSIGHTS_APPLY_LOADING,
  BRAND_INSIGHTS_APPLY_CONFIRM,
  BRAND_INSIGHTS_APPLY_CANCEL,
  BRAND_INSIGHTS_APPLY_REJECTED,
  BRAND_INSIGHTS_APPLY_ALREADY_IN_CONFIG,
  BRAND_INSIGHTS_APPLY_UNMAPPABLE,
  BRAND_INSIGHTS_APPLY_REWRITE,
  BRAND_INSIGHTS_APPLY_RETRY,
  BRAND_INSIGHTS_APPLY_TIMEOUT,
  BRAND_INSIGHTS_APPLY_FIELD,
  BRAND_INSIGHTS_APPLY_RESULT_TITLE,
  BRAND_INSIGHTS_APPLY_SHOW_FULL,
  BRAND_INSIGHTS_APPLY_SHOW_CHANGES,
  BRAND_INSIGHTS_APPLY_NO_CHANGES,
  BRAND_INSIGHTS_APPLY_DIFF_COLLAPSED,
  MODAL_CREDITS_USAGE_DETAILED_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_ARIA_LABEL,
  MODAL_CREDITS_USAGE_DETAILED_LINK,
  MODAL_CREDITS_USAGE_DETAILED_PERIOD,
  MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_ADVERTISER_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_USER_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_COLUMN_ADVERTISER,
  MODAL_CREDITS_USAGE_DETAILED_COLUMN_USER,
  MODAL_CREDITS_USAGE_DETAILED_COLUMN_CREDITS_SPENT,
  MODAL_CREDITS_USAGE_DETAILED_COLUMN_VIDEOS_SPENT,
  MODAL_CREDITS_USAGE_DETAILED_LOADING,
  MODAL_CREDITS_USAGE_DETAILED_EMPTY,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_TOTAL_CREDITS,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_CREDITS_BY_GROUP_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_GROUP_CREDITS,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_GROUP_ACCORDION_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_EMPTY_GROUPS,
  MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_CALCULATING,
  PRE_ACTIVATION_BADGE,
  PRE_ACTIVATION_SECTION_01_BUSINESS,
  PRE_ACTIVATION_SECTION_02_CURRENT_ADS,
  PRE_ACTIVATION_SECTION_03_OBJECTIVES,
  PRE_ACTIVATION_SECTION_04_MEETING_ACCESS,
  PRE_ACTIVATION_HERO_TITLE,
  PRE_ACTIVATION_HERO_DESCRIPTION,
  PRE_ACTIVATION_HERO_DESCRIPTION_AGENCY,
  PRE_ACTIVATION_FIELD_BUSINESS_NAME,
  PRE_ACTIVATION_FIELD_AGENCY_NAME,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_NAME,
  PRE_ACTIVATION_FIELD_FULL_NAME,
  PRE_ACTIVATION_FIELD_EMAIL,
  PRE_ACTIVATION_FIELD_WHATSAPP,
  PRE_ACTIVATION_FIELD_WHAT_YOU_SELL,
  PRE_ACTIVATION_HINT_WHAT_YOU_SELL,
  PRE_ACTIVATION_FIELD_AVERAGE_PRICE,
  PRE_ACTIVATION_HINT_AVERAGE_PRICE,
  PRE_ACTIVATION_FIELD_IDEAL_CUSTOMER,
  PRE_ACTIVATION_HINT_IDEAL_CUSTOMER,
  PRE_ACTIVATION_FIELD_WHERE_CUSTOMER_BUYS,
  PRE_ACTIVATION_FIELD_WEBSITE_URL,
  PRE_ACTIVATION_PLACEHOLDER_BUSINESS_NAME,
  PRE_ACTIVATION_PLACEHOLDER_FULL_NAME,
  PRE_ACTIVATION_PLACEHOLDER_EMAIL,
  PRE_ACTIVATION_PLACEHOLDER_WHATSAPP,
  PRE_ACTIVATION_PLACEHOLDER_WHAT_YOU_SELL,
  PRE_ACTIVATION_PLACEHOLDER_AVERAGE_PRICE,
  PRE_ACTIVATION_PLACEHOLDER_IDEAL_CUSTOMER,
  PRE_ACTIVATION_PLACEHOLDER_WEBSITE_URL,
  PRE_ACTIVATION_SALES_CHANNEL_TIENDA_WEB,
  PRE_ACTIVATION_SALES_CHANNEL_TIENDA_FISICA,
  PRE_ACTIVATION_SALES_CHANNEL_WHATSAPP,
  PRE_ACTIVATION_SALES_CHANNEL_MARKETPLACE,
  PRE_ACTIVATION_SALES_CHANNEL_APP,
  PRE_ACTIVATION_FIELD_HAS_ADS,
  PRE_ACTIVATION_HAS_ADS_SI,
  PRE_ACTIVATION_HAS_ADS_ANTES,
  PRE_ACTIVATION_HAS_ADS_NO,
  PRE_ACTIVATION_FIELD_AD_PLATFORMS,
  PRE_ACTIVATION_ADS_PLATFORM_META,
  PRE_ACTIVATION_ADS_PLATFORM_GOOGLE,
  PRE_ACTIVATION_ADS_PLATFORM_TIKTOK,
  PRE_ACTIVATION_ADS_PLATFORM_OTHER,
  PRE_ACTIVATION_PLACEHOLDER_ADS_PLATFORM_OTHER,
  PRE_ACTIVATION_FIELD_MONTHLY_AD_SPEND,
  PRE_ACTIVATION_HINT_MONTHLY_AD_SPEND,
  PRE_ACTIVATION_FIELD_CURRENT_METRICS,
  PRE_ACTIVATION_HINT_CURRENT_METRICS,
  PRE_ACTIVATION_FIELD_TARGET_CPA,
  PRE_ACTIVATION_HINT_TARGET_CPA,
  PRE_ACTIVATION_FIELD_BEST_CAMPAIGN_MESSAGES,
  PRE_ACTIVATION_HINT_BEST_CAMPAIGN_MESSAGES,
  PRE_ACTIVATION_PLACEHOLDER_MONTHLY_AD_SPEND,
  PRE_ACTIVATION_PLACEHOLDER_CURRENT_METRICS,
  PRE_ACTIVATION_PLACEHOLDER_TARGET_CPA,
  PRE_ACTIVATION_PLACEHOLDER_BEST_CAMPAIGN_MESSAGES,
  PRE_ACTIVATION_FIELD_MONTHLY_SALES,
  PRE_ACTIVATION_FIELD_SALES_GOAL_60_90,
  PRE_ACTIVATION_FIELD_BUZZLY_FOCUS,
  PRE_ACTIVATION_BUZZLY_FOCUS_PERFORMANCE,
  PRE_ACTIVATION_BUZZLY_FOCUS_CONTENIDO,
  PRE_ACTIVATION_BUZZLY_FOCUS_AMBOS,
  PRE_ACTIVATION_FIELD_CREATIVE_MATERIAL_LEVEL,
  PRE_ACTIVATION_HINT_CREATIVE_MATERIAL_LEVEL,
  PRE_ACTIVATION_CREATIVE_MATERIAL_SI_MUCHO,
  PRE_ACTIVATION_CREATIVE_MATERIAL_SI_POCO,
  PRE_ACTIVATION_CREATIVE_MATERIAL_NO_IA,
  PRE_ACTIVATION_FIELD_CREATIVE_MATERIAL_LOCATION,
  PRE_ACTIVATION_FIELD_ADDITIONAL_MEETING_NOTES,
  PRE_ACTIVATION_PLACEHOLDER_MONTHLY_SALES,
  PRE_ACTIVATION_PLACEHOLDER_SALES_GOAL_60_90,
  PRE_ACTIVATION_PLACEHOLDER_CREATIVE_MATERIAL_LOCATION,
  PRE_ACTIVATION_PLACEHOLDER_ADDITIONAL_MEETING_NOTES,
  PRE_ACTIVATION_MEETING_INTRO,
  PRE_ACTIVATION_FIELD_MEETING_ACCESS,
  PRE_ACTIVATION_MEETING_ACCESS_META_BM,
  PRE_ACTIVATION_MEETING_ACCESS_GOOGLE_ADS,
  PRE_ACTIVATION_MEETING_ACCESS_TIKTOK_ADS,
  PRE_ACTIVATION_MEETING_ACCESS_GA4,
  PRE_ACTIVATION_MEETING_ACCESS_PIXEL,
  PRE_ACTIVATION_MEETING_ACCESS_GTM,
  PRE_ACTIVATION_FIELD_ACCESS_NOT_READY,
  PRE_ACTIVATION_HINT_ACCESS_NOT_READY,
  PRE_ACTIVATION_PLACEHOLDER_ACCESS_NOT_READY,
  PRE_ACTIVATION_ARIA_REQUIRED,
  PRE_ACTIVATION_SUBMIT_BUTTON,
  PRE_ACTIVATION_SUBMIT_SUCCESS_TITLE,
  PRE_ACTIVATION_SUBMIT_SUCCESS_MESSAGE,
  PRE_ACTIVATION_CONFIDENTIALITY_NOTE,
  PRE_ACTIVATION_FIELD_ORGANIZATION_TYPE,
  PRE_ACTIVATION_HINT_ORGANIZATION_TYPE,
  PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY_LABEL,
  PRE_ACTIVATION_ORGANIZATION_TYPE_BRAND_LABEL,
  PRE_ACTIVATION_SECTION_CONTACT,
  PRE_ACTIVATION_FIELD_JOB_TITLE,
  PRE_ACTIVATION_PLACEHOLDER_JOB_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_01_BASICS,
  PRE_ACTIVATION_SECTION_AGENCY_02_LIVE_EXERCISE,
  PRE_ACTIVATION_SECTION_AGENCY_03_OPERATIONS,
  PRE_ACTIVATION_SECTION_AGENCY_04_MEETING_ACCESS,
  PRE_ACTIVATION_FIELD_AGENCY_PLATFORM_USERS_COUNT,
  PRE_ACTIVATION_HINT_AGENCY_PLATFORM_USERS_COUNT,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_PLATFORM_USERS_COUNT,
  PRE_ACTIVATION_FIELD_AGENCY_AD_PLATFORMS,
  PRE_ACTIVATION_FIELD_AGENCY_MODULES,
  PRE_ACTIVATION_HINT_AGENCY_MODULES,
  PRE_ACTIVATION_AGENCY_MODULE_CREATIVE,
  PRE_ACTIVATION_AGENCY_MODULE_PAID_MEDIA,
  PRE_ACTIVATION_AGENCY_MODULE_ORGANIC_SOCIAL,
  PRE_ACTIVATION_AGENCY_MODULE_COMPETITOR_ADS,
  PRE_ACTIVATION_FIELD_AGENCY_SESSION_BRAND_NAME,
  PRE_ACTIVATION_HINT_AGENCY_SESSION_BRAND_NAME,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_SESSION_BRAND_NAME,
  PRE_ACTIVATION_FIELD_AGENCY_BRAND_ASSETS_READY,
  PRE_ACTIVATION_HINT_AGENCY_BRAND_ASSETS_READY,
  PRE_ACTIVATION_FIELD_AGENCY_CREATIVE_BOTTLENECK,
  PRE_ACTIVATION_HINT_AGENCY_CREATIVE_BOTTLENECK,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_CREATIVE_BOTTLENECK,
  PRE_ACTIVATION_FIELD_AGENCY_USES_AD_AUTOMATION,
  PRE_ACTIVATION_HINT_AGENCY_USES_AD_AUTOMATION,
  PRE_ACTIVATION_OPTION_YES,
  PRE_ACTIVATION_OPTION_NO,
  PRE_ACTIVATION_BEFORE_START_LABEL,
  PRE_ACTIVATION_BEFORE_START_TITLE,
  PRE_ACTIVATION_BEFORE_START_INTRO,
  PRE_ACTIVATION_BEFORE_START_TIP_1_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_1_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_TIP_2_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_2_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_TIP_3_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_3_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_TIP_4_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_4_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_TIP_5_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_5_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_CALLOUT,
  PRE_ACTIVATION_ADS_PLATFORM_LINKEDIN,
  PRE_ACTIVATION_FIELD_AGENCY_PHONE,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_PHONE,
  PRE_ACTIVATION_FIELD_AGENCY_JOB_TITLE,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_JOB_TITLE,
  PRE_ACTIVATION_FIELD_AGENCY_BACKUP_CONTACT,
  PRE_ACTIVATION_HINT_AGENCY_BACKUP_CONTACT,
  PRE_ACTIVATION_FIELD_AGENCY_LEADERSHIP_CONTACT,
  PRE_ACTIVATION_HINT_AGENCY_LEADERSHIP_CONTACT,
  PRE_ACTIVATION_SECTION_CONTACT_DESCRIPTION_AGENCY,
  PRE_ACTIVATION_SECTION_AGENCY_02_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_02_SUBTITLE,
  PRE_ACTIVATION_SECTION_AGENCY_03_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_03_SUBTITLE,
  PRE_ACTIVATION_SECTION_AGENCY_04_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_04_SUBTITLE,
  PRE_ACTIVATION_SECTION_AGENCY_04_DESCRIPTION,
  PRE_ACTIVATION_SECTION_AGENCY_05_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_05_SUBTITLE,
  PRE_ACTIVATION_SECTION_AGENCY_05_DESCRIPTION,
  PRE_ACTIVATION_SECTION_AGENCY_06_TITLE,
  PRE_ACTIVATION_SECTION_AGENCY_06_HEADING,
  PRE_ACTIVATION_FIELD_AGENCY_USER_FULL_NAME,
  PRE_ACTIVATION_FIELD_AGENCY_USER_EMAIL,
  PRE_ACTIVATION_FIELD_AGENCY_TEAM_FAMILIARITY,
  PRE_ACTIVATION_HINT_AGENCY_TEAM_FAMILIARITY,
  PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_ADVANCED,
  PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INTERMEDIATE,
  PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INITIAL,
  PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_MIXED,
  PRE_ACTIVATION_AGENCY_TEAM_CALLOUT,
  PRE_ACTIVATION_FIELD_AGENCY_BRAND_WEBSITE,
  PRE_ACTIVATION_HINT_AGENCY_BRAND_WEBSITE,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_BRAND_WEBSITE,
  PRE_ACTIVATION_AGENCY_SCHEDULE_BUTTON,
  PRE_ACTIVATION_AGENCY_SCHEDULE_LOCKED_HINT,
  PRE_ACTIVATION_ONBOARDING_MODAL_ARIA_LABEL,
  PRE_ACTIVATION_ONBOARDING_MODAL_TITLE,
  PRE_ACTIVATION_ONBOARDING_MODAL_DESCRIPTION,
  PRE_ACTIVATION_SCHEDULED_SESSION_TITLE,
  PRE_ACTIVATION_SCHEDULED_SESSION_DATE,
  PRE_ACTIVATION_SCHEDULED_SESSION_TIME,
  PRE_ACTIVATION_SCHEDULED_SESSION_MISSING,
  PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_SINGLE_BRAND,
  PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_ACCOUNT_ADMIN,
  PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_RESCHEDULE,
  PRE_ACTIVATION_SUBMIT_SUCCESS_MESSAGE_AGENCY,
  OWNER_FORM_SUBMISSION_COLUMN_ORGANIZATION_TYPE,
  TIKTOK_ADGROUP_PLACEMENTS_TITLE,
  TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_LABEL,
  TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_DESCRIPTION,
  TIKTOK_ADGROUP_PLACEMENTS_PANGLE_LABEL,
  TIKTOK_ADGROUP_PLACEMENTS_PANGLE_DESCRIPTION,
  POST,
  ALERT_IMAGE_PROVIDER_STATUS_BANNER,
  ALERT_VIDEO_PROVIDER_STATUS_BANNER,
  ALERT_CAMPAIGN_PROVIDER_STATUS_BANNER,
  WHATSAPP,
  ID_PLATFORM,
  APPSUMO_CALLBACK_CONNECTING,
  APPSUMO_CALLBACK_ERROR_TITLE,
  APPSUMO_CALLBACK_ERROR_DESCRIPTION,
  APPSUMO_CALLBACK_ERROR_CODE_EXPIRED,
  APPSUMO_CALLBACK_ERROR_OAUTH_DENIED,
  APPSUMO_CALLBACK_BUTTON_RETURN_TO_APPSUMO,
  APPSUMO_CALLBACK_ERROR_ANOMALOUS,
  APPSUMO_REGISTER_TITLE,
  APPSUMO_REGISTER_SUBTITLE,
  APPSUMO_REGISTER_BUTTON_SUBMIT,
  APPSUMO_REGISTER_SESSION_EXPIRED,
  APP_SUMO_REACTIVATION_NOT_ELIGIBLE,
  APPSUMO_REACTIVATION_OTP_TITLE,
  APPSUMO_REACTIVATION_OTP_EMAIL_SENT,
  BUTTON_HIRE_PERFORMANCE_SPECIALIST,
  MODAL_PERFORMANCE_SPECIALIST_ARIA_LABEL,
  MODAL_PERFORMANCE_SPECIALIST_TITLE,
  MODAL_PERFORMANCE_SPECIALIST_SUBTITLE,
  MODAL_PERFORMANCE_SPECIALIST_WHAT_YOU_GET_TITLE,
  MODAL_PERFORMANCE_SPECIALIST_FEATURE_1,
  MODAL_PERFORMANCE_SPECIALIST_FEATURE_2,
  MODAL_PERFORMANCE_SPECIALIST_FEATURE_3,
  MODAL_PERFORMANCE_SPECIALIST_FEATURE_4,
  MODAL_PERFORMANCE_SPECIALIST_PRICING_TITLE,
  MODAL_PERFORMANCE_SPECIALIST_PRICING_MAIN,
  MODAL_PERFORMANCE_SPECIALIST_PRICING_NOTE_1,
  MODAL_PERFORMANCE_SPECIALIST_PRICING_NOTE_2,
  MODAL_PERFORMANCE_SPECIALIST_CTA,
  MODAL_AD_HOC_SUPPORT_ARIA_LABEL,
  MODAL_AD_HOC_SUPPORT_TITLE,
  MODAL_AD_HOC_SUPPORT_DESCRIPTION,
  BILLING_SPECIALIST_PURCHASE_SUCCESS_TITLE,
  BILLING_SPECIALIST_PURCHASE_SUCCESS_DESCRIPTION,
  BILLING_SPECIALIST_SCHEDULE_MEETING_BUTTON,
  ALERT_AD_ACCOUNT_STATUS_UNSETTLED_PREPAY_LABEL,
  ALERT_AD_ACCOUNT_NO_BALANCE_LABEL,
  MODAL_CREATE_WITH_IA_LABEL_VIDEO_DURATION_SECONDS,
  MODAL_CREATE_WITH_IA_VIDEO_DURATION_12_SECONDS,
  MODAL_CREATE_WITH_IA_VIDEO_DURATION_15_SECONDS,
  MODAL_CREATE_WITH_IA_VIDEO_DURATION_20_SECONDS,
  MODAL_CREATE_WITH_IA_VIDEO_DURATION_25_SECONDS,
  MODAL_CREATE_WITH_IA_VIDEO_DURATION_30_SECONDS,
  ENTERPRISE_INTAKE_BADGE,
  ENTERPRISE_INTAKE_BADGE_AGENCY,
  ENTERPRISE_INTAKE_BADGE_BRAND,
  ENTERPRISE_INTAKE_HERO_TITLE,
  ENTERPRISE_INTAKE_HERO_DESCRIPTION,
  ENTERPRISE_INTAKE_SECTION_01_CONTACT,
  ENTERPRISE_INTAKE_SECTION_03_USERS,
  ENTERPRISE_INTAKE_SECTION_04_SUPPORT_CONTRACT,
  ENTERPRISE_INTAKE_SECTION_05_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_ARIA_REQUIRED,
  ENTERPRISE_INTAKE_SUBMIT_BUTTON,
  ENTERPRISE_INTAKE_SUBMIT_SUCCESS_TITLE,
  ENTERPRISE_INTAKE_SUBMIT_SUCCESS_MESSAGE,
  ENTERPRISE_INTAKE_CONFIDENTIALITY_NOTE,
  ENTERPRISE_INTAKE_OTHER_OPTION,
  ENTERPRISE_INTAKE_OTHER_PLACEHOLDER,
  ENTERPRISE_INTAKE_FIELD_FULL_NAME,
  ENTERPRISE_INTAKE_FIELD_CORPORATE_EMAIL,
  ENTERPRISE_INTAKE_FIELD_COMPANY_NAME,
  ENTERPRISE_INTAKE_FIELD_JOB_TITLE,
  ENTERPRISE_INTAKE_FIELD_COMPANY_WEBSITE,
  ENTERPRISE_INTAKE_PLACEHOLDER_FULL_NAME,
  ENTERPRISE_INTAKE_PLACEHOLDER_CORPORATE_EMAIL,
  ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME,
  ENTERPRISE_INTAKE_PLACEHOLDER_JOB_TITLE,
  ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_WEBSITE,
  ENTERPRISE_INTAKE_FIELD_PURCHASE_DECISION_MAKER,
  ENTERPRISE_INTAKE_PURCHASE_DECISION_SELF,
  ENTERPRISE_INTAKE_PURCHASE_DECISION_COLLECT_INFO,
  ENTERPRISE_INTAKE_PURCHASE_DECISION_SHARED,
  ENTERPRISE_INTAKE_FIELD_CURRENT_TOOL_OR_ADLE_STATUS,
  ENTERPRISE_INTAKE_CURRENT_TOOL_ADLE_CLIENT,
  ENTERPRISE_INTAKE_CURRENT_TOOL_EVALUATING_SWITCH,
  ENTERPRISE_INTAKE_CURRENT_TOOL_NO_SIMILAR,
  ENTERPRISE_INTAKE_FIELD_OPERATING_COUNTRIES_COUNT,
  ENTERPRISE_INTAKE_PLACEHOLDER_OPERATING_COUNTRIES_COUNT,
  ENTERPRISE_INTAKE_FIELD_CREATIVES_VARY_BY_MARKET,
  ENTERPRISE_INTAKE_CREATIVES_VARY_YES_PER_MARKET,
  ENTERPRISE_INTAKE_CREATIVES_VARY_PARTIALLY,
  ENTERPRISE_INTAKE_CREATIVES_VARY_NO_SAME_MATERIAL,
  ENTERPRISE_INTAKE_CREATIVES_VARY_NOT_APPLICABLE,
  ENTERPRISE_INTAKE_SECTION_02_MODULE_SELECTOR,
  ENTERPRISE_INTAKE_HINT_SECTION_02_MODULES,
  ENTERPRISE_INTAKE_FIELD_SELECTED_ADLE_MODULES,
  ENTERPRISE_INTAKE_MODULE_CREATIVE_ASSETS,
  ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_LAUNCH,
  ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_IMPORT,
  ENTERPRISE_INTAKE_MODULE_ORGANIC_SOCIAL,
  ENTERPRISE_INTAKE_FIELD_PRIMARY_GOAL,
  ENTERPRISE_INTAKE_PRIMARY_GOAL_CREATIVE_SPEED,
  ENTERPRISE_INTAKE_PRIMARY_GOAL_PERFORMANCE,
  ENTERPRISE_INTAKE_PRIMARY_GOAL_SCALE_MULTIPLATFORM,
  ENTERPRISE_INTAKE_PRIMARY_GOAL_REDUCE_COSTS,
  ENTERPRISE_INTAKE_PRIMARY_GOAL_CENTRALIZE_OPERATIONS,
  ENTERPRISE_INTAKE_VOLUME_STABLE_YEAR_ROUND,
  ENTERPRISE_INTAKE_VOLUME_PEAK_DEMAND,
  ENTERPRISE_INTAKE_SECTION_MODULE_1_CREATIVE_ASSETS,
  ENTERPRISE_INTAKE_MODULE1_INTRO,
  ENTERPRISE_INTAKE_MODULE1_FIELD_BRANDS_OR_VISUAL_IDENTITIES_COUNT,
  ENTERPRISE_INTAKE_MODULE1_FIELD_INDEPENDENT_BRAND_CONFIGS_COUNT,
  ENTERPRISE_INTAKE_MODULE1_HINT_INDEPENDENT_BRAND_CONFIGS,
  ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_NEW_IMAGES_COUNT,
  ENTERPRISE_INTAKE_MODULE1_FIELD_FORMATS_PER_PIECE_AVG,
  ENTERPRISE_INTAKE_MODULE1_HINT_FORMATS_PER_PIECE,
  ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_ADDITIONAL_EDITS_COUNT,
  ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_ADDITIONAL_EDITS,
  ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_VIDEOS_COUNT,
  ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_VIDEOS,
  ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_IMAGE_ANIMATIONS_COUNT,
  ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_IMAGE_ANIMATIONS,
  ENTERPRISE_INTAKE_MODULE1_FIELD_VERSIONS_PER_PIECE_BEFORE_APPROVAL,
  ENTERPRISE_INTAKE_MODULE1_HINT_VERSIONS_PER_PIECE,
  ENTERPRISE_INTAKE_MODULE1_FIELD_CREATIVE_VOLUME_VARIATION,
  ENTERPRISE_INTAKE_MODULE1_FIELD_PEAK_MONTH_PIECES_COUNT,
  ENTERPRISE_INTAKE_SECTION_MODULE_2_PAID_MEDIA_LAUNCH,
  ENTERPRISE_INTAKE_MODULE2_INTRO,
  ENTERPRISE_INTAKE_MODULE2_FIELD_AD_ACCOUNTS_OR_ADVERTISERS_COUNT,
  ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_CAMPAIGNS_COUNT,
  ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_CAMPAIGNS,
  ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_OPTIMIZATIONS_COUNT,
  ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_OPTIMIZATIONS,
  ENTERPRISE_INTAKE_MODULE2_FIELD_CAMPAIGN_VOLUME_VARIATION,
  ENTERPRISE_INTAKE_MODULE2_FIELD_PEAK_MONTH_CAMPAIGNS_COUNT,
  ENTERPRISE_INTAKE_SECTION_MODULE_3_PAID_MEDIA_IMPORT,
  ENTERPRISE_INTAKE_MODULE3_INTRO,
  ENTERPRISE_INTAKE_MODULE3_FIELD_CAMPAIGNS_TO_IMPORT,
  ENTERPRISE_INTAKE_MODULE3_FIELD_IMPORT_PLATFORMS,
  ENTERPRISE_INTAKE_MODULE3_PLATFORM_META,
  ENTERPRISE_INTAKE_MODULE3_PLATFORM_GOOGLE,
  ENTERPRISE_INTAKE_MODULE3_PLATFORM_TIKTOK,
  ENTERPRISE_INTAKE_MODULE3_PLATFORM_LINKEDIN,
  ENTERPRISE_INTAKE_SECTION_MODULE_4_ORGANIC_SOCIAL,
  ENTERPRISE_INTAKE_MODULE4_INTRO,
  ENTERPRISE_INTAKE_MODULE4_FIELD_MONTHLY_ORGANIC_POSTS,
  ENTERPRISE_INTAKE_MODULE4_FIELD_SCHEDULING_NETWORKS,
  ENTERPRISE_INTAKE_MODULE4_NETWORK_INSTAGRAM,
  ENTERPRISE_INTAKE_MODULE4_NETWORK_FACEBOOK,
  ENTERPRISE_INTAKE_MODULE4_NETWORK_TIKTOK,
  ENTERPRISE_INTAKE_MODULE4_NETWORK_LINKEDIN,
  ENTERPRISE_INTAKE_MODULE4_NETWORK_X_TWITTER,
  ENTERPRISE_INTAKE_MODULE4_FIELD_POST_CREATION_SOURCE,
  ENTERPRISE_INTAKE_MODULE4_POST_CREATED_IN_ADLE,
  ENTERPRISE_INTAKE_MODULE4_POST_READY_TO_SCHEDULE,
  ENTERPRISE_INTAKE_MODULE4_POST_MIXED,
  ENTERPRISE_INTAKE_FIELD_ACTIVE_ADVERTISERS_MONTH1,
  ENTERPRISE_INTAKE_HINT_ACTIVE_ADVERTISERS_MONTH1,
  ENTERPRISE_INTAKE_FIELD_TOTAL_ADVERTISERS_60_90,
  ENTERPRISE_INTAKE_HINT_TOTAL_ADVERTISERS_60_90,
  ENTERPRISE_INTAKE_FIELD_ADMIN_ACCESS_PHASE1,
  ENTERPRISE_INTAKE_ADMIN_ACCESS_ALL,
  ENTERPRISE_INTAKE_ADMIN_ACCESS_MOST,
  ENTERPRISE_INTAKE_ADMIN_ACCESS_SOME,
  ENTERPRISE_INTAKE_FIELD_PLATFORM_USERS_COUNT,
  ENTERPRISE_INTAKE_FIELD_PLATFORM_CAPACITY_MANAGEMENT,
  ENTERPRISE_INTAKE_PLATFORM_CAPACITY_CENTRALIZED_POOL,
  ENTERPRISE_INTAKE_PLATFORM_CAPACITY_ASSIGNED_QUOTAS,
  ENTERPRISE_INTAKE_CREDITS_MIXED,
  ENTERPRISE_INTAKE_CREDITS_EQUIVALENCES_TITLE,
  ENTERPRISE_INTAKE_CREDITS_RENEWAL_NOTE,
  ENTERPRISE_INTAKE_CREDITS_UNCERTAIN_NOTE,
  ENTERPRISE_INTAKE_VOLUME_ZERO,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_ESTIMATED_CREDITS,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_IMAGES,
  ENTERPRISE_INTAKE_HINT_MONTHLY_AI_IMAGES,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_VIDEOS,
  ENTERPRISE_INTAKE_HINT_MONTHLY_AI_VIDEOS,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_CAMPAIGNS,
  ENTERPRISE_INTAKE_HINT_MONTHLY_AI_CAMPAIGNS,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_OPTIMIZATIONS,
  ENTERPRISE_INTAKE_HINT_MONTHLY_AI_OPTIMIZATIONS,
  ENTERPRISE_INTAKE_FIELD_USES_ORGANIC_SCHEDULING,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_ORGANIC_POSTS,
  ENTERPRISE_INTAKE_HINT_MONTHLY_ORGANIC_POSTS,
  ENTERPRISE_INTAKE_HINT_MONTHLY_ESTIMATED_CREDITS,
  ENTERPRISE_INTAKE_FIELD_PHASE1_PAID_CHANNELS,
  ENTERPRISE_INTAKE_HINT_PHASE1_PAID_CHANNELS,
  ENTERPRISE_INTAKE_CHANNEL_META,
  ENTERPRISE_INTAKE_CHANNEL_GOOGLE,
  ENTERPRISE_INTAKE_CHANNEL_TIKTOK,
  ENTERPRISE_INTAKE_CHANNEL_LINKEDIN,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_AD_SPEND_RANGE,
  ENTERPRISE_INTAKE_HINT_MONTHLY_AD_SPEND_RANGE,
  ENTERPRISE_INTAKE_AD_SPEND_LESS_THAN_10K,
  ENTERPRISE_INTAKE_AD_SPEND_MORE_THAN_500K,
  ENTERPRISE_INTAKE_FIELD_PLATFORM_MANAGEMENT,
  ENTERPRISE_INTAKE_HINT_PLATFORM_MANAGEMENT,
  ENTERPRISE_INTAKE_PLATFORM_MGMT_OWN_TEAM,
  ENTERPRISE_INTAKE_PLATFORM_MGMT_THIRD_PARTY,
  ENTERPRISE_INTAKE_PLATFORM_MGMT_ADLE_OPERATES,
  ENTERPRISE_INTAKE_FIELD_WHITE_LABEL,
  ENTERPRISE_INTAKE_HINT_WHITE_LABEL,
  ENTERPRISE_INTAKE_WHITE_LABEL_ESSENTIAL,
  ENTERPRISE_INTAKE_WHITE_LABEL_INTERESTED,
  ENTERPRISE_INTAKE_WHITE_LABEL_NOT_NEEDED,
  ENTERPRISE_INTAKE_WHITE_LABEL_UNSURE,
  ENTERPRISE_INTAKE_FIELD_URGENCY_DEADLINE,
  ENTERPRISE_INTAKE_PLACEHOLDER_URGENCY_DEADLINE,
  ENTERPRISE_INTAKE_FIELD_ESTIMATED_TOOL_BUDGET,
  ENTERPRISE_INTAKE_HINT_ESTIMATED_TOOL_BUDGET,
  ENTERPRISE_INTAKE_BUDGET_LT_1000,
  ENTERPRISE_INTAKE_BUDGET_1000_2500,
  ENTERPRISE_INTAKE_BUDGET_2500_5000,
  ENTERPRISE_INTAKE_BUDGET_5000_10000,
  ENTERPRISE_INTAKE_BUDGET_GT_10000,
  ENTERPRISE_INTAKE_BUDGET_NOT_DEFINED,
  ENTERPRISE_INTAKE_BUDGET_PREFER_NOT_ANSWER,
  ENTERPRISE_INTAKE_FIELD_SUPPORT_LEVEL,
  ENTERPRISE_INTAKE_SUPPORT_TECH_ONLY,
  ENTERPRISE_INTAKE_SUPPORT_PARTIAL,
  ENTERPRISE_INTAKE_SUPPORT_FULL_OPERATION,
  ENTERPRISE_INTAKE_FIELD_CSM_CADENCE,
  ENTERPRISE_INTAKE_CSM_WEEKLY,
  ENTERPRISE_INTAKE_CSM_BIWEEKLY,
  ENTERPRISE_INTAKE_CSM_MONTHLY,
  ENTERPRISE_INTAKE_CSM_AS_NEEDED,
  ENTERPRISE_INTAKE_FIELD_CONTRACT_FORMAT,
  ENTERPRISE_INTAKE_CONTRACT_MONTHLY,
  ENTERPRISE_INTAKE_CONTRACT_QUARTERLY,
  ENTERPRISE_INTAKE_CONTRACT_ANNUAL,
  ENTERPRISE_INTAKE_FIELD_IMPLEMENTATION_TIMELINE,
  ENTERPRISE_INTAKE_HINT_IMPLEMENTATION_TIMELINE,
  ENTERPRISE_INTAKE_TIMELINE_0_3_DAYS,
  ENTERPRISE_INTAKE_TIMELINE_4_7_DAYS,
  ENTERPRISE_INTAKE_TIMELINE_8_15_DAYS,
  ENTERPRISE_INTAKE_TIMELINE_16_30_DAYS,
  ENTERPRISE_INTAKE_TIMELINE_30_PLUS_DAYS,
  ENTERPRISE_INTAKE_FIELD_SECURITY_REQUIREMENTS,
  ENTERPRISE_INTAKE_SECURITY_SSO,
  ENTERPRISE_INTAKE_SECURITY_AUDIT_LOGS,
  ENTERPRISE_INTAKE_SECURITY_NOT_APPLICABLE,
  ENTERPRISE_INTAKE_FIELD_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_FOOTNOTE_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_HINT_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_PLACEHOLDER_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_MODULE_REPORTS,
  ENTERPRISE_INTAKE_MODULE_COMPETITORS,
  ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT,
  ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT_AGENCY,
  ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_AGENCY,
  ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_BRAND,
  ENTERPRISE_INTAKE_PLACEHOLDER_SCOPE_BRANDS_COUNT,
  ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME_BRAND,
  ENTERPRISE_INTAKE_HINT_MONTHLY_STATIC_PIECES,
  ENTERPRISE_INTAKE_FIELD_CREATIVES_BUFFER,
  ENTERPRISE_INTAKE_HINT_CREATIVES_BUFFER,
  ENTERPRISE_INTAKE_BUFFER_STATICS,
  ENTERPRISE_INTAKE_BUFFER_ANIMATIONS,
  ENTERPRISE_INTAKE_BUFFER_VIDEOS,
  ENTERPRISE_INTAKE_BUFFER_NONE,
  ENTERPRISE_INTAKE_FIELD_CREATIVES_BUFFER_PERCENT,
  ENTERPRISE_INTAKE_BUFFER_PERCENT_10,
  ENTERPRISE_INTAKE_BUFFER_PERCENT_15,
  ENTERPRISE_INTAKE_BUFFER_PERCENT_20,
  ENTERPRISE_INTAKE_PLACEHOLDER_BUFFER_PERCENT_OTHER,
  ENTERPRISE_INTAKE_HINT_CAMPAIGNS_SECTION,
  ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_AGENCY,
  ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_BRAND,
  ENTERPRISE_INTAKE_FIELD_OPTIMIZATION_FREQUENCY,
  ENTERPRISE_INTAKE_HINT_OPTIMIZATION_FREQUENCY,
  ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_LOW,
  ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_MEDIUM,
  ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_HIGH,
  ENTERPRISE_INTAKE_HINT_PLATFORM_USERS_COUNT,
  ENTERPRISE_INTAKE_HINT_CONTRACT_TERM,
  ENTERPRISE_INTAKE_CONTRACT_TERM_6,
  ENTERPRISE_INTAKE_CONTRACT_TERM_12,
  ENTERPRISE_INTAKE_FIELD_MEDIA_MANAGEMENT_ADDON,
  ENTERPRISE_INTAKE_HINT_MEDIA_MANAGEMENT_ADDON,
  ENTERPRISE_INTAKE_MEDIA_ADDON_YES,
  ENTERPRISE_INTAKE_MEDIA_ADDON_NO,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_MEDIA_SPEND,
  ENTERPRISE_INTAKE_PLACEHOLDER_MONTHLY_MEDIA_SPEND,
  ENTERPRISE_INTAKE_WHITE_LABEL_YES,
  ENTERPRISE_INTAKE_WHITE_LABEL_NO,
  ENTERPRISE_INTAKE_SECTION_PLAN,
  OWNER_FORM_SUBMISSION_TYPE_PRE_ACTIVATION,
  OWNER_FORM_SUBMISSION_TYPE_ENTERPRISE,
  OPTION_EMAIL,
  OPTION_META,
  OPTION_LINKEDIN,
  OPTION_GOOGLE,
  OPTION_LLM,
  OPTION_OTHER,
  GLOBAL_REPORT_TITLE,
  GLOBAL_REPORT_DESCRIPTION,
  GLOBAL_REPORT_MENU_GROUP,
  GLOBAL_REPORT_MENU_ITEM,
  GLOBAL_REPORT_PAGE_TITLE,
  GLOBAL_REPORT_PERIOD_LAST_7_DAYS,
  GLOBAL_REPORT_PERIOD_LAST_14_DAYS,
  GLOBAL_REPORT_PERIOD_LAST_30_DAYS,
  GLOBAL_REPORT_AI_ANALYSIS,
  GLOBAL_REPORT_OBJECTIVES_BUTTON,
  GLOBAL_REPORT_TOTAL_INVESTMENT,
  GLOBAL_REPORT_AVERAGE_ROAS,
  GLOBAL_REPORT_ACTIVE_CAMPAIGNS,
  GLOBAL_REPORT_REMAINING_BUDGET,
  GLOBAL_REPORT_BUDGET_EXPIRES_IN,
  GLOBAL_REPORT_PAUSED_CAMPAIGNS,
  GLOBAL_REPORT_VS_PREVIOUS_WEEK,
  GLOBAL_REPORT_AGENT_INSIGHTS,
  GLOBAL_REPORT_NEW_INSIGHTS,
  GLOBAL_REPORT_NO_INSIGHTS,
  GLOBAL_REPORT_INSIGHTS_ERROR,
  GLOBAL_REPORT_SUMMARY_TITLE,
  GLOBAL_REPORT_SUMMARY_OVERVIEW_TEXT,
  GLOBAL_REPORT_INSIGHTS_QUESTION,
  GLOBAL_REPORT_GENERATING_SUMMARY,
  GLOBAL_REPORT_SUMMARY_NOT_GENERATED,
  GLOBAL_REPORT_ASK_QUESTION,
  GLOBAL_REPORT_ASK_QUESTION_OPEN,
  GLOBAL_REPORT_VIEW_HISTORICAL_INSIGHTS,
  GLOBAL_REPORT_AGENT_ACTIONS,
  GLOBAL_REPORT_ACTIONS_PERFORMED,
  GLOBAL_REPORT_ACTION_TYPE_GENERATE_CAMPAIGN,
  GLOBAL_REPORT_ACTION_TYPE_CREATIVES,
  GLOBAL_REPORT_ACTION_TYPE_VIDEOS,
  GLOBAL_REPORT_ACTION_TYPE_MESSAGES,
  GLOBAL_REPORT_ACTION_TYPE_OPTIMIZATIONS_APPLIED,
  GLOBAL_REPORT_ACTION_TYPE_GENERIC,
  GLOBAL_REPORT_ACTION_CREATIVES_SUBTITLE,
  GLOBAL_REPORT_ACTION_VIDEOS_SUBTITLE,
  GLOBAL_REPORT_ACTION_MESSAGES_SUBTITLE,
  GLOBAL_REPORT_ACTION_GENERIC_SUBTITLE,
  GLOBAL_REPORT_NO_ACTIONS_IN_PERIOD,
  GLOBAL_REPORT_NO_CAMPAIGNS_IN_PERIOD,
  GLOBAL_REPORT_NO_ACTIVITY_IN_PERIOD,
  GLOBAL_REPORT_SELECT_DATES_PROMPT,
  GLOBAL_REPORT_MEASURABLE_KPI_LABEL,
  GLOBAL_REPORT_MEASURABLE_KPI_ALL,
  GLOBAL_REPORT_NO_CAMPAIGNS_FOR_KPI,
  GLOBAL_REPORT_DOWNLOAD_NOT_READY,
  GLOBAL_REPORT_PDF_OPTION,
  GLOBAL_REPORT_CUSTOM_OPTION,
  GLOBAL_REPORT_SERVER_PDF_BUTTON,
  GLOBAL_REPORT_SERVER_PDF_FOOTER,
  GLOBAL_REPORT_SERVER_PDF_FILE_NAME,
  MODAL_CUSTOM_REPORT_CTA,
  MODAL_CUSTOM_REPORT_TITLE,
  MODAL_CUSTOM_REPORT_DESCRIPTION,
  MODAL_CUSTOM_REPORT_TEMPLATE,
  MODAL_CUSTOM_REPORT_TEMPLATE_GENERAL,
  MODAL_CUSTOM_REPORT_TEMPLATE_SALES,
  MODAL_CUSTOM_REPORT_TEMPLATE_LEADS,
  MODAL_CUSTOM_REPORT_TEMPLATE_CUSTOM,
  MODAL_CUSTOM_REPORT_PROMPT,
  MODAL_CUSTOM_REPORT_PROMPT_PLACEHOLDER,
  MODAL_CUSTOM_REPORT_USE_PREVIOUS_PROMPT,
  MODAL_CUSTOM_REPORT_DATES,
  MODAL_CUSTOM_REPORT_FORMAT,
  MODAL_CUSTOM_REPORT_LANGUAGE,
  MODAL_CUSTOM_REPORT_FORMAT_PDF,
  MODAL_CUSTOM_REPORT_FORMAT_PPTX,
  MODAL_CUSTOM_REPORT_FORMAT_CSV,
  MODAL_CUSTOM_REPORT_PROMPT_PLACEHOLDER_CSV,
  MODAL_CUSTOM_REPORT_PDF_UNAVAILABLE,
  MODAL_CUSTOM_REPORT_COLLECTING,
  MODAL_CUSTOM_REPORT_ANALYZING,
  MODAL_CUSTOM_REPORT_RENDERING,
  MODAL_CUSTOM_REPORT_ERROR,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_TITLE,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DESCRIPTION,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_EMPTY,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE_TITLE,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE_DESCRIPTION,
  MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE,
  GLOBAL_REPORT_HEAVY_LOAD_FETCHING_CAMPAIGNS,
  GLOBAL_REPORT_HEAVY_LOAD_FETCHING_STATS,
  GLOBAL_REPORT_HEAVY_LOAD_ANALYZING,
  GLOBAL_REPORT_HEAVY_LOAD_GENERATING_INSIGHTS,
  GLOBAL_REPORT_ACTIVE_CAMPAIGNS_TABLE,
  GLOBAL_REPORT_CAMPAIGNS_TABLE,
  GLOBAL_REPORT_COLUMN_CAMPAIGN,
  GLOBAL_REPORT_COLUMN_INVESTMENT,
  GLOBAL_REPORT_COLUMN_ROAS,
  GLOBAL_REPORT_COLUMN_IMPRESSIONS,
  GLOBAL_REPORT_COLUMN_CTR,
  GLOBAL_REPORT_COLUMN_STATUS,
  GLOBAL_REPORT_STATUS_ALERT,
  GLOBAL_REPORT_STATUS_OPTIMAL,
  GLOBAL_REPORT_STATUS_BRAND,
  GLOBAL_REPORT_INSIGHT_ROAS_DROP_TITLE,
  GLOBAL_REPORT_INSIGHT_ROAS_DROP_DESCRIPTION,
  GLOBAL_REPORT_INSIGHT_CPC_PEAK_TITLE,
  GLOBAL_REPORT_INSIGHT_CPC_PEAK_DESCRIPTION,
  GLOBAL_REPORT_INSIGHT_VIDEO_OUTPERFORMS_TITLE,
  GLOBAL_REPORT_INSIGHT_VIDEO_OUTPERFORMS_DESCRIPTION,
  GLOBAL_REPORT_ACTION_DATE_TODAY,
  GLOBAL_REPORT_ACTION_DATE_YESTERDAY,
  GLOBAL_REPORT_ACTION_DATE_MAR_26,
  GLOBAL_REPORT_ACTION_DATE_MAR_25,
  GLOBAL_REPORT_ACTION_CAMPAIGNS_CREATED,
  GLOBAL_REPORT_ACTION_IMAGES_GENERATED,
  GLOBAL_REPORT_ACTION_VIDEOS_PRODUCED,
  GLOBAL_REPORT_ACTION_OPTIMIZATION_APPLIED,
  GLOBAL_REPORT_DEFAULT_BRAND_NAME,
  GLOBAL_REPORT_STATS_TIME_TITLE,
  GLOBAL_REPORT_STATS_TIME_SUBTITLE,
  GLOBAL_REPORT_STATS_DAILY_RESULTS_TITLE,
  GLOBAL_REPORT_STATS_WEEKLY_RESULTS_TITLE,
  GLOBAL_REPORT_STATS_MONTHLY_RESULTS_TITLE,
  GLOBAL_REPORT_STATS_DAILY_RESULTS_SUBTITLE,
  GLOBAL_REPORT_STATS_WEEKLY_TIME_SUBTITLE,
  GLOBAL_REPORT_STATS_MONTHLY_TIME_SUBTITLE,
  GLOBAL_REPORT_STATS_IMPRESSIONS_CTR_TITLE,
  GLOBAL_REPORT_STATS_IMPRESSIONS_CTR_SUBTITLE,
  GLOBAL_REPORT_STATS_WEEKLY_IMPRESSIONS_CTR_SUBTITLE,
  GLOBAL_REPORT_STATS_MONTHLY_IMPRESSIONS_CTR_SUBTITLE,
  GLOBAL_REPORT_STATS_PLATFORM_TITLE,
  GLOBAL_REPORT_STATS_PLATFORM_SUBTITLE,
  GLOBAL_REPORT_STATS_PLATFORM_CPA_TITLE,
  GLOBAL_REPORT_STATS_PLATFORM_SPEND_TITLE,
  GLOBAL_REPORT_STATS_CREATIVES_TITLE,
  GLOBAL_REPORT_STATS_CREATIVES_SUBTITLE,
  GLOBAL_REPORT_STATS_CREATIVES_LOWEST_CPA_TITLE,
  GLOBAL_REPORT_STATS_CREATIVES_HIGHEST_VOLUME_TITLE,
  GLOBAL_REPORT_STATS_RADAR_TITLE,
  GLOBAL_REPORT_STATS_RADAR_SUBTITLE,
  GLOBAL_REPORT_STATS_BELOW_AVERAGE,
  GLOBAL_REPORT_STATS_ABOVE_AVERAGE,
  GLOBAL_REPORT_STATS_NO_DATA,
  GLOBAL_REPORT_STATS_SPEND_AXIS,
  GLOBAL_REPORT_STATS_IMPRESSIONS_AXIS,
  GLOBAL_REPORT_STATS_SPEND_DISTRIBUTION,
  GLOBAL_REPORT_GOALS_TITLE,
  GLOBAL_REPORT_GOALS_SUBTITLE,
  GLOBAL_REPORT_GOALS_STACKED_TITLE,
  GLOBAL_REPORT_GOALS_STACKED_SUBTITLE,
  GLOBAL_REPORT_GOALS_PROJECTION_TITLE,
  GLOBAL_REPORT_GOALS_PROJECTION_SUBTITLE,
  GLOBAL_REPORT_GOALS_ACHIEVED,
  GLOBAL_REPORT_GOALS_REMAINING,
  GLOBAL_REPORT_GOALS_EXCEEDED,
  GLOBAL_REPORT_GOALS_PROJECTION_ACTUAL,
  GLOBAL_REPORT_GOALS_PROJECTION_FORECAST,
  GLOBAL_REPORT_GOALS_TARGET_LINE,
  GLOBAL_REPORT_GOALS_CONFIGURE_PROMPT,
  GLOBAL_REPORT_GOALS_CONFIGURE_BUTTON,
  GLOBAL_REPORT_GOALS_KPI_MISMATCH_PROMPT,
  VERIFICATION_CODE_INCORRECT,
  REGISTRATION_EMAIL_NOT_VERIFIED,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_TITLE_PRODUCTS,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_TITLE_SERVICES,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS_URL,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS_UPLOAD,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES_URL,
  MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES_UPLOAD,
  ORGANIC,
  ADVERTISER_SELECTOR_BRANDS_COUNT_SINGLE,
  ANIMATE,
  CAMPAIGN_APPROVAL_PAGE_TITLE,
  CAMPAIGN_APPROVAL_PAGE_DESCRIPTION,
  CAMPAIGN_APPROVAL_INVALID_TITLE,
  CAMPAIGN_APPROVAL_INVALID_DESCRIPTION,
  CAMPAIGN_APPROVAL_EXPIRED_TITLE,
  CAMPAIGN_APPROVAL_EXPIRED_DESCRIPTION,
  CAMPAIGN_APPROVAL_CONTENT_EMPTY,
  CAMPAIGN_APPROVAL_LOADING_FETCHING_CAMPAIGN_DATA,
  CAMPAIGN_APPROVAL_LOADING_PREPARING_REVIEW,
  CAMPAIGN_APPROVAL_GENERAL_COMMENT_TITLE,
  CAMPAIGN_APPROVAL_GENERAL_COMMENT_DESCRIPTION,
  CAMPAIGN_APPROVAL_COMMENT_PLACEHOLDER,
  CAMPAIGN_APPROVAL_COMMENT_BUTTON,
  CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_TITLE,
  CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_DESCRIPTION,
  CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_PLACEHOLDER,
  CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_BUTTON,
  CAMPAIGN_APPROVAL_DECISION_TITLE,
  CAMPAIGN_APPROVAL_DECISION_DESCRIPTION,
  CAMPAIGN_APPROVAL_DECISION_PLACEHOLDER,
  CAMPAIGN_APPROVAL_APPROVE_BUTTON,
  CAMPAIGN_APPROVAL_REJECT_BUTTON,
  CAMPAIGN_APPROVAL_TEXTS_TITLE,
  CAMPAIGN_APPROVAL_DESTINATION_TITLE,
  CAMPAIGN_APPROVAL_LEAD_FORM_PREVIEW_UNAVAILABLE,
  CAMPAIGN_APPROVAL_CREATIVES_TITLE,
  CAMPAIGN_APPROVAL_CREATIVE_TITLE,
  CAMPAIGN_APPROVAL_SLIDE_LABEL,
  CAMPAIGN_APPROVAL_FIELD_TITLE_LABEL,
  CAMPAIGN_APPROVAL_FIELD_HEADLINE_LABEL,
  CAMPAIGN_APPROVAL_FIELD_LONG_HEADLINE_LABEL,
  CAMPAIGN_APPROVAL_FIELD_DESCRIPTION_LABEL,
  CAMPAIGN_APPROVAL_FIELD_CREATIVE_LABEL,
  CAMPAIGN_APPROVAL_LOCKED_STATUS_APPROVED,
  CAMPAIGN_APPROVAL_LOCKED_STATUS_REJECTED,
  CAMPAIGN_APPROVAL_LOCKED_STATUS_DECIDED,
  CAMPAIGN_APPROVAL_TARGET_ENTITY_AD,
  CAMPAIGN_APPROVAL_TARGET_ENTITY_ASSETS_GROUP,
  CAMPAIGN_APPROVAL_CONTROLS_TITLE,
  CAMPAIGN_APPROVAL_CONTROLS_DESCRIPTION,
  CAMPAIGN_APPROVAL_INACTIVE_DESCRIPTION,
  CAMPAIGN_APPROVAL_STATE_INACTIVE,
  CAMPAIGN_APPROVAL_STATE_ACTIVE,
  CAMPAIGN_APPROVAL_SHARED_LINK_LABEL,
  CAMPAIGN_APPROVAL_CONFIRM_ENABLE_TITLE,
  CAMPAIGN_APPROVAL_CONFIRM_ENABLE_DESCRIPTION,
  CAMPAIGN_APPROVAL_ENABLE_BUTTON,
  CAMPAIGN_APPROVAL_COPY_LINK_BUTTON,
  CAMPAIGN_APPROVAL_COPY_LINK_COPIED,
  CAMPAIGN_APPROVAL_REJECTED_DESCRIPTION,
  CAMPAIGN_APPROVAL_APPROVED_DESCRIPTION,
  CAMPAIGN_APPROVAL_PENDING_DESCRIPTION,
  CAMPAIGN_APPROVAL_VIEW_COMMENTS_BUTTON,
  CAMPAIGN_APPROVAL_VIEW_REVIEW_BUTTON,
  CAMPAIGN_APPROVAL_STATUS_PENDING,
  CAMPAIGN_APPROVAL_STATUS_APPROVED,
  CAMPAIGN_APPROVAL_STATUS_REJECTED,
  GALLERY_CONTENT_APPROVAL_STATUS_REJECTED,
  CAMPAIGN_APPROVAL_PANEL_TITLE,
  CAMPAIGN_APPROVAL_PANEL_DESCRIPTION,
  CAMPAIGN_APPROVAL_PANEL_EMPTY,
  CAMPAIGN_APPROVAL_PANEL_STALE_TOGGLE,
  CAMPAIGN_APPROVAL_PANEL_CURRENT_DRAFT,
  CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_PENDING,
  CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_APPROVED,
  CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_REJECTED,
  CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_PENDING,
  CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_APPROVED,
  CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_REJECTED,
  CAMPAIGN_APPROVAL_STALE_LABEL,
  CAMPAIGN_APPROVAL_PUBLISH_BLOCKED_BANNER,
  CAMPAIGN_APPROVAL_AD_PREVIEW_TITLE,
  CAMPAIGN_APPROVAL_AD_PREVIEW_ERROR,
  CAMPAIGN_APPROVAL_SEND_FOR_REVIEW,
  CONTENT_APPROVAL_PAGE_TITLE,
  CONTENT_APPROVAL_REPLACE_BUTTON,
  CONTENT_APPROVAL_EDIT_BUTTON,
  CONTENT_APPROVAL_SAVE_REVISION_BUTTON,
  CONTENT_APPROVAL_SAVE_REVISION_SUCCESS_DESCRIPTION,
  CONTENT_APPROVAL_APPROVE_CONTENT_BUTTON,
  CONTENT_APPROVAL_SIDEBAR_TITLE,
  CONTENT_APPROVAL_ALL_GOOD_QUESTION,
  CONTENT_APPROVAL_CONFIRM_ENABLE_TITLE,
  CONTENT_APPROVAL_CONFIRM_ENABLE_DESCRIPTION,
  CONTENT_APPROVAL_ENABLE_SUCCESS_DESCRIPTION,
  CAMPAIGN_APPROVAL_ENABLE_SUCCESS_DESCRIPTION,
  APPROVAL_ENABLE_SUCCESS_OR_SEPARATOR,
  APPROVAL_REVIEW_EMAIL_LABEL,
  APPROVAL_EMAIL_SEND_BUTTON,
  APPROVAL_EMAIL_SEND_SENT,
  APPROVAL_EMAIL_INVALID,
  APPROVAL_REVIEWER_NOT_FOUND,
  APPROVAL_ADD_REVIEWER,
  APPROVAL_REVIEWER_LABEL,
  APPROVAL_REVIEWER_MAX_REACHED,
  APPROVAL_REVIEWER_EMAIL_DUPLICATED,
  APPROVAL_REVIEWER_ADDED_SUCCESS,
  APPROVAL_REVIEWER_STATUS_PENDING,
  APPROVAL_REVIEWER_STATUS_APPROVED,
  APPROVAL_REVIEWER_STATUS_REJECTED,
  APPROVAL_CURRENT_REVIEWER_LABEL,
  APPROVAL_REVIEWING_AS_PREFIX,
  APPROVAL_REVIEWERS_SECTION_LABEL,
  APPROVAL_COMMENT_AUTHOR_LABEL,
  CONTENT_APPROVAL_SENT_DATE,
  CONTENT_APPROVAL_CLIENT_COMMENTS_TITLE,
  CONTENT_APPROVAL_CLIENT_COMMENTS_EMPTY,
  CONTENT_APPROVAL_REVIEWER_COMMENTS_EMPTY,
  CONTENT_APPROVAL_COMMENT_PLACEHOLDER,
  CONTENT_APPROVAL_REVIEW_LINK_LABEL,
  CONTENT_APPROVAL_STATUS_SECTION_LABEL,
  CONTENT_APPROVAL_MAIN_CREATIVE_LABEL,
  CONTENT_APPROVAL_CREATIVE_CARD_TITLE,
  CONTENT_APPROVAL_CREATIVE_TYPE_LABEL,
  CONTENT_APPROVAL_COMMENT_CREATIVE_NUMBER,
  CONTENT_APPROVAL_CONFIRM_APPROVE_TITLE,
  CONTENT_APPROVAL_CONFIRM_APPROVE_DESCRIPTION,
  CONTENT_APPROVAL_APPROVE_BUTTON,
  CONTENT_APPROVAL_DECISION_APPROVED_SUCCESS,
  CONTENT_APPROVAL_CONTENT_APPROVED_TITLE,
  CONTENT_APPROVAL_COMMENT_SENT_SUCCESS,
  CONTENT_APPROVAL_REVIEW_NEXT_CONTENT_BUTTON,
  CONTENT_APPROVAL_ANOTHER_COMMENT_BUTTON,
  CONTENT_APPROVAL_ALL_CONTENTS_REVIEWED,
  CONTENT_APPROVAL_REVIEW_NEXT_DESCRIPTION,
  CONTENT_APPROVAL_REVIEW_NEXT_DESCRIPTION_SINGLE,
  CONTENT_APPROVAL_LOCKED_STATUS_APPROVED,
  CONTENT_APPROVAL_INVALID_TITLE,
  CONTENT_APPROVAL_INVALID_DESCRIPTION,
  CONTENT_APPROVAL_EXPIRED_TITLE,
  CONTENT_APPROVAL_EXPIRED_DESCRIPTION,
  CONTENT_APPROVAL_LOADING_VALIDATING_LINK,
  CONTENT_APPROVAL_LOADING_FETCHING_CREATIVES,
  CONTENT_APPROVAL_LOADING_PREPARING_REVIEW,
  CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_TITLE,
  CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_DESCRIPTION,
  CAMPAIGN_APPROVAL_READY_TO_DECIDE,
  CAMPAIGN_APPROVAL_COMMENTS_LEFT,
  CAMPAIGN_APPROVAL_AD_SET_LABEL,
  CAMPAIGN_APPROVAL_ADS_COUNT,
  CAMPAIGN_APPROVAL_ADS_COUNT_SINGLE,
  CAMPAIGN_APPROVAL_SIDEBAR_CAMPAIGNS,
  CAMPAIGN_APPROVAL_SIDEBAR_AD_SETS,
  CAMPAIGN_APPROVAL_SIDEBAR_AD_SETS_SINGLE,
  CAMPAIGN_APPROVAL_SIDEBAR_ADS,
  CAMPAIGN_APPROVAL_SIDEBAR_ADS_SINGLE,
  CAMPAIGN_APPROVAL_SIDEBAR_TEXTS,
  CAMPAIGN_APPROVAL_SIDEBAR_TEXTS_SINGLE,
  CAMPAIGN_APPROVAL_SIDEBAR_CREATIVES,
  CAMPAIGN_APPROVAL_SIDEBAR_CREATIVES_SINGLE,
  CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT,
  CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT_SINGLE,
  CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT,
  CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT_SINGLE,
  CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT,
  CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT_SINGLE,
  CAMPAIGN_APPROVAL_REJECT_REQUIRES_COMMENT,
  CAMPAIGN_APPROVAL_COMMENT_SEND_HINT,
  CAMPAIGN_APPROVAL_APPROVE_CAMPAIGN_BUTTON,
  CAMPAIGN_APPROVAL_CONFIRM_APPROVE_TITLE,
  CAMPAIGN_APPROVAL_CONFIRM_APPROVE_DESCRIPTION,
  CAMPAIGN_APPROVAL_CONFIRM_REJECT_TITLE,
  CAMPAIGN_APPROVAL_CONFIRM_REJECT_DESCRIPTION,
  CAMPAIGN_APPROVAL_DECISION_APPROVED_SUCCESS,
  CAMPAIGN_APPROVAL_DECISION_REJECTED_SUCCESS,
  RESIZE_CUSTOM,
  MODAL_RESIZE_CUSTOM_TITLE,
  MODAL_RESIZE_CUSTOM_DESCRIPTION,
  MODAL_RESIZE_CUSTOM_DEFAULT_SIZE_LABEL,
  ERROR_RESIZE_DIMENSION_INVALID,
  ERROR_RESIZE_DIMENSION_MAX_EDGE,
  ERROR_RESIZE_DIMENSION_NOT_MULTIPLE_PREFIX,
  ERROR_RESIZE_DIMENSION_OR,
  ERROR_RESIZE_TOTAL_TOO_SMALL,
  ERROR_RESIZE_TOTAL_TOO_LARGE,
  ERROR_RESIZE_ASPECT_RATIO_EXCEEDED_PREFIX,
  ERROR_RESIZE_ASPECT_RATIO_CHOOSE_OPTION,
  ERROR_RESIZE_ASPECT_RATIO_ADJUST_WIDTH_PREFIX,
  ERROR_RESIZE_ASPECT_RATIO_KEEP_HEIGHT_SUFFIX,
  ERROR_RESIZE_ASPECT_RATIO_ADJUST_HEIGHT_PREFIX,
  ERROR_RESIZE_ASPECT_RATIO_KEEP_WIDTH_SUFFIX,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_INVALID,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_WIDTH_NOT_MULTIPLE_OF_16,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_HEIGHT_NOT_MULTIPLE_OF_16,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_MAX_EDGE_EXCEEDED,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_ASPECT_RATIO_EXCEEDED,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_FEW_PIXELS,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_MANY_PIXELS,
  BUTTON_RESIZE_IMAGE,
  MODAL_BATCH_IMAGE_EDIT_TITLE,
  MODAL_BATCH_IMAGE_EDIT_VERSION_LABEL,
  MODAL_BATCH_IMAGE_EDIT_PROMPT_PLACEHOLDER,
  MODAL_BATCH_IMAGE_EDIT_GENERATE,
  MODAL_BATCH_IMAGE_EDIT_APPLY,
  MODAL_BATCH_IMAGE_EDIT_STATUS_PENDING,
  MODAL_BATCH_IMAGE_EDIT_STATUS_SUCCESS,
  MODAL_BATCH_IMAGE_EDIT_STATUS_ERROR,
  MODAL_BATCH_IMAGE_EDIT_RETRY,
  MODAL_BATCH_IMAGE_EDIT_FAILED_BADGE,
  MODAL_BATCH_IMAGE_EDIT_EXPAND,
  MODAL_BATCH_IMAGE_EDIT_BACK_TO_GRID,
  MODAL_BATCH_IMAGE_EDIT_FOOTER_ACTION,
  MODAL_BATCH_IMAGE_EDIT_IMAGE_ALT,
  MODAL_BATCH_IMAGE_EDIT_SAVE_ALERT_TITLE,
  MODAL_BATCH_IMAGE_EDIT_SAVE_ALERT_DESCRIPTION,
  MODAL_BATCH_IMAGE_EDIT_SAVE_AS_NEW_BUTTON,
  MODAL_BATCH_IMAGE_EDIT_REPLACE_BUTTON,
  TEMPLATES_MENU_ITEM,
  TEMPLATES_TITLE,
  TEMPLATE,
  TEMPLATES_SEARCH_PLACEHOLDER,
  TEMPLATES_SEARCH_NO_RESULTS,
  TEMPLATES_SORT_NEWEST_FIRST,
  TEMPLATES_SORT_OLDEST_FIRST,
  TEMPLATES_SORT_NAME_ASC,
  TEMPLATES_SORT_NAME_DESC,
  TEMPLATES_DESCRIPTION,
  TEMPLATES_BUTTON_UPLOAD,
  TEMPLATES_UPLOAD_FROM_GALLERY,
  TEMPLATES_UPLOAD_FROM_DEVICE,
  TEMPLATES_BUTTON_CREATE,
  TEMPLATES_LAYOUT_KIND_IMAGE,
  TEMPLATES_LAYOUT_KIND_CAROUSEL,
  TEMPLATES_CREATE_KIND_TITLE,
  TEMPLATES_CREATE_KIND_DESCRIPTION,
  TEMPLATES_CREATE_KIND_SINGLE,
  TEMPLATES_CREATE_KIND_CAROUSEL,
  TEMPLATES_CREATE_KIND_SLIDE_COUNT,
  TEMPLATES_SLIDE_LABEL,
  TEMPLATES_ADD_SLIDE,
  TEMPLATES_DUPLICATE_SLIDE,
  TEMPLATES_DELETE_SLIDE,
  TEMPLATES_SLIDES_ROW,
  TEMPLATES_CAROUSEL_TYPE,
  TEMPLATES_CONTINUOUS_SETUP_TITLE,
  TEMPLATES_CONTINUOUS_SETUP_SLIDES,
  TEMPLATES_CONTINUOUS_SETUP_FORMAT,
  TEMPLATES_LAYOUT_KIND_CONTINUOUS,
  TEMPLATES_LAYOUT_KIND_INDIVIDUAL,
  TEMPLATES_LAYOUT_KIND_INDIVIDUAL_TOOLTIP,
  TEMPLATES_LAYOUT_KIND_CONTINUOUS_TOOLTIP,
  TEMPLATES_LAYOUT_KIND_TO_INDIVIDUAL_HINT,
  TEMPLATES_LAYOUT_KIND_TO_CONTINUOUS_HINT,
  TEMPLATES_LAYOUT_KIND_TO_INDIVIDUAL_BLOCKED,
  TEMPLATES_LAYOUT_KIND_TO_CONTINUOUS_BLOCKED,
  TEMPLATES_CONFIRM_DELETE_STRIP_SLIDE_DESCRIPTION,
  TEMPLATES_STRIP_FORMAT_TOO_LARGE,
  TEMPLATES_FORMATS_ROW,
  TEMPLATES_CAROUSEL_CHIP,
  TEMPLATES_CONTINUOUS_CAROUSEL_CHIP,
  TEMPLATES_EMPTY,
  TEMPLATES_FOLDER_EMPTY,
  TEMPLATES_EMPTY_CANVAS_HINT,
  TEMPLATES_EMPTY_ADD_LAYER,
  TEMPLATES_BACKGROUND_LAYER,
  TEMPLATES_OPEN,
  TEMPLATES_DUPLICATE,
  TEMPLATES_DELETE,
  TEMPLATES_SAVE,
  TEMPLATES_USAGE_GUIDE,
  TEMPLATES_GUIDE_PDF_URL,
  TEMPLATES_GUIDE_VIDEO_URL,
  TEMPLATES_BACK,
  TEMPLATES_NAME,
  TEMPLATES_UNTITLED,
  TEMPLATES_ZONES,
  TEMPLATES_LAYERS,
  TEMPLATES_PROPERTIES,
  TEMPLATES_NO_SELECTION,
  TEMPLATES_ADD_LAYER,
  TEMPLATES_ZONE_NAME,
  TEMPLATES_LAYER_NAME,
  TEMPLATES_ZONE_TYPE,
  TEMPLATES_ZONE_SOURCE,
  TEMPLATES_TYPE_TEXT,
  TEMPLATES_TYPE_IMAGE,
  TEMPLATES_TYPE_SHAPE,
  TEMPLATES_TYPE_GROUP,
  TEMPLATES_SOURCE_ASSET,
  TEMPLATES_SOURCE_DATA,
  TEMPLATES_SOURCE_GENERATED,
  TEMPLATES_SOURCE_FIXED,
  TEMPLATES_SOURCE_COMPUTED,
  TEMPLATES_SOURCE_ASSET_HINT,
  TEMPLATES_SOURCE_DATA_HINT,
  TEMPLATES_SOURCE_GENERATED_HINT,
  TEMPLATES_SOURCE_COMPUTED_HINT,
  TEMPLATES_FIXED_VALUE,
  TEMPLATES_FIXED_VALUE_PLACEHOLDER,
  TEMPLATES_LAYER_TEXT,
  TEMPLATES_STYLE,
  TEMPLATES_ORIGIN_TEXT,
  TEMPLATES_EXPRESSION,
  TEMPLATES_VARIABLE,
  TEMPLATES_PROMPT,
  TEMPLATES_GENERATE_PROMPT,
  TEMPLATES_GENERATE_PROMPT_ERROR,
  TEMPLATES_GENERATE_PROMPT_NO_EXAMPLE,
  TEMPLATES_SAVE_PROMPT,
  TEMPLATES_SAVE_PROMPT_TITLE,
  TEMPLATES_SAVE_PROMPT_ERROR,
  TEMPLATES_SAVE_PROMPT_SUCCESS,
  TEMPLATES_IMPORT_PROMPT,
  TEMPLATES_IMPORT_PROMPT_TITLE,
  TEMPLATES_IMPORT_SELECTED,
  TEMPLATES_IMPORT_PROMPT_EMPTY,
  TEMPLATES_IMPORT_PROMPT_ERROR,
  TEMPLATES_DELETE_PROMPT,
  TEMPLATES_DELETE_PROMPT_ERROR,
  TEMPLATES_TRY_LAYER,
  TEMPLATES_TRY_LAYER_ERROR,
  TEMPLATES_IS_BACKGROUND,
  TEMPLATES_NEGATIVE_PROMPT,
  TEMPLATES_ASSET_REF,
  TEMPLATES_SELECT_ASSET,
  TEMPLATES_CHANGE_ASSET,
  TEMPLATES_FIT,
  TEMPLATES_SHAPE_FILL,
  TEMPLATES_SHAPE_RADIUS,
  TEMPLATES_FONT_SIZE,
  TEMPLATES_FONT_COLOR,
  TEMPLATES_STROKE_WIDTH,
  TEMPLATES_STROKE_METRIC,
  TEMPLATES_SHADOW,
  TEMPLATES_SHADOW_ANGLE,
  TEMPLATES_SHADOW_DISTANCE,
  TEMPLATES_SHADOW_BLUR,
  TEMPLATES_PRESETS,
  TEMPLATES_SHADOW_PRESET_SOFT,
  TEMPLATES_SHADOW_PRESET_LIFT,
  TEMPLATES_SHADOW_PRESET_HARD,
  TEMPLATES_SHADOW_PRESET_GLOW,
  TEMPLATES_STROKE_COLOR,
  TEMPLATES_BACKGROUND_PADDING,
  TEMPLATES_BACKGROUND_SEPARATION,
  TEMPLATES_BACKGROUND_RADIUS,
  TEMPLATES_BACKGROUND_COLOR,
  TEMPLATES_PAINT_SETTINGS,
  TEMPLATES_HIGHLIGHTS_TITLE,
  TEMPLATES_HIGHLIGHTS_HINT,
  TEMPLATES_HIGHLIGHTS_ADD,
  TEMPLATES_HIGHLIGHTS_REMOVE,
  TEMPLATES_HIGHLIGHTS_KIND_FILL,
  TEMPLATES_HIGHLIGHTS_KIND_STROKE,
  TEMPLATES_HIGHLIGHTS_KIND_BACKGROUND,
  TEMPLATES_HIGHLIGHTS_PHRASE,
  TEMPLATES_HIGHLIGHTS_PHRASE_INVALID,
  TEMPLATES_HIGHLIGHTS_CAPTURE,
  TEMPLATES_HIGHLIGHTS_CAPTURING,
  TEMPLATES_INLINE_REPLACEMENTS_TITLE,
  TEMPLATES_INLINE_REPLACEMENTS_HINT,
  TEMPLATES_INLINE_REPLACEMENTS_ADD,
  TEMPLATES_INLINE_REPLACEMENTS_REMOVE,
  TEMPLATES_INLINE_REPLACEMENTS_PHRASE,
  TEMPLATES_LINE_SPACING,
  TEMPLATES_LETTER_SPACING,
  TEMPLATES_FONT_FAMILY,
  TEMPLATES_FONT_FACE,
  TEMPLATES_TEXT_STYLE,
  TEMPLATES_TEXT_STYLE_NORMAL,
  TEMPLATES_TEXT_STYLE_ITALIC,
  TEMPLATES_TEXT_STYLE_UNDERLINE,
  TEMPLATES_TEXT_STYLE_ITALIC_UNDERLINE,
  TEMPLATES_ADD_FONT,
  TEMPLATES_ADD_FONT_TITLE,
  TEMPLATES_ADD_FONT_NAME,
  TEMPLATES_ADD_FONT_NAME_HINT,
  TEMPLATES_ADD_FONT_FILE,
  TEMPLATES_ADD_FONT_SELECT_FILE,
  TEMPLATES_ADD_FONT_ERROR,
  TEMPLATES_ADD_FONT_INVALID_FILE,
  TEMPLATES_ADD_FONT_INVALID_NAME,
  TEMPLATES_ADD_FONT_MATCH_HINT,
  TEMPLATES_ADD_FONT_PARSE_FAILED,
  TEMPLATES_ADD_FONT_PARTIAL_ERROR,
  TEMPLATES_ADD_FONT_VARIABLE,
  TEMPLATES_ADD_FONT_SUMMARY,
  TEMPLATES_ADD_FONT_SUMMARY_FAMILY,
  TEMPLATES_ADD_FONT_SUMMARY_STYLE,
  TEMPLATES_ADD_FONT_SUMMARY_KIND,
  TEMPLATES_ADD_FONT_SUMMARY_STATIC,
  TEMPLATES_ADD_FONT_SUMMARY_STYLES,
  TEMPLATES_ADD_FONT_SUMMARY_HINT,
  TEMPLATES_ADD_FONT_CHANGE_FILE,
  TEMPLATES_ALIGN,
  TEMPLATES_ALIGN_LEFT,
  TEMPLATES_ALIGN_CENTER,
  TEMPLATES_ALIGN_RIGHT,
  TEMPLATES_ALIGN_TOP,
  TEMPLATES_ALIGN_MIDDLE,
  TEMPLATES_ALIGN_BOTTOM,
  TEMPLATES_ALIGN_LAYERS,
  TEMPLATES_LOCK_LAYER,
  TEMPLATES_UNLOCK_LAYER,
  TEMPLATES_HIDE_LAYER,
  TEMPLATES_SHOW_LAYER,
  TEMPLATES_ALIGNMENT_GUIDES,
  TEMPLATES_GUIDE_OPACITY,
  TEMPLATES_ORIENTATION,
  TEMPLATES_ORIENTATION_HORIZONTAL,
  TEMPLATES_ORIENTATION_VERTICAL,
  TEMPLATES_ORIENTATION_VERTICAL_UP,
  TEMPLATES_OVERFLOW,
  TEMPLATES_MAX_LINES,
  TEMPLATES_MIN_LINES,
  TEMPLATES_MIN_FONT,
  TEMPLATES_POSITION,
  TEMPLATES_SIZE,
  TEMPLATES_POS_X,
  TEMPLATES_POS_Y,
  TEMPLATES_POS_W,
  TEMPLATES_POS_H,
  TEMPLATES_FRAME_W,
  TEMPLATES_FRAME_H,
  TEMPLATES_CLIP,
  TEMPLATES_HIDE,
  TEMPLATES_SHOW,
  TEMPLATES_MIN_SIZE,
  TEMPLATES_PADDING,
  TEMPLATES_DRAW,
  TEMPLATES_DRAWING,
  TEMPLATES_DRAW_HINT,
  TEMPLATES_OVERFLOW_SHRINK,
  TEMPLATES_OVERFLOW_REJECT,
  TEMPLATES_BACKDROP_NOTE,
  TEMPLATES_NODE_COUNT,
  TEMPLATES_NODE_COUNT_SINGLE,
  TEMPLATES_ARTBOARD,
  TEMPLATES_ADD_FORMAT,
  TEMPLATES_CUSTOM_FORMAT,
  TEMPLATES_CUSTOM_FORMAT_TITLE,
  TEMPLATES_CUSTOM_WIDTH,
  TEMPLATES_CUSTOM_HEIGHT,
  TEMPLATES_CUSTOM_SIZE_INVALID,
  TEMPLATES_EDIT_PREVIOUS,
  TEMPLATES_NEW_FORMAT_HINT,
  TEMPLATES_REMOVE_FORMAT,
  TEMPLATES_THIS_FORMAT,
  TEMPLATES_UPLOAD_REFERENCE,
  TEMPLATES_CHANGE_REFERENCE,
  TEMPLATES_SHOW_GUIDE,
  TEMPLATES_HIDE_GUIDE,
  TEMPLATES_GUIDE_HINT,
  TEMPLATES_EDITOR_PREVIEW_VARIABLES_TITLE,
  TEMPLATES_EDITOR_PREVIEW_VARIABLES_DESCRIPTION,
  TEMPLATES_EDITOR_PREVIEW_ERROR,
  TEMPLATES_EDITOR_PREVIEW_TITLE,
  TEMPLATES_EDITOR_PREVIEW_USED_VALUES,
  TEMPLATES_EDITOR_PREVIEW_SAVED_TO_GALLERY,
  TEMPLATES_ZOOM_IN,
  TEMPLATES_ZOOM_OUT,
  TEMPLATES_ZOOM_FIT,
  TEMPLATES_TEXT_COLLISION_ONE,
  TEMPLATES_TEXT_COLLISION_OTHER,
  TEMPLATES_TEXT_COLLISION_UNNAMED_TEXT,
  TEMPLATES_TEXT_COLLISION_UNNAMED_IMAGE,
  CANVAS_TOOLS_BAR_LABEL,
  CANVAS_TOOL_ERASER,
  CANVAS_TOOL_ERASER_HINT,
  CANVAS_TOOL_ERASER_BRUSH_SIZE,
  CANVAS_TOOL_ERASER_APPLY,
  TEMPLATES_UNAUTHORIZED,
  TEMPLATES_ANALYZING_LOCK,
  TEMPLATES_SAVE_SUCCESS,
  TEMPLATES_DELETE_ERROR,
  TEMPLATES_UPLOAD_ERROR,
  TEMPLATES_ANALYZE_ERROR,
  TEMPLATES_ANALYZE_IMAGE_TOO_SMALL,
  IMAGE_TOO_SMALL_FOR_LAYERIZE,
  TEMPLATES_ANALYZE_RETRY,
  TEMPLATES_CREATE_ERROR,
  TEMPLATES_SAVE_ERROR,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_TITLE,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_TITLE_CAROUSEL,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_DESCRIPTION,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_DESCRIPTION_CAROUSEL,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_ARIA_LABEL,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_FORMAT,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_TYPE,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_VARIABLE,
  TEMPLATES_SAVE_TRANSPARENCY_GAP_TITLE,
  TEMPLATES_SAVE_TRANSPARENCY_GAP_DESCRIPTION,
  TEMPLATES_CONFIRM_DELETE_TITLE,
  TEMPLATES_CONFIRM_DELETE_DESCRIPTION,
  TEMPLATES_CONFIRM_REMOVE_FORMAT_TITLE,
  TEMPLATES_CONFIRM_REMOVE_FORMAT_DESCRIPTION,
  TEMPLATES_CONFIRM_ADD_FORMAT,
  TEMPLATES_CONFIRM_ADD_FORMAT_DESCRIPTION,
  TEMPLATES_CONFIRM_AI_RESIZE_BACKGROUND,
  TEMPLATES_CONFIRM_AI_RESIZE_BACKGROUND_DESCRIPTION,
  TEMPLATES_AI_RESIZE_BACKGROUND_CONFIRM,
  TEMPLATES_AI_RESIZE_BACKGROUND_LOCK,
  TEMPLATES_KEEP_EDITING,
  TEMPLATES_CLOSE_UNSAVED_DESCRIPTION,
  TEMPLATES_PRODUCE_DRAFT_COMPLETE,
  TEMPLATES_PRODUCE_DRAFT_TITLE,
  TEMPLATES_PRODUCE_DRAFT_DESCRIPTION,
  TEMPLATES_SAVE_PRODUCE_TITLE,
  TEMPLATES_SAVE_BLOCKED_PRODUCING,
  TEMPLATES_SAVE_PRODUCE_DESCRIPTION,
  TEMPLATES_SAVE_PRODUCE_CONFIRM,
  TEMPLATES_SAVE_PRODUCE_CANCEL,
  TEMPLATES_NEW_ZONE,
  TEMPLATES_NEW_LAYER,
  TEMPLATES_PRODUCE_MENU_ITEM,
  TEMPLATES_PRODUCE_TITLE,
  TEMPLATES_PRODUCE_DESCRIPTION,
  TEMPLATES_PRODUCE_CONFIG_KICKER,
  TEMPLATES_PRODUCE_SELECTED_TEMPLATE_LABEL,
  TEMPLATES_PRODUCE_VARIABLES_EYEBROW,
  TEMPLATES_PRODUCE_SUMMARY_IMAGE_UNIT,
  TEMPLATES_PRODUCE_SUMMARY_IMAGES_UNIT,
  TEMPLATES_PRODUCE_SUMMARY_VARIATION_LABEL,
  TEMPLATES_PRODUCE_SUMMARY_VARIATIONS_LABEL,
  TEMPLATES_PRODUCE_SUMMARY_COST,
  TEMPLATES_PRODUCE_SUMMARY_COST_LABEL,
  TEMPLATES_PRODUCE_SUMMARY_RATE,
  TEMPLATES_PRODUCE_SUMMARY_FORMAT,
  TEMPLATES_PRODUCE_SUMMARY_IMAGES_COUNT,
  TEMPLATES_PRODUCE_SUMMARY_IMAGES_COUNT_SINGLE,
  TEMPLATES_PRODUCE_SUMMARY_SIZE_COUNT,
  TEMPLATES_PRODUCE_SUMMARY_SIZES_COUNT,
  TEMPLATES_PRODUCE_SUMMARY_SLIDE_COUNT,
  TEMPLATES_PRODUCE_SUMMARY_SLIDES_COUNT,
  TEMPLATES_PRODUCE_ROW_COUNT,
  TEMPLATES_PRODUCE_ROW_COUNT_SINGLE,
  TEMPLATES_PRODUCE_TEMPLATE,
  TEMPLATES_PRODUCE_CHANGE,
  TEMPLATES_PRODUCE_DIMENSIONS,
  TEMPLATES_PRODUCE_LANGUAGE,
  TEMPLATES_PRODUCE_VARIATIONS,
  TEMPLATES_PRODUCE_VARIATIONS_PER_ROW,
  TEMPLATES_PRODUCE_ROWS,
  TEMPLATES_PRODUCE_ROWS_HINT,
  TEMPLATES_PRODUCE_ADD_ROW,
  TEMPLATES_PRODUCE_LOAD_LAST_CONFIG,
  TEMPLATES_PRODUCE_UPLOAD_CSV,
  TEMPLATES_PRODUCE_DOWNLOAD_FORMAT,
  TEMPLATES_PRODUCE_CSV_EXAMPLE_FILENAME,
  TEMPLATES_PRODUCE_CSV_EXAMPLE_TEXT,
  TEMPLATES_PRODUCE_GENERATE,
  TEMPLATES_PRODUCE_GENERATE_SINGLE,
  TEMPLATES_PRODUCE_PREVIEW,
  TEMPLATES_PRODUCE_PREVIEW_TOOLTIP,
  TEMPLATES_PRODUCE_PREVIEW_THIS_SLIDE,
  TEMPLATES_PRODUCE_PREVIEW_WHOLE_CAROUSEL,
  TEMPLATES_PRODUCE_SUMMARY,
  TEMPLATES_PRODUCE_EMPTY_TEMPLATES,
  TEMPLATES_PRODUCE_EMPTY_VARIABLES,
  TEMPLATES_PRODUCE_SELECT_TEMPLATE,
  TEMPLATES_PRODUCE_CSV_TITLE,
  TEMPLATES_PRODUCE_CSV_DESCRIPTION,
  TEMPLATES_PRODUCE_CSV_REPLACE,
  TEMPLATES_PRODUCE_CSV_APPEND,
  TEMPLATES_PRODUCE_CSV_ERROR,
  TEMPLATES_PRODUCE_CSV_EMPTY,
  TEMPLATES_PRODUCE_CHANGE_TEMPLATE_TITLE,
  TEMPLATES_PRODUCE_CHANGE_TEMPLATE_DESCRIPTION,
  TEMPLATES_PRODUCE_VALIDATION_ERROR,
  TEMPLATES_PRODUCE_VALIDATION_HIGHLIGHT,
  TEMPLATES_PRODUCE_VALIDATION_NO_ROWS,
  TEMPLATES_PRODUCE_VALIDATION_VARIATIONS,
  TEMPLATES_PRODUCE_VALIDATION_NO_FORMATS,
  TEMPLATES_PRODUCE_VALIDATION_TOO_MANY_ROWS,
  TEMPLATES_PRODUCE_GENERATE_SUCCESS,
  TEMPLATES_PRODUCE_DELETE_ROW,
  TEMPLATES_PRODUCE_COPY_TO_COLUMN,
  TEMPLATES_PRODUCE_SELECT_IMAGE,
  TEMPLATES_PRODUCE_REPLACE_IMAGE,
  TEMPLATES_PRODUCE_IMAGE_CHECKING,
  TEMPLATES_PRODUCE_IMAGE_UNUSABLE,
  TEMPLATES_PRODUCE_IMAGES_PROCESSING,
  TEMPLATES_PRODUCE_IMAGES_UNUSABLE,
  TEMPLATES_PRODUCE_DELETE_IMAGE,
  TEMPLATES_PRODUCE_RESULTS,
  TEMPLATES_PRODUCE_RUN_TITLE,
  TEMPLATES_PRODUCE_RUN_LEGACY,
  TEMPLATES_PRODUCE_DELETE_SELECTED,
  TEMPLATES_PRODUCE_DELETE_CONFIRM_TITLE,
  TEMPLATES_PRODUCE_DELETE_CONFIRM_TEXT,
  TEMPLATES_PRODUCE_DELETE_ERROR,
  TEMPLATES_PRODUCE_DOWNLOAD_CONFIG,
  TEMPLATES_PRODUCE_CONFIG_FILENAME,
  TEMPLATES_PRODUCE_GENERATING,
  TEMPLATES_PRODUCE_ACTIVE_RUN,
  TEMPLATES_PRODUCE_EDIT_TITLE,
  TEMPLATES_PRODUCE_EDIT_NO_INSTANCE,
  TEMPLATES_PRODUCE_ADD_TEXT,
  TEMPLATES_PRODUCE_ADD_IMAGE,
  TEMPLATES_PRODUCE_ADD_SHAPE,
  TEMPLATES_PRODUCE_ADD_GROUP,
  TEMPLATES_GROUP_LAYERS,
  TEMPLATES_PRODUCE_SAVE_ERROR,
  TEMPLATES_PRODUCE_PARTIAL_SUMMARY,
  TEMPLATES_PRODUCE_PARTIAL_TITLE,
  TEMPLATES_PRODUCE_PARTIAL_SUBTITLE_SINGULAR,
  TEMPLATES_PRODUCE_PARTIAL_SUBTITLE_PLURAL,
  TEMPLATES_PRODUCE_RETRY_FAILED,
  TEMPLATES_PRODUCE_RETRY_FAILED_SINGULAR,
  TEMPLATES_PRODUCE_RETRY_FAILED_PLURAL,
  TEMPLATES_PRODUCE_FAILURE_GENERIC,
  TEMPLATES_PRODUCE_FAILURE_BUSY,
  TEMPLATES_PRODUCE_FAILURE_IMAGE,
  TEMPLATES_PRODUCE_FAILURE_DATA,
  INSIGHTS_PAGE_TITLE,
  INSIGHTS_HEADER_BRAND,
  INSIGHTS_HEADER_HELP,
  INSIGHTS_CONNECT_STEP_NUMBER,
  INSIGHTS_CONNECT_TITLE,
  INSIGHTS_CONNECT_MUTED,
  INSIGHTS_CONNECT_DESCRIPTION,
  INSIGHTS_CONNECT_CARD_TITLE,
  INSIGHTS_CONNECT_CARD_SUBTITLE,
  INSIGHTS_CONNECT_CTA,
  INSIGHTS_CONNECT_CONNECTING,
  INSIGHTS_CONNECT_CREDENTIALS_NOTE,
  INSIGHTS_CONNECT_ERROR_CANCELLED,
  INSIGHTS_CONNECT_ERROR_FAILED,
  INSIGHTS_CONNECT_ERROR_SDK,
  INSIGHTS_CONNECT_ERROR_NO_ACCOUNTS,
  INSIGHTS_CONNECT_ERROR_GENERIC,
  INSIGHTS_ACCOUNT_BACK,
  INSIGHTS_ACCOUNT_STEP_NUMBER,
  INSIGHTS_ACCOUNT_TITLE,
  INSIGHTS_ACCOUNT_MUTED,
  INSIGHTS_ACCOUNT_DESCRIPTION,
  INSIGHTS_ACCOUNT_CONTINUE,
  INSIGHTS_ACCOUNT_EMPTY,
  INSIGHTS_ACCOUNT_STATUS_ACTIVE,
  INSIGHTS_ACCOUNT_STATUS_PAUSED,
  INSIGHTS_GENERATING_STEP_NUMBER,
  INSIGHTS_GENERATING_TITLE,
  INSIGHTS_GENERATING_MUTED,
  INSIGHTS_GENERATING_DESCRIPTION,
  INSIGHTS_GENERATING_PROCESSING_LABEL,
  INSIGHTS_GENERATING_ERROR,
  INSIGHTS_GENERATING_RETRY,
  INSIGHTS_DONE_STEP_NUMBER,
  INSIGHTS_DONE_TITLE,
  INSIGHTS_DONE_MUTED,
  INSIGHTS_DONE_DESCRIPTION,
  INSIGHTS_DONE_REPORT_TITLE,
  INSIGHTS_DONE_REPORT_SUBTITLE,
  INSIGHTS_DONE_CTA_TITLE,
  INSIGHTS_DONE_CTA_DESCRIPTION,
  INSIGHTS_DONE_SCHEDULE_DEMO,
  INSIGHTS_DONE_RESTART,
  INSIGHTS_REPORT_WHY,
  INSIGHTS_REPORT_WHAT_TO_DO,
  INSIGHTS_REPORT_QUICK_WINS,
  INSIGHTS_FEATURES_HEADING,
  INSIGHTS_FEATURE_AI_MEDIA_TITLE,
  INSIGHTS_FEATURE_AI_MEDIA_DESCRIPTION,
  INSIGHTS_FEATURE_AI_CAMPAIGNS_TITLE,
  INSIGHTS_FEATURE_AI_CAMPAIGNS_DESCRIPTION,
  INSIGHTS_FEATURE_COMPETITORS_TITLE,
  INSIGHTS_FEATURE_COMPETITORS_DESCRIPTION,
  INSIGHTS_FEATURE_REPORTS_TITLE,
  INSIGHTS_FEATURE_REPORTS_DESCRIPTION,
  AI_COMPETITORS_PAGE_TITLE,
  AI_COMPETITORS_URL_STEP_NUMBER,
  AI_COMPETITORS_URL_TITLE,
  AI_COMPETITORS_URL_MUTED,
  AI_COMPETITORS_URL_DESCRIPTION,
  AI_COMPETITORS_URL_PLACEHOLDER,
  AI_COMPETITORS_URL_CTA,
  AI_COMPETITORS_URL_INVALID,
  AI_COMPETITORS_URL_BLOCKED,
  AI_COMPETITORS_URL_NO_COMPETITORS,
  AI_COMPETITORS_ANALYZING_STEP_NUMBER,
  AI_COMPETITORS_ANALYZING_TITLE,
  AI_COMPETITORS_ANALYZING_MUTED,
  AI_COMPETITORS_ANALYZING_DESCRIPTION,
  AI_COMPETITORS_PROGRESS_FALLBACK,
  AI_COMPETITORS_PROGRESS_REVIEWING_PAGE,
  AI_COMPETITORS_PROGRESS_FINDING_COMPETITORS,
  AI_COMPETITORS_PROGRESS_CONSOLIDATING_COMPETITORS,
  AI_COMPETITORS_PROGRESS_RESOLVING_ADS,
  AI_COMPETITORS_PROGRESS_SEARCHING_ADS,
  AI_COMPETITORS_PROGRESS_CONSOLIDATING_ADS,
  AI_COMPETITORS_COMPETITORS_STEP_NUMBER,
  AI_COMPETITORS_COMPETITORS_TITLE,
  AI_COMPETITORS_COMPETITORS_MUTED,
  AI_COMPETITORS_COMPETITORS_DESCRIPTION,
  AI_COMPETITORS_COMPETITORS_EMPTY,
  AI_COMPETITORS_COMPETITORS_ADD_PLACEHOLDER,
  AI_COMPETITORS_COMPETITORS_ADD,
  AI_COMPETITORS_COMPETITORS_ADD_INVALID,
  AI_COMPETITORS_COMPETITORS_NAME_LABEL,
  AI_COMPETITORS_COMPETITORS_REMOVE,
  AI_COMPETITORS_COMPETITORS_CTA,
  AI_COMPETITORS_COMPETITORS_NEED_ONE,
  AI_COMPETITORS_COMPETITORS_ADD_MAX,
  AI_COMPETITORS_SEARCHING_STEP_NUMBER,
  AI_COMPETITORS_SEARCHING_TITLE,
  AI_COMPETITORS_SEARCHING_MUTED,
  AI_COMPETITORS_SEARCHING_ERROR,
  AI_COMPETITORS_SEARCHING_RETRY,
  AI_COMPETITORS_RESULTS_STEP_NUMBER,
  AI_COMPETITORS_RESULTS_TITLE,
  AI_COMPETITORS_RESULTS_MUTED,
  AI_COMPETITORS_RESULTS_SUMMARY,
  AI_COMPETITORS_RESULTS_NO_ADS,
  AI_COMPETITORS_RESULTS_NO_ADS_ALERT_TITLE,
  AI_COMPETITORS_RESULTS_NO_ADS_ALERT_BODY,
  AI_COMPETITORS_RESULTS_NO_ADS_CTA,
  AI_COMPETITORS_RESULTS_VIEW_MORE,
  AI_COMPETITORS_RESULTS_GENERATE,
  AI_COMPETITORS_RESULTS_LOCKED_COUNT,
  AI_COMPETITORS_RESULTS_DOWNLOAD,
  AI_COMPETITORS_RESULTS_FORMAT_IMAGE,
  AI_COMPETITORS_RESULTS_FORMAT_VIDEO,
  AI_COMPETITORS_RESULTS_FORMAT_CAROUSEL,
  AI_COMPETITORS_AGENDA_CONFIRM_TITLE,
  AI_COMPETITORS_AGENDA_CONFIRM_TEXT,
  AI_COMPETITORS_AGENDA_CONFIRM_CTA,
  AI_COMPETITORS_AGENDA_BACK,
  AI_COMPETITORS_AGENDA_STEP_NUMBER,
  AI_COMPETITORS_AGENDA_TITLE,
  AI_COMPETITORS_AGENDA_MUTED,
  AI_COMPETITORS_AGENDA_CONTEXT,
  AI_COMPETITORS_AGENDA_CONTEXT_ZERO,
  AI_COMPETITORS_AGENDA_CONTEXT_FALLBACK,
  AI_COMPETITORS_THANKS_STEP_NUMBER,
  AI_COMPETITORS_THANKS_TITLE,
  AI_COMPETITORS_THANKS_MUTED,
  AI_COMPETITORS_THANKS_DESCRIPTION,
  NEW_FEATURE_CALLOUT_BADGE,
  NEW_FEATURE_CALLOUT_CLOSE_ARIA,
  NEW_FEATURE_CALLOUT_DEFAULT_CTA,
  NEW_FEATURE_CALLOUT_INSIGHTS_TITLE,
  NEW_FEATURE_CALLOUT_INSIGHTS_DESCRIPTION,
  NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_TITLE,
  NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_DESCRIPTION,
  NEW_FEATURE_CALLOUT_AUTOMATIONS_TITLE,
  NEW_FEATURE_CALLOUT_AUTOMATIONS_DESCRIPTION,
  AUTOMATIONS_MENU_TITLE,
  AUTOMATIONS_PAGE_TITLE,
  AUTOMATIONS_PAGE_DESCRIPTION,
  BUTTON_NEW_AUTOMATION,
  AUTOMATIONS_HERO_TITLE,
  AUTOMATIONS_HERO_DESCRIPTION,
  AUTOMATIONS_STATUS_ACTIVE,
  AUTOMATIONS_STATUS_PAUSED,
  AUTOMATIONS_LABEL_FOLDER,
  AUTOMATIONS_LABEL_PLATFORMS,
  AUTOMATIONS_LABEL_FREQUENCY,
  AUTOMATIONS_LABEL_NEXT_POST,
  AUTOMATIONS_MOCK_BRAND_CONTENT,
  AUTOMATIONS_MOCK_PRODUCT_LAUNCH,
  AUTOMATIONS_MOCK_THOUGHT_LEADERSHIP,
  AUTOMATIONS_MOCK_FOLDER_SOCIAL_SEPTEMBER,
  AUTOMATIONS_MOCK_FOLDER_ALL_CONTENT,
  AUTOMATIONS_MOCK_FOLDER_LINKEDIN,
  AUTOMATIONS_MOCK_FREQ_ONE_PER_DAY,
  AUTOMATIONS_MOCK_FREQ_FIVE_PER_WEEK,
  AUTOMATIONS_MOCK_FREQ_THREE_PER_WEEK,
  AUTOMATIONS_FREQ_ONE_PER_DAY,
  AUTOMATIONS_FREQ_THREE_PER_WEEK,
  AUTOMATIONS_FREQ_FOUR_PER_WEEK,
  AUTOMATIONS_FREQ_FIVE_PER_WEEK,
  AUTOMATIONS_FREQ_SIX_PER_WEEK,
  AUTOMATIONS_MOCK_NEXT_TODAY,
  AUTOMATIONS_MOCK_NEXT_EMPTY,
  AUTOMATIONS_MOCK_NEXT_TOMORROW,
  MODAL_CREATE_AUTOMATION_TITLE,
  AUTOMATIONS_STEP_SOURCE,
  AUTOMATIONS_STEP_PLATFORMS,
  AUTOMATIONS_STEP_SCHEDULE,
  AUTOMATIONS_STEP_CONTENT_AI,
  AUTOMATIONS_STEP_REVIEW,
  AUTOMATIONS_STEP_SOURCE_TITLE,
  AUTOMATIONS_STEP_SOURCE_HELP,
  AUTOMATIONS_SOURCE_ALL_TITLE,
  AUTOMATIONS_SOURCE_ALL_DESCRIPTION,
  AUTOMATIONS_SOURCE_FOLDER_TITLE,
  AUTOMATIONS_SOURCE_FOLDER_DESCRIPTION,
  AUTOMATIONS_SOURCE_INCLUDE_SUBFOLDERS,
  AUTOMATIONS_SOURCE_INCLUDE_SUBFOLDERS_HELP,
  AUTOMATIONS_STEP_LANGUAGE_TITLE,
  AUTOMATIONS_STEP_LANGUAGE_HELP,
  AUTOMATIONS_VALIDATION_LANGUAGE,
  AUTOMATIONS_REVIEW_LANGUAGE,
  AUTOMATIONS_CONNECT_ACCOUNTS,
  AUTOMATIONS_STEP_PLATFORMS_TITLE,
  AUTOMATIONS_STEP_PLATFORMS_HELP,
  AUTOMATIONS_PLATFORM_CONNECTED,
  AUTOMATIONS_STEP_SCHEDULE_TITLE,
  AUTOMATIONS_STEP_SCHEDULE_HELP,
  AUTOMATIONS_SCHEDULE_FREQUENCY,
  AUTOMATIONS_SCHEDULE_PUBLISHING_WINDOW,
  AUTOMATIONS_SCHEDULE_PUBLISHING_WINDOW_HELP,
  AUTOMATIONS_SCHEDULE_TIMEZONE,
  AUTOMATIONS_SCHEDULE_VALIDITY,
  AUTOMATIONS_SCHEDULE_VALIDITY_HELP,
  AUTOMATIONS_SCHEDULE_START,
  AUTOMATIONS_SCHEDULE_START_NOW,
  AUTOMATIONS_SCHEDULE_START_NOW_HELP,
  AUTOMATIONS_SCHEDULE_START_SCHEDULED,
  AUTOMATIONS_SCHEDULE_END,
  AUTOMATIONS_SCHEDULE_END_ALWAYS_ON,
  AUTOMATIONS_SCHEDULE_END_ALWAYS_ON_HELP,
  AUTOMATIONS_SCHEDULE_END_SCHEDULED,
  AUTOMATIONS_STEP_CONTENT_AI_TITLE,
  AUTOMATIONS_STEP_CONTENT_AI_HELP,
  AUTOMATIONS_CONTENT_ORIGINAL_TITLE,
  AUTOMATIONS_CONTENT_ORIGINAL_DESCRIPTION,
  AUTOMATIONS_CONTENT_AI_TITLE,
  AUTOMATIONS_CONTENT_AI_DESCRIPTION,
  AUTOMATIONS_AI_NOTE_TITLE,
  AUTOMATIONS_AI_NOTE_DESCRIPTION,
  AUTOMATIONS_STEP_REVIEW_TITLE,
  AUTOMATIONS_STEP_REVIEW_HELP,
  AUTOMATIONS_REVIEW_SOURCE,
  AUTOMATIONS_REVIEW_PLATFORMS,
  AUTOMATIONS_REVIEW_SCHEDULE,
  AUTOMATIONS_REVIEW_VALIDITY,
  AUTOMATIONS_REVIEW_VALIDITY_VALUE,
  AUTOMATIONS_REVIEW_VALIDITY_START_NOW,
  AUTOMATIONS_REVIEW_VALIDITY_START_AT,
  AUTOMATIONS_REVIEW_VALIDITY_ALWAYS_ON,
  AUTOMATIONS_REVIEW_VALIDITY_END_AT,
  AUTOMATIONS_REVIEW_NAME,
  AUTOMATIONS_REVIEW_CONTENT_AI,
  AUTOMATIONS_DEFAULT_NAME,
  AUTOMATIONS_BUTTON_BACK,
  AUTOMATIONS_BUTTON_CREATE,
  AUTOMATIONS_BUTTON_SAVE,
  AUTOMATIONS_REVIEW_SCHEDULE_VALUE,
  AUTOMATIONS_STATUS_WAITING,
  AUTOMATIONS_STATUS_SCHEDULING,
  AUTOMATIONS_STATUS_ATTENTION,
  AUTOMATIONS_STATUS_OFF,
  AUTOMATIONS_STATUS_ENDED,
  AUTOMATIONS_MENU_EDIT,
  AUTOMATIONS_MENU_VIEW_CALENDAR,
  AUTOMATIONS_MENU_TURN_OFF,
  AUTOMATIONS_TURN_OFF_TITLE,
  AUTOMATIONS_TURN_OFF_DESCRIPTION,
  AUTOMATIONS_TURN_OFF_CONFIRM,
  AUTOMATIONS_WAITING_BANNER,
  AUTOMATIONS_ATTENTION_BANNER,
  AUTOMATIONS_VALIDATION_FOLDER,
  AUTOMATIONS_VALIDATION_ACCOUNTS,
  AUTOMATIONS_VALIDATION_WINDOW,
  AUTOMATIONS_VALIDATION_START_REQUIRED,
  AUTOMATIONS_VALIDATION_START_FUTURE,
  AUTOMATIONS_VALIDATION_END_REQUIRED,
  AUTOMATIONS_VALIDATION_END_FUTURE,
  AUTOMATIONS_VALIDATION_END_AFTER_START,
  AUTOMATIONS_HERO_QUEUED,
  AUTOMATIONS_HERO_PUBLISHED,
  AUTOMATIONS_HERO_FAILED,
  AUTOMATIONS_HERO_NEXT,
  AUTOMATIONS_NEXT_NONE,
  AUTOMATIONS_REMAINING_CONTENT,
  CALENDAR_SOURCE_AUTOMATED,
  CALENDAR_ACTIVE_AUTOMATIONS,
  CALENDAR_AUTOMATION_ENDS,
  CALENDAR_AUTOMATION_FOLDER,
  CALENDAR_SOURCE_MANUAL,
  EVENT_DETAILS_AUTOMATION,
  EVENT_DETAILS_ACCOUNT,
  MODAL_EDIT_AUTOMATION_TITLE,
  AUTOMATIONS_NO_PERMISSION,
  OPTIMISTIC_SWITCH_FAILURE_BODY,
  OPTIMISTIC_SWITCH_ACTIVATE_CAMPAIGN,
  OPTIMISTIC_SWITCH_DEACTIVATE_CAMPAIGN,
  OPTIMISTIC_SWITCH_ACTIVATE_ASSETS_GROUP,
  OPTIMISTIC_SWITCH_DEACTIVATE_ASSETS_GROUP,
  OPTIMISTIC_SWITCH_ACTIVATE_AD_GROUP,
  OPTIMISTIC_SWITCH_DEACTIVATE_AD_GROUP,
  OPTIMISTIC_SWITCH_ACTIVATE_AD,
  OPTIMISTIC_SWITCH_DEACTIVATE_AD,
  OPTIMISTIC_SWITCH_ACTIVATE_AUTOMATION,
  OPTIMISTIC_SWITCH_DEACTIVATE_AUTOMATION,
  OPTIMISTIC_SWITCH_ACTIVATE_PROMO_CODE,
  OPTIMISTIC_SWITCH_DEACTIVATE_PROMO_CODE,
  OPTIMISTIC_SWITCH_FAILURE_EMAIL_SUBJECT,
  CREATE_CAMPAIGN_WIZARD_ARIA,
  CREATE_CAMPAIGN_SETUP_TITLE,
  CREATE_CAMPAIGN_SETUP_DESCRIPTION,
  CREATE_CAMPAIGN_WIZARD_STEP_INSTRUCTIONS_HELP,
  CREATE_CAMPAIGN_WIZARD_STEP_LANGUAGE_HELP,
  CREATE_CAMPAIGN_WIZARD_STEP_LOCATIONS_HELP,
  CREATE_CAMPAIGN_WIZARD_STEP_PLATFORM_HELP,
  ACTIVATED,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_TITLE,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_DESCRIPTION,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNELS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_VIDEOS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CONTENT_CATEGORIES,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EXCLUDED_APPS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_CATEGORIES,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_LOADING,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EMPTY_ROW,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SETTINGS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORDS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_YOUTUBE,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APPS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD_INVALID_CHARS,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD_MATCH_SYNTAX,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_TYPE,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_BROAD,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_PHRASE,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_EXACT,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNEL,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNEL_INVALID,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_VIDEO,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CATEGORIES,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_ID,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_NAME,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SEARCH_CATEGORIES,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EMPTY,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SAVED,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SAVE_ERROR,
  GOOGLE_ADS_ACCOUNT_EXCLUSIONS_LOAD_ERROR,
  GOOGLE_ADS_CONTENT_LABEL_BELOW_THE_FOLD,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_CONTENT_FOR_FAMILIES,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_GAMES_FIGHTING,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_GAMES_MATURE,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_HEALTH_SENSITIVE,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_HEALTH_SOURCE_UNDETERMINED,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_RECENT,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_SENSITIVE,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_SOURCE_NOT_FEATURED,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_POLITICS,
  GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_RELIGION,
  GOOGLE_ADS_CONTENT_LABEL_EMBEDDED_VIDEO,
  GOOGLE_ADS_CONTENT_LABEL_JUVENILE,
  GOOGLE_ADS_CONTENT_LABEL_LIVE_STREAMING_VIDEO,
  GOOGLE_ADS_CONTENT_LABEL_PARKED_DOMAIN,
  GOOGLE_ADS_CONTENT_LABEL_PROFANITY,
  GOOGLE_ADS_CONTENT_LABEL_SEXUALLY_SUGGESTIVE,
  GOOGLE_ADS_CONTENT_LABEL_SOCIAL_ISSUES,
  GOOGLE_ADS_CONTENT_LABEL_TRAGEDY,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO_NOT_YET_RATED,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_G,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_MA,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_PG,
  GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_T,
  FEATURE_ADDON_PAYWALL_TITLE,
  FEATURE_ADDON_PAYWALL_DESCRIPTION,
  FEATURE_ADDON_PAYWALL_CURRENT_LIMIT,
  FEATURE_ADDON_PAYWALL_TIER_CTA,
  FEATURE_ADDON_PAYWALL_CLOSE,
  FEATURE_ADDON_PAYWALL_FREE,
  FEATURE_ADDON_PAYWALL_INCLUDED,
  FEATURE_ADDON_INCLUDED_AUTOMATIONS,
  FEATURE_ADDON_INCLUDED_TEMPLATES,
  FEATURE_ADDON_INCLUDED_COMPETITORS,
  FEATURE_ADDON_BENEFIT_COMPETITORS_POOL_ONE,
  FEATURE_ADDON_PAYWALL_CURRENT,
  FEATURE_ADDON_PAYWALL_PER_MONTH,
  FEATURE_ADDON_BENEFIT_CAPACITY_AUTOMATIONS,
  FEATURE_ADDON_BENEFIT_CAPACITY_AUTOMATIONS_ONE,
  FEATURE_ADDON_BENEFIT_CAPACITY_TEMPLATES,
  FEATURE_ADDON_BENEFIT_CAPACITY_TEMPLATES_ONE,
  FEATURE_ADDON_BENEFIT_ACTIONS,
  FEATURE_ADDON_BENEFIT_ACTIONS_ONE,
  FEATURE_ADDON_BENEFIT_VISIBILITY,
  FEATURE_ADDON_BENEFIT_VISIBILITY_ALL,
  FEATURE_ADDON_PAYWALL_TIER_NAME,
  FEATURE_ADDON_HERO_AUTOMATIONS,
  FEATURE_ADDON_HERO_TEMPLATES,
  FEATURE_ADDON_HERO_COMPETITORS,
  FEATURE_ADDON_BENEFIT_AUTOMATIONS_PUBLISH,
  FEATURE_ADDON_BENEFIT_AUTOMATIONS_SCHEDULE,
  FEATURE_ADDON_BENEFIT_TEMPLATES_LAYERS,
  FEATURE_ADDON_BENEFIT_TEMPLATES_ANALYZE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_SAVE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_INSPIRE,
  FEATURE_ADDON_BENEFIT_AUTOMATIONS_PLATFORMS,
  FEATURE_ADDON_BENEFIT_AUTOMATIONS_FREQUENCY,
  FEATURE_ADDON_CLARIFICATION_MULTIPLATFORM_TERM,
  FEATURE_ADDON_CLARIFICATION_MULTIPLATFORM_BODY,
  FEATURE_ADDON_BENEFIT_TEMPLATES_PRODUCE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_PLATFORMS,
  FEATURE_ADDON_BENEFIT_COMPETITORS_FAVORITES,
  FEATURE_ADDON_BENEFIT_COMPETITORS_FAVORITES_ONE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_GENERATE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_GENERATE_ONE,
  FEATURE_ADDON_BENEFIT_COMPETITORS_POOL,
  FEATURE_ADDON_NAME_AUTOMATIONS,
  FEATURE_ADDON_NAME_TEMPLATES,
  FEATURE_ADDON_NAME_COMPETITORS,
  FEATURE_ADDON_UNPAID_TITLE,
  FEATURE_ADDON_UNPAID_PERIOD,
  FEATURE_ADDON_UNPAID_AMOUNT,
  FEATURE_ADDON_BILLING_TITLE,
  FEATURE_ADDON_BILLING_RENEWS,
  FEATURE_ADDON_BILLING_CANCELS,
  FEATURE_ADDON_BILLING_UPGRADE,
  FEATURE_ADDON_BILLING_CANCEL_TITLE,
  FEATURE_ADDON_BILLING_CANCEL_MODAL_TITLE,
  FEATURE_ADDON_BILLING_CANCEL_MODAL_CONFIRM,
  FEATURE_ADDON_BILLING_CANCEL_MODAL_KEEP,
  FEATURE_ADDON_BILLING_CANCEL_DESCRIPTION,
  FEATURE_ADDON_BILLING_CANCELLED_TITLE,
  FEATURE_ADDON_BILLING_REACTIVATED_TITLE,
  FEATURE_ADDON_BILLING_MENU,
  EXTRA_SEATS_MANAGE,
  EXTRA_SEATS_MODAL_TITLE,
  EXTRA_SEATS_MODAL_SUBTITLE,
  EXTRA_SEATS_MODAL_SUBTITLE_NO_PRICE,
  EXTRA_SEATS_QUANTITY_LABEL,
  EXTRA_SEATS_DELTA_USERS_ONE,
  EXTRA_SEATS_DELTA_USERS,
  EXTRA_SEATS_AMOUNT_PER_MONTH,
  EXTRA_SEATS_DUE_TODAY_LABEL,
  EXTRA_SEATS_PRORATION_TODAY,
  EXTRA_SEATS_NEXT_TOTAL_FROM,
  EXTRA_SEATS_NEXT_TOTAL_MONTHLY,
  EXTRA_SEATS_MONTHLY_TOTAL,
  EXTRA_SEATS_KEEP_UNTIL_CYCLE_ONE,
  EXTRA_SEATS_KEEP_UNTIL_CYCLE,
  EXTRA_SEATS_PRORATION_NOTE,
  EXTRA_SEATS_NO_CHARGE_NOTE,
  EXTRA_SEATS_ACTIVE_MEMBERS_BLOCK_ONE,
  EXTRA_SEATS_ACTIVE_MEMBERS_BLOCK,
  EXTRA_SEATS_REDUCE_BLOCKED_ONE,
  EXTRA_SEATS_REDUCE_BLOCKED,
  EXTRA_SEATS_CONFIRM,
  EXTRA_SEATS_ADDED,
  EXTRA_SEATS_CHECKOUT_CANCELLED,
  EXTRA_SEATS_CHECKOUT_INCOMPLETE,
  EXTRA_SEATS_BILLING_ROW_TITLE,
  EXTRA_SEATS_QUANTITY_BADGE,
  EXTRA_SEATS_REDUCE_NOTICE,
  EXTRA_SEATS_CANCEL_NOTICE,
  EXTRA_SEATS_CHANGE_SAVED,
  EXTRA_SEATS_FORBIDDEN,
  EXTRA_SEATS_DECREASE,
  EXTRA_SEATS_INCREASE,
  EXTRA_SEATS_RETRY,
  EXTRA_SEATS_REACTIVATE_NOT_ELIGIBLE,
  EXTRA_SEATS_CHECKOUT_FORBIDDEN,
  EXTRA_SEATS_MISSING_AGENCY,
  SEAT_LIMIT_REACHED,
  SEATS_QUANTITY_CHANGED,
  SEATS_OPERATION_IN_PROGRESS,
  SEATS_UNPAID,
  SEATS_QUANTITY_OUT_OF_RANGE,
  SEATS_NOT_ELIGIBLE,
  SEATS_PRICE_NOT_CONFIGURED,
  SEATS_SUBSCRIPTION_NOT_FOUND,
  BUTTON_BULK_CREATE_CAMPAIGNS,
  BULK_CAMPAIGNS_SUMMARY,
  BULK_CAMPAIGNS_LIST_TITLE,
  BULK_CAMPAIGNS_GENERATE,
  BULK_CAMPAIGNS_GENERATING,
  BULK_CAMPAIGNS_ALERT_ANALYZING,
  BULK_CAMPAIGNS_ALERT_ANALYSIS_SUCCESS,
  BULK_CAMPAIGNS_ALERT_ANALYSIS_ERROR,
  BULK_CAMPAIGNS_ALERT_GENERATING,
  BULK_CAMPAIGNS_ALERT_GENERATION_SUCCESS,
  BULK_CAMPAIGNS_ALERT_GENERATION_ERROR,
  BULK_CAMPAIGNS_GENERATE_ERROR,
  BULK_CAMPAIGNS_PLATFORM_NOT_SUPPORTED,
  BULK_CAMPAIGNS_PLATFORM_NOT_DETECTED,
  BULK_CAMPAIGNS_TYPE_NOT_SUPPORTED,
  BULK_CAMPAIGNS_TITLE,
  BULK_CAMPAIGNS_DESCRIPTION,
  BULK_CAMPAIGNS_DROP_TITLE,
  BULK_CAMPAIGNS_DROP_FORMATS,
  BULK_CAMPAIGNS_ANALYZING,
  BULK_CAMPAIGNS_FILE_NOT_SUPPORTED,
  BULK_CAMPAIGNS_FILE_TOO_LARGE,
  BULK_CAMPAIGNS_EXTRACT_ERROR,
  BULK_CAMPAIGNS_CONTENTS_LOAD_ERROR,
  BULK_CAMPAIGNS_NO_CAMPAIGNS_FOUND,
  BULK_CAMPAIGNS_CHOOSE_ANOTHER_FILE,
  CAMPAIGN_AGENT_WELCOME_TITLE,
  CAMPAIGN_AGENT_WELCOME_SUBTITLE,
  CAMPAIGN_AGENT_STEP_ASK,
  CAMPAIGN_AGENT_STEP_REVIEW,
  CAMPAIGN_AGENT_STEP_APPLY,
  CAMPAIGN_AGENT_WELCOME_HINT,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_1,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_2,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_3,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_4,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_5,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_6,
  CAMPAIGN_AGENT_CARD_LEARNINGS_TITLE,
  CAMPAIGN_AGENT_CARD_LEARNINGS_DESCRIPTION,
  CAMPAIGN_AGENT_CARD_LEARNINGS_QUESTION,
  CAMPAIGN_AGENT_CARD_IMPROVE_TITLE,
  CAMPAIGN_AGENT_CARD_IMPROVE_DESCRIPTION,
  CAMPAIGN_AGENT_CARD_IMPROVE_QUESTION,
  CAMPAIGN_AGENT_CARD_BUDGET_TITLE,
  CAMPAIGN_AGENT_CARD_BUDGET_DESCRIPTION,
  CAMPAIGN_AGENT_CARD_BUDGET_QUESTION,
  CAMPAIGN_AGENT_CARD_COPY_TITLE,
  CAMPAIGN_AGENT_CARD_COPY_DESCRIPTION,
  CAMPAIGN_AGENT_CARD_COPY_QUESTION,
  CAMPAIGN_AGENT_IMPROVEMENTS_READY_ONE,
  CAMPAIGN_AGENT_IMPROVEMENTS_READY_MANY,
  CAMPAIGN_AGENT_IMPROVEMENTS_READY_DESCRIPTION,
  CAMPAIGN_AGENT_CHANGES_COUNT_ONE,
  CAMPAIGN_AGENT_CHANGES_COUNT_MANY,
  CAMPAIGN_AGENT_CREATIVE_BADGE,
  CAMPAIGN_AGENT_SUMMARY_TITLE,
  CAMPAIGN_AGENT_SUMMARY_NEW_VALUE,
  CAMPAIGN_AGENT_SUMMARY_NEW_VALUES,
  CAMPAIGN_AGENT_SUMMARY_ADD_ONE,
  CAMPAIGN_AGENT_SUMMARY_ADD_MANY,
  CAMPAIGN_AGENT_SUMMARY_REMOVE_ONE,
  CAMPAIGN_AGENT_SUMMARY_REMOVE_ITEM,
  CAMPAIGN_AGENT_SUMMARY_REMOVE_MANY,
  CAMPAIGN_AGENT_SUMMARY_CREATE,
  CAMPAIGN_AGENT_SUMMARY_CREATE_UNNAMED,
  CAMPAIGN_AGENT_SUMMARY_CREATIVE,
  CAMPAIGN_AGENT_SUMMARY_MORE_ONE,
  CAMPAIGN_AGENT_SUMMARY_MORE_MANY,
  CAMPAIGN_AGENT_SUMMARY_FOOTNOTE,
  CAMPAIGN_AGENT_SUMMARY_CREATIVE_FOOTNOTE,
  CAMPAIGN_AGENT_SUMMARY_MANUAL,
  BUTTON_CAMPAIGN_AGENT_REVIEW_AND_APPLY,
  BUTTON_CAMPAIGN_AGENT_APPLY_AND_OPEN_AD,
  BUTTON_CAMPAIGN_AGENT_VIEW_RECOMMENDATION,
  BUTTON_CAMPAIGN_AGENT_VIEW_CHANGES,
  CAMPAIGN_AGENT_APPLIED_BADGE,
  CAMPAIGN_AGENT_APPLIED_CAPTION,
  CAMPAIGN_AGENT_DONE_CAPTION,
  CAMPAIGN_AGENT_DISCARDED_BADGE,
  CAMPAIGN_AGENT_DISCARDED_CAPTION,
  CAMPAIGN_AGENT_RESULT_APPLIED_TITLE,
  CAMPAIGN_AGENT_RESULT_APPLIED_DESCRIPTION,
  CAMPAIGN_AGENT_RESULT_PARTIAL_TITLE,
  CAMPAIGN_AGENT_RESULT_PARTIAL_DESCRIPTION,
  CAMPAIGN_AGENT_RESULT_FAILED_TITLE,
  CAMPAIGN_AGENT_RESULT_FAILED_DESCRIPTION,
  CAMPAIGN_AGENT_RESULT_CREATIVE_TITLE,
  CAMPAIGN_AGENT_RESULT_CREATIVE_DESCRIPTION,
  BUTTON_CAMPAIGN_AGENT_GO_TO_PUBLISH,
  BUTTON_CAMPAIGN_AGENT_NEXT_IMPROVEMENT,
  BUTTON_CAMPAIGN_AGENT_ASK_ALTERNATIVE,
  CAMPAIGN_AGENT_ASK_ALTERNATIVE_MESSAGE,
  CAMPAIGN_AGENT_FOLLOW_UP_MORE_TITLE,
  CAMPAIGN_AGENT_FOLLOW_UP_MORE_MESSAGE,
  CAMPAIGN_AGENT_FOLLOW_UP_BUDGET_TITLE,
  CAMPAIGN_AGENT_FOLLOW_UP_COPY_TITLE,
  CAMPAIGN_AGENT_BUTTON_TOOLTIP,
  CAMPAIGN_AGENT_BUTTON_TOOLTIP_PENDING_ONE,
  CAMPAIGN_AGENT_BUTTON_TOOLTIP_PENDING_MANY,
  PAYWALL_INSUFFICIENT_CREDITS_TITLE,
  PAYWALL_INSUFFICIENT_CREDITS_SUBTITLE,
  PAYWALL_INSUFFICIENT_CREDITS_UPGRADE_TITLE,
  PAYWALL_INSUFFICIENT_CREDITS_UPGRADE_DESCRIPTION,
  PAYWALL_INSUFFICIENT_CREDITS_BUY_TITLE,
  PAYWALL_INSUFFICIENT_CREDITS_BUY_DESCRIPTION,
  PAYWALL_INSUFFICIENT_CREDITS_ARIA_LABEL,
  BULK_CAMPAIGNS_CONTENTS_COUNTER,
  BULK_PLATFORM_GOOGLE,
  BULK_PLATFORM_META,
  BULK_PLATFORM_TIKTOK,
  BULK_PLATFORM_LINKEDIN,
  BULK_FIELD_INSTAGRAM,
  BULK_CAMPAIGNS_EMPTY_FILE,
  BULK_CAMPAIGNS_TOO_MANY_CONTENTS,
  BULK_CAMPAIGNS_ANALYZE,
  BULK_CAMPAIGNS_CANCEL_ANALYSIS,
  BULK_CAMPAIGNS_STALE,
  BULK_CAMPAIGNS_SELECT_CONTENTS,
  BULK_CAMPAIGNS_CONTENTS_HINT,
  BULK_CAMPAIGNS_REMOVE_CONTENT,
  BULK_CAMPAIGNS_FILE_READY,
  BULK_CAMPAIGNS_REPLACE_FILE,
  BULK_CAMPAIGNS_RESULT_CREATED,
  BULK_CAMPAIGNS_RESULT_FAILED,
  BULK_CAMPAIGNS_RESULT_CLEARED,
  BULK_CAMPAIGNS_RESULT_CLEARED_DETAIL,
  BULK_CAMPAIGNS_RESULT_TITLE,
  BULK_CAMPAIGNS_VIEW_CAMPAIGNS,
  BULK_CAMPAIGNS_SUMMARY_COUNT,
  BULK_CAMPAIGNS_ACCOUNTS_UNAVAILABLE,
  BULK_FIELD_PRIMARY_TEXT,
  BULK_FIELD_HEADLINE,
  BULK_FIELD_LONG_HEADLINE,
  BULK_FIELD_SEARCH_THEME,
  BULK_FIELD_CALL_TO_ACTION,
  BULK_FIELD_TITLES,
  BULK_FIELD_HEADLINES,
  BULK_FIELD_LONG_HEADLINES,
  BULK_FIELD_DESCRIPTIONS,
  BULK_FIELD_KEYWORDS,
  BULK_FIELD_KEYWORDS_NEGATIVE,
  BULK_FIELD_DESTINATION_URL,
  BULK_FIELD_DAILY_BUDGET,
  BULK_FIELD_LANGUAGE,
  BULK_FIELD_OBJECTIVE,
  BULK_FIELD_SEARCH_THEMES,
  BULK_FIELD_CALLOUTS,
  BULK_FIELD_AUDIENCE,
  BULK_FIELD_PAGE,
  BULK_FIELD_IDENTITY,
  BULK_FIELD_APP,
  BULK_FIELD_APP_STORE,
  BULK_FIELD_AD_FORMAT,
  BULK_FIELD_ACCOUNT,
  BULK_FIELD_MERCHANT,
  BULK_FIELD_LOCATIONS,
  TIKTOK_INDUSTRY_22102000000,
  TIKTOK_INDUSTRY_22101000000,
  TIKTOK_INDUSTRY_22107000000,
  TIKTOK_INDUSTRY_22108000000,
  TIKTOK_INDUSTRY_22109000000,
  TIKTOK_INDUSTRY_22106000000,
  TIKTOK_INDUSTRY_22999000000,
  TIKTOK_INDUSTRY_22112000000,
  TIKTOK_INDUSTRY_22105000000,
  TIKTOK_INDUSTRY_22113000000,
  TIKTOK_INDUSTRY_22110000000,
  TIKTOK_INDUSTRY_22111000000,
  TIKTOK_INDUSTRY_16105000000,
  TIKTOK_INDUSTRY_16104000000,
  TIKTOK_INDUSTRY_16101000000,
  TIKTOK_INDUSTRY_16102000000,
  TIKTOK_INDUSTRY_16999000000,
  TIKTOK_INDUSTRY_16100000000,
  TIKTOK_INDUSTRY_20101000000,
  TIKTOK_INDUSTRY_20110000000,
  TIKTOK_INDUSTRY_20104000000,
  TIKTOK_INDUSTRY_20106000000,
  TIKTOK_INDUSTRY_20109000000,
  TIKTOK_INDUSTRY_20107000000,
  TIKTOK_INDUSTRY_20102000000,
  TIKTOK_INDUSTRY_20105000000,
  TIKTOK_INDUSTRY_20999000000,
  TIKTOK_INDUSTRY_20111000000,
  TIKTOK_INDUSTRY_20103000000,
  TIKTOK_INDUSTRY_20100000000,
  TIKTOK_INDUSTRY_20108000000,
  TIKTOK_INDUSTRY_20112000000,
  TIKTOK_INDUSTRY_12104000000,
  TIKTOK_INDUSTRY_12108000000,
  TIKTOK_INDUSTRY_12100000000,
  TIKTOK_INDUSTRY_12102000000,
  TIKTOK_INDUSTRY_12110000000,
  TIKTOK_INDUSTRY_12105000000,
  TIKTOK_INDUSTRY_12107000000,
  TIKTOK_INDUSTRY_12109000000,
  TIKTOK_INDUSTRY_12103000000,
  TIKTOK_INDUSTRY_12999000000,
  TIKTOK_INDUSTRY_12101000000,
  TIKTOK_INDUSTRY_12106000000,
  TIKTOK_INDUSTRY_14105000000,
  TIKTOK_INDUSTRY_14104000000,
  TIKTOK_INDUSTRY_14107000000,
  TIKTOK_INDUSTRY_14106000000,
  TIKTOK_INDUSTRY_14101000000,
  TIKTOK_INDUSTRY_14100000000,
  TIKTOK_INDUSTRY_14999000000,
  TIKTOK_INDUSTRY_14103000000,
  TIKTOK_INDUSTRY_14102000000,
  TIKTOK_INDUSTRY_24108000000,
  TIKTOK_INDUSTRY_24118000000,
  TIKTOK_INDUSTRY_24105000000,
  TIKTOK_INDUSTRY_24103000000,
  TIKTOK_INDUSTRY_24104000000,
  TIKTOK_INDUSTRY_24109000000,
  TIKTOK_INDUSTRY_24114000000,
  TIKTOK_INDUSTRY_24107000000,
  TIKTOK_INDUSTRY_24120000000,
  TIKTOK_INDUSTRY_24119000000,
  TIKTOK_INDUSTRY_24116000000,
  TIKTOK_INDUSTRY_24117000000,
  TIKTOK_INDUSTRY_24111000000,
  TIKTOK_INDUSTRY_24106000000,
  TIKTOK_INDUSTRY_24112000000,
  TIKTOK_INDUSTRY_24101000000,
  TIKTOK_INDUSTRY_24999000000,
  TIKTOK_INDUSTRY_24113000000,
  TIKTOK_INDUSTRY_24100000000,
  TIKTOK_INDUSTRY_24102000000,
  TIKTOK_INDUSTRY_24110000000,
  TIKTOK_INDUSTRY_24115000000,
  TIKTOK_INDUSTRY_30100000000,
  TIKTOK_INDUSTRY_30102000000,
  TIKTOK_INDUSTRY_30101000000,
  TIKTOK_INDUSTRY_10100000000,
  TIKTOK_INDUSTRY_10102000000,
  TIKTOK_INDUSTRY_10105000000,
  TIKTOK_INDUSTRY_10106000000,
  TIKTOK_INDUSTRY_10999000000,
  TIKTOK_INDUSTRY_10103000000,
  TIKTOK_INDUSTRY_10101000000,
  TIKTOK_INDUSTRY_10104000000,
  TIKTOK_INDUSTRY_13100000000,
  TIKTOK_INDUSTRY_13108000000,
  TIKTOK_INDUSTRY_13117000000,
  TIKTOK_INDUSTRY_13115000000,
  TIKTOK_INDUSTRY_13116000000,
  TIKTOK_INDUSTRY_13112000000,
  TIKTOK_INDUSTRY_13107000000,
  TIKTOK_INDUSTRY_13104000000,
  TIKTOK_INDUSTRY_13102000000,
  TIKTOK_INDUSTRY_13110000000,
  TIKTOK_INDUSTRY_13111000000,
  TIKTOK_INDUSTRY_13109000000,
  TIKTOK_INDUSTRY_13999000000,
  TIKTOK_INDUSTRY_13105000000,
  TIKTOK_INDUSTRY_13113000000,
  TIKTOK_INDUSTRY_13101000000,
  TIKTOK_INDUSTRY_13114000000,
  TIKTOK_INDUSTRY_1310300000,
  TIKTOK_INDUSTRY_27103000000,
  TIKTOK_INDUSTRY_27104000000,
  TIKTOK_INDUSTRY_27100000000,
  TIKTOK_INDUSTRY_27101000000,
  TIKTOK_INDUSTRY_27102000000,
  TIKTOK_INDUSTRY_27999000000,
  TIKTOK_INDUSTRY_25301000000,
  TIKTOK_INDUSTRY_25302000000,
  TIKTOK_INDUSTRY_25300000000,
  TIKTOK_INDUSTRY_25313000000,
  TIKTOK_INDUSTRY_25303000000,
  TIKTOK_INDUSTRY_25999000000,
  TIKTOK_INDUSTRY_25311000000,
  TIKTOK_INDUSTRY_25304000000,
  TIKTOK_INDUSTRY_25305000000,
  TIKTOK_INDUSTRY_25306000000,
  TIKTOK_INDUSTRY_25307000000,
  TIKTOK_INDUSTRY_25308000000,
  TIKTOK_INDUSTRY_25309000000,
  TIKTOK_INDUSTRY_25310000000,
  TIKTOK_INDUSTRY_25312000000,
  TIKTOK_INDUSTRY_29102000000,
  TIKTOK_INDUSTRY_29101000000,
  TIKTOK_INDUSTRY_29100000000,
  TIKTOK_INDUSTRY_29103000000,
  TIKTOK_INDUSTRY_29999000000,
  TIKTOK_INDUSTRY_21102000000,
  TIKTOK_INDUSTRY_21101000000,
  TIKTOK_INDUSTRY_21103000000,
  TIKTOK_INDUSTRY_21104000000,
  TIKTOK_INDUSTRY_21100000000,
  TIKTOK_INDUSTRY_21999000000,
  TIKTOK_INDUSTRY_21105000000,
  TIKTOK_INDUSTRY_18106000000,
  TIKTOK_INDUSTRY_18110000000,
  TIKTOK_INDUSTRY_18104000000,
  TIKTOK_INDUSTRY_18101000000,
  TIKTOK_INDUSTRY_18102000000,
  TIKTOK_INDUSTRY_18105000000,
  TIKTOK_INDUSTRY_18108000000,
  TIKTOK_INDUSTRY_18109000000,
  TIKTOK_INDUSTRY_18999000000,
  TIKTOK_INDUSTRY_18112000000,
  TIKTOK_INDUSTRY_18100000000,
  TIKTOK_INDUSTRY_18103000000,
  TIKTOK_INDUSTRY_18107000000,
  TIKTOK_INDUSTRY_18111000000,
  TIKTOK_INDUSTRY_26114000000,
  TIKTOK_INDUSTRY_26112000000,
  TIKTOK_INDUSTRY_26102000000,
  TIKTOK_INDUSTRY_26113000000,
  TIKTOK_INDUSTRY_26108000000,
  TIKTOK_INDUSTRY_26104000000,
  TIKTOK_INDUSTRY_26105000000,
  TIKTOK_INDUSTRY_26111000000,
  TIKTOK_INDUSTRY_26999000000,
  TIKTOK_INDUSTRY_26101000000,
  TIKTOK_INDUSTRY_26106000000,
  TIKTOK_INDUSTRY_26107000000,
  TIKTOK_INDUSTRY_26109000000,
  TIKTOK_INDUSTRY_26103000000,
  TIKTOK_INDUSTRY_26100000000,
  TIKTOK_INDUSTRY_23113000000,
  TIKTOK_INDUSTRY_23114000000,
  TIKTOK_INDUSTRY_23122000000,
  TIKTOK_INDUSTRY_23102000000,
  TIKTOK_INDUSTRY_23126000000,
  TIKTOK_INDUSTRY_23108000000,
  TIKTOK_INDUSTRY_23105000000,
  TIKTOK_INDUSTRY_23111000000,
  TIKTOK_INDUSTRY_23116000000,
  TIKTOK_INDUSTRY_23104000000,
  TIKTOK_INDUSTRY_23128000000,
  TIKTOK_INDUSTRY_23107000000,
  TIKTOK_INDUSTRY_23124000000,
  TIKTOK_INDUSTRY_23125000000,
  TIKTOK_INDUSTRY_23127000000,
  TIKTOK_INDUSTRY_23115000000,
  TIKTOK_INDUSTRY_23106000000,
  TIKTOK_INDUSTRY_23109000000,
  TIKTOK_INDUSTRY_23110000000,
  TIKTOK_INDUSTRY_23100000000,
  TIKTOK_INDUSTRY_23119000000,
  TIKTOK_INDUSTRY_23999000000,
  TIKTOK_INDUSTRY_23129000000,
  TIKTOK_INDUSTRY_23101000000,
  TIKTOK_INDUSTRY_23118000000,
  TIKTOK_INDUSTRY_23130000000,
  TIKTOK_INDUSTRY_23131000000,
  TIKTOK_INDUSTRY_23103000000,
  TIKTOK_INDUSTRY_23134000000,
  TIKTOK_INDUSTRY_23123000000,
  TIKTOK_INDUSTRY_23132000000,
  TIKTOK_INDUSTRY_23133000000,
  TIKTOK_INDUSTRY_23112000000,
  TIKTOK_INDUSTRY_23117000000,
  TIKTOK_INDUSTRY_19999000000,
  TIKTOK_INDUSTRY_19103000000,
  TIKTOK_INDUSTRY_19101000000,
  TIKTOK_INDUSTRY_19102000000,
  TIKTOK_INDUSTRY_19105000000,
  TIKTOK_INDUSTRY_19106000000,
  TIKTOK_INDUSTRY_19104000000,
  TIKTOK_INDUSTRY_19100000000,
  TIKTOK_INDUSTRY_28100000000,
  TIKTOK_INDUSTRY_28101000000,
  TIKTOK_INDUSTRY_15100000000,
  TIKTOK_INDUSTRY_15105000000,
  TIKTOK_INDUSTRY_15103000000,
  TIKTOK_INDUSTRY_15101000000,
  TIKTOK_INDUSTRY_15102000000,
  TIKTOK_INDUSTRY_15104000000,
  TIKTOK_INDUSTRY_15106000000,
  TIKTOK_INDUSTRY_15107000000,
  TIKTOK_INDUSTRY_15999000000,
  TIKTOK_INDUSTRY_17103000000,
  TIKTOK_INDUSTRY_17999000000,
  TIKTOK_INDUSTRY_17105000000,
  TIKTOK_INDUSTRY_17106000000,
  TIKTOK_INDUSTRY_11111000000,
  TIKTOK_INDUSTRY_11110000000,
  TIKTOK_INDUSTRY_11101000000,
  TIKTOK_INDUSTRY_11103000000,
  TIKTOK_INDUSTRY_11102000000,
  TIKTOK_INDUSTRY_11100000000,
  TIKTOK_INDUSTRY_11107000000,
  TIKTOK_INDUSTRY_11112000000,
  TIKTOK_INDUSTRY_11104000000,
  TIKTOK_INDUSTRY_11108000000,
  TIKTOK_INDUSTRY_11106000000,
  TIKTOK_INDUSTRY_11999000000,
  TIKTOK_INDUSTRY_11105000000,
  TIKTOK_INDUSTRY_11109000000,
  META_ATTRIBUTION_WINDOW_TITLE,
  META_ATTRIBUTION_WINDOW_DESCRIPTION,
  META_ATTRIBUTION_WINDOW_7D_CLICK_1D_VIEW,
  META_ATTRIBUTION_WINDOW_7D_CLICK,
  META_ATTRIBUTION_WINDOW_1D_CLICK_1D_VIEW,
  META_ATTRIBUTION_WINDOW_1D_CLICK,
  META_ATTRIBUTION_WINDOW_DEFAULT_OPTION,
  META_ATTRIBUTION_ENGAGED_VIEW_LABEL,
  WHITE_LABEL_TITLE,
  WHITE_LABEL_BUY,
  WHITE_LABEL_PRICE_PER_MONTH,
  WHITE_LABEL_DIALOG_BODY,
  WHITE_LABEL_NO_SETUP_FEE,
  WHITE_LABEL_AFTER_PAYMENT,
  WHITE_LABEL_APP_SUMO_CONFIRM,
  WHITE_LABEL_ONLY_OWNER,
  WHITE_LABEL_STATUS_PENDING_BRANDING,
  WHITE_LABEL_STATUS_CONFIGURING,
  WHITE_LABEL_STATUS_ACTIVE,
  WHITE_LABEL_STATUS_REVERT_PENDING,
  WHITE_LABEL_ALREADY_ACTIVE,
  WHITE_LABEL_COMPLETE_BRAND,
  WHITE_LABEL_EDIT_BRAND,
  WHITE_LABEL_FORM_TITLE,
  WHITE_LABEL_FORM_INTRO,
  WHITE_LABEL_FORM_SECTION_GENERAL,
  WHITE_LABEL_FORM_SECTION_VISUAL,
  WHITE_LABEL_FORM_SECTION_VISUAL_HELP,
  WHITE_LABEL_FORM_SECTION_COLORS,
  WHITE_LABEL_FORM_SECTION_COLORS_HELP,
  WHITE_LABEL_FORM_SECTION_DOMAIN,
  WHITE_LABEL_FORM_BADGE_REQUIRED,
  WHITE_LABEL_FORM_BADGE_OPTIONAL,
  WHITE_LABEL_FORM_DROP_TITLE,
  WHITE_LABEL_FORM_DROP_HINT,
  WHITE_LABEL_FORM_INVALID_FILE,
  WHITE_LABEL_FORM_DOMAIN_BLOCKED,
  WHITE_LABEL_FORM_DOMAIN_INVALID,
  WHITE_LABEL_FORM_COLOR_INVALID,
  WHITE_LABEL_FORM_NAME_INVALID,
  WHITE_LABEL_FORM_NOTES_INVALID,
  WHITE_LABEL_FORM_LOGO_NAV_HELP,
  WHITE_LABEL_FORM_LOGO_LOGIN_HELP,
  WHITE_LABEL_FORM_FAVICON_CAPTION,
  WHITE_LABEL_FORM_FAVICON_HELP,
  WHITE_LABEL_FORM_NAME_PLACEHOLDER,
  WHITE_LABEL_FORM_DOMAIN_PLACEHOLDER,
  WHITE_LABEL_FORM_NOTES_PLACEHOLDER,
  WHITE_LABEL_FORM_COLOR_PRIMARY,
  WHITE_LABEL_FORM_COLOR_SECONDARY,
  WHITE_LABEL_FORM_COLOR_BUTTONS,
  WHITE_LABEL_FORM_NAME_BUSINESS,
  WHITE_LABEL_FORM_LOGO,
  WHITE_LABEL_FORM_LOGO_NAVBAR,
  WHITE_LABEL_FORM_LOGO_LOGIN,
  WHITE_LABEL_FORM_FAVICON,
  WHITE_LABEL_FORM_PRIMARY_COLOR,
  WHITE_LABEL_FORM_SECONDARY_COLOR,
  WHITE_LABEL_FORM_PRIMARY_BUTTON_COLOR,
  WHITE_LABEL_FORM_DESIRED_DOMAIN,
  WHITE_LABEL_FORM_DOMAIN_HELP,
  WHITE_LABEL_FORM_NOTES,
  WHITE_LABEL_FORM_SUBMIT,
  WHITE_LABEL_FORM_SUBMITTED,
  WHITE_LABEL_CONFIRMING_PAYMENT,
  WHITE_LABEL_CHECKOUT_CANCELLED,
  WHITE_LABEL_NOT_ELIGIBLE,
  WHITE_LABEL_ERROR_ALREADY_ACTIVE,
  WHITE_LABEL_NOT_PURCHASED,
  WHITE_LABEL_INVALID_BRANDING,
  WHITE_LABEL_INVALID_TRANSITION,
  AGENCY_ACCOUNT_LINKING_PICKER_TITLE,
  AGENCY_ACCOUNT_LINKING_PICKER_SHEET_TITLE,
  AGENCY_ACCOUNT_LINKING_PICKER_SHEET_DESCRIPTION,
  AGENCY_ACCOUNT_LINKING_CONSENT,
  AGENCY_ACCOUNT_LINKING_CONSENT_TOOLTIP,
  AGENCY_ACCOUNT_LINKING_CONSENT_INFO,
  AGENCY_ACCOUNT_LINKING_CARD_TITLE,
  AGENCY_ACCOUNT_LINKING_CARD_BODY,
  AGENCY_ACCOUNT_LINKING_ENABLE,
  AGENCY_ACCOUNT_LINKING_NOT_NOW,
  AGENCY_ACCOUNT_LINKING_SHEET_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_DESCRIPTION,
  AGENCY_ACCOUNT_LINKING_CONFIRM_ALERT_TITLE,
  AGENCY_ACCOUNT_LINKING_CONFIRM_ALERT_BODY,
  AGENCY_ACCOUNT_LINKING_CONFIRM,
  AGENCY_ACCOUNT_LINKING_TOAST_DONE_ONE,
  AGENCY_ACCOUNT_LINKING_TOAST_DONE_OTHER,
  AGENCY_ACCOUNT_LINKING_TOAST_PARTIAL,
  AGENCY_ACCOUNT_LINKING_TOAST_LATER,
  AGENCY_ACCOUNT_LINKING_PLATFORM_META,
  AGENCY_ACCOUNT_LINKING_PLATFORM_GOOGLE,
  AGENCY_ACCOUNT_LINKING_PLATFORM_TIKTOK,
  AGENCY_ACCOUNT_LINKING_SHEET_LINKING,
  AGENCY_ACCOUNT_LINKING_SHEET_PARTIAL_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_PARTIAL_BODY,
  AGENCY_ACCOUNT_LINKING_SHEET_FAILED_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_FAILED_BODY,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVAL_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVAL_BODY,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_META,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_GOOGLE,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_TIKTOK,
  AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_GENERIC,
  AGENCY_ACCOUNT_LINKING_SHEET_NOT_CONFIGURED,
  AGENCY_ACCOUNT_LINKING_SHEET_RECONNECT,
  AGENCY_ACCOUNT_LINKING_SHEET_RETRY_STEP,
  AGENCY_ACCOUNT_LINKING_SHEET_REQUEST_AGAIN,
  AGENCY_ACCOUNT_LINKING_SHEET_SUPPORT,
  AGENCY_ACCOUNT_LINKING_SHEET_IN_PROGRESS_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_IN_PROGRESS,
  AGENCY_ACCOUNT_LINKING_SHEET_PROCESSING_TITLE,
  AGENCY_ACCOUNT_LINKING_SHEET_PROCESSING,
  AGENCY_ACCOUNT_LINKING_COLUMN_STATUS,
  AGENCY_ACCOUNT_LINKING_COLUMN_DETAILS,
  AGENCY_ACCOUNT_LINKING_STATUS_UNLINKED,
  AGENCY_ACCOUNT_LINKING_STATUS_PENDING,
  AGENCY_ACCOUNT_LINKING_STATUS_FAILED,
  AGENCY_ACCOUNT_LINKING_STATUS_LINKED,
  AGENCY_ACCOUNT_LINKING_DETAIL_NOT_ADMIN,
  AGENCY_ACCOUNT_LINKING_DETAIL_RECONNECT,
  AGENCY_ACCOUNT_LINKING_DETAIL_UNREADABLE,
  AGENCY_ACCOUNT_LINKING_DETAIL_NOT_CONFIGURED,
  AGENCY_ACCOUNT_LINKING_DETAIL_NOT_IN_BUSINESS,
  AGENCY_ACCOUNT_LINKING_DETAIL_LIMIT,
  AGENCY_ACCOUNT_LINKING_DETAIL_MANAGED_ELSEWHERE,
  AGENCY_ACCOUNT_LINKING_DETAIL_INCOMPATIBLE,
  AGENCY_ACCOUNT_LINKING_DETAIL_REJECTED,
  AGENCY_ACCOUNT_LINKING_DETAIL_EXPIRED,
  AGENCY_ACCOUNT_LINKING_DETAIL_REVOKED,
  AGENCY_ACCOUNT_LINKING_DETAIL_UNSUPPORTED,
  AGENCY_ACCOUNT_LINKING_DETAIL_GENERIC,
  ADLE_CARD_WAITLIST_EYEBROW,
  ADLE_CARD_WAITLIST_TITLE,
  ADLE_CARD_WAITLIST_SUBTITLE,
  ADLE_CARD_WAITLIST_FEATURE_VIRTUAL_CARDS,
  ADLE_CARD_WAITLIST_FEATURE_SINGLE_BALANCE,
  ADLE_CARD_WAITLIST_FEATURE_CASHBACK,
  ADLE_CARD_WAITLIST_FEATURE_NO_FEES,
  ADLE_CARD_WAITLIST_FEATURE_NO_DECLINES,
  ADLE_CARD_WAITLIST_FEATURE_TOP_UPS,
  ADLE_CARD_WAITLIST_EMAIL_LABEL,
  ADLE_CARD_WAITLIST_COUNTRY_LABEL,
  ADLE_CARD_WAITLIST_COUNTRY_PLACEHOLDER,
  ADLE_CARD_WAITLIST_CTA,
  ADLE_CARD_WAITLIST_NOT_NOW,
  ADLE_CARD_WAITLIST_DISCLAIMER,
  ADLE_CARD_WAITLIST_SUCCESS_TITLE,
  ADLE_CARD_WAITLIST_SUCCESS_DESCRIPTION,
  ADLE_CARD_WAITLIST_SUBMIT_ERROR,
  ADLE_CARD_WAITLIST_BANNER,
  ADLE_CARD_WAITLIST_BANNER_LINK,
  ADLE_CARD_WAITLIST_CARD_ARIA,
  ADLE_CARD_WAITLIST_CARD_VIRTUAL,
  ADLE_CARD_WAITLIST_CARD_BRAND_FALLBACK,
  OWNER_DASHBOARD_NAV_ADLE_CARD_WAITLIST,
  ADLE_CARD_WAITLIST_ADMIN_TOTAL,
  ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_ALL_TIME,
  ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_3M,
  ADLE_CARD_WAITLIST_ADMIN_SPEND_UNAVAILABLE,
} from "../keysTranslations";

const translation = {
  /*COMMON*/
  [SEARCH]: "Search",
  [LOADING_INFORMATION]: "Loading information",
  [LOADING_SUGGESTED_INFORMATION]:
    "Searching suggested creators, it may take a while.",
  [LOADING_SIMILAR_PROFILES_INFORMATION]: "Loading reference profiles",
  [LOADING_REPORT_INFORMATION]: "Loading report",
  [LOADING_DOWNLOAD_PROFILES]: "Downloading profiles",
  [LOADING_CONTENT]: "Loading content",
  [LOADING_CONFIGURATION]: "Loading configuration",
  [LOADING_PLAN_INFORMATION]: "Loading plan information",
  [UPDATING_INFORMATION]: "Updating information",
  [INFORMATION_INVALID_ACCESS]: "You cannot access this information",
  [EMPTY_CONTENT_SHOW]: "No content to display",
  [EMPTY_SIMILAR_PROFILES_SHOW]: "No reference profiles found",
  [EMPTY_RESULTS_SHOW]: "No results found",
  [NO_MORE_RESULTS_TO_SHOW]: "There are no more results to display",
  [EMPTY_RESULTS_SHOW_ON_THIS_PAGE]: "No results found on this page",
  [EMPTY_QUESTIONS_SHOW]: "No questions found",
  [EMPTY_ANALYTICS]:
    "Analytics for this post could not be retrieved. Please contact support or your advisor for assistance.",
  [EMPTY_KEYWORDS]: "No keywords found",
  [ADVANCED_CONFIGURATION]: "Advanced configuration",
  [WAIT]: "Wait",
  [COLLABORATIONS]: "Collaborations",
  [COLLABORATION]: "Collaboration",
  [ALL]: "All",
  [DEACTIVATE]: "Deactivate",
  [ACTIVATE]: "Activate",
  [DEACTIVATED]: "Deactivated",
  [ACTIVATED]: "Activated",
  [ACTIVE]: "Active",
  [BRAND]: "Brand",
  [WARNING]: "Warning",
  [INFORMATION]: "Information",
  [CATEGORY]: "Category",
  [CATEGORIES]: "Categories",
  [PRODUCT]: "Product",
  [PRODUCTS]: "Products",
  [ERROR]: "Error",
  [ACTIONS]: "Actions",
  [STATUS]: "Status",
  [CITIES]: "Cities",
  [UNKNOWN_FORMAT]: "Unknown format",
  [ERROR_DESCRIPTION_GENERIC]: "{{message}}",
  [HELP]: "Help",
  [READY]: "Done",
  [FIELD_HAS_NO_VALUE_TO_COPY]: "This field has no value to copy",
  [GO]: "Go",
  [GO_TO_PROFILE]: "Go to profile",
  [GO_TO_ACCOUNT]: "Go to account",
  [PROFILE]: "Profile",
  [LOGOUT]: "Log Out",
  [CLIENT]: "Client",
  [NAME]: "Name",
  [ADDRESS]: "Address",
  [IDENTIFICATION_NUMBER]: "Identification number",
  [PHONE_NUMBER]: "Phone number",
  [EMAIL]: "Email",
  [NOTIFICATIONS]: "Notifications",
  [CONTENT]: "Content",
  [ANALYTIC]: "Analytic",
  [ANALYTICS]: "Analytics",
  [COMMENTS]: "Comments",
  [COMMENT]: "Comment",
  [SHOW_COMMENTS]: "Show comments",
  [EMPTY_COMMENTS]: "No comments",
  [REVIEWS]: "Reviews",
  [REVIEW]: "Review",
  [SHOW_REVIEWS]: "Show reviews",
  [EMPTY_REVIEWS]: "No reviews",
  [SCORE]: "Score",
  [QUALITY_AUDIENCE]: "Audience quality",
  [QUALITY_CONTENT]: "Content quality",
  [AUDIENCE]: "Audience",
  [AUDIENCE_TITLE_EXPLANATION]: "What is the audience?",
  [AUDIENCE_EXPLANATION]:
    "The audience is the number of people who follow or subscribe to the content creator's profile. Larger audiences have a better reach for each post, but generally the interaction or engagement rate is lower as the audience increases.",
  [ENGAGEMENT]: "Engagement",
  [ENGAGEMENT_TITLE_EXPLANATION]: "What is the engagement?",
  [ENGAGEMENT_EXPLANATION]:
    "The engagement or interaction rate is the number of people who interact with the published content, whether it is a like, a comment, a share, or save, and other actions depending on the platform. If you want to estimate how many people will interact with the content, multiply the audience by the engagement and divide it by 100.",
  [FOLLOWERS]: "Followers",
  [AVG_VIEWS]: "Avg views",
  [AVG_LIKES]: "Avg likes",
  [POST]: "Post",
  [AVG_COMMENTS]: "Avg comments",
  [RECORDS_IN_TABLE]: "Records",
  [SHOP_DEACTIVATE_ALERT_DESCRIPTION]:
    "Your shop has been deactivated. Contact support if you need help.",
  [PAGE_IN_TABLE]: "Page",
  [UPDATE]: "Update",
  [MALES]: "Males",
  [MALE]: "Male",
  [FEMALES]: "Females",
  [FEMALE]: "Female",
  [STORE]: "Store",
  [SELECT_STORE]: "Select store",
  [EMPTY_STORES]: "No stores created",
  [ORDER]: "Order",
  [NEW_ORDER]: "New order",
  [NEW]: "New",
  [SECOND]: "Second",
  [SECONDS]: "Seconds",
  [MINUTE]: "Minute",
  [MINUTES]: "Minutes",
  [MINUTE_LETTER_COUNT_DOWN]: "min",
  [HOUR]: "Hour",
  [HOURS]: "Hours",
  [HOUR_LETTER_COUNT_DOWN]: "h",
  [DAY]: "Day",
  [DAYS]: "Days",
  [DAY_LETTER_COUNT_DOWN]: "d",
  [WEEK]: "Week",
  [WEEKS]: "Weeks",
  [WEEK_LETTER_COUNT_DOWN]: "w",
  [MONTH]: "Month",
  [MONTHS]: "Months",
  [CALENDAR_MONTH]: "Month",
  [CALENDAR_WEEK]: "Week",
  [CALENDAR_DAY]: "Day",
  [CALENDAR_TODAY]: "Today",
  [CALENDAR_TOMORROW]: "Tomorrow",
  [CALENDAR_NEXT]: "Next",
  [CALENDAR_PREVIOUS]: "Previous",
  [CALENDAR_AGENDA]: "Agenda",
  [CALENDAR_SHOW_MORE]: "+ {{total}} more",
  [VIEW_CALENDAR]: "View Calendar",
  [POST_TITLE]: "Posts",
  [CALENDAR_POST_TITLE]: "Post",
  [CALENDAR_STORIES_TITLE]: "Story",
  [CALENDAR_REELS_TITLE]: "Reel",
  [CALENDAR_MULTIPLE_POST_TITLE]: "Post - Multiple Networks",
  [CALENDAR_INVALID_DATE_ERROR]:
    "Please select a future date and time to schedule your post.",
  [EVENT_DETAILS_DESCRIPTION]: "Description",
  [EVENT_DETAILS_DATE_AND_TIME]: "Date and time",
  [EVENT_DETAILS_SOCIAL_NETWORK]: "Social network",
  [EVENT_DETAILS_STATUS]: "Status",
  [EVENT_DETAILS_STATUS_DRAFT]: "Draft",
  [EVENT_DETAILS_STATUS_SCHEDULED]: "Scheduled",
  [EVENT_DETAILS_STATUS_PUBLISHED]: "Published",
  [GALLERY_MAX_SELECTIONS_REACHED]: "You can select up to {{limit}} items.",
  [GALLERY_PUBLISHED_ON_PLATFORMS]: "Published on {{platforms}}",
  [GALLERY_PLATFORM_STATUSES_LABEL]: "Publication statuses",
  [GALLERY_STATUS_PUBLISHED_DIRECT]: "Published directly on {{date}}",
  [GALLERY_STATUS_PUBLISHED_DIRECT_UNKNOWN]: "Published directly",
  [GALLERY_STATUS_SCHEDULED]: "Scheduled for {{date}}",
  [GALLERY_STATUS_SCHEDULED_UNKNOWN]: "Scheduled",
  [GALLERY_STATUS_PUBLISHED_SCHEDULE]: "Published via schedule on {{date}}",
  [GALLERY_STATUS_PUBLISHED_SCHEDULE_UNKNOWN]: "Published via schedule",
  [GALLERY_STATUS_FAILED]: "Failed on {{date}}",
  [GALLERY_STATUS_FAILED_UNKNOWN]: "Failed",
  [GALLERY_STATUS_PUBLISHED_LEGACY]: "Published",
  [SHARE_MODAL_PLATFORM_ALREADY_PUBLISHED]:
    "This platform was already published and cannot be removed",
  [EVENT_DETAILS_STATUS_FAILED]: "Publishing Failed",
  [EVENT_DETAILS_NETWORK_INSTAGRAM]: "Instagram",
  [EVENT_DETAILS_NETWORK_FACEBOOK]: "Facebook",
  [EVENT_DETAILS_NETWORK_TIKTOK]: "TikTok",
  [EVENT_DETAILS_NETWORK_LINKEDIN]: "LinkedIn",
  [EVENT_DETAILS_NETWORK_YOUTUBE]: "YouTube",
  [EVENT_DETAILS_CONTENT]: "Content",
  [ORGANIC_PUBLISH_RETRY_CONFIRM_TITLE]: "Do you want to retry publishing?",
  [ORGANIC_PUBLISH_RETRY_CONFIRM_DESCRIPTION]:
    "You are about to retry publishing on {{platforms}}.",
  [ORGANIC_PUBLISH_RETRY_ALERT_ARIA_LABEL]:
    "Platforms and errors for publishing retry",
  [ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_PLATFORM]: "Platform",
  [ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_MESSAGE]: "Message",
  [ORGANIC_PUBLISH_RETRY_ERROR]:
    "Some platforms could not be published. Review the errors and try again.",
  [ORGANIC_PUBLISH_PARTIAL_STATUS]: "Partially published",
  [QUESTION]: "Question",
  [QUESTIONS]: "Questions",
  [CONTENT_CREATOR]: "Content creator",
  [ADD]: "Add",
  [MONDAY]: "Monday",
  [TUESDAY]: "Tuesday",
  [WEDNESDAY]: "Wednesday",
  [THURSDAY]: "Thursday",
  [FRIDAY]: "Friday",
  [SATURDAY]: "Saturday",
  [SUNDAY]: "Sunday",
  [SELECT_A_OPTION]: "Select an option",
  [FILE_SELECTED]: "Selected file: {{fileName}}",
  [YES]: "Yes",
  [NO]: "No",
  [IMAGES]: "Images",
  [VIDEOS]: "Videos",
  [OK]: "Ok",
  [FILTER]: "Filter",
  [SUPER_ADMIN]: "Super Administrator",
  [ADMIN]: "Administrator",
  [OPERATOR]: "Operator",
  [TOTAL]: "Total",
  [NO_HAVE]: "No have",
  [NO_ADDED]: "Not Added",
  [SUPPORT]: "Support",
  [CONTACT_US]: "Contact us",
  [ONE]: "One",
  [TWO]: "Two",
  [THREE]: "Three",
  [ANY]: "Any",
  [GENDER]: "Gender",
  [REVISIONS]: "Revisions",
  [CURRENT_CONTENT]: "Current content",
  [CURRENT_CONTENT_EMPTY]:
    "No current content, wait for the creator to upload it",
  [NO_SEND_CONTENT_FEEDBACK]: "The creator did not send feedback content",
  [EDIT]: "Edit",
  [THIS_CREATOR_IS_FAVORITE]: "Is favorite",
  [ADD_TO_FAVORITES]: "Add to favorites",
  [REMOVE_FROM_FAVORITES]: "Remove from favorites",
  [SPANISH]: "Spanish",
  [ENGLISH]: "English",
  [PORTUGUESE]: "Portuguese",
  [FRENCH]: "French",
  [RUSSIAN]: "Russian",
  [JAPANESE]: "Japanese",
  [MANDARIN]: "Mandarin",
  [HINDI]: "Hindi",
  [ARABIC]: "Arabic",
  [BENGALI]: "Bengali",
  [PUNJABI]: "Punjabi",
  [GERMAN]: "German",
  [JAVANESE]: "Javanese",
  [KOREAN]: "Korean",
  [INDONESIAN]: "Indonesian",
  [TURKISH]: "Turkish",
  [BULGARIAN]: "Bulgarian",
  [SLOVAK]: "Slovak",
  [CROATIAN]: "Croatian",
  [DANISH]: "Danish",
  [UKRAINIAN]: "Ukrainian",
  [ENGLISH_US]: "English (US)",
  [ENGLISH_UK]: "English (UK)",
  [SPANISH_SPAIN]: "Spanish (Spain)",
  [PORTUGUESE_BRAZIL]: "Portuguese (Brazil)",
  [PORTUGUESE_PORTUGAL]: "Portuguese (Portugal)",
  [FRENCH_FRANCE]: "French (France)",
  [FRENCH_CANADA]: "French (Canada)",
  [TRADITIONAL_CHINESE_HONG_KONG]: "Traditional Chinese (Hong Kong)",
  [TRADITIONAL_CHINESE_TAIWAN]: "Traditional Chinese (Taiwan)",
  [JAPANESE_KANSAI]: "Japanese (Kansai)",
  [NORWEGIAN_BOKMAL]: "Norwegian (Bokmål)",
  [NORWEGIAN_NYNORSK]: "Norwegian (Nynorsk)",
  [CATALAN]: "Catalan",
  [CZECH]: "Czech",
  [WELSH]: "Welsh",
  [BASQUE]: "Basque",
  [FINNISH]: "Finnish",
  [GALICIAN]: "Galician",
  [HUNGARIAN]: "Hungarian",
  [ITALIAN]: "Italian",
  [DUTCH]: "Dutch",
  [FRISIAN]: "Frisian",
  [POLISH]: "Polish",
  [ROMANIAN]: "Romanian",
  [SLOVENIAN]: "Slovenian",
  [SWEDISH]: "Swedish",
  [FLEMISH]: "Flemish",
  [ESPERANTO]: "Esperanto",
  [ESTONIAN]: "Estonian",
  [FAROESE]: "Faroese",
  [GREEK]: "Greek",
  [ICELANDIC]: "Icelandic",
  [IRISH]: "Irish",
  [LATVIAN]: "Latvian",
  [LITHUANIAN]: "Lithuanian",
  [MACEDONIAN]: "Macedonian",
  [THAI]: "Thai",
  [VIETNAMESE]: "Vietnamese",
  [KHMER]: "Khmer",
  [FILIPINO]: "Filipino",
  [MALAY]: "Malay",
  [GUJARATI]: "Gujarati",
  [KANNADA]: "Kannada",
  [TAMIL]: "Tamil",
  [TELUGU]: "Telugu",
  [MALAYALAM]: "Malayalam",
  [URDU]: "Urdu",
  [HEBREW]: "Hebrew",
  [PERSIAN]: "Persian",
  [NORTHERN_KURDISH_KURMANJI]: "Northern Kurdish (Kurmanji)",
  [ARMENIAN]: "Armenian",
  [AZERBAIJANI]: "Azerbaijani",
  [BELARUSIAN]: "Belarusian",
  [BOSNIAN]: "Bosnian",
  [GEORGIAN]: "Georgian",
  [KAZAKH]: "Kazakh",
  [MONGOLIAN]: "Mongolian",
  [SERBIAN]: "Serbian",
  [TAJIK]: "Tajik",
  [UZBEK]: "Uzbek",
  [AFRIKAANS]: "Afrikaans",
  [SWAHILI]: "Swahili",
  [ALBANIAN]: "Albanian",
  [CEBUANO]: "Cebuano",
  [GUARANI]: "Guarani",
  [MARATHI]: "Marathi",
  [NEPALI]: "Nepali",
  [PASHTO]: "Pashto",
  [SINHALA]: "Sinhala",
  [CHINESE]: "Chinese",
  [ASSAMESE]: "Assamese",
  [HARYANAVI]: "Haryanavi",
  [BIHARI]: "Bihari",
  [ORIYA]: "Oriya",
  [RAJASTHANI]: "Rajasthani",
  [NORWEGIAN]: "Norwegian",
  [VIEW]: "View",
  [STORES]: "Stores",
  [PLAN]: "Plan",
  [AUTOMATIC_RENOVATION]: "Automatic renovation",
  [PREVIOUS_PERIOD]: "Previous period",
  [START_DATE_AND_END_DATE_VALIDATION]:
    "The start date cannot be greater than the end date",
  [LOADING_CONFIGURATION_METRICS]: "Loading configuration metrics",
  [ACCEPTED]: "Accepted",
  [PENDING]: "Pending",
  [ARE_YOU_SURE]: "Are you sure?",
  [ARE_YOU_SURE_TO_DISCONNECT_ACCOUNT]:
    "Are you sure you want to disconnect this account?",
  [CHANGE]: "Change",
  [REPORT_REQUESTS]: "Requests report",
  [REQUESTS_ACCEPTED]: "Accepted",
  [REQUESTS_REJECTED]: "Rejected",
  [REQUESTS_ACTIVE]: "Active requests",
  [CODE]: "Code",
  [IS_AUTOMATIC]: "Is automatic",
  [REDEEMED]: "Redeemed",
  [EXPIRED]: "Expired",
  [REDEEMED_SINGULAR]: "Redeemed",
  [EXPIRED_SINGULAR]: "Expired",
  [REJECTED]: "Rejected",
  [ROLE]: "Role",
  [UNKNOWN]: "Unknown",
  [RIGHT]: "Right",
  [LEFT]: "Left",
  [LOGO]: "Logo",
  [LOGO_DESCRIPTION]:
    "For best results, use a logo without transparency, with a solid background that contrasts with the logo elements.",
  [CANCEL_ANYTIME]: "Cancel anytime",
  [ADD_BRAND]: "Add brand",
  [DATE]: "Date",
  [NAME_BUSINESS_BOT]: "Ana from {{NAME_BUSINESS}}",
  [SERVICE_FEE]: "Service fee",
  [TOTAL_PAYMENT]: "Total payment",
  [LAST_COLLABORATION]: "Last collaboration",
  [PERSONALIZED_INSTRUCTIONS]: "Personalized instructions",
  [EMPTY_REQUESTS]: "You don't have any requests yet",
  [EMPTY_CAMPAIGNS]: "You don't have any campaigns yet",
  [EMPTY_ORDERS]: "You don't have any collaborations yet",
  [EMPTY_REDEEM_CODES]: "You don't have any redeemed codes yet",
  [EMPTY_USERS]: "You haven't created any users yet",
  [EMPTY_CONTACTS]: "You haven't created any contacts yet",
  [EMPTY_INVOICES]: "You haven't created any invoices yet",
  [EMPTY_APPLICANTS_PENDING]: "You don't have any pending applicants yet",
  [EMPTY_APPLICANTS_ACCEPTED]: "You haven't accepted any applicants yet",
  [EMPTY_ADS_CAMPAIGNS]: "You don't have any ads campaigns yet",
  [TARGET_CAMPAIGN]: "Targeting",
  [LOCATIONS]: "Locations",
  [GENDERS]: "Genders",
  [AGES]: "Ages",
  [PLATFORMS]: "Platforms",
  [PLATFORM]: "Platform",
  [PREVIOUS_PERIOD]: "Previous period",
  [REPORTS]: "Report",
  [IMPRESSIONS]: "Impressions",
  [CLICKS]: "Clicks",
  [CTR]: "CTR",
  [CPA]: "CPA",
  [CLICK]: "Clicks",
  [CPM]: "CPM",
  [CPC]: "CPC",
  [RESULTS]: "Results",
  [SPEND]: "Spend",
  [PERIOD]: "Period",
  [AVERAGE]: "Average",
  [TYPE_LEAST_CHARACTERS]: "Type at least {{value}} characters",
  [LOADING]: "Loading",
  [OBJECTIVE]: "Objective",
  [AWARENESS]: "Awareness",
  [TRAFFIC]: "Traffic",
  [INTERACTIONS]: "Interactions",
  [LEADS]: "Leads",
  [DOWNLOADS]: "Downloads",
  [SALES]: "Sales",
  [META_CAMPAIGN]: "Meta campaign",
  [TIKTOK_CAMPAIGN]: "TikTok campaign",
  [CONTENT_TO_ADVERTISE]: "Content",
  [EMPTY_TRACKING_IDS_META]: "You have no Meta pixels created",
  [EMPTY_TRACKING_IDS_LINKEDIN]: "You have no LinkedIn pixels created",
  [FINISHED]: "Finished",
  [TIKTOK_BUSINESS]: "TikTok Business",
  [EMPTY_TRACKING_IDS_TIKTOK]: "You have no TikTok pixels created",
  [TIKTOK_PRIVACY_LEVEL_LABEL]: "Privacy Level",
  [TIKTOK_ACCOUNT_LABEL]: "TikTok Account",
  [TIKTOK_PRIVACY_LEVEL_PUBLIC_TO_EVERYONE]: "Public to Everyone",
  [TIKTOK_PRIVACY_LEVEL_MUTUAL_FOLLOW_FRIENDS]: "Mutual Follow Friends",
  [TIKTOK_PRIVACY_LEVEL_FOLLOWER_OF_CREATOR]: "Follower of Creator",
  [TIKTOK_PRIVACY_LEVEL_SELF_ONLY]: "Self Only",
  [TIKTOK_DISABLE_DUET_LABEL]: "Disable Duet",
  [TIKTOK_DISABLE_DUET_DESCRIPTION]:
    "If enabled, other TikTok users will not be allowed to make Duets using this post",
  [TIKTOK_DISABLE_STITCH_LABEL]: "Disable Stitch",
  [TIKTOK_DISABLE_STITCH_DESCRIPTION]:
    "If enabled, other TikTok users will not be allowed to make Stitches using this post",
  [TIKTOK_DISABLE_COMMENT_LABEL]: "Disable Comments",
  [TIKTOK_AUTO_ADD_MUSIC_LABEL]: "Auto Add Music",
  [TIKTOK_DISABLE_COMMENT_DESCRIPTION]:
    "If enabled, other TikTok users will not be allowed to make comments on this post",
  [TIKTOK_IS_AIGC_LABEL]: "AI Generated Content",
  [TIKTOK_IS_AIGC_DESCRIPTION]:
    "Set to true if the video is AI generated content. The video will be labelled with Creator labeled as AI-generated tag",
  [SHORT_TIME_HAS_PASSED_SINCE_ACTIVATION_STATISTICS]:
    "A short time has passed since you activated the campaign, the statistics may take a while to update",
  [SHOPIFY]: "Shopify",
  [WOOCOMMERCE]: "Woocommerce",
  [FOLLOWERS_ABBREVIATED]: "FLL",
  [ENGAGEMENT_ABBREVIATED]: "ER",
  [ADD_NEW_STYLE]: "Add new style",
  [WANTS_SOCIAL_MEDIA_POST]: "I want social media exposure",
  [DOES_NOT_WANTS_SOCIAL_MEDIA_POST]: "I don't want social media exposure",
  [EXPLANATION_SEND_ONE_REVISION]:
    "You will only be able to submit one revision",
  [I_NEED_HELP]: "I need help",
  [REVISION_OPTION_GOOD]: "Awesome! But I have a question",
  [REVISION_OPTION_REGULAR]: "It's okay, but something's missing",
  [REVISION_OPTION_BAD]: "This doesn't work for me",
  [WHY_THESE_RECOMMENDED_SETTINGS]: "Why these recommended settings?",
  [PIXEL_REQUIRED]: "Pixel required",
  [DRAFT]: "Draft",
  [CANVA]: "Canva",
  [CONNECTED_ACCOUNTS]: "Connected accounts",
  [CONNECTED_ACCOUNTS_CONNECT_MORE_PLATFORMS]: "Connect more platforms",
  [CONNECTED_ACCOUNTS_BUTTON_CONNECT]: "Connect",
  [CONNECTED_ACCOUNTS_EMPTY_HINT]:
    "You have no ad accounts connected yet. Use the plus button to add one.",
  [CONNECTED_ACCOUNTS_INTEGRATIONS_COUNT]: "{{count}} accounts",
  [CONNECTED_ACCOUNTS_INTEGRATIONS_COUNT_SINGULAR]: "1 account",
  [CONNECTED_ACCOUNTS_PLATFORM_META]: "Meta",
  [CONNECTED_ACCOUNTS_PLATFORM_GOOGLE]: "Google Ads",
  [CONNECTED_ACCOUNTS_PLATFORM_TIKTOK_BUSINESS]: "TikTok",
  [CONNECTED_ACCOUNTS_PLATFORM_LINKEDIN]: "LinkedIn",
  [CONNECTED_ACCOUNTS_ACCORDION_EXPAND]: "Show connected accounts",
  [SLIDE_MENU_COLLAPSE]: "Collapse menu",
  [SLIDE_MENU_EXPAND]: "Expand menu",
  [CONNECTED_ACCOUNTS_ACCORDION_COLLAPSE]: "Hide connected accounts",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_TITLE]: "Default Campaign Settings",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE]: "Save Settings",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_SUCCESS]:
    "Default campaign settings saved successfully",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_ERROR]:
    "Could not save default campaign settings. Please try again.",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_LOADING]: "Loading saved settings...",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_AD_FORMAT_LABEL]: "Ad Format",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_LABEL]: "App",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_PROMOTION_LABEL]: "App Promotion",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CAMPAIGN_TYPE_LABEL]: "Campaign Type",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CATALOG_FOR_APP_INSTALL_LABEL]:
    "Catalog for App Install",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CATALOG_LABEL]: "Catalog",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DEEP_LINK_LABEL]: "Deep Link",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DESTINATION_TYPE_LABEL]:
    "Destination Type",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DESTINATION_URL_LABEL]:
    "Destination URL",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_IDENTITIES_ACCOUNTS_LABEL]:
    "Accounts and Identities",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_MERCHANT_ID_LABEL]: "Merchant Center",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_OBJECTIVE_LABEL]: "Campaign Objective",
  [CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_TIKTOK_CAMPAIGN_TYPE_LABEL]:
    "TikTok Campaign Type",
  [CAMPAIGN]: "Campaign",
  [ASSETS_GROUP]: "Assets group",
  [AD_GROUP]: "Ad group",
  [AD]: "Ad",
  [NUMBER_ITEM]: "N° {{value}}",
  [TITLES]: "Titles",
  [TITLES_META]: "Primary Texts",
  [TITLE]: "Title",
  [LONG_HEADLINES]: "Long Headlines",
  [HEADLINES]: "Headlines",
  [DESCRIPTIONS]: "Descriptions",
  [COMING_SOON]: "Coming soon",
  [ENTER_CODE]: "Enter code",
  [WE_SEND_VERIFICATION_CODE_TO_YOUR_PHONE]:
    "We will send a verification code to your phone, it may take up to a minute to arrive.",
  [MODIFY_PHONE_NUMBER]: "Modify phone number",
  [OTP_VERIFICATION_TITLE]: "Verification Code",
  [OTP_VERIFICATION_EMAIL_SENT]:
    "We've sent a 6-digit code to {{emailMasked}}.",
  [OTP_BACK_TO_EMAIL]: "Back to email",
  [META_TOGGLE_DESCRIPTION]: "Facebook, Instagram and Audience Network",
  [GOOGLE_TOGGLE_DESCRIPTION]:
    "Search engine. Coming soon: YouTube and Display Network",
  [TIKTOK_TOGGLE_DESCRIPTION]: "TikTok Feed and Search",
  [LINKEDIN_TOGGLE_DESCRIPTION]: "LinkedIn Feed, Search, and Chat",
  [NOT_AVAILABLE]: "Not available",
  [EDIT_INSTRUCTIONS]: "Edit instructions",
  [PROMPT]: "Prompt",
  [TYPE]: "Type",
  [RETENTION_DAYS]: "Retention days",
  [ERRORS]: "Errors",
  [DELIVERY_STATUS]: "Delivery status",
  [OPERATION_STATUS]: "Operation status",
  [MOST_POPULAR]: "Most popular",
  [MANUAL_SEGMENTATION]: "Manual segmentation",
  [RE_TARGETING_SEGMENTATION]: "Custom audiences",
  [IDENTITIES_TIK_TOK_EMPTY]: "You have no TikTok identities",
  [ADD_NEW_IDENTITY]: "Add new identity",
  [GENERAL_INFORMATION]: "General information",
  [CONTEXT]: "Context",
  [CAMPAIGN_HAS_NEVER_BEEN_ACTIVATED]: "The campaign has never been activated",
  [LOADING_METRICS_FROM_PLATFORMS]: "Loading metrics...",
  [HOW_IS_YOUR_CAMPAIGN_GOING]: "Recommendations this Week",
  [AN_ERROR_OCCURRED_GETTING_THE_REPORT]:
    "An error occurred while generating the report, try again later.",
  [AD_ACCOUNTS]: "Ad Accounts",
  [FACEBOOK_PAGES]: "Facebook Pages",
  [INSTAGRAM_ACCOUNTS]: "Instagram Accounts",
  [LAST_RECORDED_EVENT_ON]: "Last recorded event on",
  [NEVER]: "Never",
  [PIXEL_HAS_NO_RECORDED_EVENTS]: "The pixel has no recorded events",
  [LAST_UPDATE]: "Last update",
  [IN_A_FEW_MINUTES_YOUR_INVOICE_WILL_BE_AVAILABLE]:
    "Your new benefits will be activated in a few seconds",
  [RETRIEVING_GENERAL_INFORMATION]:
    "We are retrieving your general account information.",
  [RETRIEVING_YOUTUBE_CHANNEL]:
    "We are retrieving your YouTube channel information.",
  [RETRIEVING_TIKTOK_PROFILE]: "We are retrieving your TikTok profile.",
  [RETRIEVING_AD_ACCOUNTS]:
    "We are retrieving the listing of advertising accounts.",
  [RETRIEVING_FACEBOOK_PAGES]:
    "We are retrieving the listing of Facebook pages.",
  [RETRIEVING_INSTAGRAM_ACCOUNTS]:
    "We are retrieving the listing of Instagram accounts",
  [ENDING_CONNECTION]: "Ending connection",
  [ESTABLISHING_CONNECTION_WITH_PLATFORM]:
    "Establishing connection with {{platform}}",
  [RETRIEVING_AUTHORIZATION_DATA]: "Retrieving authorization data",
  [OPENING_AUTHORIZATION_WINDOW]: "Opening authorization window",
  [CONNECTING_CANVA_VERIFYING_AUTHORIZATION]:
    "Verifying authorization with Canva",
  [CONNECTING_CANVA_LINKING_ACCOUNT]: "Linking your Canva account",
  [VERIFYING_YOUR_SESSION]: "Verifying your session, please wait",
  [GETTING_REQUIRED_INFORMATION]: "Getting required information",
  [VERIFYING_PLATFORMS_INFORMATION]: "Verifying platform information.",
  [CREATING_CAMPAIGN]: "Creating campaign",
  [CREATING_AD_GROUPS]: "Creating ad groups",
  [UPLOADING_CONTENTS]: "Uploading content",
  [CREATING_ADS]: "Creating ads",
  [SAVING_INFORMATION]: "Saving information",
  [INACTIVE]: "Inactive",
  [CUSTOM_EVENT]: "Custom Event",
  [FAST]: "Fast",
  [EASY]: "Easy",
  [AUTOMATED]: "Automated",
  [FULL_CONTROL]: "Full control",
  [CUSTOMIZE]: "Customize",
  [TAILORED]: "Tailored",
  [RETARGETING_EMPTY_SEGMENTATION_CLARIFICATION]:
    "With custom audiences enabled, manual segmentation isn't necessary",
  [CAMPAIGN_CREATED]: "Campaign created",
  [CAMPAIGN_UPDATED]: "Campaign updated",
  [CREATIFY_VIDEO_PREVIEW_CLARIFICATION]:
    "This is a preview of the video. It may contain synchronization errors that will be corrected in the final version.",
  [CREATIFY_VIDEO_ERROR_RENDER_CLARIFICATION]:
    "The video could not be rendered due to an error. Please contact us via support chat to fix this issue and continue with the campaign.",
  [CREATIFY_VIDEO_RENDERING_CLARIFICATION_AND_CREATE_CAMPAIGN]:
    "We're rendering the final content. Once it's ready, we'll publish your campaign",
  [CREATIFY_VIDEO_RENDERING_CLARIFICATION]:
    "We're rendering the final content. Once it's ready, it will automatically download",
  [COPY]: "Copy",
  [GENERATING_VIDEO_MESSAGE]: "Generating video",
  [TASK_ALERT_ESTIMATED_TIME]: "Estimated time: {{estimatedTime}}",
  [DO_YOU_HAVE_DISCOUNT_CODE]: "Do you have a discount code?",
  [DISCOUNT_VALUE]: "Discount value",
  [NORMAL_PRICE]: "Normal price",
  [CONTENT_NUMERATION]: "Content {{value}}",
  [WE_CANT_GET_AVATARS]: "We can't get avatars, please try again later",
  [CONTENT_GENERATOR]: "Content Generator",
  [SELECT_BACKGROUND_CONTENT]: "Background Content",
  [SELECT_BACKGROUND_CONTENT_CLARIFICATION]:
    "You must select at least 3 contents",
  [CUSTOM]: "Custom",
  [GETTING_CREATIFY_VIDEO_DATA]: "Getting data from the video",
  [CREDITS]: "Credits",
  [COINS]: "Coins",
  [CREDITS_VALUE]: "{{value,number}} Credits",
  [COST_OF_ACTION]: "Cost of Action",
  [COST_OF_CAMPAIGN]: "Campaign Cost",
  [COST_OF_RESIZE]: "Resize Cost",
  [CURRENT]: "Current",
  [CURRENT_BALANCE]: "Current Balance",
  [BALANCE_AFTER]: "Balance After Action",
  [COINS_VALUE]: "{{value,number}} Coins",
  [PER_MONTH]: "Per month",
  [ACTION_CONFIRM_TEXT]:
    "You will spend {{cost,number}} {{type}} performing this action",
  [CURRENT_USAGE_TYPE]: "Current {{type}}",
  [YOUR_TRIAL_CREDITS_END]: "Your trial credits will expire on {{date,short}}",
  [YOUR_TRIAL_COINS_END]: "Your trial coins will expire on {{date,short}}",
  [YOUR_TRIAL_END]: "Your trial period has ended",
  [CREATE_DEACTIVATED]: "Create deactivated",
  [CREATE_ACTIVATED]: "Create activated",
  [EMPTY_TRACKING_IDS_GOOGLE]: "You have no Google tags created",
  [REST_CAMPAIGNS]: "You have {{value,number}} campaigns left to create",
  [REST_CREATIVES]: "You have {{value,number}} creatives left to generate",
  [REST_CREATIVE_SINGULAR]:
    "You have {{value,number}} creative left to generate",
  [REST_VIDEO_SINGULAR]: "You have {{value,number}} video left to generate",
  [REST_CREDITS]: "You have {{value,number}} credits remaining",
  [CREATIVES_REMAINING_SHORT]: "You have {{value,number}} creatives left",
  [REST_VIDEOS]: "You have {{value,number}} videos left to generate",
  [VIDEOS_REMAINING_SHORT]: "You have {{value,number}} videos left",
  [CREATIVES_REMAINING_SHORT_SINGULAR]:
    "You have {{value,number}} creative left",
  [SUGGESTED_CREATIVES_COUNT]:
    "Number of Suggested Creatives: {{count,number}}",
  [SUGGESTED_CREATIVES_PROGRESS]:
    "{{current,number}}/{{total,number}} suggested",
  [VIDEOS_REMAINING_SHORT_SINGULAR]: "You have {{value,number}} video left",
  [CREDITS_EXPLANATION]: `With your plan you can generate advertising campaigns, which include:<br/>
  • Multi-platform management.<br/>
  • AI audience segmentation.<br/>
  • AI locations selector.<br/>
  • AI texts and copies.<br/>
  • AI advanced insights and reports.`,
  [COINS_EXPLANATION]: `Coins are mainly used to generate audiovisual content, for example:<br/>
  • Rendering or downloading an AI-generated video.`,
  [META_DESTINATION_TYPE_INSTAGRAM_PROFILE_CLARIFICATION]:
    "Users will be taken to the previously selected Instagram profile",
  [ADVERTISER]: "Administrator",
  [MARKETER]: "Media Buyer",
  [VIEWER]: "Viewer",
  [DESIGNER]: "Designer",
  [DELETED]: "Deleted",
  [PASSWORD_CLARIFICATION_IN_EDIT_USER]:
    "Leave blank if you don't want to change it",
  [CREATED_AT]: "Created at",
  [CREATED_BY]: "Created by",
  [MONTHLY]: "Monthly",
  [QUARTERLY]: "Quarterly",
  [SEMIYEARLY]: "Semiyearly",
  [YEARLY]: "Yearly",
  [CPA_CLARIFICATION]:
    "The CPA (Cost per Action) is the cost you have paid for each action a user performs based on your campaign objective. Below are the actions you are paying for in this campaign.",
  [MAIN_STATISTIC_CPM_CLARIFICATION]:
    "(CPM) You pay per 1,000 impressions of your ad, to increase awareness of your brand.",
  [MAIN_STATISTIC_CLICK_CLARIFICATION]:
    "(Click) You pay for every click your ad receives, to increase traffic to your website.",
  [MAIN_STATISTIC_POST_ENGAGEMENT_CLARIFICATION]:
    "(Post interaction) You pay for each interaction your post receives (likes, comments, shares, saves, saves, etc.), to increase the interaction of your content.",
  [MAIN_STATISTIC_LEAD_CLARIFICATION]:
    "(Lead) You pay for each lead that registers on your website.",
  [MAIN_STATISTIC_PURCHASE_CLARIFICATION]:
    "(Purchase) You pay for each purchase that is made on your website.",
  [MAIN_STATISTIC_AD_RECALL_CLARIFICATION]:
    "(Ad recall) You pay for each person who remembers seeing your ad, to increase awareness of your brand.",
  [MAIN_STATISTIC_VIDEO_VIEW_CLARIFICATION]:
    "(Video View) You pay for every playback of at least 6 seconds on your video ad.",
  [MAIN_STATISTICS_INSTAGRAM_PROFILE_CLARIFICATION]:
    "(Instagram profile visit) You pay for each visit to the previously selected Instagram profile.",
  [MAIN_STATISTIC_VALUE_CPM_CLARIFICATION]:
    "{{value,number}} impressions. You pay for every 1,000 impressions of your ad, to increase awareness of your brand.",
  [MAIN_STATISTIC_VALUE_CLICK_CLARIFICATION]:
    "{{value,number}} clicks. You pay for each click your ad receives, to increase traffic to your website.",
  [MAIN_STATISTIC_VALUE_POST_ENGAGEMENT_CLARIFICATION]:
    "{{value,number}} interactions. You pay for each interaction your post receives (likes, comments, shares, saves, saves, etc.), to increase the interaction of your content.",
  [MAIN_STATISTIC_VALUE_LEAD_CLARIFICATION]:
    "{{value,number}} leads. You pay for each lead that registers on your website.",
  [MAIN_STATISTIC_VALUE_PURCHASE_CLARIFICATION]:
    "{{value,number}} purchases. You pay for each purchase that is made on your website.",
  [MAIN_STATISTIC_VALUE_AD_RECALL_CLARIFICATION]:
    "{{value,number}} ad memories. You pay for each person who remembers seeing your ad, to increase awareness of your brand.",
  [MAIN_STATISTIC_VALUE_VIDEO_VIEW_CLARIFICATION]:
    "{{value,number}} video views. You pay for each playback of at least 6 seconds in your video ad.",
  [MAIN_STATISTIC_VALUE_INSTAGRAM_PROFILE_CLARIFICATION]:
    "{{value,number}} Instagram profile views. You pay for each visit to the previously selected Instagram profile.",
  [ANALYZING_CAMPAIGN_STATISTICS]: "Analyzing campaign statistics",
  [COMPARING_RESULTS_OBTAINED]: "Comparing results obtained",
  [GENERATING_OPTIMIZATIONS]: "Generating optimizations",
  [CAMPAIGN_OPTIMIZED_NAME]: "Optimized",
  [CAMPAIGN_OPTIMIZED]: "Campaign optimized",
  [CAMPAIGN_OPTIMIZED_GENERATED]: "Optimized campaign generated",
  [APPLYING_OPTIMIZATIONS]: "Applying optimizations",
  [IMPRESSIONS_BY_PLATFORM]: "Impressions by platform",
  [CLICKS_BY_PLATFORM]: "Clicks by platform",
  [MAIN_ACTIONS_BY_PLATFORM]: "Results by platform",
  [CONCLUSION]: "Conclusion",
  [RECOMMENDATIONS]: "Recommendations",
  [DAY_COUNT]: "Day {{value,number}}",
  [ADS_CAMPAIGN_REPORT_BREAKDOWN_DAILY]: "Daily",
  [WEEK_COUNT]: "Week {{value,number}}",
  [EMPTY_STATISTICS_FOR_DETAILED_REPORT]:
    "There is not enough data and statistics to generate a report",
  [LOCATIONS_TIK_TOK_EMPTY]:
    "No relevant locations were found, they may not be available on TikTok or specifically for the country of your account. More information <a href='https://ads.tiktok.com/help/article/placements-available-locations?aadvid=7375164243290914833' target='_blank' style='text-decoration: underline'>here</a>.",
  [PRODUCT_OR_SERVICE_CONTEXT]: "Product or service to be promoted",
  [TARGET_AUDIENCE_CONTEXT]: "Target audience you want to reach",
  [GREETING]: "Greeting",
  [FIRST_USER_MESSAGE]: "First User Message",
  [IS_CAROUSEL]: "Is Carousel",
  [CARD]: "Card",
  [FORM]: "Form",
  [FORMS]: "Forms",
  [ANSWER]: "Answer",
  [ANSWERS]: "Answers",
  [GOOGLE_PHRASE_KEYWORD]: "Phrase match",
  [GOOGLE_PHRASE_KEYWORD_EXPLANATION]:
    "It will display ads when a user's query includes at least the meaning of your keyword. The format of this type is the keyword in quotation marks (“keyword”).",
  [GOOGLE_EXACT_KEYWORD]: "Exact match",
  [GOOGLE_EXACT_KEYWORD_EXPLANATION]:
    "Will display ads when a user's search includes the exact keyword or a close variant that includes the meaning or intent. The format of this type is the keyword in square brackets ([keyword]).",
  [GOOGLE_BROAD_KEYWORD]: "Broad match",
  [GOOGLE_BROAD_KEYWORD_EXPLANATION]:
    "Will display ads when a user's search includes synonyms, variants and intents similar to the keyword. The format of this type is the keyword without anything else (keyword).",
  [GOOGLE_KEYWORDS_EXPLANATION]: `Keywords are terms or phrases that are used to display ads to people searching for something online. There are three types of keywords: <br/><br/>
    <strong>Exact match:</strong> Will display ads when a user's search includes the exact keyword or a close variant that includes the meaning or intent. The format of this type is the keyword in square brackets ([keyword]).<br/><br/>
    <strong>Phrase match:</strong> It will display ads when a user's query includes at least the meaning of your keyword. The format of this type is the keyword in quotation marks (“keyword”).<br/><br/>
    <strong>Broad match:</strong> Will display ads when a user's search includes synonyms, variants and intents similar to the keyword. The format of this type is the keyword without anything else (keyword).`,
  [GOOGLE_KEYWORDS_NEGATIVE_EXPLANATION]: `Negative keywords are terms or phrases used in digital advertising to prevent ads from being displayed on irrelevant searches. Adding negative keywords prevents ads from appearing when users search for those specific terms, helping to improve ad relevance, reduce costs and increase conversion rates. There are three types of keywords:<br/><br/>
  <strong>Exact match:</strong> Will display ads when a user's search includes the exact keyword or a close variant that includes the meaning or intent. The format of this type is the keyword in square brackets ([keyword]).<br/><br/>
  <strong>Phrase match:</strong> It will display ads when a user's query includes at least the meaning of your keyword. The format of this type is the keyword in quotation marks (“keyword”).<br/><br/>
  <strong>Broad match:</strong> Will display ads when a user's search includes synonyms, variants and intents similar to the keyword. The format of this type is the keyword without anything else (keyword).  `,
  [GOOGLE_SEARCH_AD_GROUP_TYPE_LABEL]: "Ad Group Type",
  [GOOGLE_SEARCH_AD_GROUP_TYPE_STANDARD]: "Standard",
  [GOOGLE_SEARCH_AD_GROUP_TYPE_DSA]: "Dynamic Search Ads",
  [GOOGLE_WEBPAGE_CRITERIA_TITLE]: "Webpage Criteria",
  [GOOGLE_WEBPAGE_CRITERIA_EXPLANATION]:
    "Define which pages of your indexed site can serve ads for this ad group (for example URL equals or URL contains). Add at least one criterion.",
  [GOOGLE_WEBPAGE_CRITERION_OPERATOR_LABEL]: "Rule",
  [GOOGLE_WEBPAGE_CRITERION_VALUE_LABEL]: "URL or text",
  [GOOGLE_WEBPAGE_CRITERION_URL_EQUALS]: "URL equals",
  [GOOGLE_WEBPAGE_CRITERION_URL_CONTAINS]: "URL contains",
  [FIELD_WEBPAGE_CRITERIA_REQUIRED]:
    "Add at least one webpage criterion for Dynamic Search ad groups.",
  [FIELD_WEBPAGE_CRITERIA_REPEATED]: "Duplicate webpage criteria: {{value}}",
  [GOOGLE_SEARCH_AD_GROUP_DSA_NO_KEYWORDS_STATS]:
    "Dynamic Search ad groups use webpage criteria instead of positive keywords.",
  [GOOGLE_DSA_SETTINGS_TITLE]: "Dynamic Search Ads Settings",
  [GOOGLE_DSA_SETTINGS_EXPLANATION]:
    "Required when any ad group uses Dynamic Search Ads. Google uses this domain to automatically generate ads.",
  [GOOGLE_DSA_DOMAIN_LABEL]: "Domain",
  [GOOGLE_DSA_LANGUAGE_LABEL]: "Language",
  [GOOGLE_WEBPAGES_NOT_ADDED]: "No webpage criteria added",
  [GOOGLE_WEBPAGE_ADD_TITLE]: "Add URL",
  [GOOGLE_WEBPAGE_EDIT_TITLE]: "Edit URL",
  [GOOGLE_WEBPAGE_URL_LABEL]: "URL",
  [COLUMN_NAME_URL]: "URL",
  [ALERT_DELETE_WEBPAGE_TITLE]: "Delete webpage?",
  [ALERT_DELETE_WEBPAGE_DESCRIPTION]:
    "Are you sure you want to delete this webpage criterion?",
  [ALERT_DELETE_WEBPAGES_TITLE]: "Delete webpages?",
  [ALERT_DELETE_WEBPAGES_DESCRIPTION]:
    "Are you sure you want to delete {{value}} webpage criteria?",
  [GOOGLE_NETWORK_SETTING_GOOGLE_SEARCH]: "Google Search",
  [GOOGLE_NETWORK_SETTING_SEARCH_NETWORK]: "Google Search Network",
  [GOOGLE_NETWORK_SETTING_CONTENT_NETWORK]: "Google Display Network",
  [GOOGLE_NETWORK_SETTING_PARTNER_SEARCH_NETWORK]:
    "Google Partner Search Network",
  [TOP_KEYWORDS]: "Top Keywords",
  [BETA]: "Beta",
  [PROCESSING_MEDIA_TO_USE]: "Processing the content for use",
  [SAVING_MEDIA]: "Saving the content",
  [TUTORIAL]: "Tutorial",
  [SELECT_RANGE_DATE]: "Select date range",
  [TO]: "to",
  [MONTH_COUNT]: "Month {{value,number}}",
  [WRITE_INSTRUCTIONS_TO_CREATE_YOUR_CAMPAIGN]:
    "Describe how you want to focus the campaign. Example: This campaign is designed to position product X as a practical solution for teams looking to save time and reduce manual work.",
  [TITLE_CAMPAIGN_INSTRUCTIONS]: "Campaign Theme or Instructions",
  [DOCUMENTS_ATTACHMENT_LABEL]: "Add Files",
  [FILE_UPLOADED]: "UPLOADED",
  [ADD_PLATFORMS]: "Add Platforms",
  [ERROR_GENERATING_CAMPAIGN]:
    "An error occurred while generating the campaign",
  [THIS_ITEM_HAS_ERRORS]: "This section has errors",
  [INDIVIDUAL]: "Individual",
  [CAROUSEL]: "Carousel",
  [RADIUS]: "Radius",
  [AROUND]: "Around",
  [ADVANTAGE_ENHANCES_ACTIVE_COUNT]: "{{active}}/{{total}} Active enhances",
  [WE_ARE_SYNCHRONIZING_INFORMATION_WITH_PLATFORMS]: "Syncing Data",
  [OPTIONAL]: "Optional",
  [KEYWORDS_NOT_ADDED]: "No keywords added",
  [KEYWORDS_NEGATIVE_NOT_ADDED]: "No negative keywords added",
  [ENTER_ONE_KEYWORD_PER_LINE]: "Enter one keyword per line",
  [KEYWORDS]: "Keywords",
  [KEYWORDS_NEGATIVE]: "Negative keywords",
  [TOTAL_IMPRESSIONS]: "Total Impressions",
  [TOTAL_CLICKS]: "Total Clicks",
  [TOTAL_CLICK]: "Total click",
  [TOTAL_RESULTS]: "Total Results",
  [TOTAL_SPEND]: "Total Spend",
  [AVERAGE_CTR]: "Average CTR",
  [TOTAL_ROAS_GOOGLE]: "Google ROAS",
  [TOTAL_ROAS_TIK_TOK]: "TikTok ROAS",
  [TOTAL_ROAS_META]: "Meta ROAS",
  [CUSTOM_AUDIENCES]: "Custom audiences",
  [CREATIVE]: "Creative",
  [SELECTED]: "Selected",
  [ROAS]: "ROAS",
  [FORECAST]: "Forecast",
  [ACTION]: "Action",
  [DELETE]: "Delete",
  [INSIGHTS]: "Insights",
  [INSIGHT]: "Insight",
  [CHANGE_CONTENT_FOR_OPTIMIZATION_AD_INSIGHT]:
    "Here you can change the creative to apply the insight",
  [PRESS_ENTER_TO_ADD_OPTION]: "Press enter to add",
  [GOOGLE_SEARCH]: "Google Search",
  [GOOGLE_P_MAX]: "Google PMax",
  [GOOGLE_APP]: "Google App Install",
  [YOUTUBE_VIDEO_LINK]: "YouTube Video URL",
  [DO_NOT_UPLOAD_VIDEO_ON_YOUTUBE_HELPER_TEXT]:
    "Don't have the video uploaded on YouTube? Upload it now",
  [YOUTUBE_VIDEO_SOURCE_YOUTUBE]: "YouTube",
  [YOUTUBE_VIDEO_SOURCE_GALLERY]: "Gallery",
  [YOUTUBE_VIDEO_SOURCE_URL]: "URL",
  [MODAL_GALLERY_YOUTUBE_TITLE]: "Select Video from YouTube",
  [MODAL_GALLERY_YOUTUBE_EMPTY]: "No public videos found on this channel",
  [BUTTON_SELECT_FROM_YOUTUBE]: "Select from YouTube",
  [BUTTON_PUBLISH_VIDEO_ON_YOUTUBE]: "Publish Video on YouTube",
  [MODAL_UPLOAD_YOUTUBE_VIDEO_TITLE]: "Upload Video to YouTube",
  [MODAL_UPLOAD_YOUTUBE_VIDEO_DURATION_INVALID]:
    "The video must be between {{min}} and {{max}} seconds long. Please select another video.",
  [REQUIRED_IMAGES_GOOGLE_ASSETS_GROUP_HELPER_TEXT]: `At least one square image (Recommended size 1200px x 1200px)<br/>
At least one horizontal image (Recommended size 1200px x 628px)`,
  [REQUIRED_IMAGES_GOOGLE_SQUARE_IMAGE]:
    "<b>At least one square image</b> (Recommended size 1200px x 1200px)",
  [REQUIRED_IMAGES_GOOGLE_HORIZONTAL_IMAGE]:
    "<b>At least one horizontal image</b> (Recommended size 1200px x 628px)",
  [REQUIRED_VIDEOS_GOOGLE_ASSETS_GROUP_HELPER_TEXT]: `The video must be between 10 and 60 seconds long.`,
  [CAMPAIGNS_NOT_FOUND]: "No campaigns found",
  [CAMPAIGNS_TABLE_EXPAND_ROW]: "Expand ad groups",
  [CAMPAIGNS_TABLE_COLLAPSE_ROW]: "Collapse ad groups",
  [CAMPAIGNS_TABLE_EXPAND_GROUP]: "Expand ads",
  [CAMPAIGNS_TABLE_COLLAPSE_GROUP]: "Collapse ads",
  [CAMPAIGNS_TABLE_TREE_EMPTY]: "This campaign has no ad groups or ads",
  [CAMPAIGNS_TABLE_TREE_ERROR]: "Ad groups could not be loaded",
  [CAMPAIGNS_TABLE_TREE_METRICS_ERROR]:
    "Ad group and ad metrics could not be loaded",
  [CAMPAIGNS_TABLE_TREE_ADS_EMPTY]: "This group has no ads",
  [CAMPAIGNS_TABLE_SHOW_MORE_ADS]: "Show {{count}} more",
  [CAMPAIGN_SELECTED]: "Selected campaign",
  [ALREADY_IMPORTED]: "Already exists",
  [CREATE_A_CAMPAIGN]: "Create a Campaign",
  [CREATE_A_CAMPAIGN_FOR_BRAND_NAME]: "Create a Campaign for {{value}}",
  [COPY_VALUE_IN_OTHER_ADS]: "Copy value in other ads",
  [COPY_VALUES_IN_OTHER_ADS]: "Copy values in other ads",
  [COPY_VALUE_IN_OTHER_ADGROUPS]: "Copy value to other ad groups",
  [COPY_VALUES_IN_OTHER_ADGROUPS]: "Copy values to other ad groups",
  [GETTING_METRICS]: "Getting metrics",
  [GENERATING_REPORT]: "Generating report",
  [EXPORT_COPIES_TO_GOOGLE_DRIVE]: "Export copies to Google Drive",
  [COPIES_OF_AD]: "Ad copies",
  [ALL_COPIES_OF_PLATFORM]: "All {{platform}} copies",
  [CONFIGURED_SITE_LINKS]: "{{value,number}} site links configured",
  [FIRST_USER_MESSAGE_BRAND_SETUP]:
    "You have configured your brand correctly, now you can create content for your brand and launch advertising campaigns",
  [DATA_TYPE_CONTACT_INFORMATION_OPTION]:
    "Emails, Phones, and/or Mailing Addresses",
  [DATA_TYPE_CRM_ID_OPTION]: "User IDs",
  [ALL_CUSTOMERS]: "All customers",
  [PURCHASERS]: "Purchasers",
  [HIGH_VALUE_CUSTOMERS]: "High value customers",
  [DISENGAGED_CUSTOMERS]: "Disengaged customers",
  [QUALIFIED_LEADS]: "Qualified leads",
  [CONVERTED_LEADS]: "Converted leads",
  [PAID_SUBSCRIBERS]: "Paid subscribers",
  [LOYALTY_SIGN_UPS]: "Loyalty signups",
  [CART_ABANDONERS]: "Cart abandoners",
  [NO_HEADERS_TABLE_VALID_NOT_MODIFY_HEADERS_GOOGLE_CUSTOM_AUDIENCE]:
    "No valid headers found in the uploaded file, please do not modify the headers of the template",
  [WITH_OUT_PLAN]: "Without plan",
  [CONFIRMATION_USAGE_TEXT]: "Are you sure you want to perform this action?",
  [SQUARE_FORMAT]: "Square format",
  [VERTICAL_FORMAT]: "Vertical format",
  [HORIZONTAL_FORMAT]: "Horizontal format",
  [RESIZE_TO_SQUARE]: "Resize to Square",
  [RESIZE_TO_VERTICAL]: "Resize to Vertical",
  [RESIZE_TO_HORIZONTAL]: "Resize to Horizontal",
  [RESIZE_TO_FEED]: "Resize to 4:5 (Instagram)",
  [RESIZE_CUSTOM]: "Resize Custom",
  [MODAL_RESIZE_CUSTOM_TITLE]: "Resize Image",
  [MODAL_RESIZE_CUSTOM_DESCRIPTION]:
    "Enter the width and height in pixels to resize the image.",
  [MODAL_RESIZE_CUSTOM_DEFAULT_SIZE_LABEL]: "Preset size",
  [ERROR_RESIZE_DIMENSION_INVALID]: "Enter a valid value greater than 0",
  [ERROR_RESIZE_DIMENSION_MAX_EDGE]: "Maximum {{max, number}} px per side",
  [ERROR_RESIZE_DIMENSION_NOT_MULTIPLE_PREFIX]:
    "Must be a multiple of 16. Suggested:",
  [ERROR_RESIZE_DIMENSION_OR]: "or",
  [ERROR_RESIZE_TOTAL_TOO_SMALL]:
    "{{total, number}} px² — too small. Minimum {{min, number}} px² total.",
  [ERROR_RESIZE_TOTAL_TOO_LARGE]:
    "{{total, number}} px² — too large. Maximum {{max, number}} px² total.",
  [ERROR_RESIZE_ASPECT_RATIO_EXCEEDED_PREFIX]:
    "Aspect ratio must be 3:1 or lower.",
  [ERROR_RESIZE_ASPECT_RATIO_CHOOSE_OPTION]:
    "Choose one of the following options:",
  [ERROR_RESIZE_ASPECT_RATIO_ADJUST_WIDTH_PREFIX]: "Adjust width to",
  [ERROR_RESIZE_ASPECT_RATIO_KEEP_HEIGHT_SUFFIX]: "(keep height)",
  [ERROR_RESIZE_ASPECT_RATIO_ADJUST_HEIGHT_PREFIX]: "Adjust height to",
  [ERROR_RESIZE_ASPECT_RATIO_KEEP_WIDTH_SUFFIX]: "(keep width)",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_INVALID]:
    "Width and height must be positive numbers.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_WIDTH_NOT_MULTIPLE_OF_16]:
    "Width must be a multiple of 16.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_HEIGHT_NOT_MULTIPLE_OF_16]:
    "Height must be a multiple of 16.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_MAX_EDGE_EXCEEDED]:
    "Custom size exceeds the maximum of {{max, number}} px per side.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_ASPECT_RATIO_EXCEEDED]:
    "Custom size aspect ratio must be 3:1 or lower.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_FEW_PIXELS]:
    "Custom size is too small. Minimum {{min, number}} px² total.",
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_MANY_PIXELS]:
    "Custom size is too large. Maximum {{max, number}} px² total.",
  [BUTTON_RESIZE_IMAGE]: "Resize",
  [RESIZE_MENU_LABEL]: "Resize",
  [RESIZING_IMAGES_BATCH_MESSAGE]: "Resizing images",
  [MULTI_FORMAT_RESIZE_FORMATS_COUNT]: "{{count}} formats",
  [MULTI_FORMAT_RESIZE_CREDITS_COUNT]: "{{count}} credits",
  [MULTI_FORMAT_RESIZE_ONE_FORMAT]: "1 format",
  [MULTI_FORMAT_RESIZE_ONE_CREDIT]: "1 credit",
  [MODAL_BATCH_IMAGE_EDIT_TITLE]: "Edit your Images",
  [MODAL_BATCH_IMAGE_EDIT_VERSION_LABEL]: "Version {{version, number}}",
  [MODAL_BATCH_IMAGE_EDIT_PROMPT_PLACEHOLDER]:
    "Write the instruction for all...",
  [MODAL_BATCH_IMAGE_EDIT_GENERATE]: "Generate",
  [MODAL_BATCH_IMAGE_EDIT_APPLY]: "Apply",
  [MODAL_BATCH_IMAGE_EDIT_STATUS_PENDING]: "Pending",
  [MODAL_BATCH_IMAGE_EDIT_STATUS_SUCCESS]: "Done",
  [MODAL_BATCH_IMAGE_EDIT_STATUS_ERROR]: "Error",
  [MODAL_BATCH_IMAGE_EDIT_RETRY]: "Retry",
  [MODAL_BATCH_IMAGE_EDIT_FAILED_BADGE]: "Failed",
  [MODAL_BATCH_IMAGE_EDIT_EXPAND]: "Expand",
  [MODAL_BATCH_IMAGE_EDIT_BACK_TO_GRID]: "Back to grid",
  [MODAL_BATCH_IMAGE_EDIT_FOOTER_ACTION]: "Edit with AI",
  [MODAL_BATCH_IMAGE_EDIT_IMAGE_ALT]: "Batch edit creative",
  [MODAL_BATCH_IMAGE_EDIT_SAVE_ALERT_TITLE]:
    "How do you want to save these images?",
  [MODAL_BATCH_IMAGE_EDIT_SAVE_ALERT_DESCRIPTION]:
    "You can replace the original images or create new versions with your changes.",
  [MODAL_BATCH_IMAGE_EDIT_SAVE_AS_NEW_BUTTON]: "Save as New",
  [MODAL_BATCH_IMAGE_EDIT_REPLACE_BUTTON]: "Replace",
  [EDIT_WITH_CANVA]: "Edit with Canva",
  [EDIT_WITH_IA]: "Edit",
  [ANIMATE_IMAGE_WITH_AI]: "Animate Image with AI",
  [ANIMATE]: "Animate",
  [ANIMATE_IMAGE_CONFIRMATION_TITLE]: "Information",
  [ANIMATE_IMAGE_CONFIRMATION_DESCRIPTION]:
    "15 credits will be spent to perform this action. Do you want to continue?",
  [MODAL_ANIMATE_IMAGE_PREVIEW_TITLE]: "Animate Image with AI",
  [MODAL_ANIMATE_IMAGE_PROMPT_LABEL]: "Animation instructions (optional)",
  [MODAL_ANIMATE_IMAGE_PROMPT_PLACEHOLDER]:
    "e.g. gently move the products, add a soft ripple to the background colors...",
  [MODAL_ANIMATE_IMAGE_PROMPT_HELPER]:
    "Leave empty for a natural default animation.",
  [MODAL_ANIMATE_IMAGE_PROMPT_MAX_LENGTH]:
    "Maximum {{max}} characters ({{current}}/{{max}})",
  [ANIMATE_IMAGE_OUTRO_LABEL]: "Outro video (optional)",
  [ANIMATE_IMAGE_OUTRO_HELPER]:
    "It is added at the end of each generated video.",
  [ANIMATE_IMAGE_OUTRO_NONE]: "No outro video.",
  [ANIMATE_IMAGE_SAVE_OUTRO]: "Save outro video",
  [ANIMATE_IMAGE_SAVE_OUTRO_TITLE]: "Save outro video",
  [ANIMATE_IMAGE_SAVE_OUTRO_SUCCESS]: "Outro video saved",
  [ANIMATE_IMAGE_SAVE_OUTRO_ERROR]: "Could not save the outro video.",
  [ANIMATE_IMAGE_OUTRO_FILE]: "Select video",
  [ANIMATE_IMAGE_OUTRO_FILE_HINT]:
    "MP4, MOV, or WEBM. Up to {{seconds}} seconds and {{size}} MB.",
  [ANIMATE_IMAGE_IMPORT_OUTRO]: "Outro videos",
  [ANIMATE_IMAGE_IMPORT_OUTRO_TITLE]: "Outro videos",
  [ANIMATE_IMAGE_IMPORT_OUTRO_EMPTY]: "No saved outro videos.",
  [ANIMATE_IMAGE_IMPORT_OUTRO_ERROR]: "Could not load outro videos.",
  [ANIMATE_IMAGE_DELETE_OUTRO]: "Delete outro video",
  [ANIMATE_IMAGE_DELETE_OUTRO_ERROR]: "Could not delete the outro video.",
  [ANIMATE_IMAGE_OUTRO_CLEAR]: "Remove outro",
  [ANIMATE_IMAGE_OUTRO_TOO_LARGE]: "The video exceeds the {{size}} MB limit.",
  [ANIMATE_IMAGE_OUTRO_TOO_LONG]:
    "The video is longer than {{seconds}} seconds.",
  [ANIMATE_IMAGE_OUTRO_INVALID_TYPE]:
    "The file must be an MP4, MOV, or WEBM video.",
  [ANIMATE_IMAGE_USE_SELECTED]: "Use",
  [SELECT_CONTENT_CONFIRMATION_TEXT]: "Do you want to select this content?",
  [FORMAT_OPTIONS_TOOLTIP]: "Format options",
  [CHANGES]: "Changes",
  [EMPTY_CHANGES]: "No changes to show",
  [AD_GROUPS]: "Ad groups",
  [ADS]: "Ads",
  [ASSETS_GROUPS]: "Assets groups",
  [ADDED]: "Added",
  [REMOVED]: "Removed",
  [IT_WAS_CREATED]: "It was created",
  [HISTORICAL_CHANGES]: "Historical changes",
  [LOG_GROUP_AUDIENCE_NETWORK]: "Audience Network",
  [LOG_GROUP_FEEDS]: "Feeds",
  [LOG_GROUP_REELS_STORIES]: "Reels/Stories",
  [STATUS_DEACTIVATED]: "Deactivated",
  [STATUS_ACTIVE]: "Active",
  [STATUS_FINISHED]: "Finished",
  [N_NUMBER_SELECTED]: "{{value,number}} Selected",
  [FILTER_BY_STATUS]: "Filter by status",
  [SELECT_CATALOG_IN_CAMPAIGN_LEVEL]:
    "First select a catalog in the configuration",
  [INTRO_CARD]: "Intro card",
  [CATALOG_CARD]: "Catalog card",
  [PROFILE_CARD]: "Profile card",
  [SINGLE_IMAGE]: "Single Image",
  [SLIDES_SHOW]: "Slides show",
  [MODIFY_CATALOG_LABELS]: "Modify catalog labels",
  [MODIFY_PRODUCT_TAGS]: "Modify product tags",
  [SOLID]: "Solid",
  [TRANSPARENT]: "Transparent",
  [AUTOMATIC_LABELS]: "Automatic labels",
  [MANUAL_LABEL]: "Manual label",
  [RECTANGLE]: "Rectangle",
  [PILL]: "Pill",
  [CIRCLE]: "Circle",
  [TRIANGLE]: "Triangle",
  [TOP_LEFT]: "Top left",
  [TOP_RIGHT]: "Top right",
  [BOTTOM_LEFT]: "Bottom left",
  [BOTTOM_RIGHT]: "Bottom right",
  [AUTOMATICALLY_TAG_PRODUCTS]: "Show product tags",
  [INSTANT_EXPERIENCE]: "Instant experience",
  [FILTER_BY_NAME]: "Filter by name",
  [ALL_PRODUCTS]: "All products",
  [USE_A_SELECTION_OF_PRODUCTS]: "Use a selection of products",
  [SELECT_PRODUCTS_BY]: "Select products by",
  [CONDITION]: "Condition",
  [PRODUCT_TYPE]: "Product type",
  [CHANNEL]: "Channel",
  [CUSTOM_LABEL]: "Custom label",
  [CONDITION_NEW]: "New",
  [CONDITION_USED]: "Used",
  [CONDITION_REFURBISHED]: "Refurbished",
  [CHANNEL_ONLINE]: "Online",
  [CHANNEL_LOCAL]: "Local",
  [ITEM_ID]: "Item ID",
  [SELECT_ALL]: "Select all",
  [RECOMMENDED_ACTIONS]: "Recommended actions",
  [DAY_SLASH_TIME]: "Day/Time",
  [DRAG_THE_MOUSE_TO_SELECT_THE_TIME_PERIOD]:
    "Drag the mouse to select the time period",
  [SELECTED_TIME_PERIOD]: "Selected time period",
  [NO_SELECTION]: "No selection",
  [USER_TIMEZONE]: "User's timezone",
  [AD_ACCOUNT_TIMEZONE]: "Ad account timezone",
  [GOOGLE_ORIGIN_APP]: "App",
  [GOOGLE_ORIGIN_CALL_FROM_ADS]: "Call From Ads",
  [GOOGLE_ORIGIN_GOOGLE_HOSTED]: "Google Hosted",
  [GOOGLE_ORIGIN_STORE]: "Store",
  [GOOGLE_ORIGIN_WEBSITE]: "Website",
  [GOOGLE_ORIGIN_YOUTUBE_HOSTED]: "YouTube Hosted",
  [GOOGLE_CATEGORY_ADD_TO_CART]: "Add To Cart",
  [GOOGLE_CATEGORY_BEGIN_CHECKOUT]: "Begin Checkout",
  [GOOGLE_CATEGORY_BOOK_APPOINTMENT]: "Book Appointment",
  [GOOGLE_CATEGORY_CONTACT]: "Contact",
  [GOOGLE_CATEGORY_CONVERTED_LEAD]: "Converted Lead",
  [GOOGLE_CATEGORY_DEFAULT]: "Default",
  [GOOGLE_CATEGORY_DOWNLOAD]: "Download",
  [GOOGLE_CATEGORY_ENGAGEMENT]: "Engagement",
  [GOOGLE_CATEGORY_GET_DIRECTIONS]: "Get Directions",
  [GOOGLE_CATEGORY_IMPORTED_LEAD]: "Imported Lead",
  [GOOGLE_CATEGORY_OUTBOUND_CLICK]: "Outbound Click",
  [GOOGLE_CATEGORY_PAGE_VIEW]: "Page View",
  [GOOGLE_CATEGORY_PHONE_CALL_LEAD]: "Phone Call Lead",
  [GOOGLE_CATEGORY_PURCHASE]: "Purchase",
  [GOOGLE_CATEGORY_QUALIFIED_LEAD]: "Qualified Lead",
  [GOOGLE_CATEGORY_REQUEST_QUOTE]: "Request Quote",
  [GOOGLE_CATEGORY_SIGNUP]: "Signup",
  [GOOGLE_CATEGORY_STORE_SALE]: "Store Sale",
  [GOOGLE_CATEGORY_STORE_VISIT]: "Store Visit",
  [GOOGLE_CATEGORY_SUBMIT_LEAD_FORM]: "Submit Lead Form",
  [GOOGLE_CATEGORY_SUBSCRIBE_PAID]: "Subscribe Paid",
  [TRACKING_WEBSITE_EVENTS]: "Website Events",
  [TRACKING_EVENTS]: "Tracking Events",
  [VALID]: "Valid",
  [INVALID]: "Invalid",
  [NOT_READY]: "Not Ready",
  [INSIGHT_APPLIED]: "Insight Applied",
  [INSIGHT_DISCARDED]: "Insight Discarded",
  [MAXIMIZE_CONVERSIONS]: "Maximize Conversions",
  [MAXIMIZE_CONVERSION_VALUE]: "Maximize Conversion Value",
  [IN_CURRENCY]: "in {{currency}}",
  [TARGET_CPA_EXPLANATION]:
    "Set the average cost you want to pay for each result.",
  [BID_GOAL_EXPLANATION]:
    "Define the maximum amount you are willing to pay for each bid.",
  [OPTIMIZATION_GOAL_CONVERSATIONS]: "You will pay for Conversations.",
  [OPTIMIZATION_GOAL_VISIT_INSTAGRAM_PROFILE]:
    "You will pay for Profile Visits.",
  [OPTIMIZATION_GOAL_LINK_CLICKS]: "You will pay for Clicks.",
  [OPTIMIZATION_GOAL_THRUPLAY]: "You will pay for Complete Views.",
  [OPTIMIZATION_GOAL_LANDING_PAGE_VIEWS]:
    "You will pay for Landing Page Views.",
  [OPTIMIZATION_GOAL_OPTION_REACH]: "Reach",
  [OPTIMIZATION_GOAL_OPTION_THRUPLAY]: "Maximize video play time (ThruPlay)",
  [OPTIMIZATION_GOAL_OPTION_LINK_CLICKS]: "Link Clicks",
  [OPTIMIZATION_GOAL_OPTION_LANDING_PAGE_VIEWS]: "Landing Page Views",
  [OPTIMIZATION_GOAL_PLACEHOLDER]: "Optimize For",
  [OPTIMIZATION_GOAL_POST_ENGAGEMENT]: "You will pay for Engagement.",
  [OPTIMIZATION_GOAL_OFFSITE_CONVERSIONS]: "You will pay for Conversions.",
  [OPTIMIZATION_GOAL_LEAD_GENERATION]: "You will pay for Lead Generation.",
  [OPTIMIZATION_GOAL_APP_INSTALLS]: "You will pay for App Installs.",
  [OPTIMIZATION_GOAL_CPM]: "You will pay for Thousand Impressions.",
  [OPTIMIZATION_GOAL_CLICK_TO_APP]: "You will pay for Click to App.",
  [OPTIMIZATION_GOAL_CONVERSION_IN_APP]: "You will pay for Conversion in App.",
  [SYNCING_INFORMATION_NO_EDIT_CLARIFICATION]:
    "Syncing campaign, wait before making changes",
  [WAIT_FOR_CAMPAIGN_SYNC]: "Wait until the campaign syncs",
  [BRAND_GUIDELINES_ENABLED_CLARIFICATION]:
    "Brand guidelines are enabled for this campaign, so you cannot modify this field directly.",
  [METRICS]: "Metrics",
  [TIMES_EVERY]: "Times Every",
  [FREQUENCY_CAP_EXPLANATION]:
    "As a maximum, we'll aim to stay under {{value}} impressions every {{interval}} days",
  [FREQUENCY_TARGET_EXPLANATION]:
    "To help achieve your target, we'll aim to deliver about {{value}} impressions every {{interval}} days.",
  [TARGET]: "Target",
  [TARGET_FREQUENCY_EXPLANATION]:
    "The average number of times you want people to see your ads",
  [CAP]: "Cap",
  [CAP_FREQUENCY_EXPLANATION]:
    " The maximum number of times you want people to see your ads",
  [FREQUENCY_SPECS_CONTROL_PLACEHOLDER]: "Frequency Control",
  [FREQUENCY_SPECS_CAP_EXPLANATION]:
    "The maximum number of times you want people to see your ads",
  [FREQUENCY_SPECS_CAP_DESCRIPTION]:
    "As a maximum, we'll aim to stay under {{maxFrequency}} impressions every {{intervalDays}} days",
  [RESERVATION_ESTIMATES]: "Reservation Estimates",
  [AUDIENCE_ESTIMATES]: "Audience Estimates",
  [LOADING_LOCATIONS_IN_MAP]: "Loading Locations on Map",
  [EXPORTING_LOCATIONS_TO_FORM]: "Configuring Locations...",
  [SUGGESTED_LOCATIONS_TITLE]: "Suggested Locations",
  [LOADING_SUGGESTED_LOCATIONS]: "Loading Suggested Locations...",
  [SUGGESTED_LOCATIONS_COUNT]: "{{count}} suggested",
  [ADD_ALL_LOCATIONS]: "Add all",
  [ESTIMATED_DAILY_REACH]: "Estimated Daily Reach",
  [AVERAGE_AUDIENCE_SIZE]: "Average Audience Size",
  [NO_ESTIMATION_AVAILABLE]: "No Estimation Available",
  [ALL_USERS]: "All Users",
  [ALL_TIME]: "All Time",
  [APPLY_OPTIMIZATIONS_WITH_NAME]: `Apply the optimization "{{value}}"`,
  [DISCONNECTED_ACCOUNT]: "Disconnected Account",
  [CAMPAIGN_ALREADY_BEING_CREATED]:
    "The campaign is already being created from another device/tab",
  [CAMPAIGN_ALREADY_BEING_UPDATED]:
    "The campaign is already being updated from another device/tab",
  [UNKNOWN_VALUE]: "Unknown Value",
  [VIDEO]: "Video",
  [IMAGE]: "Image",
  [CAMPAIGNS]: "Campaigns",
  [TEXT_IN_IMAGE]: "Text in Image",
  [VIDEO_LANGUAGE]: "Video Language",
  [LOGO_IN_IMAGE]: "Logo in Image",
  [LOGO_IN_VIDEO]: "Logo in Video",
  [LOGO_IN_VIDEO_DESCRIPTION_LEAD]:
    "The logo will appear at the end of the video.",
  [I_DONT_HAVE_A_WEBSITE]: "I don't have a website",
  [SET_UP_BRAND]: "Set Up Brand",
  [OVERLAPS_WITH]: "Overlaps",
  [GENERATION_FAILED]: "Generation Failed",
  [YOUR_CAMPAIGN_HAS_SOME_DISAPPROVALS]: "Your campaign has some disapprovals",
  [ANALYZING_CONTENT]: "Analyzing content to generate recommendations ...",
  [CONTENT_WARNING_TITLE]: "Content Warning",
  [CONTENT_RECOMMENDATIONS_SUBTITLE]:
    "We recommend adding the following content formats for better performance",
  [CONTENT_RECOMMENDATIONS]: "Content Recommendations",
  [CONTENT_RECOMMENDATION_OPEN_CREATE_WITH_IA]:
    "Use this recommendation in Create with AI",
  [NO_CONTENT_RECOMMENDATIONS]: "No Content Recommendations Found",
  [CONTENT_RECOMMENDATIONS_BANNER_TITLE]: "Content Recommendations",
  [CONTENT_RECOMMENDATIONS_BANNER_DESCRIPTION]:
    "We found creative angles that could work for your campaign. Generate them in one click.",
  [CONTENT_RECOMMENDATIONS_VIEW_ALL]: "See all ({{count,number}})",
  [CONTENT_RECOMMENDATIONS_COMPLETED_PROGRESS]:
    "{{completed,number}} of {{total,number}} generated",
  [CONTENT_RECOMMENDATION_GENERATED]: "Generated",
  [CONTENT_RECOMMENDATION_GENERATE_ARIA]: "Generate: {{text}}",
  [CONTENT_RECOMMENDATIONS_ALL_COMPLETED]:
    "All set! You added every recommendation",
  [BAD]: "Bad",
  [REGULAR]: "Regular",
  [GOOD]: "Good",
  [VERY_GOOD]: "Very Good",
  [EXCELLENT]: "Excellent",
  [FIELD]: "Field",
  [ID_PLATFORM]: "{{value}} ID",

  /* PAYMENTS */
  [SELECT_PAYMENT_METHOD]: "Select Payment Method",
  [ADD_PAYMENT_METHOD]: "Add Payment Method",
  [PAYMENT_METHOD]: "Payment Method",
  [PAYMENT_METHODS]: "Payment Methods",
  [PAYMENT_METHODS_EMPTY]: "No payment methods available, add one",
  [MAIN_PAYMENT_METHOD]: "Main Payment Method",
  [OTHERS_PAYMENT_METHODS]: "Other Payment Methods",
  [OTHERS_PAYMENT_METHODS_EMPTY]: "No additional payment methods",
  [PAYMENT_METHODS_SECURE]: "Your payment methods will be secured",
  [PAYMENT_METHODS_SECURE_EXPLANATION]:
    "Your payment information will never be exposed, and you can modify it at any time",
  [PAYMENT_METHODS_ENCRYPTED]: "End-to-End Encryption",
  [PAYMENT_SUCCESSFUL]: "Payment successful",
  [UPGRADE_SUBSCRIPTION_SUCCESSFUL]: "Subscription Upgraded Successfully",
  [PRICE_TO_BE_PAID]: "Price to be paid",
  [PAY]: "Pay",
  [ADD_CARD]: "Add card",
  [VERIFY_SUBSCRIPTION_TITLE]: "We Couldn't Verify Your Subscription",
  [VERIFY_SUBSCRIPTION_DESCRIPTION]:
    "Our provider could not verify and sync your subscription. Please enter the details you used for the purchase again. You will not be charged and your data will stay secure.",
  [VERIFY_SUBSCRIPTION_CTA]: "Verify",
  [SAVE_CONFIGURATION]: "Save configuration",
  [CARD_INFORMATION_EXPLANATION_TITLE]: "Information collected from your card",
  [CARD_INFORMATION_NUMBER_CARD_EXPLANATION_TITLE]: "Card Number",
  [CARD_INFORMATION_NUMBER_CARD_EXPLANATION_DESCRIPTION]:
    "The card number consists of 16 digits and is separated into groups of 4. It is located on the front of the card.",
  [CARD_INFORMATION_EXPIRATION_DATE_EXPLANATION_TITLE]: "Expiration Date",
  [CARD_INFORMATION_EXPIRATION_DATE_EXPLANATION_DESCRIPTION]:
    "It can be found on the front or back of the card, and it consists of 4 or sometimes 3 numbers. Its format is MM/YY (Month in number/Last two digits of the year).",
  [CARD_INFORMATION_CVV_EXPLANATION_TITLE]: "Security Code (CVV)",
  [CARD_INFORMATION_CVV_EXPLANATION_DESCRIPTION]:
    "It is usually located on the back, sometimes on the front, and consists of 4 or 3 numbers. Its function is to validate the card.",
  [YOU_WILL_PAY]: "You will pay",
  [ACCEPT_TERMS_PAY]: `Accept {{NAME_BUSINESS}}'s terms and conditions`,
  [DELETE_PAYMENT_METHOD_CONFIRMATION_TITLE]:
    "Are you sure you want to delete this payment method?",
  [QUANTITY_TO_PAY]: "Amount to pay",
  [USERS]: "Users",
  [ANONYMOUS_USER]: "Anonymous User",

  /* FIELDS PLACEHOLDERS */
  [NAME_PLACEHOLDER]: "Name",
  [EMAIL_PLACEHOLDER]: "Email",
  [PASSWORD_PLACEHOLDER]: "Password",
  [PASSWORD_CONFIRMATION_PLACEHOLDER]: "Confirm password",
  [SELECT_BUSINESS_PLACEHOLDER]: "Select a business",
  [NAME_BUSINESS_PLACEHOLDER]: "Business name",
  [SELECT_BRANDS_PLACEHOLDER]: "Select brands",
  [MAIN_BRAND_PLACEHOLDER]: "Main brand",
  [SELECT_BRAND_PLACEHOLDER]: "Select a brand",
  [SELECT_STORE_PLACEHOLDER]: "Select a store",
  [NAME_AND_LAST_NAME_PLACEHOLDER]: "First and last name",
  [SELECT_TYPE_PLAN_PLACEHOLDER]: "Plan type",
  [COST_COLLABORATION_PLACEHOLDER]: "Collaboration cost",
  [CREDITS_PLACEHOLDER]: `{{NAME_BUSINESS}} Credits`,
  [TRIAL_DAYS_PLACEHOLDER]: "Trial days",
  [TYPE_PACKAGE_PLACEHOLDER]: "Package type",
  [PRICE_BASIC_PLACEHOLDER]: "Basic subscription cost",
  [COST_COLLABORATION_BASIC_PLACEHOLDER]: "Basic collaboration cost",
  [PRICE_PRO_PLACEHOLDER]: "Pro subscription cost",
  [COST_COLLABORATION_PRO_PLACEHOLDER]: "Pro collaboration cost",
  [PRICE_GROWTH_PLACEHOLDER]: "Growth subscription cost",
  [COST_COLLABORATION_GROWTH_PLACEHOLDER]: "Growth collaboration cost",
  [COMMERCIAL_PLACEHOLDER]: "Commercial",
  [BUSINESS_NAME_PLACEHOLDER]: "Name",
  [BUSINESS_DESCRIPTION_PLACEHOLDER]: "Description",
  [BUSINESS_TEXT_STYLE_PLACEHOLDER]: "Communication Tone",
  [BUSINESS_LOOK_AND_FEEL_PLACEHOLDER]: "Look and Feel",
  [LOOK_AND_FEEL_PLACEHOLDER]: "Look and Feel",
  [BUSINESS_OFFERING_PLACEHOLDER]: "Offering",
  [BUSINESS_OFFERING_PHYSICAL_PRODUCT_PLACEHOLDER]: "Physical Products",
  [BUSINESS_OFFERING_SERVICES_PLACEHOLDER]: "Services",
  [DESCRIPTION_OPTIONAL_PLACEHOLDER]: "Description (optional)",
  [PRICE_PLACEHOLDER]: "Price",
  [CURRENCY_PLACEHOLDER]: "Currency",
  [IS_RECURRENCE_PLACEHOLDER]: "The charge is",
  [RECURRENCE_PLACEHOLDER]: "Recurrence",
  [SELECT_CAMPAIGN_PLACEHOLDER]: "Select a campaign",
  [SELECT_UGC_CONTENT_FORMAT]: "Select a content style",
  [SELECT_SOME_OPTIONS]: "Select some options",
  [OBJECTIVE_PLACEHOLDER]: "Objective",
  [PLATFORMS_PLACEHOLDER]: "Platforms",
  [PLATFORM_PLACEHOLDER]: "Platform",
  [BUDGET_PLACEHOLDER]: "Budget",
  [DAILY_BUDGET_PLACEHOLDER]: "Daily Budget in {{currency}}",
  [LIFETIME_BUDGET_PLACEHOLDER]: "Total Budget in {{currency}}",
  [LOCATIONS_PLACEHOLDER]: "Locations",
  [EXCLUDED_LOCATIONS_PLACEHOLDER]: "Excluded Locations",
  [AGE_RANGE_PLACEHOLDER]: "Age Range",
  [GENDERS_PLACEHOLDER]: "Genders",
  [INTERESTS_PLACEHOLDER]: "Interests",
  [INDUSTRIES_PLACEHOLDER]: "Industries",
  [JOB_FUNCTIONS_PLACEHOLDER]: "Job Functions",
  [SENIORITIES_PLACEHOLDER]: "Seniorities",
  [JOB_TITLES_PLACEHOLDER]: "Job Titles",
  [COMPANY_SIZES_PLACEHOLDER]: "Company Sizes",
  [COMPANIES_PLACEHOLDER]: "Companies",
  [DEGREES_PLACEHOLDER]: "Degrees",
  [FIELDS_OF_STUDY_PLACEHOLDER]: "Fields of Study",
  [SCHOOLS_PLACEHOLDER]: "Schools",
  [SKILLS_PLACEHOLDER]: "Skills",
  [MEMBER_TRAITS_PLACEHOLDER]: "Member Traits",
  [MEMBER_BEHAVIORS_PLACEHOLDER]: "Member Behaviors",
  [MEMBER_GROUPS_PLACEHOLDER]: "Member Groups",

  [DEGREES_SEARCH_PLACEHOLDER]:
    "e.g. Bachelor of Computer Engineering, Master of Data Science",
  [FIELDS_OF_STUDY_SEARCH_PLACEHOLDER]:
    "e.g. Computer Science, Marketing, Business Administration",
  [INTERESTS_SEARCH_PLACEHOLDER]:
    "e.g. Software Development, Digital Marketing, Business Consulting",
  [SCHOOLS_SEARCH_PLACEHOLDER]:
    "e.g. Harvard University, Stanford University, MIT",
  [SKILLS_SEARCH_PLACEHOLDER]:
    "e.g. Project Management, Python, Microsoft Excel",
  [COMPANIES_SEARCH_PLACEHOLDER]: "e.g. Microsoft, Meta, Google, Stripe",
  [INDUSTRIES_SEARCH_PLACEHOLDER]:
    "e.g. Software Development, Financial Services, Healthcare",
  [COMPANY_SIZES_SEARCH_PLACEHOLDER]: "e.g. 11-50 employees, 51-200 employees",
  [JOB_FUNCTIONS_SEARCH_PLACEHOLDER]: "e.g. Marketing, Engineering, Sales",
  [JOB_TITLES_SEARCH_PLACEHOLDER]:
    "e.g. Software Engineer, Project Manager, Designer",
  [SENIORITIES_SEARCH_PLACEHOLDER]: "e.g. Senior, Manager, Director",
  [MEMBER_BEHAVIORS_SEARCH_PLACEHOLDER]:
    "e.g. Job Seekers, Recently Promoted, Frequent Travelers",

  [LINKEDIN_STAFF_COUNT_MYSELF_ONLY]: "Myself Only",
  [LINKEDIN_STAFF_COUNT_2_10]: "2-10 employees",
  [LINKEDIN_STAFF_COUNT_11_50]: "11-50 employees",
  [LINKEDIN_STAFF_COUNT_51_200]: "51-200 employees",
  [LINKEDIN_STAFF_COUNT_201_500]: "201-500 employees",
  [LINKEDIN_STAFF_COUNT_501_1000]: "501-1,000 employees",
  [LINKEDIN_STAFF_COUNT_1001_5000]: "1,001-5,000 employees",
  [LINKEDIN_STAFF_COUNT_5001_10000]: "5,001-10,000 employees",
  [LINKEDIN_STAFF_COUNT_10001_PLUS]: "10,001+ employees",

  [LINKEDIN_JOB_FUNCTION_ACCOUNTING]: "Accounting",
  [LINKEDIN_JOB_FUNCTION_ADMINISTRATIVE]: "Administrative",
  [LINKEDIN_JOB_FUNCTION_ARTS_AND_DESIGN]: "Arts and Design",
  [LINKEDIN_JOB_FUNCTION_BUSINESS_DEVELOPMENT]: "Business Development",
  [LINKEDIN_JOB_FUNCTION_COMMUNITY_AND_SOCIAL_SERVICES]:
    "Community and Social Services",
  [LINKEDIN_JOB_FUNCTION_CONSULTING]: "Consulting",
  [LINKEDIN_JOB_FUNCTION_EDUCATION]: "Education",
  [LINKEDIN_JOB_FUNCTION_ENGINEERING]: "Engineering",
  [LINKEDIN_JOB_FUNCTION_ENTREPRENEURSHIP]: "Entrepreneurship",
  [LINKEDIN_JOB_FUNCTION_FINANCE]: "Finance",
  [LINKEDIN_JOB_FUNCTION_HEALTHCARE_SERVICES]: "Healthcare Services",
  [LINKEDIN_JOB_FUNCTION_HUMAN_RESOURCES]: "Human Resources",
  [LINKEDIN_JOB_FUNCTION_INFORMATION_TECHNOLOGY]: "Information Technology",
  [LINKEDIN_JOB_FUNCTION_LEGAL]: "Legal",
  [LINKEDIN_JOB_FUNCTION_MARKETING]: "Marketing",
  [LINKEDIN_JOB_FUNCTION_MEDIA_AND_COMMUNICATION]: "Media and Communication",
  [LINKEDIN_JOB_FUNCTION_MILITARY_AND_PROTECTIVE_SERVICES]:
    "Military and Protective Services",
  [LINKEDIN_JOB_FUNCTION_OPERATIONS]: "Operations",
  [LINKEDIN_JOB_FUNCTION_PRODUCT_MANAGEMENT]: "Product Management",
  [LINKEDIN_JOB_FUNCTION_PROGRAM_AND_PROJECT_MANAGEMENT]:
    "Program and Project Management",
  [LINKEDIN_JOB_FUNCTION_PURCHASING]: "Purchasing",
  [LINKEDIN_JOB_FUNCTION_QUALITY_ASSURANCE]: "Quality Assurance",
  [LINKEDIN_JOB_FUNCTION_REAL_ESTATE]: "Real Estate",
  [LINKEDIN_JOB_FUNCTION_RESEARCH]: "Research",
  [LINKEDIN_JOB_FUNCTION_SALES]: "Sales",
  [LINKEDIN_JOB_FUNCTION_CUSTOMER_SUCCESS_AND_SUPPORT]:
    "Customer Success and Support",

  [LINKEDIN_SENIORITY_UNPAID]: "Unpaid",
  [LINKEDIN_SENIORITY_TRAINING]: "Training",
  [LINKEDIN_SENIORITY_ENTRY]: "Entry",
  [LINKEDIN_SENIORITY_SENIOR]: "Senior",
  [LINKEDIN_SENIORITY_MANAGER]: "Manager",
  [LINKEDIN_SENIORITY_DIRECTOR]: "Director",
  [LINKEDIN_SENIORITY_VP]: "VP",
  [LINKEDIN_SENIORITY_CXO]: "CXO",
  [LINKEDIN_SENIORITY_PARTNER]: "Partner",
  [LINKEDIN_SENIORITY_OWNER]: "Owner",

  [LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_TRAVELERS]: "Frequent Travelers",
  [LINKEDIN_MEMBER_BEHAVIOR_JOB_SEEKERS]: "Job Seekers",
  [LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_EDUCATION]: "Open to Education",
  [LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_CONTRIBUTORS]: "Frequent Contributors",
  [LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED]: "Recently Relocated",
  [LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_PROMOTED]: "Recently Promoted",
  [LINKEDIN_MEMBER_BEHAVIOR_CAREER_CHANGERS]: "Career Changers",
  [LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_SWITCHED_JOBS]: "Recently Switched Jobs",
  [LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION]: "Open to Relocation",
  [LINKEDIN_MEMBER_BEHAVIOR_EXPAT]: "Ex-pat",
  [LINKEDIN_MEMBER_BEHAVIOR_MOBILE_USERS]: "Mobile Users",
  [LINKEDIN_MEMBER_BEHAVIOR_DESKTOP_LAPTOP_USERS]: "Desktop/Laptop Users",
  [LINKEDIN_MEMBER_BEHAVIOR_DOMESTIC_FREQUENT_TRAVELERS]:
    "Domestic Frequent Travelers",
  [LINKEDIN_MEMBER_BEHAVIOR_INTERNATIONAL_FREQUENT_TRAVELERS]:
    "International Frequent Travelers",
  [LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_DOMESTIC]:
    "Recently Relocated (Domestic)",
  [LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_INTERNATIONAL]:
    "Recently Relocated (International)",
  [LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_DOMESTIC]:
    "Open to Relocation (Domestic)",
  [LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_INTERNATIONAL]:
    "Open to Relocation (International)",
  [LINKEDIN_MEMBER_BEHAVIOR_ANDROID_USERS]: "Android Users",
  [LINKEDIN_MEMBER_BEHAVIOR_WINDOWS]: "Windows",
  [LINKEDIN_MEMBER_BEHAVIOR_MAC]: "Mac",
  [LINKEDIN_MEMBER_BEHAVIOR_LINUX]: "Linux",

  [AUDIENCE_ATTRIBUTES_PLACEHOLDER]: "Audience Attributes",
  [BEHAVIORS_PLACEHOLDER]: "Behaviors",
  [DEMOGRAPHICS_PLACEHOLDER]: "Demographics",
  [DEMOGRAPHICS_BASIC_PLACEHOLDER]: "Basic Demographics",
  [BUDGET_CONFIGURATION_PLACEHOLDER]: "Budget Configuration",
  [BUDGET_CAMPAIGN_DATES_PLACEHOLDER]: "Campaign Dates",
  [DESTINATION_TYPE_PLACEHOLDER]: "Conversion Location",
  [CUSTOM_AUDIENCES_PLACEHOLDER]: "Custom audiences",
  [CUSTOM_PLACEMENTS_PLACEHOLDER]: "Custom placements",
  [EXCLUDED_CUSTOM_AUDIENCES_PLACEHOLDER]: "Excluded custom audiences",
  [KEYWORDS_PLACEHOLDER]: "Keywords",
  [KEYWORDS_NEGATIVE_PLACEHOLDER]: "Negative Keywords",
  [DESCRIPTION_PLACEHOLDER]: "Description",
  [LONG_HEADLINE_PLACEHOLDER]: "Long Headline",
  [TRACKING_META_ID_PLACEHOLDER]: "Meta Pixel ID",
  [TRACKING_TIKTOK_ID_PLACEHOLDER]: "TikTok Pixel ID",
  [TRACKING_GOOGLE_ID_PLACEHOLDER]: "Google Tag ID",
  [TRACKING_LINKEDIN_ID_PLACEHOLDER]: "LinkedIn Pixel ID",
  [TRACKING_CUSTOM_EVENT_ID_META_PLACEHOLDER]: "Meta Tracking Event",
  [TRACKING_CUSTOM_EVENT_ID_TIKTOK_PLACEHOLDER]: "TikTok Tracking Event",
  [TRACKING_CUSTOM_EVENT_ID_GOOGLE_PLACEHOLDER]: "Google Tracking Event",
  [TRACKING_CUSTOM_EVENT_ID_LINKEDIN_PLACEHOLDER]: "LinkedIn Tracking Event",
  [DESTINATION_URL_PLACEHOLDER]: "Redirect URL",
  [DEEP_LINK_PLACEHOLDER]: "Deep Link",
  [CREATOR_BODY_BUILD_PLACEHOLDER]: "Body type",
  [CREATOR_CLOTHING_STYLE_PLACEHOLDER]: "Clothing style",
  [CREATOR_CONTENT_STYLE_PLACEHOLDER]: "Content style",
  [CREATOR_DISTINGUISHING_FEATURES_PLACEHOLDER]: "Distinguishing features",
  [CALL_TO_ACTION_PLACEHOLDER]: "Call to Action",
  [CHOOSE_AN_ADDRESS_PLACEHOLDER]: "Choose an Address",
  [CALL_TO_ACTIONS_PLACEHOLDER]: "Call to Actions",
  [ADS_CAMPAIGN_CONTEXT]: "What is your campaign about?",
  [TYPE_BUDGET_PLACEHOLDER]: "Type of Budget",
  [TITLE_PLACEHOLDER]: "Title",
  [HEADLINE_PLACEHOLDER]: "Headline",
  [WEBSITE_URL_PLACEHOLDER]: "Your Website URL",
  [LANGUAGE_CAMPAIGN_PLACEHOLDER]: "Campaign Language",
  [LANGUAGE_PLACEHOLDER]: "Language",
  [VERIFICATION_CODE_PLACEHOLDER]: "Verification code",
  [TYPE_PLACEHOLDER]: "Type",
  [RETENTION_DAYS_PLACEHOLDER]: "Audience retention (In days)",
  [IDENTITY_TIK_TOK_PLACEHOLDER]: "TikTok identity",
  [PROFILE_IMAGE_PLACEHOLDER]: "Profile image",
  [PROFILE_NAME_PLACEHOLDER]: "Profile name",
  [AD_ACCOUNT_META_PLACEHOLDER]: "Meta Ad Account",
  [AD_ACCOUNT_TIKTOK_PLACEHOLDER]: "TikTok Ad Account",
  [AD_ACCOUNT_GOOGLE_PLACEHOLDER]: "Google Ad Account",
  [AD_ACCOUNT_LINKEDIN_PLACEHOLDER]: "LinkedIn Ad Account",
  [LINKEDIN_ACCOUNT_SHARE_PLACEHOLDER]: "LinkedIn account",
  [LINKEDIN_PUBLISH_AS_PERSONAL_LABEL]: "Personal",
  [LINKEDIN_PUBLISH_AS_COMPANY_PAGE_LABEL]: "Company Page",
  [PAGE_FACEBOOK_PLACEHOLDER]: "Facebook Page",
  [INSTAGRAM_ACCOUNT_PLACEHOLDER]: "Instagram Account",
  [USE_FB_PAGE_AS_IG]: "Use Facebook Page as Instagram",
  [YOUTUBE_ACCOUNT_PLACEHOLDER]: "YouTube Account",
  [YOUTUBE_PRIVACY_LEVEL_PUBLIC]: "Public",
  [YOUTUBE_PRIVACY_LEVEL_UNLISTED]: "Unlisted",
  [YOUTUBE_PRIVACY_LEVEL_PRIVATE]: "Private",
  [YOUTUBE_PRIVACY_LEVEL_LABEL]: "Privacy Level",
  [YOUTUBE_TITLE_LABEL]: "Title",
  [YOUTUBE_DESCRIPTION_LABEL]: "Description",
  [YOUTUBE_NOTIFY_SUBSCRIBERS_LABEL]: "Notify Subscribers",
  [YOUTUBE_MADE_FOR_KIDS_LABEL]: "Made for Kids",
  [FORMAT_PLACEHOLDER]: "Format",
  [ADVERTISER_SELECTOR_BRANDS_COUNT]: "{{count}} brands",
  [ADVERTISER_SELECTOR_BRANDS_COUNT_SINGLE]: "{{count}} brand",
  [ADVERTISER_SELECTOR_NO_RESULTS]: "No results",
  [ADVERTISER_SELECTOR_SEARCH_PLACEHOLDER]: "Search brands…",
  [ADVERTISER_SELECTOR_TRY_ANOTHER_NAME]: "Try another name",
  [ADVERTISER_SELECTOR_CONFIGURE_LIMITS_BUTTON]: "Configure Limits",
  [SELECT_ADVERTISER_ID_PLACEHOLDER]: "Brand",
  [SOCIAL_NETWORK_URL_PLACEHOLDER]: "Social Network URL",
  [DISCOUNT_CODE_PLACEHOLDER]: "Discount Code",
  [BRAND_INSTAGRAM_PROFILE_URL_PLACEHOLDER]: "Brand Instagram Profile URL",
  [INSTAGRAM_PROFILE_URL_PLACEHOLDER]: "Instagram Profile URL",
  [SCRIPT_PLACEHOLDER]: "Script",
  [META_DESTINATION_TYPE_PLACEHOLDER]: "Conversion Location",
  [ROLE_PLACEHOLDER]: "Role",
  [CAMPAIGN_TYPE_PLACEHOLDER]: "Campaign Type",
  [CONVERSION_ACTIONS_PLACEHOLDER]: "Conversion Actions",
  [SEARCH_KEYWORDS_PLACEHOLDER]: "Search Keywords",
  [WHATSAPP_BUSINESS_NUMBER_PLACEHOLDER]: "WhatsApp Business Number",
  [WELCOME_MESSAGE_TEMPLATE_PLACEHOLDER]: "Welcome Message Template",
  [MESSAGE_TEMPLATE_UNSUPPORTED_TITLE]:
    "Template not supported by the platform",
  [MESSAGE_TEMPLATE_UNSUPPORTED_DESCRIPTION]:
    "This template includes a form created directly in Meta. It cannot be edited here, but it will be kept as-is when you save the ad changes.",
  [GREETING_MESSAGE_PLACEHOLDER]: "Greeting Message",
  [CUSTOMER_TYPE_MESSAGE_PLACEHOLDER]: "User message type",
  [CUSTOMER_TYPE_PREFILL_MESSAGE]: "Pre-filled Message",
  [CUSTOMER_TYPE_QUICK_QUESTIONS_MESSAGE]: "Quick Questions",
  [CUSTOMER_TEXT_PLACEHOLDER]: "User pre-filled message",
  [CUSTOMER_TEXTS_PLACEHOLDER]: "User quick question {{value}}",
  [LOG_MESSAGE_TEMPLATE_CUSTOMER_TEXTS]: "Customer texts",
  [INSTANT_FORM_PLACEHOLDER]: "Instant Form",
  [TIKTOK_LEAD_DESTINATION_WEBSITE]: "Website",
  [TIKTOK_LEAD_DESTINATION_INSTANT_FORM]: "Instant Form",
  [TIKTOK_INSTANT_FORM_EDITOR_HINT]:
    "The form is created in TikTok's editor. To change the questions, create another form and replace it on the ad.",
  [TIKTOK_INSTANT_FORM_CREATE]: "Create form",
  [INTEGRATION_MISSING_PERMISSION]:
    "Your integration does not have enough permissions for this feature. Please reconnect your {{platform}} account.",
  [TIKTOK_INSTANT_FORM_EDITOR_FAILED]:
    "The editor could not be opened. Allow pop-ups for this site and try creating the form again. If the problem continues, contact support from the help chat on the right.",
  [TIKTOK_INSTANT_FORM_LOCKED_DESTINATION]:
    "The destination of a published ad group cannot be changed. Create another ad group.",
  [TIKTOK_CAROUSEL_REQUIRES_TIKTOK_PLACEMENT]:
    "Carousel ads require the ad group to include the TikTok placement.",
  [TIKTOK_INSTANT_FORM_PREVIEW_NAME]: "Form: {{name}}",
  [CREATE_ADS_CAMPAIGN_TIKTOK_LEAD_DESTINATION_QUESTION]:
    "Where should the leads go?",
  [CREATE_ADS_CAMPAIGN_TIKTOK_INSTANT_FORM_QUESTION]:
    "Choose an instant form. You can leave this empty and select it later.",
  [WHY_WOULD_IT_WORK]: "Why would it work?",
  [INSTANT_FORM_SECTION_FORM_TYPE]: "Form type",
  [INSTANT_FORM_SECTION_INTRO]: "Intro",
  [INSTANT_FORM_SECTION_QUESTIONS]: "Questions",
  [INSTANT_FORM_SECTION_END]: "End",
  [INSTANT_FORM_FIELD_HEADLINE]: "Headline",
  [INSTANT_FORM_FIELD_DESCRIPTION]: "Description",
  [INSTANT_FORM_FIELD_CTA]: "CTA",
  [ENTER_ANSWER_PLACEHOLDER]: "Enter answer",
  [IMAGES_OF_CAMPAIGN_PLACEHOLDER]: "Images",
  [VIDEOS_OF_CAMPAIGN_PLACEHOLDER]: "Videos",
  [LOGO_OF_THE_BRAND_PLACEHOLDER]: "Brand logo",
  [LOGO_URLS_PLACEHOLDER]: "Brand Logos",
  [NETWORK_DISPLAY_SETTING_PLACEHOLDER]:
    "Where do you want Google to show your ad?",
  [GOOGLE_AI_MAX_ENABLE_QUESTION]: "Do you want to enable Google AI Max?",
  [GOOGLE_AI_MAX_ACTIVATED]: "Enabled",
  [GOOGLE_AI_MAX_DEACTIVATED]: "Disabled",
  [REPORT_BREAKDOWN_PLACEHOLDER]: "Breakdown",
  [ADS_CAMPAIGN_CONTEXT_PLACEHOLDER]: "What will your campaign be about?",
  [ADS_CAMPAIGN_LANGUAGE_PLACEHOLDER]: "Campaign Language",
  [ADS_CAMPAIGN_LANGUAGE_SELECT_PLACEHOLDER]: "Select a Language",
  [ADS_CAMPAIGN_LOCATION_PLACEHOLDER]: "What locations do you want to target?",
  [ADS_CAMPAIGN_PLATFORMS_PLACEHOLDER]:
    "On which platforms your campaign will run?",
  [SOCIAL_NETWORKS_PLACEHOLDER]: "Social Networks",
  [BUSINESS_COMPETITORS_PLACEHOLDER]: "Competitors",
  [FIND_A_LOCATION_PLACEHOLDER]: "Find a location",
  [CREATIVE_TYPE_PLACEHOLDER]: "Creative Type",
  [ADVANTAGE_CREATIVE_ENHANCES_PLACEHOLDER]: "Creative Advantage Enhances",
  [SITE_LINKS_PLACEHOLDER]: "Sitelinks",
  [SITE_LINK_PLACEHOLDER]: "Sitelink",
  [SITE_LINK_TEXT_PLACEHOLDER]: "Name",
  [SITE_LINK_DESCRIPTION_PLACEHOLDER]: "Description",
  [SITE_LINK_FINAL_URL_PLACEHOLDER]: "Final URL",
  [SITE_LINK_DESCRIPTIONS_PLACEHOLDER]: "Descriptions",
  [CALLOUTS_PLACEHOLDER]: "Callouts",
  [CALLOUT_TEXT_PLACEHOLDER]: "Callout text",
  [KEYWORD_PLACEHOLDER]: "Keyword",
  [KEYWORD_MATCH_TYPE_PLACEHOLDER]: "Match Type",
  [FROM_PLACEHOLDER]: "From",
  [SEARCH_THEMES_PLACEHOLDER]: "Search themes",
  [STATUS_PLACEHOLDER]: "Status",
  [USE_CAMPAIGN_BUDGET_PLACEHOLDER]: "Campaign Level Budget (CBO)",
  [DESTINATION_TYPE_AD_PLACEHOLDER]: "Destination",
  [DATA_TYPE_PLACEHOLDER]: "Data type",
  [CUSTOMER_TYPES_PLACEHOLDER]: "Customer types",
  [FIRST_NAME_PLACEHOLDER]: "First name",
  [LAST_NAME_PLACEHOLDER]: "Last name",
  [COUNTRY_CODE_PLACEHOLDER]: "Country code",
  [POSTAL_CODE_PLACEHOLDER]: "Postal code",
  [PHONE_PLACEHOLDER]: "Phone",
  [BUSINESS_LOGO]: "Brand logo",
  [SELECT_RANGE_DATE_PLACEHOLDER]: "Select a Date Range",
  [MEDIA_URLS_PLACEHOLDER]: "Creative",
  [CATALOG_PLACEHOLDER]: "Catalog",
  [PROMOTED_PRODUCTS_PLACEHOLDER]: "Promoted Products",
  [PRODUCT_SET]: "Product Set",
  [PRODUCT_SET_PLACEHOLDER]: "Product Set",
  [PRODUCT_CONFIGURATION_PLACEHOLDER]: "Product Configuration",
  [PRODUCT_LIST]: "Product List",
  [PRODUCT_LIST_PLACEHOLDER]: "Customized Products",
  [BUTTON_ADD_PRODUCTS]: "Add Customized Products",
  [MODAL_PRODUCT_LIST_TIKTOK_TITLE]: "Select Products",
  [MODAL_PRODUCT_LIST_TIKTOK_DESCRIPTION]:
    "Choose the products you want to promote in this ad.",
  [SEARCH_PRODUCT_PLACEHOLDER]: "Search products",
  [IS_CATALOG_CAMPAIGN_PLACEHOLDER]: "Catalog Campaign",
  [BRAND_PLACEHOLDER]: "Brand",
  [RETAILER_ID_PLACEHOLDER]: "Retailer ID",
  [SHORT_DESCRIPTION_PLACEHOLDER]: "Short description",
  [CURRENT_PRICE_PLACEHOLDER]: "Current price",
  [UNIT_PRICE_PLACEHOLDER]: "Unit price",
  [CUSTOM_LABEL_NUMBER_PLACEHOLDER]: "Custom label {{value}}",
  [CUSTOM_NUMBER_PLACEHOLDER]: "Custom number {{value}}",
  [URL_PLACEHOLDER]: "URL",
  [CREATIVE_FROM_PLACEHOLDER]: "Creative from",
  [EDIT_CREATIVE_TOOLS_PLACEHOLDER]: "Edit Creative Tools",
  [OVERLAY_TYPE_PLACEHOLDER]: "Overlay type",
  [OVERLAY_POSITION_PLACEHOLDER]: "Overlay position",
  [OVERLAY_SHAPE_PLACEHOLDER]: "Overlay shape",
  [OVERLAY_COLOR_PLACEHOLDER]: "Overlay color",
  [OVERLAY_OPACITY_PLACEHOLDER]: "Overlay opacity",
  [OVERLAY_FONT_PLACEHOLDER]: "Overlay font",
  [PRICE_LABEL_PLACEHOLDER]: "Price",
  [AUTO_SHOW_LABEL_PLACEHOLDER]: "Auto show label",
  [LABEL_TEXT_PLACEHOLDER]: "Label text",
  [STRIKETHROUGH_PRICE_PLACEHOLDER]: "Strikethrough price",
  [PERCENTAGE_OFF_PLACEHOLDER]: "Percentage off",
  [FREE_SHIPPING_PLACEHOLDER]: "Free shipping",
  [OVERLAY_TEXT_COLOR_PLACEHOLDER]: "Text color",
  [OVERLAY_TEXT_FONT_PLACEHOLDER]: "Text font",
  [ONLY_SHOW_LABEL_WHEN_INCREASE_ENGAGEMENT]:
    "Only show the label when it's likely to increase engagement.",
  [APP_PLACEHOLDER]: "App",
  [ANDROID_DEEP_LINK_PLACEHOLDER]: "Android Deep Link",
  [IOS_DEEP_LINK_PLACEHOLDER]: "iOS Deep Link",
  [INSTANT_EXPERIENCE_PLACEHOLDER]: "Instant experience",
  [DEEP_DESTINATION_APP_URL_PLACEHOLDER]: "Deep App URL",
  [CUSTOM_STORE_LISTING_ID_PLACEHOLDER]: "Custom store listing ID",
  [CUSTOM_PRODUCT_PAGE_ID_PLACEHOLDER]: "Custom Product Page ID",
  [IOS_14_CAMPAIGN_PLACEHOLDER]:
    "Target iOS 14 and Above Devices (Recommended)",
  [UTM_PARAMETERS_PLACEHOLDER]: "UTM parameters",
  [MERCHANT_CENTER_ID_PLACEHOLDER]: "Merchant Center ID",
  [PRODUCTS_TO_PROMOTE_PLACEHOLDER]: "Products to promote",
  [ADS_SCHEDULE_PLACEHOLDER]: "Run ads on a schedule",
  [ADS_SCHEDULE_ALWAYS_ON]: "Always on",
  [TIMEZONE_PLACEHOLDER]: "Timezone",
  [AD_SCHEDULE_PLACEHOLDER]: "Ad Schedule",
  [SEARCH_BY_NAME_PLACEHOLDER]: "Search by Name",
  [PLACEMENTS_PLACEHOLDER]: "Placements",
  [DEVICES_PLACEHOLDER]: "Devices",
  [CREATIVE_SOURCE_PLACEHOLDER]: "Creative Source",
  [MANUAL_UPLOAD_PLACEHOLDER]: "Manual Upload",
  [FROM_CATALOG]: "From catalog",
  [MANUAL_UPLOAD]: "Manual upload",
  [PUBLICATION_DESCRIPTION]: "Publication description",
  [ADVANTAGE_CATALOG_PLACEHOLDER]: "Advantage Catalog",
  [DESTINATION_DEEP_LINK_CONFIGURATION_PLACEHOLDER]:
    "Destination deep link configuration",
  [COVER_CONTENT_PLACEHOLDER]: "Cover content",
  [SEARCH_PLACEHOLDER]: "Search",
  [OFFLINE_EVENTS_PLACEHOLDER]: "Offline Events",
  [SIZE_FOR_DISPLAY_PLACEHOLDER]: "Size for Display",
  [SIZE_FOR_SEARCH_PLACEHOLDER]: "Size for Search",
  [SIZE_PLACEHOLDER]: "Size",
  [MAXIMUM_COST_PER_CLICK_PLACEHOLDER]: "Maximum Cost Per Click",
  [TARGET_CPA_PLACEHOLDER]: "Target CPA",
  [BID_CONTROL_PLACEHOLDER]: "Bid Control",
  [HIGHEST_VOLUME_PLACEHOLDER]: "Highest Volume",
  [TARGET_ROAS_PLACEHOLDER]: "Target ROAS",
  [BIDDING_STRATEGY_TYPE_PLACEHOLDER]: "Bidding Strategy Type",
  [ADVERTISERS_AVAILABLE_PLACEHOLDER]: "Brands you have access to",
  [BUYING_TYPE_PLACEHOLDER]: "Buying Type",
  [SEARCH_SPECIFIC_LOCATION_PLACEHOLDER]: "Search a specific location",
  [LANGUAGES_PLACEHOLDER]: "Languages",
  [FREQUENCY_CONTROL_PLACEHOLDER]: "Frequency Control",
  [FILTER_BY_USERS_PLACEHOLDER]: "Filter by User",
  [FILTER_BY_DATES_PLACEHOLDER]: "Filter by Dates",
  [TRACKING_OFFLINE_EVENTS_PLACEHOLDER]: "Offline Events",
  [PRESETS_DATE_PLACEHOLDER]: "Presets",
  [ASPECT_RATIO_PLACEHOLDER]: "Dimensions",
  [DATE_RANGE_PRESET_CUSTOM]: "Custom",
  [MIN_DAILY_BUDGET_PLACEHOLDER]: "Minimum Daily Spend",
  [MAX_DAILY_BUDGET_PLACEHOLDER]: "Maximum Daily Spend",
  [MIN_TOTAL_BUDGET_PLACEHOLDER]: "Minimum Total Spend",
  [MAX_TOTAL_BUDGET_PLACEHOLDER]: "Maximum Total Spend",
  [DARK_POST_PLACEHOLDER]: "Ads-only mode",
  [DARK_POST_DESCRIPTION_PLACEHOLDER]:
    "If you enable this option, your ads will only appear as ads and not on your TikTok profile. If you disable it, they will also be published as a post on your profile.",

  [IS_ADVANTAGE_AUDIENCE_ACTIVE_PLACEHOLDER]: "Enable Advantage+ Audience",
  [IS_ADVANTAGE_AUDIENCE_ACTIVE_DESCRIPTION_PLACEHOLDER]:
    "Allow Meta to broaden your targeting automatically towards audiences that potentially convert.",

  //EXAMPLES
  [ADS_CAMPAIGN_CONTEXT_EXAMPLE]:
    "Write a paragraph detailing the product or service you want to promote, the target audience you want to reach and the objective you want to achieve with your campaign",
  [ADS_CAMPAIGN_LOCATION_EXAMPLE]:
    "Write a prompt and press enter (e.g., 'major cities in the United States') or search for a place",
  [SEARCH_SPECIFIC_LOCATION_EXAMPLE]:
    "Search by name or coordinates (in the format: latitude, longitude)",
  [SOCIAL_NETWORK_EXAMPLE]: "https://www.instagram.com/yourbrand",

  /*OPTIONS SELECT*/
  [PLAN_PAY_PER_USE]: "Pay-Per-Use subscription",
  [PLAN_PACKAGE]: "Package License",
  [PLAN_REGULAR]: "Regular plans (Basic and Pro)",
  [PLAN_ENTERPRISE]: "Enterprise",
  [ADD_NEW_OPTION]: `Add "{{value}}"`,
  [RECURRENT_OPTION]: "Recurrent",
  [RECURRING_DAYS]: "Every day",
  [RECURRING_WEEKS]: "Every week",
  [RECURRING_MONTHS]: "Every month",
  [RECURRING_YEARS]: "Every year",
  [ASPECT_RATIO_9_16]: "Vertical (9:16)",
  [ASPECT_RATIO_16_9]: "Horizontal (16:9)",
  [ASPECT_RATIO_1_1]: "Square (1:1)",
  [ASPECT_RATIO_4_5]: "Instagram Feed (4:5)",

  /*PLANS*/
  [PLAN_PAY_PER_USE_NAME]: "Pay Per Use Plan",
  [PLAN_PACKAGE_NAME]: "Plan {{value}}",

  /* FIELDS VALIDATIONS */
  [FIELD_REQUIRED]: "This field is required",
  [FIELD_MUST_BE_SELECT_AT_LEAST_PRODUCTS]:
    "You must select at least {{value}} products",
  [FIELDS_REQUIRED]: "All fields are required",
  [FIELD_NUMERIC]: "This field must be numeric",
  [FIELD_TEXT]: "This field must contain only letters",
  [FIELD_ALPHANUMERIC]: "This field must contain only letters and numbers",
  [FIELD_MIN_LENGTH]: "Minimum {{value}} characters",
  [FIELD_MAX_LENGTH]: "Maximum {{value}} characters",
  [FIELD_MAX_LENGTH_SHORT]: "Maximum {{value}} characters",
  [FIELD_FILE_VALID_REQUIRED]:
    "You must select a file in one of these formats: {{value}}",
  [FIELD_FILE_MAX_SIZE]:
    "The file is too large, please select one with a size smaller than {{value}}{{type}}",
  [FIELD_MEDIA_FILE_MIN_DIMENSIONS]:
    "The selected content is low resolution, please select a content at least {{width}}px wide and {{height}}px high",
  [FIELD_IMAGE_REQUIRED]: "You must select a valid image format",
  [FIELD_IMAGE_FORMAT_VALID]:
    "The image is too large, please select one with a size smaller than {{value}}{{type}}",
  [FIELD_IMAGE_SIZE_VALID]: "No image has been selected",
  [FIELD_FILE_REQUIRED]:
    "The file is too large, please select one with a size smaller than {{value}}{{type}}",
  [FIELD_FILE_SIZE_VALID]: "No file has been selected",
  [FIELD_URL_VALID]: "The URL must be valid",
  [FIELD_URL_ADLE_APP_DOMAIN]: "The link must belong to app.adle.ai",
  [FIELD_URL_VALID_WITH_PROTOCOL]:
    "The URL must be valid and contain a protocol (https:// or http://)",
  [FIELD_URL_HTTPS_VALID]: "The URL must include https://",
  [FIELD_URL_REPEATED]: "This URL has already been added",
  [FIELD_EMAIL_VALID]: "The email must be valid",
  [FIELD_EMAIL_REGISTERED]: "The email is already registered",
  [FIELD_SPACES_VALID]: "The field cannot contain spaces",
  [FIELD_PHONE_VALID]: "The phone must be valid",
  [FIELD_ALL_REQUIRED]: "All fields are required",
  [FIELD_BOTH_PASSWORD_REQUIRED]: "Both passwords are required",
  [FIELD_PASSWORDS_NO_MATCH]: "Passwords do not match",
  [FIELD_PASSWORD_MIN_LENGTH]: "Password must be at least 6 characters long",
  [FIELD_PASSWORD_CHANGE_MIN_LENGTH]:
    "If you're changing the password, it must be at least 6 characters long",
  [FIELD_PASSWORD_INSECURE]:
    "The password must be at least 6 characters, one uppercase letter, one lowercase letter, one number, and one special character",
  [FIELD_NUMBER_NEGATIVE]: "The number cannot be negative",
  [FIELD_IS_DYNAMIC_CREATIVE_ONLY_ONE_AD]:
    "With dynamic creatives only 1 ad is allowed in the ad group.",
  [FIELD_SCHEDULE_REQUIRED_WHEN_CAMPAIGN_BUDGET_OTHERS_HAVE]:
    "With a campaign budget, if any ad group has ad scheduling configured, all must have it configured. Please configure it for this group as well.",
  [FIELD_BID_GOAL_REQUIRED_WHEN_CAMPAIGN_BUDGET_OTHERS_HAVE]:
    "With a campaign budget, if any ad group has a bid goal set, all must have it. Please set it for this group as well.",
  [FIELD_EMAIL_REQUIRED]: "The email is required",
  [FIELD_SEARCH_CHATS_MORE_3_CHARACTERS]:
    "Type more than 3 characters to search for new chats",
  [FIELD_NUMBER_0_OR_NEGATIVE]: "The number cannot be 0 or negative",
  [FIELD_NUMBER_100_GREATER]: "The number cannot be greater than 100",
  [FIELD_NUMBER_LESS_THAN]: "The number cannot be less than {{value}}",
  [FIELD_NUMBER_GREATER_THAN]: "The number cannot be greater than {{value}}",
  [FIELD_CREDITS_NOT_BE_NEGATIVE]: `{{NAME_BUSINESS}} Credits cannot be negative`,
  [FIELD_COST_COLLABORATION_NOT_BE_NEGATIVE]:
    "Collaboration cost cannot be negative",
  [FIELD_TRIAL_MONTHS_NOT_BE_NEGATIVE]: "Trial months cannot be negative",
  [FIELD_TRIAL_DAYS_NOT_BE_NEGATIVE]: "Trial days cannot be negative",
  [FIELD_PLAN_PRICES_NOT_BE_NEGATIVE]: "Plan prices cannot be negative",
  [FIELD_STAFF_IS_REQUIRED]: "A staff must be selected",
  [FIELD_BOTH_DATES_REQUIRED]: "Both dates are required",
  [FIELD_START_DATE_GREATER_THAN_END_DATE]:
    "The start date cannot be greater than the end date",
  [FIELD_END_DATE_GREATER_NOW]:
    "The end date cannot be greater than the current date",
  [FIELD_START_DATE_LESS_THAN_NOW]:
    "The start date cannot be less than the current date",
  [FIELD_END_DATE_LESS_THAN_NOW]:
    "The end date cannot be less than the current date",
  [FIELD_DATE_IN_PAST]: "The date cannot be in the past",
  [FIELD_DATE_AT_LEAST_FIFTEEN_MINUTES_FUTURE]:
    "The date must be at least 15 minutes in the future",
  [FIELD_DATE_AT_LEAST_FIVE_MINUTES_FUTURE]:
    "The date must be at least 5 minutes in the future",
  [FIELD_MIN_AMOUNT_PAY]:
    "The amount to pay cannot be less than {{value,currency}}",
  [FIELD_ACCESS_TOKEN_SHOPIFY_VALID]:
    "Shopify's access token is not in the correct format, it usually starts with shpat_ followed by random characters",
  [FIELD_NAME_REQUIRED]: "Name is required",
  [FIELD_OBJECTIVE_REQUIRED]: "Objective is required",
  [FIELD_PLATFORMS_REQUIRED]: "Platforms are required",
  [FIELD_PLATFORM_REQUIRED]: "Platform is required",
  [FIELD_TYPE_BUDGET_REQUIRED]: "Budget type is required",
  [FIELD_BUDGET_REQUIRED]: "Budget is required",
  [FIELD_CURRENCY_MIN_VALUE]: "Value cannot be less than {{value,currency}}",
  [FIELD_LOCATIONS_REQUIRED]: "Locations are required",
  [FIELD_GENDERS_REQUIRED]: "Genders are required",
  [FIELD_INTERESTS_REQUIRED]: "Interests are required",
  [FIELD_BEHAVIORS_REQUIRED]: "Behaviors are required",
  [FIELD_DESCRIPTION_REQUIRED]: "Description is required",
  [FIELD_VIDEO_REQUIRED]: "Video is required",
  [FIELD_CREATIVE_MUST_BE_VIDEO_NOT_IMAGE]:
    "The creative must be a video, not an image",
  [FIELD_META_TRACKING_ID_REQUIRED]: "Meta pixel is required",
  [FIELD_DESTINATION_URL_REQUIRED]: "Destination URL is required",
  [FIELD_WEBSITE_URL_REQUIRED]: "Website URL is required",
  [FIELD_DESTINATION_URL_NOT_FOUND_IN_EVENTS_PIXEL_REQUIRED]:
    "Destination URL is not configured for the selected pixels",
  [FIELD_DESTINATION_URL_NOT_FOUND_IN_EVENTS_PIXEL]:
    "The destination URL is not configured with the selected pixel; if you continue, some statistics may not be recorded",
  [FIELD_TIKTOK_TRACKING_ID_REQUIRED]: "TikTok pixel is required",
  [FIELD_MIN_LENGTH_SELECT]: "You must select at least {{value}} options",
  [FIELD_MAX_LENGTH_SELECT]: "You must select a maximum of {{value}} options",
  [FIELD_CONTENT_REQUIRED]: "Content is required",
  [FIELD_START_AND_END_DATES_REQUIRED]: "Start and end dates are required",
  [FIELD_LANGUAGE_REQUIRED]: "Language is required",
  [FIELD_CALL_TO_ACTION_VALID_BY_OBJECTIVE]:
    "Select a valid call to action for the selected objective",
  [FIELD_TRACKING_IDS_REQUIRED]: "Pixels are required",
  [FIELD_AD_ACCOUNTS_REQUIRED]: "Ad accounts are required",
  [FIELD_CONTENT_IS_BEING_PROCESSED]: "Content is being processed",
  [FIELD_MIN_TOTAL_BUDGET_ONE_DOLLAR]:
    "The budget cannot be less than {{value,number}} {{currency}}",
  [FIELD_MIN_DAILY_BUDGET]:
    "The daily budget cannot be less than {{value,number}} {{currency}}",
  [FIELD_MIN_BUDGET]:
    "The budget cannot be less than {{value,number}} {{currency}}",
  [FIELD_URL_INSTAGRAM]: "The URL must be from Instagram",
  [FIELD_MIN_CONTENT]: "You must select at least {{value}} content",
  [FIELD_MAX_CONTENT]: "You must select a maximum of {{value}} content",
  [FIELD_TRAFFIC_URL_NOT_BE_LINK_FACEBOOK]:
    "The URL you want to drive traffic to cannot be a Facebook URL",
  [FIELD_TRAFFIC_URL_NOT_BE_LINK_INSTAGRAM]: `To drive traffic to Instagram, choose "Traffic" as campaign objective and "Instagram profile" as conversion location`,
  [FIELD_TRAFFIC_URL_NOT_BE_LINK_WHATSAPP]:
    "The URL you want to drive traffic to cannot be a WhatsApp URL",
  [FIELD_AD_FORMAT_REQUIRED_AD_PREVIEW]:
    "You must select a format to generate the ad preview",
  [FIELD_CALL_TO_ACTION_REQUIRED_AD_PREVIEW]:
    "You must select a Call to action to generate the ad preview",
  [FIELD_PAGE_ID_REQUIRED_AD_PREVIEW]:
    "You must select a Facebook page in the settings to generate the ad preview",
  [FIELD_SPONSOR_PAGE_ID_REQUIRED_AD_PREVIEW]:
    "You must select a sponsor Facebook page for the partnership ad to generate the ad preview",
  [FIELD_INSTAGRAM_ID_REQUIRED_AD_PREVIEW]:
    "You must select an Instagram account in the settings to generate the ad preview",
  [FIELD_APP_ID_REQUIRED_AD_PREVIEW]:
    "You must select an app in the ad group settings to generate the ad preview",
  [FIELD_IDENTITY_TIK_TOK_ID_REQUIRED_AD_PREVIEW]:
    "You must select a TikTok identity in the settings to generate the ad preview",
  [FIELD_POST_ID_REQUIRED_AD_PREVIEW]:
    "You must select a Facebook or Instagram post to generate the ad preview",
  [FIELD_ADDRESS_REQUIRED_AD_PREVIEW]:
    "You must select an address to generate the ad preview",
  [FIELD_MIN_CARDS_AD_CAROUSEL]:
    "You must create at least {{value}} cards to use a carousel ad.",
  [FIELD_TEXT_ONLY_HAS_LETTERS_NUMBERS_DOTS_COMMAS]:
    "The text can only contain letters, numbers, dots and commas",
  [FIELD_TEXT_REPEATED]: "The text cannot be repeated",
  [FIELD_IMAGES_REPEATED]: "Duplicate images are not allowed",
  [FIELD_VIDEOS_REPEATED]: "Duplicate videos are not allowed",
  [FIELD_KEYWORDS_REPEATED]: "There are repeated keywords: {{value}}",
  [FIELD_KEYWORDS_MAX_LENGTH]:
    "These keywords exceed the maximum of {{value}} characters: {{keywords}}",
  [FIELD_TWO_CARDS_REQUIRED_FOR_GENERATE_PREVIEW]:
    "You must create two cards to generate the ad preview",
  [FIELD_KEYWORDS_AND_KEYWORDS_NEGATIVE_REPEATED]:
    "There are repeated keywords between keywords and negative keywords: {{value}}",
  [FIELD_CAMPAIGN_MUST_HAVE_ONE_DAY_ACTIVE]:
    "The campaign must have at least one day active",
  [FIELD_THIS_KEYWORD_ALREADY_EXIST_IN_YOUR_LIST]:
    "This keyword already exists in your list",
  [FIELD_MEDIA_URL_REQUIRED_AD_PREVIEW]:
    "You must select a content for your ad",
  [FIELD_AD_PREVIEW_CONTENT_CHANGE_WARNING_DRAFT]:
    "Once the ad is created, you will not be able to change the content",
  [FIELD_AD_PREVIEW_CONTENT_CHANGE_WARNING_CREATED]:
    "To change the content, you must create a new ad",
  [META_AD_PREVIEW_AD_BLOCKER_NOTICE]:
    "If this preview looks wrong or does not load correctly, check whether an ad blocker is enabled and disable it for this page.",
  [FIELD_START_DATE_REQUIRED]: "The start date is required",
  [FIELD_VIDEO_YOUTUBE_URL_INVALID]:
    "The URL of a Youtube video must be in the format https://www.youtube.com/watch?v=XXXXXXXX or https://www.youtube.com/shorts/XXXXXXXX",
  [FIELD_MAX_IMAGES_VALID]: "You must select a maximum of {{value}} images",
  [FIELD_MAX_VIDEOS_YOUTUBE_VALID]:
    "You must enter a maximum of {{value}} videos",
  [FIELD_YOUTUBE_VIDEO_NOT_PUBLIC]: "This YouTube video is not public",
  [FIELD_YOUTUBE_VIDEO_DURATION_INVALID]:
    "This YouTube video does not meet the required duration",
  [FIELD_YOUTUBE_VIDEO_NOT_PUBLIC_AND_DURATION_INVALID]:
    "This YouTube video is not public and does not meet the required duration",
  [FIELD_MIN_TEXTS_VALID]: "You must enter at least {{value}} texts",
  [FIELD_MAX_TEXTS_VALID]: "You must enter a maximum of {{value}} texts",
  [FIELD_TITLES_REQUIRED_AD_PREVIEW]: "Empty titles are not allowed",
  [FIELD_TITLES_REQUIRED_AD_PREVIEW_TIKTOK]:
    "The title is required and must be between 1 and 100 characters.",
  [FIELD_HEADLINES_REQUIRED_AD_PREVIEW]: "Empty headlines are not allowed",
  [FIELD_DESCRIPTIONS_REQUIRED_AD_PREVIEW]:
    "Empty descriptions are not allowed",
  [FIELD_INSTANT_EXPERIENCE_REQUIRED_AD_PREVIEW]:
    "You must select an instant experience to generate the ad preview",
  [FIELD_PRODUCT_SET_ID_REQUIRED_AD_PREVIEW]:
    "You must select a product set to generate the ad preview",
  [FIELD_ALMOST_ONE_INCLUSION_OR_EXCLUSION]:
    "You must select at least one inclusion or exclusion",
  [FIELD_CONTENT_INTRO_CARD_IS_REQUIRED_AD_PREVIEW]:
    "You must select a content for the intro card to generate the ad preview",
  [FIELD_META_PLACEMENT_FACEBOOK_PROFILE_FEED_REQUIRED]:
    "Facebook profile feed requires Facebook Feed to be selected.",
  [FIELD_META_PLACEMENT_FACEBOOK_MARKETPLACE_REQUIRED]:
    "Facebook Marketplace requires Facebook Feed to be selected.",
  [FIELD_META_PLACEMENT_MESSENGER_INBOX_REQUIRED]:
    "Messenger inbox requires Facebook Feed to be selected.",
  [FIELD_META_PLACEMENT_FACEBOOK_NOTIFICATIONS_REQUIRED]:
    "Facebook Notifications requires Facebook Feed to be selected.",
  [FIELD_META_PLACEMENT_FACEBOOK_STORIES_REQUIRED]:
    "Facebook Stories requires Facebook Feed to be selected.",
  [FIELD_META_PLACEMENT_AUDIENCE_NETWORK_NATIVE_BANNER_INTERSTITIAL_REQUIRED]:
    "Audience Network native, banner and interstitial requires Facebook Feed to be selected.",
  [FIELD_META_PLACEMENT_AUDIENCE_NETWORK_REWARDED_VIDEOS_REQUIRED]:
    "Audience Network rewarded videos requires Facebook Feed to be selected.",
  [FIELD_META_PLACEMENT_ADS_ON_FACEBOOK_REELS_REQUIRED]:
    "Ads on Facebook Reels requires Facebook Feed to be selected.",
  [FIELD_META_PLACEMENT_FACEBOOK_INSTREAM_VIDEOS_REQUIRED]:
    "Facebook in-stream videos requires Facebook Feed to be selected.",
  [FIELD_META_PLACEMENT_FACEBOOK_SEARCH_RESULTS_REQUIRED]:
    "Facebook search results requires Facebook Feed to be selected.",
  [FIELD_META_PLACEMENT_INSTAGRAM_STORIES_REQUIRED]:
    "Facebook Stories requires Instagram Stories to be selected.",
  [FIELD_META_PLACEMENT_INSTAGRAM_PROFILE_FEED_REQUIRED]:
    "Instagram profile feed requires Instagram feed to be selected.",
  [FIELD_META_PLACEMENT_INSTAGRAM_SEARCH_RESULTS_REQUIRED]:
    "Instagram search results requires Instagram feed to be selected.",
  [FIELD_META_PLACEMENT_INSTAGRAM_EXPLORE_REQUIRED]:
    "Instagram Explore requires Instagram feed to be selected.",
  [FIELD_META_PLACEMENT_INSTAGRAM_EXPLORE_HOME_REQUIRED]:
    "Instagram Explore home requires both Instagram feed and Instagram Explore to be selected.",
  [FIELD_META_PLACEMENT_INSTAGRAM_PROFILE_REELS_REQUIRED]:
    "Instagram profile reels requires Instagram Reels to be selected.",
  [FIELD_DESTINATION_URL_REQUIRED_AD_PREVIEW]:
    "You must select a destination URL tos generate the ad preview",
  [FIELD_DESTINATION_URL_IN_YOUR_CAROUSEL_REQUIRED_AD_PREVIEW]:
    "You must select a destination URL in each card of your carousel to generate the ad preview",
  [FIELD_IMAGES_MIN_REQUIRED]: "You must select at least {{value}} images",
  [FIELD_ESTIMATION_ID_REQUIRED]:
    "You must wait for the estimation to be generated before reserving it",
  [FIELD_ESTIMATION_BUDGET_REQUIRED]:
    "You must enter a budget to generate the estimation",
  [FIELD_ESTIMATION_START_END_DATE_REQUIRED]:
    "You must select start and end dates to generate the estimation",
  [FIELD_ESTIMATION_FREQUENCY_REQUIRED]:
    "You must configure the frequency to generate the estimation",
  [FIELD_ESTIMATION_LOCATION_REQUIRED]:
    "You must select at least one location to generate the estimation",
  [FIELD_SEARCH_THEMES_MAX_WORDS]:
    "The following search themes have more than {{value}} words: {{items}}",
  [FIELD_MUSIC_URL_REQUIRED_AD_PREVIEW]: "You must select a music for your ad",
  [FIELD_CONSECUTIVE_UPPERCASE]:
    "{{value}} consecutive uppercase letters are not allowed",
  [FIELD_EMOJI_NOT_ALLOWED]: "Emojis are not allowed",

  [REQUEST_REJECT_CONFIRMATION_DESCRIPTION]:
    "Do you want to reject this content and close the report?",
  [REQUEST_APPROVE_CONFIRMATION_DESCRIPTION]:
    "Do you want to approve this report and refund the credits to the brand?",
  [REQUEST_REJECTED]: "Request rejected",
  [REQUEST_REJECTED_DESCRIPTION]:
    "Content creator {{influencerName}}'s request was successfully rejected.",
  [REPORTED_CONTENT_STATUS_REJECTED]: "Rejected",
  [REPORTED_CONTENT_STATUS_PENDING]: "Pending",
  [REPORTED_CONTENT_STATUS_APPROVED]: "Approved",
  [LIST_OF_CREATORS]: "List of creators",

  /*MODAL COMMERCIAL*/
  [MODAL_COMMERCIAL_TITLE_CREATE]: "Create commercial",
  [MODAL_COMMERCIAL_TITLE_EDIT]: "Edit commercial {{value}}",
  [MODAL_COMMERCIAL_CREATE_COMMERCIAL]: "Create commercial",
  [MODAL_COMMERCIAL_ALREADY_EXIST]:
    "A commercial with this name already exists",

  /*MODAL CREATE PAYMENT LINK*/
  [MODAL_CREATE_PAYMENT_LINK_TITLE]: "Create payment link",
  [MODAL_CREATE_PAYMENT_LINK_DESCRIPTION]:
    "Create a payment link for this brand, this will create an enterprise subscription.",
  [MODAL_CREATE_PAYMENT_LINK_ARIA_LABEL]: "Create Payment Link Modal",
  [MODAL_CREATE_PAYMENT_LINK_LINKS]: "Payment Links",
  [MODAL_CREATE_PAYMENT_LINK_LINKS_EMPTY]: "No payment links available",
  [MODAL_CREATE_PAYMENT_LINK_NAME]: "Payment {{value}}",

  /*MODAL HELP VIDEO AND FAQ*/
  [WARNING_MOBILE_TUTORIAL]:
    "For a better experience, perform the tutorial from your computer or laptop",
  [FAQ_DESCRIPTION]:
    "Here you will find the most frequently asked questions from our users. You can search for them by keywords or phrases.",
  [FAQ_QUESTION_WHAT_IS_BUZZLY]: `What is {{NAME_BUSINESS}}?`,
  [FAQ_QUESTION_WHAT_IS_BUZZLY_DESCRIPTION]: `{{NAME_BUSINESS}} is the first platform that allows small businesses to offer free or discounted products to content creators in exchange for exposure on social media. At the same time, creators can access a wide variety of products and services directly from their favorite brands through our mobile app.`,
  [FAQ_QUESTION_WHAT_IS_REQUEST]: "What is a Request?",
  [FAQ_QUESTION_WHAT_IS_REQUEST_DESCRIPTION]:
    "A request is a petition made by a content creator for you to send them an invitation to collaborate with your brand.",
  [FAQ_QUESTION_WHAT_IS_PUBLICATION]: "What is a Post?",
  [FAQ_QUESTION_WHAT_IS_PUBLICATION_DESCRIPTION]: `A Post is the collaboration generated when a content creator redeems an invitation in your store. A Post can have the following states: <br><br>
  <strong>Pending Post:</strong> The content creator redeemed the invitation but has not yet posted anything on their social media.<br>
  <strong>Pending Analytics:</strong> The content creator has already posted your brand's content on their social media and uploaded it, but analytics are not available yet.<br>
  <strong>Review:</strong> The creator has uploaded the analytics, and you can now review the collaboration's results to give a rating to the creator.<br>
  <strong>Verified:</strong> You have rated the collaboration based on the content and analytics generated.<br>
  <strong>Feedback:</strong> The creator had some issues with your products or services, so no collaboration was generated. You can invite them again.<br>
  `,
  [FAQ_QUESTION_WHAT_IS_CAMPAIGN]: "What is a Campaign?",
  [FAQ_QUESTION_WHAT_IS_CAMPAIGN_DESCRIPTION]: `A campaign is a more structured form of collaboration with content creators, where you can allocate a budget, set goals, content types, and specific requirements for content creators to apply. Once they apply, you can accept or reject creators for your campaign.`,
  [FAQ_QUESTION_WHAT_IS_ORDER]: "What is an Order?",
  [FAQ_QUESTION_WHAT_IS_ORDER_DESCRIPTION]: `An order is a request for products or services made by a content creator to your brand via delivery. An order can have the following states: <br><br>
  <strong>To Be Accepted:</strong> The content creator has already requested the products or services, but you need to accept the order and assign a processing time.<br>
  <strong>In Progress:</strong> You have accepted the order and are processing the products or services to send them to the content creator when ready, assigning shipping information.<br>
  <strong>To Be Delivered:</strong> You have already sent the products or services to the content creator, and only the delivery remains to be completed.<br>
  `,
  [FAQ_QUESTION_WHAT_IS_STORE]: "What is a Store?",
  [FAQ_QUESTION_WHAT_IS_STORE_DESCRIPTION]:
    "A store is a physical branch where content creators can redeem the invitations you send them to obtain products or services from your brand and generate content from your premises.",
  [FAQ_QUESTION_WHAT_ROLES_EXISTS]: "What Roles Exist?",
  [FAQ_QUESTION_WHAT_ROLES_EXISTS_DESCRIPTION]: `You can create different users to access your brand panel, and there are two roles: <br><br>
  <strong>Administrator:</strong> The administrator can manage invitations to content creators, requests, ambassadors, orders, campaigns, etc. They can also modify your brand information and create more users.<br>
  <strong>Operator:</strong> The operator is responsible for receiving the creator if they will visit one of your stores. They can redeem the code, manage orders in all three states, and view the menu.<br>
  `,
  [FAQ_QUESTION_ADDITIONAL_ACTIONS_DELIVERED_PRODUCTS]:
    "Do I need to do anything additional on the platform after delivering the products?",
  [FAQ_QUESTION_ADDITIONAL_ACTIONS_DELIVERED_PRODUCTS_DESCRIPTION]: `You don't need to do anything additional. Simply enter the code in the "Redeem Code" section, verify the invitation's value, and deliver the products.<br><br>
  
<strong>1.</strong> Select the store at the top right.<br>
<strong>2.</strong> Enter the code provided by the content creator when they arrive at the store.<br>
<strong>3.</strong> Validate the code and its respective value.`,
  [FAQ_QUESTION_MUST_CALL_ADMIN]:
    "Do I need to call the business owner to verify the invitations?",
  [FAQ_QUESTION_MUST_CALL_ADMIN_DESCRIPTION]:
    "You don't need to call. If the platform accepts the code when you enter it, it means that the business owner, your direct manager, or the administrator has already sent an invitation to that content creator, and they are approved by that person.",
  [FAQ_QUESTION_CREATOR_REDEEM_CODE_WITH_MINOR_VALUE]:
    "What happens if the content creator redeems the code and does not use the entire value of the invitation?",
  [FAQ_QUESTION_CREATOR_REDEEM_CODE_WITH_MINOR_VALUE_DESCRIPTION]:
    "Once the code is redeemed, it expires automatically. This means the code won't work for any subsequent occasions.",
  [FAQ_QUESTION_DIFFERENCE_BETWEEN_EXCHANGES_AND_CAMPAIGNS]:
    "What are the differences between the exchange mode and paid campaigns?",
  [FAQ_QUESTION_DIFFERENCE_BETWEEN_EXCHANGES_AND_CAMPAIGNS_DESCRIPTION]: `The main difference is that in the <strong>exchange mode</strong>, content creators have more freedom to choose how to create the content, generating a more organic and natural collaboration. In contrast, in <strong>paid campaigns</strong>, brands can establish stricter rules on how the content should be created, and the creator must follow those guidelines for the content to be approved.`,
  [FAQ_QUESTION_ENSURE_CREATORS_UNDERSTAND_ACCEPT_EXCHANGE_TERMS]:
    "How can I ensure creators understand and accept the exchange terms?",
  [FAQ_QUESTION_ENSURE_CREATORS_UNDERSTAND_ACCEPT_EXCHANGE_TERMS_DESCRIPTION]: `To ensure that content creators understand and accept the exchange terms, you can do the following:<br><br>
    <strong>1.</strong> Review the creator's profile and metrics to see if the content they generally create aligns with what you are looking for.<br>
    <strong>2.</strong> The invitation comment should be clear and easy to understand.<br>
    <strong>3.</strong> Once you send the invitation, you can message the content creator to establish more direct communication and clarify any doubts they may have regarding creating the content.<br>
    `,

  /*MODAL BRAND SETUP*/
  [MODAL_BRAND_SETUP_TITLE]:
    "Do you want to reconfigure and update your brand information?",
  [MODAL_BRAND_SETUP_DESCRIPTION]:
    "The following users will be affected by this change:",
  [BRAND_SETUP_EXTRACTION_WARNING_MESSAGE]:
    "We couldn't extract some data. This happens because some websites use mechanisms that block automated access to information, so you'll need to enter the information manually.",
  [BRAND_SETUP_LOADING_GETTING_WEBSITE_INFORMATION]:
    "Scanning your website to understand your brand...",
  [BRAND_SETUP_LOADING_ANALYZING_BRAND]:
    "Analyzing your tone, value proposition and key brand elements...",
  [BRAND_SETUP_LOADING_GENERATING_BRAND_PROFILE]:
    "Building your brand profile...",
  [BRAND_SETUP_LOADING_FINALIZING_DETAILS]:
    "Organizing everything to finalize your Brand Setup...",
  [BRAND_SETUP_GENERATION_PROMPT_LABEL]: "Focus or extra context (optional)",
  [BRAND_SETUP_GENERATION_PROMPT_PLACEHOLDER]:
    "Example: focus on the 14-day trial, speak to shop owners, and avoid discount claims",
  [BRAND_SETUP_GENERATION_ATTACH_PDF]: "Attach a PDF",
  [BRAND_SETUP_GENERATION_PDF_HINT]:
    "Optional. One PDF, up to 20 MB. It is analyzed together with your website and notes.",
  [BRAND_SETUP_GENERATION_REMOVE_PDF]: "Remove {{name}}",
  [BRAND_SETUP_GENERATION_PDF_INVALID]: "Use a PDF file.",
  [BRAND_SETUP_GENERATION_PDF_TOO_LARGE]:
    "The PDF must be {{maxMb}} MB or smaller.",
  [BRAND_SETUP_GENERATION_SHOW_ADVANCED]: "Add a PDF or extra context",
  [BRAND_SETUP_GENERATION_HIDE_ADVANCED]: "Hide PDF and extra context",
  [BRAND_SETUP_VERSION_CURRENT]: "Current",
  [BRAND_SETUP_VERSION_LABEL]:
    "V{{versionNumber}} - {{date, MM/dd/yyyy HH:mm}}",
  [BRAND_SETUP_VERSION_PLACEHOLDER]: "Version",
  [BRAND_SETUP_GROUP_VISUAL_IDENTITY_TITLE]: "Visual Identity",
  [BRAND_SETUP_GROUP_VISUAL_IDENTITY_DESCRIPTION]:
    "Everything that defines how your brand looks",
  [BRAND_SETUP_GROUP_AUDIENCE_TITLE]: "Audience and Competitors",
  [BRAND_SETUP_GROUP_AUDIENCE_DESCRIPTION]:
    "Who you speak to and in what context",
  [BRAND_SETUP_GROUP_COPY_TITLE]: "Brand Message",
  [BRAND_SETUP_GROUP_COPY_DESCRIPTION]:
    "How your brand communicates and what it offers",
  [BRAND_INSIGHTS_TAB_TITLE]: "Insights",
  [BRAND_INSIGHTS_PAGE_TITLE]: "Insights",
  [BRAND_INSIGHTS_PAGE_DESCRIPTION]:
    "Discover the learnings AI identified from your campaign results. Apply them to your brand setup.",
  [BRAND_INSIGHTS_POSITIVE_TITLE]: "Repeat",
  [BRAND_INSIGHTS_NEGATIVE_TITLE]: "Avoid",
  [BRAND_INSIGHTS_POSITIVE_SUBTITLE]:
    "Strategies that are already working. Do more of this.",
  [BRAND_INSIGHTS_NEGATIVE_SUBTITLE]:
    "Strategies that are not working. Avoid repeating them.",
  [BRAND_INSIGHTS_TOPIC_ANGLE]: "Angle",
  [BRAND_INSIGHTS_TOPIC_COPY]: "Copy",
  [BRAND_INSIGHTS_TOPIC_CTA]: "CTA",
  [BRAND_INSIGHTS_TOPIC_TONE]: "Tone",
  [BRAND_INSIGHTS_TOPIC_AESTHETIC]: "Aesthetic",
  [BRAND_INSIGHTS_TOPIC_VALUE_PROP]: "Value prop",
  [BRAND_INSIGHTS_EMPTY]: "There are no learnings for your brand yet",
  [BRAND_INSIGHTS_REVIEW_CHANGE]: "Review",
  [BRAND_INSIGHTS_DISMISS]: "Dismiss",
  [BRAND_INSIGHTS_DISMISS_ALERT_TITLE]: "Are you sure?",
  [BRAND_INSIGHTS_DISMISS_ALERT_DESCRIPTION]:
    "This learning will be dismissed and you will not be able to recover it.",
  [BRAND_INSIGHTS_COUNT]: "{{count}} learnings",
  [BRAND_INSIGHTS_UNREAD_ONE]: "1 New",
  [BRAND_INSIGHTS_UNREAD_OTHER]: "{{count}} News",
  [BRAND_INSIGHTS_APPLY_TITLE]: "Apply Change",
  [BRAND_INSIGHTS_APPLY_LOADING]:
    "AI is proposing a change to your brand setup.",
  [BRAND_INSIGHTS_APPLY_CONFIRM]: "Apply",
  [BRAND_INSIGHTS_APPLY_CANCEL]: "Cancel",
  [BRAND_INSIGHTS_APPLY_REJECTED]:
    "Could not propose a safe change to brand setup.",
  [BRAND_INSIGHTS_APPLY_ALREADY_IN_CONFIG]:
    "This insight is already reflected in your brand setup.",
  [BRAND_INSIGHTS_APPLY_UNMAPPABLE]:
    "This insight does not fit any field in your brand setup, as it is operational or related to campaign management.",
  [BRAND_INSIGHTS_APPLY_REWRITE]:
    "We could not generate a proposal. Please try again.",
  [BRAND_INSIGHTS_APPLY_RETRY]:
    "We could not generate a proposal. Please try again.",
  [BRAND_INSIGHTS_APPLY_TIMEOUT]:
    "The proposal is taking longer than usual. Please try again in a few minutes.",
  [BRAND_INSIGHTS_APPLY_FIELD]: "Field",
  [BRAND_INSIGHTS_APPLY_RESULT_TITLE]: "How the field ends up",
  [BRAND_INSIGHTS_APPLY_SHOW_FULL]: "Show full text",
  [BRAND_INSIGHTS_APPLY_SHOW_CHANGES]: "Show only changes",
  [BRAND_INSIGHTS_APPLY_NO_CHANGES]:
    "The proposal does not change the current field.",
  [BRAND_INSIGHTS_APPLY_DIFF_COLLAPSED]: "[…{{count}} unchanged words…]",

  [LIST_CREATORS_WITH_AUDIENCE_SIMILAR]:
    "List of creators with similar audiences",
  [AUDIENCE_INFORMATION]: "Audience information",
  [AUDIENCE_CREDIBILITY]: "Audience credibility",
  [AUDIENCE_CREDIBILITY_TITLE_EXPLANATION]: "What is audience credibility?",
  [AUDIENCE_CREDIBILITY_DESCRIPTION_EXPLANATION]:
    "Audience credibility is an indicator that determines the percentage of followers who are real or valid profiles, i.e., bots or fraudulent profiles are excluded. The higher the percentage, the more reliable is the audience of the content creator",
  [AUDIENCE_BY_COUNTRY]: "Audience by country",
  [AUDIENCE_BY_CITIES]: "Audience by cities",
  [AUDIENCE_BY_BRAND_AFFINITY]: "Brand affinity",
  [AUDIENCE_BY_INTERESTS]: "Interests",
  [AUDIENCE_BY_DISTRIBUTION_AGE]: "Age and gender distribution",
  [AUDIENCE_BY_PERCENTAGE_GENDERS]: "Genders percentage",
  [AUDIENCE_BY_SIMILAR_AUDIENCE]: "Similar profiles",
  [AUDIENCE_BY_SIMILAR_AUDIENCE_NOT_FOUND]: "No similar profiles found",
  [GALLERY_CONTENT_BUZZLY]: `Portfolio`,

  /* LIST MENU */
  [MENU_CONNECTED_ACCOUNTS]: "Connected accounts",
  [MENU_PLATFORM]: "Exchange",
  [MENU_MEDIA]: "Media",
  [MENU_SERVICES]: "Tools",
  [MENU_ACTIONS]: "Operations",
  [MENU_CONFIGURATION]: "Settings",
  [MENU_ADMINISTRATION]: "Administration",
  [SUB_MENU_CREATORS]: "Creators",
  [SUB_MENU_PUBLICATIONS]: "Collabs",
  [SUB_MENU_EVENTS]: "Events",
  [SUB_MENU_CAMPAIGNS]: "Campaigns",
  [SUB_MENU_ADS_CAMPAIGNS]: "{{NAME_BUSINESS}} Ads",
  [SUB_MENU_REPORTS]: "Reports",
  [SUB_MENU_DISCOVERY]: "Discovery",
  [SUB_MENU_SOCIAL_FEED]: "Social feed",
  [SUB_MENU_GALLERY]: "Gallery",
  [SUB_MENU_REDEEM_CODE]: "Redeem code",
  [SUB_MENU_ORDERS]: "Orders",
  [SUB_MENU_ACCOUNT]: "Account",
  [SUB_MENU_STORES]: "My stores",
  [SUB_MENU_MENU]: "Catalog",
  [SUB_MENU_USERS]: "Users",
  [SUB_MENU_BILLING_AND_PAYMENTS]: "Billing",
  [SUB_MENU_BILLING_DASHBOARD]: "Payments",
  [SUB_MENU_BILLING_DATA]: "Information",
  [SUB_MENU_USERS_OWNER]: "Users",
  [SUB_MENU_BRANDS]: "Brands",
  [SUB_MENU_BRAND_SIGNUPS]: "Brand signups",
  [SUB_MENU_CREATORS_OWNER]: "Creators",
  [SUB_MENU_CREATORS_EXTERNALS]: "External creators",
  [SUB_MENU_PAY_CREATORS]: "Pay creators",
  [SUB_MENU_CREATOR_SIGNUPS]: "Creator signups",
  [SUB_MENU_CONTENTS]: "Content",
  [SUB_MENU_DELIVERIES]: "Deliveries",
  [SUB_MENU_CONTENT_APPLICATION]: "Content application",
  [SUB_MENU_REPORTS_OWNER]: "Reports",
  [SUB_MENU_FEEDBACK]: "Feedback",
  [SUB_MENU_PAYMENTS_FAILED]: "Failed payments",

  /* DATE */
  [MONTH_SHORT]: "{{date,monthTextShort}}",
  [DATE_DAY_AND_MONTH_SHORT]: "{{date, day}} {{date,monthTextShort}}",
  [DATE_HOUR]: "{{date, hour}}",
  [DATE_SHORT]: "{{date, monthText}} {{date, day}}, {{date, year}}",
  [DATE_SHORT_2]: "{{date,monthTextShort}} {{date,dayShort}}, {{date,year}}",
  [DATE_RELATIVE]: "{{date, relative}}",
  [DATE_SHORT_LOCALIZED]: "{{date, short}}",
  [DATE_LONG]: "{{date, day}}/{{date,month}}/{{date,year}} {{date,hour}}",
  [DATE_LONG_TEXT]:
    "{{date,dayText}}, {{date,monthText}} {{date, day}}, {{date,year}}",
  [DATE_LONG_TEXT_2]:
    "{{date,dayTextLong}}, {{date,monthText}} {{date, day}}, {{date,year}}",
  [DATE_LONG_TEXT_WITH_HOUR]:
    "{{date,dayText}}, {{date,monthText}} {{date, day}}, {{date,year}} {{date,hour}}",
  [DATE_LONG_LOCALIZED]: "{{date, long}}",
  [DATE_DISTANCE]: "{{date, ago}}",
  [RENEWED_ON]: "Renewed on: {{date,short}}",
  [EXPIRE_ON]: "Expire on: {{date,short}}",
  [LAST_UPDATE_DATE]: "Last update: {{date, relative}}",
  [LAST_UPDATE_DATE_SHORT]:
    "Updated at {{date,monthTextShort}} {{date,dayShort}}, {{date,year}}",
  [PUBLISHED_DATE]: "Published: {{date, short}}",

  /* CURRENCY */
  [VALUE_WITH_CURRENCY]: "{{value,number}} {{currency}}",
  [VALUE_WITH_PERCENTAGE]: "{{value, number}}%",
  [NUMBER_CURRENCY]: "{{value, currency}}",
  [VALUE_SUBSCRIPTION_3_DAYS_FREE]: "3 days free",
  [VALUE_SUBSCRIPTION_MONTHLY]: "{{value,number}} {{currency}}/mo",
  [VALUE_SUBSCRIPTION_YEARLY_UNIQUE_PAYMENT]:
    "Annual one-time payment of {{value,number}} {{currency}}",
  [VALUE_SUBSCRIPTION_PRORATED]: "{{value,currency}} USD now",
  [VALUE_SUBSCRIPTION_AFTER_PRORATED]:
    "{{value,currency}} USD from {{date,short}}",
  [VALUE_EXPRESSED_IN]: "Value expressed in {{currency}}",
  [VALUE_NUMBER]: "{{value,number}}",
  [VALUE_WITH_CURRENCY_MANUAL_FORMAT]: "${{value,number}} {{currency}}",

  /* Buttons */
  [BUTTON_RETRY]: "Retry",
  [BUTTON_RETRY_PUBLISHING]: "Retry Publishing",
  [BUTTON_INVITE]: "Invite",
  [BUTTON_VIEW_INVITE]: "View invitation",
  [BUTTON_EDIT_INVITE]: "Edit invitation",
  [BUTTON_CANCEL_INVITE]: "Cancel invite",
  [BUTTON_VIEW_REQUEST]: "View request",
  [BUTTON_START_NOW]: "Start now",
  [BUTTON_REJECT_REQUEST]: "Reject request",
  [BUTTON_ORDER_IN_PROCESS]: "Order in process",
  [BUTTON_VIEW_COLLABORATION]: "View collaboration",
  [BUTTON_VIEW_METRICS]: "View metrics",
  [BUTTON_VIEW_REPORT]: "View report",
  [BUTTON_INIT_CHAT]: "Send message",
  [BUTTON_ADD_REFERENCE_PROFILE]: "Add reference profile",
  [BUTTON_USE_AS_REFERENCE_PROFILE]: "Use as reference profile",
  [BUTTON_ADD_AS_REFERENCE]: "Add as reference",
  [BUTTON_ADDED]: "Added",
  [BUTTON_DOWNLOAD]: "Download",
  [BUTTON_DOWNLOAD_PDF]: "Download PDF",
  [BUTTON_CALCULATE]: "Calculate",
  [BUTTON_ENTERPRISE_CALCULATE]: "Calculate enterprise",
  [BUTTON_REDEEM_CODE]: "Redeem",
  [BUTTON_ADD_STORE]: "Add store",
  [BUTTON_SEARCH]: "Search",
  [BUTTON_ACCEPT_ORDER]: "Accept order",
  [BUTTON_REJECT_ORDER]: "Reject order",
  [BUTTON_READY_ORDER]: "Order ready",
  [BUTTON_DELIVER_ORDER]: "Deliver order",
  [BUTTON_CANCEL]: "Cancel",
  [BUTTON_DISCARD]: "Discard",
  [BUTTON_VIEW]: "Review",
  [BUTTON_CREATE_CAMPAIGN]: "Create",
  [BUTTON_CREATE_CAMPAIGN2]: "Create Campaign",
  [BUTTON_LAUNCH_AD]: "Launch Ad",
  [BUTTON_CREATE_CONTENT]: "Create Content",
  [BUTTON_SAVE_PROGRESS]: "Save progress",
  [BUTTON_NEXT]: "Next",
  [BUTTON_PREVIOUS]: "Previous",
  [BUTTON_ADVANCED_CONFIGURATION]: "Advanced configuration",
  [BUTTON_FINISH]: "Finish",
  [BUTTON_URL]: "URL",
  [BUTTON_UPLOAD]: "Upload",
  [BUTTON_UPLOAD_FILES]: "Upload Files",
  [BUTTON_UPLOAD_FOLDER]: "Upload Folder",
  [BUTTON_UPLOAD_CONTENT]: "Upload content",
  [BUTTON_UPLOAD_DOCUMENT]: "Upload document",
  [BUTTON_REMOVE_CONTENT]: "Remove content",
  [DELETE_CONTENT_CONFIRMATION_TITLE]: "Delete Content",
  [DELETE_CONTENT_CONFIRMATION_DESCRIPTION]:
    "Are you sure you want to delete this content? This action is permanent and cannot be undone.",
  [DELETE_SCHEDULED_CONTENT_CONFIRMATION_TITLE]: "Delete Content Scheduled",
  [DELETE_SCHEDULED_CONTENT_CONFIRMATION_DESCRIPTION]:
    "Are you sure you want to delete this content scheduled? If you continue, it will be removed from the calendar and will no longer be published.",
  [DELETE_SCHEDULED_CONTENT_ERROR_DESCRIPTION]:
    "We couldn't delete this scheduled content. Please try again.",
  [DELETE_SCHEDULED_CONTENT_SUCCESS]:
    "Scheduled publication deleted successfully",
  [DELETE_MULTIPLE_CONTENT_CONFIRMATION_TITLE]: "Delete selected contents",
  [DELETE_MULTIPLE_CONTENT_CONFIRMATION_DESCRIPTION]:
    "Are you sure you want to delete {{count}} selected contents? This action is permanent and cannot be undone.",
  [BUTTON_DELETE_CONTENT]: "Delete",
  [BUTTON_FINISHED_CAMPAIGN]: "Finish campaign",
  [BUTTON_SAVE_CAMPAIGN]: "Save campaign",
  [BUTTON_DEACTIVATE_CAMPAIGN]: "Deactivate campaign",
  [BUTTON_ACTIVATE_CAMPAIGN]: "Activate campaign",
  [BUTTON_SEND_INVITE]: "Send invite",
  [BUTTON_REJECT]: "Reject",
  [BUTTON_ACCEPT]: "Accept",
  [BUTTON_ACCEPT_AND_PAY]: "Pay now",
  [BUTTON_ASSIGN_INVITE]: "Assign invitation",
  [BUTTON_REVIEW_CONTENT]: "Review content",
  [BUTTON_VIEW_PRELIMINARY_CONTENT]: "Review",
  [BUTTON_VIEW_APPLICANT]: "View applicant",
  [BUTTON_REVIEW]: "Rate",
  [BUTTON_ACCEPT_CONTENT]: "Accept content",
  [BUTTON_REJECT_CONTENT]: "Reject & No Refund",
  [BUTTON_SEND_REVIEW]: "Send review",
  [BUTTON_CONTINUE]: "Continue",
  [BUTTON_SIGN_UP]: "Sign up",
  [BUTTON_CONTINUOUS]: "Continuous",
  [BUTTON_CONTINUE_WITHOUT_CHANGES]: "Continue without Changes",
  [BUTTON_RESIZE_AND_CONTINUE]: "Resize and Post",
  [BUTTON_UNDERSTOOD]: "Understood",
  [BUTTON_MORE_QUESTIONS]: "I have more questions",
  [BUTTON_INIT_TUTORIAL]: "Start tutorial",
  [BUTTON_PAYMENTS]: "Payments",
  [BUTTON_BROADCAST]: "Broadcast",
  [BUTTON_SAVE]: "Save",
  [BUTTON_SEND_MESSAGE]: "Chat now",
  [BUTTON_UPLOAD_FILE]: "Upload file",
  [BUTTON_REMOVE_FILE]: "Remove file",
  [BUTTON_VERIFY_PUBLICATION]: "Verify post",
  [BUTTON_SEE_PUBLICATION_ON]: "See on {{value}}",
  [BUTTON_METRICS_READY]: "Metrics ready",
  [BUTTON_UPLOAD_TIKTOK]: "Upload on TikTok",
  [BUTTON_VIEW_PROFILE]: "View profile",
  [BUTTON_GENERATE_DESCRIPTION]: "Generate description",
  [BUTTON_GENERATE_COMMENT]: "Generate comment",
  [BUTTON_UPLOAD_IMAGE]: "Upload image",
  [BUTTON_REMOVE_IMAGE]: "Remove image",
  [BUTTON_SAVE_CHANGES]: "Save changes",
  [BUTTON_UPLOAD_VIDEO]: "Upload video",
  [BUTTON_REMOVE_VIDEO]: "Remove video",
  [BUTTON_DISCONNECT]: "Disconnect",
  [BUTTON_CONNECT_TIKTOK]: "Connect TikTok",
  [BUTTON_CONNECT_TIKTOK_BUSINESS]: "Connect TikTok Business",
  [BUTTON_BE_ECOMMERCE]: "Always open",
  [BUTTON_NOT_BE_ECOMMERCE]: "Edit schedules",
  [BUTTON_ADD_TURN]: "Add schedule",
  [BUTTON_DELETE]: "Delete",
  [BUTTON_ARCHIVE_CAMPAIGN]: "Archive",
  [BUTTON_CREATE]: "Create",
  [BUTTON_CONNECT_WOOCOMMERCE]: "Connect WooCommerce",
  [BUTTON_CREATE_USER]: "Create user",
  [BUTTON_CREATE_ACCOUNT]: "Create Account",
  [MODAL_CREATE_ACCOUNT_TITLE]: "What's your email?",
  [MODAL_CREATE_ACCOUNT_DESCRIPTION]:
    "Link your account with an email and password to maintain your access.",
  [BUTTON_CREATE_CONTACT]: "Create contact",
  [BUTTON_VIEW_DETAILS]: "View details",
  [BUTTON_DOWNLOAD_INVOICE]: "Download invoice",
  [BUTTON_CLOSE]: "Close",
  [BUTTON_UPLOAD_CATALOG]: "Upload catalog",
  [BUTTON_COPY_CATALOG]: "Copy catalog",
  [BUTTON_DOWNLOAD_FORMAT]: "Download format",
  [BUTTON_DUPLICATE]: "Duplicate",
  [BUTTON_DUPLICATE_IN_SAME_GROUP]: "In the same group",
  [BUTTON_DUPLICATE_IN_OTHER_AD_GROUP]:
    "Another campaign or group in this or another campaign",
  [DUPLICATE_AD_OTHER_GROUP_MODAL_TITLE]: "Duplicate your Ad",
  [DUPLICATE_AD_OTHER_GROUP_MODAL_DESCRIPTION]:
    "Select the target campaign and ad group where the ad will be duplicated.",
  [DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_CHANGE_WARNING]:
    "Duplicating this ad into another campaign will take you out of the current campaign. Any unpublished or unsaved changes in the current campaign will be lost.",
  [DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_LABEL]: "Campaign",
  [DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_PLACEHOLDER]: "Select a campaign",
  [DUPLICATE_AD_OTHER_GROUP_AD_GROUP_LABEL]: "Ad group",
  [DUPLICATE_AD_OTHER_GROUP_AD_GROUP_PLACEHOLDER]: "Select an ad group",
  [DUPLICATE_AD_OTHER_GROUP_EMPTY_AD_GROUPS]:
    "No ad groups available for this campaign",
  [BUTTON_DUPLICATE_IN_SAME_CAMPAIGN]: "In the same campaign",
  [BUTTON_DUPLICATE_IN_OTHER_CAMPAIGN]: "In another campaign",
  [DUPLICATE_AD_GROUP_MODAL_TITLE]: "Duplicate Your Ad Group",
  [DUPLICATE_AD_GROUP_MODAL_DESCRIPTION]:
    "Select the target campaign where the ad group will be duplicated.",
  [DUPLICATE_AD_GROUP_CAMPAIGN_CHANGE_WARNING]:
    "Duplicating this ad group into another campaign will take you out of the current campaign. Any unpublished or unsaved changes in the current campaign will be lost.",
  [DUPLICATE_AD_GROUP_CAMPAIGN_TYPE_MISMATCH]:
    "The selected campaign does not share the same objective or campaign type. Select a campaign with the same objective or type.",
  [DUPLICATE_CAMPAIGN_AD_FORMAT_MISMATCH]:
    "The selected campaign does not share the same ad format. Select a campaign with the same format.",
  [DUPLICATE_ASSETS_GROUP_MODAL_TITLE]: "Duplicate Your Assets Group",
  [DUPLICATE_ASSETS_GROUP_MODAL_DESCRIPTION]:
    "Select the target campaign where the assets group will be duplicated.",
  [DUPLICATE_ASSETS_GROUP_CAMPAIGN_CHANGE_WARNING]:
    "Duplicating this assets group into another campaign will take you out of the current campaign. Any unpublished or unsaved changes in the current campaign will be lost.",
  [BUTTON_EDIT]: "Edit",
  [BUTTON_MOVE_OTHER_CATEGORY]: "Move to other category",
  [BUTTON_COPY]: "Copy",
  [BUTTON_REGISTER]: "Register",
  [BUTTON_NO_HAVE_DOCUMENT]: "I don't have this document",
  [BUTTON_UPLOAD_AFTER]: "Upload later",
  [BUTTON_INVITED]: "Invited",
  [BUTTON_YES_I_SURE]: "Yes, I'm sure",
  [BUTTON_SEND_REVISION]: "Send revision",
  [BUTTON_APPROVE_CONTENT]: "Refund Credits",
  [BUTTON_UPLOAD_INSTAGRAM]: "Upload on Instagram",
  [BUTTON_CONNECT_INSTAGRAM]: "Connect Instagram",
  [BUTTON_RELOAD_PAGE]: "Reload page",
  [BUTTON_REPLACE_IMAGE]: "Replace image",
  [BUTTON_GENERATE_CONTENT]: "Generate content",
  [BUTTON_REGENERATE_CONTENT]: "Regenerate content",
  [BUTTON_REGENERATE_TEXT]: "Regenerate texts",
  [BUTTON_UPLOAD_LOGO]: "Upload Logo",
  [BUTTON_REPLACE_LOGO]: "Replace logo",
  [BUTTON_UPLOAD_BACKGROUND]: "Upload background",
  [BUTTON_REPLACE_BACKGROUND]: "Replace background",
  [BUTTON_REMOVE_BACKGROUND]: "Remove background",
  [BUTTON_GENERATE_OTHER]: "Regenerate",
  [BUTTON_SUBSCRIBE_NOW]: "Subscribe",
  [BUTTON_ADD_USER]: "Add user",
  [BUTTON_ADD_SHOP]: "Add shop",
  [BUTTON_DOWNLOAD_REPORT]: "Download report",
  [BUTTON_PASS_TO_SUBSCRIPTION_BASIC]: "Switch to basic subscription",
  [BUTTON_EXTEND]: "Extend",
  [BUTTON_ARCHIVE]: "Archive",
  [BUTTON_UNARCHIVE]: "Unarchive",
  [BUTTON_CREATE_TRANSACTION]: "Create transaction",
  [BUTTON_UPDATE_STATISTICS]: "Update statistics",
  [BUTTON_SEND_PAYMENT]: "Send payment",
  [BUTTON_CREATOR_CHAT]: "Creator Chat",
  [BUTTON_SEND_FILE]: "Send file",
  [BUTTON_SEE_MORE]: "See more",
  [BUTTON_SEE_LESS]: "See less",
  [BUTTON_SEND]: "Send",
  [BUTTON_YOU_HAVE_DOUBTS]: "Questions? Contact Us",
  [BUTTON_WATCH_DEMO]: "Watch Demo",
  [BUTTON_SAVE_CONTENT]: "Save Content",
  [BUTTON_SEND_BROADCAST]: "Send broadcast",
  [BUTTON_ADD_CONTENT]: "Add Content",
  [BUTTON_ADD_SELECTED_CONTENT]: "Add Content",
  [BUTTON_SEE_ALL_APPLICANTS]: "See all applicants",
  [BUTTON_GO_BACK]: "Go back",
  [BUTTON_CLEAR_FILTERS]: "Clear filters",
  [BUTTON_TIKTOK_BILLING]: "TikTok billing",
  [BUTTON_META_BILLING]: "Meta billing",
  [BUTTON_REPLACE_CONTENT]: "Replace",
  [BUTTON_CHANGE_CONTENT]: "Change Content",
  [BUTTON_EDIT_CONTENT]: "Edit",
  [BUTTON_CHANGE_SLIDE]: "Change Slide",
  [PLATFORM_ONLY_ACCEPTS_VIDEOS]: "{{platform}} only accepts videos",
  [BUTTON_SELECT_VIDEO]: "Select Video",
  [BUTTON_REPLACE_VIDEO]: "Replace Video",
  [BUTTON_SELECT_THIS_CONTENT]: "Select this Content",
  [BUTTON_REMOVE_SELECTION]: "Remove Selection",
  [BUTTON_RECHARGE_BALANCE]: "Recharge Balance",
  [BUTTON_CONNECT_SHOPIFY]: "Connect Shopify",
  [BUTTON_CONNECT_META]: "Connect Meta",
  [BUTTON_CONTACT_AN_ADVISOR]: "I need help",
  [BUTTON_GENERATE_SCRIPT]: "Generate Script",
  [BUTTON_VIEW_INVOICE]: "View Invoice",
  [BUTTON_ADJUST_PREFERENCES]: "Adjust Preferences",
  [BUTTON_GENERATE_AGAIN]: "Generate Again",
  [BUTTON_CREATE_ADS_CAMPAIGN]: "Create Campaign",
  [BUTTON_EDIT_BUDGET]: "Edit Budget",
  [BUTTON_PUBLISH_CAMPAIGN]: "Publish Campaign",
  [BUTTON_START_CHAT]: "Start Chat",
  [BUTTON_SELECT_CONTENT]: "Select Content",
  [BUTTON_SELECT_DOCUMENT]: "Select documents",
  [BUTTON_SELECT_POST]: "Select Post",
  [BUTTON_CREATE_WITH_CANVA]: "Create with Canva",
  [BUTTON_CREATE_WITH_IA]: "Create",
  [BUTTON_CONNECT_CANVA]: "Connect Canva",
  [BUTTON_USE_THIS_CONTENT]: "Use this Content",
  [BUTTON_CONNECT_GOOGLE]: "Connect Google",
  [BUTTON_CONNECT_GOOGLE_DRIVE]: "Connect Google Drive",
  [BUTTON_SELECT]: "Select",
  [BUTTON_DESELECT]: "Deselect",
  [BUTTON_SEND_CODE]: "Send Code",
  [BUTTON_VERIFY_CODE]: "Verify",
  [BUTTON_RESEND_CODE]: "Resend",
  [BUTTON_CONNECTED]: "Connected",
  [BUTTON_DISCONNECTED]: "Disconnected",
  [BUTTON_ADD_RE_TARGETING]: "Add Audience",
  [BUTTON_BUY_PLAN]: "Buy {{value}}",
  [BUTTON_ADD]: "Add",
  [BUTTON_UPLOAD_CONTENT_FROM_ADS_PLATFORMS]: "Upload from Social Networks",
  [BUTTON_UPDATE]: "Update",
  [BUTTON_CONNECT_ACCOUNT]: "Connect Account",
  [BUTTON_REPLACE]: "Replace",
  [BUTTON_SUPPORT]: "Support",
  [BUTTON_CANCEL_SUBSCRIPTION]: "Cancel Subscription",
  [BUTTON_REACTIVATE_SUBSCRIPTION]: "Reactivate Subscription",
  [BUTTON_CHANGE_PAYMENT_METHODS]: "Change Payment Method",
  [BUTTON_DELETE_PLATFORM]: "Delete Platform",
  [BUTTON_GENERATE_WITH_AI]: "Generate with AI",
  [BUTTON_CONTACT_US]: "Contact Us",
  [BUTTON_GENERATE_RANDOM]: "Generate Random",
  [BUTTON_GENERATE]: "Generate",
  [BUTTON_REGISTER_WITH_GOOGLE]: "Register with Google",
  [BUTTON_LOG_IN_WITH_GOOGLE]: "Log in with Google",
  [BUTTON_CHANGE_LOGO]: "Change Logo",
  [BUTTON_DELETE_LOGO]: "Delete Logo",
  [BUTTON_UPGRADE_PLAN]: "Upgrade to {{value}}",
  [BUTTON_UPGRADE_PLAN_2]: "Upgrade plan",
  [LABEL_CURRENT_SUBSCRIPTION_PLAN]: "Current Plan",
  [BUTTON_UPGRADE_TO_PAID_PLAN]: "Upgrade to paid plan",
  [BUTTON_BOOK_A_DEMO]: "Book a demo",
  [BUTTON_APPLY_OPTIMIZATIONS]: "Apply Optimizations",
  [BUTTON_OPTIMIZATION_APPLIED]: "Optimization Applied",
  [BUTTON_CHANGES_APPLIED]: "Changes Applied",
  [BUTTON_APPLY_CHANGES]: "Apply Changes",
  [BUTTON_PREVIEW_CHANGES]: "Review Changes",
  [BUTTON_DISCARD_OPTIMIZATIONS]: "Discard Optimizations",
  [BUTTON_DISCARD_OPTIMIZATIONS_DESCRIPTION]:
    "Are you sure you want to discard the optimizations?",
  [BUTTON_CREATE_TEMPLATE]: "Create template",
  [BUTTON_EDIT_TEMPLATE]: "Edit template",
  [BUTTON_VIEW_DETAILED_REPORT]: "View detailed report",
  [BUTTON_SELECT_INSTANT_FORM]: "Select Form",
  [BUTTON_RECONNECT_ACCOUNT]: "Reconnect account",
  [BUTTON_RECONNECT]: "Reconnect",
  [BUTTON_ADD_CONVERSION_ACTION]: "Add conversion action",
  [BUTTON_SELECT_AVATAR]: "Select avatar",
  [BUTTON_CHANGE_AVATAR]: "Change avatar",
  [BUTTON_FILTER]: "Filter",
  [BUTTON_CONNECT_LINKEDIN]: "Connect LinkedIn",
  [BUTTON_REMOVE]: "Remove",
  [BUTTON_TRY_AGAIN]: "Try again",
  [BUTTON_PUBLISH_CHANGES]: "Publish changes",
  [BUTTON_ANALYZE]: "Analyze",
  [BUTTON_DROP_PIN]: "Drop pin",
  [BUTTON_EDIT_PLACEMENTS]: "Edit placements",
  [BUTTON_EDIT_ADVANTAGE_ENHANCES]: "Edit advantage enhances",
  [BUTTON_COMPLETE_INFORMATION]: "Complete information",
  [BUTTON_ADD_KEYWORDS]: "Add",
  [BUTTON_SELECT_POST_FROM_SOCIAL_NETWORKS]: "Select post from social networks",
  [BUTTON_CREATE_NEW]: "Create new",
  [BUTTON_PREVIEW_OPTIMIZATION]: "Review Optimization",
  [BUTTON_CHANGE_CREATIVE]: "Change Creative",
  [BUTTON_APPLIED]: "Applied",
  [BUTTON_SKIP]: "Skip",
  [BUTTON_ADD_VIDEO]: "Add video",
  [BUTTON_CREATE_FROM_SCRATCH]: "Create With AI",
  [BUTTON_CREATE_FROM_TEMPLATES]: "From Templates",
  [BUTTON_IMPORT_FROM_PLATFORM]: "Import",
  [BUTTON_IMPORT_FROM_GOOGLE_DRIVE]: "Import from Google Drive",
  [BUTTON_IMPORT_CAMPAIGN]: "Import Campaign",
  [BUTTON_DUPLICATE_FROM_PLATFORM]: "Duplicate",
  [BUTTON_DUPLICATE_CAMPAIGN]: "Duplicate Campaign",
  [MODAL_DUPLICATE_ADS_CAMPAIGN_TITLE]: "Duplicate Campaign",
  [MODAL_DUPLICATE_ADS_CAMPAIGN_DESCRIPTION]:
    "Select a campaign from your platform to duplicate its structure as a draft",
  [MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_TITLE]: "Campaign Duplicated",
  [MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_DESCRIPTION]:
    "The campaign structure was duplicated as a draft. Review it and publish it when you're ready.",
  [MODAL_IMPORT_ADS_CAMPAIGN_SUPPORTED_TYPES]:
    "You can only import {{types}} campaigns.",
  [MODAL_DUPLICATE_ADS_CAMPAIGN_SUPPORTED_TYPES]:
    "You can only duplicate {{types}} campaigns.",
  [BUTTON_SAVE_AND_PUBLISH]: "Publish Changes",
  [BUTTON_ADD_SITE_LINK]: "Add site link",
  [BUTTON_EDIT_SITE_LINKS]: "Edit site links",
  [BUTTON_SELECT_CSV_FILE]: "Upload CSV file",
  [BUTTON_DOWNLOAD_TEMPLATE]: "Download template",
  [BUTTON_UPLOAD_GOOGLE_ASSET_LIBRARY]: "Upload from Google Asset Library",
  [BUTTON_MARK_AS_DONE]: "Mark as done",
  [BUTTON_SELECT_INSTANT_EXPERIENCE]: "Select experience",
  [BUTTON_VIEW_ACTION]: "View action",
  [BUTTON_CREATE_CUSTOM_AUDIENCE]: "Create Audience",
  [BUTTON_CLEAR_ALL]: "Clear All",
  [BUTTON_RESET_TO_BASIC_METRICS]: "Show Basic Metrics",
  [BUTTON_GO_TO_BILLING]: "Go to Billing",
  [BUTTON_WHY_THIS_RECOMMENDATION]: "Why this recommendation?",
  [BUTTON_CLEAR_DATES]: "Clear Dates",
  [BUTTON_NEW_CAMPAIGN]: "New Campaign",
  [BUTTON_DISCONNECT_ACCOUNT]: "Disconnect Account",
  [BUTTON_SELECT_ALL]: "Select All",
  [BUTTON_DESELECT_ALL]: "Deselect All",
  [BUTTON_USE_SAVED_AUDIENCE]: "Use Saved Audience",
  [BUTTON_ADD_PRODUCT]: "Add Product",
  [BUTTON_ADD_SERVICE]: "Add Service",

  /* Categories */
  [NEW_CREATORS_CATEGORY]: "New creators",
  [FAVORITES_CATEGORY]: "Favorites",
  [TOP_RATED_CATEGORY]: "Top rated",

  //VERSION
  [NEW_VERSION_TITLE]: "New version available!",
  [NEW_VERSION_DESCRIPTION]:
    "We've released an update to our website that might conflict with your current version. We recommend refreshing the page to get the latest version and avoid potential errors.",

  [DESCRIPTION_SEND_MESSAGE]: "Chat with this creator",
  [DESCRIPTION_SEND_PAYMENT]: "Send a payment securely",

  [MODAL_PAY_CREATOR_AMOUNT_LABEL]: "Payment amount",

  /* PAGES */

  // Creators
  [CREATORS_TITLE]: "Content Creators",
  [CREATOR_DESCRIPTION]:
    "Find and filter creators to collaborate on exchanges, send messages & payments",
  [SEARCH_BAR_TEXT_CREATORS]: "Search by username",
  [TAB_CREATORS]: "Creators",
  [TAB_REQUESTS]: "Requests",
  [TAB_SUGGESTED]: "For you",
  [CREATORS_SUGGESTED_EMPTY]:
    "No suggested creators found, adjust your preferences to find creators",
  [CREATORS_TABLE_COLUMN_NAME]: "Name",
  [CREATORS_TABLE_COLUMN_CITY]: "City",
  [CREATORS_TABLE_COLUMN_AUDIENCE]: "Audience",
  [CREATORS_TABLE_COLUMN_ENGAGEMENT]: "Engagement",
  [CREATORS_TABLE_COLUMN_CATEGORIES]: "Categories",
  [CREATORS_TABLE_COLUMN_DATE]: "Date",
  [CREATORS_TABLE_COLUMN_SCORE]: "Score",
  [CREATORS_TABLE_COLUMN_ACTIVITY]: "Activity",
  [DISCOVER_NEW_CREATORS]: "Discover new creators",

  [RECURRENT_FIELDS_DEFAULT_TITLE]:
    "How often do you want to invite this creator?",
  [RECURRENT_FIELD_REPEAT_COUNT_PLACEHOLDER]: "Every",
  [RECURRENT_FIELD_REPEAT_COUNT_MIN_VALIDATION]:
    "The minimum value is {{value}}",
  [RECURRENT_FIELD_REPEAT_COUNT_MAX_VALIDATION]:
    "The maximum recurrence is {{months}} months or {{weeks}} weeks",
  [RECURRENT_FIELD_FREQUENCY_PLACEHOLDER]: "Choose an option",
  [RECURRENT_FIELD_DAY_AN_PLACEHOLDER]: "A",
  [RECURRENT_FIELD_DAY_ALL_PLACEHOLDER]: "Every",
  [MODAL_BROADCAST_ARIAL_LABEL]: "Broadcast Modal",
  [MODAL_BROADCAST_TITLE]: "Send a broadcast",
  [MODAL_BROADCAST_DESCRIPTION]: "Send a message to all your ambassadors",
  [MODAL_BROADCAST_SELECT_USER_PLACEHOLDER]: "Select users",
  [MODAL_BROADCAST_SELECT_USER_REQUIRED]: "You must select at least one user",
  [MODAL_BROADCAST_MESSAGE_PLACEHOLDER]: "Message",
  [BROADCAST_MESSAGE_SENT]: "Global message sent",
  [MODAL_BROADCAST_CONFIRM_TITLE]: "Send Broadcast",
  [MODAL_BROADCAST_CONFIRM_DESCRIPTION]:
    "Are you sure you want to send a message to all your ambassadors?",

  //PUBLICATIONS
  [PUBLICATIONS_TITLE]: "Collaborations",
  [PUBLICATIONS_DESCRIPTION]:
    "Review the collaborations created by content creators about your products",
  [PUBLICATIONS_TABLE_ARIA_LABEL]: "Collaborations table",
  [PUBLICATIONS_TABLE_COLUMN_DATE]: "Date",
  [PUBLICATION_STATUS_PENDING_CONTENT]: "Content Pending",
  [PUBLICATION_STATUS_PENDING_APPROVAL]: "Review",
  [PUBLICATION_STATUS_PENDING]: "Pending Post",
  [PUBLICATION_STATUS_PENDING_SOCIAL]: "Pending Post",
  [PUBLICATIONS_STATUS_PENDING_ANALYTICS]: "Pending Analytics",
  [PUBLICATIONS_STATUS_SENT]: "Review",
  [PUBLICATIONS_STATUS_FEEDBACK]: "Feedback",
  [PUBLICATIONS_STATUS_VERIFIED]: "Verified",

  //PUBLICATION
  [PUBLICATION_TITLE]: "Post",
  [NUMBER_PUBLICATION]: "Post #",
  [FEEDBACK_TITLE]: "Feedback",
  [PUBLICATION_FINISH_ONBOARDING_NEW_BRANDS_DESCRIPTION]:
    "Now you can continue with the store tutorial.",
  [PUBLICATION_FINISH_DESCRIPTION]:
    "You have completed the platform tutorial, and now you know how to generate invitations.",
  [FEEDBACK_PLACEHOLDER]: "How was your experience using the platform?",
  [FEEDBACK_REASON_ABOUT]: "Negative review about {{reason}}",
  [FEEDBACK_REASON]: "Reason for negative review",
  [FEEDBACK_COMMENT]: "Comment",
  [ANALYTICS_EXPLANATION_TITLE]: "How to Interpret Analytics?",
  [ANALYTICS_EXPLANATION_DESCRIPTION]:
    "In analytics, you can determine if the content that the content creator posted about your brand generated results according to your criteria.",
  [ANALYTICS_EXPLANATION_DESCRIPTION_2]:
    "Analytics are generally divided into different sections of information, but the most important ones are the summary and interactions. Here's an explanation of the different data in these sections.",
  [ANALYTICS_EXPLANATION_ACCOUNTS_REACHED_DESCRIPTION]:
    "• <b>Accounts Reached</b>: These are the different social media accounts the post reached. They can be divided into followers and non-followers, whether or not they follow the content creator.",
  [ANALYTICS_EXPLANATION_ENGAGEMENT_DESCRIPTION]:
    "• <b>Engagement</b>: These are the accounts that interacted with the post in some way, such as responses to stories or the number of times the post was shared by other users.",
  [ANALYTICS_EXPLANATION_STICKERS_TAPS_DESCRIPTION]:
    "• <b>Stickers Taps</b>: This represents the number of times users interacted with tags or stickers in a post, allowing them to view your brand's profile.",
  [ANALYTICS_EXPLANATION_NAVIGATION_DESCRIPTION]:
    "• <b>Navigation</b>: It describes the behavior of users with the content the content creator posted, whether they exited the story, moved on to the next without waiting for the completion time, waited for the entire specified time, or went back to view the story again.",
  [RECURRENT_VALUE_NOT_FOUND]:
    "The invitation's recurrence could not be obtained for some reason, please change the values.",
  [MODAL_REVIEW_ARIA_LABEL]: "Modal to review an influencer",
  [MODAL_REVIEW_DISCLAIMER]:
    "Your rating will not be shared with the content creator.",
  [MODAL_REVIEW_SCORE_PLACEHOLDER]:
    "Rate from 1 to 5 the results of this creator according to your expectations.",
  [MODAL_REVIEW_SCORE_CONTENT_PLACEHOLDER]:
    "Rate the quality and production of the content posted.",
  [MODAL_REVIEW_SCORE_CONTENT_MIN_VALUE]:
    "The minimum rating for content is 1 star",
  [MODAL_REVIEW_SCORE_CONTENT_EXPLANATION_TITLE]:
    "How to interpret the content?",
  [MODAL_REVIEW_SCORE_CONTENT_EXPLANATION_DESCRIPTION]:
    "Rate the content creator based on the quality of the post - images, text, or videos about your brand. One star means you are not satisfied with the content and won't use or download it, while five stars mean you are completely satisfied with the content and will use and repost it on your channels or networks.",
  [MODAL_REVIEW_SCORE_ENGAGEMENT_PLACEHOLDER]:
    "Rate the reach and engagement of the posted content.",
  [MODAL_REVIEW_SCORE_ENGAGEMENT_MIN_VALUE]:
    "The minimum rating for statistics is 1 star",
  [MODAL_REVIEW_COMMENT_PLACEHOLDER]:
    "Describe what you thought of the content and the reach of this creator.",
  [REVISION_COUNT]: "Revision {{value}}",
  [UPLOAD_NEW_CONTENT]: "Upload new content",
  [ADD_URL_PUBLICATION]: "Add URL",

  //ADS CAMPAIGNS
  [ADS_CAMPAIGNS_TITLE]: "Campaigns",
  [ADS_CAMPAIGNS_TITLE_DASHBOARD]: "Campaigns",
  [ADS_CAMPAIGNS_DESCRIPTION]: "Manage and analyze your ad campaigns",

  //ADS CAMPAIGN
  [ADS_CONFIGURATION_APPS_TITLE]: "Apps Configuration",
  [ADS_CONFIGURATION_DESTINATION_TITLE]: "Destination Configuration",
  [ADS_CAMPAIGN_PREVIEW]: "Preview",
  [ADS_CAMPAIGN_TITLE]: "Campaign information",
  [ADS_CAMPAIGN_CAMPAIGN_INFORMATION_SUB_TITLE]: "{{platform}} Ad",
  [ADS_CAMPAIGN_BUDGET_INFORMATION_SUB_TITLE]: "General budget information",
  [ADS_CAMPAIGN_SEGMENTATION_SUB_TITLE]: "Segmentation Information",
  [ADS_CAMPAIGN_SAVED_AUDIENCE_SUB_TITLE]: "Saved Audience",
  [ADS_CAMPAIGN_ADDITIONAL_CONFIGURATION_AD_GROUP_SUB_TITLE]:
    "Additional configuration",
  [ADS_CAMPAIGN_HAS_BEEN_FINISHED]: "This campaign has ended",
  [ADS_CAMPAIGN_HAS_BEEN_ACTIVATE]: "Campaign activated",
  [ADS_CAMPAIGN_HAS_BEEN_SAVE]: "Campaign saved",
  [ADS_CAMPAIGN_HAS_BEEN_DUPLICATE]: "Campaign duplicated",
  [ADS_CAMPAIGN_USE_GENERAL_BUDGET]: "Use a general campaign budget",
  [ADS_CAMPAIGN_PLATFORM_BRAND_CONFIGURATION_SUB_TITLE]: "Brand Configuration",
  [ADS_CAMPAIGN_PLATFORM_ASSETS_CONFIGURATION_SUB_TITLE]:
    "Assets Configuration",
  [ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_SUB_TITLE]: "Budget Information",
  [ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_GENERAL]: "General Configuration",
  [ADS_CAMPAIGN_AD_GROUP_INFORMATION_SUB_TITLE]: "Ad group information",
  [ADS_CAMPAIGN_PLATFORM_ADDITIONAL_CONFIGURATION_SUB_TITLE]:
    "Additional Configuration",
  [ADS_CAMPAIGNS_PLATFORM_TEXTS_SUB_TITLE]: "Texts configuration",
  [ADS_CAMPAIGN_AD_GROUP_PRODUCTS_SUB_TITLE]: "Products Configuration",
  [ADS_CAMPAIGN_AD_APP_CONFIGURATION_SUB_TITLE]: "App Configuration",
  [ADS_CAMPAIGN_PRODUCTS_CONFIGURATION_SUB_TITLE]: "Products Configuration",

  //PRODUCT SET AUDIENCE BUILDER
  [PRODUCT_SET_AUDIENCE_BUILDER_TITLE]: "Audience Rules",
  [PRODUCT_SET_AUDIENCE_BUILDER_PROSPECTING_TITLE]:
    "Find prospective customers even if they haven't interacted with your business.",
  [PRODUCT_SET_AUDIENCE_BUILDER_RETARGETING_TITLE]:
    "Retarget ads to people who interacted with your products on and off Meta Platforms.",
  [PRODUCT_SET_AUDIENCE_BUILDER_TIKTOK_PROSPECTING_SEGMENT]:
    "Find new customers",
  [PRODUCT_SET_AUDIENCE_BUILDER_TIKTOK_RETARGETING_SEGMENT]:
    "Retarget an audience",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_TITLE]: "Custom combination",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_INCLUSIONS_TITLE]:
    "Included audience interactions",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_INCLUSIONS_ADD_BUTTON]: "Add inclusion",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_EXCLUSIONS_TITLE]: "But not",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_EXCLUSIONS_ADD_BUTTON]: "Add exclusion",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_IN_THE_LAST]: "In the last",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_DAYS]: "days",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_LABEL]:
    "Viewed or added to cart but not purchased",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_DESCRIPTION]:
    "Promote products from {{value}} to people who viewed or added those products to cart in the last ",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_LABEL]:
    "Added to cart but not purchased",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_DESCRIPTION]:
    "Promote products from {{value}} to people who added those products to their cart in the last ",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_LABEL]: "Upsell products",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_DESCRIPTION]:
    "Promote {{value}} to people who viewed or added products to cart from the product set below within the last ",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_SELECT_PRODUCT_SET_LABEL]:
    "Viewed or added products to cart from:",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_LABEL]: "Cross-sell products",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_DESCRIPTION]:
    "Promote {{value}} to people who purchased from the product set below in the last",
  [PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_SELECT_PRODUCT_SET_LABEL]:
    "Purchased products from:",
  [PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_SELECT_PRODUCT_SET_LABEL]:
    "Interacted with products from:",

  [MODAL_ERRORS_CAMPAIGNS_TITLE]: "Oops! Something went wrong.",
  [MODAL_ERRORS_CAMPAIGNS_DESCRIPTION]:
    "An error occurred while creating the campaign",

  //CREATE ADS CAMPAIGN
  [CREATE_ADS_CAMPAIGN_MODE_QUESTION]: "Choose the campaign type",
  [CREATE_ADS_CAMPAIGN_NAME_QUESTION]:
    "What will be the name of your campaign?",
  [CREATE_ADS_CAMPAIGN_NAME_PLACEHOLDER]: "New summer collection",
  [CREATE_ADS_CAMPAIGN_OBJECTIVE_QUESTION]:
    "What is the objective of your campaign?",
  [CREATE_ADS_CAMPAIGN_APP_PROMOTION_QUESTION]:
    "What type of app do you want to promote?",
  [CREATE_ADS_CAMPAIGN_TYPE_QUESTION]:
    "What type of campaign do you want to create?",
  [CREATE_ADS_CAMPAIGN_OBJECTIVE_DESCRIPTION]:
    "The objective of your campaign is important to display your ads in the best possible way.",
  [CREATE_ADS_CAMPAIGN_DESTINATION_TYPE_QUESTION]:
    "Where you want to generate the conversion?",
  [CREATE_ADS_CAMPAIGN_TARGET_CPA_QUESTION]:
    "What is the target CPA of your campaign?",
  [CREATE_ADS_CAMPAIGN_DESTINATION_URL_QUESTION]:
    "To which website do you want to send the traffic from your campaign?",
  [CREATE_ADS_CAMPAIGN_DEEP_LINK_QUESTION]:
    "What is the deep link for your app?",
  [CREATE_ADS_CAMPAIGN_DATES_QUESTION]:
    "When will your campaign start and end?",
  [CREATE_ADS_CAMPAIGN_AD_FORMAT_QUESTION]:
    "What ad format do you want to use?",
  [CREATE_ADS_CAMPAIGN_WEBSITE_URL_QUESTION]:
    "What is the URL of your website?",
  [CREATE_ADS_CAMPAIGN_AD_ACCOUNT_QUESTION]:
    "On which ad account do you want to create the campaign?",
  [CREATE_ADS_CAMPAIGN_AD_ACCOUNTS_QUESTION]:
    "On which ad accounts do you want to create the campaign?",
  [CREATE_ADS_CAMPAIGN_IDENTITIES_ACCOUNTS_QUESTION]:
    "Which accounts will show your ads?",
  [META_GENERATE_CAMPAIGN_IDENTITIES_PLACEMENTS_HINT]:
    "Afterwards you can refine the placements where you want your ads to appear (for example, only Instagram or only Facebook).",
  [MODAL_CLOSE_UNSAVED_WARNING_DESCRIPTION]:
    "Are you sure you want to leave? Your setup won't be saved.",
  [MODAL_CLOSE_UNSAVED_CONFIRM]: "Leave",
  [META_ADAPT_PLACEMENTS_CONFIRM_TITLE]:
    "Should we adapt your images to more formats?",
  [META_ADAPT_PLACEMENTS_CONFIRM_TEXT]:
    "We can generate square and vertical versions of your images so they look better in feeds, stories, and reels. This uses additional creative credits.",
  [META_ADAPT_PLACEMENTS_CONFIRM_YES]: "Yes, adapt",
  [META_ADAPT_PLACEMENTS_CONFIRM_NO]: "No, continue",
  [META_ADAPT_PLACEMENTS_CHECKBOX_LABEL]:
    "Resize images to fit all vertical and square placements.",
  [META_ADAPT_PLACEMENTS_CHECKBOX_COST]: "(It will cost you {{count}} credits)",
  [CREATE_ADS_CAMPAIGN_CATALOG_QUESTION]:
    "Which catalog do you want to use to create the campaign?",
  [CREATE_ADS_CAMPAIGN_CATALOG_FOR_APP_INSTALL_QUESTION]:
    "Do you want to use a catalog for this campaign?",
  [CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_QUESTION]:
    "What type of campaign do you want to create?",
  [CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_WEBSITE]: "Website",
  [CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_APP]: "App",
  [CREATE_ADS_CAMPAIGN_APP_ID_QUESTION]: "Which app do you want to promote?",
  [CREATE_ADS_CAMPAIGN_TRACKING_QUESTION]:
    "Which pixel do you want to use to track your campaign?",
  [CREATE_ADS_CAMPAIGN_TRACKINGS_QUESTION]:
    "Which pixels do you want to use to track your campaign?",
  [CREATE_ADS_CAMPAIGN_TRACKING_CUSTOM_EVENT_QUESTION]:
    "What Meta event do you want to track on your website?",
  [CREATE_ADS_CAMPAIGN_TRACKING_CUSTOM_EVENTS_QUESTION]:
    "What Meta events do you want to track on your website?",
  [CREATE_ADS_CAMPAIGN_PLATFORM_QUESTION]:
    "On which platform do you want to create the ads?",
  [CREATE_ADS_CAMPAIGN_TYPE_BUDGET_QUESTION]:
    "What type of campaign do you want to create?",
  [CREATE_ADS_CAMPAIGN_TYPE_BUDGET_DAILY_RADIO_LABEL]:
    "Daily campaign (daily budget)",
  [CREATE_ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_RADIO_LABEL]:
    "Campaign with fixed dates (total budget)",
  [CREATE_ADS_CAMPAIGN_BUDGET_DAILY_QUESTION]:
    "What will be the maximum DAILY budget of your campaign?",
  [CREATE_ADS_CAMPAIGN_BUDGET_TOTAL_QUESTION]:
    "What will be the maximum budget of your campaign?",
  [CREATE_ADS_CAMPAIGN_BUDGET_DESCRIPTION_QUESTION]:
    "You won't pay anything until you publish your campaign.",
  [CREATE_ADS_CAMPAIGN_BUDGET_PLACEHOLDER]: "Enter a value",
  [CREATE_ADS_CAMPAIGN_START_END_DATE_QUESTION]:
    "When will your campaign start and end?",
  [CREATE_ADS_CAMPAIGN_LOCATIONS_QUESTION]:
    "What locations do you want to target?",
  [CREATE_ADS_CAMPAIGN_LOCATIONS_PLACEHOLDER]:
    "Describe a place or set of locations",
  [CREATE_ADS_CAMPAIGN_AGE_RANGE_QUESTION]:
    "What is the age range of the audience that will see your ads?",
  [CREATE_ADS_CAMPAIGN_GENDERS_QUESTION]:
    "What genders do you want your ads to be shown to?",
  [CREATE_ADS_CAMPAIGN_INTERESTS_QUESTION]:
    "What interests do you want the audience that will see your ads to have?",
  [CREATE_ADS_CAMPAIGN_INTERESTS_PLACEHOLDER]: "Beachwear, vacations, summer",
  [CREATE_ADS_CAMPAIGN_BEHAVIORS_QUESTION]:
    "What behaviors do you want the audience that will see your ads to have?",
  [CREATE_ADS_CAMPAIGN_BEHAVIORS_PLACEHOLDER]:
    "Beachwear shoppers, frequent travelers",
  [CREATE_ADS_CAMPAIGN_DEMOGRAPHICS_QUESTION]:
    "What demographics do you want the audience that will see your ads to have?",
  [CREATE_ADS_CAMPAIGN_DEMOGRAPHICS_PLACEHOLDER]:
    "Recently engaged, upcoming birthday, upcoming anniversary",
  [CREATE_ADS_CAMPAIGN_DESCRIPTION_QUESTION]:
    "What text will accompany your ad?",
  [CREATE_ADS_CAMPAIGN_DESCRIPTION_PLACEHOLDER]:
    "The new summer collection is here, elevate your beach style with our outfits. Discover them now!",
  [CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION]: "Tell us about your campaign",
  [CREATE_ADS_CAMPAIGN_CONTEXT_DESCRIPTION]: `Write a paragraph detailing the product or service you want to promote, the main message and the target audience you want to reach.`,
  [CREATE_ADS_CAMPAIGN_CONTEXT_PLACEHOLDER]:
    "My campaign is to promote my new summer collection that I just launched. This collection is perfect for beach vacations, with swimsuits, shorts and beach accessories. It is ideal for those men and women who are looking for a fresh and modern look.",
  [CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_QUESTION]:
    "What is the product or service you want to promote and what are its main attributes?",
  [CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_DESCRIPTION]:
    "Write a paragraph detailing the product or service you want to promote, what are its main attributes and what makes it stand out.",
  [CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_PLACEHOLDER]:
    "My product is a swimsuit with a modern and fresh design. It is made of high quality material and is perfect to stand out at the beach.",
  [CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_QUESTION]:
    "What audience do you want to show the ad?",
  [CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_DESCRIPTION]:
    "Write a paragraph detailing the target audience you want to reach amd what characteristics they should have.",
  [CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_PLACEHOLDER]:
    "My target audience are men and women from 18 to 35 years old who like the beach and fashion, who like to look modern and fresh. ",
  [CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_QUESTION]: "Tell us about your brand",
  [CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_DESCRIPTION]:
    "Write a paragraph detailing what your brand is called, what it is about, what products or services you offer and what makes it stand out.",
  [CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_PLACEHOLDER]:
    "My brand is called 'Beachwear', is a beachwear and accessories store. We offer a wide variety of products with modern, fresh designs that align with current trends. Our high-quality products are crafted to make you stand out at the beach.",
  [CREATE_ADS_CAMPAIGN_SOCIAL_NETWORK_QUESTION]:
    "What is your brand's Instagram profile?",
  [CREATE_ADS_CAMPAIGN_SOCIAL_NETWORK_PLACEHOLDER]:
    "https://www.instagram.com/yourbrand",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_QUESTION]:
    "What content do you want to promote?",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_SERVICES_QUESTION]:
    "What content do you want to promote?",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DOCUMENTS_QUESTION]:
    "Which documents do you want to promote?",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_POSTS_QUESTION]:
    "What posts do you want to promote?",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_PRODUCTS_QUESTION]:
    "What products do you want to promote?",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_WITH_OUT_CAROUSEL]:
    "Add content for each ad. You'll have the option to choose other formats in the next step.",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_DOCUMENTS]:
    "Upload one document per ad (PDF, PPT, or DOC). Each document will be a separate ad.",
  [LINKEDIN_DOCUMENT_PDF_PREVIEW_LOADING]: "Loading document preview",
  [LINKEDIN_DOCUMENT_PDF_PREVIEW_ERROR]:
    "The document preview could not be displayed",
  [LINKEDIN_DOCUMENT_PDF_PREVIEW_ALT]: "Preview of {{fileName}}",
  [LINKEDIN_DOCUMENT_PREVIEW_PREV]: "Previous page",
  [LINKEDIN_DOCUMENT_PREVIEW_NEXT]: "Next page",
  [LINKEDIN_DOCUMENT_PREVIEW_PAGE_COUNT]: "{{current}} / {{total}}",
  [LINKEDIN_DOCUMENT_PREVIEW_OPEN_NEW_TAB]: "Open in a new tab",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_CAROUSEL]:
    "For now, select only the first images of the carousels you want to upload. You can add the rest afterwards.",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_PRODUCT]:
    "Add content of the products you want to promote. <b>Each content you add will be an independent ad within the campaign</b> and you'll be able to edit the formats later.",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_PRODUCT_SINGLE]:
    "Add content of the products you want to promote. You'll be able to edit the formats later.",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_SERVICE_SINGLE]:
    "Add content of the services you want to promote. You'll be able to edit the formats later.",
  [CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_SERVICE]:
    "Add content of the services you want to promote. <b>Each content you add will be an independent ad within the campaign</b> and you'll be able to edit the formats later.",
  [CREATE_ADS_CAMPAIGN_TEMPLATE_QUESTION]:
    "What type of campaign do you want to create?",
  [CREATE_ADS_CAMPAIGN_TEMPLATE_SINGULAR]: "Singular",
  [CREATE_ADS_CAMPAIGN_TEMPLATE_MULTIPLE]: "Multiple",
  [CREATE_ADS_CAMPAIGN_MULTIPLE_PRODUCTS_QUESTION]:
    "Add the products you want to promote",
  [CREATE_ADS_CAMPAIGN_MULTIPLE_PRODUCTS_DESCRIPTION]:
    "For each product, add the destination link and the creative content.",
  [CREATE_ADS_CAMPAIGN_MULTIPLE_SERVICES_QUESTION]:
    "Add the services you want to promote",
  [CREATE_ADS_CAMPAIGN_MULTIPLE_SERVICES_DESCRIPTION]:
    "For each service, add the destination link and the creative content.",
  [PRODUCT_URL_PLACEHOLDER]: "Product URL",
  [SERVICE_URL_PLACEHOLDER]: "URL or landing page",
  [PRODUCT_LABEL]: "Product {{number}}",
  [SERVICE_LABEL]: "Service {{number}}",
  [PRODUCT_FIELDS_REQUIRED]: "All fields are required in product {{number}}",
  [SERVICE_FIELDS_REQUIRED]: "All fields are required in service {{number}}",
  [PRODUCT_URL_INVALID]: "The URL of product {{number}} is invalid",
  [SERVICE_URL_INVALID]: "The URL of service {{number}} is invalid",
  [MEDIA_URLS_TAB_SINGULAR_PRODUCT]: "Single product",
  [MEDIA_URLS_TAB_SINGULAR_SERVICE]: "Single service",
  [MEDIA_URLS_TAB_MULTIPLE_PRODUCTS]: "Multiple products",
  [MEDIA_URLS_TAB_MULTIPLE_SERVICES]: "Multiple services",
  [MEDIA_URLS_MODE_EXPLANATION_PRODUCTS]:
    "Decide if this campaign will focus on a single product or multiple products. Each product can have its own link and creatives.",
  [MEDIA_URLS_MODE_EXPLANATION_SERVICES]:
    "Decide if this campaign will focus on a single service or multiple services. Each service can have its own link and creatives.",
  [CREATE_ADS_CAMPAIGN_GOOGLE_CONVERSION_ACTIONS_QUESTION]:
    "What conversion action do you want to track?",
  [CREATE_ADS_CAMPAIGN_GOOGLE_CONVERSION_ACTIONS_DESCRIPTION]:
    "Select the conversion action you want to track on your campaign.",
  [CREATE_ADS_CAMPAIGN_LOADING_GETTING_REQUIRED_INFORMATION]:
    "Setting up your campaign strategy...",
  [CREATE_ADS_CAMPAIGN_LOADING_ANALYZING_INFORMATION]:
    "Analyzing data for high-impact opportunities...",
  [CREATE_ADS_CAMPAIGN_LOADING_GENERATING_RECOMMENDATIONS]:
    "Building your optimized ad strategy...",
  [CREATE_ADS_CAMPAIGN_LOADING_FINALIZING_DETAILS]:
    "Preparing your campaign for review...",
  [CREATE_ADS_CAMPAIGN_LOADING_CREATING_INSTANT_FORM]: "Creating instant form",
  [CREATE_ADS_CAMPAIGN_INTRO_TITLE]: "{{NAME_BUSINESS}} AI",
  [CREATE_ADS_CAMPAIGN_INTRO_DESCRIPTION]:
    "A powerful solution for the creation, optimization and management of your campaigns across multiple platforms.",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_CREATE_CAMPAIGN]:
    "Create ad campaigns in minutes",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_CREATE_CAMPAIGN]:
    "Create ad campaigns in minutes",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_OPTIMIZE_WITH_AI]:
    "Optimize your campaigns with AI",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_MANAGE_SIMPLE]:
    "Manage your campaigns easily",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_ANALYZE_PERFORMANCE]:
    "Analyze the performance of your campaigns",
  [CREATE_ADS_CAMPAIGN_INTRO_FEATURE_ALL_IN_ONE_PLACE]:
    "And much more! All in one place.",
  [CREATE_ADS_CAMPAIGN_INTRO_CALL_TO_ACTION_DESCRIPTION]:
    "What are you waiting for to get started? Create your campaign now!",
  [CREATE_ADS_CAMPAIGN_INTRO_CALL_TO_ACTION_BUTTON]: "Create campaign",
  [CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_PRODUCT_ADVERTISE]:
    "- What is the product or service you want to promote?",
  [CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_COMMUNICATE]:
    "- What is the main message you want to communicate?",
  [CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_SEGMENTATION]:
    "- What is the target audience you want to reach?",
  [CREATE_ADS_LANGUAGE_QUESTION]: "What language will your campaign be in?",
  [CREATE_ADS_PLATFORMS_QUESTION]:
    "On which platforms do you want to publish your campaign?",
  [CREATE_ADS_CAMPAIGN_QUICK_MODE]: "Quick Campaign",
  [CREATE_ADS_CAMPAIGN_QUICK_MODE_DESCRIPTION]:
    "AI-powered for beginners. Fast, easy setup with automated best practices",
  [CREATE_ADS_CAMPAIGN_ADVANCED_MODE]: "Advanced",
  [CREATE_ADS_CAMPAIGN_ADVANCED_MODE_DESCRIPTION]:
    "Set up your campaign, select objectives, conversion events and advertising accounts",
  [CREATE_ADS_CAMPAIGN_VIDEO_URLS_QUESTION]:
    "What videos do you want to promote?",
  [CREATE_ADS_CAMPAIGN_VIDEO_URLS_DESCRIPTION]:
    "Select the videos you want to promote in your campaign",
  [CREATE_ADS_CAMPAIGN_IMAGE_URLS_QUESTION]:
    "What images do you want to promote?",
  [CREATE_ADS_CAMPAIGN_IMAGE_URLS_DESCRIPTION_QUESTION]:
    "Select the images you want to promote in your campaign",
  [CREATE_ADS_CAMPAIGN_PROJECTION_QUESTION]: "Campaign projection",
  [CREATE_ADS_CAMPAIGN_MERCHANT_ID_QUESTION]:
    "Do you want to promote products in this campaign?",

  // ADS CAMPAIGN REPORTS
  [ADS_CAMPAIGN_STATISTICS_CURRENT_STATE_TITLE]: "Current metrics",
  [ADS_CAMPAIGN_STATISTICS_SLIDE_MENU_OVERVIEW]: "Overview",
  [ADS_CAMPAIGN_STATISTICS_SLIDE_MENU_STATISTICS]: "Statistics",
  [ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_METRICS]: "Metrics",
  [ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_PERFORMING_ASSETS]:
    "Best Perfoming Assets",
  [ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_INSIGHTS]: "Insights",
  [ADS_CAMPAIGNS_STATISTICS_PERFORMANCE_TRENDS]: "Performance trends",
  [ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPM]: "Cost per thousand impressions",
  [ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPC]: "Cost per click",
  [ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPA]: "Cost per action",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_ASSETS_GROUP]:
    "Best assets group",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_GROUP]: "Best ad group",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD]: "Best creative",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_TITLE]:
    "Most viewed title",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_DESCRIPTION]:
    "Most viewed description",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_KEYWORDS]: "Top keywords",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_VIDEOS]: "Top videos",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_IMAGES]: "Top images",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_HEADLINES]: "Top headlines",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_LONG_HEADLINES]: "Top long headlines",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_DESCRIPTIONS]: "Top descriptions",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_AUDIENCE_BREAKDOWN]: "Audience Breakdown",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_HIGHEST_PERFORMING]: "Highest performance",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_AGE_RANGE_LABEL]: "Range",
  [ADS_CAMPAIGNS_STATISTICS_INSIGHTS_PLAY_VIDEO]: "Play video",

  //ADS CAMPAIGNS LOGS
  [ADS_CAMPAIGNS_LOGS_TITLE]: "Campaign Logs",
  [ADS_CAMPAIGNS_LOGS_CONTEXT_TITLE]: "Campaign Context",
  [BUTTON_REVERT_CHANGE]: "Revert",
  [REVERT_CHANGE_CONFIRM_TITLE]: "Revert Change?",
  [REVERT_CHANGE_CONFIRM_TEXT]:
    "This change will be applied to the draft. You will need to save or publish to apply it to the platform.",
  [REVERT_CHANGE_SUCCESS]: "Change Reverted Successfully",
  [REVERT_CHANGE_ERROR]: "Could Not Revert Change",

  // SETTINGS
  [SETTINGS_TITLE]: "Settings",
  [API_KEYS_TAB_TITLE]: "API keys",
  [BYOK_SETTINGS_DESCRIPTION]:
    "Configure your own provider keys and choose whether AI usage should default to your keys or to credits.",
  [BYOK_DEFAULT_PAYMENT_MODE_LABEL]: "Default Usage Mode",
  [BYOK_DEFAULT_PAYMENT_MODE_HELPER]:
    "When BYOK is selected, {{NAME_BUSINESS}} will use your compatible provider key. If a required provider is missing, the action will automatically fall back to credits.",
  [BYOK_PAYMENT_MODE_CREDITS]: "Credits",
  [BYOK_PAYMENT_MODE_BYOK]: "Bring your own key",
  [BYOK_CONFIGURED_PREVIEW]: "Configured key: {{preview}}",
  [BYOK_NOT_CONFIGURED]: "No key configured yet.",
  [BYOK_PROVIDER_INPUT_LABEL]: "{{provider}} API key",
  [BYOK_PROVIDER_INPUT_PLACEHOLDER]: "Paste a new API key",
  [BYOK_SAVE_BUTTON]: "Save configuration",
  [BYOK_SAVING_BUTTON]: "Saving...",
  [BYOK_SAVE_SUCCESS_TITLE]: "API keys updated",
  [BYOK_SAVE_SUCCESS_DESCRIPTION]:
    "Your BYOK configuration was saved successfully.",
  [BYOK_SAVE_ERROR]:
    "We couldn't save your BYOK configuration. Please try again.",
  [BYOK_PROVIDER_KEYS_TITLE]: "Provider Keys",
  [BYOK_PROVIDERS_COUNTER]: "{{configured}} of {{total}} configured",
  [BYOK_KEY_CONFIGURED_STATUS]: "Key configured",
  [BYOK_NO_KEY_CONFIGURED_STATUS]: "No key configured",
  [BYOK_REPLACE_KEY]: "Replace key",
  [BYOK_DELETE_KEY]: "Delete key",
  [BYOK_DELETE_KEY_TITLE]: "Delete API key",
  [BYOK_DELETE_KEY_DESCRIPTION]:
    "Remove the {{provider}} API key? {{NAME_BUSINESS}} will fall back to credits for that provider.",
  [BYOK_DELETE_KEY_ERROR]: "We couldn't delete this API key. Please try again.",
  [BYOK_DELETE_KEY_SUCCESS_TITLE]: "API key removed",
  [BYOK_DELETE_KEY_SUCCESS_DESCRIPTION]:
    "The {{provider}} API key was removed from your BYOK configuration.",
  [BYOK_KEY_ENCRYPTED_NOTICE]:
    "Your key is encrypted and stored securely. It will never be exposed in plaintext.",
  [BYOK_DEFAULT_PAYMENT_MODE_DESCRIPTION]:
    "Choose how AI usage is billed by default across all providers.",
  [BYOK_PROVIDERS_WILL_BE_USED]: "Providers that will be used:",
  [BYOK_CONFIGURE_MISSING_PROVIDERS]: "Configure missing providers",
  [MODAL_API_KEYS_ARIA_LABEL]: "API keys configuration",

  // CAMPAIGNS
  [CAMPAIGNS_TITLE]: "Campaigns",
  [CAMPAIGNS_DESCRIPTION]:
    "Create your campaign, select & pay applicants and approve the content",
  [CAMPAIGNS_SEARCHBAR_PLACEHOLDER]: "Search campaigns",
  [CAMPAIGNS_TABLE_COLUMN_NAME]: "Name",
  [CAMPAIGNS_TABLE_COLUMN_PLATFORMS]: "Platforms",
  [CAMPAIGNS_TABLE_COLUMN_STATUS]: "Status",
  [CAMPAIGN_ACTIVATE]: "Activate campaign",
  [CAMPAIGN_DEACTIVATE]: "Deactivate campaign",
  [CAMPAIGN_ACTIVATE_TIME_CONFIRMATION]:
    "Are you sure you want to activate this campaign? Your campaign will be active for a minimum of 24 hours.",
  [CAMPAIGN_DEACTIVATE_TIME]:
    "You must wait 24 hours to deactivate the campaign since its last activation.",
  [CAMPAIGN_FINISHED_TIME]:
    "You must wait 24 hours to end the campaign since its last activation.",
  [CAMPAIGN_DEACTIVATE_APPLICANTS_ACCEPTED]:
    "You cannot deactivate the campaign until all accepted applicants have submitted their content.",
  [CAMPAIGN_FINISH_APPLICANTS_ACCEPTED]:
    "You cannot finish the campaign until all accepted applicants have submitted their content.",
  [CAMPAIGN_ACTIVATE_FIELDS_REQUIRED]:
    "This campaign has empty required fields. Complete them to activate it.",
  [CAMPAIGN_ACTIVATE_MIN_BUDGET_CREATOR]:
    "The budget for each content creator should not be less than {{value,currency}}.",
  [CAMPAIGN_ACTIVATE_TRAFFIC_LINK]: "The traffic link must be a valid URL.",
  [CAMPAIGN_ACTIVATE_HAS_COLLABORATION_USER_NAME_INSTAGRAM]:
    "The Instagram username is required if you will make a collaboration.",
  [CAMPAIGN_ACTIVATE_ATTACHMENT_LINK]:
    "The reference link of the campaign must be a valid URL.",
  [CAMPAIGN_FINISHED_CONFIRMATION]:
    "Are you sure you want to finish this campaign?",
  [CAMPAIGN_HAS_BEEN_FINISHED]: "The campaign has been finished.",
  [CAMPAIGN_FINISH_ONBOARDING]:
    "You have finished the tutorial, now you know how to generate more personalized collaborations with content creators.",

  // CAMPAIGN DETAIL
  [CAMPAIGN_DETAIL_TITLE]: "Campaign {{name}}",
  [CAMPAIGN_DETAIL_APPLICANTS_ACCEPTED_TITLE]: "Participants",
  [CAMPAIGN_DETAIL_APPLICANTS_PENDING_TITLE]: "Requests",
  [CAMPAIGN_DETAIL_APPLICANTS_INVITED_TITLE]: "Invited",
  [CAMPAIGN_DETAIL_CREATORS_INVITED_TITLE]: "Creators invited",
  [CAMPAIGN_DETAIL_CAMPAIGN_INFORMATION_TITLE]: "Campaign information",
  [CAMPAIGN_DETAIL_APPLICANT_PAYMENT_DESCRIPTION]:
    "Your payment has been successful. Now you must wait for {{influencerName}} to generate the content for your approval.",
  [CAMPAIGN_DETAIL_APPLICANT_PAYMENT_ADDITIONAL_DESCRIPTION]:
    "In addition, you can send a product redemption invitation to the content creator so that they can access your products for free.",
  [CAMPAIGN_DETAIL_REJECT_APPLICANT_CONFIRMATION]:
    "Are you sure you want to reject this applicant?",
  [CAMPAIGN_FIELDS_REQUIRED]:
    "Fields that are not advanced settings are required.",
  [CAMPAIGN_NAME_PLACEHOLDER]: "Campaign name",
  [CAMPAIGN_DESCRIPTION_PLACEHOLDER]: "Campaign description",
  [CAMPAIGN_GOAL_PLACEHOLDER]: "Campaign goal",
  [CAMPAIGN_BUDGET_PLACEHOLDER]: "Individual budget per content",
  [CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_PLACEHOLDER]:
    "With content published on social networks",
  [CAMPAIGN_PLATFORMS_PLACEHOLDER]: "Platforms for your campaign",
  [CAMPAIGN_TYPE_CONTENT_MEDIA_PLACEHOLDER]:
    "Type of content for your campaign",
  [CAMPAIGN_TYPE_CONTENT_PLACEHOLDER]: "Formats for your campaign",
  [CAMPAIGN_COPY_POST_PLACEHOLDER]: "Copy to accompany the content (optional)",
  [CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER]:
    "Link to where you want to direct traffic",
  [CAMPAIGN_HAS_COLLABORATION_PLACEHOLDER]:
    "I want the content to be posted with an Instagram collaboration",
  [CAMPAIGN_PRODUCT_ATTRIBUTES_PLACEHOLDER]:
    "Main product attributes to communicate",
  [CAMPAIGN_MESSAGE_CONTENT_PLACEHOLDER]:
    "Message to be communicated with the content",
  [CAMPAIGN_DATES_START_DATE_PLACEHOLDER]: "Campaign start date",
  [CAMPAIGN_DATES_END_DATE_PLACEHOLDER]: "Campaign end date",
  [CAMPAIGN_REPOST_PLACEHOLDER]:
    "Do you want the content creator to tag your profile?",
  [CAMPAIGN_REPOST_PLACEHOLDER_ITEM]: "{{platform}}'s username",
  [CAMPAIGN_AUDIENCE_LOCATION_PLACEHOLDER]:
    "Cities of interest to impact with your campaign",
  [CAMPAIGN_AGE_RANGE_PLACEHOLDER]:
    "Age range for content creators for your campaign",
  [CAMPAIGN_BRIEF_PLACEHOLDER]: "Brand brief",
  [CAMPAIGN_BRIEF_DESCRIPTION]:
    "It is a small creative document with all the detailed information and action guide for the campaign, must be in PDF format.",
  [CAMPAIGN_ATTACHMENT_FILE_PLACEHOLDER]: "Campaign content reference",
  [CAMPAIGN_ATTACHMENT_FILE_DESCRIPTION]:
    "An image or video that serves as a reference for content creators on how the campaign will be.",
  [CAMPAIGN_ATTACHMENT_LINK_TITLE]: "Campaign link reference",
  [CAMPAIGN_ATTACHMENT_LINK_DESCRIPTION]:
    "A link to another page with content that serves as a reference for content creators on how the campaign will be.",
  [CAMPAIGN_ATTACHMENT_LINK_PLACEHOLDER]: "Reference link",
  [CAMPAIGN_GENDERS_PLACEHOLDER]: "Genders for the campaign",
  [CAMPAIGN_REFERENCE_PROFILES_PLACEHOLDER]:
    "Profile(s) that can serve as reference",
  [CAMPAIGN_HASHTAG_PLACEHOLDER]: "Campaign hashtag",
  [CAMPAIGN_MESSAGE_TONE_PLACEHOLDER]: "Tone of your campaign message",
  [CAMPAIGN_ENVIRONMENT_PLACEHOLDER]:
    "Environment where content will be created",
  [CAMPAIGN_COLORS_CONTENT_PLACEHOLDER]: "Colors to appear in the content",
  [CAMPAIGN_PROHIBITED_COLORS_CONTENT_PLACEHOLDER]:
    "Colors not to appear in the content",
  [CAMPAIGN_KEY_WORDS_PLACEHOLDER]: "Keywords for your campaign",
  [CAMPAIGN_PROHIBITED_KEY_WORDS_PLACEHOLDER]:
    "Words not to be used during the campaign",
  [CAMPAIGN_OUTFIT_PLACEHOLDER]: "Recommended outfit",

  // CREATE CAMPAIGN
  [CREATE_CAMPAIGN_QUESTION]: "Question {{question}}",
  [CREATE_CAMPAIGN_ACCEPT_TERMS_DISCLAIMER]: `By creating a campaign, you are accepting {{NAME_BUSINESS}}'s terms and conditions.`,
  [CREATE_CAMPAIGN_NAME_EXAMPLE]: "Example campaign",
  [CREATE_CAMPAIGN_NAME_REQUIRED]: "Name is required",
  [CREATE_CAMPAIGN_DESCRIPTION_REQUIRED]: "Description is required",
  [CREATE_CAMPAIGN_BUDGET_REQUIRED]: "Budget is required",
  [CREATE_CAMPAIGN_BUDGET_MIN_VALUE]:
    "The budget for each content creator should not be less than {{value,currency}}",
  [CREATE_CAMPAIGN_PLATFORMS_REQUIRED]: "You must select at least one platform",
  [CREATE_CAMPAIGN_TYPE_CONTENT_MEDIA]:
    "You must select at least one type of content",
  [CREATE_CAMPAIGN_TYPE_CONTENT]: "You must select at least one format",
  [CREATE_CAMPAIGN_TRAFFIC_LINK_REQUIRED]:
    "The link to where you want to drive traffic is required.",
  [CREATE_CAMPAIGN_TRAFFIC_LINK_VALID]:
    "The link to where you want to drive traffic must be a valid URL.",
  [CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_REQUIRED]:
    "Product attributes are required",
  [CREATE_CAMPAIGN_MESSAGE_CONTENT_REQUIRED]:
    "The message to be communicated with the content is required",
  [CREATE_CAMPAIGN_DATES_REQUIRED]: "Both dates are required",
  [CREATE_CAMPAIGN_REPOST_HAS_COLLABORATION]:
    "As you will make a collaboration on Instagram, the Instagram username is required.",
  [CREATE_CAMPAIGN_AUDIENCE_LOCATION_REQUIRED]: "Cities are required",
  [CREATE_CAMPAIGN_ATTACHMENT_LINK]: "The URL must be valid",
  [CREATE_CAMPAIGN_HAS_BEEN_ACTIVATE]: "Campaign activated",
  [CREATE_CAMPAIGN_HAS_BEEN_SAVE]: "Campaign saved",
  [CREATE_CAMPAIGN_SAVE_PROGRESS_NAME_REQUIRED]:
    "To save the progress, you must at least enter the campaign name",
  [CREATE_CAMPAIGN_SAVE_PROGRESS]: "Your progress has been saved",
  [CREATE_CAMPAIGN_NAME_QUESTION]: "What will be the name of your campaign?",
  [CREATE_CAMPAIGN_NAME_PLACEHOLDER]: "New X shoe collection",
  [CREATE_CAMPAIGN_DESCRIPTION_QUESTION]:
    "Create an eye-catching and clear description of your campaign to encourage creators to participate!",
  [CREATE_CAMPAIGN_DESCRIPTION_PLACEHOLDER]:
    "The X shoe collection that will revolutionize the footwear market",
  [CREATE_CAMPAIGN_GOAL_QUESTION]: "What is the goal of your campaign?",
  [CREATE_CAMPAIGN_GOAL_PLACEHOLDER]: "Select an option",
  [CREATE_CAMPAIGN_GOAL_BRAND_AWARENESS_OPTION]: "Brand awareness",
  [CREATE_CAMPAIGN_GOAL_ENGAGEMENT_OPTION]: "Engagement",
  [CREATE_CAMPAIGN_GOAL_LEADS_OPTION]: "Leads",
  [CREATE_CAMPAIGN_GOAL_SALES_OPTION]: "Sales conversion",
  [CREATE_CAMPAIGN_GOAL_REQUIRED]: "You must select a goal",
  [CREATE_CAMPAIGN_BUDGET_QUESTION]:
    "How much are you willing to pay each content creator?",
  [CREATE_CAMPAIGN_BUDGET_DESCRIPTION]:
    "Based on the number of creators you need ({{quantity}}), we suggest a budget of {{budget,currency}}",
  [CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_QUESTION]: "Campaign type",
  [CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_DESCRIPTION]:
    "Mention on social networks means creators will post content mentioning your account. If you select no, you will simply receive the content.",
  [CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_PLACEHOLDER]:
    "Select an option",
  [CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_UGC_OPTION]:
    "UGC - User-generated content only",
  [CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_REQUIRED]:
    "You must select an option",
  [CREATE_CAMPAIGN_PLATFORMS]: "Which platforms do you want for your campaign?",
  [CREATE_CAMPAIGN_TYPE_CONTENT_MEDIA_QUESTION]:
    "What will be the type of content for your campaign?",
  [CREATE_CAMPAIGN_TYPE_CONTENT_QUESTION]:
    "What will be the format for your campaign?",
  [CREATE_CAMPAIGN_COPYWRITING_QUESTION]: `What would be the "copy" text that would accompany the content? (Optional)`,
  [CREATE_CAMPAIGN_COPYWRITING_PLACEHOLDER]:
    "The new X Shoes collection has been launched, dare to try them!",
  [CREATE_CAMPAIGN_TRAFFIC_LINK_QUESTION]:
    "What is the link where you want to take the traffic?",
  [CREATE_CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER]: "https://www.yourwebsite.com",
  [CREATE_CAMPAIGN_HAS_COLLABORATION_QUESTION]:
    "Do you want content to be published with an Instagram collaboration?",
  [CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_QUESTION]:
    "What are the main attributes of the product or service to be communicated with the content?",
  [CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_PLACEHOLDER]:
    "Novel, revolutionary, original, singular, etc.",
  [CREATE_CAMPAIGN_MESSAGE_CONTENT_QUESTION]:
    "What is the message to be communicated with the content?",
  [CREATE_CAMPAIGN_MESSAGE_CONTENT_PLACEHOLDER]:
    "It must be communicated that there is no other product like it on the market, because it is a new trend.",
  [CREATE_CAMPAIGN_DATES_QUESTION]:
    "What will be the start and end date of your campaign?",
  [CREATE_CAMPAIGN_DATES_DESCRIPTION]:
    "The duration of the campaign must be at least one week, so there is a mandatory space between the start date and the end date, and it must be created at least one week in advance.",
  [CREATE_CAMPAIGN_DATES_START_DATE_PLACEHOLDER]: "Campaign start date",
  [CREATE_CAMPAIGN_DATES_END_DATE_PLACEHOLDER]: "Campaign end date",
  [CREATE_CAMPAIGN_REPOST_QUESTION]:
    "If you want the content creator to tag your profile type the @. Otherwise, click next",
  [CREATE_CAMPAIGN_AUDIENCE_LOCATION_QUESTION]:
    "Which are the cities of interest where you want to impact with your campaign?",
  [CREATE_CAMPAIGN_AUDIENCE_LOCATION_PLACEHOLDER]: "Select cities",
  [CREATE_CAMPAIGN_AUDIENCE_LOCATION_ALL_OPTION]: "All",
  [CREATE_CAMPAIGN_AGE_RANGE_QUESTION]:
    "What is the age range that content creators should be for your campaign?",
  [CREATE_CAMPAIGN_UGC_CONTENT_FORMAT_QUESTION]:
    "What content style do you want for your campaign?",
  [CREATE_CAMPAIGN_UGC_CONTENT_FORMAT_PLACEHOLDER]: "Select a style",
  [CREATE_CAMPAIGN_BRIEF_QUESTION]: "Upload the brand brief",
  [CREATE_CAMPAIGN_BRIEF_DESCRIPTION]:
    "It is a small creative document with all the detailed information and action guide for the campaign, must be in PDF format.",
  [CREATE_CAMPAIGN_UPLOAD_BRIEF]: "Upload brief",
  [CREATE_CAMPAIGN_REMOVED_BRIEF]: "Remove brief",
  [CREATE_CAMPAIGN_ATTACHMENT_FILE_QUESTION]:
    "Upload a campaign content reference",
  [CREATE_CAMPAIGN_ATTACHMENT_FILE_DESCRIPTION]:
    "An image or video that serves as a reference for the content creators of how the content creators of what the campaign will look like.",
  [CREATE_CAMPAIGN_ATTACHMENT_LINK_QUESTION]:
    "Upload a reference to the campaign's content link",
  [CREATE_CAMPAIGN_ATTACHMENT_LINK_DESCRIPTION]:
    "A link to another page with content that will serve as a reference for the content content creators of what the campaign will look like.",
  [CREATE_CAMPAIGN_ATTACHMENT_LINK_PLACEHOLDER]: "https://www.yourbrand.com/",
  [CREATE_CAMPAIGN_QUANTITY_GENDER_QUESTION]:
    "What genres do you need for your campaign?",
  [CREATE_CAMPAIGN_REFERENCE_PROFILES_QUESTION]:
    "Do you have @ profile(s) that can serve as reference?",
  [CREATE_CAMPAIGN_REFERENCE_PROFILES_PLACEHOLDER]:
    "@xavi, @laura, @daniel, @maria, etc.",
  [CREATE_CAMPAIGN_HASHTAG_QUESTION]:
    "What will be the hashtag for your campaign?",
  [CREATE_CAMPAIGN_HASHTAG_PLACEHOLDER]: "#ShoesXTrend",
  [CREATE_CAMPAIGN_MESSAGE_TONE_QUESTION]:
    "How should the tone of your campaign message be?",
  [CREATE_CAMPAIGN_MESSAGE_TONE_PLACEHOLDER]:
    "Serious, jocular, calm, free, etc.",
  [CREATE_CAMPAIGN_ENVIRONMENT_QUESTION]:
    "What should the environment where the content will be made look like?",
  [CREATE_CAMPAIGN_ENVIRONMENT_PLACEHOLDER]:
    "Household, natural, commercial, free, etc.",
  [CREATE_CAMPAIGN_COLORS_CONTENT_QUESTION]:
    "What colors should be in the content?",
  [CREATE_CAMPAIGN_COLORS_CONTENT_PLACEHOLDER]: "Blue and white",
  [CREATE_CAMPAIGN_PROHIBITED_COLORS_CONTENT_QUESTION]:
    "What colors can NOT be in the content?",
  [CREATE_CAMPAIGN_PROHIBITED_COLORS_CONTENT_PLACEHOLDER]: "Red and black",
  [CREATE_CAMPAIGN_KEY_WORDS_QUESTION]:
    "What are the keywords of your campaign?",
  [CREATE_CAMPAIGN_KEY_WORDS_PLACEHOLDER]: "Revolutionary, trendy, new, etc.",
  [CREATE_CAMPAIGN_PROHIBITED_WORDS_QUESTION]:
    "What NOT to say during the campaign?",
  [CREATE_CAMPAIGN_PROHIBITED_WORDS_PLACEHOLDER]:
    "Words, details, reference to other brands, etc.",
  [CREATE_CAMPAIGN_OUTFIT_QUESTION]: "Is there any recommended outfit?",
  [CREATE_CAMPAIGN_OUTFIT_PLACEHOLDER]: "Recommended outfit",
  [CREATE_CAMPAIGN_OUTFIT_PLACEHOLDER]:
    "What should or should not be shown in the physical",
  [CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_TITLE]:
    "¡Ready! Here is your content script",
  [CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_TITLE_GENERATING]:
    "We are generating a content script for your campaign...",
  [CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_SCRIPT_LABEL]:
    "Campaign script",

  //APPLICANTS
  [APPLICANTS_STATUS_PENDING]: "Pending",
  [APPLICANTS_STATUS_ACCEPTED]: "Content pending",
  [APPLICANTS_STATUS_REJECTED]: "Rejected",
  [APPLICANTS_STATUS_CONTENT_SUBMITTED]: "Content to review",
  [APPLICANTS_STATUS_CONTENT_REVISIONS]: "Content submitted",
  [APPLICANTS_STATUS_CONTENT_PENDING_SOCIAL]: "Pending social media posting",
  [APPLICANTS_STATUS_CONTENT_PENDING_ANALYTICS]: "Pending analytics",
  [APPLICANTS_STATUS_DELIVERED]: "Content ready",
  [APPLICANT_CONTENT_OF_CREATOR]: "Content of {{influencerName}}",
  [APPLICANT_REVISION_PLACEHOLDER]: "Send a review to the content creator",

  //REPORTS SHOP
  [START_DATE_PLACEHOLDER]: "Start Date",
  [END_DATE_PLACEHOLDER]: "End Date",
  [LIKES]: "Likes",
  [SHARES]: "Shares",

  //GALLERY
  [GALLERY_TITLE]: "Content",
  [MODAL_GALLERY_ARIA_LABEL]: "Brand content gallery modal",
  [MODAL_GALLERY_EMPTY_CONTENT]: "There is no content in the gallery yet",
  [SELECT_ACCOUNT_TO_LOAD_GALLERY_CONTENT]:
    "Select a platform and an account to load content.",
  [SELECT_YOUTUBE_ACCOUNT_TO_LOAD_GALLERY_CONTENT]:
    "Select a YouTube Account to load Content",
  [MODAL_GALLERY_NO_MORE_CONTENT]: "No more content to display",
  [MODAL_FILTERS_LABEL]: "Filters",

  // ADGROUP PLACEMENTS
  [META_ADGROUP_PLACEMENTS_TYPE_ADVANTAGE]:
    "Advantage+ placements (recommended)",
  [META_ADGROUP_PLACEMENTS_TYPE_ADVANTAGE_DESCRIPTION]:
    "Use Advantage+ placements to maximize your budget and help show your ads to more people.",
  [META_ADGROUP_PLACEMENTS_TYPE_MANUAL]: "Manual Placements",
  [META_ADGROUP_PLACEMENTS_TYPE_MANUAL_DESCRIPTION]:
    "Manually choose the places to show your ad. The more placements you select, the more opportunities you'll have to reach your target audience.",

  //MODAL_MEDIA
  [MODAL_MEDIA_ARIA_LABEL]: "Modal media",

  //MODAL UPLOAD TIKTOK
  [MODAL_UPLOAD_TIKTOK_ARIA_LABEL]: "Upload video to TikTok modal",
  [MODAL_UPLOAD_TIKTOK_TITLE]: "Upload video to TikTok",
  [MODAL_UPLOAD_FAILED_GET_CONFIGURATION]:
    "An error occurred while getting the configuration. Please try again later or contact support.",
  [MODAL_UPLOAD_CONTENT_UPLOADED]: "Content uploaded!",
  [MODAL_UPLOAD_TIKTOK_VIDEO_UPLOADED_DESCRIPTION]:
    "The video has been successfully uploaded to TikTok and will appear on your profile in a moment.",
  [MODAL_UPLOAD_FAILED_GENERATE_DESCRIPTION]:
    "Failed to retrieve collaboration information. Please contact support.",
  [MODAL_UPLOAD_TIKTOK_DESCRIPTION_LABEL]: "Description",
  [MODAL_UPLOAD_TIKTOK_DESCRIPTION_PLACEHOLDER]:
    "Remember to add a catchy description for your video, tag the users appearing in it, and add relevant hashtags.",
  [MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_LABEL]: "Who can watch this video?",
  [MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_PUBLIC_OPTION]: "Public",
  [MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_FOLLOWERS_OPTION]: "Followers",
  [MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_ONLY_I_OPTION]: "Only me",
  [MODAL_UPLOAD_TIKTOK_ALLOW_USERS_PLACEHOLDER]: "Allow users to",
  [MODAL_UPLOAD_TIKTOK_ALLOW_USERS_COMMENT_OPTION]: "Comment",
  [MODAL_UPLOAD_TIKTOK_ALLOW_USERS_DUOS_OPTION]: "Duets",
  [MODAL_UPLOAD_TIKTOK_ALLOW_USERS_CUT_OPTION]: "Cut",

  //MODAL MAP RADIUS
  [MARKER_LIST]: "Marker List",
  [MARKER_NUMBER_LIST]: "Marker #{{value}}",
  [MARKER_TYPE]: "Type",
  [MARKER_LNG]: "Lng",
  [MARKER_LAT]: "Lat",
  [MARKER_RADIUS]: "Radius",

  //MODAL PREVIEW OPTIMIZATION
  [MODAL_PREVIEW_OPTIMIZATIONS_TITLE]: "Apply Changes",
  [MODAL_PREVIEW_OPTIMIZATIONS_DESCRIPTION]:
    "Review and approve the changes that will be applied to your campaign",
  [WHY_THIS_OPTIMIZATION]: "Why this optimization?",

  //MODAL STEP DATA
  [MODAL_STEP_DATA_TITLE]: "Information to modify",

  //MODAL MESSAGE TEMPLATE
  [MODAL_MESSAGE_TEMPLATE_TITLE]: "Create a message template",
  [MODAL_MESSAGE_TEMPLATE_DESCRIPTION]:
    "Set up a message configuration when users click on your ad.",

  //MODAL PRODUCT TAGS META
  [MODAL_PRODUCT_TAGS_TITLE_META]: "Product tags",
  [MODAL_PRODUCT_TAGS_DESCRIPTION_META]:
    "Enable this option to show a product information tag on your ad",

  //MODAL CATALOG LABELS
  [MODAL_CATALOG_LABELS_TITLE]: "Catalog labels",
  [MODAL_CATALOG_LABELS_DESCRIPTION]: "Configure catalog labels for your ad",

  //MODAL SITE LINKS
  [MODAL_SITE_LINKS_TITLE]: "Site Links",
  [MODAL_SITE_LINKS_DESCRIPTION]: "Configure site links for your ad",
  [MODAL_SITE_LINK_TITLE]: "Label",
  [MODAL_SITE_LINK_IMAGE_URL]: "Thumbnail",
  [MODAL_SITE_LINK_URL]: "URL",

  //MODAL INSTANT FORMS LIST
  [MODAL_INSTANT_FORMS_LIST_TITLE]: "Instant Forms",
  [MODAL_INSTANT_FORMS_LIST_DESCRIPTION]:
    "Select the form you want to use to capture leads.",
  [MODAL_INSTANT_FORMS_EMPTY_TEXT]: "No instant forms created",

  //MODAL LEAD FORMS LIST
  [MODAL_LEAD_FORMS_LIST_TITLE]: "Forms",
  [MODAL_LEAD_FORMS_LIST_DESCRIPTION]:
    "Select a lead form for your ad. A non-English form only serves campaigns in the matching language.",
  [MODAL_LEAD_FORMS_EMPTY_TEXT]: "No lead forms created",
  [MODAL_LEAD_FORMS_DUPLICATE_AND_EDIT]: "Duplicate and edit",
  [MODAL_LEAD_FORMS_VIEW]: "View",
  [MODAL_LEAD_FORMS_COPY_NAME_PREFIX]: "Copy of",

  //MODAL CREATE LEAD FORM
  [MODAL_CREATE_LEAD_FORM_TITLE]: "Create Form",
  [MODAL_VIEW_LEAD_FORM_TITLE]: "View Form",
  [INSTANT_FORM_PREVIEW_MORE]: "+{{count}} more",
  [MODAL_CREATE_LEAD_FORM_DESCRIPTION]:
    "Create a LinkedIn lead form to capture leads in your campaign",
  [MODAL_VIEW_LEAD_FORM_DESCRIPTION]:
    "Review the form details. You cannot edit or create in this view.",
  [MODAL_VIEW_LEAD_FORM_LOAD_ERROR]:
    "We couldn't load the form details. Please try again in a few minutes.",
  [MODAL_CREATE_LEAD_FORM_LOCALE_WARNING]:
    "A non-English form only serves campaigns in the matching language",
  [MODAL_CREATE_LEAD_FORM_NAME]: "Form name",
  [MODAL_CREATE_LEAD_FORM_HEADLINE]: "Headline",
  [MODAL_CREATE_LEAD_FORM_DETAILS]: "Details",
  [MODAL_CREATE_LEAD_FORM_SECTION_FORM]: "Form details",
  [MODAL_CREATE_LEAD_FORM_SECTION_CONTACT]: "Contact details",
  [MODAL_CREATE_LEAD_FORM_SECTION_PRIVACY]: "Data privacy",
  [MODAL_CREATE_LEAD_FORM_SECTION_CONFIRMATION]: "Confirmation",
  [MODAL_CREATE_LEAD_FORM_PROFILE_FIELDS]: "Profile fields",
  [MODAL_CREATE_LEAD_FORM_PROFILE_FIRST_NAME]: "First name",
  [MODAL_CREATE_LEAD_FORM_PROFILE_LAST_NAME]: "Last name",
  [MODAL_CREATE_LEAD_FORM_PROFILE_EMAIL]: "Email",
  [MODAL_CREATE_LEAD_FORM_PROFILE_PHONE]: "Phone number",
  [MODAL_CREATE_LEAD_FORM_PROFILE_CITY]: "City",
  [MODAL_CREATE_LEAD_FORM_PROFILE_STATE]: "State",
  [MODAL_CREATE_LEAD_FORM_PROFILE_COUNTRY]: "Country",
  [MODAL_CREATE_LEAD_FORM_PROFILE_ZIP]: "Zip code",
  [MODAL_CREATE_LEAD_FORM_PROFILE_JOB_TITLE]: "Job title",
  [MODAL_CREATE_LEAD_FORM_PROFILE_COMPANY]: "Company name",
  [MODAL_CREATE_LEAD_FORM_PROFILE_LINKEDIN]: "LinkedIn profile URL",
  [MODAL_CREATE_LEAD_FORM_CUSTOM_QUESTIONS]: "Custom questions",
  [MODAL_CREATE_LEAD_FORM_ADD_CUSTOM_QUESTION]: "Add custom question",
  [MODAL_CREATE_LEAD_FORM_CUSTOM_QUESTION_HINT]:
    "Prefer multiple choice over single-line text when possible. Profile fields and custom questions cannot add up to more than 12.",
  [MODAL_CREATE_LEAD_FORM_QUESTION_TITLE]: "Question",
  [MODAL_CREATE_LEAD_FORM_QUESTION_TYPE]: "Question type",
  [MODAL_CREATE_LEAD_FORM_QUESTION_TYPE_TEXT]: "Single-line text",
  [MODAL_CREATE_LEAD_FORM_QUESTION_TYPE_MULTIPLE_CHOICE]: "Multiple choice",
  [MODAL_CREATE_LEAD_FORM_ADD_OPTION]: "Add option",
  [MODAL_CREATE_LEAD_FORM_OPTION]: "Option",
  [MODAL_CREATE_LEAD_FORM_PRIVACY_POLICY_URL]: "Privacy policy URL",
  [MODAL_CREATE_LEAD_FORM_PRIVACY_POLICY_TEXT]: "Privacy policy text",
  [MODAL_CREATE_LEAD_FORM_THANK_YOU_MESSAGE]: "Thank-you message",
  [MODAL_CREATE_LEAD_FORM_LANDING_PAGE_URL]: "Landing page URL",
  [MODAL_CREATE_LEAD_FORM_CTA]: "Thank-you call to action",
  [MODAL_CREATE_LEAD_FORM_CTA_VISIT_COMPANY_WEBSITE]: "Visit company website",
  [MODAL_CREATE_LEAD_FORM_CTA_LEARN_MORE]: "Learn more",
  [MODAL_CREATE_LEAD_FORM_CTA_VIEW_NOW]: "View now",
  [MODAL_CREATE_LEAD_FORM_CTA_DOWNLOAD_NOW]: "Download now",
  [MODAL_CREATE_LEAD_FORM_CTA_TRY_NOW]: "Try now",
  [MODAL_CREATE_LEAD_FORM_MIN_OPTIONS]: "Add between 2 and 15 options",
  [MODAL_CREATE_LEAD_FORM_MAX_CUSTOM_QUESTIONS]:
    "Profile fields and custom questions cannot add up to more than 12",

  //MODAL CREATE INSTANT FORM
  [MODAL_CREATE_INSTANT_FORM_TITLE]: "Create an instant form",
  [MODAL_CREATE_INSTANT_FORM_DESCRIPTION]: "Create a form to capture leads",
  [MODAL_CREATE_INSTANT_FORM_TYPE_MORE_VOLUME]: "More volume",
  [MODAL_CREATE_INSTANT_FORM_TYPE_MORE_VOLUME_DESCRIPTION]:
    "Create a form that is quick to fill out and submit on mobile.",
  [MODAL_CREATE_INSTANT_FORM_TYPE_HIGHER_INTENT]: "Higher intent",
  [MODAL_CREATE_INSTANT_FORM_TYPE_HIGHER_INTENT_DESCRIPTION]:
    "Add a step that lets people review and confirm their info before submitting.",
  [MODAL_CREATE_INSTANT_FORM_QUESTIONS_HEADLINE]: "Questions page headline",
  [MODAL_CREATE_INSTANT_FORM_CONTACT_FIELDS]: "Contact information",
  [MODAL_CREATE_INSTANT_FORM_CONTACT_FULL_NAME]: "Full name",
  [MODAL_CREATE_INSTANT_FORM_CONTACT_WORK_EMAIL]: "Work email",
  [MODAL_CREATE_INSTANT_FORM_MAX_QUESTIONS]:
    "Contact information and custom questions can't add up to more than {{value}}",
  [MODAL_CREATE_INSTANT_FORM_PRIVACY_LINK_TEXT]: "Link text",
  [MODAL_CREATE_INSTANT_FORM_ADDITIONAL_ACTION]: "Additional action",
  [MODAL_CREATE_INSTANT_FORM_ACTION_VIEW_WEBSITE]: "Go to website",
  [MODAL_CREATE_INSTANT_FORM_ACTION_VIEW_WEBSITE_DESCRIPTION]:
    "Share a URL for people to visit your website.",
  [MODAL_CREATE_INSTANT_FORM_ACTION_BOOK_TIME]: "Book time",
  [MODAL_CREATE_INSTANT_FORM_ACTION_BOOK_TIME_DESCRIPTION]:
    "Allow people to open your Calendly or any custom scheduling link to reserve time.",
  [MODAL_CREATE_INSTANT_FORM_WEBSITE_URL]: "Website URL",
  [MODAL_CREATE_INSTANT_FORM_SCHEDULING_LINK]: "Scheduling link",
  [MODAL_CREATE_INSTANT_FORM_SCHEDULING_PROVIDER]:
    "Detected provider: {{provider}}",
  [MODAL_CREATE_INSTANT_FORM_BOOK_TIME_HINT]:
    "On Facebook the calendar is shown inside the form. On Instagram it opens in the in-app browser.",
  [MODAL_CREATE_INSTANT_FORM_BUTTON_TEXT]: "Button text",
  [LEAD_FORM_RECOMMENDATION_GENERATING]: "Generating a recommended form...",
  [LEAD_FORM_RECOMMENDATION_CANCEL]: "Cancel recommendation",
  [LEAD_FORM_RECOMMENDATION_FAILED]:
    "We couldn't generate the recommended form. You can fill it in manually.",
  [LEAD_FORM_RECOMMENDATION_CAMPAIGN_GENERATING]:
    "The campaign is still generating. You can fill in the form manually.",

  //MODAL INSTANT EXPERIENCE LIST
  [MODAL_INSTANT_EXPERIENCE_LIST_TITLE]: "Instant experiences",
  [MODAL_INSTANT_EXPERIENCE_LIST_DESCRIPTION]:
    "Select the instant experience you want to use in your ad.",
  [MODAL_INSTANT_EXPERIENCE_EMPTY_TEXT]: "No instant experiences created",

  //MODAL EDIT PRODUCTS CONFIGURATION
  [MODAL_EDIT_PRODUCTS_CONFIGURATION_TITLE]: "Products configuration",
  [MODAL_EDIT_PRODUCTS_CONFIGURATION_DESCRIPTION]:
    "Edit the products configuration that you want to promote in your ad",
  [PRODUCTS_CONFIGURATION_SYNC_DELAY_CAPTION]:
    "Changes or new products can take up to 24 hours to sync and appear here.",
  [CATEGORY_ANIMALS_PET_SUPPLIES]: "Animals & Pet Supplies",
  [CATEGORY_ARTS_ENTERTAINMENT]: "Arts & Entertainment",
  [CATEGORY_BUSINESS_INDUSTRIAL]: "Business & Industrial",
  [CATEGORY_CAMERAS_OPTICS]: "Cameras & Optics",
  [CATEGORY_CLOTHING_ACCESSORIES]: "Clothing & Accessories",
  [CATEGORY_ELECTRONICS]: "Electronics",
  [CATEGORY_FOOD_BEVERAGES]: "Food, Beverages & Tobacco",
  [CATEGORY_FURNITURE]: "Furniture",
  [CATEGORY_HEALTH_BEAUTY]: "Health & Beauty",
  [CATEGORY_HOME_GARDEN]: "Home & Garden",
  [CATEGORY_BABY_TODDLER]: "Baby & Toddler",
  [CATEGORY_HARDWARE]: "Hardware",
  [CATEGORY_MATURE]: "Mature",
  [CATEGORY_MEDIA]: "Media",
  [CATEGORY_VEHICLES_PARTS]: "Vehicles & Parts",
  [CATEGORY_OFFICE_SUPPLIES]: "Office Supplies",
  [CATEGORY_SPORTING_GOODS]: "Sporting Goods",
  [CATEGORY_TOYS_GAMES]: "Toys & Games",
  [CATEGORY_SOFTWARE]: "Software",
  [CATEGORY_LUGGAGE_BAGS]: "Luggage & Bags",
  [CATEGORY_RELIGIOUS_CEREMONIAL]: "Religious & Ceremonial",

  //MODAL EDIT PLACEMENTS META
  [MODAL_EDIT_PLACEMENTS_META_TITLE]: "Edit placements",
  [MODAL_EDIT_PLACEMENTS_META_DESCRIPTION]:
    "Edit the creative for each specific placement",
  [MODAL_EDIT_GROUP_CREATIVE_META_TITLE]: "Edit placement creative",
  [MODAL_EDIT_GROUP_CREATIVE_META_DESCRIPTION]:
    "Adjust the creative for this placement group",
  [PLACEMENT_META_USE]: "Use",
  [PLACEMENT_META_RESIZE]: "Resize",
  [PLACEMENT_META_SELECT_OTHER_CONTENT]: "Select other content",

  //MODAL EDIT ADVANTAGE ENHANCES META
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_TITLE]: "Creative Advantage Enhancements",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_DESCRIPTION]:
    "Allow Meta to apply these enhancements to your ads when their predictions determine that it will help improve performance the most. Enabled enhancements will show on less than 5% of your ad impressions.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_STANDARD_ENHANCES_TITLE]: "Standard Enhances",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_STANDARD_ENHANCES_DESCRIPTION]: `Set of enhances that may include: <br/>
        <ol>
        <li>- Automatic adjustment of the ad's aspect ratio</li>    
        <li>- Application of templates in certain locations for better visibility</li>    
        <li>- Display relevant comments below the ad</li>    
        </ol>`,
  [MODAL_EDIT_ADVANTAGE_ENHANCES_AUTO_CROP_TITLE]: "Auto Crop",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_AUTO_CROP_DESCRIPTION]:
    "We will automatically adjust the aspect ratio of your ad's creative when it can improve performance.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_TEXT_OPTIMIZATIONS_TITLE]:
    "Text Optimizations",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_TEXT_OPTIMIZATIONS_DESCRIPTION]:
    "We will automatically adjust the aspect ratio of your ad's creative when it can improve performance.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_INLINE_COMMENT_TITLE]: "Inline Comment",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_INLINE_COMMENT_DESCRIPTION]:
    "We will display the most relevant comment below your ad on Facebook and Instagram.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_ENHANCE_CTA_TITLE]: "Enhance CTA",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_ENHANCE_CTA_DESCRIPTION]:
    "We'll pair key phrases from your ad sources with your CTA. You can view all the phrases we've collected before running your ad.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_TEMPLATES_TITLE]: "Image Templates",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_TEMPLATES_DESCRIPTION]:
    "We will add overlays that show text you have provided along with your selected ad creative when it is likely to improve performance.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_ANIMATION_TITLE]: "Image Animation",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_ANIMATION_DESCRIPTION]:
    "Automatically add common movements like panning, zooming, rotating and more to your eligible images and transform them into short, engaging videos.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_CV_TRANSFORMATION_TITLE]: "3D Transformation",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_CV_TRANSFORMATION_DESCRIPTION]:
    "We will add 3D motion and depth to your image when likely to improve performance.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_IMAGE_BRIGHTNESS_AND_CONTRAST_TITLE]:
    "Image Brightness & Contrast",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_IMAGE_BRIGHTNESS_AND_CONTRAST_DESCRIPTION]:
    "We will adjust the brightness and contrast of your image when likely to improve performance. The stock image shown does not represent your ad.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_VIDEO_FILTERING_TITLE]: "Video Filtering",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_VIDEO_FILTERING_DESCRIPTION]:
    "We will add color and visual sharpening enhancements to make your video more engaging when likely to improve performance.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_DESCRIPTION_AUTOMATION_TITLE]:
    "Description Automation",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_DESCRIPTION_AUTOMATION_DESCRIPTION]:
    "We will dynamically choose when to show your carousel description.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_PROFILE_CARD_TITLE]: "Profile Card",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_PROFILE_CARD_DESCRIPTION]:
    "We will add a card at the end with your Page profile picture.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_CAROUSEL_TO_VIDEO_TITLE]: "Carousel to Video",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_CAROUSEL_TO_VIDEO_DESCRIPTION]:
    "Show ads with multiple images as a video slideshow when likely to increase performance.",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_MEDIA_ORDER_TITLE]: "Media Order",
  [MODAL_EDIT_ADVANTAGE_ENHANCES_MEDIA_ORDER_DESCRIPTION]:
    "We will automatically show the best performing card first.",

  //MODAL KEYWORDS
  [MODAL_EDIT_KEYWORD_TITLE]: "Edit Keyword",
  [MODAL_ADD_KEYWORDS_TITLE]: "Add Keywords",

  //MODAL IMPORT ADS CAMPAIGN
  [MODAL_IMPORT_ADS_CAMPAIGN_TITLE]: "Import Campaign",
  [MODAL_IMPORT_ADS_CAMPAIGN_DESCRIPTION]: "Select a campaign to import",
  [MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_TITLE]: "Import Successful",
  [MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_DESCRIPTION]:
    "Your campaign was imported successfully. Imported campaigns are read-only, but you can view metrics and generate reports.",
  [ALERT_IMPORTED_CAMPAIGN_READONLY_DESCRIPTION]:
    "Imported campaigns are read-only, but you can view metrics and generate reports.",

  //MODAL UPLOAD INSTAGRAM
  [MODAL_UPLOAD_INSTAGRAM_ARIA_LABEL]: "Upload media to Instagram modal",
  [MODAL_UPLOAD_INSTAGRAM_TITLE]: "Upload media to Instagram",
  [MODAL_UPLOAD_INSTAGRAM_CONTENT_UPLOADED_DESCRIPTION]:
    "The content has been successfully uploaded to Instagram and will appear on your profile in a moment.",
  [MODAL_UPLOAD_INSTAGRAM_DESCRIPTION_LABEL]: "Description",
  [MODAL_UPLOAD_INSTAGRAM_DESCRIPTION_PLACEHOLDER]:
    "Remember to add a catchy description for your content, tag the users appearing in it, and add relevant hashtags.",
  [MODAL_UPLOAD_INSTAGRAM_TYPE_LABEL]: "Type",
  [MODAL_UPLOAD_INSTAGRAM_TYPE_POST_LABEL]: "Post",
  [MODAL_UPLOAD_INSTAGRAM_TYPE_STORY_LABEL]: "Story",
  [MODAL_UPLOAD_INSTAGRAM_TYPE_REEL_LABEL]: "Reel",

  //MODAL CANVA
  [MODAL_CANVA_ARIA_LABEL]: "Modal to design in Canva",
  [MODAL_CANVA_TITLE]: "Design in Canva",
  [MODAL_CANVA_DESCRIPTION]:
    "Generate creative designs to use in {{NAME_BUSINESS}}",
  [MODAL_CANVA_CREATING_DESIGN]:
    "We are generating a design area, please wait a moment.",
  [MODAL_CANVA_DESIGN_NOT_CREATED]:
    "An error occurred and a design area could not be created",
  [MODAL_CANVA_DESIGN_NOT_RETRIEVED]:
    "An error occurred and the design could not be retrieved",
  [MODAL_CANVA_IS_EDITING_IN_CANVA]:
    "Return to {{NAME_BUSINESS}} when you finish editing your content in Canva",
  [MODAL_CANVA_IS_GETTING_YOUR_DESIGN]:
    "We are recovering your most recent design",
  [MODAL_CANVA_IS_GETTING_YOUR_FINAL_DESIGN]:
    "We are exporting your final design",
  [MODAL_CANVA_INFORMATION_SAVE_DESIGN]:
    "Once you finish editing your content in canva, close the tab and it will automatically load here.",
  [MODAL_CANVA_IMPORT_IMAGES_ONLY_WARNING_DESCRIPTION]:
    "You can only import images from Canva. You can't import videos.",
  [MODAL_CANVA_IMAGE_CONFIG_TITLE]: "Create Content with Canva",
  [MODAL_CANVA_IMAGE_CONFIG_DESCRIPTION]:
    "Select the content type and its dimensions",
  [MODAL_CANVA_IMAGE_CONFIG_TYPE_LABEL]: "Content type",
  [MODAL_CANVA_IMAGE_CONFIG_WIDTH_LABEL]: "Width (px)",
  [MODAL_CANVA_IMAGE_CONFIG_HEIGHT_LABEL]: "Height (px)",
  [MODAL_CANVA_IMAGE_CONFIG_CREATE_BUTTON]: "Create design",
  [MODAL_CANVA_IMAGE_CONFIG_CANCEL_BUTTON]: "Cancel",
  [MODAL_CANVA_ACCOUNT_LABEL]: "Canva Account",
  [MODAL_GOOGLE_DRIVE_ACCOUNT_LABEL]: "Google Drive Account",
  [MODAL_GOOGLE_DRIVE_ACCOUNT_TITLE]: "Import From Google Drive",
  [MODAL_GOOGLE_DRIVE_ACCOUNT_DESCRIPTION]:
    "Select the Google Drive account to import from",
  [MODAL_GOOGLE_DRIVE_ACCOUNT_CONFIRM_BUTTON]: "Continue",
  [GOOGLE_DRIVE_CONFIGURING_FILE_SELECTOR]: "Configuring file selector...",
  [GOOGLE_DRIVE_OPENING_SELECTOR]: "Opening Google Drive selector...",
  [GOOGLE_DRIVE_IMPORTING_FILES]: "Importing files from Google Drive...",
  [MODAL_CANVA_FOLDER_LABEL]: "Canva Folder",
  [MODAL_CANVA_IMAGE_CONFIG_EDIT_BUTTON]: "Edit",
  [MODAL_CANVA_IMAGE_CONFIG_EDIT_TITLE]: "Edit with Canva",
  [MODAL_CANVA_IMAGE_CONFIG_EDIT_DESCRIPTION]:
    "Select the account you want to edit with",
  [MODAL_CANVA_DISCONNECT_TITLE]: "Disconnect Canva Account",
  [MODAL_CANVA_DISCONNECT_DESCRIPTION]:
    "Select the account you want to disconnect",
  [MODAL_CANVA_DISCONNECT_BUTTON]: "Disconnect",
  [IMAGE_TYPE_PORTRAIT_LABEL]: "Portrait",
  [IMAGE_TYPE_LANDSCAPE_LABEL]: "Landscape",
  [IMAGE_TYPE_SQUARE_LABEL]: "Square",
  [ERROR_WIDTH_RANGE]: "Width must be between 100 and 5000 pixels",
  [ERROR_HEIGHT_RANGE]: "Height must be between 100 and 5000 pixels",

  //MODAL VERIFY INTEGRATION SCOPES
  [MODAL_VERIFY_INTEGRATION_SCOPES_TITLE]: "Some Permissions Are Missing",
  [MODAL_VERIFY_INTEGRATION_SCOPES_DESCRIPTION]:
    "We detected that one or more connections are missing permissions required to use new platform features. Reconnect them below.",

  //MODAL CUSTOM AUDIENCES
  [MODAL_CUSTOM_AUDIENCES_ARIA_LABEL]: "Custom audiences configuration",
  [MODAL_CUSTOM_AUDIENCES_TITLE]: "Custom Audiences Configuration",
  [MODAL_CUSTOM_AUDIENCES_DESCRIPTION]:
    "Set up a custom audience to reach a specific group of people",
  [MODAL_CUSTOM_AUDIENCES_EMPTY_TEXT]: "No audiences created",

  //MODAL CUSTOM AUDIENCES EXCLUDE
  [MODAL_EXCLUDED_CUSTOM_AUDIENCES_ARIA_LABEL]:
    "Excluded audiences configuration",
  [MODAL_EXCLUDED_CUSTOM_AUDIENCES_TITLE]: "Excluded Audiences Configuration",
  [MODAL_EXCLUDED_CUSTOM_AUDIENCES_DESCRIPTION]:
    "Set up a custom audience to exclude a specific group of people",

  //MODAL SAVED AUDIENCES
  [MODAL_SAVED_AUDIENCES_TITLE]: "Saved Audiences",
  [MODAL_SAVED_AUDIENCES_DESCRIPTION]:
    "Load a saved audience to use in your campaign",

  //MODAL CREATE CUSTOM AUDIENCE
  [MODAL_CREATE_CUSTOM_AUDIENCE_ARIA_LABEL]: "Custom audience configuration",
  [MODAL_CREATE_CUSTOM_AUDIENCE_TITLE]: "Custom audience configuration",
  [MODAL_CREATE_CUSTOM_AUDIENCE_DESCRIPTION]: "Configure a new custom audience",
  [MODAL_CREATE_CUSTOM_AUDIENCE_UPLOAD_CSV_CUSTOMER_LIST]:
    "Upload a CSV file with your customer list",

  //MODAL CREATE IDENTITY TIKTOK BUSINESS
  [MODAL_CREATE_IDENTITY_TIKTOK_BUSINESS_TITLE]: "Create a TikTok identity",
  [MODAL_CREATE_IDENTITY_TIKTOK_BUSINESS_DESCRIPTION]:
    "Create an identity for your TikTok ads. This identity (name and logo) will be displayed as a profile in your ads so that users can identify your brand",
  [TIKTOK_CREATE_AD_ACCOUNT_OPTION]: "Create Ad Account",
  [TIKTOK_CREDIT_BANNER_EYEBROW]: "TikTok credit",
  [TIKTOK_CREDIT_BANNER_TITLE]:
    "of your ad spend back as TikTok credit for 12 months",
  [TIKTOK_CREDIT_BANNER_DESCRIPTION_PREFIX]: "All you have to do is",
  [TIKTOK_CREDIT_BANNER_DESCRIPTION_HIGHLIGHT]:
    "create your TikTok ad account in {{NAME_BUSINESS}}",
  [TIKTOK_CREDIT_BANNER_CTA]: "Create my TikTok account in {{NAME_BUSINESS}}",
  [TIKTOK_CREDIT_BADGE_TOOLTIP]:
    "This account was created in {{NAME_BUSINESS}}: you get 4% of your ad spend back as TikTok credit for 12 months.",
  [AD_ACCOUNT_CREATED_FROM_BUSINESS]: "Created from {{NAME_BUSINESS}}",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_TITLE]: "Create a TikTok Ad Account",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_DESCRIPTION]:
    "Choose the Business Center where the account will be created and enter the advertiser details.",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_BUSINESS_CENTER]: "Business Center",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_NAME]: "Ad account name",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_COMPANY]: "Company name",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_INDUSTRY]: "Industry",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_COUNTRY]: "Company registration country",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_CURRENCY]: "Currency",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_CURRENCY_HELPER]:
    "It must match the Business Center currency",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_TIMEZONE]: "Time zone",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_REVIEW_NOTE]:
    "We recommend opening TikTok Ads Manager, since TikTok may ask for some details that can only be filled there, such as a verification or adding a payment method. Once TikTok approves your account, you can use it in {{NAME_BUSINESS}}.",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_CREDIT_ALERT]:
    "Get 4% of your ad spend back as TikTok credit for 12 months with the account you create from {{NAME_BUSINESS}}.",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_NO_BUSINESS_CENTERS]:
    "We could not find any Business Center. Connect your TikTok account to continue.",
  [MODAL_CREATE_AD_ACCOUNT_TIKTOK_SUCCESS_TITLE]: "Ad Account Created",

  [GUIDE_TIKTOK_AD_ACCOUNT_EYEBROW]: "Guide",
  [GUIDE_TIKTOK_AD_ACCOUNT_TITLE]: "Create a TikTok Ad Account",
  [GUIDE_TIKTOK_AD_ACCOUNT_INTRO]:
    "Create the ad account in {{NAME_BUSINESS}}. TikTok still has to approve the account and the billing details before ads can run.",
  [GUIDE_TIKTOK_AD_ACCOUNT_BACK]: "Back to Ad Accounts",
  [GUIDE_TIKTOK_AD_ACCOUNT_LINK]: "View the Guide",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP]: "Step {{step}}",
  [GUIDE_TIKTOK_AD_ACCOUNT_PATH_SETTINGS]: "Settings",
  [GUIDE_TIKTOK_AD_ACCOUNT_PATH_AD_ACCOUNTS]: "Ad Accounts",
  [GUIDE_TIKTOK_AD_ACCOUNT_PATH_CONNECT]: "Connect TikTok",
  [GUIDE_TIKTOK_AD_ACCOUNT_PATH_CREATE]: "Create Ad Account",
  [GUIDE_TIKTOK_AD_ACCOUNT_PATH_ADS_MANAGER]: "TikTok Ads Manager",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_TITLE]: "Open Ad Accounts and Connect TikTok",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_BODY]:
    "Open Settings in the side menu, then open Ad Accounts. Under Connect more platforms, click Connect TikTok and finish the TikTok for Business authorization.",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_ALT]:
    "Settings on Ad Accounts, with the Connect TikTok button",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_AUTH_ALT]:
    "TikTok for Business authorization window to confirm permissions",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_TITLE]: "Choose Create Ad Account",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_BODY]:
    "Open the connected TikTok account. In the TikTok Ad Account list, select Create Ad Account.",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_ALT]:
    "TikTok ad account selector with Create Ad Account",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_TITLE]: "Enter the Advertiser Details",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_BODY]:
    "Choose the Business Center. Then enter the ad account name, company name, industry, company registration country, currency, and time zone. The currency has to match the Business Center. Click Create.",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_ALT]: "Form to create a TikTok ad account",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_4_TITLE]:
    "Complete the Account in TikTok Business",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_4_BODY]:
    "Creating the account does not finish the setup. Open ___TIKTOK_BUSINESS___, open the new ad account, and add the details TikTok asks for. If you already filled this in before, TikTok probably will not ask for it again.",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_TITLE]: "You Can Launch a Campaign",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_BODY]:
    "Once you have completed every step and confirmed in ___TIKTOK_BUSINESS___ that no extra steps are required, you can launch campaigns from {{NAME_BUSINESS}}.",
  [GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_ALT]:
    "Modal to create a campaign in {{NAME_BUSINESS}}",
  [GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_TITLE]: "Required in TikTok Business",
  [GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_WEBSITE]: "Website",
  [GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_BILLING]: "Billing Address",
  [GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_PAYMENT]: "Payment Method",

  //MODAL MAIN GENERATE SOCIAL MEDIA CONTENT
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ARIA_LABEL]:
    "Modal for generating weekly content",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_TITLE]: `Feed Generator`,
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_DESCRIPTION]:
    "Generate your weekly social media content with a click",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTEXT_LABEL]:
    "What do you want to communicate with this content?",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTEXT_PLACEHOLDER]:
    "I want to communicate that my products/brand is everything the user needs",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_WEBSITE_URL_LABEL]: "Your website URL",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_HAS_TEXTS_LABEL]:
    "Do you want the content to have text?",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_ALL_WITH_TEXT]: "All with text",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_SOME_WITH_TEXT]: "Some with text",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_WITHOUT_TEXT]: "None with text",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_LANGUAGE_LABEL]: "Language",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_TONES_LABEL]: "Content tones",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_COLOR_TEXT_LABEL]: "Text color",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_COLOR_BACKGROUND_LABEL]:
    "Background color",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_HAS_TEXT_LABEL]: "With text",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_FONT_FAMILY_LABEL]: "Font family",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALIGN_TEXT_LABEL]: "Text alignment",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALIGN_LOGO_LABEL]: "Logo alignment",
  [MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_TITLE]: "Gallery",
  [MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_EMPTY]:
    "There is no content yet, add some",
  [MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_UPLOAD_OPTION]: "Upload from Device",
  [MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_FROM_COLLABORATIONS_OPTION]:
    "Upload from {{NAME_BUSINESS}}",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_CONTENTS_REQUIRED]:
    "You must select at least one day",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_SCHEDULE_BUTTON]:
    "Schedule Content",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_SCHEDULED_CONTENT]:
    "Scheduled content",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALREADY_CONTENT_ON_THIS_DATE]:
    "There is already a content for this date, please select another one",
  [MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_CONTENT_WILL_BE_PUBLISHED_IMMEDIATELY]:
    "This content will be published immediately",

  //MODAL CONNECT ACCOUNTS
  [MODAL_CONNECT_ACCOUNTS_TITLE]: "Connect your accounts",
  [MODAL_CONNECT_ACCOUNTS_DESCRIPTION]:
    "To publish this campaign you must connect your advertising accounts.",

  //MODAL GENERATE SOCIAL MEDIA CONTENT
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_ARIA_LABEL]:
    "Modal for generating content",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_TITLE]: "Generate Content",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_LABEL]: "Choose tone",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_TOP_FIVE_OPTION]: "Top five",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_EDUCATION_OPTION]:
    "Educational",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_QUOTES_OPTION]:
    "Famous quotes",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_CURIOUS_FACTS_OPTION]:
    "Curious facts",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_RHYMES_OR_POEMS_OPTION]:
    "Rhymes or poems",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_HUMOR_OPTION]: "Humor",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_EMPTY_CONTENT]: "No generated content",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_TEXT_LABEL]: "Image text",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_DESCRIPTION]: "Content description",
  [MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_GENERATING_CONTENT]:
    "Generating content",

  //REDEEM CODE
  [REDEEM_CODE_TITLE]: "Redeem Code",
  [REDEEM_CODE_DESCRIPTION]:
    "Enter the code provided by the content creator to validate the value and redeem the product",
  [REDEEM_CODE_SEARCHBAR_PLACEHOLDER]: "Write a code",
  [REDEEM_CODE_TABLE_COLUMN_CODE]: "Code",
  [REDEEM_CODE_TABLE_COLUMN_DATE]: "Redemption date",
  [REDEEM_CODE_TABLE_COLUMN_VALUE]: "Value",
  [REDEEM_CODE_TABLE_COLUMN_TERMS]: "Terms and conditions",
  [CODE_REDEEMED]: "Code redeemed",
  [VALUE_CODE_REDEEMED]: "Value: {{value,currency}}",
  [VALUE_GENERAL_CODE_REDEEMED]: "Value: {{value}}%",
  [CODE_NO_EXIST]: "This code does not exist",
  [CODE_NO_REDEEM_BEFORE_DATE]:
    "You cannot redeem this code yet, you can do it from {{date,short}}.",

  //ORDERS
  [ORDERS_TITLE]: "Orders",
  [ORDERS_DESCRIPTION]: "Manage orders placed by content creators",
  [ORDERS_REMEMBER_MARK_AS_DELIVERED]:
    "Remember to mark your order as 'Delivered' so the creator can upload your content.",
  [ORDERS_SEARCHBAR_PLACEHOLDER]: "Search by order number",
  [ORDERS_TAB_TO_BE_ACCEPTED]: "To be accepted",
  [ORDERS_TAB_TO_BE_ACCEPTED_DESCRIPTION]:
    "Here you will see new orders from guest content creators. Accept them to confirm that you will process them.",
  [ORDERS_TAB_IN_PREPARATION]: "Processing",
  [ORDERS_TAB_IN_PREPARATION_DESCRIPTION]:
    "Here you will see the orders to be processed on your side. When the time expires, a delivery will be ready to pick it up.",
  [ORDERS_TAB_TO_BE_DELIVERED]: "To be delivered",
  [ORDERS_TAB_TO_BE_DELIVERED_DESCRIPTION]:
    "Here you will see the orders ready on your side for a delivery to pick them up.",
  [DELIVERY_INTERN]: "Own",
  [DELIVERY_INTERN_ON_THE_WAY]: "Own delivery on the way",
  [DELIVERY_ON_THE_WAY]: "Delivery {{delivery}} on the way",
  [ORDER_ID]: "Order #{{id}}",
  [ORDER_ACCEPTED]: "Order accepted",
  [ORDER_ACCEPTED_DESCRIPTION]:
    "The order has been accepted and moved to processing",
  [ORDER_READY]: "Order ready",
  [ORDER_READY_DESCRIPTION]:
    "The order is ready and has been moved for delivery.",
  [ORDER_TO_BE_DELIVERED_CONFIRMATION]:
    "Are you sure the order has been delivered?",
  [ORDER_TO_BE_DELIVERED_CONFIRMATION_BUTTON]: "Deliver order",
  [ORDER_CANCELLED_CONFIRMATION]: "Are you sure you want to cancel the order?",
  [ORDER_CANCELLED_CONFIRMATION_BUTTON]: "Cancel order",
  [ORDER_DELIVERED]: "Order delivered",
  [ORDER_DELIVERED_DESCRIPTION]:
    "The order has already been delivered to the user",
  [DELIVERY_SELECTED]: "Selected delivery!",
  [DELIVERY_SELECTED_DESCRIPTION]:
    "Delivery {{delivery}} has been selected for this order.",
  [ORDER_REJECTED]: "Order rejected",
  [ORDER_REJECTED_DESCRIPTION]: "The order has been rejected",
  [ORDER_TOTAL_VALUE]: "Total value",
  [ORDER_TOTAL_VALUE_DISCOUNT]: "With {{value}}% discount",
  [ORDER_LIST_OF_PRODUCTS]: "List of products",
  [ORDER_OPTIONS]: "Options",
  [ORDER_TIME_PREPARATION_TITLE]: "Indicate the delivery time of the order",
  [MIN_VALUE_PREPARATION_ORDER]:
    "This is the minimum time to process this order",
  [MAX_VALUE_PREPARATION_ORDER]:
    "This is the maximum time to process this order",
  [INVALID_TIME_PREPARATION]: "You must choose a valid time type",
  [TIME_PREPARATION_VALUES_VALIDATION]:
    "You must choose a time greater than {{min}} or less than {{max}}",
  [GUIDE_NUMBER]: "Guide number",
  [GUIDE_NUMBER_REQUIRED]: "Guide number is required",
  [DELIVERY_TYPE_DUPLICATE]: "There is already a delivery with this name",
  [SELECT_DELIVERY_TYPE]: "Select a delivery",
  [SELECT_DELIVERY_TYPE_OTHER]: "Other delivery",
  [DELIVERY_DATA]: "Delivery data",
  [OWN_DELIVERY]: "Own delivery",

  //EVENTS
  [EVENT_NO_EXIST]: "The event does not exist",
  [EVENT_DISABLED]: "The {{event}} event is not active",
  [EVENT_HAS_FIELDS_REQUIRED]:
    "This event has empty required fields. To activate it, please complete them.",
  [EVENT_RECURRENT_REQUIRED]: "The type of recurrence is required.",

  //ACCOUNT
  [ACCOUNT_TITLE]: "My Account",
  [ACCOUNT_DESCRIPTION]: "Fill out your company information",

  //COMPANY INFORMATION
  [COMPANY_INFORMATION_TITLE]: "Set up your brand",
  [COMPANY_INFORMATION_SUBCATEGORY_DUPLICATE]:
    "A subcategory with this name already exists",
  [COMPANY_INFORMATION_TYPE_ID_PLACEHOLDER]: "Type of identification",
  [COMPANY_INFORMATION_ID_NUMBER_PLACEHOLDER]: "Identification number",
  [COMPANY_INFORMATION_ID_NUMBER_MIN_LENGTH]:
    "The identification number must have at least {{value}} digits",
  [COMPANY_INFORMATION_ID_NUMBER_TYPE]:
    "The identification number should only consist of digits. If it's a NIT, it should include a hyphen and the verification digit.",
  [COMPANY_INFORMATION_BRAND_NAME_PLACEHOLDER]: "Brand name",
  [COMPANY_INFORMATION_BUSINESS_NAME_PLACEHOLDER]: "Business name",
  [COMPANY_INFORMATION_ADDRESS_PLACEHOLDER]: "Registered address",
  [COMPANY_INFORMATION_AVERAGE_TICKET_PLACEHOLDER]: "Average ticket value",
  [COMPANY_INFORMATION_AVERAGE_TICKET_MIN_VALUE]:
    "The average ticket value must be at least {{value,currency}}",
  [COMPANY_INFORMATION_SOCIAL_NETWORK_PLACEHOLDER]: "Social network",
  [COMPANY_INFORMATION_SECOND_SOCIAL_NETWORK_PLACEHOLDER]:
    "Secondary social network",
  [COMPANY_INFORMATION_WEBSITE_URL_PLACEHOLDER]: "Brand website",
  [COMPANY_INFORMATION_TRAFFIC_URL_PLACEHOLDER]: "URL to direct traffic",
  [COMPANY_INFORMATION_CATEGORY_PLACEHOLDER]: "Categories",
  [COMPANY_INFORMATION_SUBCATEGORY_PLACEHOLDER]: "Subcategories",
  [COMPANY_INFORMATION_NEW_SUBCATEGORY]: "New subcategory",
  [COMPANY_INFORMATION_SHORT_DESCRIPTION_PLACEHOLDER]:
    "Write a striking description of your brand to encourage creators to collaborate with you",
  [COMPANY_INFORMATION_ADMIN_PHONE_PLACEHOLDER]: "Administrator's phone",
  [COMPANY_INFORMATION_RESERVATION_URL_PLACEHOLDER]: "URL for reservations",
  [COMPANY_INFORMATION_UPLOAD_LOGO_PLACEHOLDER]: "Upload brand logo",
  [COMPANY_INFORMATION_UPLOAD_LOGO_DESCRIPTION_PLACEHOLDER]:
    "This will help customers or couriers identify your brand.",
  [COMPANY_INFORMATION_UPLOAD_COVER_PLACEHOLDER]: "Upload cover image",
  [COMPANY_INFORMATION_UPLOAD_COVER_DESCRIPTION_PLACEHOLDER]:
    "This will increase visibility. Use horizontal images or 16:9 aspect ratio for better viewing.",
  [COMPANY_INFORMATION_UPLOAD_REGULATORY_DOCUMENT_PLACEHOLDER]:
    "Upload regulatory document",
  [COMPANY_INFORMATION_UPLOAD_REGULATORY_DOCUMENT_DESCRIPTION_PLACEHOLDER]:
    "Regulatory document for the sale of food (e.g., Invima, FDA)",
  [COMPANY_INFORMATION_VIEW_DOCUMENT]: "View document",
  [COMPANY_INFORMATION_GENERAL_DISCOUNT_TITLE]: "General discount code",
  [COMPANY_INFORMATION_GENERAL_DISCOUNT_DESCRIPTION]: `The general discount code is a code that {{NAME_BUSINESS}} creators can use to purchase your products just like any other customer, so no collaboration will be generated.`,
  [COMPANY_INFORMATION_GENERAL_DISCOUNT_EXPLANATION_1]:
    "If you save a discount percentage and you have an e-commerce integration, a discount code will be created with that percentage.",
  [COMPANY_INFORMATION_GENERAL_DISCOUNT_EXPLANATION_2]:
    "If you remove the discount percentage, have an e-commerce integration, and previously had a general code created, it will be deactivated.",

  [COMPANY_INFORMATION_GENERAL_DISCOUNT_PERCENTAGE_PLACEHOLDER]:
    "Discount percentage",
  [COMPANY_INFORMATION_GENERAL_DISCOUNT_CODE_PLACEHOLDER]: "Discount code",
  [COMPANY_INFORMATION_SHOP_ID_COPIED]: "Shop ID copied",
  [COMPANY_INFORMATION_ONBOARDING_FINISH_DESCRIPTION]:
    "Now you will need to complete all the information about your brand in this account section.",
  [COMPANY_INFORMATION_SAVED]: "Company information saved",

  //PLATFORMS CONNECT
  [PLATFORMS_CONNECTED_TITLE]: "Connect your accounts",
  [PLATFORMS_CONNECTED_INSTAGRAM_FAILED]: "Could not connect with Instagram",
  [PLATFORMS_CONNECTED_FACEBOOK_SDK_UNAVAILABLE]:
    "Your browser blocked the connection to Meta. This is usually caused by an ad blocker, a privacy extension, or a corporate network/firewall.",
  [PLATFORMS_CONNECTED_META_BLOCKED_TITLE]: "We couldn't open Meta's login",
  [PLATFORMS_CONNECTED_META_POPUP_BLOCKED]:
    "Meta's window didn't open or closed before finishing. This usually happens when the browser blocks popups or a privacy extension interferes.",
  [PLATFORMS_CONNECTED_META_BLOCKED_STEP_DISABLE_BLOCKER]:
    "Disable your ad blocker and privacy extensions for this page.",
  [PLATFORMS_CONNECTED_META_BLOCKED_STEP_ALLOW_POPUPS]:
    "Allow popups for this page.",
  [PLATFORMS_CONNECTED_META_BLOCKED_STEP_RETRY]:
    "Reload the page and try again.",
  [PLATFORMS_TOKEN_EXPIRED]: "Your token has expired, please reconnect",
  [AD_ACCOUNTS_TITLE]: "Ad accounts",

  //BRAND SETUP
  [BRAND_SETUP_TITLE]: "Brand setup",

  //SCHEDULE
  [SCHEDULE_TITLE]: "Schedules",
  [SCHEDULE_ECOMMERCE_ALERT_TITLE]: "Are you sure?",
  [SCHEDULE_ECOMMERCE_ALERT_DESCRIPTION]:
    "This will make your brand's schedule 24/7",
  [SCHEDULE_ONE_DAY_WITH_TURN]: "At least one day must have a shift",
  [SCHEDULE_EMPTY_TURN]: "There cannot be empty shifts",
  [SCHEDULE_OPEN_AND_CLOSE_HOUR_VALIDATION]:
    "The opening time cannot be greater than the closing time",
  [SCHEDULE_MAX_CLOSE_HOUR]:
    "The time cannot be greater than 23:59, use 00:00 instead of 24:00",
  [SCHEDULE_TABLE_ARIA_LABEL]: "Schedule table",
  [SCHEDULE_TABLE_COLUMN_OPEN]: "Opens",
  [SCHEDULE_TABLE_COLUMN_CLOSE]: "Closes",
  [SCHEDULE_SAVED]: "Schedule saved",

  //LEGAL REPRESENTATIVE
  [LEGAL_REPRESENTATIVE_TITLE]: "Legal representative information",
  [LEGAL_REPRESENTATIVE_NAME_PLACEHOLDER]: "First name",
  [LEGAL_REPRESENTATIVE_LAST_NAME_PLACEHOLDER]: "Last name",
  [LEGAL_REPRESENTATIVE_TYPE_ID_PLACEHOLDER]: "ID type",
  [LEGAL_REPRESENTATIVE_ID_NUMBER_PLACEHOLDER]: "ID number",
  [LEGAL_REPRESENTATIVE_PHONE_PLACEHOLDER]: "Phone",
  [LEGAL_REPRESENTATIVE_SAVED]: "Legal representative information saved",

  //PASSWORD
  [PASSWORD_TITLE]: "Change Password",
  [PASSWORD_CURRENT_PASSWORD_PLACEHOLDER]: "Current password",
  [PASSWORD_NEW_PASSWORD_PLACEHOLDER]: "New password",
  [PASSWORD_CONFIRM_PASSWORD_PLACEHOLDER]: "Confirm new password",
  [PASSWORD_FORMAT_DESCRIPTION]: "Password format:",
  [PASSWORD_FORMAT_SUGGESTION1]: "At least 6 characters",
  [PASSWORD_FORMAT_SUGGESTION2]: "At least one uppercase letter",
  [PASSWORD_FORMAT_SUGGESTION3]: "At least one lowercase letter",
  [PASSWORD_FORMAT_SUGGESTION4]: "At least one number",
  [PASSWORD_INSECURE]:
    "Password is not secure, please consider the recommendations",
  [PASSWORDS_NOT_MATCH]: "New passwords do not match",
  [PASSWORD_CHANGED]: "Password changed",
  [PASSWORD_CURRENT_INVALID]: "Current password is incorrect",
  [PASSWORD_ACCOUNT_DISABLED_FOR_MORE_INTENTS]:
    "The account has been temporarily disabled due to too many failed attempts. Please try again later.",

  //STORES
  [MODAL_STORE_ARIA_LABEL]: "Store modal",
  [MODAL_STORE_TITLE]: "Create a store",
  [MODAL_STORE_TITLE_EDIT]: "Edit a store",
  [MODAL_STORE_DESCRIPTION]:
    "Create a store that is a physical or virtual brand point of sale.",
  [MODAL_STORE_DESCRIPTION_EDIT]: "Edit a store you have created.",
  [MODAL_STORE_TYPE_PLACEHOLDER]: "Store type",
  [MODAL_STORE_TYPE_REGULAR_OPTION]: "Regular",
  [MODAL_STORE_HOW_TO_INTEGRATE_STORE]: `How to integrate my {{value}} store with {{NAME_BUSINESS}}?`,
  [MODAL_STORE_NAME_PLACEHOLDER]: "Store name",
  [MODAL_STORE_DESCRIPTION_PLACEHOLDER]: "Description",
  [MODAL_STORE_ADDRESS_PLACEHOLDER]: "Address",
  [MODAL_STORE_CITY_PLACEHOLDER]: "City",
  [MODAL_STORE_PHONE_PLACEHOLDER]: "Phone",
  [MODAL_STORE_LINK_STORE_SPECIAL_PLACEHOLDER]: "Link to your {{value}} store",
  [MODAL_STORE_NAME_SHOPIFY_PLACEHOLDER]: "Shopify Store Name",
  [MODAL_STORE_LOOK_NAME_SHOPIFY]: "Check your store's name",
  [MODAL_STORE_LOOK_NAME_SHOPIFY_HELPER_TEXT]:
    "Your store's name is what will appear in the URL to which you'll be redirected. You should copy the part that comes before <strong>.myshopify.com</strong>. For example, if the URL redirects to https://<strong>testclapps</strong>.myshopify.com, the store's name is <strong>testclapps</strong>.",
  [MODAL_STORE_ACCESS_TOKEN_FOR_BUZZLY_PLACEHOLDER]: `Access Token for {{NAME_BUSINESS}}`,
  [MODAL_STORE_DO_CREATE_DISCOUNT_SHIPPING_PLACEHOLDER]: "Offer free shipping",
  [MODAL_STORE_CITIES_PLACEHOLDER]: "Select cities",
  [MODAL_STORE_ORDERS_METHODS_PLACEHOLDER]:
    "Select methods for product delivery",
  [MODAL_STORE_ORDERS_METHODS_DELIVERY_OPTION]: "Delivery",
  [MODAL_STORE_ORDERS_METHODS_IN_STORE_OPTION]: "In-Store",
  [MODAL_STORE_PRODUCT_AVAILABILITY_PLACEHOLDER]: "Product availability",
  [MODAL_STORE_PRODUCT_AVAILABILITY_NATIONAL_OPTION]: "National (All cities)",
  [MODAL_STORE_PRODUCT_AVAILABILITY_LOCAL_OPTION]:
    "Local (Only in the selected city)",
  [MODAL_STORE_COVERAGE_RADIUS_PLACEHOLDER]: "Coverage radius in kilometers",
  [MODAL_STORE_TITLE_CREATE_INTEGRATE_SHOPIFY]: "Integrate Shopify",
  [MODAL_STORE_DESCRIPTION_CREATE_INTEGRATE_SHOPIFY]:
    "Connect your Shopify store with {{NAME_BUSINESS}} to facilitate the management of your invitations and redemptions.",
  [MODAL_STORE_DESCRIPTION_DISCONNECT_SHOPIFY]:
    "All Shopify invitation and redemption management functionalities will be disabled.",
  [MODAL_STORE_BUTTON_CREATE_INTEGRATE_SHOPIFY]: "Integrate Shopify",
  [MODAL_STORE_TITLE_CREATE_INTEGRATE_WOOCOMMERCE]: "Integrate WooCommerce",
  [MODAL_STORE_DESCRIPTION_CREATE_INTEGRATE_WOOCOMMERCE]:
    "Connect your WooCommerce store with {{NAME_BUSINESS}} to facilitate the management of your invitations and redemptions.",
  [MODAL_STORE_BUTTON_CREATE_INTEGRATE_WOOCOMMERCE]: "Integrate WooCommerce",
  [MODAL_STORE_DESCRIPTION_DISCONNECT_WOOCOMMERCE]:
    "All WooCommerce invitation and redemption management functionalities will be disabled.",

  //MENU
  [MENU_TITLE]: "Catalog",
  [MENU_DESCRIPTION]: "Create the catalog of your brand's products",
  [MENU_EMPTY_STORES]: "You don't have a store created to add a catalog",
  [MODAL_COPY_MENU_ARIA_LABEL]: "Modal to copy catalog",
  [MODAL_COPY_MENU_TITLE]: "Copy catalog",
  [MODAL_COPY_MENU_DESCRIPTION]: "Copy the catalog from one store to another",
  [MODAL_COPY_MENU_SAME_STORE]: "You cannot copy a catalog to the same store",
  [MODAL_COPY_MENU_CONFIRM_ALERT_TITLE]:
    "Are you sure you want to copy this catalog?",
  [MODAL_COPY_MENU_CONFIRM_ALERT_DESCRIPTION]:
    "This action will overwrite the catalog in the destination store.",
  [MODAL_COPY_MENU_COPIED]: "Catalog copied",
  [SELECT_CATALOG]: "Select a catalog",
  [MODAL_UPLOAD_MENU_ARIA_LABEL]: "Modal to upload catalog",
  [MODAL_UPLOAD_MENU_TITLE]: "Upload catalog",
  [MODAL_UPLOAD_MENU_DESCRIPTION]:
    "Select the store to which you want to upload the catalog",
  [MODAL_UPLOAD_MENU_FILE_PLACEHOLDER]:
    "To upload a catalog, you must do so from an Excel format with the extension xlsx, following the template for the columns.",
  [MODAL_UPLOAD_MENU_ERROR_FORMAT]:
    "An error has been found in the format. Please do not modify the structure of the template or leave required fields empty.",
  [MODAL_UPLOAD_MENU_MIN_PRICE_PRODUCT]:
    "The price of a product must be {{value,number}} or higher",
  [MODAL_UPLOAD_MENU_CONFIRM_ALERT_TITLE]:
    "Are you sure you want to upload this catalog?",
  [MODAL_UPLOAD_MENU_CONFIRM_ALERT_DESCRIPTION]:
    "This action will delete the existing catalog and replace it.",
  [MODAL_UPLOAD_MENU_UPLOADED]: "Catalog uploaded",
  [MENU_ADD_CATEGORY]: "Add category",
  [MENU_CATEGORY_NAME_PLACEHOLDER]: "Category name",
  [MENU_CATEGORY_REQUIRED]: "You must enter a category name",
  [MENU_ADD_PRODUCT]: "Add product",
  [MENU_PRODUCT_MIN_VALUE]: "The price must be {{value,number}} or higher",
  [MENU_CREATE_PRODUCT_TITLE]: "Create the base product",
  [MENU_PRODUCT_NAME_PLACEHOLDER]: "Name",
  [MENU_PRODUCT_DESCRIPTION_PLACEHOLDER]: "Description",
  [MENU_PRODUCT_PRICE_PLACEHOLDER]: "Price",
  [MENU_PRODUCT_TYPE_PRODUCT_PLACEHOLDER]: "Product type",
  [MENU_PRODUCT_TYPE_PRODUCT_EXPLANATION]:
    "This product is not suitable for the general public (harmful or for individuals over 18 years)",
  [MENU_PRODUCT_ACCOMPANIMENTS_TYPE_TITLE]: "Product Options",
  [MENU_PRODUCT_ACCOMPANIMENTS_TYPE_DESCRIPTION]:
    "Add options and customization for this product",
  [MENU_PRODUCT_ADD_ACCOMPANIMENT_TYPE_PLACEHOLDER]:
    "Add product option category",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_IS_MANDATORY_PLACEHOLDER]:
    "Is it mandatory?",
  [MENU_PRODUCT_ADD_ACCOMPANIMENT_PLACEHOLDER]: "Add product option",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_AND_MAX_NUMBER]:
    "The minimum options cannot be greater than the maximum",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_NUMBER]:
    "The minimum or maximum options cannot be less than 0",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_NAME_PLACEHOLDER]: "Name",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_OPTIONS_PLACEHOLDER]: "Minimum options",
  [MENU_PRODUCT_ACCOMPANIMENT_TYPE_MAX_OPTIONS_PLACEHOLDER]: "Maximum options",
  [MENU_PRODUCT_ACCOMPANIMENT_NAME_PLACEHOLDER]: "Name",
  [MENU_PRODUCT_ACCOMPANIMENT_PRICE_PLACEHOLDER]: "Price",
  [MODAL_MOVE_PRODUCT_ARIA_LABEL]:
    "Modal to move a product to another category",
  [MODAL_MOVE_PRODUCT_CATEGORY_OBJECTIVE]:
    "Select the category you want to move the product to",
  [MODAL_MOVE_PRODUCT_CATEGORY_REQUIRED]: "You must select a category",
  [MODAL_MOVE_PRODUCT_BUTTON]: "Move product",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_ARIA_LABEL]:
    "Modal to copy an accompaniment type category to another product",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_CATEGORY_OBJECTIVE]:
    "Select the product category that contains the accompaniment type category",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_PRODUCT_OBJECTIVE]:
    "Select the product that contains the accompaniment type category",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_OBJECTIVE]:
    "Select the accompaniment type category you want to copy",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_OBJECTIVE_PLACEHOLDER]:
    "Accompaniment type category",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_CATEGORY_REQUIRED]:
    "You must select a category",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_PRODUCT_REQUIRED]: "You must select a product",
  [MODAL_COPY_ACCOMPANIMENT_TYPE_REQUIRED]:
    "You must select an accompaniment type category",
  [MENU_ONBOARDING_TEST_CATEGORY]: "Test category",
  [MENU_ONBOARDING_TEST_PRODUCT]: "Test product",
  [MENU_ONBOARDING_TEST_PRODUCT_DESCRIPTION]: "Test description",
  [MENU_ONBOARDING_FINISH_DESCRIPTION]:
    "You have completed the menu creation tutorial, and now you know how to manage your menu.",
  [MENU_ONBOARDING_FINISH_ADDITIONAL_DESCRIPTION]:
    "Now, you should fill out all the information about your brand in this account section.",
  [MENU_CATEGORY_DUPLICATE]: "Duplicate category",
  [MENU_CATEGORY_DUPLICATE_DESCRIPTION]:
    "A category with this name already exists",
  [MENU_CATEGORY_CREATED]: "Category created",
  [MENU_CATEGORY_SAVED]: "Category saved",
  [MENU_CATEGORY_DELETE_CONFIRMATION_TITLE]: "Delete Category",
  [MENU_CATEGORY_DELETE_CONFIRMATION_DESCRIPTION]:
    "Are you sure you want to delete this category?",
  [MENU_CATEGORY_DELETING]: "Deleting category",
  [MENU_CATEGORY_DELETED]: "Category deleted",
  [MENU_PRODUCT_DUPLICATE]: "Duplicate product",
  [MENU_PRODUCT_DUPLICATE_DESCRIPTION]:
    "A product with this name already exists",
  [MENU_PRODUCT_CREATED]: "Product created",
  [MENU_PRODUCT_SAVED]: "Product saved",
  [MENU_PRODUCT_DELETE_CONFIRMATION_TITLE]: "Delete product",
  [MENU_PRODUCT_DELETE_CONFIRMATION_DESCRIPTION]:
    "Are you sure you want to delete this product?",
  [MENU_PRODUCT_DELETING]: "Deleting product",
  [MENU_PRODUCT_DELETED]: "Product deleted",
  [MENU_PRODUCT_MOVE_SAME_CATEGORY]:
    "Cannot move the product to the same category",
  [MENU_PRODUCT_MOVED]: "Product moved",
  [MENU_PRODUCT_CHANGE_STATUS]: "Product {{status}}",
  [MENU_ACCOMPANIMENT_TYPE_DUPLICATE]: "Duplicate product option category",
  [MENU_ACCOMPANIMENT_TYPE_DUPLICATE_DESCRIPTION]:
    "A product option category with this name already exists",
  [MENU_ACCOMPANIMENT_TYPE_COPIED]: "Product option category copied",
  [MENU_ACCOMPANIMENT_DUPLICATED]: "Product option duplicated",
  [MENU_ACCOMPANIMENT_DUPLICATED_DESCRIPTION]:
    "A product option with this name already exists",

  //USERS
  [USERS_TITLE]: "Users",
  [USERS_DESCRIPTION]: "Create users to help manage your business",
  [USERS_TABS_ARIA_LABEL]: "Users and Contacts Tabs",
  [USERS_PORTAL_TAB]: "Users",
  [USERS_CONTACTS_TAB]: "Contacts",
  [USERS_EMAIL_DUPLICATE]: "The email is already in use by another user",
  [USERS_USER_CREATED]: "User created",
  [USERS_USER_SAVED]: "User saved",
  [USERS_USER_DELETE_CONFIRMATION_TITLE]:
    "Are you sure you want to delete this user?",
  [USERS_USER_DELETE_CONFIRMATION_DESCRIPTION]:
    "Once deleted, it cannot be recovered",
  [USERS_USER_DELETING]: "Deleting user",
  [USERS_USER_DELETED]: "User deleted",
  [USERS_LIMIT_REACHED]: "User Limit Reached",
  [ADVERTISERS_LIMIT_REACHED]:
    "You have reached the limit of brands. Upgrade your plan to add more.",
  [USERS_ONBOARDING_FINISH]:
    "Now you know which roles exist and what each one is for.",
  [USERS_USER_SEARCH_BAR_PLACEHOLDER]: "Search for a user",
  [USERS_TABLE_ARIA_LABEL]: "Users table",
  [USERS_TABLE_COLUMN_NAME]: "Name",
  [USERS_TABLE_COLUMN_EMAIL]: "Email",
  [USERS_TABLE_COLUMN_STORE]: "Store",
  [USERS_TABLE_COLUMN_ROLE]: "Role",
  [MODAL_USER_ARIA_LABEL]: "Create user modal",
  [MODAL_USER_TITLE]: "Create User",
  [MODAL_USER_TITLE_EDIT]: "Edit User",
  [MODAL_USER_DESCRIPTION]: "Add user so they can access {{NAME_BUSINESS}}.",
  [MODAL_USER_DESCRIPTION_EDIT]:
    "Edit a user who has access to {{NAME_BUSINESS}}.",
  [MODAL_USER_NAME_PLACEHOLDER]: "Full Name",
  [MODAL_USER_ROLE_PLACEHOLDER]: "User role",
  [MODAL_USER_ROLE_OPERATOR_EXPLANATION]:
    "People who manage actions like Redeem Code and Orders, and ensure that products are activated or deactivated based on inventory.",
  [MODAL_USER_STORE_PLACEHOLDER]: "Select a store",
  [MODAL_USER_PASSWORD_PLACEHOLDER]: "Password",
  [MODAL_USER_REPEAT_PASSWORD_PLACEHOLDER]: "Repeat password",
  [USERS_CONTACT_CREATED]: "Contact Created",
  [USERS_CONTACT_SAVED]: "Contact Saved",
  [USERS_CONTACT_DELETE_CONFIRMATION_TITLE]:
    "Are you sure you want to delete this contact?",
  [USERS_CONTACT_DELETE_CONFIRMATION_DESCRIPTION]:
    "Once deleted, it cannot be recovered",
  [USERS_CONTACT_DELETED]: "Contact Deleted",
  [USERS_CONTACT_SEARCH_BAR_PLACEHOLDER]: "Search for contact",
  [USERS_CONTACT_TABLE_ARIA_LABEL]: "Contact Table",
  [USERS_CONTACT_TABLE_COLUMN_PHONE]: "Phone",
  [MODAL_CONTACT_ARIA_LABEL]: "Create Contact Modal",
  [MODAL_CONTACT_TITLE]: "Create a contact",
  [MODAL_CONTACT_TITLE_EDIT]: "Edit a contact",
  [MODAL_CONTACT_DESCRIPTION]:
    "Create a contact for {{NAME_BUSINESS}} to communicate with you.",
  [MODAL_CONTACT_DESCRIPTION_EDIT]: "Edit a contact you have created.",
  [MODAL_CONTACT_PHONE_PLACEHOLDER]: "Contact's Phone Number",

  //BILLING AND PAYMENTS
  [STORAGE_USAGE_TITLE]: "Storage",
  [STORAGE_USAGE_LABEL]: "{{value}} {{unit}} of {{maxValue}} GB",
  [STORAGE_FULL_TITLE]: "Insufficient storage",
  [STORAGE_FULL_MESSAGE]:
    "You've reached your storage limit. To save more content, upgrade your plan or delete existing content.",
  [STORAGE_FULL_BUTTON_DELETE]: "Delete Content",
  [STORAGE_FULL_BUTTON_UPGRADE]: "Upgrade Plan",
  [BILLING_AND_PAYMENTS_TITLE]: "Billing",
  [BILLING_AND_PAYMENTS_DESCRIPTION]: "Manage your business plan and payments",
  [BILLING_AND_PAYMENTS_TABLE_ARIA_LABEL]: "Invoices table",
  [BILLING_AND_PAYMENTS_TABLE_COLUMN_PAID_DATE]: "Payment date",
  [BILLING_AND_PAYMENTS_TABLE_COLUMN_DUE_DATE]: "Due date",
  [BILLING_AND_PAYMENTS_TABLE_COLUMN_VALUE]: "Value",
  [BILLING_AND_PAYMENTS_TABLE_COLUMN_REASON]: "Reason",
  [BILLING_AND_PAYMENTS_TABLE_COLUMN_STATUS]: "Status",
  [PAYMENT_REASON_COLLABORATION]: "Payment for collaboration",
  [PAYMENT_REASON_APPLICANT]: "Payment for applicant",
  [PAYMENT_REASON_CLAPP_CREDITS]: `Payment for credits`,
  [PAYMENT_REASON_SUBSCRIPTION_PRO]: `Subscription {{NAME_BUSINESS}} Pro`,
  [PAYMENT_REASON_PACKAGE]: "Plan {{name}}",
  [PAYMENT_REASON_PLAN]: "Plan {{name}}",
  [PAYMENT_PAID]: "Paid",
  [PAYMENT_PENDING]: "Pending",
  [MODAL_INVOICE_ARIA_LABEL]: "Invoice details modal",
  [MODAL_INVOICE_TITLE]: "Invoice #{{value}}",
  [MODAL_INVOICE_DISCLAIMER]:
    "If you believe there's an error in the billing, you can contact support for detailed assistance.",
  [MODAL_INVOICE_CREDITS]: "Credits payment",
  [MODAL_INVOICE_NUMBER_CREDITS]: "Number of credits",
  [PURCHASE_CREDITS]: "Credits Purchase",
  [PURCHASE_VIDEOS]: "Video Purchase",
  [PURCHASE_X_CREDITS]: "Purchase of {{value}} credits",
  [MODAL_INVOICE_PLAN_ENTERPRISE_WITH_CREDITS]:
    "{{credits}} media & publicity collaborations",
  [MODAL_INVOICE_SUBSCRIPTION]:
    "{{name}} subscription payment, period from {{startDate, short}} to {{endDate, short}}",
  [MODAL_INVOICE_LICENSE]:
    "{{name}} license payment, period from {{startDate, short}} to {{endDate, short}}",
  [MODAL_INVOICE_COLLABORATION]: "Content exchange payment",
  [MODAL_INVOICE_APPLICANT]: "Campaign applicant payment",
  [MODAL_INVOICE_FEE]: "Fee {{value}}%",
  [MODAL_INVOICE_IVA]: "IVA {{value}}%",
  [MODAL_INVOICE_ORDER_TO_COLLECT]: "Order to collect",
  [MODAL_INVOICE_APPLICANT_CAMPAIGN_PAID]: "Campaign",
  [MODAL_PAY_INVOICE_ARIA_LABEL]: "Invoice payment modal",
  [MODAL_PAY_INVOICE_TITLE]: "Pay Invoice #{{value}}",
  [MODAL_PAY_INVOICE_WILL_PAY]: "You will pay {{value,currency}}",
  [MODAL_PAY_SUBSCRIPTION_PENDING_INVOICE_MESSAGE]:
    "You have a pending invoice for {{value}} {{currency}}, for: {{concept}}",
  [MODAL_PAY_SUBSCRIPTION_PAY_NOW]: "Pay Now",
  [MODAL_PAY_SUBSCRIPTION_PENDING_PAYMENT_TITLE]:
    "Pending Payment of {{value}} {{currency}}",
  [BILLING_PENDING_SUBSCRIPTION_PAYMENT_DESCRIPTION]:
    "Complete payment before {{limitDate}} to avoid removal of your gallery content and campaigns for {{NAME_BUSINESS}} (and on connected advertising platforms).",
  [BILLING_AND_PAYMENT_PLAN_DEACTIVATE]: "Your plan is inactive",
  [BILLING_AND_PAYMENT_PLAN_CANCELLED]: "Your plan has been cancelled",
  [BILLING_AND_PAYMENT_PLAN_TRIAL]: "Trial",
  [BILLING_AND_PAYMENT_PLAN_TRIAL_DESCRIPTION]: `You have an active trial plan so you can learn the benefits of using {{NAME_BUSINESS}}`,
  [BILLING_AND_PAYMENT_CHANGE_YOUR_PLAN]: "Change your plan now",
  [BILLING_AND_PAYMENT_ACTIVATE_PLAN]: "Activate plan",
  [BILLING_AND_PAYMENT_SELECT_PLAN]: "Select a plan",
  [BILLING_AND_PAYMENT_NO_HAVE_PLAN]: "-",
  [BILLING_AND_PAYMENT_PLAN_EXPIRED]: `Your trial plan has expired. Add a payment method and activate your plan now to continue using {{NAME_BUSINESS}}.`,
  [BILLING_AND_PAYMENT_PLAN_NAME]: "Plan {{name}}",
  [BILLING_AND_PAYMENT_MODEL_USAGE_COLLABORATION_TITLE]: "Pay per use",
  [BILLING_AND_PAYMENT_MODEL_USAGE_COLLABORATION_COST]:
    "{{value,currency}} per exchange",
  [BILLING_AND_PAYMENT_MODEL_USAGE_WHAT_BENEFITS]:
    "What benefits do you get with this plan?",
  [BILLING_AND_PAYMENT_MODEL_USAGE_SHOW_BENEFTIS]: "Show Benefits",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT1]:
    "Access to our catalog of content creators.",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT2]:
    "Show your products and/or services to audiences of 5,000 to 2 million people on Instagram, TikTok, and YouTube.",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT3]:
    "Analyze profiles, verify the quality and authenticity of their content, and get information about their audience.",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT4]:
    "Automate product and service exchange (invitations and requests).",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT5]: "Automate paid campaigns.",
  [BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT6]:
    "Download content from the platform and use it on your social media, website, and other marketing channels.",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_NAME]: "Plan {{name}}",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_CHANGE]: "Change your plan now",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_COLLECT_COST_COLLABORATION]:
    "You haven't selected a plan yet, for now, you will be charged {{value,currency}} for each collaboration that occurs.",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_ADD_PAYMENT_METHOD_TO_ACTIVATE]:
    "Add a payment method to activate your plan",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_EXPIRED]: `Your trial plan has expired. Select a plan to continue using {{NAME_BUSINESS}}.`,
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_NO_HAVE_PACKAGE]: "-",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_ACTIVATE_PACKAGE]: "Activate Plan",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_SELECT_PACKAGE]: "Select a Plan",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_CANCEL_PACKAGE]: "Cancel Plan",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_WHAT_BENEFITS]:
    "What benefits do you get with this plan?",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_COST_COLLABORATION]:
    "{{value,currency}} per collaboration",
  [BILLING_AND_PAYMENT_MODEL_PACKAGE_CANCEL_DISCLAIMER]:
    "* Subscriptions automatically renew every month. If you wish to cancel or change your plan, you must contact support at least 5 days in advance.",
  [MODAL_SELECT_PACKAGE_ARIA_LABEL]: "Plan Selection Modal",
  [MODAL_SELECT_CREDITS_ARIA_LABEL]: "Credits Selection Modal",
  [MODAL_SELECT_PACKAGE_AND_PAYMENT_METHOD_REQUIRED]:
    "Plan and payment method are required",
  [MODAL_SELECT_PACKAGE_UPLOAD_GROWTH]: "Upgrade to Growth!",
  [MODAL_SELECT_PACKAGE_PRICING_HERO_TITLE]:
    "Are you ready to have your brand seen by thousands of people?",
  [MODAL_SELECT_PACKAGE_PRICING_DISCOVER_BUZZLY]: `Discover {{NAME_BUSINESS}}`,
  [MODAL_SELECT_PACKAGE_UPLOAD_GROWTH_DESCRIPTION]:
    "With the Growth plan, you can access more benefits",
  [MODAL_SELECT_PACKAGE_PRICING_HERO_DESCRIPTION]:
    "Discover the platform that will take your brand to the next level of recognition on social media.",
  [MODAL_SELECT_PACKAGE_VALUE_EXPRESSED]:
    "Values are expressed in {{currency}}",
  [MODAL_SELECT_PACKAGE_PRICE]: "{{value,currency}}/mo",
  [MODAL_SELECT_PACKAGE_LICENSED_FEE_ENTERPRISE]: "License fee and Content",
  [MODAL_SELECT_PACKAGE_LICENSED_FEE]: "License fee ({{period}} months)",
  [MODAL_SELECT_PACKAGE_LICENSED_PRICE]: "{{value,currency}}",
  [MODAL_SELECT_PACKAGE_CONTENT_ENTERPRISE]: "Content",
  [MODAL_SELECT_PACKAGE_PRICE_UPLOAD_GROWTH]:
    "You will be charged {{value,currency}} for upgrading to Growth",
  [MODAL_SELECT_PACKAGE_ACCORDING_TO_THE_REQUIREMENT]:
    "According to requirement",
  [MODAL_SELECT_PACKAGE_BUY_PACKAGE_NAME]: "Buy {{value}}",
  [MODAL_SELECT_PACKAGE_COST_COLLABORATION]:
    "{{value,currency}} per collaboration",
  [MODAL_SELECT_PACKAGE_COST_CONTENT]: "{{value,currency}} per content",
  [MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_CHAT_WITH_CREATORS]:
    "• Direct chat with creators",
  [MODAL_SELECT_PACKAGE_BENEFIT_CONTENT_CURATION]: "• Content curation",
  [MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_PUBLICATION_PLATFORM]:
    "• Direct Post to IG or TikTok",
  [MODAL_SELECT_PACKAGE_BENEFIT_COLLABORATE_WITH_CREATOR]:
    "• Collaborate with creators",
  [MODAL_SELECT_PACKAGE_BENEFIT_LAUNCH_CAMPAIGNS]: "• Launch campaigns",
  [MODAL_SELECT_PACKAGE_BENEFIT_DOWNLOAD_CONTENT]:
    "• Download content for your social media feed ",
  [MODAL_SELECT_PACKAGE_BENEFIT_ANALYZE_METRICS]:
    "• Analyze audience metrics, reach and engagement",
  [MODAL_SELECT_PACKAGE_BENEFIT_CATALOG]: "• Access content creator catalog",
  [MODAL_SELECT_PACKAGE_BENEFIT_AUTOMATIZATION]:
    "• Automation of product exchange for content",
  [MODAL_SELECT_PACKAGE_BENEFIT_SUPPORT_TICKETS]:
    "• Support via ticket assistance",
  [MODAL_SELECT_PACKAGE_BENEFIT_ALL_BASIC]: `• All benefits of Basic plan`,
  [MODAL_SELECT_PACKAGE_BENEFIT_KAM]:
    "• KAM - account manager (Strategic consulting)",
  [MODAL_SELECT_PACKAGE_BENEFIT_VOLUME_CONTENT]: "• Volume of contents",
  [MODAL_SELECT_PACKAGE_BENEFIT_DISCOVERY]:
    "• Discover and analyze metrics of any IG or TikTok profile",
  [MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_CHAT]: "• Direct chat with creators",
  [MODAL_SELECT_PACKAGE_BENEFIT_ASSISTANCE_MARKETING]:
    "• 24/7 AI marketing assistant",
  [MODAL_SELECT_PACKAGE_BENEFIT_ALL_GROWTH]: "• All benefits of Growth plan",
  [MODAL_SELECT_PACKAGE_BENEFIT_BRANDS_UNLIMITED]: "• Unlimited brands",
  [MODAL_SELECT_PACKAGE_BENEFIT_PERSONALIZED_INTEGRATIONS]:
    "• Personalized integrations (WhatsApp, websites)",
  [MODAL_SELECT_PACKAGE_BENEFIT_IMPLEMENTATIONS_TECHNOLOGICAL]:
    "• Technological implementations",
  [MODAL_SELECT_PACKAGE_BENEFIT_PRIORITIZED_SUPPORT]: "• Priority support",
  [MODAL_SUBSCRIPTION_PRO_ARIA_LABEL]: "Modal to pay for pro subscription",
  [MODAL_SUBSCRIPTION_PRO_TITLE_HERO]:
    "Are you ready to unlock tools to enhance your collaborations?",
  [MODAL_SUBSCRIPTION_PRO_DESCRIPTION_HERO]: `{{NAME_BUSINESS}} Pro will grant you access to features that will help improve your collaborations with creators.`,
  [MODAL_SUBSCRIPTION_PRO_TITLE]: `{{NAME_BUSINESS}} Pro`,
  [MODAL_SUBSCRIPTION_PRO_SUB_HEADER]: "More Features",
  [MODAL_SUBSCRIPTION_PRO_BENEFIT_1]:
    "• Start direct chats with non-ambassador creators",
  [MODAL_SUBSCRIPTION_PRO_BUY_BUTTON]: `Buy {{NAME_BUSINESS}} Pro`,

  //PACKAGES
  [ADS_SUBSCRIPTION_TITLE]: "{{value}} Subscription",
  [SPEND_FEE]: "Advertising Spend Fee",
  [ADS_SUBSCRIPTION_DESCRIPTION]:
    "With your subscription, you'll gain access to our AI-powered campaign and content generation tools.",

  //PRICING
  [PRICING_HERO_TITLE_PACKAGES]: "Create, launch and optimize ads in seconds",
  [PRICING_HERO_TITLE_CREDITS]: "Create, launch and optimize ads in seconds",
  [PRICING_HERO_DESCRIPTION]: ``,
  [PRICING_APPSUMO_CREDITS_STACK_TITLE]: "Your credits stack",
  [PRICING_APPSUMO_CREDITS_STACK_DESCRIPTION]:
    "Your plan's monthly credits will be added to your current AppSumo credits.",
  [PRICING_CREDIT_USAGE_TITLE]: "How are credits used?",
  [PRICING_CREDIT_USAGE_CAMPAIGN]: "ad campaign",
  [PRICING_CREDIT_USAGE_IMAGE]: "AI-generated image",
  [PRICING_CREDIT_USAGE_VIDEO]: "AI-generated video",
  [PRICING_CREDIT_USAGE_ANIMATE_IMAGE]: "AI-animated image",
  [PRICING_CREDIT_USAGE_ANALYZE_IMAGE_LAYERS]: "image layer analysis",
  [PRICING_CREDIT_USAGE_CUSTOM_REPORT]: "custom report (CSV)",
  [PRICING_CREDIT_USAGE_CUSTOM_REPORT_DECK]: "custom report (PPTX/PDF)",
  [PRICING_CREDIT_USAGE_OPTIMIZATION]: "AI agent message",
  [PRICING_CREDIT_USAGE_SCHEDULED_POST]: "scheduled post",
  [PRICING_CREDIT_USAGE_PER]: "per",
  [PRICING_CREDIT_USAGE_CREDIT]: "credit",
  [PRICING_CREDIT_USAGE_CREDITS]: "credits",
  [CREDIT_COST_ITEM]: "{{credits}} {{creditWord}} per {{action}}",
  [ADS_SUBSCRIPTION_CREDITS_BENEFIT]: "{{value,number}} Credits",
  [ADS_SUBSCRIPTION_CREDITS_MONTHLY_BENEFIT]: "{{value,number}}/m Credits",
  [ADS_SUBSCRIPTION_CREDITS_QUARTERLY_BENEFIT]: "{{value,number}}/q Credits",
  [ADS_SUBSCRIPTION_CREDITS_SEMIANNUALLY_BENEFIT]: "{{value,number}}/s Credits",
  [ADS_SUBSCRIPTION_CREDITS_YEARLY_BENEFIT]: "{{value,number}}/y Credits",
  [ADS_SUBSCRIPTION_COINS_BENEFIT]: "{{value,number}} Coins",
  [ADS_SUBSCRIPTION_BENEFIT_PLATFORMS_CAMPAIGNS]: "Meta and TikTok campaigns",
  [ADS_SUBSCRIPTION_BENEFIT_CAMPAIGNS]: "{{value}} cross-platform campaigns",
  [ADS_SUBSCRIPTION_BENEFIT_CAMPAIGN]: "{{value}} cross-platform campaign",
  [ADS_SUBSCRIPTION_ENTERPRISE_CAMPAIGNS_CUSTOM]: "Custom number of campaigns",
  [ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS]: "{{value}} brands",
  [ADS_SUBSCRIPTION_BENEFIT_ADVERTISER]: "{{value}} brand",
  [ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS_CUSTOM]: "Custom number of brands",
  [TOTAL_ADVERTISERS_COUNT]: "{{value}} Brands",
  [TOTAL_ADVERTISER_COUNT]: "{{value}} Brand",
  [ADS_SUBSCRIPTION_BENEFIT_CREATIVES]: "{{value}} creatives",
  [ADS_SUBSCRIPTION_BENEFIT_VIDEOS]: "{{value}} AI Videos (Ready-to-Publish)",
  [ADS_SUBSCRIPTION_BENEFIT_CREDITS_PER_MONTH]:
    "{{value,number}} credits / month",
  [ADS_SUBSCRIPTION_BENEFIT_VIDEOS_AI]: "{{value}} AI videos",
  [ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS_UP_TO]: "Up to {{value}} brands",
  [ADS_SUBSCRIPTION_BENEFIT_USERS_UP_TO]: "Up to {{value}} users",
  [ADS_SUBSCRIPTION_BENEFIT_USER]: "{{value}} user",
  [ADS_SUBSCRIPTION_BENEFIT_UNLIMITED_SOCIAL_POSTS]:
    "Unlimited social media publishing",
  [ADS_SUBSCRIPTION_BENEFIT_SUPPORT_CHAT_AND_EMAIL]:
    "Chat + priority email support",
  [ADS_SUBSCRIPTION_BENEFIT_WHITE_LABEL_OPTIONAL]: "Optional white-label",
  [ADS_SUBSCRIPTION_BENEFIT_CREATIVES_CUSTOM]: "Custom number of creatives",
  [ADS_SUBSCRIPTION_BENEFIT_OPTIMIZATIONS]: "Up to {{value}} optimizations",
  [ADS_SUBSCRIPTION_BENEFIT_AI_CAMPAIGNS]: "AI-powered campaign creation",
  [ADS_SUBSCRIPTION_BENEFIT_AI_AUDIENCE_SEGMENTATION]:
    "AI-powered audience segmentation",
  [ADS_SUBSCRIPTION_BENEFIT_AI_CONTENT]: "AI-generated content",
  [ADS_SUBSCRIPTION_BENEFIT_POSTS]: "Social media posting & scheduling",
  [ADS_SUBSCRIPTION_BENEFIT_AI_ADVANCED_INSIGHTS_AND_REPORTS]:
    "Actionable insights & analytics",
  [ADS_SUBSCRIPTION_BENEFIT_USERS]: "Up to {{value}} user(s)",
  [ADS_SUBSCRIPTION_BENEFIT_STORAGE]: "{{value}} GB storage",
  [ADS_SUBSCRIPTION_BENEFIT_STORAGE_CUSTOM]: "Custom storage",
  [ADS_SUBSCRIPTION_BENEFIT_EMAIL_SUPPORT]: "Email Support",
  [ADS_SUBSCRIPTION_BENEFIT_CHAT_SUPPORT]: "Chat Support",
  [ADS_SUBSCRIPTION_BENEFIT_PRIORITY_SUPPORT]: "Priority Support",
  [ADS_SUBSCRIPTION_BENEFIT_DEDICATED_ACCOUNT_MANAGER]:
    "Dedicated Account Marketer",

  //BILLING DATA
  [BILLING_DATA_TITLE]: "Billing Data",
  [BILLING_DATA_DESCRIPTION]: "Complete the data used for issuing invoices",
  [BILLING_DATA_SAVED]: "Billing data saved",
  [BILLING_DATA_PERSONAL_INFORMATION_DESCRIPTION]: "Personal information",
  [BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_PLACEHOLDER]: "Type",
  [BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_NATURE_OPTION]: "Individual",
  [BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_LEGAL_OPTION]: "Business",
  [BILLING_DATA_PERSONAL_INFORMATION_BUSINESS_NAME_PLACEHOLDER]:
    "Business name",
  [BILLING_DATA_PERSONAL_INFORMATION_NAME_PLACEHOLDER]: "First name",
  [BILLING_DATA_PERSONAL_INFORMATION_LAST_NAME_PLACEHOLDER]: "Last name",
  [BILLING_DATA_PERSONAL_INFORMATION_TYPE_ID_PLACEHOLDER]:
    "Type of identification",
  [BILLING_DATA_PERSONAL_INFORMATION_ID_NUMBER_PLACEHOLDER]:
    "Identification number",
  [BILLING_DATA_CONTACT_INFORMATION_DESCRIPTION]: "Contact information",
  [BILLING_DATA_CONTACT_INFORMATION_EMAIL_BILLING_PLACEHOLDER]:
    "Email (Billing)",
  [BILLING_DATA_CONTACT_INFORMATION_ADDRESS_PLACEHOLDER]: "Address",
  [BILLING_DATA_CONTACT_INFORMATION_PHONE_PLACEHOLDER]: "Mobile number",

  [MODAL_FREE_TRIAL_TITLE]: "Start your 3-day free trial!",
  [MODAL_FREE_TRIAL_DESCRIPTION]:
    "Collaborate on exchanges, campaigns, send payments and chat with content creators.",
  [MODAL_FREE_TRIAL_CAPTION]: "Start now for free",
  [MODAL_FREE_TRIAL_BUTTON]: "Try it FREE",
  [MODAL_FREE_TRIAL_START_ALERT_DESCRIPTION]:
    "You've unlocked your free trial, upgrade to {{NAME_BUSINESS}} Pro to start working with content creators.",

  [TRIAL_CONFIGURING_EXPERIENCE]: "Configuring your experience...",
  [TRIAL_PREPARING_PLATFORM]:
    "We are preparing everything so you can try the platform instantly.",
  [TRIAL_RETRY_ACCESS]: "Retry Access",

  [BLOCK_PAYMENT_FAILED_TITLE]: "Your payment failed",
  [BLOCK_TRIAL_END_TITLE]: "Your trial period has ended",
  [BLOCK_PACKAGE_DESCRIPTION]:
    "Activate your plan to collaborate with creators, launch campaigns, analyze metrics & download content for your social media feed",
  [BLOCK_PACKAGE_TITLE]: "Plan deactivated",
  [BLOCK_PLAN_BUTTON]: "Go to billing panel",
  [BLOCK_PLAN_BUTTON_ACTIVATE_PLAN]: "Activate plan",
  [BLOCK_TRIAL_ACTIVE_TITLE]: "Free trial is active",
  [BLOCK_TRIAL_ACTIVE_DESCRIPTION]:
    "Activate your plan to unlock the full potential of {{NAME_BUSINESS}}",
  [BLOCK_TRIAL_ACTIVE_BUTTON]: "Activate plan",
  [BLOCK_CONTACT_YOUR_ADMINISTRATOR_TITLE]:
    "Your account is inactive, please contact your administrator.",

  [MODAL_DISSATISFACTION_COLLABORATION_TITLE]:
    "We understand you're dissatisfied",
  [MODAL_DISSATISFACTION_COLLABORATION_DESCRIPTION]:
    "We're sorry the collaboration didn't meet your expectations. That's why we'll offer you the next collaboration for free",
  [MODAL_DISSATISFACTION_COLLABORATION_BUTTON]: "Receive 1 credit",
  [MODAL_DISSATISFACTION_COLLABORATION_EXPLANATION_CREDIT]:
    "*A credit equals a free collaboration and will be applied to your next collaboration.",
  [MODAL_DISSATISFACTION_COLLABORATION_CREDIT_RECEIVED]:
    "You received one credit",

  [MODAL_BUY_CREDITS_ARIA_LABEL]: `Modal to buy {{NAME_BUSINESS}} credits`,
  [MODAL_BUY_CREDITS_TITLE]: "Buy credits",
  [MODAL_BUY_CREDITS_DESCRIPTION]:
    "One credit equals one creator's post on exchange",
  [MODAL_BUY_CREDITS_CREDIT_FOR_COLLABORATION]:
    "Each successful exchange costs {{value,currency}}",
  [MODAL_BUY_CREDITS_HOW_MANY_CREDITS_BUY]:
    "How many credits would you like to buy?",
  [MODAL_BUY_CREDITS_REDEEMED_ESTIMATED_TIME]:
    "Your credits will be redeemed in an estimated {{value}} months",
  [MODAL_BUY_CREDITS_ADDITIONAL_CREDITS]: "We'll gift you {{value}} credit(s)!",
  [MODAL_BUY_CREDITS_LAST_TEXT_PAY]:
    "The total payment will be {{value,currency}}",
  [MODAL_BUY_CREDITS_AMOUNT_FOR_PRICE]:
    "{{credits}} Credits for {{value,currency}}",
  [MODAL_BUY_CREDITS_GIFT_CREDITS]:
    "(We gift you {{creditsGift}} for buying more than {{creditsBuy}})",
  [MODAL_BUY_CREDITS_AND_PAYMENT_METHOD_REQUIRED]:
    "The number of credits and payment method are required",
  [MODAL_BUY_CREDITS_NEGATIVE]: "The number of credits cannot be less than 1",
  [MODAL_BUY_CREDITS_PURCHASED]: "Successful Credit Purchase",
  [MODAL_BUY_CREDITS_PURCHASED_DESCRIPTION]:
    "We have successfully completed the transaction. Your credits are now available in your account.",
  [MODAL_BUY_VIDEOS_PURCHASED]: "Successful Video Purchase",
  [MODAL_BUY_VIDEOS_PURCHASED_DESCRIPTION]:
    "We have successfully completed the transaction. Your purchased videos are now available in your account.",
  [BUY_CREDITS]: "Buy Credits",
  [MODAL_PURCHASE_CREDITS_TITLE]: "Purchase Credits",
  [MODAL_PURCHASE_CREDITS_ARIA_LABEL]: "Purchase credits modal",
  [MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_TITLE]: "How purchasing credits works",
  [MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_1]:
    "One-time credits cost 50% more than recurring credits.",
  [MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_2]:
    "Unused credits will reset at the end of your current billing period.",
  [MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_3]:
    "Want a better rate or higher limit?",
  [MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_3_LINK]: "Upgrade your plan",
  [MODAL_PURCHASE_CREDITS_SELECT_AMOUNT]: "Select Package",
  [MODAL_PURCHASE_CREDITS_MINIMUM_AMOUNT]:
    "The minimum amount of credits you can purchase is {{minCredits}}.",
  [MODAL_PURCHASE_CREDITS_CUSTOM_AMOUNT_PLACEHOLDER]: "Enter custom amount",
  [MODAL_PURCHASE_CREDITS_UPGRADE_PLAN]: "Upgrade Plan",
  [MODAL_PURCHASE_CREDITS_PURCHASE_BUTTON]: "Purchase Credits",
  [MODAL_PURCHASE_CREDITS_PAYMENT_SUMMARY]:
    "You will pay ${{amount}} USD for {{credits}} Credits",
  [MODAL_PURCHASE_CREDITS_CREDITS_LABEL]: "{{credits}} credits",
  [MODAL_PURCHASE_CREDITS_PRICE_PER_CREDIT]: "${{price}} per credit",
  [MODAL_PURCHASE_CREDITS_CREDIT_PACKAGES_TITLE]: "Credit Packages",
  [MODAL_PURCHASE_CREDITS_VIDEO_PACKAGES_TITLE]: "Video Packages",
  [MODAL_PURCHASE_CREDITS_VIDEO_PACKAGES_SUBTITLE]:
    "Publish-ready videos with a structured script, audio, and subtitles included.",
  [MODAL_PURCHASE_CREDITS_VIDEO_ON_SCREEN_TEXT_LANGUAGES]:
    "Supported languages:",
  [MODAL_PURCHASE_CREDITS_VIDEOS_LABEL]: "{{videos}} AI Videos",
  [MODAL_PURCHASE_CREDITS_PRICE_PER_VIDEO]: "${{price}} USD each",
  [MODAL_PURCHASE_CREDITS_PURCHASE_VIDEOS_BUTTON]: "Purchase videos",
  [MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLES_TITLE]: "Video Examples",
  [MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLE]: "Example {{number}}",

  [VIDEO_INSUFFICIENT_CREDITS_ALERT_TITLE]: "Insufficient Video Credits",
  [VIDEO_INSUFFICIENT_CREDITS_ALERT_INTRO]:
    "You do not have enough video credits to complete this action. To get more credits, choose one of the following options:",
  [VIDEO_INSUFFICIENT_CREDITS_ALERT_INSTRUCTION]:
    "To get more credits, choose one of the following options:",
  [VIDEO_INSUFFICIENT_CREDITS_ALERT_OPTION_PURCHASE]: "Buy Credits",
  [VIDEO_INSUFFICIENT_CREDITS_ALERT_OPTION_UPGRADE]: "Plan Upgrade",

  //MODAL ADD BRAND SUPER ADMIN
  [MODAL_ADD_BRAND_SUPER_ADMIN_TITLE]: "Add brand",

  //MODAL UPLOAD CUSTOM AUDIENCES GOOGLE
  [MODAL_UPLOAD_CUSTOM_AUDIENCES_GOOGLE_TITLE]: "Upload your audience",
  [MODAL_UPLOAD_CUSTOM_AUDIENCES_GOOGLE_DESCRIPTION]:
    "Upload a CSV file to create a custom audience",

  //MODAL INSTANT EXPERIENCE CREATE
  [MODAL_INSTANT_EXPERIENCE_CREATE_TITLE]: "Create Instant Experience",
  [MODAL_INSTANT_EXPERIENCE_CREATE_DESCRIPTION]:
    "Configure your custom instant experience.",

  //LOGIN
  [FORGOT_PASSWORD]: "Forgot your password?",
  [NO_HAVE_ACCOUNT]: "Don't have an account?",
  [REGISTER_HERE]: "Register",
  [ALREADY_HAVE_AN_ACCOUNT]: "Already have an account?",
  [LOG_IN]: "Log In",
  [RESET_PASSWORD_EMAIL_SENT]:
    "We have sent an email to you with a link so you can reset your password.",

  //AUTH LAYOUT (MARKETING PANEL)
  [AUTH_LAYOUT_HERO_TITLE]: "Supercharge your Marketing",
  [AUTH_LAYOUT_HERO_DESCRIPTION]:
    "The AI marketing platform that helps you create, schedule, and analyze your content effortlessly.",
  [AUTH_LAYOUT_PREVIEW_PLACEHOLDER]: "Your dashboard preview will appear here.",
  [AUTH_LAYOUT_PREVIEW_IMAGE_ALT]:
    "{{NAME_BUSINESS}} dashboard preview with campaigns, metrics, and campaign list",
  [AUTH_LAYOUT_FEATURE_AI_TITLE]: "AI-powered campaigns",
  [AUTH_LAYOUT_FEATURE_AI_DESCRIPTION]: "Automate your marketing with AI.",
  [AUTH_LAYOUT_FEATURE_ANALYTICS_TITLE]: "Analytics that matter",
  [AUTH_LAYOUT_FEATURE_ANALYTICS_DESCRIPTION]:
    "Track performance metrics and turn data into clear next steps.",
  [AUTH_LAYOUT_FEATURE_SCHEDULING_TITLE]: "Smart scheduling",
  [AUTH_LAYOUT_FEATURE_SCHEDULING_DESCRIPTION]:
    "Plan and publish content across channels from one place.",

  //RESET PASSWORD
  [RESET_PASSWORD]: "Reset password",
  [RESET_PASSWORD_GET_TOKEN_FAILED]:
    "We could not obtain the token to reset the password, try opening the link sent to your email again or clicking the Forgot your password button again",
  [RESET_PASSWORD_SAVED]: "Password changed",

  //COMPLETE REGISTRATION
  [SET_PASSWORD]: "Set your Password",

  //REGISTER
  [REGISTER_COUNTRY_ANSWER]: "In which country is your brand located?",
  [REGISTER_COUNTRY_PLACEHOLDER]: "Country",
  [REGISTER_NAME_ANSWER]: "What is your name?",
  [REGISTER_PHONE_ANSWER]: "What is your mobile number?",
  [REGISTER_EMAIL_ANSWER]: "What is your email address?",
  [REGISTER_PASSWORD_ANSWER]: "Set a password",
  [REGISTER_BUSINESS_NAME_ANSWER]: "What is your brand's name?",
  [REGISTER_CATEGORY_ANSWER]: "What is your brand's category?",
  [REGISTER_SOCIAL_NETWORK_ANSWER]:
    "What is your brand's primary social network?",
  [REGISTER_SOCIAL_NETWORK_ANSWER_DESCRIPTION]:
    "Enter your social network's username.",
  [REGISTER_WEBSITE_ANSWER]: "What is your brand's website?",
  [REGISTER_WEBSITE_ANSWER_DESCRIPTION]:
    "Enter your IG or other social media link if you don't have a website.",
  [REGISTER_MONTHLY_SALES_ANSWER]: "What is your brand's monthly revenue?",
  [REGISTER_BUDGET_MARKETING_ANSWER]:
    "What is your brand's monthly marketing budget?",
  [REGISTER_EMPLOYEES_ANSWER]: "How many employees does your brand have?",
  [REGISTER_PRODUCT_AVAILABILITY_ANSWER]: "Where are your customers located?",
  [REGISTER_RUT_ANSWER]: "Upload your company's constitution document",
  [REGISTER_INVIMA_ANSWER]: "Upload your brand's health authority registration",
  [REGISTER_ICA_ANSWER]:
    "Upload the product authority registration for animal products for your brand",
  [REGISTER_YOU_MEET_ANSWER]: "Where did you hear about us?",
  [REGISTER_WRITE_PLACEHOLDER]: "Write your answer here",
  [REGISTER_SELECT_PLACEHOLDER]: "Select an option",
  [REGISTER_COUNTRY_REQUIRED]: "You must select your country",
  [REGISTER_NAME_REQUIRED]: "You must enter your name",
  [REGISTER_PHONE_REQUIRED]: "You must enter your mobile number",
  [REGISTER_PHONE_NUMERIC_REQUIRED]: "The mobile number is not valid",
  [REGISTER_BUSINESS_NAME_REQUIRED]: "You must enter your brand's name",
  [REGISTER_CATEGORY_REQUIRED]: "You must select a category",
  [REGISTER_SOCIAL_NETWORK_REQUIRED]:
    "The social network username must be at least 3 characters long",
  [REGISTER_WEB_SITE_REQUIRED]:
    "You must enter the link to your brand's website",
  [REGISTER_MONTHLY_SALES_REQUIRED]:
    "You must select your brand's monthly revenue",
  [REGISTER_BUDGET_MARKETING_REQUIRED]:
    "You must select your brand's monthly marketing budget",
  [REGISTER_EMPLOYEES_REQUIRED]:
    "You must select the number of employees in your brand",
  [REGISTER_PRODUCT_AVAILABILITY_REQUIRED]:
    "You must select the availability of your products",
  [REGISTER_RUT_REQUIRED]:
    "You must select the RUT or company constitution document",
  [REGISTER_INVIMA_REQUIRED]:
    "You must select your brand's INVIMA registration",
  [REGISTER_ICA_REQUIRED]: "You must select your brand's ICA registration",
  [REGISTER_YOU_MEET_REQUIRED]:
    "You must select an option for where you heard about us",
  [REGISTER_NO_HAVE_DOCUMENTS_ALERT_TITLE]: "Sorry",
  [REGISTER_NO_HAVE_DOCUMENTS_ALERT_DESCRIPTION]:
    "We cannot continue the process if you don't have the required documents. Please revisit the process once you have them.",
  [REGISTER_REGISTERED_ALERT_DESCRIPTION]:
    "We are reviewing your information. We will send you an email once your brand is approved.",
  [PLEASE_SELECT_COUNTRY]: "Please select a country",
  [REGISTER_PROFILE_CREATOR_CITIES_ANSWER]:
    "Which cities do you want to find creators from to work with?",
  [REGISTER_PROFILE_CREATOR_PLATFORMS_ANSWER]:
    "On which social media or content platforms do you want to find creators to work with?",
  [REGISTER_PROFILE_CREATOR_CATEGORIES_ANSWER]:
    "What type of content do you want your ideal creator to make?",
  [REGISTER_PROFILE_CREATOR_GENDER_ANSWER]:
    "Which genders of creators do you want to work with?",
  [REGISTER_PROFILE_CREATOR_AGE_ANSWER]:
    "Which age groups of creators do you want to work with?",
  [REGISTER_PROFILE_CREATOR_BODY_BUILD]:
    "What type of body build do you want your ideal creator to have?",
  [REGISTER_PROFILE_CREATOR_CLOTHING_STYLE]:
    "What type of clothing style do you want your ideal creator to have?",
  [REGISTER_PROFILE_CREATOR_DISTINGUISHING_FEATURES]:
    "What distinguishing features do you want your ideal creator to have?",
  [REGISTER_PROFILE_CREATOR_CONTENT_STYLE]:
    "What type of content style do you want your ideal creator to have?",
  [REGISTER_PROFILE_CREATOR_CITIES_REQUIRED]:
    "You must select at least one city",
  [REGISTER_PROFILE_CREATOR_PLATFORMS_REQUIRED]:
    "You must select at least one platform",
  [REGISTER_PROFILE_CREATOR_CATEGORIES_REQUIRED]:
    "You must select at least three categories",
  [REGISTER_PROFILE_CREATOR_GENDER_REQUIRED]:
    "You must select at least one gender",
  [REGISTER_PROFILE_CREATOR_AGE_RANGE_REQUIRED]:
    "You must select at least two age ranges",
  [REGISTER_PROFILE_CREATOR_BODY_BUILD_REQUIRED]:
    "You must select at least two body builds",
  [REGISTER_PROFILE_CREATOR_CLOTHING_STYLE_REQUIRED]:
    "You must select at least three clothing styles",
  [REGISTER_PROFILE_CREATOR_DISTINGUISHING_FEATURES_REQUIRED]:
    "You must select at least three distinguishing features",
  [REGISTER_PROFILE_CREATOR_CONTENT_STYLE_REQUIRED]:
    "You must select at least three content styles",

  //CHATS
  [CHAT_ERROR_SENT_MESSAGE]:
    "Sorry, there was an internal failure, please try again later.",
  [CHAT_DO_PAYMENT]: "Make payment",
  [CHAT_WRITE_QUESTION_HERE]: "Write a question",
  [CHAT_WRITE_MESSAGE_HERE]: "Write a message",
  [CHAT_EMAIL_NO_PERMITTED]: "Sending emails is not allowed",
  [ONE_SECOND_AGO]: "1 second ago",
  [CHAT_FIRST_MESSAGE_BOT]:
    "Hello, I'm Ana, expert advisor on the platform.\nHow can I help you today?",
  [CHAT_NO_MORE]: "No more chats to load",
  [CHAT_DO_A_QUESTION]: "Ask a question",
  [CHAT_ASK_A_QUESTION_ABOUT_YOUR_CAMPAIGN]: "Send a message",
  [CHAT_CAMPAIGN_OPEN_AUTO_SUMMARY_QUESTION]:
    "Give me a concise summary of my campaign and whether I should make any changes right now.",
  [CHAT_CAMPAIGN_OPEN_ANALYZING_SUGGESTIONS]:
    "Analyzing your campaign to give you suggestions...",
  [CHAT_BOT_NAME]: "Marketing Agent",
  [CHAT_BOT_DESCRIPTION]: "Ask about your campaign",
  [CHAT_BOT_WELCOME_MESSAGE]: "What would you like to optimize today?",
  [CHAT_BOT_WELCOME_DESCRIPTION]:
    "You can also ask me for copy changes, segmentation, etc.",
  [CHAT_BOT_WELCOME_MESSAGE_STATISTICS]:
    "What would you like to know about your campaign?",
  [CHAT_BOT_WELCOME_DESCRIPTION_STATISTICS]:
    "You can ask me about metrics, targeting, budgets, costs and more.",
  [CHAT_BOT_WELCOME_MESSAGE_OWNER]: "What do you need help with?",
  [CHAT_BOT_WELCOME_DESCRIPTION_OWNER]:
    "Ask about your clients, brands, plans and billing.",
  [CHAT_ASK_A_QUESTION_OWNER]: "Ask about your dashboard...",
  [CHAT_REASONING_ANALYZING_USER_MESSAGE]: "Analyzing user message",
  [CHAT_REASONING_PROCESSING_CAMPAIGN_DATA]: "Processing campaign data",
  [CHAT_REASONING_GETTING_PERFORMANCE_METRICS]: "Getting performance metrics",
  [CHAT_REASONING_ANALYZING_BEST_PRACTICES]: "Analyzing best practices",
  [CHAT_REASONING_GENERATING_RECOMMENDATIONS]: "Generating recommendations",
  [CHAT_THINKING]: "Thinking",

  //SUMMARY TEXT (CHAT)
  [CHAT_SUMMARY_OVERVIEW_TEXT]:
    "How was the performance overall in {{platforms}} between the dates {{startDateTime}} and {{endDateTime}}? Give a concise paragraph detailing the performance.",

  //NOTIFICATIONS
  [NOTIFICATIONS_TITLE]: "Notifications",
  [NOTIFICATIONS_MARK_READS]: "Mark as read",
  [NOTIFICATIONS_EMPTY]: "You have no notifications",
  [NOTIFICATIONS_NO_MORE]: "You have no more notifications",
  [NOTIFICATIONS_CHECK_NOTIFICATION]: "Check",

  //TRANSACTIONS
  [TRANSACTION_CONCEPT_LABEL]: "Concept",
  [TRANSACTION_TYPE]: "Type",
  [TRANSACTION_TYPE_CREDIT]: "Credit",
  [TRANSACTION_TYPE_DEBIT]: "Debit",
  [TRANSACTION_STATUS]: "Status",
  [TRANSACTION_STATUS_PENDING]: "Pending",
  [TRANSACTION_STATUS_PENDING_RELEASE]: "Pending release",
  [TRANSACTION_STATUS_IN_PROCESS_RELEASE]: "In process of release",
  [TRANSACTION_STATUS_RELEASED]: "Released",
  [TRANSACTION_STATUS_PENDING_SENT]: "Pending to send",
  [TRANSACTION_IN_TRANSIT]: "In transit",
  [TRANSACTION_STATUS_PAID]: "Paid",
  [TRANSACTION_WAS_PAID]: "Was paid",
  [MODAL_CREATE_TRANSACTION]: "Create a transaction for a creator",
  [MODAL_CREATE_TRANSACTION_AMOUNT_LABEL]: "Amount (USD)",
  [MODAL_CREATE_TRANSACTION_CONCEPT_LABEL]: "Concept",
  [MODAL_CREATE_TRANSACTION_CONCEPT_APPLICANT]: "Applicant",
  [MODAL_CREATE_TRANSACTION_CONCEPT_ORDER]: "Order",
  [MODAL_CREATE_TRANSACTION_CONCEPT_REFERRAL]: "Referral",
  [MODAL_CREATE_TRANSACTION_CONCEPT_ID]: "Concept ID (Optional)",

  //CONTENT
  [CONTENT_TITLE]: "Brand content",

  //CONTENT APPLICATION
  [CONTENT_APPLICATION_TITLE]: "Content application",
  [CONTENT_APPLICATION_ACCEPT_TITLE]: "Accept application",
  [CONTENT_APPLICATION_ACCEPT_DESCRIPTION]:
    "By accepting this application, the user will be able to register as a content creator",
  [CONTENT_APPLICATION_REJECT_TITLE]: "Reject application",
  [CONTENT_APPLICATION_REJECT_DESCRIPTION]:
    "By rejecting this application, the user will not be able to register as a content creator",

  //REPORTS
  [REPORTS_TITLE]: "Reports",
  [REPORTS_DESCRIPTION]:
    "Here you will find the general statistics of the {{NAME_BUSINESS}} ecosystem",
  [REPORTS_ERROR_GENERATING]:
    "Something went wrong with generating statistics, please try again.",
  [REPORTS_REQUESTS_ACTIVE]: "Active requests",
  [REPORTS_REQUESTS_INACTIVE]: "Inactive requests",
  [REPORTS_TYPE_USERS]: "User type",
  [REPORTS_NUMBER_USERS]: "Number of users",
  [REPORTS_TYPE_ORDER]: "Order type",
  [REPORTS_NUMBER_ORDER]: "Number of orders",
  [REPORTS_MODAL_DESCRIPTION]:
    "Here you will find reports of different categories",
  [REPORTS_MODAL_ONLY_BRANDS_ACTIVE]: "Only active stores",
  [REPORTS_MODAL_TYPE_REPORT_LABEL]: "Report type",
  [REPORTS_MODAL_TYPE_REPORT_BRANDS]: "Brands",
  [REPORTS_MODAL_TYPE_REPORT_CREATORS]: "Creators",
  [REPORTS_MODAL_TYPE_REPORT_ORDERS]: "Orders",

  //SHOPIFY TERMS
  [INTEGRATIONS_TERMS_TITLE]: `{{NAME_BUSINESS}}'s Privacy Policy with Integrations`,
  [INTEGRATIONS_TERMS_DESCRIPTION]: "Last updated: {{date,short}}",
  [INTEGRATIONS_TERMS_CONTENT]: `
    <strong>1. Information collected</strong><br>
    
    At {{NAME_BUSINESS}}, we respect the privacy of our users and customers. Through our integration with platforms, we collect limited and specific information only for the technical operation of our application. The data we collect includes:<br>
    
    Integration store name: We use this information to identify the store and facilitate the execution of specific actions within the platform.<br>
    
    Authorization token: We use an authorization token provided by platform merchants to make necessary technical requests for monitoring delivery status changes and executing actions as required.<br><br>
    
    <strong>2. Use of information</strong><br>
    
    It's important to note that we do not store any personal data or identifiable information of merchants or their customers. The collected information is used solely for the technical execution of the {{NAME_BUSINESS}} application on the platform. It is not used for any other purpose and is not stored in our databases.<br><br>
    
    <strong>3. Data retention</strong><br>
    
    In line with our no data storage policy, we do not retain any information of merchants or their customers. Any received information is used in real-time and discarded immediately after its use.<br><br>
    
    <strong>4. Contact</strong><br>
    
    If you have any questions or concerns about our privacy policy, feel free to contact us at ${EMAIL_SUPPORT}.
  `,

  [AUTH_TIKTOK_VERIFICATION_LOADING]: "Verifying your TikTok account",
  [AUTH_TIKTOK_VERIFICATION_SUCCESS]: "Your TikTok account has been verified",
  [AUTH_TIKTOK_VERIFICATION_FAILED]:
    "An error occurred. We couldn't verify your TikTok account",

  // COLUMN NAMES
  [COLUMN_NAME_BRAND]: "Brand",
  [COLUMN_NAME_AGENCY]: "Agency",
  [COLUMN_NAME_ADVERTISER]: "Brand",
  [COLUMN_NAME_USER]: "User",
  [COLUMN_NAME_CATEGORY]: "Category",
  [COLUMN_NAME_IS_LOGGED]: "Logged in",
  [COLUMN_NAME_IS_ACTIVE]: "Is active",
  [COLUMN_NAME_PACKAGE]: "Package",
  [COLUMN_NAME_EMAIL]: "Email",
  [COLUMN_NAME_NAME]: "Name",
  [COLUMN_NAME_PHONE]: "Phone",
  [COLUMN_NAME_STAFF]: "Staff",
  [COLUMN_NAME_ACCEPTED]: "Accepted",
  [COLUMN_NAME_MONTHLY_SALES]: "Monthly sales",
  [COLUMN_NAME_BUDGET_MARKETING]: "Marketing budget",
  [COLUMN_NAME_EMPLOYEES]: "Employees",
  [COLUMN_NAME_PRODUCT_AVAILABILITY]: "Product availability",
  [COLUMN_NAME_SOCIAL_NETWORK]: "Social network",
  [COLUMN_NAME_WEB_SITE]: "Website",
  [COLUMN_NAME_YOU_MEET]: "Where you met us",
  [COLUMN_NAME_DATE]: "Date",
  [COLUMN_NAME_PLAN]: "Plan",
  [COLUMN_NAME_PAYMENT_METHOD]: "Payment method",
  [COLUMN_NAME_COST_COLLABORATION]: "Cost per collaboration",
  [COLUMN_NAME_CREDITS]: "Credits",
  [COLUMN_NAME_COUNTRY]: "Country",
  [COLUMN_NAME_CREATOR_NAME]: "Name",
  [COLUMN_NAME_CREATOR_PLATFORM]: "Platform",
  [COLUMN_NAME_CITY]: "City",
  [COLUMN_NAME_AUDIENCE]: "Audience",
  [COLUMN_NAME_ENGAGEMENT]: "Engagement",
  [COLUMN_NAME_CATEGORIES]: "Categories",
  [COLUMN_NAME_SCORE]: "Score",
  [COLUMN_NAME_ACTIVITY]: "Activity",
  [COLUMN_NAME_ACTIONS]: "Actions",
  [COLUMN_NAME_ACTION]: "Action",
  [COLUMN_NAME_STATUS]: "Status",
  [COLUMN_NAME_REDEEMED_DATE]: "Redeemed on",
  [COLUMN_NAME_TERMS]: "Terms",
  [COLUMN_NAME_TYPE]: "Type",
  [COLUMN_NAME_ADDRESS]: "Address",
  [COLUMN_NAME_STORE]: "Store",
  [COLUMN_NAME_ROLE]: "Role",
  [COLUMN_NAME_PAID_DATE]: "Paid On",
  [COLUMN_NAME_DUE_DATE]: "Due On",
  [COLUMN_NAME_REASON]: "Reason",
  [COLUMN_NAME_VALUE]: "Value",
  [COLUMN_NAME_ID]: "ID",
  [COLUMN_NAME_CREATOR]: "Creator",
  [COLUMN_NAME_CREATED_DATE]: "Created on",
  [COLUMN_NAME_ACCEPTED_DATE]: "Accepted on",
  [COLUMN_NAME_DETAILS]: "Details",
  [COLUMN_NAME_DELIVERY]: "Delivery",
  [COLUMN_NAME_CODE_VERIFICATION]: "Verification code",
  [COLUMN_NAME_ACCOUNT_NAME]: "Account name",
  [COLUMN_NAME_IS_HIDDEN]: "Hidden",
  [COLUMN_NAME_COMMENT]: "Comment",
  [COLUMN_NAME_URLS]: "Urls",
  [COLUMN_NAME_KEYWORD]: "Keyword",
  [COLUMN_NAME_SEARCH_TERM]: "Search Term",
  [GOOGLE_SEARCH_TERMS_TITLE]: "Search Terms",
  [GOOGLE_SEARCH_TERMS_DESCRIPTION]:
    "These are the exact queries people typed in Google that triggered your ads. Each row shows which keyword matched that search.",
  [GOOGLE_SEARCH_TERMS_EMPTY]: "No search terms yet",
  [SEARCH_TERM_MATCH_TYPE_BROAD]: "Broad match",
  [SEARCH_TERM_MATCH_TYPE_PHRASE]: "Phrase match",
  [SEARCH_TERM_MATCH_TYPE_EXACT]: "Exact match",
  [SEARCH_TERM_MATCH_TYPE_NEAR_PHRASE]: "Phrase match (close variant)",
  [SEARCH_TERM_MATCH_TYPE_NEAR_EXACT]: "Exact match (close variant)",
  [SEARCH_TERM_MATCH_TYPE_AI_MAX]: "AI Max",
  [COLUMN_NAME_IMPRESSIONS]: "Impressions",
  [COLUMN_NAME_CLICKS]: "Clicks",
  [COLUMN_NAME_CONFIGURE_COLUMNS]: "Show Columns",
  [COLUMN_NAME_CTR]: "CTR",
  [COLUMN_NAME_CONVERSIONS]: "Conversions",
  [COLUMN_NAME_CPA]: "CPA",
  [COLUMN_NAME_CPM]: "CPM",
  [COLUMN_NAME_CPC]: "CPC",
  [COLUMN_NAME_MATCH_TYPE]: "Match Type",
  [COLUMN_NAME_PLATFORM]: "Platforms",
  [COLUMN_NAME_SPEND]: "Spend",
  [COLUMN_NAME_RESULTS]: "Results",
  [COLUMN_NAME_FIELD]: "Field",
  [COLUMN_NAME_CURRENT_VALUE]: "Current value",
  [COLUMN_NAME_NEW_VALUE]: "New value",
  [COLUMN_NAME_CAMPAIGN]: "Campaign",
  [COLUMN_NAME_BUDGET]: "Budget",
  [COLUMN_NAME_CREATED_BY]: "Created by",
  [CAMPAIGNS_TABLE_ARIA_LABEL]: "Campaigns table",
  [CAMPAIGNS_TABLE_TITLE]: "Campaigns list",
  [CAMPAIGNS_STATUS_DRAFT]: "Draft",
  [CAMPAIGNS_STATUS_FINISHED]: "Finished",
  [CAMPAIGNS_STATUS_DELETED]: "Deleted",
  [CAMPAIGNS_TABLE_FILTER_COLUMNS_TITLE]: "Filter columns",
  [COLUMN_NAME_ENTITY]: "Entity",

  //ALERTS
  [ALERT_PLATFORM_STATUS_BANNER]:
    "{{platform}} is experiencing technical issues. Some features may be temporarily affected",
  [ALERT_IMAGE_PROVIDER_STATUS_BANNER]:
    "The image generation/editing provider is experiencing technical issues. This functionality may be temporarily affected",
  [ALERT_VIDEO_PROVIDER_STATUS_BANNER]:
    "The video generation provider is experiencing technical issues. This functionality may be temporarily affected",
  [ALERT_CAMPAIGN_PROVIDER_STATUS_BANNER]:
    "The campaign generation provider is experiencing technical issues. This functionality may be temporarily affected",
  [ALERT_REBRAND_BANNER]:
    "Buzzly is now Adle. Same AI marketing platform, new identity.",
  [ALERT_REBRAND_BANNER_DISCORD_BODY]:
    "Join the official Adle Discord community.",
  [DISCORD_LINK]: "Join Discord",
  [ALERT_REBRAND_BANNER_APPSUMO_REVIEW_BODY]:
    "<margin>🌮</margin> Early Sumolings: bonus credits are in. <underline>Share your experience on AppSumo 💛</underline>",
  [ALERT_REBRAND_BANNER_AFFILIATE_BODY]:
    "<margin>💸</margin> Earn with our affiliate program.",
  [ALERT_REBRAND_BANNER_AFFILIATE_LINK]: "Apply Now 💸",
  [APPSUMO_REVIEW_BANNER_LINK]: "Leave a review",
  [ALERT_REBRAND_BANNER_CAROUSEL_PREVIOUS]: "Previous banner message",
  [ALERT_REBRAND_BANNER_CAROUSEL_NEXT]: "Next banner message",
  [MODAL_REBRAND_ADLE_TITLE]: "Buzzly is now Adle",
  [MODAL_REBRAND_ADLE_DESCRIPTION]:
    "Buzzly is migrating its brand to Adle. It remains the same AI marketing platform, with a new identity.",
  [MODAL_REBRAND_ADLE_GO_TO_ADLE_BUTTON]: "Go to Adle",
  [ALERT_INACTIVE_SHOP_TITLE]: "Brand Deactivated",
  [ALERT_INACTIVE_SHOP_DESCRIPTION]:
    "Activate the brand to continue using the platform.",

  [ALERT_OPERATOR_ACTION_UNAUTHORIZED_DESCRIPTION]:
    "You cannot perform this action because you don't have sufficient permissions.",
  [ALERT_CREATE_SECOND_ADS_CAMPAIGN]: "Create campaign on {{platform}}",
  [ALERT_CREATE_SECOND_ADS_CAMPAIGN_DESCRIPTION]:
    "Do you wish to create a campaign on {{platform}} with the same settings as this campaign?",
  [ALERT_REMEMBER_IF_RECHARGE_ACCOUNT_PLATFORM]:
    "If you recharge your account, please note that it may take a few minutes for the balance to be reflected and for this option to be re-enabled.",
  [ALERT_DESCRIPTION_DISCONNECT_FACEBOOK]:
    "All campaign creation and management functionalities will be disabled in Meta and post directly to Instagram.",
  [ALERT_DESCRIPTION_DISCONNECT_TIKTOK]:
    "All functionalities to post directly to TikTok will be disabled.",
  [ALERT_DESCRIPTION_DISCONNECT_TIKTOK_BUSINESS]:
    "All functionalities for creating and managing TikTok campaigns will be disabled",
  [ALERT_DESCRIPTION_DISCONNECT_LINKEDIN]:
    "All functionalities to create and manage LinkedIn campaigns will be disabled",
  [ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE]: "Are you sure?",
  [ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION]:
    "You will create a campaign with the following budgets for each platform:",
  [ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE_UPDATE]: "Are you sure?",
  [ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION_UPDATE]:
    "Ad groups will be created with the following new budgets for each platform",
  [ALERT_DESCRIPTION_DISCONNECT_CANVA]:
    "All functionalities to create content or edit with Canva will be disabled.",
  [ALERT_TIK_TOK_BUSINESS_NEEDS_CREATE_IDENTITY_TITLE]: "Connection successful",
  [ALERT_TIK_TOK_BUSINESS_NEEDS_CREATE_IDENTITY_DESCRIPTION]:
    "Your TikTok account has been successfully connected, now you need to create an identity to display your ads",
  [ALERT_CONNECT_ACCOUNT_FOR_CREATE_CAMPAIGN_TITLE]: "Connect your account",
  [ALERT_CONNECT_ACCOUNT_FOR_CREATE_CAMPAIGN_DESCRIPTION]:
    "In order to create a campaign you need to connect your account",
  [ALERT_CANCEL_SUBSCRIPTION_TITLE_CONFIRMATION]: "Are you sure?",
  [ALERT_CANCEL_SUBSCRIPTION_DESCRIPTION_CONFIRMATION]:
    "By canceling your subscription, you will lose access to all the platform's functionalities.",
  [ALERT_CANCEL_SUBSCRIPTION_TITLE]: "Subscription Canceled",
  [ALERT_CANCEL_PLAN_TITLE]: "Plan Canceled",
  [ALERT_CANCEL_SUBSCRIPTION_DESCRIPTION]:
    "Your subscription's auto-renewal has been cancelled, your service will remain active until {{date, monthText}} {{date, day}}, {{date, year}}",
  [ALERT_REACTIVATE_SUBSCRIPTION_TITLE]: "Subscription Reactivated",
  [ALERT_PAYMENT_METHOD_CHANGED_TITLE]:
    "Your payment method has been changed successfully",
  [ALERT_CONNECT_ACCOUNT_SECURE_DESCRIPTION]:
    "With {{NAME_BUSINESS}} your accounts will be safe. We are a verified and audited platform by {{platform}}, allowing you to manage and disconnect your accounts at any time.",
  [ALERT_POPUP_BLOCKED_TITLE]: "Allow Pop-ups",
  [ALERT_POPUP_BLOCKED_DESCRIPTION]:
    "We detected that you have pop-ups blocked for this website. Please enable pop-ups and try again.",
  [ALERT_DELETE_PLATFORM_CAMPAIGN_DESCRIPTION]:
    "You will no longer publish a campaign in {{platform}}",
  [ALERT_DUPLICATE_CAMPAIGN_TITLE]: "Duplicate Campaign",
  [ALERT_DUPLICATE_CAMPAIGN_DESCRIPTION]:
    "A campaign will be created with these same settings, but you will be able to edit it before publishing.",
  [ALERT_DELETE_CAMPAIGN_ACTIVE_TITLE]:
    "Do you want to deactivate and delete this campaign?",
  [ALERT_DELETE_CAMPAIGN_TITLE]:
    "Are you sure you want to delete this campaign?",
  [ALERT_ARCHIVE_CAMPAIGN_TITLE]:
    "Are you sure you want to archive this campaign?",
  [ALERT_ARCHIVE_CAMPAIGN_TITLE_ACTIVE]:
    "Do you want to deactivate and archive this campaign?",
  [ALERT_ARCHIVE_CAMPAIGN_DESCRIPTION]:
    "This campaign has already been generated and has been deducted from your plan. By archiving it, you will not be able to recover it and the cost will not be refunded",
  [ALERT_DELETE_CAMPAIGN_DESCRIPTION]:
    "The {{platform}} campaign will be deleted. You will not be able to recover the information or create a {{platform}} campaign in this campaign group again.",
  [ALERT_DELETE_ELEMENT_TITLE]: "Are you sure?",
  [ALERT_DELETE_ELEMENT_DESCRIPTION]:
    "If you delete this element, you will not be able to recover the information.",
  [ALERT_DELETE_CAMPAIGN_ERROR_TITLE]: "Error deleting campaign",
  [ALERT_DELETE_CAMPAIGN_ERROR_TEXT]:
    "Could not delete the campaign, please try again",
  [ALERT_PUBLISH_ACTIVE_OR_DEACTIVATE_CAMPAIGN_TITLE]:
    "Choose whether you want your campaign to be created as active or inactive",
  [ALERT_GOOGLE_ACCOUNT_NO_REGISTERED_TITLE]:
    "You do not have a registered account",
  [ALERT_GOOGLE_ACCOUNT_NO_REGISTERED_DESCRIPTION]:
    "In order to register you need to schedule a demo with us.",
  [ALERT_DESCRIPTION_DISCONNECT_GOOGLE]:
    "All functionality to create and manage Google Ads campaigns will be disabled.",
  [ALERT_CONNECT_GOOGLE_BETA_TITLE]: "Connect your Google Ads account",
  [ALERT_CONNECT_GOOGLE_BETA_DESCRIPTION]:
    "This feature is in <strong>BETA</strong>. Below, you will see how to connect your Google Ads account.",
  [ALERT_FILL_BRAND_SETUP_TITLE]: "Complete your brand information",
  [ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_CAMPAIGN]:
    "Fill in your brand details to generate a campaign with AI",
  [ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_GENERATE_CREATIVES]:
    "Fill in your brand details to generate creatives with AI",
  [ALERT_DELETE_KEYWORD_TITLE]: "Delete keyword",
  [ALERT_DELETE_KEYWORD_DESCRIPTION]:
    "Are you sure you want to delete this keyword?",
  [ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_TITLE]: "Wait",
  [ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_DESCRIPTION]:
    "If you make this change, the content you have selected for your ads will be deselected",
  [ALERT_IS_DYNAMIC_CREATIVE_ON_TITLE]: "Are you sure?",
  [ALERT_IS_DYNAMIC_CREATIVE_ON_DESCRIPTION]:
    "When using dynamic creatives, the following limitations will apply:<br><br><ul><li>You can only have 1 Ad. (The rest will be removed if you have more than one)</li><li>You can only use Website or Instant Forms as the ad group conversion location</li></ul>These corrections will be applied automatically if you continue.",
  [ALERT_IS_DYNAMIC_CREATIVE_OFF_TITLE]: "Are you sure?",
  [ALERT_IS_DYNAMIC_CREATIVE_OFF_DESCRIPTION]:
    "When you stop using dynamic creatives, the following changes will apply:<br><br><ul><li>Your only ad will be reset, keeping only the first creative and the first call to action</li></ul>",
  [ALERT_CHANGE_AD_ACCOUNT_GENERAL_TITLE]: "Wait",
  [ALERT_CHANGE_AD_ACCOUNT_META_DESCRIPTION]: `If you change your advertising account, some selected campaign settings will be reset:<br/><br/>
  
Pixel<br/>
Instant form<br/>
WhatsApp number<br/>
Custom audiences<br/>
Budgets`,
  [ALERT_CHANGE_AD_ACCOUNT_TIKTOK_DESCRIPTION]: `If you change your advertising account, some selected campaign settings will be reset:<br/><br/>

TikTok identity<br/>
Pixel<br/>
Budgets`,
  [ALERT_CHANGE_AD_ACCOUNT_GOOGLE_DESCRIPTION]: `If you change your advertising account, some selected campaign settings will be reset:<br/><br/>

Conversion actions<br/>
Budget`,
  [ALERT_CHANGE_AD_ACCOUNT_LINKEDIN_DESCRIPTION]: `If you change your advertising account, some selected campaign settings will be reset:<br/><br/>

Custom audiences<br/>
Instant form<br/>
Budget`,
  [ALERT_DELETE_KEYWORDS_TITLE]: "Delete keywords",
  [ALERT_DELETE_KEYWORDS_DESCRIPTION]:
    "Are you sure you want to delete {{value}} keywords?",
  [ALERT_CHANGE_CUSTOM_AUDIENCES_CAMPAIGN_TITLE]: "Wait",
  [ALERT_CHANGE_CUSTOM_AUDIENCES_CAMPAIGN_DESCRIPTION]:
    "One or more ad groups have custom audiences configured, if you select custom audiences at the campaign level, the custom audience configurations of the ad groups will be deselected.",
  [ALERT_CHANGE_CUSTOM_AUDIENCES_GROUPS_TITLE]: "Wait",
  [ALERT_CHANGE_CUSTOM_AUDIENCES_GROUPS_DESCRIPTION]:
    "There are one or more custom audiences configured at the campaign level, if you select custom audiences at the group level, the custom audience configurations of the campaign will be deselected.",
  [SUGGESTION_BUDGET_TITLE]: "Suggestion Budget",
  [SUGGESTION_BUDGET_TEXT]:
    "You have extended the end date of this ad group, we recommend increasing the total budget to maintain an equal relationship",
  [SUGGESTION_BUDGET_PREVIOUS]: "Previous Budget",
  [SUGGESTION_BUDGET_CURRENT]: "Suggested Budget",
  [SUGGESTION_BUDGET_APPLY]: "Apply Suggestion",
  [SUGGESTION_BUDGET_CANCEL]: "Cancel",
  [SUGGESTION_BUDGET_MINIMUM]: "Minimum Budget",
  [ALERT_CHANGE_ADVERTISER_TITLE]: "You switched to brand {{businessName}}",
  [ALERT_RESIZE_IMAGE_FAILED_DESCRIPTION]:
    "We couldn't resize this image. Please try again.",

  //OPTIONS UGC FORMATS
  [OPTION_UGC_FORMAT_GRWM]: "GRWM (Get Ready With Me)",
  [OPTION_UGC_FORMAT_GRWM_EXPLANATION]:
    "This type of content involves creators sharing their preparation routine, whether for everyday or special events. Viewers can watch as the creator applies makeup, styles hair, and selects outfits, while discussing various topics in an informal manner.",
  [OPTION_UGC_FORMAT_OODT]: "OOTD (Outfit of the Day)",
  [OPTION_UGC_FORMAT_OODT_EXPLANATION]:
    "In these videos or posts, creators showcase the outfit they have chosen for the day. Popular among fashion enthusiasts, it may include details on where they purchased the clothing, how they pair it with other items, and style tips.",
  [OPTION_UGC_FORMAT_HAULS]: "Hauls",
  [OPTION_UGC_FORMAT_HAULS_EXPLANATION]:
    "'Hauls' are videos or photo series where creators display a collection of recently purchased products, which may include fashion, beauty, technology, etc. They often share their first impressions of these products and may include usage demonstrations.",
  [OPTION_UGC_FORMAT_DIYS]: "Tutorials/DIYs",
  [OPTION_UGC_FORMAT_DIYS_EXPLANATION]:
    "Tutorials or 'Do It Yourself' (DIYs) are step-by-step guides created by users that demonstrate how to make something, from cooking recipes to craft projects and beauty hacks. These contents are educational and aim to teach skills in an easy and accessible way.",
  [OPTION_UGC_FORMAT_UNBOXING]: "Unboxing",
  [OPTION_UGC_FORMAT_UNBOXING_EXPLANATION]:
    "In these videos, creators unbox new products in front of the camera to show their contents and provide a first impression. They are common in technology, toys, cosmetics, and more, helping viewers decide if they want to purchase those products.",
  [OPTION_UGC_FORMAT_CHALLENGES]: "Challenges",
  [OPTION_UGC_FORMAT_CHALLENGES_EXPLANATION]:
    "Challenges are activities in which creators engage to entertain their followers. These can range from food challenges, games, physical activities to fashion challenges, like creating an outfit with specific items.",
  [OPTION_UGC_FORMAT_REVIEWS]: "Reviews/Testimonials",
  [OPTION_UGC_FORMAT_REVIEWS_EXPLANATION]:
    "Creators share their detailed opinions and experiences about a specific product or service. These reviews help other users form an opinion before making a purchase.",
  [OPTION_UGC_FORMAT_VLOGS]: "Vlogs",
  [OPTION_UGC_FORMAT_VLOGS_EXPLANATION]:
    "Vlogs are video diaries where creators share aspects of their daily life, travels, special events, etc. They are personal and allow viewers to feel a closer connection with the creator's lifestyle.",
  [OPTION_UGC_FORMAT_QA]: "Q&A (Questions and Answers)",
  [OPTION_UGC_FORMAT_QA_EXPLANATION]:
    "In a question and answer format, creators interact directly with their audience by answering questions they have previously sent. This helps build a more personal and direct relationship with followers.",
  [OPTION_UGC_FORMAT_STORYTIME]: "Storytime",
  [OPTION_UGC_FORMAT_STORYTIME_EXPLANATION]:
    "These are videos or posts where creators narrate personal stories or significant experiences. They are engaging due to their narrative aspect and often include lessons or morals.",
  [OPTION_UGC_FORMAT_ROOM_TOURS]: "Room Tours",
  [OPTION_UGC_FORMAT_ROOM_TOURS_EXPLANATION]:
    "Creators showcase their personal space, such as their bedroom, studio, or entire house. These videos are popular because they allow followers to get decoration ideas and feel a closeness to the creator's lifestyle.",
  [OPTION_UGC_FORMAT_WHATS_IN_MY_BAG]: "What's in My Bag?",
  [OPTION_UGC_FORMAT_WHATS_IN_MY_BAG_EXPLANATION]:
    "In this type of content, creators reveal what they carry in their bags or backpacks daily. It is particularly popular among celebrities and influencers in fashion and beauty, as it offers a glimpse into their personal essentials.",
  [OPTION_UGC_FORMAT_COOKING]: "Cooking/Baking Recipes",
  [OPTION_UGC_FORMAT_COOKING_EXPLANATION]:
    "Creators share recipes and cooking or baking processes in the form of videos or posts. These contents are useful for those seeking new meal ideas and enjoy the visual and explanatory aspect of cooking.",
  [OPTION_UGC_FORMAT_FITNESS_ROUTINES]: "Fitness Routines",
  [OPTION_UGC_FORMAT_FITNESS_ROUTINES_EXPLANATION]:
    "Fitness influencers share their workout routines, health tips, and wellness journeys. These videos are motivational and educational, helping followers stay active and healthy.",
  [OPTION_UGC_FORMAT_ASMR]: "ASMR (Autonomous Sensory Meridian Response)",
  [OPTION_UGC_FORMAT_ASMR_EXPLANATION]:
    "ASMR videos are designed to evoke a relaxing sensation in viewers through soft sounds and meticulous movements. They are highly popular for relaxation and stress management.",
  [OPTION_UGC_FORMAT_PLAN_WITH_ME]: "Plan With Me",
  [OPTION_UGC_FORMAT_PLAN_WITH_ME_EXPLANATION]:
    "In these videos, creators show how they organize their agenda or weekly planner, sharing time management techniques and planner decoration. It is ideal for stationery and personal organization enthusiasts.",
  [OPTION_UGC_FORMAT_MUKBANG]: "Mukbang",
  [OPTION_UGC_FORMAT_MUKBANG_EXPLANATION]:
    "Originated in South Korea, in these videos creators consume large amounts of food while interacting with their audience. It has been popularized globally as a form of virtual company during meals.",
  [OPTION_UGC_FORMAT_DAY_IN_THE_LIFE]: "Day in the Life",
  [OPTION_UGC_FORMAT_DAY_IN_THE_LIFE_EXPLANATION]:
    "Creators share a video documenting a typical day in their life, showing from morning to night. This gives followers a comprehensive view of their daily activities and lifestyle.",
  [OPTION_UGC_FORMAT_BEHIND_THE_SCENES]: "Behind the Scenes",
  [OPTION_UGC_FORMAT_BEHIND_THE_SCENES_EXPLANATION]:
    "These videos offer a behind-the-scenes look into the lives of creators, including how they prepare their content, manage businesses, or even special events they attend.",
  [OPTION_UGC_FORMAT_TRAVEL_DIARIES]: "Travel Diaries",
  [OPTION_UGC_FORMAT_TRAVEL_DIARIES_EXPLANATION]:
    "In travel diaries, creators share experiences, tips, and adventures from their travels. These videos or posts are appealing to those seeking travel inspiration or learning about new cultures.",

  //ERRORS
  [SOMETHING_ERROR_GENERATING_STATISTICS]:
    "Something went wrong with the generation of statistics, please try again.",
  [AUTH_SENT_EMAIL_RESET_PASSWORD]:
    "An email has been sent to reset the password.",
  [EMAIL_UNSUBSCRIBE_SUCCESS_TITLE]: "Unsubscribed Successfully",
  [EMAIL_UNSUBSCRIBE_SUCCESS_TEXT]:
    "You will no longer receive emails from us at this address.",
  [EMAIL_UNSUBSCRIBE_ERROR_TITLE]: "Unsubscribe Failed",
  [EMAIL_UNSUBSCRIBE_ERROR_TEXT]:
    "We could not process your unsubscribe request. The link may be invalid or expired.",
  [AUTH_PAGE_DOCUMENT_TITLE_LOGIN]: "{{nameBusiness}} - Login",
  [AUTH_PAGE_DOCUMENT_TITLE_LOGIN_OWNER]: "{{nameBusiness}} - Admin Login",
  [AUTH_LOGIN_OWNER_CHIP_LABEL]: "Access Owner",
  [AUTH_LOGIN_OWNER_SUBMIT]: "Owner Login",
  [AUTH_LOGIN_OWNER_NOT_OWNER]: "Not an owner?",
  [AUTH_LOGIN_OWNER_GO_TO_LOGIN]: "Log in",
  [AUTH_PAGE_DOCUMENT_TITLE_REGISTER]: "{{nameBusiness}} - Register",
  [AUTH_PAGE_DOCUMENT_TITLE_RESET_PASSWORD]:
    "{{nameBusiness}} - Reset password",
  [AUTH_PAGE_BRANDING_LOGO_ALT]: "Logo",
  [AUTH_LOGIN_DEMO_EXISTING_ACCOUNT_BANNER]:
    "This email is already registered. Sign in below with your password, or recover it if you forgot it.",
  [ACCOUNT_ROLE_INVALID]: "This account does not have a valid role to log in",
  [ERROR_INTERNAL]: "Internal error, please try again later",
  [AUTH_INVALID_PASSWORD]: "The password is not valid",
  [AUTH_WRONG_PASSWORD]: "Email or password is incorrect",
  [AUTH_MANY_REQUESTS]: "Too many failed attempts, please try again later",
  [AUTH_USER_NOT_FOUND]: "Email or password is incorrect",
  [AUTH_EMAIL_ALREADY_EXISTS]: "Email is already in use",
  [PHONE_ALREADY_REGISTERED]: "This phone number is already registered",
  [AUTH_INVALID_VERIFICATION_CODE]: "Invalid verification code",
  [AUTH_INVALID_APP_CREDENTIAL]: "Phone number invalid",
  [STRIPE_CARD_DECLINED]:
    "The card has been declined. Please verify the card information or use a different card",
  [STRIPE_EXPIRED_CARD]:
    "The card has expired. Please verify the expiration date or use a different card",
  [STRIPE_INCORRECT_CVC]:
    "Incorrect card security code. Please verify the card security code or use a different card",
  [STRIPE_PROCESSING_ERROR]:
    "There was an error processing the card. Please try again later or use a different payment method",
  [STRIPE_INCORRECT_NUMBER]:
    "Incorrect card number. Please verify the card number or use a different card",
  [STRIPE_GENERIC_DECLINE]: "The card was declined for an unknown reason",
  [STRIPE_INSUFFICIENT_FUNDS]:
    "Insufficient funds on the card to complete the purchase or for verification charge",
  [STRIPE_LOST_CARD]: "Payment declined because the card was reported as lost",
  [STRIPE_STOLEN_CARD]:
    "Payment declined because the card was reported as stolen",
  [STRIPE_PROFILE_NOT_FOUND]: "This profile does not exist",
  [STRIPE_INTENT_AUTH_FAILURE]: "Card authentication failed",
  [NIT_VALID]: "Identification number",
  [BUSINESS_NAME_VALID]: "Business legal name",
  [BRAND_NAME_VALID]: "Brand name",
  [ADDRESS_VALID]: "Business address",
  [CATEGORY_VALID]: "Category",
  [SUBCATEGORIES_VALID]: "Subcategories",
  [SHORT_DESCRIPTION_VALID]: "Short business description",
  [ORDERS_METHODS_VALID]: "Order delivery methods",
  [LOGO_IMG_VALID]: "Business logo",
  [COVER_IMG_VALID]: "Cover image",
  [SCHEDULE_VALID]: "Business hours of operation",
  [STORES_VALID]: "At least one created and active store",
  [IS_PLAN_ACTIVE_VALID]: "You must have an active plan",
  [MENUS_VALID]:
    "You must have at least one category with at least one product created in the menu",
  [DEFAULT_PAYMENT_METHOD_VALID]:
    "You must have a default added card or purchased credits",
  [HAS_DEBT_VALID]: "You should not have pending payments",
  [SUBSCRIPTION_PLAN_VALID]: "You must have an active plan",
  [MISSING_PARAMETERS]: "Required parameters were not sent.",
  [PASSWORD_INVALID]: "Invalid password.",
  [INVALID_SEARCH]: "Invalid search.",
  [USER_ID_REQUIRED]: "UserID is required.",
  [SHOP_ID_REQUIRED]: "ShopID is required.",
  [LAST_USER_NOT_DELETED]:
    "All users cannot be deleted; at least one must remain.",
  [PLAN_TRIAL_USER_USED]:
    "The trial period has already been used for this user.",
  [ORDERS_NOT_FOUND_IN_INTERVAL]:
    "No orders were found in the selected date range.",
  [TYPE_REPORT_NOT_FOUND]: "Report type not found.",
  [SHOP_NOT_FOUND]: "Brand not found.",
  [PAYMENT_MODEL_INVALID]: "Invalid payment model.",
  [SHOP_NOT_HAS_SOCIAL_NETWORK]:
    "The brand does not have an associated social network.",
  [NO_VALID_PLATFORM_FOUND]: "No valid platform found.",
  [GETTING_STATISTICS]:
    "Error getting statistics; please try again later or contact support.",
  [SHOP_BUSINESS_NAME_NOT_FOUND]: "Brand name not found.",
  [REFERENCE_PROFILES_REQUIRED]: "Reference profiles not found.",
  [DECRYPTING_PASSWORD]: "Error getting password.",
  [USER_ID_AND_PAYMENT_ID]: "UserID and paymentID are required.",
  [MESSAGES_REQUIRED]: "Messages are required.",
  [PLAN_IS_NO_ACTIVE]: "The plan is not active.",
  [USER_BANNED]: "This user is banned.",
  [GETTING_LOCALES]:
    "Error getting local files; please try again later or contact support.",
  [GETTING_PROFILE]:
    "Error getting profile data; please try again later or contact support.",
  [PRODUCTS_NOT_SENT]: "Products were not sent.",
  [ACCOUNT_NOT_FOUND]: "Account not found.",
  [COLLECTING_INFORMATION_RETRY_AFTER]:
    "Error collecting information; please try again later or contact support.",
  [ERROR_OCCURRED]: "An unexpected error occurred, please try again later",
  [FREE_BOT_MESSAGES_LIMIT_REACHED]:
    "You've reached today's {{limit}} free messages with the agent. It resets tomorrow.",
  [TEXT_REGENERATION_LIMIT_REACHED]:
    "This campaign has used all {{limit}} free text regenerations.",
  [REFERENCE_VIDEO_ANALYSIS_UNAVAILABLE]:
    "The reference ad service is unavailable right now because our video analysis provider is unavailable. Please try again later.",
  [ACTION_COULD_NOT_BE_COMPLETED]:
    "This action could not be completed due to an error from our provider, please try again later.",
  [PLATFORM_NOT_SENT]: "Platform not sent.",
  [PLATFORM_APP_REQUEST_LIMIT_REACHED]:
    "This ad platform is experiencing very high demand and is temporarily limiting requests. Some features may be affected.",
  [VERIFICATION_CODE_NOT_FOUND]: "Verification code not found.",
  [VERIFICATION_CODE_INCORRECT]: "Verification code not incorrect.",
  [REGISTRATION_EMAIL_NOT_VERIFIED]: "Registration email not verified.",
  [ORDER_NOT_FOUND]: "Order not found.",
  [TYPE_OR_PATH_NOT_SENT]: "File or path not sent.",
  [ID_OR_PATH_NOT_SENT]: "File ID or path not sent.",
  [IDS_NOT_SENT]: "IDs not sent",
  [ANALYTIC_URL_NOT_SENT]: "Analytic URL not sent.",
  [ANALYTIC_URL_INVALID]: "Invalid analytic URL.",
  [EXTRACTING_ANALYTICS]:
    "Error extracting analytics; please try again later or contact support.",
  [CREDENTIALS_INVALID]: "Invalid credentials.",
  [COLLABORATION_PRICE_NOT_BE_NEGATIVE]:
    "Collaboration price cannot be negative.",
  [CREDITS_NOT_BE_NEGATIVE]: "Credits cannot be negative.",
  [PACKAGES_PRICES_NOT_BE_NEGATIVE]: "Plan prices cannot be negative.",
  [ROL_REQUIRED]: "Role is required.",
  [SHOP_ID_AND_STORE_ID_REQUIRED]: "ShopID and storeID are required.",
  [PASSWORD_MUST_BE_6_CHARACTERS]: "Password must be at least 6 characters.",
  [ALL_USERS_NOT_DELETE]:
    "All users cannot be deleted; at least one must remain.",
  [SHOP_APPLICANT_NOT_FOUND]: "Brand application not found.",
  [USER_PASSWORD_NOT_FOUND]: "User password not found.",
  [PLAN_NOT_FOUND]: "Plan not found.",
  [SUBSCRIPTION_NOT_CREATED]: "Subscription not created.",
  [ID_SUBSCRIPTION_NOT_FOUND]: "Subscription ID not found.",
  [SUBSCRIPTION_REACTIVATE]: "Subscription reactivated.",
  [CUSTOMER_ID_NOT_FOUND]: "CustomerID not found.",
  [APPLICANT_NOT_FOUND]: "Applicant not found.",
  [SHOP_COUNTRY_NOT_FOUND]: "Brand country not found.",
  [FINAL_PRICE_NOT_FOUND]: "Could not obtain the final price.",
  [PAYMENT_FAILED]: "Payment failed",
  [CREDITS_MUST_BE_GREATER_THAN_ZERO]: "Credits must be greater than 0.",
  [CSRF_INVALID]: "Invalid CSRF",
  [INTEGRATION_INFORMATION_NOT_FOUND]: "Integration information not found.",
  [MODAL_INTEGRATION_NOT_FOUND_TITLE]: "Reconnect Your Accounts",
  [MODAL_INTEGRATION_NOT_FOUND_DESCRIPTION]:
    "There is an error with the currently connected account. Reconnect the current account or connect a new one using the selector at the end of the table, then choose which account each campaign should use. The integration you connect must have access to each campaign’s ad account.",
  [MODAL_INTEGRATION_NOT_FOUND_COLUMN_PLATFORM]: "Platform",
  [MODAL_INTEGRATION_NOT_FOUND_COLUMN_CAMPAIGN]: "Campaign",
  [MODAL_INTEGRATION_NOT_FOUND_COLUMN_AD_ACCOUNT]: "Ad Account",
  [MODAL_INTEGRATION_NOT_FOUND_COLUMN_REASON]: "Reason",
  [MODAL_INTEGRATION_NOT_FOUND_COLUMN_INTEGRATION]: "Integration",
  [MODAL_INTEGRATION_NOT_FOUND_ROW_DISABLED]:
    "Cannot resolve the associated campaign.",
  [MODAL_INTEGRATION_NOT_FOUND_ROW_LOADING]: "Loading...",
  [MODAL_INTEGRATION_NOT_FOUND_ROW_ERROR]: "Error loading campaign data.",
  [MODAL_INTEGRATION_NOT_FOUND_SELECT_PLACEHOLDER]: "Select an integration",
  [MODAL_INTEGRATION_NOT_FOUND_SAVE]: "Save",
  [GETTING_VIDEO]: "Error getting the video.",
  [UPLOAD_URL_NOT_FOUND]: "Upload URL not found.",
  [UPLOADING_VIDEO]: "Error uploading the video.",
  [STORE_NOT_FOUND]: "Store not found.",
  [NAME_REQUIRED]: "Name is required.",
  [PRICE_REQUIRED]: "Price is required.",
  [CURRENCY_REQUIRED]: "Currency is required.",
  [RECURRING_REQUIRED]: "Recurring is required.",
  [CREATING_PRODUCT]: "Error creating the product.",
  [CREATING_PRICE]: "Error creating the price.",
  [CREATING_PAYMENT_LINK]: "Error creating the payment link.",
  [GETTING_PAYMENT_LINK]: "Error getting the payment link.",
  [TOKEN_INVALID]: "Token invalid",
  [TOKEN_EXPIRED]: "Token expired",
  [IG_ACCOUNT_NOT_FOUND]:
    "No linked Instagram account found to a Facebook page. Please ensure you have selected an Instagram account during integration or link one and try again.",
  [IG_DATA_NOT_FOUND]: "Instagram data not found",
  [REVIEW_NOT_FOUND]: "No review found for this collaboration",
  [REVIEW_IS_NOT_ONE_START]:
    "The review for this collaboration is not 1 star, a credit cannot be issued",
  [DISSATISFACTION_CREDIT_ALREADY_EXISTS]:
    "A free credit has already been assigned for this collaboration",
  [META_INTEGRATION_UNLINKED_PAGES_ERROR]:
    "You may not have linked your Instagram account to your Facebook or Meta Business page. Please link your accounts to proceed.",
  [PAYMENT_METHOD_NOT_FOUND]:
    "You don't have an added payment method, please add one to continue.",
  [HAS_PENDING_PAYMENTS]:
    "You have pending invoices, please make the payment to continue.",
  [NO_IMAGES_FOUND_ON_PAGE]: "No images found on the page",
  [NO_CREATE_DISCOUNT_SHOPIFY]:
    "We encountered an error from Shopify during integration, make sure you have selected the scopes 'read_price_rules', 'write_price_rules', 'write_discounts', and 'read_discounts' during the integration steps.",
  [NO_CREATE_WEBHOOK_ORDER_CREATED_SHOPIFY]:
    "We encountered an error from Shopify during integration, make sure you have selected the scope 'read_orders' during the integration steps.",
  [NO_CREATE_WEBHOOK_FULFILLMENT_CREATED_SHOPIFY]:
    "We encountered an error from Shopify during integration, make sure you have selected the scope 'read_fulfillments' during the integration steps.",
  [NO_CREATE_WEBHOOK_FULFILLMENT_UPDATED_SHOPIFY]:
    "We encountered an error from Shopify during integration, make sure you have selected the scope 'read_fulfillments' during the integration steps.",
  [GETTING_INFORMATION_FROM_SHOPIFY_URL]:
    "Error getting Shopify settings, please make sure the URL is correct and the store access is public.",
  [RATE_DAILY_LIMIT_AI]:
    "You have reached the daily limit for using artificial intelligence features. Please try again tomorrow.",
  [RATE_DAILY_LIMIT_AI_CHAT]:
    "You have reached your {{NAME_BUSINESS}} Help limit for today. Please try again tomorrow.",
  [PERMISSIONS_OR_CONFIGURATION_ACCOUNT_CHANGE_META]:
    "Your account permissions or settings changed, please try again. If the error persists, disconnect and reconnect the account.",
  [ACCOUNT_IS_NOT_TYPE_BUSINESS_OR_NO_ACCEPTED_ALL_PERMISSIONS]:
    "Your Instagram account is not of the Business type or you did not select all the permissions, please change your account to business and try again. If the error persists, disconnect and reconnect the account.",
  [FACEBOOK_PAGE_ID_NOT_FOUND]:
    "No linked Facebook page found. Please ensure you have selected a page during integration or link one and try again.",
  [META_BUSINESS_ACCOUNT_NOT_FOUND]:
    "No linked business account found. Please ensure you have selected an business account during integration or link one and try again.",
  [IG_BUSINESS_ACCOUNT_NOT_FOUND]: `A Creator or Business Instagram account was not found linked to the Facebook page you selected, follow this step-by-step to link an Instagram account.
    <ol>
     <li style="text-align: left">
      Enter the <a style="color:inherit" href="https://business.facebook.com/latest/settings/pages/" target="_blank">Meta Business Center</a>
     </li>
     <li style="text-align: left">
      Find and select the Facebook page you want to connect to
     </li>
     <li style="text-align: left">
      In the new interface click on "Connect Assets".
     </li>
     <li style="text-align: left">
      In the new window click on "Connect Instagram account".
     </li>
     <li style="text-align: left">
      In the new window connect to your Instagram account and end the connection.
     </li>
     <li style="text-align: left">
      Once the connection is terminated, try to reconnect your account on our platform.
     </li>
    </ol>`,
  [ACCOUNT_TIKTOK_AUTH_NOT_MATCH]:
    "We couldn't verify your account, please try again.",
  [ACCOUNT_TOKEN_META_NOT_FOUND]:
    "We couldn't find your Meta integration information, please try again or reconnect your account.",
  [ACCOUNT_ID_BUSINESS_META_NOT_FOUND]:
    "No linked Meta Business account found, please try again or link a Business account.",
  [OBJECTIVE_CAMPAIGN_META_INVALID]:
    "The selected campaign objective is not valid.",
  [SPECIAL_CATEGORY_CAMPAIGN_META_INVALID]:
    "The selected special category type is not valid.",
  [CAMPAIGN_META_NOT_DELETED]:
    "The campaign could not be deleted, please try again.",
  [CAMPAIGN_META_NOT_CREATED]:
    "The campaign could not be created, please try again.",
  [ADS_CAMPAIGN_NOT_FOUND]: "The ad campaign was not found.",
  [NO_PIXELS_FOUND]:
    "No pixels associated with your Meta account were found, please create one and try again.",
  [NO_PIXELS_ACTIVE]:
    "No active pixel associated with your Meta account, please activate one and try again.",
  [CAMPAIGN_META_NOT_FOUND]: "The campaign was not found in Meta.",
  [CAMPAIGN_META_NOT_UPDATED]:
    "The campaign could not be updated, please try again.",
  [CAMPAIGN_AD_SET_META_NOT_CREATED]:
    "The ad set could not be created, please try again.",
  [CAMPAIGN_AD_SET_META_NOT_UPDATED]:
    "The ad set could not be updated, please try again.",
  [CAMPAIGN_INFORMATION_UPDATE_FAILED_RATE_LIMIT]:
    "An error occurred while updating the information, please try again in a few seconds.",
  [CAMPAIGN_MEDIA_META_NOT_CREATED]:
    "The campaign video could not be uploaded, please try again.",
  [CAMPAIGN_MEDIA_THUMBNAIL_META_NOT_FOUND]:
    "The campaign video thumbnail was not found.",
  [CAMPAIGN_CREATIVE_AD_META_NOT_CREATED]:
    "The ad creative template could not be created, please try again.",
  [CAMPAIGN_CREATIVE_AD_META_NOT_UPDATED]:
    "The ad creative template could not be updated, please try again.",
  [CAMPAIGN_CREATIVE_AD_META_NOT_FOUND]:
    "The ad creative template was not found.",
  [CAMPAIGN_MESSAGE_TEMPLATE_META_NOT_FOUND]:
    "The WhatsApp form of this ad could not be retrieved. Please try again later.",
  [CAMPAIGN_AD_META_NOT_CREATED]:
    "The ad could not be created, please try again.",
  [CAMPAIGN_AD_META_NOT_UPDATED]:
    "The ad could not be updated, please try again.",
  [CAMPAIGN_METRICS_META_NOT_FOUND]: "The campaign metrics were not found.",
  [CREATE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE]:
    "You do not have enough balance to create a campaign, please recharge your account and try again.",
  [ACTIVE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE]:
    "You do not have enough balance to activate the campaign, please recharge your account and try again.",
  [CAMPAIGN_AUDIENCE_IS_TOO_NARROW]:
    "Your target audience is too narrow, try changing your targeting criteria to reach a wider audience.",
  [CAMPAIGN_BUDGET_IS_TOO_LOW]: "Your daily budget is too low.",
  [IDENTITY_NOT_FOUND]:
    "We couldn't find a TikTok profile linked to your TikTok Business account, please link a profile and try again.",
  [VIDEO_ERROR_LOW_RESOLUTION]:
    "The video resolution is too low, try uploading a higher resolution video.",
  [VIDEO_ERROR_NO_BACKGROUND_AUDIO]:
    "The video has no audio or the audio is too low, try uploading a video with clear and audible audio.",
  [VIDEO_ERROR_ASPECT_RATIO]:
    "The video does not have a permitted aspect ratio, try uploading a video with a 1:1 (square), 9:16 (vertical), or 16:9 (horizontal) aspect ratio.",
  [VIDEO_ERROR_BLACK_EDGE]:
    "The video has black bars or edges, try uploading a video without borders.",
  [VIDEO_ERROR_ILLEGAL_DURATION]:
    "The video has an unsupported duration, try uploading a video between 5 and 60 seconds long.",
  [ERROR_GETTING_URL_INFORMATION_BY_PROTECTED]:
    "We couldn't get the information from your website. Some pages use mechanisms that block automated access (anti-crawlers), so it will be necessary to enter the information manually.",
  [META_ERROR_GETTING_USER_INFORMATION]:
    "An error occurred while getting user information",
  [META_ERROR_GETTING_BUSINESS_ACCOUNTS_INFORMATION]:
    "An error occurred while getting business accounts information",
  [META_ERROR_GETTING_ACCOUNTS_INFORMATION]:
    "An error occurred while getting accounts information",
  [META_AD_ACCOUNT_IS_NOT_ACTIVE]: "Meta ad account is disabled",
  [META_AD_ACCOUNT_HAVE_NOT_PAYMENT_METHOD]:
    "Meta ad account does not have a valid payment method",
  [META_OAUTH_PERMISSIONS_ERROR]: `You do not have access to some of the resources you are trying to use, verify the following:<br/>
    <ul style="text-align: left">
      <li>That you have selected the correct advertising account</li>
      <li>That your advertising account is active, has a valid payment method associated, and has no pending payments</li>
      <li>That you have proper access to pixels, catalogs or posts (if selected)</li>
    </ul>`,
  [META_ACCOUNT_AUTHENTICATION_REQUIRED]: `Meta requires you to verify your account before you can create or edit ads. Complete the verification in Meta Ads Manager, then try publishing again in {{NAME_BUSINESS}}.<br/>
    <ol style="text-align: left; padding-left: 1.25em; margin: 0.5em 0 0;">
      <li style="text-align: left; margin-bottom: 0.35em;">Open <a style="color:inherit" href="https://adsmanager.facebook.com/adsmanager/manage/campaigns" target="_blank">Meta Ads Manager</a></li>
      <li style="text-align: left; margin-bottom: 0.35em;">In the account selector at the top left, find and select the ad account you are using for this campaign in {{NAME_BUSINESS}}</li>
      <li style="text-align: left; margin-bottom: 0.35em;">Click <strong>Create</strong> to start a new campaign, choose any objective, and fill in placeholder details</li>
      <li style="text-align: left; margin-bottom: 0.35em;">Once the structure is created, open the ad from the left-hand panel</li>
      <li style="text-align: left; margin-bottom: 0.35em;">You may already see a red alert to start authentication — if so, follow it. If not, continue to the next step</li>
      <li style="text-align: left; margin-bottom: 0.35em;">Complete the campaign and ad fields until you can click <strong>Publish</strong> (bottom right). When you try to publish, Meta should prompt you to authenticate</li>
      <li style="text-align: left; margin-bottom: 0;">After completing authentication, try publishing your campaign in {{NAME_BUSINESS}} again. If you still cannot publish or never saw the alert, please contact support</li>
    </ol>`,
  [ADVERTISER_ID_NOT_FOUND_TIK_TOK]: `An advertising account was not found associated with the account you want to connect, follow this step by step to create one and try again.<br/>
    <ol>
      <li style="text-align: left">
      Enter the <a style="color:inherit" href="https://business.tiktok.com/select" target="_blank">business center</a>
      </li>
      <li style="text-align: left">
      Select a business account
      </li>
      <li style="text-align: left">
      In the left menu find for the "Advertiser Accounts" option and click on it
      </li>
      <li style="text-align: left">
      At the top you will find an "Add advertiser account" button, click it and follow the steps below
      </li>
      <li style="text-align: left">
      When you finish creating it, try to connect again
      </li>
    </ol>`,
  [ADVERTISER_ID_NOT_FOUND_GOOGLE]: `An advertising account was not found associated with the account you want to connect, follow this step by step to create one and try again.<br/>
    <ol>
      <li style="text-align: left">
      Enter the  <a style="color:inherit" href="https://ads.google.com/aw" target="_blank">Google Ads Manager</a>
      </li>
      <li style="text-align: left">
      Verify that the correct Google account is selected at the top right, if it is not, click on change account in the middle of the screen.
      </li>
      <li style="text-align: left">
      Once you have selected the correct account, verify that your account has access to a valid advertising account, if not, click on "New Google Ads account" in the central part of the screen and follow the steps to create one.
      </li>
      <li style="text-align: left">
      When you finish creating it, try to reconnect your account on our platform.
      </li>
    </ol>`,
  [CURRENCY_MISMATCH]:
    "We detected an error with your ad account's currency, please try again later.",
  [ADVERTISER_CURRENCY_NOT_FOUND_TIK_TOK]: `Your business does not have a currency assigned to it, follow this step by step to assign one and try again. <br/>
    <ol>
      <li style="text-align: left">
      Enter the <a style="color:inherit" href="https://business.tiktok.com/select " target="_blank">business center</a>
      </li>
      <li style="text-align: left">
      Select a business account
      </li>
      <li style="text-align: left">
      In the left menu look for the "Business Settings" option and click on it
      </li>
      <li style="text-align: left">
      At the top you will find the option to configure your business, click on it and follow the steps to configure your entire business, including the currency
      </li>
      <li style="text-align: left">
      When you finish setting up your business, try connecting again
      </li>
    </ol>
    `,
  [ERROR_GETTING_URL_META_DATA_AND_IMAGES]:
    "We were unable to obtain information from your website. Make sure the URL is valid, accessible and contains images.",
  [ADVERTISER_ID_TO_CHANGE_NO_PERMISSION]:
    "You do not have permission to change this brand.",
  [CANNOT_DELETE_MAIN_ADVERTISER]:
    "This brand cannot be deleted because it is the main brand of the agency. Please select a different brand.",
  [DISCOUNT_CODE_NOT_FOUND]: "Discount code not found",
  [DISCOUNT_CODE_NOT_APPLICABLE_TO_THIS_PRODUCT]:
    "Code not applicable to this product",
  [SCRIPT_IS_TOO_SHORT]: "The script is too short, please add more information",
  [WEBSITE_AND_SOCIAL_NETWORK_CANT_ANALYZED]:
    "We were unable to analyze your website and social network, please check the urls or upload the content manually and try again",
  [EMAIL_PROVIDER_IS_NOT_EQUAL_TO_EMAIL_FORM]:
    "An inconsistency was found with the email provided, please try again",
  [OAUTH_IN_WINDOW_NO_COMPLETED]:
    "Authentication process did not complete, please try again",
  [OAUTH_CALLBACK_ACCOUNT_CONNECTED_TITLE]: "Account Connected",
  [OAUTH_CALLBACK_ACCOUNT_CONNECTED_TEXT]:
    "Your account was connected successfully.",
  [ERROR_PROCESSING_REQUEST]:
    "An error occurred while processing this request. Please try again",
  [ERROR_PROCESSING_CAMPAIGNS]:
    "An error occurred while processing campaigns. Please try again.",
  [ERROR_ANALYZING_LINK_CREATIFY]:
    "We could not analyze this link. Check the URL and try again.",
  [GENERATE_AI_FREE_VIDEO_LIMIT]:
    "You have reached the free AI video generation limit.",
  [NOT_HAVE_ENOUGH_USAGE_VALUE]:
    "You do not have enough credits for this action.",
  [USAGE_VALUE_NOT_FOUND]: "Usage information was not found.",
  [FAL_AI_CREDENTIALS_INVALID]:
    "Your Fal AI API key is invalid or the account has no balance.",
  [HEYGEN_CREDENTIALS_INVALID]:
    "Your HeyGen API key is invalid or the account has no balance.",
  [ERROR_NETWORK_CONNECTION]:
    "An error occurred while connecting to the internet network, please try again",
  [ERROR_ON_AD_ID_OF_AD_GROUP_ID]:
    "In Ad N°{{adID}} of Ad Group N°{{adGroupID}}",
  [ERROR_ON_AD_GROUP_ID]: "In the Ad Group N°{{adGroupID}}",
  [ERROR_ON_ASSETS_GROUP_ID]: "In the Assets Group N°{{assetsGroupID}}",
  [REQUEST_TIME_OUT]:
    "An unexpected error occurred, please try again in a few seconds",
  [TIME_OUT_FOR_PROVIDER]:
    "An error occurred with our video provider, please try again later.",
  [FACEBOOK_PAGE_NEED_CONNECTED_WHATSAPP_NUMBER]: `Your Facebook page must have a WhatsApp number connected in order to continue. Follow this step by step to connect it and try again.<br/>
    <ol>
    <li style="text-align: left">
      Navigate to <a style="color:inherit" href="https://www.facebook.com/settings/?tab=linked_whatsapp" target="_blank">your Facebook page settings</a>
    </li>
    <li style="text-align: left">
      Enter the WhatsApp number you want to connect
    </li>
    <li style="text-align: left">
      Click on Send WhatsApp Code
    </li>
    <li style="text-align: left">
      Enter the code you received on your WhatsApp
    </li>
    <li style="text-align: left">
      Click on Confirm
    </li>
    <li style="text-align: left">
     Once you finish connecting your WhatsApp number, try again. If the error persists, you may need to reconnect your Meta account on our platform
    </li>
    </ol>`,
  [YOUR_FACEBOOK_PAGE_MUST_BE_IN_BUSINESS_PORTFOLIO_OWN_WHATSAPP]: `Your Facebook page is not within the business portfolio to which the WhatsApp Business number you are trying to use belongs. Follow this step by step to connect it and try again.<br/>
  <ol>
    <li style="text-align: left">
      Navigate to <a style="color:inherit" href="https://business.facebook.com/latest/settings/pages/?business_id={{businessID}}" target="_blank">Business Portfolio in the pages section</a>
    </li>
    <li style="text-align: left">
      Click on the Add button on the top right hand side
    </li>
    <li style="text-align: left">
      Select the option to Add an existing Facebook page
    </li>
    <li style="text-align: left">
      Enter the name or the link of your Facebook page, using the link is more accurate to search for your page. Select your Facebook page once it appears in the list
    </li>
    <li style="text-align: left">
      Click the Next button until you reach the last step. You will check the box to accept the Meta terms and then click Claim Page and Instagram.
    </li>
    <li style="text-align: left">
      Once you finish connecting your Facebook page to your business portfolio, try again. If the error persists you may need to reconnect your Meta account on our platform.
    </li>
  </ol>
  `,
  [ERROR_WITH_MOBILE_PROVIDER]:
    "An error occurred with your phone provider, please try again later",
  [ERROR_CREATING_INSTANT_EXPERIENCE]:
    "An error occurred while creating the instant experience, please try again",
  [CAMPAIGN_REQUEST_ABORTED]:
    "The campaign request has been aborted due to reaching the timeout limit, please contact support.",
  [APP_URL_NOT_FOUND]:
    "The selected app does not have a valid link in the app store selected",
  [ERROR_CAMPAIGN_NOT_FOUND_TO_DUPLICATE]:
    "No se pudo recuperar la información para duplicar la campaña, intenta de nuevo",
  [INVALID_APP_DEEP_LINK]:
    "The link entered is not a valid deep link associated with an application.",
  [GENERATION_VIDEO_REJECTED]:
    "Your content instructions violate the content security policies. Try again modifying your instructions.",
  [VIDEO_INPUT_REAL_PERSON_REJECTED]:
    "The input image includes a real person, and the video provider cannot process it. Use a product or brand image without real people and try again.",
  [IMAGE_LAYERS_CONTENT_POLICY_VIOLATION]:
    "Your content could not be separated into layers because it may violate content policies.",
  [AI_PROVIDER_CREDENTIALS_INVALID]:
    "Your API key for {{provider}} is invalid or the account has no balance. Check your API key in Settings and try again.",
  [AI_PROVIDER_CREDENTIALS_INVALID_GENERIC]:
    "One of your provider API keys is invalid or the account has no balance. Check your API key in Settings and try again.",
  [AI_REQUEST_TIMEOUT]:
    "An error occurred with our AI provider. Please try again later.",
  [IMAGES_MODERATION_BLOCKED]:
    "Your content instructions violate the content security policies. Try again modifying your instructions.",
  [MALFORMED_FUNCTION_CALL]:
    "This action could not be completed, please try with a different instruction.",
  [VIDEO_GENERATION_FAILED_BY_PROVIDER]:
    "The video was not generated due to an internal error, please try again later.",
  [AI_RATE_LIMITED]:
    "Our AI provider is receiving too many requests, please try again later.",
  [AI_PROVIDER_UNAVAILABLE]:
    "Our AI provider is unavailable at the moment, please try again later.",
  [AI_GENERATION_FAILED]:
    "Generation could not be completed with our AI provider, please try again later.",
  [AGENT_REQUEST_COULD_NOT_BE_PROCESSED]:
    'I couldn\'t process your request. Please try again. If the error persists, contact the support team using the "Get Help" button.',
  [CREDITS_RETURNED_SUFFIX]:
    "Due to this error, your credits have been returned.",
  [CREATIVE_UNEXPECTED_IMAGE_PROVIDER_ERROR]:
    "An unexpected error occurred with our image provider, please try again later.",
  [CREATIVE_UNEXPECTED_VIDEO_PROVIDER_ERROR]:
    "An unexpected error occurred with our video provider, please try again later.",
  [CREATIVE_UNEXPECTED_AI_PROVIDER_ERROR]:
    "An unexpected error occurred with our AI provider, please try again later.",
  [CREATIVE_TIMEOUT_IMAGE_PROVIDER_ERROR]:
    "An error occurred with our image provider, please try again later.",
  [CREATIVE_TIMEOUT_VIDEO_PROVIDER_ERROR]:
    "An error occurred with our video provider, please try again later.",
  [CREATIVE_TIMEOUT_AI_PROVIDER_ERROR]:
    "An error occurred with our AI provider, please try again later.",
  [INVALID_UPDATE_STATUS_CREATIVE_IN_REVIEW]:
    "The creative status cannot be updated while it is under review, please try again later",
  [BENEFICIARY_OR_PAYER_NOT_FOUND]:
    "The beneficiary or payer was not found. Make sure you have permissions to read the business information.",
  [DELETE_OPERATION_NOT_ALLOWED_FOR_CAMPAIGN]:
    "This operation is not allowed for this campaign",
  [LINKEDIN_PARTNERSHIP_CREDITS_ALREADY_CLAIMED]:
    "This account has already claimed the free credits.",
  [CAMPAIGN_IS_GENERATING]:
    "This campaign is already being generated in another window or device.",
  [INVALID_JOB_TYPE]:
    "The job type is not valid or is not supported. Please try again or contact support.",
  [JOB_CANCELLED_OR_FAILED]:
    "This operation could not be completed because the job was cancelled or failed. Please try again.",
  [JOB_TIMEOUT]: "The operation took too long to complete. Please try again.",
  [CUSTOM_REPORT_NO_ACTIVE_CAMPAIGNS_IN_PERIOD]:
    "No active campaigns were found in that time period to generate a report.",

  //ERROR COMPONENT
  [ERROR_COMPONENT_TITLE]: "Oops! An error occurred",
  [ERROR_COMPONENT_DESCRIPTION]:
    "This may be caused by a technical error. Try again by reloading the page and if the error persists contact support.",
  [ERROR_COMPONENT_BUTTON_RELOAD_PAGE]: "Reload page",
  [ERROR_COMPONENT_CURRENT_ROUTE]: "Current route {{value}}",

  //CATEGORIES
  [RESTAURANTS]: "Restaurants",
  [FOODS]: "Foods",
  [TRAVEL]: "Travels and tourism",
  [ENTERTAINMENT]: "Entertainment",
  [TECHNOLOGY]: "Technology",
  [FITNESS]: "Fitness",
  [FASHION]: "Fashion",
  [BEAUTY]: "Health & Beauty",
  [PETS]: "Pets",
  [HOME]: "Home Decor",

  //SUBCATEGORIES
  [RESTAURANTS_SUBCATEGORY_FOOD]: "Food",
  [RESTAURANTS_SUBCATEGORY_DRINKS]: "Drinks",
  [RESTAURANTS_SUBCATEGORY_DESSERTS]: "Desserts",
  [RESTAURANTS_SUBCATEGORY_COFFEE]: "Coffee",
  [RESTAURANTS_SUBCATEGORY_HOT_DRINKS]: "Hot Drinks",
  [RESTAURANTS_SUBCATEGORY_COLD_DRINKS]: "Cold Drinks",
  [RESTAURANTS_SUBCATEGORY_SOFT_DRINKS]: "Soft Drinks",
  [RESTAURANTS_SUBCATEGORY_FROZEN_DRINKS]: "Frozen Drinks",
  [RESTAURANTS_SUBCATEGORY_SUSHI]: "Sushi",
  [RESTAURANTS_SUBCATEGORY_ASIAN]: "Asian",
  [RESTAURANTS_SUBCATEGORY_JAPANESE]: "Japanese",
  [RESTAURANTS_SUBCATEGORY_CHINESE]: "Chinese",
  [RESTAURANTS_SUBCATEGORY_ITALIAN]: "Italian",
  [RESTAURANTS_SUBCATEGORY_MEXICAN]: "Mexican",
  [RESTAURANTS_SUBCATEGORY_HEALTHY]: "Healthy",
  [RESTAURANTS_SUBCATEGORY_VEGAN]: "Vegan",
  [RESTAURANTS_SUBCATEGORY_VEGETARIAN]: "Vegetarian",
  [FOODS_SUBCATEGORY_SEASONINGS]: "Seasonings",
  [FOODS_SUBCATEGORY_FOOD]: "Food",
  [FOODS_SUBCATEGORY_GRANOLA]: "Granola",
  [FOODS_SUBCATEGORY_DRIED_FRUITS]: "Dried Fruits",
  [FOODS_SUBCATEGORY_HEALTHY]: "Healthy",
  [TRAVEL_SUBCATEGORY_BEACH_SUN_TOURISM]: "Beach and Sun Tourism",
  [TRAVEL_SUBCATEGORY_RURAL_TOURISM]: "Rural Tourism",
  [TRAVEL_SUBCATEGORY_GASTRONOMIC_TOURISM]: "Gastronomic Tourism",
  [TRAVEL_SUBCATEGORY_NATURE_TOURISM]: "Nature Tourism",
  [TRAVEL_SUBCATEGORY_CULTURAL_TOURISM]: "Cultural Tourism",
  [TRAVEL_SUBCATEGORY_HEALTH_TOURISM]: "Health Tourism",
  [ENTERTAINMENT_SUBCATEGORY_ENTERTAINMENT]: "Entertainment",
  [TECHNOLOGY_SUBCATEGORY_PHONES]: "Phones",
  [TECHNOLOGY_SUBCATEGORY_COMPUTERS]: "Computers",
  [TECHNOLOGY_SUBCATEGORY_VIDEO_GAME_CONSOLES]: "Video Game Consoles",
  [TECHNOLOGY_SUBCATEGORY_ACCESSORIES]: "Accessories",
  [TECHNOLOGY_SUBCATEGORY_PERIPHERALS]: "Peripherals",
  [TECHNOLOGY_SUBCATEGORY_ELECTRONICS]: "Electronics",
  [FITNESS_SUBCATEGORY_SPORTSWEAR]: "Sportswear",
  [FITNESS_SUBCATEGORY_SPORTS_ACCESSORIES]: "Sports Accessories",
  [FITNESS_SUBCATEGORY_DIETARY_SUPPLEMENTS]: "Dietary Supplements",
  [FITNESS_SUBCATEGORY_TRAINING_EQUIPMENT]: "Training Equipment",
  [FASHION_SUBCATEGORY_HAUTE_COUTURE]: "Haute Couture Fashion",
  [FASHION_SUBCATEGORY_HIPSTER]: "Hipster Fashion",
  [FASHION_SUBCATEGORY_CASUAL]: "Casual Fashion",
  [FASHION_SUBCATEGORY_CLASSIC]: "Classic Fashion",
  [FASHION_SUBCATEGORY_ROMANTIC]: "Romantic Fashion",
  [FASHION_SUBCATEGORY_SPORTSWEAR]: "Sportswear Fashion",
  [FASHION_SUBCATEGORY_PREPPY]: "Preppy Fashion",
  [FASHION_SUBCATEGORY_GRUNGE]: "Grunge Fashion",
  [FASHION_SUBCATEGORY_VINTAGE]: "Vintage Fashion",
  [BEAUTY_SUBCATEGORY_COSMETICS]: "Cosmetics",
  [BEAUTY_SUBCATEGORY_EYE_CARE]: "Eye Care",
  [BEAUTY_SUBCATEGORY_FEMININE_HYGIENE]: "Feminine Hygiene",
  [BEAUTY_SUBCATEGORY_FIRST_AID]: "First Aid",
  [BEAUTY_SUBCATEGORY_HAIR_CARE]: "Hair Care",
  [BEAUTY_SUBCATEGORY_MEDICAL_DEVICES]: "Medical Devices",
  [BEAUTY_SUBCATEGORY_MOBILITY_EQUIPMENT]: "Mobility Equipment",
  [BEAUTY_SUBCATEGORY_NUTRITIONAL_SUPPLEMENTS]: "Nutritional Supplements",
  [BEAUTY_SUBCATEGORY_MEDICATIONS]: "Medications",
  [BEAUTY_SUBCATEGORY_PERSONAL_HYGIENE]: "Personal Hygiene",
  [BEAUTY_SUBCATEGORY_SCALES]: "Scales",
  [BEAUTY_SUBCATEGORY_SKIN_CARE]: "Skin Care",
  [BEAUTY_SUBCATEGORY_VITAMINS]: "Vitamins",
  [BEAUTY_SUBCATEGORY_FACIAL_TISSUES]: "Facial Tissues",
  [PETS_SUBCATEGORY_FOOD]: "Pet Food",
  [PETS_SUBCATEGORY_COSMETICS]: "Pet Cosmetics",
  [PETS_SUBCATEGORY_ACCESSORIES]: "Pet Accessories",
  [PETS_SUBCATEGORY_CLOTHING]: "Pet Clothing",
  [PETS_SUBCATEGORY_MEDICATIONS]: "Pet Medications",
  [HOME_SUBCATEGORY_TEXTILES_CARPETS]: "Textiles and Carpets",
  [HOME_SUBCATEGORY_ART_PRINTS]: "Art Prints",
  [HOME_SUBCATEGORY_STORAGE_ORGANIZATION]: "Storage and Organization",
  [HOME_SUBCATEGORY_PLANT_DECOR]: "Plant Decorations",
  [HOME_SUBCATEGORY_CURTAINS_BLINDS]: "Curtains and Blinds",

  //OPTIONS
  [BODY_BUILD_THIN]: "Thin",
  [BODY_BUILD_AVERAGE]: "Average",
  [BODY_BUILD_WIDE]: "Wide",
  [BODY_BUILD_MUSCULAR]: "Muscular",
  [BODY_BUILD_CURVY]: "Curvy",
  [BODY_BUILD_ATHLETIC]: "Athletic",

  [CLOTHING_STYLE_CASUAL]: "Casual",
  [CLOTHING_STYLE_FORMAL]: "Formal",
  [CLOTHING_STYLE_SPORTY]: "Sporty",
  [CLOTHING_STYLE_BUSINESS]: "Business",
  [CLOTHING_STYLE_ELEGANT]: "Elegant",
  [CLOTHING_STYLE_TRENDY]: "Trendy",
  [CLOTHING_STYLE_STREETWEAR]: "Streetwear",
  [CLOTHING_STYLE_TRADITIONAL]: "Traditional",
  [CLOTHING_STYLE_VINTAGE]: "Vintage",
  [CLOTHING_STYLE_BOHEMIAN]: "Bohemian",
  [CLOTHING_STYLE_HIPSTER]: "Hipster",
  [CLOTHING_STYLE_PUNK]: "Punk",
  [CLOTHING_STYLE_GOTHIC]: "Gothic",

  [DISTINGUISHING_FEATURES_TATTOOS]: "Tattoos",
  [DISTINGUISHING_FEATURES_SCARS]: "Scars",
  [DISTINGUISHING_FEATURES_BIRTHMARKS]: "Birthmarks",
  [DISTINGUISHING_FEATURES_FRECKLES]: "Freckles",
  [DISTINGUISHING_FEATURES_MOLES]: "Moles",
  [DISTINGUISHING_FEATURES_PIERCINGS]: "Piercings",
  [DISTINGUISHING_FEATURES_DIMPLES]: "Dimples",
  [DISTINGUISHING_FEATURES_WRINKLES]: "Wrinkles",
  [DISTINGUISHING_FEATURES_GLASSES]: "Glasses",
  [DISTINGUISHING_FEATURES_BRACES]: "Braces",
  [DISTINGUISHING_FEATURES_MAKEUP]: "Makeup",
  [DISTINGUISHING_FEATURES_HAIR_ACCESSORIES]: "Hair Accessories",
  [DISTINGUISHING_FEATURES_BEARD]: "Beard",
  [DISTINGUISHING_FEATURES_MUSTACHE]: "Mustache",

  [CONTENT_STYLE_ELEGANT]: "Elegant",
  [CONTENT_STYLE_AESTHETIC]: "Aesthetic",
  [CONTENT_STYLE_RAW]: "Raw",
  [CONTENT_STYLE_MINIMALISTIC]: "Minimalistic",
  [CONTENT_STYLE_ARTISTIC]: "Artistic",
  [CONTENT_STYLE_VINTAGE]: "Vintage",
  [CONTENT_STYLE_MODERN]: "Modern",
  [CONTENT_STYLE_PLAYFUL]: "Playful",
  [CONTENT_STYLE_RUSTIC]: "Rustic",
  [CONTENT_STYLE_MONOCHROMATIC]: "Monochromatic",

  [EMPLOYEES_2_10]: "2-10 Employees",
  [EMPLOYEES_10_20]: "10-20 Employees",
  [EMPLOYEES_20_50]: "20-50 Employees",
  [EMPLOYEES_50_100]: "50-100 Employees",
  [EMPLOYEES_100_THAN]: "100+ Employees",

  [PRODUCT_AVAILABILITY_LOCAL]: "Locally (in my city)",
  [PRODUCT_AVAILABILITY_NATIONAL]: "Nationally",
  [PRODUCT_AVAILABILITY_INTERNATIONAL]: "Globally",

  [META]: "Meta",
  [META_FACEBOOK_AND_INSTAGRAM]: "Meta (Facebook and Instagram)",
  [INSTAGRAM]: "Instagram",
  [FACEBOOK]: "Facebook",
  [TIKTOK]: "TikTok",
  [LINKEDIN]: "LinkedIn",
  [GOOGLE]: "Google",
  [YOUTUBE]: "YouTube",
  [X]: "X",
  [THREADS]: "Threads",
  [WHATSAPP]: "WhatsApp",
  [ORGANIC]: "Organic",

  [DARK_KITCHEN]: "Dark kitchens",
  [OTHERS]: "Others",

  [ADS_CAMPAIGN_APP_PROMOTION_ANDROID]: "Android",
  [ADS_CAMPAIGN_APP_PROMOTION_IOS]: "Apple iOS 14+",
  [APP_STORE_ANDROID]: "Android",
  [APP_STORE_IOS]: "iOS",
  [APP_STORE_PLACEHOLDER]: "Select App Store",
  [ADS_CAMPAIGN_APP_PROMOTION_BOTH]: "Android and Apple iOS 14-",

  [ADS_CAMPAIGN_OBJECTIVE_AWARENESS]: "Awareness",
  [ADS_CAMPAIGN_OBJECTIVE_TRAFFIC]: "Traffic",
  [ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT]: "Engagement",
  [ADS_CAMPAIGN_OBJECTIVE_LEADS]: "Leads",
  [ADS_CAMPAIGN_OBJECTIVE_LEADS_LINKEDIN]: "Instant Form",
  [ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION]: "App Promotion",
  [ADS_CAMPAIGN_OBJECTIVE_SALES]: "Sales",
  [ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS]: "Video Views",
  [ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS]: "Website Conversions",
  [ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_INSTALL]: "App Install",
  [ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_RETARGETING]: "App Retargeting",
  [ADS_CAMPAIGN_TYPE_SEARCH]: "Search",
  [ADS_CAMPAIGN_TYPE_APP]: "App Install",
  [ADS_CAMPAIGN_TYPE_SHOPPING]: "Shopping",
  [ADS_CAMPAIGN_TYPE_VIDEO]: "Video",
  [ADS_CAMPAIGN_TYPE_BUDGET_DAILY]: "Daily budget",
  [ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME]: "Total budget",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MENU]: "See menu",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW]: "Shop now",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP]: "Sign up",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE]: "Subscribe",
  [ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_MORE]: "Watch more",
  [ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW]: "Apply now",
  [ADS_CAMPAIGN_CALL_TO_ACTION_APPLY]: "Apply",
  [ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_QUOTE]: "View Quote",
  [ADS_CAMPAIGN_CALL_TO_ACTION_JOIN]: "Join",
  [ADS_CAMPAIGN_CALL_TO_ACTION_ATTEND]: "Attend",
  [ADS_CAMPAIGN_CALL_TO_ACTION_REQUEST_DEMO]: "Request Demo",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MORE]: "See More",
  [ADS_CAMPAIGN_CALL_TO_ACTION_REGISTER]: "Register",
  [ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW]: "Book now",
  [ADS_CAMPAIGN_CALL_TO_ACTION_CALL_NOW]: "Call now",
  [ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US]: "Contact us",
  [ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD]: "Download",
  [ADS_CAMPAIGN_CALL_TO_ACTION_UNLOCK_FULL_DOCUMENT]: "Unlock Full Document",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_DIRECTIONS]: "Get directions",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE]: "Get quote",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES]: "Get showtimes",
  [ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE]: "Learn more",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SEND_WHATSAPP_MESSAGE]: "Send WhatsApp message",
  [ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW]: "Listen now",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE]: "Send message",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE_INSTAGRAM]:
    "Send message Instagram",
  [ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW]: "Order now",
  [ADS_CAMPAIGN_CALL_TO_ACTION_REQUEST_TIME]: "Request time",
  [ADS_CAMPAIGN_CALL_TO_ACTION_SAVE]: "Save",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_OFFER]: "Get offer",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_PROMOTIONS]: "Get promotions",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_ACCESS]: "Get access",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_UPDATES]: "Get updates",
  [ADS_CAMPAIGN_CALL_TO_ACTION_INQUIRE_NOW]: "Inquire now",
  [ADS_CAMPAIGN_CALL_TO_ACTION_BUY_TICKETS]: "Buy tickets",
  [ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME]: "Play game",
  [ADS_CAMPAIGN_CALL_TO_ACTION_EXPLORE_MORE]: "Explore more",
  [ADS_CAMPAIGN_CALL_TO_ACTION_INSTALL_NOW]: "Install now",
  [ADS_CAMPAIGN_CALL_TO_ACTION_USE_APP]: "Use app",
  [ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_NOW]: "Watch now",
  [ADS_CAMPAIGN_CALL_TO_ACTION_READ_MORE]: "Read more",
  [ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_NOW]: "View now",
  [ADS_CAMPAIGN_CALL_TO_ACTION_INTERESTED]: "Interested",
  [ADS_CAMPAIGN_CALL_TO_ACTION_GET_TICKETS_NOW]: "Get tickets now",
  [ADS_CAMPAIGN_CALL_TO_ACTION_EXPERIENCE_NOW]: "Experience now",
  [ADS_CAMPAIGN_CALL_TO_ACTION_PRE_ORDER_NOW]: "Pre-order now",
  [ADS_CAMPAIGN_CALL_TO_ACTION_VISIT_STORE]: "Visit store",
  [ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_PROFILE]: "View profile",
  [ADS_CAMPAIGN_CALL_TO_ACTION_DYNAMIC]: "Dynamic",
  [ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_WEBSITE]: "Website",
  [ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST]: "Customer list",
  [ADS_CAMPAIGN_CUSTOM_EVENT_ADD_PAYMENT_INFO]: "Add payment info",
  [ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_CART]: "Add to cart",
  [ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_WISHLIST]: "Add to wishlist",
  [ADS_CAMPAIGN_CUSTOM_EVENT_COMPLETE_REGISTRATION]: "Complete registration",
  [ADS_CAMPAIGN_CUSTOM_EVENT_DONATE]: "Donate",
  [ADS_CAMPAIGN_CUSTOM_EVENT_INITIATED_CHECKOUT]: "Initiate checkout",
  [ADS_CAMPAIGN_CUSTOM_EVENT_PURCHASE]: "Purchase",
  [ADS_CAMPAIGN_CUSTOM_EVENT_SEARCH]: "Search",
  [ADS_CAMPAIGN_CUSTOM_EVENT_START_TRIAL]: "Start trial",
  [ADS_CAMPAIGN_CUSTOM_EVENT_SUBSCRIBE]: "Subscribe",
  [ADS_CAMPAIGN_CUSTOM_EVENT_CONTACT]: "Contact",
  [ADS_CAMPAIGN_CUSTOM_EVENT_CUSTOMIZE_PRODUCT]: "Customize product",
  [ADS_CAMPAIGN_CUSTOM_EVENT_FIND_LOCATION]: "Find location",
  [ADS_CAMPAIGN_CUSTOM_EVENT_LEAD]: "Lead",
  [ADS_CAMPAIGN_CUSTOM_EVENT_SCHEDULE]: "Schedule",
  [ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_APPLICATION]: "Submit application",
  [ADS_CAMPAIGN_CUSTOM_EVENT_CONTENT_VIEW]: "View content",
  [ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_FORM]: "Submit form",
  [ADS_CAMPAIGN_CUSTOM_EVENT_CLICK_BUTTON]: "Click button",
  [ADS_CAMPAIGN_CUSTOM_EVENT_PLACE_ORDER]: "Place order",
  [ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_MOBILE_FEED_STANDARD]: "Facebook Feed",
  [ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_STORY]: "Facebook Story",
  [ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_REELS_MOBILE]: "Facebook Reels",
  [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STORY]: "Instagram Story",
  [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_REEL]: "Instagram Reel",
  [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_FEED]: "Instagram Feed",
  [ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STANDARD]: "Instagram Post",
  [ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_SINGLE_VIDEO]: "TikTok Post",
  [ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_CAROUSEL_ADS]: "TikTok Post",
  [ADS_CAMPAIGN_AD_FORMAT_GOOGLE_SEARCH]: "Google Search",
  [ADS_META_DESTINATION_TYPE_NONE]: "None",
  [ADS_META_DESTINATION_TYPE_WEBSITE]: "Website",
  [ADS_META_DESTINATION_TYPE_WEBSITE_AND_APP]: "Website and App",
  [ADS_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE]: "Website and in Store",
  [ADS_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE]:
    "Website, App and in Store",
  [ADS_META_DESTINATION_TYPE_CATALOG]: "Catalog",
  [ADS_META_DESTINATION_TYPE_INSTAGRAM_PROFILE]: "Instagram Profile",
  [ADS_META_DESTINATION_TYPE_ON_VIDEO]: "On video",
  [ADS_META_DESTINATION_TYPE_ON_POST]: "On post",
  [ADS_META_DESTINATION_TYPE_WHATSAPP]: "WhatsApp",
  [ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM]: "Messages on Instagram",
  [ADS_META_DESTINATION_TYPE_MESSAGES_ON_MESSENGER]: "Messages on Messenger",
  [ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER]:
    "Messages on Instagram and Messenger",
  [ADS_META_DESTINATION_TYPE_INSTANT_FORM]: "Instant Form",
  [ADS_META_DESTINATION_TYPE_GOOGLE_PLAY]: "Google Play",
  [ADS_META_DESTINATION_TYPE_APP_STORE]: "App Store",
  [ADS_META_DESTINATION_TYPE_APP]: "App",
  [ADS_CAMPAIGN_BUYING_TYPE_RESERVED]: "Reserved",
  [ADS_CAMPAIGN_BUYING_TYPE_AUCTION]: "Auction",

  [ADS_TIKTOK_APP_EVENT_ACTIVE_OPTION]: "Activation",
  [ADS_TIKTOK_APP_EVENT_DOWNLOAD_START_OPTION]: "Download start",
  [ADS_TIKTOK_APP_EVENT_ACTIVE_REGISTER_OPTION]: "Register",
  [ADS_TIKTOK_APP_EVENT_ACTIVE_PAY_OPTION]: "Purchase",
  [ADS_TIKTOK_APP_EVENT_IN_APP_ORDER_OPTION]: "In-app order",
  [ADS_TIKTOK_APP_EVENT_IN_APP_CART_OPTION]: "In-app cart",
  [ADS_TIKTOK_APP_EVENT_IN_APP_DETAIL_UV_OPTION]: "In-app detail UV",
  [ADS_TIKTOK_APP_EVENT_NEXT_DAY_OPEN_OPTION]: "Next day open",
  [ADS_TIKTOK_APP_EVENT_LOGIN_OPTION]: "Login",
  [ADS_TIKTOK_APP_EVENT_LAUNCH_APP_OPTION]: "Launch app",
  [ADS_TIKTOK_APP_EVENT_COMPLETE_TUTORIAL_OPTION]: "Complete tutorial",
  [ADS_TIKTOK_APP_EVENT_SEARCH_OPTION]: "Search",
  [ADS_TIKTOK_APP_EVENT_START_TRIAL_OPTION]: "Start trial",
  [ADS_TIKTOK_APP_EVENT_SUBSCRIBE_OPTION]: "Subscribe",

  [ADS_CAMPAIGN_REPORT_BREAKDOWN_WEEKLY]: "Weekly",
  [ADS_CAMPAIGN_REPORT_BREAKDOWN_MONTHLY]: "Monthly",

  [KEYWORD_BROAD_MATCH_TYPE_OPTION]: "Broad match",
  [KEYWORD_PHRASE_MATCH_TYPE_OPTION]: "Phrase match",
  [KEYWORD_EXACT_MATCH_TYPE_OPTION]: "Exact match",
  [KEYWORD_TYPE_NORMAL]: "Keyword",
  [KEYWORD_TYPE_NEGATIVE]: "Negative Keyword",

  [ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK]:
    "Open deep link in mobile app, fall back to web browser",
  [ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK]:
    "Open deep link in mobile app, fall back to mobile app store",
  [ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY]: "Open deep link in mobile web browser",
  [ADS_CAMPAIGN_META_FALLBACK_CATALOG]:
    "Use link destination settings from catalog",
  [ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY_LABEL]: "Web Destination",
  [ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK_LABEL]:
    "App Destination with Website Fallback",
  [ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK_LABEL]:
    "App Destination with App Store Fallback",
  [DESTINATION_FALLBACK_CONFIGURATION_TITLE]: "Destination Fallback",

  [ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_QUESTION]: "Dynamic Creative",
  [ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_DESCRIPTION]:
    "Meta will automatically create combinations of your content and text that your audience is likely to respond to.",
  [ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_ABOUT_LINK]: "About dynamic creative",

  [ADS_CAMPAIGN_META_AD_SETUP]: "Ad Setup",
  [ADS_CAMPAIGN_META_AD_SETUP_CREATE_AD]: "Create Ad",
  [ADS_CAMPAIGN_META_AD_SETUP_USE_POST]: "Use Post",
  [ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD]: "Use Existing Ad",
  [ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD_HINT]:
    "You can only choose ads with compatible settings, and you won’t be able to edit any field of the original ad.",
  [MODAL_META_REUSE_CREATIVES_TITLE]: "Existing Ads",
  [MODAL_META_REUSE_CREATIVES_DESCRIPTION]:
    "Select a previously created ad to keep the generated engagement",
  [MODAL_META_REUSE_CREATIVES_EMPTY]: "No reusable creatives yet.",
  [MODAL_META_REUSE_CREATIVES_VALID]: "Compatible",
  [MODAL_META_REUSE_CREATIVES_INVALID]: "Not compatible",
  [MODAL_META_REUSE_CREATIVES_FILTER_ACTIVE]: "Filter by current content",
  [MODAL_META_REUSE_CREATIVES_CLEAR_FILTER]: "Show all creatives",
  [MODAL_META_REUSE_CREATIVES_OPTIMIZATION_WARN]: "Different optimization goal",
  [MODAL_META_REUSE_CREATIVES_COLUMN_COMPATIBILITY]: "Compatibility",
  [MODAL_META_REUSE_CREATIVES_COLUMN_TEXTS]: "Texts",
  [MODAL_META_REUSE_CREATIVES_COLUMN_ENGAGEMENT]: "Engagement",

  [ADS_CAMPAIGN_META_PARTNERSHIP_AD_SECTION]: "Partnership",
  [ADS_CAMPAIGN_META_PARTNERSHIP_AD_TOGGLE]: "Enable collaboration ad",
  [ADS_CAMPAIGN_META_PARTNERSHIP_IDENTITY_ORDER]: "Identity order",
  [ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_FIRST]: "First {{name}}",
  [ADS_CAMPAIGN_META_PARTNERSHIP_PARTNER_NAME_FALLBACK]: "partner",
  [ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_CAMPAIGN_FIRST]:
    "My brand first (campaign Page / Instagram)",
  [ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_PARTNER_FIRST_LABEL]:
    "Partner (creator) first",
  [ADS_CAMPAIGN_META_PARTNERSHIP_SPONSOR_PAGE]: "Partner Facebook Page",
  [ADS_CAMPAIGN_META_PARTNERSHIP_APPROVAL_WARNING]:
    "Make sure {{name}} has approved your request to run collaboration ads. Otherwise, your ads will not be delivered.",
  [ADS_CAMPAIGN_META_PARTNERSHIP_SPONSOR_INSTAGRAM]:
    "Partner Instagram account",

  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_QUESTION]:
    "Does your campaign belong to any special ad categories?",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_DESCRIPTION]:
    "Select the categories that apply (optional; this may limit certain types of targeting)",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_PLACEHOLDER]: "Special Categories",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_HOUSING]: "Housing",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT]: "Employment",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_FINANCIAL_PRODUCTS_SERVICES]:
    "Financial products and services",
  [ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_ISSUES_ELECTIONS_POLITICS]:
    "Issues, elections and politics",

  [ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_PLACEHOLDER]:
    "Special ad categories",
  [ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_HOUSING]: "Housing",
  [ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT]: "Employment",
  [ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_CREDIT]: "Credit",

  [LESS_500K]: "Less than $500,000.00",
  [BETWEEN_500K_1M]: "$500,000.00 - $1,000,000.00",
  [BETWEEN_1M_2_5M]: "$1,000,000.00 - $2,500,000.00",
  [BETWEEN_2_5M_5M]: "$2,500,000.00 - $5,000,000.00",
  [MORE_5M]: "More than $5,000,000.00",
  [LESS_1M]: "Less than $1,000,000.00",
  [BETWEEN_1M_5M]: "$1,000,000.00 - $5,000,000.00",
  [BETWEEN_5M_15M]: "$5,000,000.00 - $15,000,000.00",
  [BETWEEN_15M_30M]: "$15,000,000.00 - $30,000,000.00",
  [BETWEEN_30M_100M]: "$30,000,000.00 - $100,000,000.00",
  [MORE_100M]: "More than $100,000,000.00",
  [LESS_150]: "Less than $150",
  [BETWEEN_150_250]: "$150.00 - $250.00",
  [BETWEEN_250_650]: "$250.00 - $650.00",
  [BETWEEN_650_1250]: "$650.00 - $1,250.00",
  [MORE_1250]: "More than $1,250.00",
  [LESS_250]: "Less than $250.00",
  [BETWEEN_250_1250]: "$250.00 - $1,250.00",
  [BETWEEN_1250_3750]: "$1,250.00 - $3,750.00",
  [BETWEEN_3750_7500]: "$3,750.00 - $7,500.00",
  [BETWEEN_7500_25K]: "$7,500.00 - $25,000.00",
  [MORE_25K]: "More than $25,000.00",
  [LESS_1000]: "Less than $1,000.00",
  [BETWEEN_1000_5000]: "$1,000.00 - $5,000.00",
  [BETWEEN_5000_15K]: "$5,000.00 - $15,000.00",
  [BETWEEN_15K_30K]: "$15,000.00 - $30,000.00",
  [BETWEEN_30K_60K]: "$30,000.00 - $60,000.00",
  [MORE_60K]: "More than $60,000.00",
  [BETWEEN_1000_2000]: "$1,000.00 - $2,000.00",
  [BETWEEN_2000_5000]: "$2,000.00 - $5,000.00",
  [BETWEEN_5000_10K]: "$5,000.00 - $10,000.00",
  [MORE_10K]: "More than $10,000.00",

  [DOCUMENT_CC]: "Citizenship card",
  [DOCUMENT_CE]: "Foreigner ID",
  [DOCUMENT_NUIP]: "NUIP",
  [DOCUMENT_NIT]: "NIT",
  [DOCUMENT_CI]: "Identity card",
  [DOCUMENT_PASSPORT]: "Passport",
  [DOCUMENT_EIN]: "EIN",
  [DOCUMENT_RUC]: "RUC",
  [DOCUMENT_ID]: "ID",
  [DOCUMENT_ID_EMIRATES]: "Emirates ID",
  [DOCUMENT_TRN]: "TRN",

  //EXPLANATIONS TOOLTIP
  [ADS_CAMPAIGN_OBJECTIVE_AWARENESS_TITLE_EXPLANATION]:
    "What is the awareness objective?",
  [ADS_CAMPAIGN_OBJECTIVE_AWARENESS_DESCRIPTION_EXPLANATION]: `Ads will be shown to people who are more likely to remember them. This objective is ideal for increasing brand or product awareness. <br><br>
    Good for:<br>
    <li><strong>Reach:</strong> Target individuals who are more likely to recall your brand.</li>
    <li><strong>Brand awareness:</strong> Aim to make your brand memorable to potential customers.</li>
    <li><strong>Video views:</strong> Engage people who are more likely to view your video content.</li>
    <li><strong>Store location awareness:</strong> Attract people using your business's physical location.</li>
    `,
  [ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_TITLE_EXPLANATION]:
    "What is the traffic objective?",
  [ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_DESCRIPTION_EXPLANATION]: `Ads will be shown to people who are more likely to click on them. This objective is ideal for increasing traffic to your website or app. <br><br>
    Good for:<br>
    <li><strong>Link clicks:</strong> Encourage individuals to click on a link to your website, app, or event page.</li>
    <li><strong>Landing page views:</strong> Drive traffic to view the content on your landing page.</li>
    <li><strong>Instagram profile visits:</strong> Motivate people to visit your Instagram profile.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_TITLE_EXPLANATION]:
    "What is the engagement objective?",
  [ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_DESCRIPTION_EXPLANATION]: `Ads will be shown to people who are more likely to interact with them. This objective is ideal for increasing comments, likes, shares, and clicks on your ad. <br><br>
    Good for:<br>
    <li><strong>Video views:</strong> Attract viewers who are likely to watch your videos.</li>
    <li><strong>Post engagement:</strong> Encourage interactions with your social media posts.</li>
    <li><strong>Conversions:</strong> Prompt individuals to view content, contact your business, add items to a wishlist, or perform other actions on your website or app.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_LEADS_TITLE_EXPLANATION]:
    "What is the leads objective?",
  [ADS_CAMPAIGN_OBJECTIVE_LEADS_DESCRIPTION_EXPLANATION]: `Ads will be shown to people who are more likely to provide contact information. This objective is ideal for increasing lead registrations.<br><br>
    Good for:<br>
    <li><strong>Instant forms:</strong> Find individuals willing to provide their contact details and other information by filling out a form.</li>
    <li><strong>Conversions:</strong> Encourage people to share their contact information, complete registration forms, submit applications, or perform other actions on your website or app.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_TITLE_EXPLANATION]:
    "What is the app promotion objective?",
  [ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_DESCRIPTION_EXPLANATION]: `Ads will be shown to people who are more likely to download your app. This objective is ideal for increasing app downloads.<br><br>
    Good for:<br>
    <li><strong>App installs:</strong> Encourage individuals to download and install your app.</li>
    <li><strong>App events:</strong> Motivate users to make in-app purchases or perform other actions within your app.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_SALES_TITLE_EXPLANATION]:
    "What is the sales objective?",
  [ADS_CAMPAIGN_OBJECTIVE_SALES_DESCRIPTION_EXPLANATION]: `Ads will be shown to people who are more likely to make a purchase. This objective is ideal for increasing sales of your product or service.<br><br>
    Good for:<br>
    <li><strong>Catalog sales:</strong> Encourage people to purchase products or services from your catalog.</li>
    <li><strong>Conversions:</strong> Get individuals to add items to their cart, make purchases, start subscriptions, or perform other actions on your website or app.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_TITLE_EXPLANATION]: "Video Views",
  [ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_DESCRIPTION_EXPLANATION]: `Show your video ads to people who are most likely to watch them. This objective is ideal for increasing video views and engagement.<br><br>
    Good for:<br>
    <li><strong>Video content:</strong> Promote video content to increase views and engagement.</li>
    <li><strong>Brand awareness:</strong> Use video to build brand awareness and reach a wider audience.</li>`,
  [ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_TITLE_EXPLANATION]:
    "Website Conversions",
  [ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_DESCRIPTION_EXPLANATION]: `Show ads to people who are most likely to take valuable actions on your website. This objective is ideal for driving conversions and sales.<br><br>
    Good for:<br>
    <li><strong>Conversions:</strong> Get people to complete valuable actions on your website, such as purchases, sign-ups, or form submissions.</li>
    <li><strong>Sales:</strong> Drive sales and revenue by targeting people likely to convert.</li>`,
  [ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX]: "Performance Max",
  [ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_TITLE_EXPLANATION]:
    "What is a Performance Max campaign type?",
  [ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_DESCRIPTION_EXPLANATION]:
    "Performance Max campaigns use Google's machine learning to show ads on all Google Ads channels, maximizing conversions or conversion value within your target budget.",
  [ADS_CAMPAIGN_TYPE_APP_TITLE_EXPLANATION]:
    "What is an app install campaign type?",
  [ADS_CAMPAIGN_TYPE_APP_DESCRIPTION_EXPLANATION]:
    "App install campaigns are designed to promote the download and installation of mobile apps on Google Play Store or App Store.",
  [ADS_CAMPAIGN_TYPE_SEARCH_TITLE_EXPLANATION]:
    "What is a search campaign type?",
  [ADS_CAMPAIGN_TYPE_SEARCH_DESCRIPTION_EXPLANATION]:
    "Search ads are shown to interested people at the right time on Google Search.",
  [ADS_CAMPAIGN_TYPE_SHOPPING_TITLE_EXPLANATION]:
    "What is a shopping campaign type?",
  [ADS_CAMPAIGN_TYPE_SHOPPING_DESCRIPTION_EXPLANATION]:
    "Shopping ads are shown to shoppers as they explore what to buy online.",
  [ADS_CAMPAIGN_TYPE_VIDEO_TITLE_EXPLANATION]: "What is a video campaign type?",
  [ADS_CAMPAIGN_TYPE_VIDEO_DESCRIPTION_EXPLANATION]:
    "Video ads are shown before, during or after a video on YouTube.",
  [ADS_CAMPAIGN_TYPE_BUDGET_DAILY_TITLE_EXPLANATION]:
    "What does a daily budget type mean?",
  [ADS_CAMPAIGN_TYPE_BUDGET_DAILY_DESCRIPTION_EXPLANATION]:
    "A daily budget is the maximum amount you are willing to spend per day on your campaign. The social network will try not to exceed this limit but may spend slightly more on days with more opportunities to show your ads.",
  [ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_TITLE_EXPLANATION]:
    "What does a total budget type mean?",
  [ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_DESCRIPTION_EXPLANATION]:
    "A total budget is the maximum amount you are willing to spend for your entire campaign. The social network will try not to exceed this limit but may spend slightly more on days with more opportunities to show your ads.",
  [ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_TITLE_EXPLANATION]:
    "What is a custom website audience?",
  [ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_DESCRIPTION_EXPLANATION]:
    "A website custom audience is created from the people who visit your website or perform specific actions on your website.",
  [ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_TITLE_EXPLANATION]:
    "What is a custom audience customer list?",
  [ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_DESCRIPTION_EXPLANATION]:
    "A custom customer list custom audience is created from the contact information you already have about your customers, such as email addresses or phone numbers.",
  [ADS_CAMPAIGNS_PIXELS_TITLE_EXPLANATION]: "What is a pixel?",
  [ADS_CAMPAIGNS_PIXELS_DESCRIPTION_EXPLANATION]: `Pixels are tools that are integrated into websites and applications to measure the effectiveness of your ads and understand the actions users take on your site. <br/><br/>

    Setting up a pixel increases the likelihood that your ads will target the right audience, which in turn maximizes your results.
    
    <ul>
      <li><a href="https://www.facebook.com/business/help/952192354843755?id=1205376682832142" target="_blank">How to create and configure a pixel in Meta?</a></li>
      <li><a href="https://ads.tiktok.com/help/article/get-started-pixel" target="_blank">How to create and configure a pixel in TikTok?</a></li>
    </ul>`,
  [ADVERTISER_ROLE_TITLE_EXPLANATION]: "What does an administrator do?",
  [ADVERTISER_ROLE_DESCRIPTION_EXPLANATION]: `Administrators have full access to all platform functionalities. <br/><br/>
      • Connect and disconnect platform accounts.<br/>
      • Generate, publish and edit campaigns.<br/>
      • Generate reports.<br/>
      • Create and edit users.<br/>
      • View billing information and current plan.`,
  [MARKETER_ROLE_TILE_EXPLANATION]: "What does a Media Buyer do?",
  [MARKETER_ROLE_DESCRIPTION_EXPLANATION]: `Marketers are mostly responsible for the creation and publication of campaigns on the platform.<br/><br/>
      • Connect and disconnect platform accounts.<br/>
      • Generate reports.<br/>
      • Generate, publish and edit campaigns.<br/>`,
  [VIEWER_ROLE_TITLE_EXPLANATION]: "What does a Viewer do?",
  [VIEWER_ROLE_DESCRIPTION_EXPLANATION]: `The viewers have access to information on the campaigns and the results obtained. <br/><br/>
      • View campaign information.<br/>
      • Generate reports.<br/>`,
  [VIEWER_ROLE_READ_ONLY_CAPABILITY]:
    "Viewers can only view information; they cannot make changes.",
  [VIEWER_CAPABILITY_VIEW_CAMPAIGNS]: "View campaigns",
  [VIEWER_CAPABILITY_VIEW_CONTENT]: "View content",
  [VIEWER_CAPABILITY_VIEW_CALENDAR]: "View calendar",
  [VIEWER_CAPABILITY_VIEW_REPORTS]: "View campaign reports",
  [DESIGNER_ROLE_TITLE_EXPLANATION]: "What does a Designer do?",
  [ROLE_CAPABILITY_CAN_MANAGE_USERS]: "Manage users",
  [ROLE_CAPABILITY_CAN_ACCESS_SETTINGS_ACCOUNTS]: "Connect accounts",
  [ROLE_CAPABILITY_CAN_CREATE_CAMPAIGN]: "Generate campaigns",
  [ROLE_CAPABILITY_CAN_EDIT_CAMPAIGN]: "Publish, edit, and manage campaigns",
  [ROLE_CAPABILITY_CAN_USE_CAMPAIGN_AGENT]: "Use AI agent",
  [ROLE_CAPABILITY_CAN_EDIT_GALLERY]: "Generate and edit content",
  [ROLE_CAPABILITY_CAN_POST]: "Publish content",
  [ROLE_CAPABILITY_CAN_EDIT_BRAND_SETUP]: "Configure brand",
  [ROLE_CAPABILITY_CAN_EDIT_BILLING]: "Edit billing",

  //ONBOARDING

  //MAIN FUNCTIONALITY
  [MAIN_FUNCTIONALITY_STEP_1]: `This is the Content Creators section. Here, you will find a list of creators who are registered on {{NAME_BUSINESS}} and available to collaborate with your brand.`,
  [MAIN_FUNCTIONALITY_STEP_2]:
    "You can use filters to search for content creators by their account name, categories, city, number of followers, audience engagement percentage, and more.",
  [MAIN_FUNCTIONALITY_STEP_3]: `You have three sections to search for content creators: <br/><br/>
    <strong>Creators:</strong> This is the general list of all creators registered on {{NAME_BUSINESS}}.<br/>
    <strong>For you:</strong> This is the list of creators that match the creator profile you are interested in.<br/>
    <strong>Requests:</strong> This is the list of creators who are interested in your brand and send you a collaboration request.
    `,
  [MAIN_FUNCTIONALITY_STEP_4]:
    "This is the general information of the creator, you can click on each card to access more complete information. Click on the card.",
  [PUBLICATIONS_FUNCTIONALITY_STEP_1]:
    "Once creators redeem their invitations, posts will be generated. To go to the posts section, click on the Posts button in the side menu.",
  [PUBLICATIONS_FUNCTIONALITY_STEP_2]:
    "Posts can have multiple states. The first is Pending Post, which occurs when the creator has redeemed their invitation but has not yet published the generated content.",
  [PUBLICATIONS_FUNCTIONALITY_STEP_3]:
    "The second is Pending Analytics, which happens when the creator has published the generated content but has not yet published the analytics to view collaboration results.",
  [PUBLICATIONS_FUNCTIONALITY_STEP_4]:
    "The third is Review, which occurs when the creator has published the generated content and analytics. Now you should review them, rate the creator, and consider making them an ambassador. Click the Review button.",
  [PUBLICATION_FUNCTIONALITY_STEP_1]:
    "Here, you will see the analytics and results generated by the content creator's content.",
  [PUBLICATION_FUNCTIONALITY_STEP_2]:
    "Here, you will see all the content that the content creator generated for your brand.",
  [PUBLICATION_FUNCTIONALITY_STEP_3]:
    "This is the button to rate the content creator. Click the Rate button.",
  [REVIEW_FUNCTIONALITY_STEP_1]:
    "This is the form for rating the content creator. Your review information will not be shared with the creator.",
  [REVIEW_FUNCTIONALITY_STEP_2]:
    "You can rate the content of the content creator on a scale of 1 to 5, indicating how good the generated content was.",
  [REVIEW_FUNCTIONALITY_STEP_3]:
    "You can rate the analytics of the content creator on a scale of 1 to 5, indicating how good the generated results were.",
  [REVIEW_FUNCTIONALITY_STEP_4]:
    "Describe in text how the overall experience was with the collaboration. This text must be at least 10 characters long.",
  [REVIEW_FUNCTIONALITY_STEP_5]:
    "Once the form is filled out, to submit your review, click the Finish button.",
  [MAIN_FUNCTIONALITY_ONBOARDING_FINISH]:
    "You have completed the platform tutorial. Now you know where to find content creators, view their information, and perform various actions with them.",

  //MENU FUNCTIONALITY
  [MENU_FUNCTIONALITY_STEP_1]:
    "Here, you can select the store for which you want to manage its catalog.",
  [MENU_FUNCTIONALITY_STEP_2]:
    "You can add a category here to organize your products or services. Click the button and enter the category name.",
  [MENU_FUNCTIONALITY_STEP_3]: "This is the new category you've just created.",
  [MENU_FUNCTIONALITY_STEP_4]: "Here, you can add a product or service.",
  [MENU_FUNCTIONALITY_STEP_5]:
    "Click the button to upload an image for the product.",
  [MENU_FUNCTIONALITY_STEP_6]: "Enter the name of the product and click Next.",
  [MENU_FUNCTIONALITY_STEP_7]:
    "Enter the description of the product and click Next.",
  [MENU_FUNCTIONALITY_STEP_8]: "Enter the price of the product and click Next.",
  [MENU_FUNCTIONALITY_STEP_9]:
    "Indicate if the product is harmful to health or for adults by clicking the checkbox.",
  [MENU_FUNCTIONALITY_STEP_10]:
    "Once the form is filled out, to create the product, click the Create button.",
  [MENU_FUNCTIONALITY_STEP_11]: "This is the product you've just created.",
  [MENU_FUNCTIONALITY_STEP_12]:
    "Click to activate/deactivate a product based on your inventory.",

  //USERS FUNCTIONALITY
  [USERS_FUNCTIONALITY_STEP_1]: "This is an Administrator user.",
  [USERS_FUNCTIONALITY_STEP_2]:
    "The Administrator role has access to all functionalities, meaning it can manage invitations to creators, manage posts, modify brand information, manage payment information, and more.",
  [USERS_FUNCTIONALITY_STEP_3]: "This is an Operator user.",
  [USERS_FUNCTIONALITY_STEP_4]:
    "The Operator role has access only to the functionalities of redeeming creators' codes who arrive at your physical store, managing orders/deliveries made by creators via the app, and activating/deactivating products based on inventory.",

  //MAIN FUNCTIONALITY OPERATOR
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_1]:
    "With the redemption bar, you can enter a code and attempt to redeem it. Enter any code and click Redeem.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_2]:
    "Here is the code you just redeemed and the value of the invitation. This is the value that will be granted to the content creator. If what the creator requests is higher than the invitation value, they will be charged the excess.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_3]: `This is the Orders section. Here, you can view the list of orders placed by content creators via delivery through the {{NAME_BUSINESS}} app. Orders/deliveries have 3 states.`,
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_4]:
    "The first is Pending Acceptance. This is when a content creator has placed an order, is waiting for you to accept it, and assign a process time.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_5]:
    "The second is Processing. This is when a content creator has placed an order, you've accepted it, and assigned a process time. You should now communicate the processing of the order",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_6]:
    "The third is Pending Delivery. This is when the order, which was in processing, is ready, and you've dispatched it using a delivery method. Once you are notified of the delivery or the creator marks it as delivered, the order will disappear from here.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_7]:
    "A new order has just come in. The platform will start making a sound until you see the new order. Click to view it.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_8]:
    "Here are the products that the content creator has ordered. You can see the quantity and price of each product.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_9]:
    "Here is the message left by the content creator, which can be instructions or recommendations for the delivery.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_10]:
    "Here is the total value of the order.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_11]:
    "Here is the content creator who placed the order and their information.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_12]:
    "Here, you can specify the order's processing and delivery time, which can be in minutes, hours, days, or weeks.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_13]:
    "Here, you can indicate the amount of time for order processing and delivery. You can add or subtract time.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_14]:
    "Once you have reviewed the information and assigned the order's processing time, you can click the Accept Order button to move it to processing.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_15]:
    "This is the order you have just accepted, and its status has changed.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_16]:
    "Here, you can see how much processing time is remaining. Click to view the order details again.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_17]:
    "Once the order is ready, you should assign delivery information to it.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_18]:
    "Once the form is filled, click the Order Ready button to mark the order as ready.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_19]:
    "This is the order you have just dispatched, and its status has changed. Here, you will find the delivery information you assigned to the order. Once you are informed that the order has been delivered, you should mark it as delivered. Click to see the order details.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_20]:
    "After reviewing the information and being informed of the delivery to the content creator, you should mark the order as delivered. Click the Order Delivered button for this.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_21]:
    "This is the Menu section. Here, you can view the list of products available in your brand's catalog.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_22]:
    "Here is the list of categories, including the test category.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_23]:
    "Here is the list of products, including the test product.",
  [MAIN_FUNCTIONALITY_OPERATOR_STEP_24]:
    "As an operator, you can only activate or deactivate products based on inventory availability. To deactivate/activate a product, click the button.",

  //CAMPAIGNS FUNCTIONALITY
  [CAMPAIGNS_FUNCTIONALITY_STEP_1]:
    "This is the Campaigns page. Here, you can create campaigns to generate more personalized collaborations with creators.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_2]:
    "Let's start by creating a campaign. Click on Create Campaign.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_3]:
    "In the center of the screen, questions for your campaign will appear.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_4]:
    "In the first question, you should write the name of your campaign.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_5]:
    "Once you've answered the question, click the Next button.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_6]:
    "After clicking the Next button, the next question will appear.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_7]:
    "Here, you can select the question you want to view. Only the questions you've viewed will be shown.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_8]:
    "The form may be quite extensive, so you can save your progress by clicking Save Progress.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_9]:
    "Once you save your progress, you'll be redirected to the campaign page.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_10]:
    "This is the Applicants section, where you can see the creators who have applied to your campaign. You can view their information, statistics, accept them, or reject them.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_11]:
    "Here, you can also use filters to view the applicants that interest you.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_12]:
    "This is a creator who applied to your campaign.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_13]:
    "This is the section for Invited Creators, where you will find the creators who interested you for your campaign and whom you invited.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_14]:
    "In this section, you will find information about your campaign. Here, you can complete the missing information and activate the campaign so that creators can apply.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_15]:
    "With this button, you can save the changes to your campaign, and it will remain in a deactivated state, meaning creators cannot apply yet.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_16]:
    "With this button, you can activate the campaign. You must have all the required information to do this. In this state, creators can apply to your campaign.",
  [CAMPAIGNS_FUNCTIONALITY_STEP_17]:
    "With this button, you can mark the campaign as completed. After this, no creator can apply, and you cannot activate it again.",

  //ALERTS
  [SAVE_LOCATION_SET_TITLE]: "Save Location Set",
  [SAVE_LOCATION_SET_NAME_LABEL]: "Name of the set",
  [SAVE_LOCATION_SET_SAVE_BUTTON]: "Save",
  [SAVE_LOCATION_SET_SAVING_BUTTON]: "Saving...",
  [SAVE_LOCATION_SET_CANCEL_BUTTON]: "Cancel",
  [PUBLISHING_ALERT_TITLE]: "Publishing Campaign",
  [PUBLISHING_ALERT_ERROR_TITLE]: "Error Publishing Campaign",
  [PUBLISHING_ALERT_SUCCESS_TITLE]: "Successfully Published Campaign",
  [PUBLISHING_ALERT_RETRY_BUTTON]: "Retry",
  [GENERATING_CAMPAIGN]: "Generating Campaign",
  [CAMPAIGN_GENERATED_SUCCESS]: "Campaign Generated Successfully",
  [CAMPAIGN_GENERATED_ERROR]: "Error Generating Campaign",
  [CAMPAIGN_GENERATED_ERROR_DESCRIPTION]:
    "An error occurred while generating the campaign. Please try again.",
  [CHANGE_BUYING_TYPE_TO_RESERVED_TITLE]: "Wait",
  [CHANGE_BUYING_TYPE_TO_RESERVED_DESCRIPTION]:
    "By changing to reserved buying type, you will lose the current configurations and only the awareness objective will be available. Do you want to continue?",
  [HIDE_ALERTS]: "Hide Alerts",
  [SHOW_ALERTS]: "Show Alerts",
  [ACTIVITY]: "Activity",
  [NO_TASKS]: "No campaigns or creatives in progress",
  [NO_TASKS_DESCRIPTION]:
    "Tasks will automatically appear here once you start publishing a campaign or generating creatives",
  [GLOBAL_ALERTS_PANEL_TITLE]: "Notifications",
  [GLOBAL_ALERTS_EMPTY]: "No notifications",
  [GLOBAL_ALERTS_EMPTY_DESCRIPTION]:
    "Product updates will appear here when they are published",
  [GLOBAL_ALERTS_BELL_ARIA]: "Notifications",
  [RESET_CHAT_ALERT_TITLE]: "Are you sure?",
  [RESET_CHAT_ALERT_DESCRIPTION]: "All chat messages will be deleted.",
  [DISCARD_OPTIMIZATION_ALERT_TITLE]: "Are you sure?",
  [DISCARD_OPTIMIZATION_ALERT_DESCRIPTION]:
    "This optimization will be discarded and you will not be able to recover it.",
  [DISCARD_GENERATING_CREATIVE_ALERT_DESCRIPTION]:
    "The generated creative will be discarded and you will not be able to recover it.",
  [DISCARD_GENERATING_VIDEO_ALERT_DESCRIPTION]:
    "The generated video will be discarded and you will not be able to recover it.",
  [DISCARD_IMAGE_ANIMATION_ALERT_DESCRIPTION]:
    "The generated animation will be discarded and you will not be able to recover it.",
  [DISCARD_GENERATING_CUSTOM_REPORT_ALERT_DESCRIPTION]:
    "The generated report will be discarded and you will not be able to recover it.",
  [DISCARD_ANALYZING_IMAGE_LAYERS_ALERT_DESCRIPTION]:
    "The layer analysis will be discarded and you will not be able to recover it.",
  [DISCARD_ANALYZING_CREATIVE_TEMPLATE_ALERT_DESCRIPTION]:
    "This template analysis will be discarded from your activity list.",
  [DISCARD_PRODUCING_CREATIVE_TEMPLATE_ALERT_DESCRIPTION]:
    "This production will be discarded from your activity list.",
  [BUTTON_DISCARD_ALL]: "Discard All",
  [DISCARD_ALL_ACTIVITIES_TITLE]: "Discard All Activities?",
  [DISCARD_ALL_ACTIVITIES_DESCRIPTION]:
    "Finished activities will be discarded and access to their information from this place will be lost. Activities that are still in progress will remain.",

  // Keys para el modal de sets guardados
  [SAVED_LOCATION_SETS_TITLE]: "Saved Location Sets",
  [SAVED_LOCATION_SETS_CLOSE_BUTTON]: "Close",

  [FIELD_OPEN_MAP_RADIUS_SELECT_TITLE]: "Select Locations",
  [FIELD_OPEN_MAP_RADIUS_SELECT_DESCRIPTION]:
    "Select locations for your campaign.",

  // Keys para los botones principales
  [LOAD_LOCATION_SET_BUTTON]: "Select Location Set",
  [SAVE_LOCATION_SET_BUTTON]: "Save Location Set",
  [SAVE_LOCATION_SET_SUCCESS]: "Location Set Saved",
  [SAVE_LOCATION_SET_ERROR]: "Error Saving Location Set",
  [LOAD_LOCATION_SETS_ERROR]: "Error Loading Location Sets",
  [SAVE_LOCATION_SET_DUPLICATE_ERROR]:
    "A set with the same locations already exists",

  // CUSTOMER ACQUISITION CONFIGURATION
  [CUSTOMER_ACQUISITION_TITLE]: "Customer Acquisition",
  [CUSTOMER_ACQUISITION_SWITCH_LABEL]:
    "Adjust your bidding to help you gain new customers",
  [CUSTOMER_ACQUISITION_ACCOUNT_LEVEL]: "Use account-level configuration",
  [CUSTOMER_ACQUISITION_CAMPAIGN_LEVEL]: "Use campaign-specific configuration",
  [CUSTOMER_ACQUISITION_NEW_CUSTOMER_VALUE]: "New Customer",
  [CUSTOMER_ACQUISITION_NEW_CUSTOMER_HIGH_VALUE]: "New High-Value Customer",

  // METRICS NOT FOUND MESSAGE
  [METRICS_NOT_FOUND_MESSAGE]: "Metrics not found",
  [SEARCH_METRICS_PLACEHOLDER]: "Search metrics...",
  [CONFIGURE_METRICS]: "Configure Metrics",
  [GENERAL_METRIC]: "General",

  /*GENERAL METRICS*/
  [REACH]: "Reach",
  [FREQUENCY]: "Frequency",
  [CPM_METRICS]: "CPM",
  [CPC_METRICS]: "CPC",
  [ESTIMATED_AUDIENCE_SIZE]: "Estimated Audience Size",
  [REACH_AT_TARGET_FREQUENCY]: "Reach at Target Frequency",
  [AUDIENCE_SIZE]: "Audience Size",
  [POTENTIAL_REACH]: "Potential Reach",
  [ESTIMATED_DAILY_RESULTS]: "Estimated Daily Results",

  /*SPECIFICS METRICS GOOGLE*/
  [ALL_CONVERSIONS]: "All Conversions",
  [ALL_CONVERSIONS_FROM_INTERACTIONS_RATE]:
    "All Conversions from Interactions Rate",
  [ALL_CONVERSIONS_VALUE]: "All Conversions Value",
  [APP_EVENT_ADD_TO_CART]: "App Add to Cart Events",
  [APP_INSTALL]: "App Installs",
  [AVERAGE_CART_SIZE]: "Average Cart Size",
  [AVERAGE_COST]: "Average Cost",
  [AVERAGE_CPC]: "Average Cost per Click",
  [AVERAGE_ORDER_VALUE_MICROS]: "Average Order Value",
  [CHECKOUT]: "Checkouts",
  [COMMENTS_METRICS]: "Comments",
  [CONVERSION_RATE]: "Conversion Rate",
  [CONVERSIONS_FROM_INTERACTIONS_RATE]: "Conversions from Interactions Rate",
  [CONVERSIONS_VALUE]: "Conversions Value",
  [COST_OF_GOODS_SOLD_MICROS]: "Cost of Goods Sold",
  [COST_PER_ALL_CONVERSIONS]: "Cost per All Conversions",
  [COST_PER_APP_EVENT_ADD_TO_CART]: "Cost per App Add to Cart",
  [COST_PER_APP_INSTALL]: "Cost per App Install",
  [COST_PER_CHECKOUT]: "Cost per Checkout",
  [COST_PER_CONVERSION]: "Cost per Conversion",
  [COST_PER_PURCHASE]: "Cost per Purchase",
  [COST_PER_VIEW_CONTENT]: "Cost per Content View",
  [CROSS_DEVICE_CONVERSIONS]: "Cross-Device Conversions",
  [CROSS_DEVICE_CONVERSIONS_VALUE_MICROS]: "Cross-Device Conversions Value",
  [CROSS_SELL_COST_OF_GOODS_SOLD_MICROS]: "Cross-Sell Cost of Goods Sold",
  [CROSS_SELL_GROSS_PROFIT_MICROS]: "Cross-Sell Gross Profit",
  [CROSS_SELL_REVENUE_MICROS]: "Cross-Sell Revenue",
  [CROSS_SELL_UNITS_SOLD]: "Cross-Sell Units Sold",
  [ENGAGEMENT_RATE]: "Engagement Rate",
  [FOLLOWS]: "Follows",
  [GROSS_PROFIT_MARGIN]: "Gross Profit Margin",
  [GROSS_PROFIT_MICROS]: "Gross Profit",
  [INTERACTION_RATE]: "Interaction Rate",
  [INTERACTIONS_METRICS]: "Interactions",
  [LEAD_COST_OF_GOODS_SOLD_MICROS]: "Lead Cost of Goods Sold",
  [LEAD_GROSS_PROFIT_MICROS]: "Lead Gross Profit",
  [LEAD_REVENUE_MICROS]: "Lead Revenue",
  [LEAD_UNITS_SOLD]: "Lead Units Sold",
  [LIKES_METRICS]: "Likes",
  [ORDERS_METRICS]: "Orders",
  [PROFILE_VISITS]: "Profile Visits",
  [PURCHASE]: "Purchases",
  [REVENUE_MICROS]: "Revenue",
  [SHARES_METRICS]: "Shares",
  [VALUE_PER_ALL_CONVERSIONS]: "Value per All Conversions",
  [VALUE_PER_CONVERSION]: "Value per Conversion",
  [VIDEO_VIEWS_P100]: "Complete Video Views",
  [VIEW_CONTENT]: "Content Views",
  [VIEW_THROUGH_CONVERSIONS]: "View-Through Conversions",

  /*SPECIFICS METRICS META*/
  [ACTION_VALUES]: "Action Values",
  [ACTIONS_METRICS]: "Actions",
  [COST_PER_ADD_TO_CART_META]: "Cost per Add to Cart",
  [ADD_TO_CART_META]: "Add to Cart",
  [COST_PER_WEB_IN_STORE_PURCHASE_META]: "Cost per Web In Store Purchase",
  [WEB_IN_STORE_PURCHASE_META]: "Web In Store Purchase",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META]:
    "Cost per Offsite Conversion Fb Pixel Search",
  [OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META]:
    "Offsite Conversion Fb Pixel Search",
  [COST_PER_LINK_CLICK_META]: "Cost per Link Click",
  [LINK_CLICK_META]: "Link Click",
  [COST_PER_PAGE_ENGAGEMENT_META]: "Cost per Page Engagement",
  [PAGE_ENGAGEMENT_META]: "Page Engagement",
  [COST_PER_PURCHASE_META]: "Cost per Purchase",
  [PURCHASE_META]: "Purchase",
  [COST_PER_LANDING_PAGE_VIEW_META]: "Cost per Landing Page View",
  [LANDING_PAGE_VIEW_META]: "Landing Page View",
  [COST_PER_POST_ENGAGEMENT_META]: "Cost per Post Engagement",
  [POST_ENGAGEMENT_META]: "Post Engagement",
  [COST_PER_ONSITE_WEB_VIEW_CONTENT_META]: "Cost per Onsite Web View Content",
  [ONSITE_WEB_VIEW_CONTENT_META]: "Onsite Web View Content",
  [COST_PER_ONSITE_WEB_ADD_TO_CART_META]: "Cost per Onsite Web Add to Cart",
  [ONSITE_WEB_ADD_TO_CART_META]: "Onsite Web Add to Cart",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META]:
    "Cost per Offsite Conversion Fb Pixel Add Payment Info",
  [OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META]:
    "Offsite Conversion Fb Pixel Add Payment Info",
  [COST_PER_COMMENT_META]: "Cost per Comment",
  [COMMENT_META]: "Comment",
  [COST_PER_ONSITE_WEB_APP_PURCHASE_META]: "Cost per Onsite Web App Purchase",
  [ONSITE_WEB_APP_PURCHASE_META]: "Onsite Web App Purchase",
  [COST_PER_OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META]:
    "Cost per Offsite Content View Add Meta Leads",
  [OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META]:
    "Offsite Content View Add Meta Leads",
  [COST_PER_VIEW_CONTENT_META]: "Cost per View Content",
  [VIEW_CONTENT_META]: "View Content",
  [COST_PER_WEB_APP_IN_STORE_PURCHASE_META]:
    "Cost per Web App In Store Purchase",
  [WEB_APP_IN_STORE_PURCHASE_META]: "Web App In Store Purchase",
  [COST_PER_ONSITE_WEB_APP_ADD_TO_CART_META]:
    "Cost per Onsite Web App Add to Cart",
  [ONSITE_WEB_APP_ADD_TO_CART_META]: "Onsite Web App Add to Cart",
  [COST_PER_OFFSITE_SEARCH_ADD_META_LEADS_META]:
    "Cost per Offsite Search Add Meta Leads",
  [OFFSITE_SEARCH_ADD_META_LEADS_META]: "Offsite Search Add Meta Leads",
  [COST_PER_POST_META]: "Cost per Post",
  [POST_META]: "Post",
  [COST_PER_ONSITE_CONVERSION_POST_SAVE_META]:
    "Cost per Onsite Conversion Post Save",
  [ONSITE_CONVERSION_POST_SAVE_META]: "Onsite Conversion Post Save",
  [COST_PER_ONSITE_WEB_INITIATE_CHECKOUT_META]:
    "Cost per Onsite Web Initiate Checkout",
  [ONSITE_WEB_INITIATE_CHECKOUT_META]: "Onsite Web Initiate Checkout",
  [COST_PER_ONSITE_CONVERSION_POST_NET_SAVE_META]:
    "Cost per Onsite Conversion Post Net Save",
  [ONSITE_CONVERSION_POST_NET_SAVE_META]: "Onsite Conversion Post Net Save",
  [COST_PER_ONSITE_WEB_APP_VIEW_CONTENT_META]:
    "Cost per Onsite Web App View Content",
  [ONSITE_WEB_APP_VIEW_CONTENT_META]: "Onsite Web App View Content",
  [COST_PER_POST_INTERACTION_GROSS_META]: "Cost per Post Interaction Gross",
  [POST_INTERACTION_GROSS_META]: "Post Interaction Gross",
  [COST_PER_ONSITE_WEB_PURCHASE_META]: "Cost per Onsite Web Purchase",
  [ONSITE_WEB_PURCHASE_META]: "Onsite Web Purchase",
  [COST_PER_ADD_PAYMENT_INFO_META]: "Cost per Add Payment Info",
  [ADD_PAYMENT_INFO_META]: "Add Payment Info",
  [COST_PER_SEARCH_META]: "Cost per Search",
  [SEARCH_META]: "Search",
  [COST_PER_VIDEO_VIEW_META]: "Cost per Video View",
  [VIDEO_VIEW_META]: "Video View",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META]:
    "Cost per Offsite Conversion Fb Pixel View Content",
  [OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META]:
    "Offsite Conversion Fb Pixel View Content",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META]:
    "Cost per Offsite Conversion Fb Pixel Add to Cart",
  [OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META]:
    "Offsite Conversion Fb Pixel Add to Cart",
  [COST_PER_POST_REACTION_META]: "Cost per Post Reaction",
  [POST_REACTION_META]: "Post Reaction",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META]:
    "Cost per Offsite Conversion Fb Pixel Initiate Checkout",
  [OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META]:
    "Offsite Conversion Fb Pixel Initiate Checkout",
  [COST_PER_OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META]:
    "Cost per Offsite Conversion Fb Pixel Purchase",
  [OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META]:
    "Offsite Conversion Fb Pixel Purchase",
  [COST_PER_INITIATE_CHECKOUT_META]: "Cost per Initiate Checkout",
  [INITIATE_CHECKOUT_META]: "Initiate Checkout",
  [COST_PER_LIKE_META]: "Cost per Like",
  [LIKE_META]: "Like",
  [AD_CLICK_ACTIONS]: "Ad Click Actions",
  [AD_IMPRESSION_ACTIONS]: "Ad Impression Actions",
  [AUCTION_BID]: "Auction Bid",
  [AUCTION_COMPETITIVENESS]: "Auction Competitiveness",
  [AUCTION_MAX_COMPETITOR_BID]: "Auction Max Competitor Bid",
  [CANVAS_AVG_VIEW_PERCENT]: "Canvas Average View Percent",
  [CANVAS_AVG_VIEW_TIME]: "Canvas Average View Time",
  [CATALOG_SEGMENT_ACTIONS]: "Catalog Segment Actions",
  [CATALOG_SEGMENT_VALUE]: "Catalog Segment Value",
  [CATALOG_SEGMENT_VALUE_MOBILE_PURCHASE_ROAS]:
    "Catalog Segment Mobile Purchase ROAS",
  [CATALOG_SEGMENT_VALUE_OMNI_PURCHASE_ROAS]:
    "Catalog Segment Omni-Channel Purchase ROAS",
  [CATALOG_SEGMENT_VALUE_WEBSITE_PURCHASE_ROAS]:
    "Catalog Segment Website Purchase ROAS",
  [CONVERSION_VALUES]: "Conversion Values",
  [CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE]:
    "Converted Product Mobile App Purchases",
  [CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE]:
    "Converted Product Mobile App Purchase Value",
  [CONVERTED_PRODUCT_OFFLINE_PURCHASE]: "Converted Product Offline Purchases",
  [CONVERTED_PRODUCT_OFFLINE_PURCHASE_VALUE]:
    "Converted Product Offline Purchase Value",
  [CONVERTED_PRODUCT_OMNI_PURCHASE]: "Converted Product Omni-Channel Purchases",
  [CONVERTED_PRODUCT_OMNI_PURCHASE_VALUES]:
    "Converted Product Omni-Channel Purchase Values",
  [CONVERTED_PRODUCT_QUANTITY]: "Converted Product Quantity",
  [CONVERTED_PRODUCT_VALUE]: "Converted Product Value",
  [CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE]:
    "Converted Product Website Purchases",
  [CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE]:
    "Converted Product Website Purchase Value",
  [CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE]:
    "Converted Promoted Product Mobile App Purchases",
  [CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE]:
    "Converted Promoted Product Mobile App Purchase Value",
  [CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE]:
    "Converted Promoted Product Offline Purchases",
  [CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE_VALUE]:
    "Converted Promoted Product Offline Purchase Value",
  [CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE]:
    "Converted Promoted Product Omni-Channel Purchases",
  [CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE_VALUES]:
    "Converted Promoted Product Omni-Channel Purchase Values",
  [CONVERTED_PROMOTED_PRODUCT_QUANTITY]: "Converted Promoted Product Quantity",
  [CONVERTED_PROMOTED_PRODUCT_VALUE]: "Converted Promoted Product Value",
  [CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE]:
    "Converted Promoted Product Website Purchases",
  [CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE]:
    "Converted Promoted Product Website Purchase Value",
  [COST_PER_15SEC_VIDEO_VIEW]: "Cost per 15-Second Video View",
  [COST_PER_15_SEC_VIDEO_VIEW]: "Cost per 15-Second Video View",
  [COST_PER_2SEC_CONTINUOUS_VIDEO_VIEW]:
    "Cost per 2-Second Continuous Video View",
  [COST_PER_ACTION_TYPE]: "Cost per Action Type",
  [COST_PER_AD_CLICK]: "Cost per Ad Click",
  [COST_PER_DDA_COUNT_BY_CONVS]: "Cost per DDA Count by Conversions",
  [COST_PER_ESTIMATED_AD_RECALLERS]: "Cost per Estimated Ad Recallers",
  [COST_PER_INLINE_LINK_CLICK]: "Cost per Inline Link Click",
  [COST_PER_INLINE_POST_ENGAGEMENT]: "Cost per Inline Post Engagement",
  [COST_PER_OBJECTIVE_RESULT]: "Cost per Objective Result",
  [COST_PER_ONE_THOUSAND_AD_IMPRESSION]: "Cost per Thousand Ad Impressions",
  [COST_PER_OUTBOUND_CLICK]: "Cost per Outbound Click",
  [COST_PER_RESULT]: "Cost per Result",
  [COST_PER_THRUPLAY]: "Cost per ThruPlay",
  [COST_PER_UNIQUE_ACTION_TYPE]: "Cost per Unique Action Type",
  [COST_PER_UNIQUE_CLICK]: "Cost per Unique Click",
  [COST_PER_UNIQUE_CONVERSION]: "Cost per Unique Conversion",
  [COST_PER_UNIQUE_INLINE_LINK_CLICK]: "Cost per Unique Inline Link Click",
  [COST_PER_UNIQUE_OUTBOUND_CLICK]: "Cost per Unique Outbound Click",
  [CPP]: "Cost per 1,000 People Reached",
  [DDA_COUNT_BY_CONVS]: "DDA Count by Conversions",
  [DDA_RESULTS]: "DDA Results",
  [ESTIMATED_AD_RECALLERS]: "Estimated Ad Recallers",
  [INSTAGRAM_PROFILE_FOLLOW]: "Instagram Follows",
  [FULL_VIEW_IMPRESSIONS]: "Full View Impressions",
  [FULL_VIEW_REACH]: "Full View Reach",
  [INLINE_LINK_CLICK_CTR]: "Inline Link Click CTR",
  [INLINE_LINK_CLICKS]: "Inline Link Clicks",
  [INLINE_POST_ENGAGEMENT]: "Inline Post Engagement",
  [INSTANT_EXPERIENCE_CLICKS_TO_OPEN]: "Instant Experience Clicks to Open",
  [INSTANT_EXPERIENCE_CLICKS_TO_START]: "Instant Experience Clicks to Start",
  [INSTANT_EXPERIENCE_OUTBOUND_CLICKS]: "Instant Experience Outbound Clicks",
  [INTERACTIVE_COMPONENT_TAP]: "Interactive Component Taps",
  [LANDING_PAGE_VIEW_PER_LINK_CLICK]: "Landing Page Views per Link Click",
  [MARKETING_MESSAGES_DELIVERY_RATE]: "Marketing Messages Delivery Rate",
  [OBJECTIVE_RESULT_RATE]: "Objective Result Rate",
  [OBJECTIVE_RESULTS]: "Objective Results",
  [OUTBOUND_CLICKS]: "Outbound Clicks",
  [OUTBOUND_CLICKS_CTR]: "Outbound Clicks CTR",
  [PURCHASE_PER_LANDING_PAGE_VIEW]: "Purchases per Landing Page View",
  [QUALIFYING_QUESTION_QUALIFY_ANSWER_RATE]: "Qualifying Question Answer Rate",
  [RESULT_RATE]: "Result Rate",
  [RESULTS_METRICS]: "Results",
  [ROAS_METRICS]: "ROAS",
  [SHOPS_ASSISTED_PURCHASES]: "Shops Assisted Purchases",
  [SOCIAL_SPEND]: "Social Spend",
  [TOTAL_CARD_VIEW]: "Total Card Views",
  [VIDEO_30SEC_WATCHED_ACTIONS]: "30-Second Video Views",
  [VIDEO_30_SEC_WATCHED_ACTIONS]: "30-Second Video Views",
  [VIDEO_AVG_TIME_WATCHED_ACTIONS]: "Average Video Watch Time",
  [VIDEO_CONTINUOUS_2SEC_WATCHED_ACTIONS]: "2-Second Continuous Video Views",
  [VIDEO_P100_WATCHED_ACTIONS]: "Video Watches at 100%",
  [VIDEO_P25_WATCHED_ACTIONS]: "Video Watches at 25%",
  [VIDEO_P50_WATCHED_ACTIONS]: "Video Watches at 50%",
  [VIDEO_P75_WATCHED_ACTIONS]: "Video Watches at 75%",
  [VIDEO_P95_WATCHED_ACTIONS]: "Video Watches at 95%",
  [VIDEO_PLAY_ACTIONS]: "Video Plays",
  [VIDEO_PLAY_CURVE_ACTIONS]: "Video Play Curve Actions",
  [VIDEO_PLAY_RETENTION_0_TO_15S_ACTIONS]: "Video Retention 0-15s",
  [VIDEO_PLAY_RETENTION_20_TO_60S_ACTIONS]: "Video Retention 20-60s",
  [VIDEO_PLAY_RETENTION_GRAPH_ACTIONS]: "Video Retention Graph",
  [VIDEO_TIME_WATCHED_ACTIONS]: "Video Time Watched",
  [WEBSITE_CTR]: "Website CTR",
  [WEBSITE_PURCHASE_ROAS]: "Website Purchase ROAS",
  [VIDEO_HOOK_RATE]: "Video Hook Rate",
  [VIDEO_RETENTION_RATE]: "Video Retention Rate",

  /*SPECIFICS METRICS TIKTOK*/
  [BILLED_COST]: "Billed Cost",
  [GROSS_IMPRESSIONS]: "Gross Impressions",
  [CONVERSION_RATE_TIKTOK]: "Conversion Rate",
  [RESULT_RATE_TIKTOK]: "Result Rate",
  [VIDEO_VIEWS_P100_TIKTOK]: "Video Views at 100%",
  [AVERAGE_VIDEO_PLAY]: "Average Video Play",
  [ENGAGEMENT_RATE_TIKTOK]: "Engagement Rate",
  [FOLLOWS_TIKTOK]: "Follows",
  [LIKES_TIKTOK]: "Likes",
  [COMMENTS_TIKTOK]: "Comments",
  [SHARES_TIKTOK]: "Shares",
  [PROFILE_VISITS_TIKTOK]: "Profile Visits",
  [COMMENTS_LINKEDIN]: "Comments",
  [COMPANY_PAGE_CLICKS_LINKEDIN]: "Company Page Clicks",
  [EXTERNAL_WEBSITE_CONVERSIONS_LINKEDIN]: "External Website Conversions",
  [FOLLOWS_LINKEDIN]: "Follows",
  [FULL_SCREEN_PLAYS_LINKEDIN]: "Full Screen Plays",
  [LANDING_PAGE_CLICKS_LINKEDIN]: "Landing Page Clicks",
  [LIKES_LINKEDIN]: "Likes",
  [REACTIONS_LINKEDIN]: "Reactions",
  [RETURN_ON_AD_SPEND_LINKEDIN]: "Return on Ad Spend",
  [SHARES_LINKEDIN]: "Shares",
  [TOTAL_ENGAGEMENTS_LINKEDIN]: "Total Engagements",
  [VIDEO_COMPLETIONS_LINKEDIN]: "Video Completions",
  [VIDEO_STARTS_LINKEDIN]: "Video Starts",
  [VIDEO_VIEWS_LINKEDIN]: "Video Views",
  [ONE_CLICK_LEADS_LINKEDIN]: "Leads",
  [ONE_CLICK_LEAD_FORM_OPENS_LINKEDIN]: "Lead Form Opens",
  [LEAD_FORM_COMPLETION_RATE_LINKEDIN]: "Lead Form Completion Rate",
  [VALID_WORK_EMAIL_LEADS_LINKEDIN]: "Work Email Leads",
  [DOWNLOAD_CLICKS_LINKEDIN]: "Download Clicks",
  [DOCUMENT_FIRST_QUARTILE_COMPLETIONS_LINKEDIN]: "Document 25%",
  [DOCUMENT_MIDPOINT_COMPLETIONS_LINKEDIN]: "Document 50%",
  [DOCUMENT_THIRD_QUARTILE_COMPLETIONS_LINKEDIN]: "Document 75%",
  [DOCUMENT_COMPLETIONS_LINKEDIN]: "Document 100%",
  [LIVE_VIEWS]: "Live Views",
  [APP_INSTALL_TIKTOK]: "App Installs",
  [COST_PER_APP_INSTALL_TIKTOK]: "Cost per App Install",
  [REGISTRATION]: "Registrations",
  [COST_PER_REGISTRATION]: "Cost per Registration",
  [PURCHASE_TIKTOK]: "Purchases",
  [COST_PER_PURCHASE_TIKTOK]: "Cost per Purchase",
  [PURCHASE_RATE]: "Purchase Rate",
  [TOTAL_PURCHASE_VALUE]: "Total Purchase Value",
  [APP_EVENT_ADD_TO_CART_TIKTOK]: "Add to Cart Events",
  [COST_PER_APP_EVENT_ADD_TO_CART_TIKTOK]: "Cost per Add to Cart Event",
  [CHECKOUT_TIKTOK]: "Checkouts",
  [COST_PER_CHECKOUT_TIKTOK]: "Cost per Checkout",
  [VIEW_CONTENT_TIKTOK]: "View Content",
  [COST_PER_VIEW_CONTENT_TIKTOK]: "Cost per View Content",
  [NEXT_DAY_OPEN]: "Next Day Opens",
  [DAY7_RETENTION]: "7-Day Retention",
  [CASH_SPEND]: "Cash Spend",
  [VOUCHER_SPEND]: "Voucher Spend",
  [COST_PER_1000_REACHED]: "Cost per 1,000 Reached",
  [CONVERSION_RATE_V2]: "Conversion Rate V2",
  [REAL_TIME_CONVERSION]: "Real-Time Conversions",
  [REAL_TIME_COST_PER_CONVERSION]: "Real-Time Cost per Conversion",
  [REAL_TIME_CONVERSION_RATE]: "Real-Time Conversion Rate",
  [REAL_TIME_CONVERSION_RATE_V2]: "Real-Time Conversion Rate V2",
  [REAL_TIME_RESULT]: "Real-Time Results",
  [REAL_TIME_COST_PER_RESULT]: "Real-Time Cost per Result",
  [REAL_TIME_RESULT_RATE]: "Real-Time Result Rate",
  [SECONDARY_GOAL_RESULT]: "Secondary Goal Results",
  [COST_PER_SECONDARY_GOAL_RESULT]: "Cost per Secondary Goal Result",
  [SECONDARY_GOAL_RESULT_RATE]: "Secondary Goal Result Rate",
  [VIDEO_PLAY_ACTIONS_TIKTOK]: "Video Play Actions",
  [VIDEO_WATCHED_2S]: "2s Video Views",
  [VIDEO_WATCHED_6S]: "6s Video Views",
  [VIDEO_VIEWS_P25]: "Video Views at 25%",
  [VIDEO_VIEWS_P50]: "Video Views at 50%",
  [VIDEO_VIEWS_P75]: "Video Views at 75%",
  [AVERAGE_VIDEO_PLAY_PER_USER]: "Average Video Play per User",
  [PAID_ENGAGED_VIEW]: "Paid Engaged Views",
  [PAID_ENGAGEMENT_ENGAGED_VIEW]: "Paid Engagement Engaged Views",
  [ENGAGED_VIEW_15S]: "15s Engaged Views",
  [PAID_ENGAGED_VIEW_15S]: "Paid 15s Engaged Views",
  [PAID_ENGAGEMENT_ENGAGED_VIEW_15S]: "Paid Engagement 15s Engaged Views",
  [CLICKS_ON_MUSIC_DISC]: "Clicks on Music Disc",
  [DUET_CLICKS]: "Duet Clicks",
  [STITCH_CLICKS]: "Stitch Clicks",
  [SOUND_USAGE_CLICKS]: "Sound Usage Clicks",
  [MUSIC_UPLOAD_TITLE]: "Background Music",
  [MUSIC_UPLOAD_BUTTON]: "Upload Music",
  [MUSIC_REMOVE_BUTTON]: "Remove Music",
  [MUSIC_UPLOAD_DESCRIPTION]: "Upload an MP3 music file for your ad",
  [ANCHOR_CLICKS]: "Anchor Clicks",
  [ANCHOR_CLICK_RATE]: "Anchor Click Rate",
  [CLICKS_ON_HASHTAG_CHALLENGE]: "Clicks on Hashtag Challenge",
  [PROFILE_VISITS_RATE]: "Profile Visit Rate",
  [TT_PLAYLIST_VISIT]: "Playlist Visits",
  [TT_PLAYLIST_VISIT_RATE]: "Playlist Visit Rate",
  [LIVE_UNIQUE_VIEWS]: "Live Unique Views",
  [LIVE_EFFECTIVE_VIEWS]: "Live Effective Views",
  [LIVE_PRODUCT_CLICKS]: "Live Product Clicks",
  [INTERACTIVE_ADD_ON_IMPRESSIONS]: "Interactive Add-On Impressions",
  [INTERACTIVE_ADD_ON_DESTINATION_CLICKS]:
    "Interactive Add-On Destination Clicks",
  [INTERACTIVE_ADD_ON_ACTIVITY_CLICKS]: "Interactive Add-On Activity Clicks",
  [INTERACTIVE_ADD_ON_OPTION_A_CLICKS]: "Interactive Add-On Option A Clicks",
  [INTERACTIVE_ADD_ON_OPTION_B_CLICKS]: "Interactive Add-On Option B Clicks",
  [COUNTDOWN_STICKER_RECALL_CLICKS]: "Countdown Sticker Recall Clicks",
  [IX_PAGE_DURATION_AVG]: "Average IX Page Duration",
  [IX_PAGE_VIEWRATE_AVG]: "Average IX Page View Rate",
  [IX_VIDEO_VIEWS]: "IX Video Views",
  [IX_VIDEO_VIEWS_P25]: "IX Video Views at 25%",
  [IX_VIDEO_VIEWS_P50]: "IX Video Views at 50%",
  [IX_VIDEO_VIEWS_P75]: "IX Video Views at 75%",
  [IX_VIDEO_VIEWS_P100]: "IX Video Views at 100%",
  [IX_AVERAGE_VIDEO_PLAY]: "IX Average Video Play",
  [REAL_TIME_APP_INSTALL]: "Real-Time App Installs",
  [REAL_TIME_APP_INSTALL_COST]: "Real-Time App Install Cost",
  [REGISTRATION_RATE]: "Registration Rate",
  [TOTAL_REGISTRATION]: "Total Registrations",
  [COST_PER_TOTAL_REGISTRATION]: "Cost per Total Registration",
  [TOTAL_PURCHASE]: "Total Purchases",
  [COST_PER_TOTAL_PURCHASE]: "Cost per Total Purchase",
  [VALUE_PER_TOTAL_PURCHASE]: "Value per Total Purchase",
  [TOTAL_ACTIVE_PAY_ROAS]: "Total Active Pay ROAS",
  [TOTAL_PURCHASE_ROAS_DAY0]: "Day 0 Total Purchase ROAS",
  [TOTAL_PURCHASE_ROAS_DAY2]: "Day 2 Total Purchase ROAS",
  [TOTAL_PURCHASE_ROAS_DAY6]: "Day 6 Total Purchase ROAS",
  [TOTAL_PURCHASE_VALUE_DAY0]: "Day 0 Total Purchase Value",
  [TOTAL_PURCHASE_VALUE_DAY2]: "Day 2 Total Purchase Value",
  [TOTAL_PURCHASE_VALUE_DAY6]: "Day 6 Total Purchase Value",
  [APP_EVENT_ADD_TO_CART_RATE]: "Add to Cart Rate",
  [TOTAL_APP_EVENT_ADD_TO_CART]: "Total Add to Cart Events",
  [COST_PER_TOTAL_APP_EVENT_ADD_TO_CART]: "Cost per Total Add to Cart Events",
  [VALUE_PER_TOTAL_APP_EVENT_ADD_TO_CART]: "Value per Total Add to Cart Events",
  [TOTAL_APP_EVENT_ADD_TO_CART_VALUE]: "Total Add to Cart Value",
  [CHECKOUT_RATE]: "Checkout Rate",
  [TOTAL_CHECKOUT]: "Total Checkouts",
  [COST_PER_TOTAL_CHECKOUT]: "Cost per Total Checkout",
  [VALUE_PER_CHECKOUT]: "Value per Checkout",
  [TOTAL_CHECKOUT_VALUE]: "Total Checkout Value",
  [VIEW_CONTENT_RATE]: "View Content Rate",
  [TOTAL_VIEW_CONTENT]: "Total View Content",
  [COST_PER_TOTAL_VIEW_CONTENT]: "Cost per Total View Content",
  [VALUE_PER_TOTAL_VIEW_CONTENT]: "Value per Total View Content",
  [TOTAL_VIEW_CONTENT_VALUE]: "Total View Content Value",
  [COST_PER_NEXT_DAY_OPEN]: "Cost per Next Day Open",
  [NEXT_DAY_OPEN_RATE]: "Next Day Open Rate",
  [TOTAL_NEXT_DAY_OPEN]: "Total Next Day Opens",
  [COST_PER_TOTAL_NEXT_DAY_OPEN]: "Cost per Total Next Day Open",
  [COST_PER_DAY7_RETENTION]: "Cost per 7-Day Retention",
  [DAY7_RETENTION_RATE]: "7-Day Retention Rate",
  [TOTAL_DAY7_RETENTION]: "Total 7-Day Retention",
  [COST_PER_TOTAL_DAY7_RETENTION]: "Cost per Total 7-Day Retention",
  [VALUE_PER_TOTAL_DAY7_RETENTION]: "Value per Total 7-Day Retention",
  [TOTAL_DAY7_RETENTION_VALUE]: "Total 7-Day Retention Value",
  [ADD_PAYMENT_INFO]: "Add Payment Info",
  [COST_PER_ADD_PAYMENT_INFO]: "Cost per Add Payment Info",
  [ADD_PAYMENT_INFO_RATE]: "Add Payment Info Rate",
  [TOTAL_ADD_PAYMENT_INFO]: "Total Add Payment Info",
  [COST_TOTAL_ADD_PAYMENT_INFO]: "Total Cost Add Payment Info",
  [ADD_TO_WISHLIST]: "Add to Wishlist",
  [COST_PER_ADD_TO_WISHLIST]: "Cost per Add to Wishlist",
  [ADD_TO_WISHLIST_RATE]: "Add to Wishlist Rate",
  [TOTAL_ADD_TO_WISHLIST]: "Total Add to Wishlist",
  [COST_PER_TOTAL_ADD_TO_WISHLIST]: "Cost per Total Add to Wishlist",
  [VALUE_PER_TOTAL_ADD_TO_WISHLIST]: "Value per Total Add to Wishlist",
  [TOTAL_ADD_TO_WISHLIST_VALUE]: "Total Add to Wishlist Value",
  [LAUNCH_APP]: "Launch App",
  [COST_PER_LAUNCH_APP]: "Cost per Launch App",
  [LAUNCH_APP_RATE]: "Launch App Rate",
  [TOTAL_LAUNCH_APP]: "Total Launch App",
  [COST_PER_TOTAL_LAUNCH_APP]: "Cost per Total Launch App",
  [COMPLETE_TUTORIAL]: "Complete Tutorial",
  [COST_PER_COMPLETE_TUTORIAL]: "Cost per Complete Tutorial",
  [COMPLETE_TUTORIAL_RATE]: "Complete Tutorial Rate",
  [TOTAL_COMPLETE_TUTORIAL]: "Total Complete Tutorial",
  [COST_PER_TOTAL_COMPLETE_TUTORIAL]: "Cost per Total Complete Tutorial",
  [VALUE_PER_TOTAL_COMPLETE_TUTORIAL]: "Value per Total Complete Tutorial",
  [TOTAL_COMPLETE_TUTORIAL_VALUE]: "Total Complete Tutorial Value",
  [CREATE_GROUP]: "Create Group",
  [COST_PER_CREATE_GROUP]: "Cost per Create Group",
  [CREATE_GROUP_RATE]: "Create Group Rate",
  [TOTAL_CREATE_GROUP]: "Total Create Group",
  [COST_PER_TOTAL_CREATE_GROUP]: "Cost per Total Create Group",
  [VALUE_PER_TOTAL_CREATE_GROUP]: "Value per Total Create Group",
  [TOTAL_CREATE_GROUP_VALUE]: "Total Create Group Value",
  [JOIN_GROUP]: "Join Group",
  [COST_PER_JOIN_GROUP]: "Cost per Join Group",
  [JOIN_GROUP_RATE]: "Join Group Rate",
  [TOTAL_JOIN_GROUP]: "Total Join Group",
  [COST_PER_TOTAL_JOIN_GROUP]: "Cost per Total Join Group",
  [VALUE_PER_TOTAL_JOIN_GROUP]: "Value per Total Join Group",
  [TOTAL_JOIN_GROUP_VALUE]: "Total Join Group Value",
  [CREATE_GAMEROLE]: "Create Game Role",
  [COST_PER_CREATE_GAMEROLE]: "Cost per Create Game Role",
  [CREATE_GAMEROLE_RATE]: "Create Game Role Rate",
  [TOTAL_CREATE_GAMEROLE]: "Total Create Game Role",
  [COST_PER_TOTAL_CREATE_GAMEROLE]: "Cost per Total Create Game Role",
  [VALUE_PER_TOTAL_CREATE_GAMEROLE]: "Value per Total Create Game Role",
  [TOTAL_CREATE_GAMEROLE_VALUE]: "Total Create Game Role Value",
  [SPEND_CREDITS]: "Spend Credits",
  [COST_PER_SPEND_CREDITS]: "Cost per Spend Credits",
  [SPEND_CREDITS_RATE]: "Spend Credits Rate",
  [TOTAL_SPEND_CREDITS]: "Total Spend Credits",
  [COST_PER_TOTAL_SPEND_CREDITS]: "Cost per Total Spend Credits",
  [VALUE_PER_TOTAL_SPEND_CREDITS]: "Value per Total Spend Credits",
  [TOTAL_SPEND_CREDITS_VALUE]: "Total Spend Credits Value",
  [ACHIEVE_LEVEL]: "Achieve Level",
  [COST_PER_ACHIEVE_LEVEL]: "Cost per Achieve Level",
  [ACHIEVE_LEVEL_RATE]: "Achieve Level Rate",
  [TOTAL_ACHIEVE_LEVEL]: "Total Achieve Level",
  [COST_PER_TOTAL_ACHIEVE_LEVEL]: "Cost per Total Achieve Level",
  [VALUE_PER_TOTAL_ACHIEVE_LEVEL]: "Value per Total Achieve Level",
  [TOTAL_ACHIEVE_LEVEL_VALUE]: "Total Achieve Level Value",
  [UNLOCK_ACHIEVEMENT]: "Unlock Achievement",
  [COST_PER_UNLOCK_ACHIEVEMENT]: "Cost per Unlock Achievement",
  [UNLOCK_ACHIEVEMENT_RATE]: "Unlock Achievement Rate",
  [TOTAL_UNLOCK_ACHIEVEMENT]: "Total Unlock Achievement",
  [COST_PER_TOTAL_UNLOCK_ACHIEVEMENT]: "Cost per Total Unlock Achievement",
  [VALUE_PER_TOTAL_UNLOCK_ACHIEVEMENT]: "Value per Total Unlock Achievement",
  [TOTAL_UNLOCK_ACHIEVEMENT_VALUE]: "Total Unlock Achievement Value",
  [SALES_LEAD]: "Sales Lead",
  [COST_PER_SALES_LEAD]: "Cost per Sales Lead",
  [SALES_LEAD_RATE]: "Sales Lead Rate",
  [TOTAL_SALES_LEAD]: "Total Sales Lead",
  [COST_PER_TOTAL_SALES_LEAD]: "Cost per Total Sales Lead",
  [VALUE_PER_TOTAL_SALES_LEAD]: "Value per Total Sales Lead",
  [TOTAL_SALES_LEAD_VALUE]: "Total Sales Lead Value",
  [IN_APP_AD_CLICK]: "In-App Ad Click",
  [COST_PER_IN_APP_AD_CLICK]: "Cost per In-App Ad Click",
  [IN_APP_AD_CLICK_RATE]: "In-App Ad Click Rate",

  [TOTAL_IN_APP_AD_CLICK]: "Total In-App Ad Click",
  [COST_PER_TOTAL_IN_APP_AD_CLICK]: "Cost per Total In-App Ad Click",
  [VALUE_PER_TOTAL_IN_APP_AD_CLICK]: "Value per Total In-App Ad Click",
  [TOTAL_IN_APP_AD_CLICK_VALUE]: "Total In-App Ad Click Value",
  [IN_APP_AD_IMPR]: "In-App Ad Impression",
  [COST_PER_IN_APP_AD_IMPR]: "Cost per In-App Ad Impression",
  [IN_APP_AD_IMPR_RATE]: "In-App Ad Impression Rate",
  [TOTAL_IN_APP_AD_IMPR]: "Total In-App Ad Impression",
  [COST_PER_TOTAL_IN_APP_AD_IMPR]: "Cost per Total In-App Ad Impression",
  [VALUE_PER_TOTAL_IN_APP_AD_IMPR]: "Value per Total In-App Ad Impression",
  [TOTAL_IN_APP_AD_IMPR_VALUE]: "Total In-App Ad Impression Value",
  [LOAN_APPLY]: "Loan Apply",
  [COST_PER_LOAN_APPLY]: "Cost per Loan Apply",
  [LOAN_APPLY_RATE]: "Loan Apply Rate",
  [TOTAL_LOAN_APPLY]: "Total Loan Apply",
  [COST_PER_TOTAL_LOAN_APPLY]: "Cost per Total Loan Apply",
  [LOAN_CREDIT]: "Loan Credit",
  [COST_PER_LOAN_CREDIT]: "Cost per Loan Credit",
  [LOAN_CREDIT_RATE]: "Loan Credit Rate",
  [TOTAL_LOAN_CREDIT]: "Total Loan Credit",
  [COST_PER_TOTAL_LOAN_CREDIT]: "Cost per Total Loan Credit",
  [LOAN_DISBURSEMENT]: "Loan Disbursement",
  [COST_PER_LOAN_DISBURSEMENT]: "Cost per Loan Disbursement",
  [LOAN_DISBURSEMENT_RATE]: "Loan Disbursement Rate",
  [TOTAL_LOAN_DISBURSEMENT]: "Total Loan Disbursement",
  [COST_PER_TOTAL_LOAN_DISBURSEMENT]: "Cost per Total Loan Disbursement",
  [LOGIN]: "Login",
  [COST_PER_LOGIN]: "Cost per Login",
  [LOGIN_RATE]: "Login Rate",
  [TOTAL_LOGIN]: "Total Login",
  [COST_PER_TOTAL_LOGIN]: "Cost per Total Login",
  [RATINGS]: "Ratings",
  [GALLERY_VIEW_SCORES]: "See Scores",
  [GALLERY_CREATE_CAMPAIGN_LEAVE_FLOW_TITLE]: "Leave current flow?",
  [GALLERY_CREATE_CAMPAIGN_LEAVE_FLOW_DESCRIPTION]:
    "You will leave the current screen and open campaign creation with the selected content. Unsaved changes may be lost.",
  [GALLERY_SELECTED_COUNT_SINGULAR]: "Selected",
  [GALLERY_SELECTED_COUNT_PLURAL]: "Selected",
  [GALLERY_FOLDERS_ALL]: "All",
  [GALLERY_FOLDERS_CREATE_TITLE]: "Create Folder",
  [GALLERY_FOLDERS_NAME]: "Folder Name",
  [GALLERY_FOLDERS_DUPLICATE]: "A folder with this name already exists",
  [GALLERY_FOLDERS_CREATE_SUCCESS]: "Folder Created",
  [GALLERY_FOLDERS_MOVE_SUCCESS]: "Content moved to the selected folder",
  [GALLERY_FOLDERS_CREATE_ERROR]: "The folder could not be created",
  [GALLERY_FOLDERS_MOVE_ERROR]: "The content could not be moved",
  [GALLERY_FOLDERS_BAR_ARIA_LABEL]: "Gallery folder navigation",
  [GALLERY_FOLDERS_NEW_INLINE]: "New folder",
  [GALLERY_UPLOAD_FOLDER_EMPTY]:
    "The folder has no valid files. Allowed formats: {{value}}.",
  [GALLERY_FOLDERS_UNASSIGN_SUCCESS]: "Content removed from folder",
  [GALLERY_FOLDERS_UNASSIGN_ERROR]:
    "The content could not be removed from the folder",
  [GALLERY_FOLDERS_CREATE_IN]: "Create folder in",
  [GALLERY_FOLDERS_MOVE]: "Move to Folder",
  [GALLERY_FOLDERS_MOVE_TITLE]: "Move to Folder",
  [GALLERY_FOLDERS_MOVE_DESCRIPTION]: "Moving from: {{folder}}",
  [GALLERY_FOLDERS_DESTINATION]: "Destination folder",
  [GALLERY_FOLDERS_SELECT]: "Select folder",
  [GALLERY_FOLDERS_DESTINATION_PATH]: "Will be saved in: {{path}}",
  [GALLERY_FOLDERS_RENAME_TITLE]: "Rename Folder",
  [GALLERY_FOLDERS_RENAME_SUCCESS]: "Folder Renamed",
  [GALLERY_FOLDERS_RENAME_ERROR]: "The folder could not be renamed",
  [GALLERY_FOLDERS_RENAME_ARIA_LABEL]: "Rename folder {{name}}",
  [GALLERY_FOLDERS_DELETE_ARIA_LABEL]: "Delete Folder {{name}}",
  [GALLERY_FOLDERS_DELETE_TITLE]: "Delete Folder?",
  [GALLERY_FOLDERS_DELETE_TEXT]:
    'The folder "{{name}}" will be deleted. Its items will not be deleted, they will just be removed from the folder.',
  [GALLERY_FOLDERS_DELETE_SUCCESS]: "Folder Deleted",
  [GALLERY_FOLDERS_DELETE_ERROR]: "The folder could not be deleted",
  [GALLERY_FOLDERS_REMOVE_FROM_FOLDER]: "Remove from Folder",
  [GALLERY_FOLDERS_REMOVE_FROM_FOLDER_TITLE]: "Remove from Folder?",
  [GALLERY_FOLDERS_REMOVE_FROM_FOLDER_TEXT]:
    "This item will no longer belong to this folder, but it will not be deleted.",
  [GALLERY_FILTER_APPROVAL_STATUS]: "Approval Status",
  [CAMPAIGNS_FOLDER_EMPTY]: "There are no campaigns in this folder",
  [CAMPAIGNS_MOVE_SELECTED]: "Move selected",
  [CAMPAIGNS_FOLDERS_MOVE]: "Move Campaigns to Folder",
  [CAMPAIGNS_FOLDERS_MOVE_TITLE]: "Move Campaigns to Folder",
  [CAMPAIGNS_FOLDERS_MOVE_DESCRIPTION]: "Moving campaigns from: {{folder}}",
  [CAMPAIGNS_FOLDERS_MOVE_SUCCESS]: "Campaigns moved to the selected folder",
  [CAMPAIGNS_FOLDERS_MOVE_ERROR]: "The campaigns could not be moved",
  [CAMPAIGNS_FOLDERS_UNASSIGN_SUCCESS]: "Campaigns removed from the folder",
  [CAMPAIGNS_FOLDERS_UNASSIGN_ERROR]:
    "The campaigns could not be removed from the folder",
  [CAMPAIGNS_SELECT_ROW]: "Select campaign",
  [COST_PER_RATINGS]: "Cost per Ratings",
  [RATINGS_RATE]: "Ratings Rate",
  [TOTAL_RATINGS]: "Total Ratings",
  [COST_PER_TOTAL_RATINGS]: "Cost per Total Ratings",
  [VALUE_PER_TOTAL_RATINGS]: "Value per Total Ratings",
  [TOTAL_RATINGS_VALUE]: "Total Ratings Value",
  [SEARCH_TIKTOK]: "Search",
  [COST_PER_SEARCH]: "Cost per Search",
  [SEARCH_RATE]: "Search Rate",
  [TOTAL_SEARCH]: "Total Search",
  [COST_PER_TOTAL_SEARCH]: "Cost per Total Search",
  [START_TRIAL]: "Start Trial",
  [COST_PER_START_TRIAL]: "Cost per Start Trial",
  [START_TRIAL_RATE]: "Start Trial Rate",
  [TOTAL_START_TRIAL]: "Total Start Trial",
  [COST_PER_TOTAL_START_TRIAL]: "Cost per Total Start Trial",
  [SUBSCRIBE]: "Subscribe",
  [COST_PER_SUBSCRIBE]: "Cost per Subscribe",
  [SUBSCRIBE_RATE]: "Subscribe Rate",
  [TOTAL_SUBSCRIBE]: "Total Subscribe",
  [COST_PER_TOTAL_SUBSCRIBE]: "Cost per Total Subscribe",
  [VALUE_PER_TOTAL_SUBSCRIBE]: "Value per Total Subscribe",
  [TOTAL_SUBSCRIBE_VALUE]: "Total Subscribe Value",
  [UNIQUE_CUSTOM_APP_EVENTS]: "Unique Custom App Events",
  [COST_PER_UNIQUE_CUSTOM_APP_EVENT]: "Cost per Unique Custom App Event",
  [CUSTOM_APP_EVENT_RATE]: "Custom App Event Rate",
  [CUSTOM_APP_EVENTS]: "Custom App Events",
  [COST_PER_CUSTOM_APP_EVENT]: "Cost per Custom App Event",
  [VALUE_PER_CUSTOM_APP_EVENT]: "Value per Custom App Event",
  [CUSTOM_APP_EVENTS_VALUE]: "Custom App Events Value",
  [UNIQUE_AD_IMPRESSION_EVENTS]: "Unique Ad Impression Events",
  [COST_PER_UNIQUE_AD_IMPRESSION_EVENT]: "Cost per Unique Ad Impression Event",
  [CUSTOMIZED_AD_IMPRESSION_EVENT_RATE]: "Customized Ad Impression Event Rate",
  [ADS_IMPRESSION_EVENTS]: "Ads Impression Events",
  [COST_PRE_AD_IMPRESSION_EVENT]: "Cost per Ad Impression Event",
  [VALUE_PER_AD_IMPRESSION_EVENT]: "Value per Ad Impression Event",
  [TOTAL_AD_IMPRESSION_EVENTS_VALUE]: "Total Ad Impression Events Value",
  [TOTAL_AD_IMPRESSION_ROAS]: "Total Ad Impression ROAS",
  [AD_IMPRESSION_AD_REVENUE_ROAS_DAY0]: "Ad Impression Ad Revenue ROAS Day 0",
  [AD_IMPRESSION_AD_REVENUE_ROAS_DAY2]: "Ad Impression Ad Revenue ROAS Day 2",
  [AD_IMPRESSION_AD_REVENUE_ROAS_DAY6]: "Ad Impression Ad Revenue ROAS Day 6",
  [AD_IMPRESSION_AD_REVENUE_DAY0]: "Ad Impression Ad Revenue Day 0",
  [AD_IMPRESSION_AD_REVENUE_DAY2]: "Ad Impression Ad Revenue Day 2",
  [AD_IMPRESSION_AD_REVENUE_DAY6]: "Ad Impression Ad Revenue Day 6",
  [COMPLETE_PAYMENT_ROAS]: "Complete Payment ROAS",
  [COMPLETE_PAYMENT]: "Complete Payment",
  [COST_PER_COMPLETE_PAYMENT]: "Cost per Complete Payment",
  [COMPLETE_PAYMENT_RATE]: "Complete Payment Rate",
  [VALUE_PER_COMPLETE_PAYMENT]: "Value per Complete Payment",
  [TOTAL_COMPLETE_PAYMENT_RATE]: "Total Complete Payment Rate",
  [TOTAL_LANDING_PAGE_VIEW]: "Total Landing Page View",
  [COST_PER_LANDING_PAGE_VIEW]: "Cost per Landing Page View",
  [LANDING_PAGE_VIEW_RATE]: "Landing Page View Rate",
  [TOTAL_PAGEVIEW]: "Total Pageview",
  [COST_PER_PAGEVIEW]: "Cost per Pageview",
  [PAGEVIEW_RATE]: "Pageview Rate",
  [AVG_VALUE_PER_PAGEVIEW]: "Average Value per Pageview",
  [TOTAL_VALUE_PER_PAGEVIEW]: "Total Value per Pageview",
  [PAGE_BROWSE_VIEW]: "Page Browse View",
  [COST_PER_PAGE_BROWSE_VIEW]: "Cost per Page Browse View",
  [PAGE_BROWSE_VIEW_RATE]: "Page Browse View Rate",
  [TOTAL_PAGE_BROWSE_VIEW_VALUE]: "Total Page Browse View Value",
  [VALUE_PER_PAGE_BROWSE_VIEW]: "Value per Page Browse View",
  [BUTTON_CLICK]: "Button Click",
  [COST_PER_BUTTON_CLICK]: "Cost per Button Click",
  [BUTTON_CLICK_RATE]: "Button Click Rate",
  [VALUE_PER_BUTTON_CLICK]: "Value per Button Click",
  [TOTAL_BUTTON_CLICK_VALUE]: "Total Button Click Value",
  [ONLINE_CONSULT]: "Online Consult",
  [COST_PER_ONLINE_CONSULT]: "Cost per Online Consult",
  [ONLINE_CONSULT_RATE]: "Online Consult Rate",
  [VALUE_PER_ONLINE_CONSULT]: "Value per Online Consult",
  [TOTAL_ONLINE_CONSULT_VALUE]: "Total Online Consult Value",
  [USER_REGISTRATION]: "User Registration",
  [COST_PER_USER_REGISTRATION]: "Cost per User Registration",
  [USER_REGISTRATION_RATE]: "User Registration Rate",
  [VALUE_PER_USER_REGISTRATION]: "Value per User Registration",
  [TOTAL_USER_REGISTRATION_VALUE]: "Total User Registration Value",
  [PAGE_CONTENT_VIEW_EVENTS]: "Page Content View Events",
  [COST_PER_PAGE_CONTENT_VIEW_EVENT]: "Cost per Page Content View Event",
  [PAGE_CONTENT_VIEW_EVENT_RATE]: "Page Content View Event Rate",
  [VALUE_PER_PAGE_CONTENT_VIEW_EVENT]: "Value per Page Content View Event",
  [TOTAL_PAGE_VIEW_CONTENT_EVENTS_VALUE]:
    "Total Page View Content Events Value",
  [PRODUCT_DETAILS_PAGE_BROWSE]: "Product Details Page Browse",
  [COST_PER_PRODUCT_DETAILS_PAGE_BROWSE]:
    "Cost per Product Details Page Browse",
  [PRODUCT_DETAILS_PAGE_BROWSE_RATE]: "Product Details Page Browse Rate",
  [VALUE_PER_PRODUCT_DETAILS_PAGE_BROWSE]:
    "Value per Product Details Page Browse",
  [TOTAL_PRODUCT_DETAILS_PAGE_BROWSE_VALUE]:
    "Total Product Details Page Browse Value",
  [WEB_EVENT_ADD_TO_CART]: "Web Event Add to Cart",
  [COST_PER_WEB_EVENT_ADD_TO_CART]: "Cost per Web Event Add to Cart",
  [WEB_EVENT_ADD_TO_CART_RATE]: "Web Event Add to Cart Rate",
  [VALUE_PER_WEB_EVENT_ADD_TO_CART]: "Value per Web Event Add to Cart",
  [TOTAL_WEB_EVENT_ADD_TO_CART_VALUE]: "Total Web Event Add to Cart Value",
  [ON_WEB_ORDER]: "On Web Order",
  [COST_PER_ON_WEB_ORDER]: "Cost per On Web Order",
  [ON_WEB_ORDER_RATE]: "On Web Order Rate",
  [VALUE_PER_ON_WEB_ORDER]: "Value per On Web Order",
  [TOTAL_ON_WEB_ORDER_VALUE]: "Total On Web Order Value",
  [INITIATE_CHECKOUT]: "Initiate Checkout",
  [COST_PER_INITIATE_CHECKOUT]: "Cost per Initiate Checkout",
  [INITIATE_CHECKOUT_RATE]: "Initiate Checkout Rate",
  [VALUE_PER_INITIATE_CHECKOUT]: "Value per Initiate Checkout",
  [TOTAL_INITIATE_CHECKOUT_VALUE]: "Total Initiate Checkout Value",
  [ADD_BILLING]: "Add Billing",
  [COST_PER_ADD_BILLING]: "Cost per Add Billing",
  [ADD_BILLING_RATE]: "Add Billing Rate",
  [VALUE_PER_ADD_BILLING]: "Value per Add Billing",
  [TOTAL_ADD_BILLING_VALUE]: "Total Add Billing Value",
  [PAGE_EVENT_SEARCH]: "Page Event Search",
  [COST_PER_PAGE_EVENT_SEARCH]: "Cost per Page Event Search",
  [PAGE_EVENT_SEARCH_RATE]: "Page Event Search Rate",
  [VALUE_PER_PAGE_EVENT_SEARCH]: "Value per Page Event Search",
  [TOTAL_PAGE_EVENT_SEARCH_VALUE]: "Total Page Event Search Value",
  [FORM_TIKTOK]: "Form",
  [COST_PER_FORM]: "Cost per Form",
  [FORM_RATE]: "Form Rate",
  [VALUE_PER_FORM]: "Value per Form",
  [TOTAL_FORM_VALUE]: "Total Form Value",
  [DOWNLOAD_START]: "Download Start",
  [COST_PER_DOWNLOAD_START]: "Cost per Download Start",
  [DOWNLOAD_START_RATE]: "Download Start Rate",
  [VALUE_PER_DOWNLOAD_START]: "Value per Download Start",
  [TOTAL_DOWNLOAD_START_VALUE]: "Total Download Start Value",
  [ON_WEB_ADD_TO_WISHLIST]: "On Web Add to Wishlist",
  [COST_PER_ON_WEB_ADD_TO_WISHLIST]: "Cost per On Web Add to Wishlist",
  [ON_WEB_ADD_TO_WISHLIST_PER_CLICK]: "On Web Add to Wishlist per Click",
  [VALUE_PER_ON_WEB_ADD_TO_WISHLIST]: "Value per On Web Add to Wishlist",
  [TOTAL_ON_WEB_ADD_TO_WISHLIST_VALUE]: "Total On Web Add to Wishlist Value",
  [ON_WEB_SUBSCRIBE]: "On Web Subscribe",
  [COST_PER_ON_WEB_SUBSCRIBE]: "Cost per On Web Subscribe",
  [ON_WEB_SUBSCRIBE_PER_CLICK]: "On Web Subscribe per Click",
  [VALUE_PER_ON_WEB_SUBSCRIBE]: "Value per On Web Subscribe",
  [TOTAL_ON_WEB_SUBSCRIBE_VALUE]: "Total On Web Subscribe Value",
  [WEBSITE_TOTAL_FIND_LOCATION]: "Website Total Find Location",
  [WEBSITE_COST_PER_FIND_LOCATION]: "Website Cost per Find Location",
  [WEBSITE_FIND_LOCATION_RATE]: "Website Find Location Rate",
  [WEBSITE_VALUE_PER_FIND_LOCATION]: "Website Value per Find Location",
  [WEBSITE_TOTAL_FIND_LOCATION_VALUE]: "Website Total Find Location Value",
  [WEBSITE_TOTAL_SCHEDULE]: "Website Total Schedule",
  [WEBSITE_COST_PER_SCHEDULE]: "Website Cost per Schedule",
  [WEBSITE_SCHEDULE_RATE]: "Website Schedule Rate",
  [WEBSITE_VALUE_PER_SCHEDULE]: "Website Value per Schedule",
  [WEBSITE_TOTAL_SCHEDULE_VALUE]: "Website Total Schedule Value",
  [WEBSITE_TOTAL_CUSTOMIZE_PRODUCT]: "Website Total Customize Product",
  [WEBSITE_COST_PER_CUSTOMIZE_PRODUCT]: "Website Cost per Customize Product",
  [WEBSITE_CUSTOMIZE_PRODUCT_RATE]: "Website Customize Product Rate",
  [WEBSITE_VALUE_PER_CUSTOMIZE_PRODUCT]: "Website Value per Customize Product",
  [WEBSITE_TOTAL_CUSTOMIZE_PRODUCT_VALUE]:
    "Website Total Customize Product Value",
  [CUSTOM_PAGE_EVENTS]: "Custom Page Events",
  [COST_PER_CUSTOM_PAGE_EVENT]: "Cost per Custom Page Event",
  [CUSTOM_PAGE_EVENT_RATE]: "Custom Page Event Rate",
  [VALUE_PER_CUSTOM_PAGE_EVENT]: "Value per Custom Page Event",
  [CUSTOM_PAGE_EVENTS_VALUE]: "Custom Page Events Value",
  [ONSITE_PURCHASES_ROAS]: "Onsite Purchases ROAS",
  [ONSITE_TOTAL_PURCHASE]: "Onsite Total Purchase",
  [ONSITE_COST_PER_PURCHASE]: "Onsite Cost per Purchase",
  [ONSITE_PURCHASE_RATE]: "Onsite Purchase Rate",
  [ONSITE_VALUE_PER_PURCHASE]: "Onsite Value per Purchase",
  [ONSITE_TOTAL_PURCHASE_VALUE]: "Onsite Total Purchase Value",
  [ONSITE_TOTAL_CHECKOUT_INITIATION]: "Onsite Total Checkout Initiation",
  [ONSITE_COST_PER_CHECKOUT_INITIATION]: "Onsite Cost per Checkout Initiation",
  [ONSITE_CHECKOUT_INITIATION_RATE]: "Onsite Checkout Initiation Rate",
  [ONSITE_VALUE_PER_CHECKOUT_INITIATION]:
    "Onsite Value per Checkout Initiation",
  [ONSITE_TOTAL_CHECKOUT_INITIATION_VALUE]:
    "Onsite Total Checkout Initiation Value",
  [ONSITE_TOTAL_ADD_TO_CART]: "Onsite Total Add to Cart",
  [ONSITE_COST_PER_ADD_TO_CART]: "Onsite Cost per Add to Cart",

  [ONSITE_ADD_TO_CART_RATE]: "Onsite Add to Cart Rate",
  [ONSITE_VALUE_PER_ADD_TO_CART]: "Onsite Value per Add to Cart",
  [ONSITE_TOTAL_ADD_TO_CART_VALUE]: "Onsite Total Add to Cart Value",
  [ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW]:
    "Onsite Total Product Details Page View",
  [ONSITE_COST_PER_PRODUCT_DETAILS_PAGE_VIEW]:
    "Onsite Cost per Product Details Page View",
  [ONSITE_PRODUCT_DETAILS_PAGE_VIEW_RATE]:
    "Onsite Product Details Page View Rate",
  [ONSITE_VALUE_PER_PRODUCT_DETAILS_PAGE_VIEW]:
    "Onsite Value per Product Details Page View",
  [ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW_VALUE]:
    "Onsite Total Product Details Page View Value",
  [ONSITE_ADD_TO_WISHLIST]: "Onsite Add to Wishlist",
  [COST_PER_ONSITE_ADD_TO_WISHLIST]: "Cost per Onsite Add to Wishlist",
  [ONSITE_ADD_TO_WISHLIST_RATE]: "Onsite Add to Wishlist Rate",
  [VALUE_PER_ONSITE_ADD_TO_WISHLIST]: "Value per Onsite Add to Wishlist",
  [TOTAL_ONSITE_ADD_TO_WISHLIST_VALUE]: "Total Onsite Add to Wishlist Value",
  [ONSITE_ADD_BILLING]: "Onsite Add Billing",
  [COST_PER_ONSITE_ADD_BILLING]: "Cost per Onsite Add Billing",
  [ONSITE_ADD_BILLING_RATE]: "Onsite Add Billing Rate",
  [VALUE_PER_ONSITE_ADD_BILLING]: "Value per Onsite Add Billing",
  [TOTAL_ONSITE_ADD_BILLING_VALUE]: "Total Onsite Add Billing Value",
  [ONSITE_FORM]: "Onsite Form",
  [COST_PER_ONSITE_FORM]: "Cost per Onsite Form",
  [ONSITE_FORM_RATE]: "Onsite Form Rate",
  [VALUE_PER_ONSITE_FORM]: "Value per Onsite Form",
  [TOTAL_ONSITE_FORM_VALUE]: "Total Onsite Form Value",
  [ONSITE_TOTAL_FILTERED_OUT_FORM_SUBMISSION]:
    "Onsite Total Filtered Out Form Submission",
  [ONSITE_DOWNLOAD_START]: "Onsite Download Start",
  [COST_PER_ONSITE_DOWNLOAD_START]: "Cost per Onsite Download Start",
  [ONSITE_DOWNLOAD_START_RATE]: "Onsite Download Start Rate",
  [ONSITE_DESTINATION_VISITS]: "Onsite Destination Visits",
  [COST_PER_ONSITE_DESTINATION_VISIT]: "Cost per Onsite Destination Visit",
  [ONSITE_DESTINATION_VISIT_RATE]: "Onsite Destination Visit Rate",
  [IX_PAGE_VIEW_COUNT]: "IX Page View Count",
  [COST_PER_IX_PAGE_VIEW_COUNT]: "Cost per IX Page View Count",
  [IX_PAGE_VIEW_COUNT_RATE]: "IX Page View Count Rate",
  [IX_BUTTON_CLICK_COUNT]: "IX Button Click Count",
  [COST_PER_IX_BUTTON_CLICK_COUNT]: "Cost per IX Button Click Count",
  [IX_BUTTON_CLICK_COUNT_RATE]: "IX Button Click Count Rate",
  [IX_PRODUCT_CLICK_COUNT]: "IX Product Click Count",
  [COST_PER_IX_PRODUCT_CLICK_COUNT]: "Cost per IX Product Click Count",
  [IX_PRODUCT_CLICK_COUNT_RATE]: "IX Product Click Count Rate",
  [OFFLINE_TOTAL_CRM_EVENTS]: "Offline Total CRM Events",
  [OFFLINE_COST_PER_CRM_EVENT]: "Offline Cost per CRM Event",
  [OFFLINE_CRM_EVENT_RATE]: "Offline CRM Event Rate",
  [OFFLINE_VALUE_PER_CRM_EVENT]: "Offline Value per CRM Event",
  [OFFLINE_CRM_EVENT_VALUE]: "Offline CRM Event Value",
  [OFFLINE_SHOPPING_EVENTS]: "Offline Shopping Events",
  [COST_PER_OFFLINE_SHOPPING_EVENT]: "Cost per Offline Shopping Event",
  [OFFLINE_SHOPPING_EVENT_RATE]: "Offline Shopping Event Rate",
  [VALUE_PER_OFFLINE_SHOPPING_EVENT]: "Value per Offline Shopping Event",
  [OFFLINE_SHOPPING_EVENTS_VALUE]: "Offline Shopping Events Value",
  [OFFLINE_SHOPPING_EVENTS_ROAS]: "Offline Shopping Events ROAS",
  [OFFLINE_CONTACT_EVENTS]: "Offline Contact Events",
  [COST_PER_OFFLINE_CONTACT_EVENT]: "Cost per Offline Contact Event",
  [OFFLINE_CONTACT_EVENT_RATE]: "Offline Contact Event Rate",
  [VALUE_PER_OFFLINE_CONTACT_EVENT]: "Value per Offline Contact Event",
  [OFFLINE_CONTACT_EVENTS_VALUE]: "Offline Contact Events Value",
  [OFFLINE_SUBSCRIBE_EVENTS]: "Offline Subscribe Events",
  [COST_PER_OFFLINE_SUBSCRIBE_EVENT]: "Cost per Offline Subscribe Event",
  [OFFLINE_SUBSCRIBE_EVENT_RATE]: "Offline Subscribe Event Rate",
  [VALUE_PER_OFFLINE_SUBSCRIBE_EVENT]: "Value per Offline Subscribe Event",
  [OFFLINE_SUBSCRIBE_EVENTS_VALUE]: "Offline Subscribe Events Value",
  [OFFLINE_FORM_EVENTS]: "Offline Form Events",
  [COST_PER_OFFLINE_FORM_EVENT]: "Cost per Offline Form Event",
  [OFFLINE_FORM_EVENT_RATE]: "Offline Form Event Rate",
  [VALUE_PER_OFFLINE_FORM_EVENT]: "Value per Offline Form Event",
  [OFFLINE_FORM_EVENTS_VALUE]: "Offline Form Events Value",
  [OFFLINE_ADD_PAYMENT_INFO_EVENTS]: "Offline Add Payment Info Events",
  [COST_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT]:
    "Cost per Offline Add Payment Info Event",
  [OFFLINE_ADD_PAYMENT_INFO_EVENT_RATE]: "Offline Add Payment Info Event Rate",
  [VALUE_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT]:
    "Value per Offline Add Payment Info Event",
  [OFFLINE_ADD_PAYMENT_INFO_EVENTS_VALUE]:
    "Offline Add Payment Info Events Value",
  [OFFLINE_ADD_TO_CART_EVENTS]: "Offline Add to Cart Events",
  [COST_PER_OFFLINE_ADD_TO_CART_EVENT]: "Cost per Offline Add to Cart Event",
  [OFFLINE_ADD_TO_CART_EVENT_RATE]: "Offline Add to Cart Event Rate",
  [VALUE_PER_OFFLINE_ADD_TO_CART_EVENT]: "Value per Offline Add to Cart Event",
  [OFFLINE_ADD_TO_CART_EVENTS_VALUE]: "Offline Add to Cart Events Value",
  [OFFLINE_ADD_TO_WISHLIST_EVENTS]: "Offline Add to Wishlist Events",
  [COST_PER_OFFLINE_ADD_TO_WISHLIST_EVENT]:
    "Cost per Offline Add to Wishlist Event",
  [OFFLINE_ADD_TO_WISHLIST_EVENT_RATE]: "Offline Add to Wishlist Event Rate",
  [VALUE_PER_OFFLINE_ADD_TO_WISHLIST_EVENT]:
    "Value per Offline Add to Wishlist Event",
  [OFFLINE_ADD_TO_WISHLIST_EVENTS_VALUE]:
    "Offline Add to Wishlist Events Value",
  [OFFLINE_CLICK_BUTTON_EVENTS]: "Offline Click Button Events",
  [COST_PER_OFFLINE_CLICK_BUTTON_EVENT]: "Cost per Offline Click Button Event",
  [OFFLINE_CLICK_BUTTON_EVENT_RATE]: "Offline Click Button Event Rate",
  [VALUE_PER_OFFLINE_CLICK_BUTTON_EVENT]:
    "Value per Offline Click Button Event",
  [OFFLINE_CLICK_BUTTON_EVENTS_VALUE]: "Offline Click Button Events Value",
  [OFFLINE_COMPLETE_REGISTRATION_EVENTS]:
    "Offline Complete Registration Events",
  [COST_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT]:
    "Cost per Offline Complete Registration Event",
  [OFFLINE_COMPLETE_REGISTRATION_EVENT_RATE]:
    "Offline Complete Registration Event Rate",
  [VALUE_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT]:
    "Value per Offline Complete Registration Event",
  [OFFLINE_COMPLETE_REGISTRATION_EVENTS_VALUE]:
    "Offline Complete Registration Events Value",
  [OFFLINE_DOWNLOAD_EVENTS]: "Offline Download Events",
  [COST_PER_OFFLINE_DOWNLOAD_EVENT]: "Cost per Offline Download Event",
  [OFFLINE_DOWNLOAD_EVENT_RATE]: "Offline Download Event Rate",
  [VALUE_PER_OFFLINE_DOWNLOAD_EVENT]: "Value per Offline Download Event",
  [OFFLINE_DOWNLOAD_EVENTS_VALUE]: "Offline Download Events Value",
  [OFFLINE_INITIATE_CHECKOUT_EVENTS]: "Offline Initiate Checkout Events",
  [COST_PER_OFFLINE_INITIATE_CHECKOUT_EVENT]:
    "Cost per Offline Initiate Checkout Event",
  [OFFLINE_INITIATE_CHECKOUT_EVENT_RATE]:
    "Offline Initiate Checkout Event Rate",
  [VALUE_PER_OFFLINE_INITIATE_CHECKOUT_EVENT]:
    "Value per Offline Initiate Checkout Event",
  [OFFLINE_INITIATE_CHECKOUT_EVENTS_VALUE]:
    "Offline Initiate Checkout Events Value",
  [OFFLINE_PLACE_ORDER_EVENTS]: "Offline Place Order Events",
  [COST_PER_OFFLINE_PLACE_ORDER_EVENT]: "Cost per Offline Place Order Event",
  [OFFLINE_PLACE_ORDER_EVENT_RATE]: "Offline Place Order Event Rate",
  [VALUE_PER_OFFLINE_PLACE_ORDER_EVENT]: "Value per Offline Place Order Event",
  [OFFLINE_PLACE_ORDER_EVENTS_VALUE]: "Offline Place Order Events Value",
  [OFFLINE_SEARCH_EVENTS]: "Offline Search Events",
  [COST_PER_OFFLINE_SEARCH_EVENT]: "Cost per Offline Search Event",
  [OFFLINE_SEARCH_EVENT_RATE]: "Offline Search Event Rate",
  [VALUE_PER_OFFLINE_SEARCH_EVENT]: "Value per Offline Search Event",
  [OFFLINE_SEARCH_EVENTS_VALUE]: "Offline Search Events Value",
  [OFFLINE_VIEW_CONTENT_EVENTS]: "Offline View Content Events",
  [COST_PER_OFFLINE_VIEW_CONTENT_EVENT]: "Cost per Offline View Content Event",
  [OFFLINE_VIEW_CONTENT_EVENT_RATE]: "Offline View Content Event Rate",
  [VALUE_PER_OFFLINE_VIEW_CONTENT_EVENT]:
    "Value per Offline View Content Event",
  [OFFLINE_VIEW_CONTENT_EVENTS_VALUE]: "Offline View Content Events Value",
  [OFFLINE_PREFERRED_LEADS]: "Offline Preferred Leads",
  [OFFLINE_COST_PER_PREFERRED_LEAD]: "Offline Cost per Preferred Lead",
  [OFFLINE_PREFERRED_LEAD_RATE]: "Offline Preferred Lead Rate",
  [OFFLINE_TOTAL_FIND_LOCATION]: "Offline Total Find Location",
  [OFFLINE_COST_PER_FIND_LOCATION]: "Offline Cost per Find Location",
  [OFFLINE_FIND_LOCATION_RATE]: "Offline Find Location Rate",
  [OFFLINE_VALUE_PER_FIND_LOCATION]: "Offline Value per Find Location",
  [OFFLINE_TOTAL_FIND_LOCATION_VALUE]: "Offline Total Find Location Value",
  [OFFLINE_TOTAL_SCHEDULE]: "Offline Total Schedule",
  [OFFLINE_COST_PER_SCHEDULE]: "Offline Cost per Schedule",
  [OFFLINE_SCHEDULE_RATE]: "Offline Schedule Rate",
  [OFFLINE_VALUE_PER_SCHEDULE]: "Offline Value per Schedule",
  [OFFLINE_TOTAL_SCHEDULE_VALUE]: "Offline Total Schedule Value",
  [OFFLINE_TOTAL_CUSTOMIZE_PRODUCT]: "Offline Total Customize Product",
  [OFFLINE_COST_PER_CUSTOMIZE_PRODUCT]: "Offline Cost per Customize Product",
  [OFFLINE_CUSTOMIZE_PRODUCT_RATE]: "Offline Customize Product Rate",
  [OFFLINE_VALUE_PER_CUSTOMIZE_PRODUCT]: "Offline Value per Customize Product",
  [OFFLINE_TOTAL_CUSTOMIZE_PRODUCT_VALUE]:
    "Offline Total Customize Product Value",
  [OFFLINE_TOTAL_CUSTOM_EVENTS]: "Offline Total Custom Events",
  [OFFLINE_COST_PER_CUSTOM_EVENT]: "Offline Cost per Custom Event",
  [OFFLINE_CUSTOM_EVENT_RATE]: "Offline Custom Event Rate",
  [OFFLINE_VALUE_PER_CUSTOM_EVENT]: "Offline Value per Custom Event",
  [OFFLINE_TOTAL_CUSTOM_EVENT_VALUE]: "Offline Total Custom Event Value",
  [MESSAGING_TOTAL_CONVERSATION_TIKTOK_DIRECT_MESSAGE]:
    "Messaging Total Conversation TikTok Direct Message",
  [MESSAGING_COST_PER_CONVERSATION_TIKTOK_DIRECT_MESSAGE]:
    "Messaging Cost per Conversation TikTok Direct Message",
  [MESSAGING_CONVERSATION_RATE_TIKTOK_DIRECT_MESSAGE]:
    "Messaging Conversation Rate TikTok Direct Message",
  [MESSAGING_TOTAL_CONVERSATION_INSTANT_MESSAGING_APP]:
    "Messaging Total Conversation Instant Messaging App",
  [MESSAGING_COST_PER_CONVERSATION_INSTANT_MESSAGING_APP]:
    "Messaging Cost per Conversation Instant Messaging App",
  [MESSAGING_CONVERSATION_RATE_INSTANT_MESSAGING_APP]:
    "Messaging Conversation Rate Instant Messaging App",
  [ONSITE_SHOPPING_ROAS]: "Onsite Shopping ROAS",
  [ONSITE_SHOPPING]: "Onsite Shopping",
  [COST_PER_ONSITE_SHOPPING]: "Cost per Onsite Shopping",
  [ONSITE_SHOPPING_RATE]: "Onsite Shopping Rate",
  [VALUE_PER_ONSITE_SHOPPING]: "Value per Onsite Shopping",
  [TOTAL_ONSITE_SHOPPING_VALUE]: "Total Onsite Shopping Value",
  [SHOP_TOTAL_PURCHASE_BY_ORDER_SUBMISSION]:
    "Shop Total Purchase by Order Submission",
  [SHOP_GROSS_REVENUE_BY_ORDER_SUBMISSION]:
    "Shop Gross Revenue by Order Submission",
  [SHOP_TOTAL_ITEMS_PURCHASED]: "Shop Total Items Purchased",
  [ONSITE_INITIATE_CHECKOUT_COUNT]: "Onsite Initiate Checkout Count",
  [COST_PER_ONSITE_INITIATE_CHECKOUT_COUNT]:
    "Cost per Onsite Initiate Checkout Count",
  [ONSITE_INITIATE_CHECKOUT_COUNT_RATE]: "Onsite Initiate Checkout Count Rate",
  [VALUE_PER_ONSITE_INITIATE_CHECKOUT_COUNT]:
    "Value per Onsite Initiate Checkout Count",
  [TOTAL_ONSITE_INITIATE_CHECKOUT_COUNT_VALUE]:
    "Total Onsite Initiate Checkout Count Value",
  [ONSITE_ON_WEB_DETAIL]: "Onsite On Web Detail",
  [COST_PER_ONSITE_ON_WEB_DETAIL]: "Cost per Onsite On Web Detail",
  [ONSITE_ON_WEB_DETAIL_RATE]: "Onsite On Web Detail Rate",
  [VALUE_PER_ONSITE_ON_WEB_DETAIL]: "Value per Onsite On Web Detail",
  [TOTAL_ONSITE_ON_WEB_DETAIL_VALUE]: "Total Onsite On Web Detail Value",
  [ONSITE_ON_WEB_CART]: "Onsite On Web Cart",
  [COST_PER_ONSITE_ON_WEB_CART]: "Cost per Onsite On Web Cart",
  [ONSITE_ON_WEB_CART_RATE]: "Onsite On Web Cart Rate",
  [VALUE_PER_ONSITE_ON_WEB_CART]: "Value per Onsite On Web Cart",
  [TOTAL_ONSITE_ON_WEB_CART_VALUE]: "Total Onsite On Web Cart Value",
  [VTA_CONVERSION]: "VTA Conversion",
  [COST_PER_VTA_CONVERSION]: "Cost per VTA Conversion",
  [CTA_CONVERSION]: "CTA Conversion",
  [COST_PER_CTA_CONVERSION]: "Cost per CTA Conversion",
  [ENGAGED_VIEW_THROUGH_CONVERSIONS]: "Engaged View Through Conversions",
  [COST_PER_ENGAGED_VIEW_THROUGH_CONVERSION]:
    "Cost per Engaged View Through Conversion",
  [VTA_APP_INSTALL]: "VTA App Install",
  [COST_PER_VTA_APP_INSTALL]: "Cost per VTA App Install",
  [CTA_APP_INSTALL]: "CTA App Install",
  [COST_PER_CTA_APP_INSTALL]: "Cost per CTA App Install",
  [EVTA_APP_INSTALL]: "EVTA App Install",
  [COST_PER_EVTA_APP_INSTALL]: "Cost per EVTA App Install",
  [VTA_REGISTRATION]: "VTA Registration",
  [COST_PER_VTA_REGISTRATION]: "Cost per VTA Registration",
  [CTA_REGISTRATION]: "CTA Registration",
  [COST_PER_CTA_REGISTRATION]: "Cost per CTA Registration",
  [EVTA_REGISTRATION]: "EVTA Registration",
  [COST_PER_EVTA_REGISTRATION]: "Cost per EVTA Registration",
  [VTA_PURCHASE]: "VTA Purchase",
  [COST_PER_VTA_PURCHASE]: "Cost per VTA Purchase",
  [CTA_PURCHASE]: "CTA Purchase",
  [COST_PER_CTA_PURCHASE]: "Cost per CTA Purchase",
  [EVTA_PURCHASE]: "EVTA Purchase",
  [COST_PER_EVTA_PURCHASE]: "Cost per EVTA Purchase",
  [VTA_COMPLETE_PAYMENT]: "VTA Complete Payment",
  [COST_PER_VTA_PAYMENTS_COMPLETED]: "Cost per VTA Payments Completed",
  [EVTA_PAYMENTS_COMPLETED]: "EVTA Payments Completed",
  [COST_PER_EVTA_PAYMENTS_COMPLETED]: "Cost per EVTA Payments Completed",
  [VTA_COMPLETE_PAYMENT_VALUE]: "VTA Complete Payment Value",
  [VTA_COMPLETE_PAYMENT_ROAS]: "VTA Complete Payment ROAS",

  [SKAN_RESULT]: "SKAN Result",
  [SKAN_COST_PER_RESULT]: "SKAN Cost per Result",
  [SKAN_RESULT_RATE]: "SKAN Result Rate",
  [SKAN_CONVERSION]: "SKAN Conversion",
  [SKAN_COST_PER_CONVERSION]: "SKAN Cost per Conversion",
  [SKAN_CONVERSION_RATE]: "SKAN Conversion Rate",
  [SKAN_CONVERSION_RATE_V2]: "SKAN Conversion Rate V2",
  [SKAN_CLICK_TIME_CONVERSION]: "SKAN Click Time Conversion",
  [SKAN_CLICK_TIME_COST_PER_CONVERSION]: "SKAN Click Time Cost per Conversion",
  [SKAN_CLICK_TIME_CONVERSION_RATE]: "SKAN Click Time Conversion Rate",
  [SKAN_CLICK_TIME_CONVERSION_RATE_V2]: "SKAN Click Time Conversion Rate V2",
  [SKAN_APP_INSTALL]: "SKAN App Install",
  [SKAN_COST_PER_APP_INSTALL]: "SKAN Cost per App Install",
  [SKAN_APP_INSTALL_WITHHELD]: "SKAN App Install Withheld",
  [SKAN_REGISTRATION]: "SKAN Registration",
  [SKAN_COST_PER_REGISTRATION]: "SKAN Cost per Registration",
  [SKAN_REGISTRATION_RATE]: "SKAN Registration Rate",
  [SKAN_TOTAL_REGISTRATION]: "SKAN Total Registration",
  [SKAN_COST_PER_TOTAL_REGISTRATION]: "SKAN Cost per Total Registration",
  [SKAN_PURCHASE]: "SKAN Purchase",
  [SKAN_COST_PER_PURCHASE]: "SKAN Cost per Purchase",
  [SKAN_PURCHASE_RATE]: "SKAN Purchase Rate",
  [SKAN_TOTAL_PURCHASE]: "SKAN Total Purchase",
  [SKAN_COST_PER_TOTAL_PURCHASE]: "SKAN Cost per Total Purchase",
  [SKAN_TOTAL_PURCHASE_VALUE]: "SKAN Total Purchase Value",
  [SKAN_TOTAL_REPETITIVE_ACTIVE_PAY_ROAS]:
    "SKAN Total Repetitive Active Pay ROAS",
  [SKAN_ADD_TO_CART]: "SKAN Add to Cart",
  [SKAN_COST_PER_ADD_TO_CART]: "SKAN Cost per Add to Cart",
  [SKAN_ADD_TO_CART_RATE]: "SKAN Add to Cart Rate",
  [SKAN_TOTAL_ADD_TO_CART]: "SKAN Total Add to Cart",
  [SKAN_COST_PER_TOTAL_ADD_TO_CART]: "SKAN Cost per Total Add to Cart",
  [SKAN_TOTAL_ADD_TO_CART_VALUE]: "SKAN Total Add to Cart Value",
  [SKAN_CHECKOUT]: "SKAN Checkout",
  [SKAN_COST_PER_CHECKOUT]: "SKAN Cost per Checkout",
  [SKAN_CHECKOUT_RATE]: "SKAN Checkout Rate",
  [SKAN_TOTAL_CHECKOUT]: "SKAN Total Checkout",
  [SKAN_COST_PER_TOTAL_CHECKOUT]: "SKAN Cost per Total Checkout",
  [SKAN_TOTAL_CHECKOUT_VALUE]: "SKAN Total Checkout Value",
  [SKAN_VIEW_CONTENT]: "SKAN View Content",
  [SKAN_COST_PER_VIEW_CONTENT]: "SKAN Cost per View Content",
  [SKAN_VIEW_CONTENT_RATE]: "SKAN View Content Rate",
  [SKAN_TOTAL_VIEW_CONTENT]: "SKAN Total View Content",
  [SKAN_COST_PER_TOTAL_VIEW_CONTENT]: "SKAN Cost per Total View Content",
  [SKAN_TOTAL_VIEW_CONTENT_VALUE]: "SKAN Total View Content Value",
  [SKAN_ADD_PAYMENT_INFO]: "SKAN Add Payment Info",
  [SKAN_COST_PER_ADD_PAYMENT_INFO]: "SKAN Cost per Add Payment Info",
  [SKAN_ADD_PAYMENT_INFO_RATE]: "SKAN Add Payment Info Rate",
  [SKAN_TOTAL_ADD_PAYMENT_INFO]: "SKAN Total Add Payment Info",
  [SKAN_COST_TOTAL_ADD_PAYMENT_INFO]: "SKAN Cost Total Add Payment Info",
  [SKAN_ADD_TO_WISHLIST]: "SKAN Add to Wishlist",
  [SKAN_COST_PER_ADD_TO_WISHLIST]: "SKAN Cost per Add to Wishlist",
  [SKAN_ADD_TO_WISHLIST_RATE]: "SKAN Add to Wishlist Rate",
  [SKAN_TOTAL_ADD_TO_WISHLIST]: "SKAN Total Add to Wishlist",
  [SKAN_COST_PER_TOTAL_ADD_TO_WISHLIST]: "SKAN Cost per Total Add to Wishlist",
  [SKAN_TOTAL_ADD_TO_WISHLIST_VALUE]: "SKAN Total Add to Wishlist Value",
  [SKAN_LAUNCH_APP]: "SKAN Launch App",
  [SKAN_COST_PER_LAUNCH_APP]: "SKAN Cost per Launch App",
  [SKAN_LAUNCH_APP_RATE]: "SKAN Launch App Rate",
  [SKAN_TOTAL_LAUNCH_APP]: "SKAN Total Launch App",
  [SKAN_COST_PER_TOTAL_LAUNCH_APP]: "SKAN Cost per Total Launch App",
  [SKAN_COMPLETE_TUTORIAL]: "SKAN Complete Tutorial",
  [SKAN_COST_PER_COMPLETE_TUTORIAL]: "SKAN Cost per Complete Tutorial",
  [SKAN_COMPLETE_TUTORIAL_RATE]: "SKAN Complete Tutorial Rate",
  [SKAN_TOTAL_COMPLETE_TUTORIAL]: "SKAN Total Complete Tutorial",
  [SKAN_COST_PER_TOTAL_COMPLETE_TUTORIAL]:
    "SKAN Cost per Total Complete Tutorial",
  [SKAN_TOTAL_COMPLETE_TUTORIAL_VALUE]: "SKAN Total Complete Tutorial Value",
  [SKAN_CREATE_GROUP]: "SKAN Create Group",
  [SKAN_COST_PER_CREATE_GROUP]: "SKAN Cost per Create Group",
  [SKAN_CREATE_GROUP_RATE]: "SKAN Create Group Rate",
  [SKAN_TOTAL_CREATE_GROUP]: "SKAN Total Create Group",
  [SKAN_COST_PER_TOTAL_CREATE_GROUP]: "SKAN Cost per Total Create Group",
  [SKAN_TOTAL_CREATE_GROUP_VALUE]: "SKAN Total Create Group Value",
  [SKAN_JOIN_GROUP]: "SKAN Join Group",
  [SKAN_COST_PER_JOIN_GROUP]: "SKAN Cost per Join Group",
  [SKAN_JOIN_GROUP_RATE]: "SKAN Join Group Rate",
  [SKAN_TOTAL_JOIN_GROUP]: "SKAN Total Join Group",
  [SKAN_COST_PER_TOTAL_JOIN_GROUP]: "SKAN Cost per Total Join Group",
  [SKAN_TOTAL_JOIN_GROUP_VALUE]: "SKAN Total Join Group Value",
  [SKAN_CREATE_GAMEROLE]: "SKAN Create Gamerole",
  [SKAN_COST_PER_CREATE_GAMEROLE]: "SKAN Cost per Create Gamerole",
  [SKAN_CREATE_GAMEROLE_RATE]: "SKAN Create Gamerole Rate",
  [SKAN_TOTAL_CREATE_GAMEROLE]: "SKAN Total Create Gamerole",
  [SKAN_COST_PER_TOTAL_CREATE_GAMEROLE]: "SKAN Cost per Total Create Gamerole",
  [SKAN_TOTAL_CREATE_GAMEROLE_VALUE]: "SKAN Total Create Gamerole Value",
  [SKAN_SPEND_CREDITS]: "SKAN Spend Credits",
  [SKAN_COST_PER_SPEND_CREDITS]: "SKAN Cost per Spend Credits",
  [SKAN_SPEND_CREDITS_RATE]: "SKAN Spend Credits Rate",
  [SKAN_TOTAL_SPEND_CREDITS]: "SKAN Total Spend Credits",
  [SKAN_COST_PER_TOTAL_SPEND_CREDITS]: "SKAN Cost per Total Spend Credits",
  [SKAN_TOTAL_SPEND_CREDITS_VALUE]: "SKAN Total Spend Credits Value",
  [SKAN_ACHIEVE_LEVEL]: "SKAN Achieve Level",
  [SKAN_COST_PER_ACHIEVE_LEVEL]: "SKAN Cost per Achieve Level",
  [SKAN_ACHIEVE_LEVEL_RATE]: "SKAN Achieve Level Rate",
  [SKAN_TOTAL_ACHIEVE_LEVEL]: "SKAN Total Achieve Level",
  [SKAN_COST_PER_TOTAL_ACHIEVE_LEVEL]: "SKAN Cost per Total Achieve Level",
  [SKAN_TOTAL_ACHIEVE_LEVEL_VALUE]: "SKAN Total Achieve Level Value",
  [SKAN_UNLOCK_ACHIEVEMENT]: "SKAN Unlock Achievement",
  [SKAN_COST_PER_UNLOCK_ACHIEVEMENT]: "SKAN Cost per Unlock Achievement",
  [SKAN_UNLOCK_ACHIEVEMENT_RATE]: "SKAN Unlock Achievement Rate",
  [SKAN_TOTAL_UNLOCK_ACHIEVEMENT]: "SKAN Total Unlock Achievement",
  [SKAN_COST_PER_TOTAL_UNLOCK_ACHIEVEMENT]:
    "SKAN Cost per Total Unlock Achievement",
  [SKAN_TOTAL_UNLOCK_ACHIEVEMENT_VALUE]: "SKAN Total Unlock Achievement Value",
  [SKAN_SALES_LEAD]: "SKAN Sales Lead",
  [SKAN_COST_PER_SALES_LEAD]: "SKAN Cost per Sales Lead",
  [SKAN_SALES_LEAD_RATE]: "SKAN Sales Lead Rate",
  [SKAN_TOTAL_SALES_LEAD]: "SKAN Total Sales Lead",
  [SKAN_COST_PER_TOTAL_SALES_LEAD]: "SKAN Cost per Total Sales Lead",
  [SKAN_TOTAL_SALES_LEAD_VALUE]: "SKAN Total Sales Lead Value",
  [SKAN_IN_APP_AD_CLICK]: "SKAN In App Ad Click",
  [SKAN_COST_PER_IN_APP_AD_CLICK]: "SKAN Cost per In App Ad Click",
  [SKAN_IN_APP_AD_CLICK_RATE]: "SKAN In App Ad Click Rate",
  [SKAN_TOTAL_IN_APP_AD_CLICK]: "SKAN Total In App Ad Click",
  [SKAN_COST_PER_TOTAL_IN_APP_AD_CLICK]: "SKAN Cost per Total In App Ad Click",
  [SKAN_TOTAL_IN_APP_AD_CLICK_VALUE]: "SKAN Total In App Ad Click Value",
  [SKAN_IN_APP_AD_IMPR]: "SKAN In App Ad Impression",
  [SKAN_COST_PER_IN_APP_AD_IMPR]: "SKAN Cost per In App Ad Impression",
  [SKAN_IN_APP_AD_IMPR_RATE]: "SKAN In App Ad Impression Rate",
  [SKAN_TOTAL_IN_APP_AD_IMPR]: "SKAN Total In App Ad Impression",
  [SKAN_COST_PER_TOTAL_IN_APP_AD_IMPR]:
    "SKAN Cost per Total In App Ad Impression",
  [SKAN_TOTAL_IN_APP_AD_IMPR_VALUE]: "SKAN Total In App Ad Impression Value",
  [SKAN_LOAN_APPLY]: "SKAN Loan Apply",
  [SKAN_COST_PER_LOAN_APPLY]: "SKAN Cost per Loan Apply",
  [SKAN_LOAN_APPLY_RATE]: "SKAN Loan Apply Rate",
  [SKAN_TOTAL_LOAN_APPLY]: "SKAN Total Loan Apply",
  [SKAN_COST_PER_TOTAL_LOAN_APPLY]: "SKAN Cost per Total Loan Apply",
  [SKAN_LOAN_CREDIT]: "SKAN Loan Credit",
  [SKAN_COST_PER_LOAN_CREDIT]: "SKAN Cost per Loan Credit",
  [SKAN_LOAN_CREDIT_RATE]: "SKAN Loan Credit Rate",
  [SKAN_TOTAL_LOAN_CREDIT]: "SKAN Total Loan Credit",
  [SKAN_COST_PER_TOTAL_LOAN_CREDIT]: "SKAN Cost per Total Loan Credit",
  [SKAN_LOAN_DISBURSEMENT]: "SKAN Loan Disbursement",
  [SKAN_COST_PER_LOAN_DISBURSEMENT]: "SKAN Cost per Loan Disbursement",
  [SKAN_LOAN_DISBURSEMENT_RATE]: "SKAN Loan Disbursement Rate",
  [SKAN_TOTAL_LOAN_DISBURSEMENT]: "SKAN Total Loan Disbursement",
  [SKAN_COST_PER_TOTAL_LOAN_DISBURSEMENT]:
    "SKAN Cost per Total Loan Disbursement",
  [SKAN_LOGIN]: "SKAN Login",
  [SKAN_COST_PER_LOGIN]: "SKAN Cost per Login",
  [SKAN_LOGIN_RATE]: "SKAN Login Rate",
  [SKAN_TOTAL_LOGIN]: "SKAN Total Login",
  [SKAN_COST_PER_TOTAL_LOGIN]: "SKAN Cost per Total Login",
  [SKAN_RATINGS]: "SKAN Ratings",
  [SKAN_COST_PER_RATINGS]: "SKAN Cost per Ratings",
  [SKAN_RATINGS_RATE]: "SKAN Ratings Rate",
  [SKAN_TOTAL_RATINGS]: "SKAN Total Ratings",
  [SKAN_COST_PER_TOTAL_RATINGS]: "SKAN Cost per Total Ratings",
  [SKAN_TOTAL_RATINGS_VALUE]: "SKAN Total Ratings Value",
  [SKAN_SEARCH]: "SKAN Search",
  [SKAN_COST_PER_SEARCH]: "SKAN Cost per Search",
  [SKAN_SEARCH_RATE]: "SKAN Search Rate",
  [SKAN_TOTAL_SEARCH]: "SKAN Total Search",
  [SKAN_COST_PER_TOTAL_SEARCH]: "SKAN Cost per Total Search",
  [SKAN_START_TRIAL]: "SKAN Start Trial",
  [SKAN_COST_PER_START_TRIAL]: "SKAN Cost per Start Trial",
  [SKAN_START_TRIAL_RATE]: "SKAN Start Trial Rate",
  [SKAN_TOTAL_START_TRIAL]: "SKAN Total Start Trial",
  [SKAN_COST_PER_TOTAL_START_TRIAL]: "SKAN Cost per Total Start Trial",
  [SKAN_SUBSCRIBE]: "SKAN Subscribe",
  [SKAN_COST_PER_SUBSCRIBE]: "SKAN Cost per Subscribe",
  [SKAN_SUBSCRIBE_RATE]: "SKAN Subscribe Rate",
  [SKAN_TOTAL_SUBSCRIBE]: "SKAN Total Subscribe",
  [SKAN_COST_PER_TOTAL_SUBSCRIBE]: "SKAN Cost per Total Subscribe",
  [SKAN_TOTAL_SUBSCRIBE_VALUE]: "SKAN Total Subscribe Value",
  [SKAN_VTA_CONVERSION]: "SKAN VTA Conversion",
  [SKAN_COST_PER_VTA_CONVERSION]: "SKAN Cost per VTA Conversion",
  [SKAN_VTA_APP_INSTALL]: "SKAN VTA App Install",
  [SKAN_COST_PER_VTA_APP_INSTALL]: "SKAN Cost per VTA App Install",
  [SKAN_VTA_REGISTRATION]: "SKAN VTA Registration",
  [SKAN_COST_PER_VTA_REGISTRATION]: "SKAN Cost per VTA Registration",
  [SKAN_VTA_PURCHASE]: "SKAN VTA Purchase",
  [SKAN_COST_PER_VTA_PURCHASE]: "SKAN Cost per VTA Purchase",
  [SKAN_CTA_CONVERSION]: "SKAN CTA Conversion",
  [SKAN_COST_PER_CTA_CONVERSION]: "SKAN Cost per CTA Conversion",
  [SKAN_CTA_APP_INSTALL]: "SKAN CTA App Install",
  [SKAN_COST_PER_CTA_APP_INSTALL]: "SKAN Cost per CTA App Install",
  [SKAN_CTA_REGISTRATION]: "SKAN CTA Registration",
  [SKAN_COST_PER_CTA_REGISTRATION]: "SKAN Cost per CTA Registration",
  [SKAN_CTA_PURCHASE]: "SKAN CTA Purchase",
  [SKAN_COST_PER_CTA_PURCHASE]: "SKAN Cost per CTA Purchase",

  // OVERVIEW REPORT
  [OVERVIEW_REPORT_GENERATING_SUMMARY]: "Generating summary...",
  [OVERVIEW_REPORT_SUMMARY_NOT_GENERATED]: "Failed to generate summary",

  // GENERATE PDF
  [REPORT_DATE_GENERATED]:
    "Generation Date: {{date,monthTextShort}} {{date,dayShort}}, {{date,year}}",
  [REPORT_GENERATED_BY_BUZZLY_AI]: "Report Generated by {{NAME_BUSINESS}}",
  [AI_GENERATED_SECTION_CHIP]: "Generated by {{NAME_BUSINESS}}",
  [AI_GENERATED_SECTION_CHIP_ARIA]:
    "Content generated by {{NAME_BUSINESS}} AI. Editing it removes this label.",
  [DOWNLOADING_PDF]: "Downloading PDF...",
  [PDF_DOWNLOADED_SUCCESSFULLY]: "PDF downloaded successfully",
  [OPTIMIZATION]: "Optimization",

  [CHAT_QUESTION_1]: "Has the ROAS improved compared to last week?",
  [CHAT_QUESTION_2]: "How does the average CPA compare to the previous period?",
  [CHAT_QUESTION_3]:
    "Is the budget well distributed across platforms or ad groups?",
  [CHAT_QUESTION_4]:
    "Which audiences are performing best in the current campaigns?",
  [CHAT_QUESTION_5]: "Are there any ad groups to pause or scale?",
  [CHAT_QUESTION_6]:
    "What strategic changes do you suggest to improve performance?",
  [CHAT_QUESTION_7]: "How has the CPA changed recently?",
  [CHAT_QUESTION_8]: "What's the next step in optimizing the campaigns?",
  [CHAT_QUESTION_9]:
    "Are there any alerts or negative trends we should review?",

  //RESERVATION STATUS
  [RESERVATION_STATUS_1]: "The prediction has been completed successfully.",
  [RESERVATION_STATUS_2]: "The prediction is still being generated.",
  [RESERVATION_STATUS_3]:
    "The audience cannot be reached. The reach is too broad or the budget is too high.",
  [RESERVATION_STATUS_4]:
    "The prediction settings are not valid (for example, duration).",
  [RESERVATION_STATUS_5]: "Invalid targeting_spec value.",
  [RESERVATION_STATUS_6]:
    "The budget or bid for the specified reach is too low.",
  [RESERVATION_STATUS_7]: "The ad set length is too short.",
  [RESERVATION_STATUS_8]: "The ad set length is too long.",
  [RESERVATION_STATUS_9]: "Too much time is missing for the ad set end date.",
  [RESERVATION_STATUS_10]: "Frequency cap has not been specified.",
  [RESERVATION_STATUS_11]:
    "The specified ad placement is not supported (for example, combining right-hand column and feed ad placement).",
  [RESERVATION_STATUS_12]:
    "There is an issue with the ad set dates (start or end): the start time has already passed, the specified times do not include midnight, or the dates do not span a full day. The end date has already passed, exceeds 90 days from the start date, or does not end after 6:00.",
  [RESERVATION_STATUS_13]: "The target country is not yet supported.",
  [RESERVATION_STATUS_14]: "The ad set dates include unavailable days.",
  [RESERVATION_STATUS_15]:
    "There is insufficient inventory, so reservations cannot be made. See 'Reserve predictions' for more information.",
  [RESERVATION_STATUS_16]:
    "The minimum reach required for the account has not been achieved. See 'Get account restrictions'.",
  [RESERVATION_STATUS_17]:
    "The actual reach available for this prediction is less than the minimum reach for the target country (typically 200,000 people for most countries).",
  [RESERVATION_STATUS_18]: "The dayparting schedule provided is not valid.",
  [RESERVATION_STATUS_19]: "The target CPM cannot be reached.",
  [RESERVATION_STATUS_20]:
    "The frequency cap is too low for combined delivery.",
  [RESERVATION_STATUS_21]:
    "The ad inventory has changed enough that the prediction is inaccurate.",
  [RESERVATION_STATUS_23]:
    "The frequency cap interval is not supported in the target country.",
  [RESERVATION_STATUS_24]:
    "The lift study ad set for account or campaign group exclusion is not consistent with the reservation prediction.",
  [RESERVATION_STATUS_25]:
    "The frequency cap cannot exceed the number of days your campaign is running.",
  [RESERVATION_STATUS_26]: "The selected audience is empty and cannot be used.",
  [RESERVATION_STATUS_27]:
    "Modifications to your running campaign are not allowed.",
  [RESERVATION_STATUS_28]:
    "The running campaign created with an insertion order cannot be modified.",
  [RESERVATION_STATUS_29]:
    "The running campaign cannot be modified due to time restrictions.",
  [RESERVATION_STATUS_30]:
    "To edit a reservation ad set that is running, choose a budget greater than the current spend.",
  [RESERVATION_STATUS_31]:
    "The lift study for the account or campaign group starts after the campaign begins.",
  [RESERVATION_STATUS_32]:
    "The lift study for the account or campaign group ends before the campaign ends.",
  [RESERVATION_STATUS_35]:
    "The start time for the reservation campaign cannot be set in the past.",
  [RESERVATION_STATUS_36]:
    "Ensure that the reservation ad set duration is greater than one day and that the campaign start or end time is valid.",
  [RESERVATION_STATUS_37]:
    "Audience Network does not support the objective with the reservation buying type.",
  [RESERVATION_STATUS_39]:
    "The selected placement combination cannot be used when buying with reservation.",
  [RESERVATION_STATUS_40]:
    "Certain mobile operating system versions cannot be targeted with the reservation buying type.",
  [RESERVATION_STATUS_41]:
    "Friends of connections cannot be targeted with the reservation buying type.",
  [RESERVATION_STATUS_42]:
    "Reservation campaigns cannot be published when Audience Network is the only selected placement. Select the Audience Network placement with Facebook feed or Instagram feed as additional placements.",
  [RESERVATION_STATUS_44]: "Reservation does not support Facebook Stories.",
  [RESERVATION_STATUS_45]:
    "To use Facebook Stories as a placement, also select Facebook feeds or Instagram Stories.",
  [RESERVATION_STATUS_50]:
    "The selected placement combination cannot be used when buying with reservation. For reservation insertion order purchases, ensure the objective is 'Video Views'. Otherwise, to use Facebook in-stream, select the Facebook feeds placement.",
  [RESERVATION_STATUS_53]:
    "In-stream video placement is only available for audiences in the United States, United Kingdom, Australia, New Zealand, Ireland, Thailand, Mexico, Peru, France, Germany, Argentina, Colombia, Spain, Chile, Ecuador, Dominican Republic, Guatemala, Bolivia, Honduras, El Salvador, Norway, Sweden, Netherlands, Belgium, Poland, Portugal, Denmark, India, Malaysia, Philippines, Indonesia, and Vietnam. To continue, edit the audience to include only people from those countries.",
  [RESERVATION_STATUS_60]:
    "To use Facebook Marketplace, select the Facebook feeds placement.",
  [RESERVATION_STATUS_66]:
    "Facebook right-hand column placement cannot be combined with other placements.",
  [RESERVATION_STATUS_69]:
    "If you want the ad to show in the Instagram Explore section, you will also need to select the Instagram feed as a placement.",
  [RESERVATION_STATUS_100]: "System error, not the user's fault. Retry.",

  // MODAL WELCOME
  [MODAL_WELCOME_TITLE]: "Welcome to {{NAME_BUSINESS}}",
  [MODAL_WELCOME_SUBTITLE]: "Your subscription has been successfully activated",
  [MODAL_WELCOME_PLAN_NAME]: "Plan {{planName}}",
  [MODAL_WELCOME_BUTTON]: "Configure your Brand",

  // MODAL REDIRECT BRAND SETUP
  [MODAL_REDIRECT_BRAND_SETUP_TITLE]: "Welcome to {{NAME_BUSINESS}}",
  [MODAL_REDIRECT_BRAND_SETUP_SUBTITLE]:
    "To start using {{NAME_BUSINESS}}, you need to set up your brand",
  [MODAL_REDIRECT_BRAND_SETUP_BUTTON]: "Set Up Your Brand",

  // MODAL SUCCESS BRAND SETUP
  [MODAL_SUCCESS_BRAND_SETUP_TITLE]: "Your Brand is Ready!",
  [MODAL_SUCCESS_BRAND_SETUP_SUBTITLE]: "Choose your next step",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_CAMPAIGN_TITLE]: "Launch Campaigns",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_CAMPAIGN_DESCRIPTION]:
    "Create ad campaigns with AI, including copy, creatives, and targeting for better results.",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_ADS_TITLE]: "Generate Ads",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_ADS_DESCRIPTION]:
    "Generate AI videos and images, ready to publish and aligned with your brand.",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_POST_TITLE]: "Post on Social",
  [MODAL_SUCCESS_BRAND_SETUP_OPTION_CALENDAR_DESCRIPTION]:
    "Publish your organic posts across multiple platforms instantly, or schedule them for later.",
  [MODAL_SUCCESS_BRAND_SETUP_BUTTON_START]: "Start",
  [MODAL_SUCCESS_BRAND_SETUP_BUTTON_LATER]: "I'll do it later",

  // ONBOARDING CHECKLIST
  [ONBOARDING_CHECKLIST_HEADER_TITLE]: "First Steps",
  [ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_TITLE]: "Set up your brand",
  [ONBOARDING_CHECKLIST_ITEM_CREATIVES_TITLE]: "Create your first creatives",
  [ONBOARDING_CHECKLIST_ITEM_PUBLISH_TITLE]: "Publish to your social networks",
  [ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_TITLE]: "Create your first campaign",
  [ONBOARDING_CHECKLIST_FOOTER_COMPLETED]:
    "Excellent work, you can now start creating",
  [ONBOARDING_CHECKLIST_SUBTITLE]:
    "Complete these steps to unlock all the potential.",
  [ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_DESCRIPTION]:
    "Add your brand name, logo, and colors to personalize your experience.",
  [ONBOARDING_CHECKLIST_ITEM_CREATIVES_DESCRIPTION]:
    "Design ad creatives and copy ready to publish.",
  [ONBOARDING_CHECKLIST_ITEM_PUBLISH_DESCRIPTION]:
    "Connect your social accounts and go live with your content.",
  [ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_DESCRIPTION]:
    "Launch and manage your first advertising campaign.",
  [ONBOARDING_CHECKLIST_PROGRESS_COMPLETED]:
    "{{completed}}/{{total}} Completed",
  [ONBOARDING_CHECKLIST_SKIP_GUIDE]: "Skip Guide",

  // CONNECTION PROGRESS MODAL
  [CONNECTING_TO_PLATFORM]: "How To Connect My {{platform}} Account",
  [CONNECTING_TO_PLATFORM_DESCRIPTION]:
    "Make sure you have administrator permissions on your {{platform}} account before proceeding",

  // MODAL CANCEL SUBSCRIPTION
  [MODAL_CANCEL_SUBSCRIPTION_TITLE]: "Cancel Subscription",
  [MODAL_CANCEL_SUBSCRIPTION_SUBTITLE]:
    "Your subscription stays active until the end of the current billing period. Until then, you’ll keep full access to your plan’s features and credits.",
  [MODAL_CANCEL_SUBSCRIPTION_SUBTITLE_WARNING]:
    "⚠️ When the period ends, your campaigns and all gallery content will be <bold>permanently deleted</bold>.",
  [MODAL_CANCEL_SUBSCRIPTION_CONFIRM_BUTTON]: "Cancel Plan",
  [MODAL_CANCEL_SUBSCRIPTION_REASON_TITLE]:
    "Reason for canceling (minimum {{minChars}} characters):",
  [MODAL_CANCEL_SUBSCRIPTION_REASON_PLACEHOLDER]:
    "Please briefly tell us why you’re canceling your subscription...",
  [MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT]: "✓ Minimum requirement met",
  [MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT_MIN_CHARS]:
    "{{charCount}}/{{minChars}} minimum characters",
  [MODAL_CANCEL_SUBSCRIPTION_WARNING_MESSAGE]:
    "All campaigns in {{NAME_BUSINESS}} and on connected ad platforms will be permanently deleted. Gallery content will be deleted too. This can’t be undone and you won’t be able to recover anything. Do you want to continue?",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_LIMITED_OFFER]:
    "Limited-time offer",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_TITLE]:
    "⚠️ This will delete all your work",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_INTRO]:
    "Fifteen business days after the billing period ends, the following will be <boldDanger>permanently</boldDanger> and <boldDanger>irreversibly</boldDanger> deleted:",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_CAMPAIGNS]:
    "Campaigns you manage in {{NAME_BUSINESS}} — these will be paused",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_GALLERY]:
    "All your gallery content: images, videos, carousels, animations, templates, and more",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_DATA]:
    "Your data, brand settings, audiences, and reports",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_API_CONNECTIONS]:
    "Your API connections to Meta, Google, TikTok, and LinkedIn",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_INTRO]:
    "Before <boldDanger>canceling</boldDanger>, we recommend:",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_DOWNLOAD_GALLERY]:
    "Download your gallery content — once downloaded, it’s yours to keep forever",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_EXPORT_REPORTS]:
    "Export any reports you want to keep",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_DUPLICATE_CAMPAIGNS]:
    "Duplicate any campaigns you want to keep running directly on the ad platforms",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_NO_RECOVERY]:
    "This can’t be undone. {{NAME_BUSINESS}} doesn’t keep a backup.",
  [MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_CONFIRM_PROMPT]:
    "To confirm, type <boldDanger>DELETE</boldDanger> below",
  [MODAL_CANCEL_SUBSCRIPTION_CONFIRM_WORD]: "DELETE",
  [BUTTON_KEEP_MY_ACCOUNT]: "Keep my account",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_INTRO]:
    "Keep your content and campaigns active with this limited-time offer.",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_PRICING_FROM_DATE]:
    "Starting {{date,short}}, you’ll pay {{price}} USD / month and receive {{credits}} credits.",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_PRICING_NO_DATE]:
    "You’ll pay {{price}} USD / month and receive {{credits}} credits.",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_IMMEDIATE_CREDITS]:
    "Plus, you’ll get 50 free credits right away.",
  [MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_TAKE_OFFER_BUTTON]: "Take Offer",
  [MODAL_CANCEL_SUBSCRIPTION_RETENTION_OFFER_REDEEMED_SUCCESS]:
    "Offer Redeemed",
  [BUTTON_CANCEL_PLAN_AND_DELETE_CAMPAIGNS]:
    "Cancel plan and delete everything",

  // CANCELLATION REASONS
  [CANCELLATION_REASON_SELECT_LABEL]: "Tell us why you're canceling",
  [CANCELLATION_REASON_TOO_EXPENSIVE]: "It's too expensive",
  [CANCELLATION_REASON_NOT_FREQUENT_USE]: "I don't use it often enough",
  [CANCELLATION_REASON_BETTER_ALTERNATIVE]: "I found a better alternative",
  [CANCELLATION_REASON_TECHNICAL_ISSUES]: "Technical or performance issues",
  [CANCELLATION_REASON_NOT_MEET_NEEDS]: "It doesn't meet my needs",
  [CANCELLATION_REASON_DIFFICULT_TO_USE]: "Difficulty using the platform",
  [CANCELLATION_REASON_SITUATION_CHANGED]:
    "My personal/professional situation changed",
  [CANCELLATION_REASON_TEMPORARY_NEED]: "I only needed it temporarily",
  [CANCELLATION_REASON_SECURITY_CONCERNS]: "Security or privacy concerns",
  [CANCELLATION_REASON_OTHER]: "Other reason",

  // FILTERS GALLERY
  [FILTERS_GALLERY_IMAGE]: "Images",
  [FILTERS_GALLERY_VIDEO]: "Videos",
  [FILTERS_GALLERY_CAROUSEL]: "Carousels",
  [GALLERY_CREATE_CAROUSEL]: "Create Carousel",
  [FILTERS_GALLERY_FEED]: "Instagram Feed",
  [FILTERS_GALLERY_HORIZONTAL]: "Horizontal",
  [FILTERS_GALLERY_VERTICAL]: "Vertical",
  [FILTERS_GALLERY_SQUARE]: "Square",
  [FILTERS_GALLERY_TODAY]: "Today",
  [FILTERS_GALLERY_WEEK]: "This week",
  [FILTERS_GALLERY_MONTH]: "This month",
  [FILTERS_GALLERY_YEAR]: "This year",
  [FILTERS_GALLERY_RESET_FILTERS]: "Reset filters",
  [FILTERS_GALLERY_RESULTS_COUNTER]: "{{count}} of {{total}} elements",

  // GALLERY CONTENT SOURCES
  [GALLERY_SOURCE_MY_CONTENT]: "My Content",
  [GALLERY_SOURCE_GOOGLE]: "Import from Google",
  [GALLERY_SOURCE_AD_ACCOUNT]: "Import from Ad Account",
  [GALLERY_SOURCE_AD_ACCOUNT_EMPTY]:
    "Select a platform and ad account to browse creative assets",
  [GALLERY_SOURCE_GOOGLE_DRIVE]: "Import from Google Drive",
  [GALLERY_SOURCE_SOCIAL_POSTS]: "Import from Social Networks",
  [GALLERY_SOCIAL_POSTS_DESCRIPTION]:
    "Select the post you want to use. Some posts may not appear if they were published recently",
  [GALLERY_VIDEO_THUMBNAIL_FALLBACK_TOOLTIP]:
    "This post is a video. The video preview could not be loaded, so the thumbnail is shown instead. If you use it, the ad will still be published as a video.",
  [GALLERY_SOURCE_CANVA]: "Import from Canva",
  [GALLERY_SELECT_SOURCE]: "Content",
  [GALLERY_ASSETS_TITLE]: "Assets",
  [GALLERY_ASSETS_RENAME_TITLE]: "Rename Asset",
  [GALLERY_ASSETS_RENAME_SUCCESS]: "Asset Renamed",
  [GALLERY_ASSETS_RENAME_ERROR]: "The asset could not be renamed",
  [GALLERY_ASSETS_RENAME_ARIA_LABEL]: "Rename Asset {{name}}",
  [GALLERY_ASSETS_NAME_LABEL]: "File Name",
  [GALLERY_UPLOADING_ASSETS]: "Uploading Assets",
  [GALLERY_GOOGLE_NOT_CONNECTED]:
    "Connect your Google account to access Google assets",
  [GALLERY_META_NOT_CONNECTED]:
    "Connect your Meta account to access social posts",
  [GALLERY_CONTENT_TYPE]: "Content Type",
  [GALLERY_DIMENSIONS]: "Dimensions",
  [GALLERY_DATE_RANGE]: "Date range",
  [GALLERY_TITLE_DIMENSIONS]: "{{width}} × {{height}}",

  // CAROUSEL IMAGES MANAGER
  [CAROUSEL_IMAGES_MANAGER_TITLE]: "Images ({{count}}/35)",
  [CAROUSEL_IMAGES_MANAGER_DELETE_ALL]: "Delete All",
  [CAROUSEL_IMAGES_MANAGER_ADD_IMAGE]: "Add Image",
  [CAROUSEL_IMAGES_MANAGER_NO_IMAGES]: "No images added",
  [CAROUSEL_IMAGES_MANAGER_DIMENSIONS_HELP]:
    "Required dimensions: 1200x628, 640x640, or 720x1280 pixels",

  // MODAL SHARE INSTAGRAM
  [MODAL_SHARE_TITLE]: "Share Content",
  [MODAL_SHARE_SELECT_PLATFORMS_TITLE]:
    "Select platforms where you want to publish",
  [ALERT_SHARE_INSTAGRAM_ERROR]: "Error Publishing This Content",
  [ALERT_SHARE_SUCCESS]: "Content published Successfully",
  [ALERT_SHARE_SCHEDULED_SUCCESS]: "The publication was scheduled successfully",
  [BUTTON_SHARE_MEDIA]: "Publish",
  [BUTTON_SHARE_LOADING]: "Publishing...",
  [BUTTON_SCHEDULE_MEDIA]: "Schedule Post",
  [BUTTON_SCHEDULING_MEDIA]: "Scheduling...",
  [BUTTON_PUBLISH_NOW]: "Publish Now",
  [SCHEDULE_DATE_MIN_FUTURE_ERROR]:
    "Date must be at least 5 minutes in the future",
  [SUGGESTED_PUBLISH_SCHEDULE_LOADING]: "Suggesting Schedule",
  [DESCRIPTION_INSTAGRAM_LABEL]: "Description",
  [DESCRIPTION_INSTAGRAM_GENERATING]: "Generating Description",
  [TYPE_CONTENT_INSTAGRAM_LABEL]: "Type of Content",
  [INSTAGRAM_COLLABORATORS_LABEL]: "Collaborators",
  [INSTAGRAM_COLLABORATORS_PLACEHOLDER]: "Add collaborators (max 3)",
  [INSTAGRAM_COLLABORATORS_HELPER]: "Enter Instagram usernames without @",
  [IMAGE_NO_CONTENT_TO_SHOW]: "No content to show",
  [NO_SUPPORTED_FILE]: "No supported file",

  // MODAL CANVA IMAGE CONFIG
  [MODAL_CANVA_IMAGE_CONFIG_CONTENT_TYPE_LABEL]: "Type of Content",

  // MAP TRADUCCIONES
  [MAP_TRADUCCIONES_STATUS]: "Status",
  [MAP_TRADUCCIONES_PLATFORM]: "Platform",
  [MAP_TRADUCCIONES_TITLES]: "Titles",
  [MAP_TRADUCCIONES_CTA]: "CTA",
  [MAP_TRADUCCIONES_CTAS]: "CTAs",
  [MAP_TRADUCCIONES_CTA_ID]: "CTA ID",
  [MAP_TRADUCCIONES_CALL_TO_ACTION]: "CTA",
  [MAP_TRADUCCIONES_CALL_TO_ACTIONS]: "CTAs",
  [MAP_TRADUCCIONES_CALL_TO_ACTION_ID]: "CTA ID",
  [CAMPAIGN_SYNCING_STATUS]: "Syncing",
  [MAP_TRADUCCIONES_MEDIA_URLS]: "Media URLs",
  [MAP_TRADUCCIONES_MEDIA_DATA]: "Media Data",
  [MAP_TRADUCCIONES_MUSIC_URL]: "Music URL",
  [MAP_TRADUCCIONES_IS_CAROUSEL]: "Is Carousel",
  [MAP_TRADUCCIONES_OBJECTIVE]: "Objective",
  [MAP_TRADUCCIONES_INTEGRATION_ID]: "Integration ID",
  [MAP_TRADUCCIONES_AD_ACCOUNT_ID]: "Ad Account ID",
  [MAP_TRADUCCIONES_PAGE_ID]: "Page ID",
  [MAP_TRADUCCIONES_INSTAGRAM_ID]: "Instagram ID",
  [MAP_TRADUCCIONES_USE_CAMPAIGN_BUDGET]: "Use Campaign Budget",
  [MAP_TRADUCCIONES_TYPE_BUDGET]: "Type Budget",
  [MAP_TRADUCCIONES_BUDGET]: "Budget",
  [MAP_TRADUCCIONES_IS_CATALOG_CAMPAIGN]: "Is Catalog Campaign",
  [MAP_TRADUCCIONES_WHATSAPP_BUSINESS_NUMBER]: "WhatsApp Business Number",
  [MAP_TRADUCCIONES_MESSAGE_TEMPLATE]: "Message Template",
  [MAP_TRADUCCIONES_INSTANT_FORM]: "Instant Form",
  [MAP_TRADUCCIONES_TRACKING_ID]: "Tracking ID",
  [MAP_TRADUCCIONES_TRACKING_CUSTOM_EVENT_ID]: "Tracking Custom Event ID",
  [MAP_TRADUCCIONES_CATALOG_ID]: "Catalog ID",
  [MAP_TRADUCCIONES_IS_IOS14_CAMPAIGN]: "Is iOS 14 Campaign",
  [MAP_TRADUCCIONES_APP_ID]: "App ID",
  [MAP_TRADUCCIONES_BUYING_TYPE]: "Buying Type",
  [MAP_TRADUCCIONES_DESCRIPTIONS]: "Descriptions",
  [MAP_TRADUCCIONES_ADS]: "Ads",
  [MAP_TRADUCCIONES_KEYWORDS]: "Keywords",
  [MAP_TRADUCCIONES_KEYWORDS_NEGATIVE]: "Negative Keywords",
  [MAP_TRADUCCIONES_START_DATE]: "Start Date",
  [MAP_TRADUCCIONES_END_DATE]: "End Date",
  [MAP_TRADUCCIONES_AGE_RANGE]: "Age Range",
  [MAP_TRADUCCIONES_GENDERS]: "Genders",
  [MAP_TRADUCCIONES_LOCATIONS]: "Locations",
  [MAP_TRADUCCIONES_INTERESTS]: "Interests",
  [MAP_TRADUCCIONES_BEHAVIORS]: "Behaviors",
  [MAP_TRADUCCIONES_CUSTOM_AUDIENCES]: "Custom Audiences",
  [MAP_TRADUCCIONES_EXCLUDED_CUSTOM_AUDIENCES]: "Excluded Custom Audiences",
  [MAP_TRADUCCIONES_BID_GOAL]: "Bid Goal",
  [MAP_TRADUCCIONES_OPTIMIZATION_GOAL]: "Optimize For",
  [MAP_TRADUCCIONES_IDENTITY_TIKTOK_ID]: "Identity TikTok ID",
  [MAP_TRADUCCIONES_TYPE]: "Type",
  [MAP_TRADUCCIONES_ID]: "ID",
  [MAP_TRADUCCIONES_DESTINATION_URL]: "Destination URL",
  [MAP_TRADUCCIONES_BUSINESS_NAME]: "Business Name",
  [MAP_TRADUCCIONES_LOGO_URLS]: "Logo URLs",
  [MAP_TRADUCCIONES_IMAGE_URLS]: "Image URLs",
  [MAP_TRADUCCIONES_VIDEO_URLS]: "Video URLs",
  [MAP_TRADUCCIONES_LONG_HEADLINES]: "Long Headlines",
  [MAP_TRADUCCIONES_SEARCH_THEMES]: "Search Themes",

  // MAP STATUS
  [MAP_STATUS_ACTIVE]: "Active",
  [MAP_STATUS_DEACTIVATED]: "Deactivated",

  [BUTTON_OPTIMIZE_CAMPAIGN]: "Insights",
  [BUTTON_OPTIMIZE_CAMPAIGN_MESSAGE]:
    "What recommendations can you give me to improve my campaign?",

  [ADD_CHANGES]: "Will be added:",
  [UPDATE_CHANGES]: "Will be updated:",
  [REMOVE_CHANGES]: "Will be removed:",

  [OVERVIEW_HOME_STATISTICS]: "Overview",
  [KPI_TARGET_CPA_ABOVE_PLATFORM]:
    "<bold>{{platform}}</bold> has a CPA of {{cpa}} {{currency}} over the last 14 days, above the target of {{targetCpa}} {{currency}}.",
  [KPI_TARGET_CPA_ALERTS_TITLE]: "Warning",
  [OVERVIEW_HOME_STATISTICS_VIEW_MORE]: "See more",
  [STATISTICS_ONLY_BUZZLY_CAMPAIGNS]:
    "Only campaigns created in {{NAME_BUSINESS}} are counted. Campaigns created outside the platform will not be taken into account.",
  [VIEW_SPEND_BREAKDOWN]: "View by Platform",
  [LIST_TABLE_CAMPAIGNS_TITLE]: "Your Campaigns",
  [DASHBOARD_METRICS_DELAY_WARNING]:
    "There may be a delay of up to 3 hours between the metrics you see in each platform's ad managers and those shown in {{NAME_BUSINESS}}.",
  [DASHBOARD_METRICS_DELAY_DISMISS]: "Don't show again",
  [TRIAL_CONTENT_CTA_MESSAGE]:
    "Did you like this content? Use it in any of these options:",
  [TRIAL_CONTENT_CTA_BUTTON_SHARE_INSTAGRAM]: "Share on Instagram",
  [TRIAL_CONTENT_CTA_BUTTON_SHARE_TIKTOK]: "Share on TikTok",
  [TRIAL_CONTENT_CTA_BUTTON_MORE_OPTIONS]: "More Options",

  // MODAL CREATE WITH AI
  [MODAL_CREATE_WITH_IA_TITLE]: "Generate Creatives",
  [MODAL_CREATE_WITH_IA_SUBTITLE]: "Configuration",
  [MODAL_CREATE_WITH_IA_GENERATED_CREATIVES]: "Generated Creatives",
  [MODAL_CREATE_WITH_IA_UPLOAD_IMAGE]: "Upload Image",
  [MODAL_CREATE_WITH_IA_ADD_URL]: "Add URL",
  [MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_EMPTY]:
    "No additional assets configured. Add them in Brand Setup.",
  [MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_SUBTITLE]:
    "Select the additional assets you want to use as reference to generate your creatives.",
  [MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_TOGGLE_ARIA]:
    "Include asset {{number}} in generation",
  [MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_PREVIEW_ARIA]:
    "Preview asset {{number}} image",
  [MODAL_CREATE_WITH_IA_EXTRACT_URL]: "Import from URL",
  [MODAL_CREATE_WITH_IA_IMPORT_PHOTOS_URL_HINT]:
    "You can also import images once a URL is added above.",
  [MODAL_CREATE_WITH_IA_DESCRIPTION]: "Description",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_BASIC]: "Basic Configuration",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE]: "Reference Images",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_TITLE_PRODUCTS]:
    "Product photos",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_TITLE_SERVICES]:
    "Service images",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS]:
    "Add images of your product for the AI to use as visual references.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES]:
    "Add images that represent your service for the AI to use as visual references.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS_URL]:
    "Optional. The AI uses this link for product details such as name, price, and offers. It works with or without photos.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS_UPLOAD]:
    "Optional. Add photos by uploading them, from the gallery, or from the product URL. They work with or without a link.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES_URL]:
    "Optional. The AI uses this link for service details such as name, price, and offers. It works with or without images.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES_UPLOAD]:
    "Optional. Add images by uploading them, from the gallery, or from the service URL. They work with or without a link.",
  [MODAL_CREATE_WITH_IA_REFERENCE_AD_TITLE]: "Reference Ad",
  [MODAL_CREATE_WITH_IA_REFERENCE_AD_STYLE_GUIDE_CHIP]: "Style",
  [MODAL_CREATE_WITH_IA_REFERENCE_AD_SOURCE_LOCAL]: "Upload",
  [MODAL_CREATE_WITH_IA_REFERENCE_AD_SOURCE_SEARCH]: "Competitors",
  [MODAL_CREATE_WITH_IA_REFERENCE_IMAGE_ASSETS_CHIP]: "Assets",
  [MODAL_CREATE_WITH_IA_REFERENCE_AD_DESCRIPTION]:
    "Upload a reference ad to copy its layout. Brand colors will be applied to that layout.",
  [MODAL_CREATE_WITH_IA_REFERENCE_VIDEO_FORCES_CUSTOM]:
    "With a reference video selected, the video type must be custom",
  [MODAL_CREATE_WITH_IA_PHYSICAL_NO_REFERENCE_IMAGES_DESCRIPTION]:
    "Do you want to generate the content without uploading product reference images?",
  [MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_REQUIRED_TITLE]:
    "Logo required for videos",
  [MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_REQUIRED_DESCRIPTION]:
    "Upload your brand's logo to generate the video.",
  [MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_OPTIONAL_DESCRIPTION]:
    "Optional: upload your logo to include it in the final ad closing. Without a logo, the closing will use headline and CTA only.",
  [MODAL_CREATE_WITH_IA_MAX_IMAGES_MESSAGE]:
    "Limit of {{maxImages}} reference images",
  [CONFIGURATION_PANEL_TITLE_IMAGE_PHYSICAL_PRODUCT]: "Product Images",
  [CONFIGURATION_PANEL_SUBTITLE_IMAGE_PHYSICAL_PRODUCT]:
    "Upload one or more images of your product that meet the requirements for the best results.",
  [CONFIGURATION_PANEL_ADD_MULTIPLE_PERSPECTIVES_TIP]:
    "Add images of the same product, in the same color and model, from different angles and perspectives for better results.",
  [CONFIGURATION_PANEL_SERVICE_WEBSITE_URL_TITLE]: "Service URL",
  [CONFIGURATION_PANEL_SERVICE_WEBSITE_URL_DESCRIPTION]:
    "Add images and content easily using your service URL.",
  [CONFIGURATION_PANEL_WEBSITE_URL_TITLE]: "Product URL",
  [CONFIGURATION_PANEL_WEBSITE_URL_DESCRIPTION]:
    "Add images and content easily using your product URL.",
  [CONFIGURATION_PANEL_CLARIFICATION_INPUT_IMAGES]:
    "Ensure your images meet the requirements for the best results.",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENTS_TITLE]:
    "Image Requirements for Best Results",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENTS_INTRO]:
    "To achieve the highest quality and fidelity, make sure your reference image meets these requirements:",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_WARNING_DISTORTION]:
    "Products with small text and/or blurry backgrounds may have imperceptible distortions.",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_HIGH_QUALITY]:
    "High quality: Use sharp, clear images without blur or pixelation",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_PROMINENT]:
    "Prominent product: The product should be the main element (occupy at least 60-70% of the space)",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SIZE]:
    "Adequate size: The product should appear large and clear, not small or hard to distinguish",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SAME_COLOR_AND_MODEL]:
    "Single variant: All photos must show the same product, color, and model; only change the angle or framing, not the color or version.",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_COMPLETE]:
    "Complete product: The product must be fully visible, without cut parts or out of frame",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_LIGHTING]:
    "Well lit: Good lighting that allows you to see all product details",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_NO_PEOPLE]:
    "No people: so it focuses on representing the product well, not people",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_TITLE]: "Avoid:",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_LIST]:
    "Very small products, cut, blurry, or where the product is not the protagonist",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_EXAMPLES_TITLE]: "Examples:",
  [CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_PEOPLE]:
    "Avoid using images that contain people.",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_INSTRUCTIONS]: "Instructions",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_THEME]: "Theme",
  [MODAL_CREATE_WITH_IA_PROMPT_OPTIONAL]:
    "This field is optional and you can use it to add generation instructions. If none are provided, we’ll use your brand configuration.",
  [MODAL_CREATE_WITH_IA_PROMPT_THEME_OPTIONAL]:
    "Describe your video theme. For example: I want to promote the discount of up to 20% for this summer.",
  [MODAL_CREATE_WITH_IA_EMPTY_STATE_TITLE]: "Ready to create",
  [MODAL_CREATE_WITH_IA_EMPTY_STATE_SUBTITLE]:
    "Configure your preferences in the sidebar",

  // MODAL IMAGE EDIT
  [MODAL_IMAGE_EDIT_EMPTY_STATE_TITLE]: "Edit your Image",
  [MODAL_IMAGE_EDIT_EMPTY_STATE_DESCRIPTION]:
    "Describe the changes you want to make to your image. You can request improvements, style changes, color adjustments, and more.",
  [MODAL_IMAGE_EDIT_TITLE]: "Edit your Image",
  [MODAL_IMAGE_EDIT_SUBTITLE]: "Edit your images with AI",
  [MODAL_IMAGE_EDIT_PROCESSING_MESSAGE]: "Thinking",
  [MODAL_IMAGE_EDIT_ERROR_CONVERT_BASE64]: "Could not convert image to base64",
  [MODAL_IMAGE_EDIT_ERROR_EDITING]: "Error editing image",
  [MODAL_IMAGE_EDIT_ERROR_PROCESSING]: "Could not process image",
  [MODAL_IMAGE_EDIT_INPUT_PLACEHOLDER]: "Describe the changes you want...",
  [MODAL_IMAGE_EDIT_EDITING_LABEL]: "Editing",
  [MODAL_IMAGE_EDIT_LOADING_LABEL]: "Loading",
  [MODAL_IMAGE_EDIT_IMAGE_NOT_FOUND]: "Image not found",
  [MODAL_IMAGE_EDIT_START_CREATING]: "Start creating your first image",
  [MODAL_IMAGE_EDIT_IMAGE_ALT]: "Image to edit",
  [MODAL_IMAGE_EDIT_VERSION_FORMAT]: "V{{version}} - IMAGE",
  [MODAL_IMAGE_EDIT_ORIGINAL_IMAGE_LABEL]: "Original Image",
  [MODAL_IMAGE_EDIT_EDITED_IMAGE_LABEL]: "Edited Image v{{version}}",
  [MODAL_IMAGE_EDIT_SAVE_ALERT_TITLE]: "How do you want to save this image?",
  [MODAL_IMAGE_EDIT_SAVE_ALERT_DESCRIPTION]:
    "Replace the original image, or save your edits as a new version.",
  [MODAL_IMAGE_EDIT_REPLACE_BUTTON]: "Replace",

  // MODAL VIDEO EDITOR
  [MODAL_VIDEO_EDITOR_TITLE]: "Video Editor",
  [MODAL_VIDEO_EDITOR_EDIT_VIDEO]: "Edit video",
  [MODAL_VIDEO_EDITOR_ADD_VIDEO]: "Add video",
  [MODAL_VIDEO_EDITOR_ADD_IMAGE]: "Add image",
  [MODAL_VIDEO_EDITOR_ADD_AUDIO]: "Add audio",
  [MODAL_VIDEO_EDITOR_ADD_SUBTITLES]: "Add subtitles",
  [MODAL_VIDEO_EDITOR_EXPORTING]: "Exporting video...",
  [MODAL_VIDEO_EDITOR_SAVE_ERROR]: "Could not save the edited video",
  [MODAL_VIDEO_EDITOR_SPLIT_HINT]:
    "Double-click a track to split at the playhead",
  [MODAL_VIDEO_EDITOR_ARIA_LABEL]: "Video Editor",
  [MODAL_VIDEO_EDITOR_TRACK_VIDEO]: "Drag or upload content",
  [MODAL_VIDEO_EDITOR_TRACK_IMAGE]: "Add elements",
  [MODAL_VIDEO_EDITOR_TRACK_AUDIO]: "Add audio",
  [MODAL_VIDEO_EDITOR_CLIP_DURATION]: "{{count}} s",
  [MODAL_VIDEO_EDITOR_SPLIT_CLIP]: "Split",
  [MODAL_VIDEO_EDITOR_CLIP_ACTIONS]: "Clip actions",
  [MODAL_VIDEO_EDITOR_BRAND]: "Video",
  [MODAL_VIDEO_EDITOR_EMPTY_STAGE_TITLE]: "Your video will appear here",
  [MODAL_VIDEO_EDITOR_EMPTY_STAGE_HINT]: "Import a file to get started",
  [MODAL_VIDEO_EDITOR_DROP_HINT]: "or drag and drop content",
  [MODAL_VIDEO_EDITOR_PLAY]: "Play",
  [MODAL_VIDEO_EDITOR_PAUSE]: "Pause",
  [MODAL_VIDEO_EDITOR_DEFAULT_PROJECT_NAME]: "Your video project",
  [MODAL_VIDEO_EDITOR_TIMELINE_ARIA]: "Video editor timeline",
  [MODAL_VIDEO_EDITOR_TIMELINE_RESIZE]: "Resize timeline",
  [MODAL_VIDEO_EDITOR_INSERT_START]: "Start",
  [MODAL_VIDEO_EDITOR_INSERT_END]: "End",
  [MODAL_VIDEO_EDITOR_ANALYZING_SUBTITLES]: "Analyzing subtitles…",
  [MODAL_VIDEO_EDITOR_TRACK_SUBTITLE]: "Subtitles",
  [MODAL_VIDEO_EDITOR_CAPTIONS_ARIA]: "Captions",
  [MODAL_VIDEO_EDITOR_CAPTIONS_DISABLE]: "Disable",
  [MODAL_VIDEO_EDITOR_CAPTIONS_ENABLE]: "Enable",
  [MODAL_VIDEO_EDITOR_SAVE_ALERT_TITLE]: "How do you want to save this video?",
  [MODAL_VIDEO_EDITOR_SAVE_ALERT_DESCRIPTION]:
    "You can replace the original video or create a new version with your changes.",
  [MODAL_VIDEO_EDITOR_ANALYZE_SUBTITLES_ERROR]: "Could not analyze subtitles",
  [MODAL_VIDEO_EDITOR_PROPERTIES_TITLE]: "Layer Properties",
  [MODAL_VIDEO_EDITOR_PROPERTIES_EMPTY]: "Select A Layer In The Timeline",
  [MODAL_VIDEO_EDITOR_PROPERTIES_NAME]: "Name",
  [MODAL_VIDEO_EDITOR_PROPERTIES_VOLUME]: "Volume",
  [MODAL_VIDEO_EDITOR_PROPERTIES_MIXED]: "Mixed",
  [MODAL_VIDEO_EDITOR_PROPERTIES_SELECTED_COUNT]: "{{count}} Layers",
  [MODAL_VIDEO_EDITOR_PROPERTIES_POSITION]: "Position",
  [MODAL_VIDEO_EDITOR_PROPERTIES_SIZE]: "Size",
  [MODAL_VIDEO_EDITOR_PROPERTIES_X]: "X",
  [MODAL_VIDEO_EDITOR_PROPERTIES_Y]: "Y",
  [MODAL_VIDEO_EDITOR_PROPERTIES_WIDTH]: "W",
  [MODAL_VIDEO_EDITOR_PROPERTIES_HEIGHT]: "H",
  [MODAL_IMAGE_EDIT_SAVE_AS_NEW_BUTTON]: "Save as New",
  [MODAL_IMAGE_EDIT_WORK_MODE_LABEL]: "Choose how to work",
  [MODAL_IMAGE_EDIT_GENERATIVE_TITLE]: "AI Editing",
  [MODAL_IMAGE_EDIT_GENERATIVE_DESCRIPTION]: "Transform the full image",
  [MODAL_IMAGE_EDIT_LAYERS_TITLE]: "Manual Editing",
  [MODAL_IMAGE_EDIT_LAYERS_DESCRIPTION]: "Move each element separately",
  [MODAL_IMAGE_EDIT_LAYERS_BADGE_NEW]: "NEW",
  [MODAL_IMAGE_EDIT_LAYERS_EMPTY_TITLE]: "Manual Editing",
  [MODAL_IMAGE_EDIT_LAYERS_EMPTY_DESCRIPTION]:
    "Analyze the image to separate each element and edit it independently.",
  [MODAL_IMAGE_EDIT_LAYERS_ERROR_TITLE]: "Could not analyze",
  [MODAL_IMAGE_EDIT_LAYERS_ERROR_DESCRIPTION]:
    "The layers for this image could not be separated. Please try again.",
  [MODAL_IMAGE_EDIT_LAYERS_ADD]: "Add",
  [MODAL_IMAGE_EDIT_LAYERS_LIST_TITLE]: "Design Elements",
  [MODAL_IMAGE_EDIT_LAYERS_TYPE_IMAGE]: "Image",
  [MODAL_IMAGE_EDIT_LAYERS_TYPE_OBJECT]: "Object",
  [MODAL_IMAGE_EDIT_LAYERS_TYPE_TEXT]: "Text",
  [MODAL_IMAGE_EDIT_LAYERS_TYPE_LOGO]: "Logo",
  [MODAL_IMAGE_EDIT_LAYERS_BACKGROUND]: "Background",
  [MODAL_IMAGE_EDIT_LAYERS_FALLBACK_NAME]: "Layer {{index}}",
  [MODAL_IMAGE_EDIT_LAYERS_ANALYZING]: "Analyzing layers",
  [MODAL_IMAGE_EDIT_AI_LOSES_LAYERS_TITLE]: "Warning",
  [MODAL_IMAGE_EDIT_AI_LOSES_LAYERS_DESCRIPTION]:
    "If you make an AI edit, the element separation for this image will be lost because a new image will be generated.",
  [MODAL_IMAGE_EDIT_CLOSE_TITLE]: "Close the editor?",
  [MODAL_IMAGE_EDIT_CLOSE_DESCRIPTION]:
    "If you close now, unsaved changes will be lost.",
  [ANALYZE_LAYERS_EDIT_TEXT_TITLE]: "Text Layer Detection",
  [ANALYZE_LAYERS_EDIT_TEXT_DESCRIPTION]:
    "Editing text may cause inconsistent layers or lost decorations. You can re-add missing elements manually if needed.",
  [ANALYZE_LAYERS_EXTRACT_TEXT_ENABLE_BUTTON]: "Enable",
  [ANALYZE_LAYERS_EXTRACT_TEXT_DISABLE_BUTTON]: "Disable",

  [MODAL_CREATE_WITH_IA_MEDIA_TYPE_IMAGE]: "Image",
  [MODAL_CREATE_WITH_IA_MEDIA_TYPE_VIDEO]: "Video",
  [MODAL_CREATE_WITH_IA_MEDIA_TYPE_VIDEO_BETA]: "Video (Beta)",
  [MODAL_CREATE_WITH_IA_MEDIA_TYPE_CAROUSEL]: "Carousel",
  [MODAL_CREATE_WITH_IA_IMAGE_TYPE_REALISTA]: "Realistic",
  [MODAL_CREATE_WITH_IA_IMAGE_TYPE_PRODUCTO]: "Product",
  [MODAL_CREATE_WITH_IA_LANGUAGE_ES]: "Spanish",
  [MODAL_CREATE_WITH_IA_LANGUAGE_EN]: "English",
  [MODAL_CREATE_WITH_IA_LANGUAGE_FR]: "French",
  [MODAL_CREATE_WITH_IA_LANGUAGE_DE]: "German",
  [MODAL_CREATE_WITH_IA_LANGUAGE_IT]: "Italian",
  [MODAL_CREATE_WITH_IA_DIMENSION_SQUARE]: "Square (1200x1200)",
  [MODAL_CREATE_WITH_IA_DIMENSION_HORIZONTAL]: "Horizontal (1920x1080)",
  [MODAL_CREATE_WITH_IA_DIMENSION_VERTICAL]: "Vertical (1080x1920)",
  [MODAL_CREATE_WITH_IA_LABEL_MEDIA_TYPE]: "Format",
  [MODAL_CREATE_WITH_IA_LABEL_IMAGE_TYPE]: "Type",
  [MODAL_CREATE_WITH_IA_LABEL_VIDEO_TYPE]: "Video Type",
  [MODAL_CREATE_WITH_IA_LABEL_LANGUAGE]: "Language",
  [MODAL_CREATE_WITH_IA_LABEL_WITH_SUBTITLES]: "With Subtitles",
  [MODAL_CREATE_WITH_IA_LABEL_AI_WATERMARK]: "AI Watermark",
  [MODAL_CREATE_WITH_IA_AI_WATERMARK_DESCRIPTION]:
    "Some platforms require a watermark on AI-generated videos by regulation to identify them.",
  [MODAL_SUBTITLE_OPTIONS_TITLE]: "Customize your Subtitles",
  [MODAL_SUBTITLE_OPTIONS_PERSONALIZE]: "Customize Subtitles",
  [MODAL_SUBTITLE_OPTIONS_FONT_FAMILY]: "Font",
  [MODAL_SUBTITLE_OPTIONS_FONT_STYLE]: "Font Style",
  [MODAL_SUBTITLE_OPTIONS_FONT_STYLE_NORMAL]: "Normal",
  [MODAL_SUBTITLE_OPTIONS_FONT_STYLE_BOLD]: "Bold",
  [MODAL_SUBTITLE_OPTIONS_FONT_STYLE_ITALIC]: "Italic",
  [MODAL_SUBTITLE_OPTIONS_FONT_STYLE_BOLD_ITALIC]: "Bold and Italic",
  [MODAL_SUBTITLE_OPTIONS_SUBTITLE_COLOR]: "Text Color",
  [MODAL_SUBTITLE_OPTIONS_DO_HIGHLIGHT]: "Highlight Words",
  [MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_COLOR]: "Highlight Color",
  [MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE]: "Highlight Effect",
  [MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE_KARAOKE]: "Karaoke",
  [MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE_WORD]: "By Word",
  [MODAL_SUBTITLE_OPTIONS_PRESET]: "Preset",
  [MODAL_SUBTITLE_OPTIONS_PRESET_KARAOKE]: "Karaoke",
  [MODAL_SUBTITLE_OPTIONS_PRESET_HIGHLIGHT]: "Highlight",
  [MODAL_SUBTITLE_OPTIONS_PRESET_BOXED]: "Boxes",
  [MODAL_SUBTITLE_OPTIONS_BOX_COLOR]: "Box Color",
  [MODAL_SUBTITLE_OPTIONS_HAS_BACKGROUND]: "Background behind Text",
  [MODAL_SUBTITLE_OPTIONS_BACKGROUND_COLOR]: "Background Color",
  [MODAL_SUBTITLE_OPTIONS_PREVIEW_LABEL]:
    "This is how my video subtitle would look",
  [MODAL_CREATE_WITH_IA_LABEL_ACCENT]: "Accent",
  [MODAL_CREATE_WITH_IA_LABEL_LOCATION]: "Localization",
  [MODAL_CREATE_WITH_IA_LABEL_DIMENSIONS]: "Dimensions",
  [MODAL_CREATE_WITH_IA_LABEL_PLATFORM]: "Optimize For",
  [MODAL_CREATE_WITH_IA_PLATFORM_DEFAULT]: "Neutral",
  [MODAL_CREATE_WITH_IA_LABEL_CAROUSEL]: "Carousel",
  [MODAL_CREATE_WITH_IA_LABEL_NUMBER_OF_IMAGES]: "Number of Images",
  [MODAL_CREATE_WITH_IA_PLACEHOLDER_NUMBER_OF_IMAGES]: "E.g: 3",
  [MODAL_CREATE_WITH_IA_PLATFORM_META]: "Meta",
  [MODAL_CREATE_WITH_IA_PLATFORM_TIKTOK]: "TikTok",
  [MODAL_CREATE_WITH_IA_PLATFORM_GOOGLE]: "Google",
  [MODAL_CREATE_WITH_IA_PLACEHOLDER_DESCRIPTION]:
    "Generate images of models using my sandals to wear in a modern office...",
  [MODAL_CREATE_WITH_IA_PLACEHOLDER_DESCRIPTION_VIDEO]:
    "Generate a video showcasing my product in action, highlighting key features and benefits...",
  [MODAL_CREATE_WITH_IA_PLACEHOLDER_IMAGE_URL]: "Image URL...",
  [MODAL_CREATE_WITH_IA_PLACEHOLDER_WEBSITE_URL]: "Website URL...",
  [MODAL_CREATE_WITH_IA_WARNING_REFERENCE_IMAGE]:
    "To generate images, you must upload images of your product",
  [MODAL_CREATE_WITH_IA_URLS_ADDED]: "URLs added {{count}}",
  [MODAL_CREATE_WITH_IA_IMAGES_COUNT]: "Product Images {{count}}",
  [MODAL_CREATE_WITH_IA_SERVICE_IMAGES_COUNT]: "Service images {{count}}",
  [MODAL_CREATE_WITH_IA_GENERATING]: "Generating...",
  [MODAL_CREATE_WITH_IA_GENERATE_WITH_AI]: "Generate",
  [MODAL_CREATE_WITH_IA_IMAGES_CREATED]: "{{count}} creatives created",
  [MODAL_CREATE_WITH_IA_GENERATING_IMAGES]: "Generating creatives...",
  [MODAL_CREATE_WITH_IA_YOU_CAN_LEAVE_THE_PAGE]: "You can leave the page",
  [`${MODAL_CREATE_WITH_IA_GENERATIONS_IN_PROGRESS}_one`]:
    "{{count}} generation in progress",
  [MODAL_CREATE_WITH_IA_GENERATIONS_IN_PROGRESS]:
    "{{count}} generations in progress",
  [MODAL_CREATE_WITH_IA_GENERATION_FAILED]: "We couldn't generate this content",
  [MODAL_CREATE_WITH_IA_MAX_CONCURRENT_GENERATIONS]:
    "You have {{count}} generations in progress. Wait for one to finish before starting another.",
  [MODAL_CREATE_WITH_IA_ERROR_LOADING_IMAGE]: "Error loading image",
  [MODAL_CREATE_WITH_IA_GENERATED_IMAGE_ALT]: "Generated image {{index}}",
  [MODAL_CREATE_WITH_IA_SAVE_TO_GALLERY]: "Save Content ({{count}})",
  [MODAL_CREATE_WITH_IA_SAVE_TO_GALLERY_NO_COUNT]: "Save Content",
  [MODAL_CREATE_WITH_IA_SAVING_TO_GALLERY]: "Saving...",
  [MODAL_CREATE_WITH_IA_SAVED_SUCCESSFULLY]: "Content Saved",
  [MODAL_CREATE_WITH_IA_DOWNLOAD_ALL]: "Download All",
  [MODAL_CREATE_WITH_IA_MORE_VARIATIONS]: "More Variations",
  [MODAL_CREATE_WITH_IA_ARIA_LABEL]: "AI Creation Modal",
  [MODAL_CREATE_WITH_IA_CONFIGURATION_ADVANCED]: "Advanced Configuration",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_LABEL]: "Format",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_LABEL_VIDEO]: "Video format",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_HELPER]:
    "Use one of these popular formats.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NONE]: "No Format",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_WHATSAPP]: "Whatsapp Message",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_IG_STORY]: "IG Story",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_APOLOGY]: "Apology",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_NEWS]: "News",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_TEXT_POST]: "Text Post",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_COMMENT_THREAD]: "Comment Thread",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_REVIEW_CAPTURE]: "Review Screenshot",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_SEARCH_AUTOCOMPLETE]:
    "Search & Autocomplete",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_CHECKLIST]: "Checklist",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_EMAIL_CAPTURE]: "Email Screenshot",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_TEXT_POST]:
    "An opinion in post form: avatar, name, and text. A person's voice, not a logo's.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_COMMENT_THREAD]:
    "A question and several stacked replies, like a forum. Social proof from someone who doesn't know you.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_REVIEW_CAPTURE]:
    "Stars, name, and text. The strongest social proof, and the one regulators watch most.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_SEARCH_AUTOCOMPLETE]:
    "A search bar with the question your customer already asks. Your brand is the answer.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_CHECKLIST]:
    "A list with checked boxes and one unchecked: your product is what's missing.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_EMAIL_CAPTURE]:
    "An inbox with a subject line that hooks. Read in half a second.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_LOAD_ERROR]: "Formats could not be loaded.",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION]: "Explanation",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_RECOMMENDED_RATIO]:
    "For this format we recommend the {{aspectRatio}} dimensions. Change them by clicking",
  [MODAL_CREATE_WITH_IA_AD_TEMPLATE_RECOMMENDED_RATIO_ACTION]: "here",
  [MODAL_CREATE_WITH_IA_GALLERY_BUTTON]: "Open Gallery",
  [MODAL_CREATE_WITH_IA_IMPORT_META_AD_LIBRARY]: "View Competitors",
  [COMPETITOR_SCOPE_MENU_ITEM]: "Competitors",
  [COMPETITOR_SCOPE_MODAL_TITLE]: "Competitor Ads",
  [ALERT_COMPETITOR_SCOPE_TITLE]: "Set up your Brand",
  [ALERT_COMPETITOR_SCOPE_DESCRIPTION]:
    "Complete your brand setup to view your competitors' ads.",
  [ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_TITLE]: "Add your Competitors",
  [ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_DESCRIPTION]:
    "Add at least one competitor in your brand setup to view their ads.",
  [BUTTON_CONFIGURE_BRAND]: "Configure Brand",
  [BUTTON_CONFIGURE_COMPETITORS]: "Configure Competitors",
  [MODAL_COMPETITORS_CONFIRM_REFERENCE_TITLE]: "Use this ad as reference?",
  [MODAL_COMPETITORS_CONFIRM_REFERENCE_DESCRIPTION]:
    "This competitor ad will be used as a style reference for your creative.",
  [MODAL_COMPETITORS_PREPARING_REFERENCE]: "Preparing to use as reference...",
  [MODAL_COMPETITORS_SHOW_FAVORITES_ONLY]: "Show favorites only",
  [MODAL_COMPETITORS_SHOW_ALL_ADS]: "Show all ads",
  [MODAL_COMPETITORS_FAVORITES_EMPTY]: "You have no favorite ads.",
  [MODAL_COMPETITORS_SAVED_TO_FAVORITES]: "Saved to Favorites",
  [MODAL_COMPETITORS_SAVED_TO_FOLDER]: "Saved to {{folder}}",
  [MODAL_COMPETITORS_REMOVED_FROM_FOLDER]: "Removed from {{folder}}",
  [MODAL_COMPETITORS_SELECT_FOLDER_TITLE]: "Select Folder",
  [MODAL_COMPETITORS_CHANGE_LOCATION]: "Change",
  [MODAL_COMPETITORS_REMOVED_FROM_FAVORITES]: "Removed from favorites",
  [MODAL_COMPETITORS_ADD_OPTION]: "Add Competitor",
  [MODAL_COMPETITORS_EDIT_BUTTON]: "Edit Competitors",
  [MODAL_COMPETITORS_EDIT_TITLE]: "Manage Competitors",
  [MODAL_COMPETITORS_EDIT_SUBTITLE]: "Add or remove brands you want to track",
  [MODAL_COMPETITORS_EDIT_COUNT_ARIA]:
    "{{current}} of {{max}} competitors added",
  [MODAL_COMPETITORS_STRONG_SIGNAL]: "Strong signal",
  [MODAL_COMPETITORS_AD_LIBRARY_CTA_LABEL]: "CTA: {{label}}",
  [MODAL_CREATE_WITH_IA_META_AD_LIBRARY_LOADING]:
    "Loading competitor references...",
  [MODAL_GALLERY_META_AD_LIBRARY_EMPTY_CONTENT]: "No references available.",
  [MODAL_META_AD_LIBRARY_COMPETITOR_FILTER_LABEL]: "Competitor",
  [MODAL_META_AD_LIBRARY_COMPETITOR_ALL]: "All competitors",
  [MODAL_META_AD_LIBRARY_PLATFORM_ALL]: "All Platforms",
  [MODAL_META_AD_LIBRARY_DURATION_HOURS]: "{{count}} hours active",
  [MODAL_META_AD_LIBRARY_DURATION_DAYS]: "{{count}} days active",
  [MODAL_META_AD_LIBRARY_VIEW_ONLY_TOOLTIP]: "View only",
  [MODAL_META_AD_LIBRARY_LOADING_RESOLVING_COMPETITORS]:
    "Searching for your competitors...",
  [MODAL_META_AD_LIBRARY_LOADING_FETCHING_ADS]: "Analyzing their ads...",
  [MODAL_META_AD_LIBRARY_LOADING_PREPARING_GALLERY]: "Picking the winners...",
  [MODAL_CREATE_WITH_IA_CLOSE_CONFIRMATION_TITLE]: "Warning",
  [MODAL_CREATE_WITH_IA_CLOSE_CONFIRMATION_TEXT]:
    "If you leave now, the content will not be saved.",
  [MODAL_CREATE_WITH_IA_LABEL_VIDEO_DURATION_SECONDS]: "Video Duration",
  [MODAL_CREATE_WITH_IA_VIDEO_DURATION_12_SECONDS]: "12 seconds",
  [MODAL_CREATE_WITH_IA_VIDEO_DURATION_15_SECONDS]: "15 seconds",
  [MODAL_CREATE_WITH_IA_VIDEO_DURATION_20_SECONDS]: "20 seconds",
  [MODAL_CREATE_WITH_IA_VIDEO_DURATION_25_SECONDS]: "25 seconds",
  [MODAL_CREATE_WITH_IA_VIDEO_DURATION_30_SECONDS]: "30 seconds",

  // VIDEO TYPES
  [VIDEO_TYPE_UNBOXING]: "Unboxing",
  [VIDEO_TYPE_PRODUCT_SHOWCASE]: "Product showcase",
  [VIDEO_TYPE_UGC]: "UGC",
  [VIDEO_TYPE_LIFESTYLE]: "Lifestyle",
  [VIDEO_TYPE_TESTIMONIALS_REVIEWS]: "Testimonials / reviews",
  [VIDEO_TYPE_TESTIMONIAL]: "Testimonial",
  [VIDEO_TYPE_EMOTIONAL_STORYTELLING]: "Emotional storytelling",
  [VIDEO_TYPE_CASE_STUDY]: "Case study",
  [VIDEO_TYPE_CORPORATE]: "Corporate",
  [VIDEO_TYPE_SURREAL]: "Surreal",
  [VIDEO_TYPE_MEGA_CREATIVE]: "Mega Creative",
  [VIDEO_TYPE_OTHER]: "Custom",

  // ALERTS CAMPAIGNS
  [ALERT_MARKETING_OBJECTIVE_GOOGLE_NOT_SET_LABEL]:
    "Your campaign may not be generating impressions because it doesn't have a marketing objective configured. To verify, go to {{platform}} Ads Manager, find your campaign, click on the settings icon and check if there's a marketing objective set.",
  [ALERT_PIXEL_NOT_FIRED_LABEL]:
    "The pixel configured in this campaign has not registered events in the last 7 days.",
  [ALERT_CAMPAIGN_STARTED_LABEL]:
    "Your campaign has been active for more than 2 days without generating impressions, check the {{platform}} Ads Manager for more details.",
  [ALERT_CAMPAIGN_CPA_HIGH_LABEL]:
    "{{platform}} has a CPA of {{cpa}} {{currency}} over the last 14 days, above the target of {{targetCpa}} {{currency}}.",
  [ALERT_AD_ACCOUNT_STATUS_LABEL]:
    "The ad account has a warning, check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_DISABLED_LABEL]:
    "Ad account disabled, check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_UNSETTLED_LABEL]:
    "Ad account has unpaid balance, your ads may not be running.",
  [ALERT_AD_ACCOUNT_STATUS_UNSETTLED_PREPAY_LABEL]:
    "Ad account has no balance available, your ads may not be running.",
  [ALERT_AD_ACCOUNT_NO_BALANCE_LABEL]:
    "Your ad account has no balance left. Your campaigns may not be running. Check the {{platform}} Ads Manager to verify.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_RISK_REVIEW_LABEL]:
    "Ad account under review for suspicious activity, check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_SETTLEMENT_LABEL]:
    "Ad account is in the process of a pending payment, please check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_IN_GRACE_PERIOD_LABEL]:
    "Ad account is in a grace period due to a pending payment, please check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_CLOSURE_LABEL]:
    "Ad account in closure process, check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_CLOSED_LABEL]:
    "Ad account permanently closed. Only available for information purposes.",
  [ALERT_AD_ACCOUNT_STATUS_ANY_CLOSED_LABEL]:
    "Ad account has unknown closed status. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_LIMITED_LABEL]:
    "Ad account is restricted or under penalty, so ads may not be running. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_LABEL]:
    "The ad account review was rejected, so ads may not be running. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_FINAL_LABEL]:
    "The final ad account review was rejected and cannot be resubmitted. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_MODIFY_REVIEW_FAILED_LABEL]:
    "The review of the ad account changes was rejected. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_REVIEW_LABEL]:
    "Ad account is pending review, so ads may not be running. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_VERIFICATION_LABEL]:
    "Ad account is pending verification, so ads may not be running. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_MODIFY_REVIEW_LABEL]:
    "Ad account changes are pending review. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_CRM_REVIEW_LABEL]:
    "Ad account is waiting for an internal review, so ads may not be running. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_PUBLIC_AUTH_LABEL]:
    "Ad account is pending public verification of its qualifications. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_PENDING_QUALIFICATION_LABEL]:
    "Ad account qualifications have not been verified, so ads may not be running. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_CONTRACT_PENDING_LABEL]:
    "The ad account contract is not yet in effect, so ads may not be running. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_DRAFT_LABEL]:
    "Ad account is still a draft and cannot serve ads yet. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_BILLING_HOLD_LABEL]:
    "Ad account is on a billing hold because of a payment method or payment problem. Ads may not be running. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_TOTAL_BUDGET_HOLD_LABEL]:
    "The ad account reached its total budget, so ads may not be running. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_END_DATE_HOLD_LABEL]:
    "The ad account reached its end date, so ads may not be running. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_RESTRICTED_LABEL]:
    "Ad account is restricted by policy, so ads may not be running. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_INTERNAL_HOLD_LABEL]:
    "Ad account is on an internal platform hold, so ads may not be running. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_STOPPED_LABEL]:
    "Ad account is stopped and is not delivering ads. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_SUSPENDED_LABEL]:
    "Ad account is suspended, so ads may not be running. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_CANCELED_LABEL]:
    "Ad account is canceled, so ads may not be running. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_BILLING_PENDING_LABEL]:
    "Ad account billing is pending approval, so ads may not be running. Check {{platform}} Ads Manager for more details.",
  [ALERT_AD_ACCOUNT_STATUS_BILLING_CANCELLED_LABEL]:
    "Ad account billing was canceled, so ads may not be running. Check {{platform}} Ads Manager for more details.",
  [ALERT_MERCHANT_NO_ELIGIBLE_PRODUCTS_LABEL]:
    "None of your Merchant Center products have an eligible status for this campaign. Please review your product status, as this may negatively affect your campaign delivery.",
  [ALERT_MERCHANT_PRODUCTS_PARTIAL_ISSUES_LABEL]:
    "Some of your Merchant Center products do not have an eligible status for this campaign. Please review your product status, as this may negatively affect your campaign delivery.",
  [ALERT_AD_CPA_LOW_LABEL]:
    "The CPA of this ad exceeds the average CPA of its ad set by at least 30%.",
  [ALERT_AD_CPA_MEDIUM_LABEL]:
    "The CPA of this ad exceeds the average CPA of its ad set by at least 50%.",
  [ALERT_AD_CPA_HIGH_LABEL]:
    "The CPA of this ad is at least double the average CPA of its ad set.",
  [ALERT_ASSET_GROUP_CPA_LOW_LABEL]:
    "The CPA of this Asset Group exceeds the campaign's average CPA by at least 30%.",
  [ALERT_ASSET_GROUP_CPA_MEDIUM_LABEL]:
    "The CPA of this Asset Group exceeds the campaign's average CPA by at least 50%.",
  [ALERT_ASSET_GROUP_CPA_HIGH_LABEL]:
    "The CPA of this Asset Group doubles or exceeds the campaign's average CPA.",
  [ALERT_AD_GROUP_CPA_LOW_LABEL]:
    "The CPA of this ad group exceeds the campaign's average CPA by at least 30%.",
  [ALERT_AD_GROUP_CPA_MEDIUM_LABEL]:
    "The CPA of this ad group exceeds the campaign's average CPA by at least 50%.",
  [ALERT_AD_GROUP_CPA_HIGH_LABEL]:
    "The CPA of this ad group doubles or exceeds the campaign's average CPA.",
  [ALERT_AD_CPA_LOW_TABLE_LABEL]:
    "An ad CPA is at least 30% higher than its ad set's average CPA.",
  [ALERT_AD_CPA_MEDIUM_TABLE_LABEL]:
    "An ad CPA is at least 50% higher than its ad set's average CPA.",
  [ALERT_AD_CPA_HIGH_TABLE_LABEL]:
    "An ad CPA is double its ad set's average CPA.",
  [ALERT_ASSET_GROUP_CPA_LOW_TABLE_LABEL]:
    "An Asset Group CPA is at least 30% higher than the campaign's average CPA.",
  [ALERT_ASSET_GROUP_CPA_MEDIUM_TABLE_LABEL]:
    "An Asset Group CPA is at least 50% higher than the campaign's average CPA.",
  [ALERT_ASSET_GROUP_CPA_HIGH_TABLE_LABEL]:
    "An Asset Group CPA doubles or exceeds the campaign's average CPA.",
  [ALERT_AD_GROUP_CPA_LOW_TABLE_LABEL]:
    "An ad group CPA is at least 30% higher than the campaign's average CPA.",
  [ALERT_AD_GROUP_CPA_MEDIUM_TABLE_LABEL]:
    "An ad group CPA is at least 50% higher than the campaign's average CPA.",
  [ALERT_AD_GROUP_CPA_HIGH_TABLE_LABEL]:
    "An ad group CPA doubles or exceeds the campaign's average CPA.",
  [ALERT_CREATIVE_FATIGUE_MEDIUM_LABEL]:
    "This ad has medium creative fatigue. Start considering a creative refresh.",
  [ALERT_CREATIVE_FATIGUE_HIGH_LABEL]:
    "This ad has high creative fatigue. Refresh the creative to recover performance.",
  [ALERT_CREATIVE_FATIGUE_MEDIUM_TABLE_LABEL]:
    "An ad has medium creative fatigue.",
  [ALERT_CREATIVE_FATIGUE_HIGH_TABLE_LABEL]: "An ad has high creative fatigue.",

  // CARDS IN CHAT BOT
  [CARD_GENERATE_COPY]: "Generate Copy",
  [CARD_GENERATE_COPY_DESCRIPTION]: "Create persuasive texts for ads",
  [CARD_GENERATE_COPY_QUESTION]:
    "Give me suggestions to improve the texts of the ads in my campaign",
  [CARD_GET_CAMPAIGN_LEARNINGS]: "Get Campaign Insights",
  [CARD_GET_CAMPAIGN_LEARNINGS_DESCRIPTION]:
    "Know what works and what doesn't in your campaign",
  [CARD_GET_CAMPAIGN_LEARNINGS_QUESTION]:
    "What insights can you give me about my campaign?",
  [CARD_OPTIMIZE_GENERAL]: "General Recommendations",
  [CARD_OPTIMIZE_GENERAL_DESCRIPTION]:
    "Suggestions to enhance overall performance",
  [CARD_OPTIMIZE_GENERAL_QUESTION]:
    "What recommendations can you give me to improve my campaign?",
  [CARD_MANAGE_BUDGET]: "Manage Budget",
  [CARD_MANAGE_BUDGET_DESCRIPTION]: "Optimize budget distribution",
  [CARD_MANAGE_BUDGET_QUESTION]:
    "Give me suggestions to optimize my campaign budget",
  // Owner dashboard chat cards
  [CARD_OWNER_CLIENT_HEALTH]: "Client health",
  [CARD_OWNER_CLIENT_HEALTH_DESCRIPTION]:
    "Understand health scores and at-risk accounts",
  [CARD_OWNER_CLIENT_HEALTH_QUESTION]:
    "Which clients have a low health score and what can I do?",
  [CARD_OWNER_INSIGHTS]: "Insights",
  [CARD_OWNER_INSIGHTS_DESCRIPTION]: "Review platform insights and trends",
  [CARD_OWNER_INSIGHTS_QUESTION]: "What insights should I review today?",
  [CARD_OWNER_ACCOUNTS]: "Accounts",
  [CARD_OWNER_ACCOUNTS_DESCRIPTION]: "Manage client accounts and access",
  [CARD_OWNER_ACCOUNTS_QUESTION]: "How do I manage client accounts?",
  [CARD_OWNER_BILLING]: "Billing",
  [CARD_OWNER_BILLING_DESCRIPTION]: "Review billing, plans and payments",
  [CARD_OWNER_BILLING_QUESTION]: "Give me an overview of billing and plans",
  [CARD_OWNER_SUPPORT]: "Support",
  [CARD_OWNER_SUPPORT_DESCRIPTION]:
    "Get help with client issues and escalations",
  [CARD_OWNER_SUPPORT_QUESTION]: "What support issues need attention?",
  [CARD_OWNER_CLIENTS_ACCOUNTS]: "Clients and accounts",
  [CARD_OWNER_CLIENTS_ACCOUNTS_DESCRIPTION]:
    "Overview of clients, logins and activity",
  [CARD_OWNER_CLIENTS_ACCOUNTS_QUESTION]:
    "Summarize my clients and their recent activity",
  [CARD_OWNER_BRANDS]: "Brands",
  [CARD_OWNER_BRANDS_DESCRIPTION]: "Manage brands and configurations",
  [CARD_OWNER_BRANDS_QUESTION]:
    "How do I add or manage brands in the dashboard?",
  [CARD_OWNER_PLANS_MRR]: "Plans and MRR",
  [CARD_OWNER_PLANS_MRR_DESCRIPTION]: "Revenue, plans and usage",
  [CARD_OWNER_PLANS_MRR_QUESTION]: "Give me an overview of MRR and plan usage",
  // Date range presets
  [DATE_RANGE_PRESET_TODAY]: "Today",
  [DATE_RANGE_PRESET_YESTERDAY]: "Yesterday",
  [DATE_RANGE_PRESET_LAST_7]: "Last 7 days",
  [DATE_RANGE_PRESET_LAST_14]: "Last 14 days",
  [DATE_RANGE_PRESET_LAST_30]: "Last 30 days",
  [DATE_RANGE_PRESET_THIS_WEEK]: "This week",
  [DATE_RANGE_PRESET_LAST_WEEK]: "Last week",
  [DATE_RANGE_PRESET_THIS_MONTH]: "This month",
  [DATE_RANGE_PRESET_LAST_MONTH]: "Last month",
  [DATE_RANGE_PRESET_THIS_YEAR]: "This year",
  [DATE_RANGE_PRESET_LAST_YEAR]: "Last year",

  [NPS_FORM_TITLE]:
    "How likely are you to recommend {{NAME_BUSINESS}} to a friend or colleague?",
  [NPS_LABEL_NOT_LIKELY_AT_ALL]: "Not likely at all",
  [NPS_LABEL_EXTREMELY_LIKELY]: "Extremely likely",
  [NPS_SAVING_RATING]: "Saving your rating...",
  [NPS_THANK_YOU_TITLE]: "Thank you for your rating!",
  [NPS_THANK_YOU_DESCRIPTION]:
    "Your opinion is very important to us and helps us improve {{NAME_BUSINESS}}.",

  //MODAL OVERLAP CONFLICTS
  [MODAL_OVERLAP_CONFLICTS_TITLE]: "Some Locations Overlap",
  [MODAL_OVERLAP_CONFLICTS_DESCRIPTION]:
    "Conflicts detected. If you continue, we will remove overlapping locations.",
  [PAGE_NUMBER]: "Page {{number}}",

  //TABLE ADMIN DASHBOARD
  [TABLE_ADMIN_DASHBOARD_CLIENT]: "Client",
  [TABLE_ADMIN_DASHBOARD_RENEW_DATE]: "Renew Date",
  [TABLE_ADMIN_DASHBOARD_RENEW_DATE_VALUE]: "{{date, dd/MM/yyyy}}",
  [TABLE_ADMIN_DASHBOARD_DISCOVERY_SOURCE]: "Discovery Source",
  [TABLE_ADMIN_DASHBOARD_HEALTH_SCORE]: "Health Score",
  [TABLE_ADMIN_DASHBOARD_CAMPAIGNS]: "Campaigns",
  [TABLE_ADMIN_DASHBOARD_KPI]: "KPI",
  [TABLE_ADMIN_DASHBOARD_SPEND]: "Spend (7d)",
  [TABLE_ADMIN_DASHBOARD_CPA]: "CPA (7d)",
  [TABLE_ADMIN_DASHBOARD_TARGET_CPA]: "Target CPA",
  [TABLE_ADMIN_DASHBOARD_ROAS]: "ROAS (7d)",
  [TABLE_ADMIN_DASHBOARD_RESULTS]: "Results (7d)",
  [TABLE_ADMIN_DASHBOARD_LAST_LOGIN]: "Last Login",
  [TABLE_ADMIN_DASHBOARD_LOGINS]: "Logins (30d)",
  [TABLE_ADMIN_DASHBOARD_USERS]: "Users",
  [TABLE_ADMIN_DASHBOARD_AUTOMATION]: "Optimizations (30d)",
  [TABLE_ADMIN_DASHBOARD_MRR]: "MRR",
  [TABLE_ADMIN_DASHBOARD_PLAN]: "Plan",
  [TABLE_ADMIN_DASHBOARD_CREATIVES]: "Creatives",
  [TABLE_ADMIN_DASHBOARD_NPS]: "NPS",
  [TABLE_ADMIN_DASHBOARD_AI_CREATIVES_LAST_30_DAYS]: "Saved AI Creatives (30d)",
  [TABLE_ADMIN_DASHBOARD_CAMPAIGNS_ACTIVE]: "{{campaignsActive}} Active",
  [TABLE_ADMIN_DASHBOARD_CAMPAIGNS_ACTIVE_SINGLE]: "{{campaignsActive}} Active",
  [TABLE_ADMIN_DASHBOARD_INVOICE_OVERDUE]: "Invoice Overdue",
  [TABLE_ADMIN_DASHBOARD_LOADING_MORE]: "Loading More Clients...",
  [TABLE_ADMIN_DASHBOARD_SHOWING_CLIENTS]:
    "Showing {{count}} of {{total}} clients",
  [TABLE_ADMIN_CREATIVES_UTILIZED]: "{{creativesUsed}} Saved",
  [TABLE_ADMIN_CREATIVE_UTILIZED]: "{{creativesUsed}} Saved",
  [TABLE_ADMIN_LAST_LOGIN_DAYS]: "{{days}}d Ago",
  [TABLE_ADMIN_CANCELLATION_REASON_SUBTITLE]: "Cancellation Reason",
  [TABLE_ADMIN_CANCELLATION_REASON_BUTTON]: "View Reason",
  [TABLE_ADMIN_CANCELLED_BADGE]: "Canceled",
  [TABLE_ADMIN_ADD_ADVERTISER_BUTTON]: "Create Brand",
  [TABLE_ADMIN_ADD_CREDITS_BUTTON]: "Add Credits",
  [TABLE_ADMIN_ACTIONS_BUTTON]: "Actions",
  [TABLE_ADMIN_ACTIVATE_PLAN_BUTTON]: "Activate Plan",
  [TABLE_ADMIN_DEACTIVATE_PLAN_BUTTON]: "Deactivate Plan",
  [TABLE_ADMIN_CONFIRM_ACTIVATE_PLAN_TITLE]: "Activate plan?",
  [TABLE_ADMIN_CONFIRM_ACTIVATE_PLAN_MESSAGE]:
    "This will activate the plan for this agency.",
  [TABLE_ADMIN_CONFIRM_DEACTIVATE_PLAN_TITLE]: "Deactivate plan?",
  [TABLE_ADMIN_CONFIRM_DEACTIVATE_PLAN_MESSAGE]:
    "This will deactivate the plan for this agency.",
  [TABLE_ADMIN_MARK_DEMO_BUTTON]: "Mark as Demo Account",
  [TABLE_ADMIN_CONFIRM_MARK_DEMO_TITLE]: "Mark as Demo Account?",
  [TABLE_ADMIN_CONFIRM_MARK_DEMO_MESSAGE]:
    "All brands under this agency will be marked as demo and will no longer appear in this list.",
  [TABLE_ADMIN_CREDITS_USAGE]: "Credits: {{used,number}} / {{total,number}}",
  [TABLE_ADMIN_PENDING_PAYMENT_BADGE]: "Pending Payment",
  [TABLE_ADMIN_PRIORITY_BADGE]: "Priority",
  [TABLE_ADMIN_SEND_EMAIL_BUTTON]: "Send Email",
  [TABLE_ADMIN_LOGIN_AS_CLIENT_BUTTON]: "Log in as Client",
  [OWNER_LOGIN_AS_USER_OPTION]: "{{name}} ({{email}})",
  [OWNER_LOGIN_AS_USER_OPTION_EMAIL]: "{{email}}",
  [OWNER_LOGIN_AS_CONNECTING]: "Signing in as client...",
  [OWNER_LOGIN_AS_ERROR_TITLE]: "Unable to sign in",
  [OWNER_LOGIN_AS_ERROR_EXPIRED]:
    "This link has expired or was already used. Ask an admin to generate a new one.",
  [OWNER_LOGIN_AS_ERROR_INVALID]: "This login link is invalid.",
  [OWNER_LOGIN_AS_ERROR_MISSING_PARAMS]:
    "This login link is missing required data.",
  [OWNER_LOGIN_AS_ERROR_GENERIC]:
    "We could not sign you in with this link. Please try again.",
  [OWNER_LOGIN_AS_ERROR_USER_NOT_FOUND]:
    "No user was found with that email address.",
  [OWNER_LOGIN_AS_ERROR_INVALID_EMAIL]: "The email address is not valid.",
  [OWNER_LOGIN_AS_ERROR_FORBIDDEN]:
    "You are not allowed to sign in as this user.",
  [OWNER_LOGIN_AS_ERROR_UNAUTHORIZED]:
    "You are not authorized to create a client login link.",
  [SUPPORT_SESSION_BANNER_TITLE]: "Support session active",
  [SUPPORT_SESSION_BANNER_DESCRIPTION]:
    "The support team is using this account. The session will end automatically at {{time}}.",
  [SUPPORT_SESSION_ENDED_TITLE]: "The support session has ended",
  [SUPPORT_SESSION_ENDED_DESCRIPTION]:
    "Support sessions last one hour. If you need more time, sign in again from the admin dashboard.",
  [TABLE_ADMIN_SEND_EMAIL_MODAL_TITLE]: "Send Email",
  [TABLE_ADMIN_SEND_EMAIL_SUBJECT_LABEL]: "Subject",
  [TABLE_ADMIN_SEND_EMAIL_BODY_LABEL]: "Message",
  [TABLE_ADMIN_SEND_EMAIL_RECIPIENTS_LABEL]: "Recipients",
  [TABLE_ADMIN_SEND_EMAIL_RECIPIENTS_PLACEHOLDER]: "Select recipients",
  [TABLE_ADMIN_SEND_EMAIL_SELECT_ALL]: "Select all",
  [TABLE_ADMIN_SEND_EMAIL_SEND_BUTTON]: "Send",
  [TABLE_ADMIN_SEND_EMAIL_SUCCESS]: "Email sent successfully",
  [TABLE_ADMIN_MODIFY_KPI_CPA_BUTTON]: "Edit KPI / CPA",
  [TABLE_ADMIN_ENABLE_FEATURES_BUTTON]: "Enable Features",
  [TABLE_ADMIN_FEATURE_TYPOGRAPHIC_FIDELITY]: "Typographic Fidelity",
  [TABLE_ADMIN_FEATURE_MINIMUM_TERM_CONTRACT]: "Minimum term clause (3 months)",
  [TABLE_ADMIN_AI_IMAGE_MODEL_BUTTON]: "AI Image Model",
  [TABLE_ADMIN_AI_IMAGE_PROVIDER_GOOGLE]: "Google",
  [TABLE_ADMIN_AI_IMAGE_PROVIDER_OPENAI]: "OpenAI",
  [TABLE_ADMIN_AI_IMAGE_PROVIDER_SEEDREAM]: "Seedream",
  [MODAL_MODIFY_KPI_CPA_TITLE]: "KPI and target CPA — {{name}}",
  [MODAL_MODIFY_KPI_CPA_PRIMARY_LABEL]: "Primary KPI",
  [MODAL_MODIFY_KPI_CPA_TARGET_LABEL]: "Target CPA",
  [MODAL_MODIFY_KPI_CPA_CURRENCY_LABEL]: "Currency",
  [MODAL_MODIFY_KPI_CPA_SAVE_SUCCESS]: "KPI and CPA settings saved",
  [MODAL_MODIFY_KPI_CPA_VOLUMEN_LABEL]:
    "How many results (of your KPI) do you want per month?",
  [MODAL_CAMPAIGN_KPI_CPA_TITLE]: "Campaign Goals",
  [MODAL_CAMPAIGN_KPI_CPA_INHERIT_HINT]:
    "Set one goal per platform (KPI, weekly results, CPA and currency). If you leave a platform empty, the account goal is used.",
  [MODAL_CAMPAIGN_KPI_CPA_WEEKLY_VOLUME_LABEL]:
    "How many results (of this KPI) do you want per week?",
  [ADMIN_KPI_PRIMARY_LEADS]: "Leads",
  [ADMIN_KPI_PRIMARY_SALES]: "Sales",
  [ADMIN_KPI_PRIMARY_MESSAGES]: "Messages",
  [ADMIN_KPI_PRIMARY_INTERACTIONS]: "Interactions",
  [ADMIN_KPI_PRIMARY_TRAFFIC]: "Traffic",
  [ADMIN_KPI_PRIMARY_CONVERSIONS]: "Conversions",
  [ADMIN_KPI_PRIMARY_DOWNLOADS]: "Downloads",
  [ADMIN_KPI_PRIMARY_APP_INSTALLS]: "App installs",
  [ADMIN_KPI_PRIMARY_VIDEO_VIEWS]: "Video views",
  [ADMIN_KPI_PRIMARY_AWARENESS]: "Awareness",
  [ADMIN_KPI_PRIMARY_REACH]: "Reach",
  [ADMIN_KPI_PRIMARY_ENGAGEMENT]: "Engagement",
  [ADMIN_KPI_PRIMARY_STORE_VISITS]: "Store visits",
  [ADMIN_KPI_PRIMARY_WEBSITE_CONVERSIONS]: "Website conversions",
  [ADMIN_KPI_PRIMARY_CATALOG_SALES]: "Catalog sales",
  [ADMIN_KPI_PRIMARY_SIGNUPS]: "Sign-ups",
  [ADMIN_DASHBOARD_TITLE]: "Clients",
  [OWNER_DASHBOARD_NAV_FORM]: "Forms",
  [OWNER_DASHBOARD_NAV_REPORTED_CONTENT]: "Reported Content",
  [OWNER_DASHBOARD_NAV_PROMOTIONAL_CODES]: "Codes",
  [OWNER_DASHBOARD_NAV_GLOBAL_NOTIFICATIONS]: "Notifications",
  [OWNER_DASHBOARD_NAV_AD_SPEND]: "Ad spend",
  [OWNER_AD_SPEND_TITLE]: "Ad spend",
  [OWNER_AD_SPEND_DESCRIPTION]:
    "Total spend of campaigns launched from the platform, in USD.",
  [OWNER_AD_SPEND_PRESET_HISTORIC]: "All time",
  [OWNER_AD_SPEND_PRESET_LAST_7]: "Last 7 days",
  [OWNER_AD_SPEND_PRESET_LAST_30]: "Last 30 days",
  [OWNER_AD_SPEND_PRESET_LAST_90]: "Last 90 days",
  [OWNER_AD_SPEND_PRESET_THIS_MONTH]: "This month",
  [OWNER_AD_SPEND_PRESET_LAST_MONTH]: "Last month",
  [OWNER_AD_SPEND_PRESET_CUSTOM]: "Custom",
  [OWNER_AD_SPEND_CUSTOM_PENDING]:
    "Select a date range and save it to update the report.",
  [OWNER_AD_SPEND_ACCURACY_WARNING]:
    "Filtering by dates before October 15, 2026 may be inaccurate.",
  [OWNER_AD_SPEND_ACCURACY_WARNING_ESTIMATED]:
    "Includes {{value}} estimated from cumulative statistics.",
  [OWNER_AD_SPEND_KPI_TOTAL]: "Total spend",
  [OWNER_AD_SPEND_KPI_ADVERTISERS]: "Advertisers with spend",
  [OWNER_AD_SPEND_KPI_COUNTRIES]: "Countries",
  [OWNER_AD_SPEND_VS_PREVIOUS_PERIOD]: "Previous period: {{value}}",
  [OWNER_AD_SPEND_CHART_TITLE]: "Spend trend by platform",
  [OWNER_AD_SPEND_CHART_DAILY]: "Daily",
  [OWNER_AD_SPEND_CHART_MONTHLY]: "Monthly",
  [OWNER_AD_SPEND_PLATFORMS_TITLE]: "Share by platform",
  [OWNER_AD_SPEND_TOP_ADVERTISERS_TITLE]: "Top spending accounts",
  [OWNER_AD_SPEND_TOP_COUNTRIES_TITLE]: "Top spending countries",
  [OWNER_AD_SPEND_TOP_ADVERTISERS_ARIA]: "Top spending accounts",
  [OWNER_AD_SPEND_TOP_COUNTRIES_ARIA]: "Top spending countries",
  [OWNER_AD_SPEND_COLUMN_ADVERTISER]: "Advertiser",
  [OWNER_AD_SPEND_COLUMN_COUNTRY]: "Country",
  [OWNER_AD_SPEND_COLUMN_SPEND]: "Spend",
  [OWNER_AD_SPEND_COLUMN_SHARE]: "% of total",
  [OWNER_AD_SPEND_COLUMN_PLATFORMS]: "Platforms",
  [OWNER_AD_SPEND_UNASSIGNED_COUNTRY]: "No country assigned",
  [OWNER_AD_SPEND_TREND_NEW]: "New",
  [OWNER_AD_SPEND_ESTIMATED_BADGE]: "Estimated",
  [OWNER_AD_SPEND_EMPTY_TITLE]: "No spend recorded yet",
  [OWNER_AD_SPEND_EMPTY_DESCRIPTION]:
    "Data will appear after the first daily collection runs.",
  [OWNER_AD_SPEND_MOCK_BADGE]: "Mock data",
  [OWNER_DASHBOARD_NAV_CREATE_USER]: "Create User",
  [OWNER_DASHBOARD_NAV_OPTIONS]: "Options",
  [OWNER_GLOBAL_NOTIFICATIONS_TITLE]: "Global Notifications",
  [OWNER_GLOBAL_NOTIFICATIONS_FIELD_TITLE]: "Title",
  [OWNER_GLOBAL_NOTIFICATIONS_FIELD_BODY]: "Body",
  [OWNER_GLOBAL_NOTIFICATIONS_FIELD_CTA]: "CTA",
  [OWNER_GLOBAL_NOTIFICATIONS_FIELD_LINK]: "Link",
  [OWNER_GLOBAL_NOTIFICATIONS_FIELD_LINK_HELPER]:
    "Use an in-app path like /ads-campaign or a full https URL. This link is shared by every language.",
  [OWNER_GLOBAL_NOTIFICATIONS_CTA_LINK_PAIR_ERROR]:
    "The CTA in every language and the link must be provided together.",
  [OWNER_GLOBAL_NOTIFICATIONS_PUBLISH_BUTTON]: "Publish and email",
  [OWNER_GLOBAL_NOTIFICATIONS_PUBLISH_SUCCESS]: "Notification published.",
  [MODAL_CREATE_OWNER_USER_ARIA_LABEL]: "Create owner user modal",
  [MODAL_CREATE_OWNER_USER_TITLE]: "Create User",
  [MODAL_CREATE_OWNER_USER_DESCRIPTION]:
    "Create an owner user with access to the admin panel.",
  [MODAL_CREATE_OWNER_USER_SUCCESS]: "User Created Successfully",
  [REGISTER_PROMOTIONAL_CODE_LABEL]: "Promotional code (optional)",
  [REGISTER_PROMOTIONAL_CODE_PLACEHOLDER]: "Enter your code",
  [REGISTER_DISCOVERY_SOURCE_LABEL]: "How did you hear about us?",
  [OWNER_PROMOTIONAL_CODES_CREATE_TITLE]: "Create promotional code",
  [OWNER_PROMOTIONAL_CODES_CREATE_BUTTON]: "Create Code",
  [OWNER_PROMOTIONAL_CODES_MODAL_SUBTITLE]:
    "Define the code, redemption limit, and whether it applies to AppSumo giveaways.",
  [OWNER_PROMOTIONAL_CODES_GENERATE_CODE_TOOLTIP]: "Generate random code",
  [OWNER_PROMOTIONAL_CODES_FIELD_CODE]: "Code",
  [OWNER_PROMOTIONAL_CODES_FIELD_MAX_REDEMPTIONS]: "Max redemptions",
  [OWNER_PROMOTIONAL_CODES_FIELD_APP_SUMO]: "AppSumo giveaway",
  [OWNER_PROMOTIONAL_CODES_FIELD_TIER]: "AppSumo tier",
  [OWNER_PROMOTIONAL_CODES_TIER_OPTION_1]: "Tier 1",
  [OWNER_PROMOTIONAL_CODES_TIER_OPTION_2]: "Tier 2",
  [OWNER_PROMOTIONAL_CODES_TIER_OPTION_3]: "Tier 3",
  [OWNER_PROMOTIONAL_CODES_COLUMN_CODE]: "Code",
  [OWNER_PROMOTIONAL_CODES_COLUMN_CREATED]: "Created",
  [OWNER_PROMOTIONAL_CODES_COLUMN_REGISTERED]: "Registrations",
  [OWNER_PROMOTIONAL_CODES_COLUMN_MAX_REDEMPTIONS]: "Max redemptions",
  [OWNER_PROMOTIONAL_CODES_COLUMN_TYPE]: "Type",
  [OWNER_PROMOTIONAL_CODES_TYPE_VALUE_APP_SUMO]: "AppSumo",
  [OWNER_PROMOTIONAL_CODES_TYPE_APP_SUMO_TIER_SUFFIX]: " - Tier {{tier}}",
  [OWNER_PROMOTIONAL_CODES_TYPE_VALUE_STANDARD]: "Standard",
  [OWNER_PROMOTIONAL_CODES_TYPE_VALUE_STRIPE_DISCOUNT]: "Stripe discount",
  [OWNER_PROMOTIONAL_CODES_FIELD_STRIPE_CODE]: "Stripe code",
  [OWNER_PROMOTIONAL_CODES_FIELD_DISCOUNT]: "Discount value",
  [OWNER_PROMOTIONAL_CODES_FIELD_DISCOUNT_TYPE]: "Discount type",
  [OWNER_PROMOTIONAL_CODES_DISCOUNT_TYPE_FIXED]: "Fixed (USD)",
  [OWNER_PROMOTIONAL_CODES_DISCOUNT_TYPE_PERCENTAGE]: "Percentage",
  [OWNER_PROMOTIONAL_CODES_ERROR_INVALID_STRIPE_DISCOUNT]:
    "Enter a valid Stripe code, discount value, and discount type",
  [PRICING_PROMO_DISCOUNT_APPLIED]: "Discounted price",
  [OWNER_PROMOTIONAL_CODES_COLUMN_STATUS]: "Status",
  [OWNER_PROMOTIONAL_CODES_STATUS_ACTIVE]: "Active",
  [OWNER_PROMOTIONAL_CODES_STATUS_INACTIVE]: "Inactive",
  [OWNER_PROMOTIONAL_CODES_CREATE_SUCCESS]: "Promotional code created",
  [OWNER_PROMOTIONAL_CODES_ERROR_DUPLICATE]:
    "A code with this value already exists",
  [OWNER_PROMOTIONAL_CODES_ERROR_INVALID]: "Enter a valid code",
  [PROMOTIONAL_CODE_NOT_FOUND]: "This promotional code does not exist.",
  [PROMOTIONAL_CODE_INACTIVE]: "This promotional code is no longer active.",
  [PROMOTIONAL_CODE_MAX_REDEMPTIONS_REACHED]:
    "This promotional code has reached its redemption limit.",
  [ADMIN_DASHBOARD_SUBTITLE]:
    "Manage your clients' access, performance, and billing.",
  [ADMIN_DASHBOARD_SEARCH_PLACEHOLDER]: "Search by name...",
  [ADMIN_DASHBOARD_FILTER_STATUS_PLACEHOLDER]: "Filter by status",
  [ADMIN_DASHBOARD_HEALTH_SUMMARY_TITLE]: "Customer Health Summary",
  [ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_HEALTHY]: "Healthy",
  [ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_WATCHLIST]: "Watchlist",
  [ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_AT_RISK]: "At Risk",
  [CREATE_BRAND_BUTTON]: "Create Brand",
  [ADMIN_DASHBOARD_CREATE_BRAND_BUTTON]: "Add Client",
  [ANNOTATIONS_SIDEBAR_AGENCY_HEADER]: "Agency: {{name}}",
  [ANNOTATIONS_SIDEBAR_ADVERTISER_HEADER]: "Advertiser: {{name}}",
  [ANNOTATIONS_SIDEBAR_EMPTY_TITLE]: "No notes yet",
  [ANNOTATIONS_SIDEBAR_EMPTY_SUBTITLE]:
    "Leave internal notes for your team about this client. Attach images, PDFs, or videos when needed.",
  [ANNOTATIONS_SIDEBAR_INPUT_PLACEHOLDER]: "Write a note for {{name}}",
  [ANNOTATIONS_SIDEBAR_YOU_LABEL]: "You",
  [ANNOTATIONS_SIDEBAR_LOADING]: "Loading notes...",
  [ANNOTATIONS_SIDEBAR_CLOSE]: "Close notes",
  [ANNOTATIONS_UNREAD_BADGE_ARIA]: "New notes",
  [ANNOTATIONS_UNREAD_COUNT]: "{{count}} new",
  [ANNOTATIONS_MENTION_ALL]: "All",
  [ANNOTATIONS_MENTION_MENU_ARIA]: "Mention user",
  [ANNOTATIONS_MESSAGE_EDIT]: "Edit",
  [ANNOTATIONS_MESSAGE_DELETE]: "Delete",
  [ANNOTATIONS_MESSAGE_DELETE_CONFIRM]:
    "Are you sure you want to delete this note?",
  [ANNOTATIONS_MESSAGE_EDITING]: "Editing message...",
  [ANNOTATIONS_MESSAGE_CANCEL_EDIT]: "Cancel edit",
  [ANNOTATIONS_MESSAGE_MENU_ARIA]: "Message options",
  [ADMIN_DASHBOARD_CREATE_BRAND_MODAL_TITLE]: "Create Brand",
  [ADMIN_DASHBOARD_CREATE_BRAND_MODAL_SUBTITLE]:
    "Set up the brand owner account",
  [ADMIN_DASHBOARD_CREATE_BRAND_PLAN_ACTIVE_LABEL]: "Active plan",
  [ADMIN_DASHBOARD_USER_CREATED_SUCCESS]: "User created successfully",
  [ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_LABEL]: "Is this a trial account?",
  [ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_YES]: "Yes, it is a trial",
  [ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_NO]: "No, it is not a trial",
  [ADMIN_DASHBOARD_CREATE_BRAND_PLAN_TYPE_LABEL]: "Plan Type",
  [ADMIN_DASHBOARD_CREATE_BRAND_PLAN_RECURRENT_LABEL]: "Plan recurrence",
  [ADMIN_DASHBOARD_CREATE_BRAND_PLAN_LABEL]: "Plan",
  [ADMIN_DASHBOARD_CREATE_BRAND_HAS_ADDON_SPEND_FEE_LABEL]: "Has Add-on",
  [ADMIN_DASHBOARD_CREATE_BRAND_FEATURES_LABEL]: "Features",
  [ADMIN_DASHBOARD_CREATE_BRAND_AD_SPEND_FEE_PERCENTAGE_LABEL]:
    "Ad spend fee (%)",
  [ADMIN_DASHBOARD_CREATE_BRAND_STRIPE_SUBSCRIPTION_ID_LABEL]:
    "Stripe Subscription ID (optional)",
  [ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_TITLE]: "Create Brand",
  [ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_BRAND_NAME_LABEL]: "Brand Name",
  [ADMIN_DASHBOARD_ADVERTISER_CREATED_SUCCESS]: "Brand Created Successfully",
  [DELETE_BRAND_CONFIRMATION_TITLE]: "Delete Brand",
  [DELETE_BRAND_CONFIRMATION_DESCRIPTION]:
    "Are you sure you want to delete “{{brandName}}”? This action is permanent and cannot be undone. Data for this brand will be removed from the agency.",
  [DELETE_BRAND_SUCCESS]: "Brand deleted successfully",
  [DELETE_BRAND_ERROR]: "We could not delete this brand. Please try again.",
  [DELETE_BRAND_MAIN_CANNOT_DELETE]:
    "This brand cannot be deleted because it is the main one.",
  [ADMIN_DASHBOARD_ADD_CREDITS_MODAL_TITLE]: "Add Credits",
  [ADMIN_DASHBOARD_ADD_CREDITS_MODAL_LABEL]: "Credits to add",
  [ADMIN_DASHBOARD_ADD_CREDITS_MODAL_PLACEHOLDER]: "Enter credits",
  [ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MIN_ERROR]:
    "Credits must be greater than or equal to {{min}}",
  [ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MAX_ERROR]:
    "Credits must be less than or equal to {{max}}",
  [ADMIN_DASHBOARD_CREDITS_ADDED_SUCCESS]: "Credits added successfully",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_MODAL_TITLE]:
    "Recurring brand usage allocation",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_CREDITS_LABEL]: "Credits limit",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_VIDEOS_LABEL]: "Videos limit",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_CONSUMED_LABEL]:
    "Consumed this cycle: {{value}}",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_PLAN_MAX_HINT]:
    "Agency plan maximum: {{max}}",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_REMOVE_HINT]:
    "Leave the field empty to remove this brand cap.",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_TOTAL_ASSIGNED_LABEL]:
    "Total assigned",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_PLAN_MAX_LABEL]: "Available on plan",
  [ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_SUCCESS]:
    "Brand usage allocation updated",
  [NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE]:
    "This brand reached its assigned usage limit.",
  [NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE_DESCRIPTION]:
    "Contact your administrator to expand this brand's limits.",
  [BRAND_USAGE_LIMIT_ALERT_EDIT_LIMITS_BUTTON]: "Edit Limits",
  [BRAND_USAGE_ALLOCATION_EXCEEDS_PLAN]:
    "Total brand allocations exceed the agency plan benefits.",
  [BRAND_USAGE_ALLOCATION_BELOW_CONSUMED]:
    "The limit cannot be lower than this brand's current cycle consumption.",
  [HEALTH_SCORE_LABEL]: "Health Score",

  // GENERATING CREATIVE ALERTS
  [GENERATING_CREATIVE_TITLE]: "Generating Creatives",
  [GENERATING_CREATIVE_SUCCESS]: "Creatives Generated Successfully",
  [GENERATING_CREATIVE_ERROR]: "Error Generating Creatives",
  [ALERT_GENERIC_ERROR_TITLE]: "An Error Occurred",
  [GENERATING_CUSTOM_REPORT_MESSAGE]: "Generating Report",
  [GENERATING_CUSTOM_REPORT_SUCCESS]: "Report Generated Successfully",
  [GENERATING_CUSTOM_REPORT_ERROR]: "Error Generating Report",
  [ANALYZING_IMAGE_LAYERS_MESSAGE]: "Analyzing Layers",
  [ANALYZING_IMAGE_LAYERS_SUCCESS]: "Image Analyzed Successfully",
  [ANALYZING_IMAGE_LAYERS_ERROR]: "Error Analyzing Layers",
  [ANALYZING_CREATIVE_TEMPLATE_MESSAGE]: "Analyzing Creative",
  [ANALYZING_CREATIVE_TEMPLATE_SUCCESS]: "Creative Analyzed Successfully",
  [ANALYZING_CREATIVE_TEMPLATE_ERROR]: "Error Analyzing Creative",
  [PRODUCING_CREATIVE_TEMPLATE_MESSAGE]: "Producing Template Creatives",
  [PRODUCING_CREATIVE_TEMPLATE_PREVIEW_MESSAGE]:
    "Producing the Template Preview",
  [PRODUCING_CREATIVE_TEMPLATE_PREVIEW_SUCCESS]:
    "Template Preview Produced Successfully",
  [PRODUCING_CREATIVE_TEMPLATE_PREVIEW_ERROR]:
    "Error Producing the Template Preview",
  [PRODUCING_CREATIVE_TEMPLATE_SUCCESS]:
    "Template Creatives Produced Successfully",
  [PRODUCING_CREATIVE_TEMPLATE_PARTIAL]:
    "{{succeeded}} of {{requested}} template creatives produced",
  [PRODUCING_CREATIVE_TEMPLATE_PARTIAL_SINGULAR]:
    "1 of {{requested}} template creatives produced",
  [PRODUCING_CREATIVE_TEMPLATE_ERROR]: "Error Producing Template Creatives",
  [EDITING_IMAGE_TITLE]: "Editing Image",
  [EDITING_IMAGE_SUCCESS]: "Image Edited Successfully",
  [EDITING_IMAGE_ERROR]: "Error Editing Image",
  [RESIZING_IMAGE_TITLE]: "Resizing Image",
  [RESIZING_IMAGE_SUCCESS]: "Image Resized Successfully",
  [RESIZING_IMAGE_ERROR]: "Error Resizing Image",

  [AGENT_LABEL]: "Agent",
  [GO_TO_DASHBOARD]: "Go to Dashboard",
  [IMAGES_MODERATION_BLOCKED]: "Images blocked by moderation",

  // Accents
  [ACCENT_ES_ARGENTINO]: "Argentine",
  [ACCENT_ES_COLOMBIANO]: "Colombian",
  [ACCENT_ES_CHILENO]: "Chilean",
  [ACCENT_ES_MEXICANO]: "Mexican",
  [ACCENT_ES_ESPANOL_ESPANA]: "Spanish (Spain)",
  [ACCENT_ES_PERUANO]: "Peruvian",
  [ACCENT_ES_VENEZOLANO]: "Venezuelan",
  [ACCENT_ES_CARIBENO]: "Caribbean",
  [ACCENT_ES_NEUTRAL]: "Neutral",
  [ACCENT_ES_PUERTORRIQUENO]: "Puerto Rican",

  [ACCENT_EN_AMERICAN]: "American",
  [ACCENT_EN_BRITISH]: "British",
  [ACCENT_EN_AUSTRALIAN]: "Australian",
  [ACCENT_EN_NEUTRAL]: "Neutral",
  [PARTNERSHIP]: "Partnership",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_IMAGE]: "Image",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_VIDEO]: "Video",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_CAROUSEL]: "Carousel",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_DOCUMENT]: "Document",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP]: "Ad Setup",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP_CREATE_AD]: "Create Ad",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP_USE_POST]: "Use Post",
  [ADS_CAMPAIGN_LINKEDIN_USE_POST_VIDEO_DOWNLOAD_URL_MISSING]:
    "This video post cannot be used because a download URL is not available.",
  [AD_FORMAT_PLACEHOLDER]: "Ad Format",
  [SELECT_AD_FORMAT_TO_CONTINUE]: "Please select an ad format to continue",

  // Campaign Learnings
  [CAMPAIGN_LEARNINGS_TITLE]: "Campaign Insights",
  [CAMPAIGN_LEARNINGS_SUBTITLE]: "Complete Analysis",
  [CAMPAIGN_LEARNINGS_KEY_LEARNINGS]: "Key Insights",
  [CAMPAIGN_LEARNINGS_WHAT_WORKED]: "What Worked",
  [CAMPAIGN_LEARNINGS_WHAT_DIDNT_WORK]: "What Didn't Work",
  [PLATFORM_META]: "Meta",
  [PLATFORM_GOOGLE]: "Google",

  // BRAND SETUP CONFIRM MODAL
  [MODAL_BRAND_SETUP_CONFIRM_TITLE]:
    "Do you want to save these brand settings?",
  [MODAL_BRAND_SETUP_CONFIRM_DESCRIPTION]:
    "This configuration will serve as the basis for generating campaigns and creative assets (images and videos). Please verify that the information is correct before proceeding, however, you can update it later.",
  [MODAL_BRAND_SETUP_CONFIRM_BUTTON]: "Proceed",
  [MODAL_BRAND_SETUP_REVIEW_BUTTON]: "Review",

  // Facebook Modal Upload
  [MODAL_UPLOAD_FACEBOOK_TYPE_LABEL]: "Facebook Content Type",
  [TYPE_CONTENT_FACEBOOK_LABEL]: "Content Type",
  [MODAL_UPLOAD_FACEBOOK_TYPE_POST_LABEL]: "Post",
  [MODAL_UPLOAD_FACEBOOK_TYPE_STORY_LABEL]: "Story",
  [MODAL_UPLOAD_FACEBOOK_TYPE_REEL_LABEL]: "Reel",

  // CAROUSEL IMAGES
  [INSTAGRAM_FEED_ASPECT_RATIO_WARNING]:
    "Your image size doesn’t match the recommended format for Instagram posts (Ideal: 4:5). Want to adjust it?",
  [CAROUSEL_MIN_IMAGES_WARNING]:
    "You must select at least 2 images for a carousel",
  [CAROUSEL_MAX_IMAGES_WARNING]: "You can select up to {{max}} images",
  [CAROUSEL_DRAG_TO_REORDER]:
    "Drag images to change order. The first will be the main image.",
  [CAROUSEL_ADD_MORE_IMAGES]: "Add more images",
  [CAROUSEL_IMAGES_SELECTED]: "{{count}} images selected",
  [CAROUSEL_MAIN_IMAGE]: "Main",

  // TIKTOK
  [TYPE_CONTENT_TIKTOK_LABEL]: "Content Type",
  [MODAL_UPLOAD_TIKTOK_TYPE_POST_LABEL]: "Post",
  [MODAL_UPLOAD_TIKTOK_TYPE_VIDEO_LABEL]: "Video",

  // Unified Carousel translation
  [CONTENT_TYPE_CAROUSEL]: "Carousel",

  // Content type change confirmation
  [CONFIRM_REGENERATE_TEXTS_AFTER_CREATIVE_CHANGE_TITLE]:
    "Do you want to regenerate all texts based on the new creative?",
  [BUTTON_KEEP_TEXTS]: "Keep texts",
  [REGENERATING_AD_TEXTS_OVERLAY_MESSAGE]: "Regenerating texts…",

  [CONFIRM_CHANGE_CONTENT_TYPE_TITLE]:
    "Are you sure you want to change the content type?",
  [CONFIRM_CHANGE_CONTENT_TYPE_MESSAGE_CAROUSEL]:
    "All platforms will change to Carousel.",
  [CONFIRM_CHANGE_CONTENT_TYPE_MESSAGE_POST]:
    "All platforms will change to Post.",

  // PLANS CREDITS
  [ADS_SUBSCRIPTION_BENEFIT_CREDITS]: "{{value,number}} Credits",
  [ADS_SUBSCRIPTION_BENEFIT_CREDITS_PER_YEAR]: "{{value,number}} credits/yr",
  [APPSUMO_SUBSCRIPTION_TIER_1]: "Tier 1",
  [APPSUMO_SUBSCRIPTION_TIER_2]: "Tier 2",
  [APPSUMO_SUBSCRIPTION_TIER_3]: "Tier 3",
  [VALUE_SUBSCRIPTION_ONE_TIME]: "{{value,number}} {{currency}} (one-time)",
  [BUTTON_APPSUMO_VIEW_PLANS]: "View plans on AppSumo",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_IMAGE]: "Image",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_VIDEO]: "Video",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_CAROUSEL]: "Carousel",
  [ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_DOCUMENT]: "Document",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP]: "Ad Setup",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP_CREATE_AD]: "Create Ad",
  [ADS_CAMPAIGN_LINKEDIN_AD_SETUP_USE_POST]: "Use Post",
  [ADS_CAMPAIGN_LINKEDIN_USE_POST_VIDEO_DOWNLOAD_URL_MISSING]:
    "This video post cannot be used because a download URL is not available.",
  [AD_FORMAT_PLACEHOLDER]: "Ad Format",
  [SELECT_AD_FORMAT_TO_CONTINUE]: "Please select an ad format to continue",

  // CREDIT REWARD MODAL
  [LINKEDIN_ARTICLE_DEFAULT_TEXT]:
    'Since integrating {{NAME_BUSINESS}}, the way we do marketing has completely changed: we moved from "just writing posts" to designing content ecosystems with a clear, cohesive strategy focused on results.\n\nWhat used to be a slow process is now a fully AI-optimized workflow: we turn ideas into smart campaigns and create multimedia content generated with artificial intelligence. On top of that, the tool elevates the tone and polishes the message so every word counts—delivering more consistency, zero creative stress, and communication that truly converts.',
  [CREDIT_REWARD_MODAL_TITLE]: "Get Free Credits",
  [CREDIT_REWARD_MODAL_SUBTITLE]: "Post on LinkedIn and Get Free Credits",
  [CREDIT_REWARD_MODAL_ARIA_LABEL]: "Get Free Credits",
  [CREDIT_REWARD_MODAL_BUTTON_TEXT]: "Get <u><em>Free Credits</em></u>",
  [CREDIT_REWARD_MODAL_REWARD]: "Reward",
  [CREDIT_REWARD_MODAL_REWARD_DESCRIPTION]: "After the post is shared",
  [CREDIT_REWARD_MODAL_ARTICLE_CONTENT_LABEL]: "Article Content",
  [CREDIT_REWARD_MODAL_ARTICLE_CONTENT_PLACEHOLDER]:
    "Write the content of the article you want to publish...",
  [CREDIT_REWARD_MODAL_VERIFICATION_NOTICE]:
    "The post will be verified before issuing the credits",
  [CREDIT_REWARD_MODAL_BUTTON_CANCEL]: "Cancel",
  [CREDIT_REWARD_MODAL_BUTTON_PUBLISH]: "Publish and Get Credits",
  [CREDIT_REWARD_MODAL_BUTTON_PUBLISHING]: "Publishing...",
  [CREDIT_REWARD_MODAL_BUTTON_RETRY]: "Retry",
  [CREDIT_REWARD_MODAL_LOADING_TITLE]: "Verifying Publication",
  [CREDIT_REWARD_MODAL_LOADING_DESCRIPTION]: "This may take a few seconds...",
  [CREDIT_REWARD_MODAL_SUCCESS_TITLE]: "Publication Successful",
  [CREDIT_REWARD_MODAL_SUCCESS_TEXT]:
    "+{{credits}} credits have been added to your account. Thank you for participating!",
  [CREDIT_REWARD_MODAL_ERROR_TITLE]: "Publication Error",
  [CREDIT_REWARD_MODAL_ERROR_TEXT]:
    "We couldn't credit the credits. Please check your publication and try again.",

  // BRAND SETUP SECTIONS
  [SECTION_COMPETITORS_TITLE]: "Competitors",
  [SECTION_COMPETITORS_SUBTITLE_SINGULAR]: "Brand Identified",
  [SECTION_COMPETITORS_SUBTITLE_PLURAL]: "Brands Identified",
  [SECTION_SOCIAL_TITLE]: "Social Networks",
  [SECTION_SOCIAL_SUBTITLE_SINGULAR]: "Profile Identified",
  [SECTION_SOCIAL_SUBTITLE_PLURAL]: "Profiles Identified",
  [SECTION_VOICE_TITLE]: "Brand Voice",
  [SECTION_VOICE_SUBTITLE]: "Tone and Personality",
  [SECTION_VOICE_TONE_DESCRIPTION]: "Tone Description",
  [SECTION_VOICE_ATTRIBUTES_LABEL]: "Voice Attributes (Max 6)",
  [SECTION_OFFER_TITLE]: "Offer",
  [SECTION_OFFER_SUBTITLE]: "Business Type",
  [SECTION_OFFER_TYPE_LABEL]: "Type",
  [SECTION_OFFER_VISUAL_STYLE_LABEL]: "Visual Style",
  [SECTION_OFFER_BUSINESS_VALUE_PROPOSITION_LABEL]:
    "Business Value Proposition",
  [SECTION_OFFER_DEFAULT_VALUE]: "Services",
  [SECTION_COUNTRY_TITLE]: "Country",
  [SECTION_COUNTRY_SUBTITLE]: "Business location",
  [SECTION_COUNTRY_LABEL]: "Country",
  [SECTION_COUNTRY_DEFAULT_VALUE]: "Select a Country",
  [SECTION_TYPOGRAPHY_TITLE]: "Typography",
  [SECTION_TYPOGRAPHY_SUBTITLE]: "Font System",
  [SECTION_TYPOGRAPHY_FONT_FAMILY_LABEL]: "Font Family",
  [SECTION_TYPOGRAPHY_TITLE_FONT_LABEL]: "Main Font",
  [SECTION_TYPOGRAPHY_SUBTITLE_FONT_LABEL]: "Secondary Font",
  [SECTION_TYPOGRAPHY_BODY_FONT_LABEL]: "Secondary Font",
  [SECTION_TYPOGRAPHY_ADD_TYPOGRAPHY]: "Add Typography",
  [SECTION_TYPOGRAPHY_FONT_SIZES_LABEL]: "Font Sizes",
  [SECTION_TYPOGRAPHY_HEADING_LABEL]: "Heading",
  [SECTION_TYPOGRAPHY_SUBHEADING_LABEL]: "Subheading",
  [SECTION_TYPOGRAPHY_BODY_LABEL]: "Body",
  [SECTION_TYPOGRAPHY_PX_UNIT]: "px",
  [SECTION_TYPOGRAPHY_GENERATING_PREVIEW]: "Generating Preview",
  [SECTION_TYPOGRAPHY_ADD_FONT]: 'Add "{{value}}"',
  [SECTION_LOGO_TITLE]: "Logo",
  [SECTION_LOGO_SUBTITLE]: "Main asset",
  [SECTION_COLORS_TITLE]: "Visual Identity",
  [SECTION_COLORS_SUBTITLE]: "Colors and Visual Style",
  [SECTION_COLORS_ADD_COLOR]: "Add color",
  [SECTION_TARGET_AUDIENCE_TITLE]: "Target Audience",
  [SECTION_TARGET_AUDIENCE_SUBTITLE]: "Ideal Customer Profile",
  [SECTION_TARGET_AUDIENCE_ICP_LABEL]: "Ideal Customer Profile",
  [SECTION_PRODUCT_IMAGES_TITLE]: "Products",
  [SECTION_PRODUCT_IMAGES_SUBTITLE]: "Add images of your products or services",
  [BUTTON_UPLOAD_PRODUCT_IMAGES]: "Upload images",
  [BUTTON_DELETE_PRODUCT_IMAGE]: "Delete",
  [SECTION_ADDITIONAL_ASSETS_TITLE]: "Additional Assets",
  [SECTION_ADDITIONAL_ASSETS_SUBTITLE]:
    "Add reference images with specific usage instructions for more personalized creatives",
  [SECTION_ADDITIONAL_ASSETS_PROMPT_LABEL]: "Usage Instruction",
  [SECTION_ADDITIONAL_ASSETS_PROMPT_PLACEHOLDER]:
    "E.g. place in the bottom-right corner as a quality seal",
  [SECTION_ADDITIONAL_ASSETS_PROMPT_REQUIRED]:
    "Usage instruction is required for each image",
  [BUTTON_UPLOAD_ADDITIONAL_ASSET]: "Add Image",
  [SECTION_ADDITIONAL_ASSETS_MAX_ERROR]: "Maximum 10 Additional Images",
  [SECTION_ADDITIONAL_ASSETS_ASSET_LABEL]: "Asset {{number}}",
  [SECTION_ADDITIONAL_ASSETS_MAX_TOOLTIP]:
    "You have reached the maximum of 10 additional assets",
  [SECTION_ADDITIONAL_ASSETS_DELETE_CONFIRM]:
    "This image and its usage instruction will be removed",
  [SECTION_ADDITIONAL_ASSETS_DELETE_CONFIRM_TITLE]: "Remove asset?",
  [SECTION_ADDITIONAL_ASSETS_INCOMPLETE_PAIR]:
    "Each asset must include both an image and a usage instruction",
  [SECTION_ADDITIONAL_ASSETS_IS_CONDITIONAL_LABEL]: "Is conditional",
  [SECTION_ADDITIONAL_ASSETS_IS_CONDITIONAL_HELP]:
    "Turn this on if the asset should only be used when it fits the creative's context. Keep it off for assets that are always required.",
  [SECTION_ADDITIONAL_ASSETS_VARIABLE_INFO_LABEL]: "Variable information",
  [SECTION_ADDITIONAL_ASSETS_VARIABLE_INFO_HELP]:
    "Turn this on if the asset must be customized with the specific information of each creative. Keep it off if its content never changes.",
  [SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_LABEL]: "Variant group",
  [SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_HELP]:
    "Give the same group name to assets that are alternatives to each other. When generating multiple creatives, a different variant will be used in each one, and only one per creative. Leave it empty if the asset has no alternatives or you don't require it to vary in each creative.",
  [SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_PLACEHOLDER]: "e.g. ticket",
  [MODAL_ADDITIONAL_ASSET_TITLE]: "Additional Asset",
  [BUTTON_CHANGE_ADDITIONAL_ASSET_IMAGE]: "Change Image",
  [SECTION_BUYER_PERSONA_TITLE]: "Buyer Persona",
  [SECTION_BUYER_PERSONA_SUBTITLE]: "Customer Profile",
  [SECTION_BUYER_PERSONA_LABEL]: "Buyer Persona",
  [SECTION_BUYER_PERSONA_PLACEHOLDER_NAME]: "Name",
  [SECTION_BUYER_PERSONA_PLACEHOLDER_DESCRIPTION]: "Description",

  // BRAND SETUP SECTIONS
  [BRAND_SETUP_SECTION_BRAND_NAME]: "Brand Name",
  [BRAND_SETUP_SECTION_BRAND_DESCRIPTION]:
    "This is the description of my brand. Here you can add additional information about your business, its values and its mission",
  [BRAND_SETUP_SECTION_BRAND_NAME_PLACEHOLDER]: "Enter your brand name here",
  [BRAND_SETUP_SECTION_BRAND_DESCRIPTION_PLACEHOLDER]:
    "Describe your brand here",

  // MODAL EDIT URL PARAMETERS
  [MODAL_EDIT_URL_PARAMETERS_TITLE]: "Edit URL Parameters",
  [MODAL_EDIT_URL_PARAMETERS_DESCRIPTION]:
    "URL parameters can help you collect performance data for your campaign.",
  [MODAL_EDIT_URL_PARAMETERS_UTM_SECTION_LABEL]: "UTM parameters",
  [MODAL_EDIT_URL_PARAMETERS_CUSTOM_SECTION_LABEL]: "Custom parameters",
  [MODAL_EDIT_URL_PARAMETERS_PREVIEW_LABEL]: "Preview",
  [MODAL_EDIT_URL_PARAMETERS_ENTER_PARAM_NAME]: "Enter parameter name",
  [MODAL_EDIT_URL_PARAMETERS_ENTER_PARAM_VALUE]: "Enter parameter value",
  [MODAL_EDIT_URL_PARAMETERS_CONFIGURED]: "{{count}} UTM parameters configured",
  [MODAL_EDIT_URL_PARAMETERS_BUTTON_APPLY]: "Apply",
  [MODAL_EDIT_URL_PARAMETERS_BUTTON_CONFIGURE]: "Edit URL parameters",
  [MODAL_EDIT_URL_PARAMETERS_CUSTOM_KEY_RESERVED]:
    "This key is reserved. Use the UTM parameters section to modify it.",
  [MODAL_EDIT_URL_PARAMETERS_BUILD_LABEL]: "Build UTMs",
  [URL_EXAMPLE_PLACEHOLDER]: "https://www.yourwebsite.com",

  // MODAL FEEDBACK
  [MODAL_FEEDBACK_TITLE]: "Share Your Feedback",
  [MODAL_FEEDBACK_DESCRIPTION]:
    "Help us improve by sharing your thoughts about this content.",
  [MODAL_FEEDBACK_PLACEHOLDER]: "Tell us what you think...",
  [MODAL_FEEDBACK_LIKE_LABEL]: "You liked this content",
  [MODAL_FEEDBACK_DISLIKE_LABEL]: "You didn't like this content",
  [MODAL_REPORT_CONTENT_TITLE]: "Report Content",
  [MODAL_REPORT_CONTENT_DESCRIPTION]:
    "Tell us what issue this content has so we can review it (only for errors like distortions, visual glitches, or incorrect results).",
  [MODAL_REPORT_CONTENT_PLACEHOLDER]:
    "Write the reason or context for this report...",
  [MODAL_REPORT_CONTENT_SUCCESS]: "Report sent successfully.",
  [BUTTON_REPORT_CONTENT]: "Report",

  // ALERTS ANIMATION IMAGE
  [ANIMATING_IMAGE_TITLE]: "Animating Image",
  [ANIMATING_IMAGE_SUCCESS]: "Image Animated Successfully",
  [ANIMATING_IMAGE_ERROR]: "Error Animating Image",
  // COUNTRIES
  [COUNTRY_ANDORRA]: "Andorra",
  [COUNTRY_UNITED_ARAB_EMIRATES]: "United Arab Emirates",
  [COUNTRY_AFGHANISTAN]: "Afghanistan",
  [COUNTRY_ANTIGUA_AND_BARBUDA]: "Antigua and Barbuda",
  [COUNTRY_ANGUILLA]: "Anguilla",
  [COUNTRY_ALBANIA]: "Albania",
  [COUNTRY_ARMENIA]: "Armenia",
  [COUNTRY_ANGOLA]: "Angola",
  [COUNTRY_ANTARCTICA]: "Antarctica",
  [COUNTRY_ARGENTINA]: "Argentina",
  [COUNTRY_AMERICAN_SAMOA]: "American Samoa",
  [COUNTRY_AUSTRIA]: "Austria",
  [COUNTRY_AUSTRALIA]: "Australia",
  [COUNTRY_ARUBA]: "Aruba",
  [COUNTRY_ALLAND_ISLANDS]: "Alland Islands",
  [COUNTRY_AZERBAIJAN]: "Azerbaijan",
  [COUNTRY_BOSNIA_AND_HERZEGOVINA]: "Bosnia and Herzegovina",
  [COUNTRY_BARBADOS]: "Barbados",
  [COUNTRY_BANGLADESH]: "Bangladesh",
  [COUNTRY_BELGIUM]: "Belgium",
  [COUNTRY_BURKINA_FASO]: "Burkina Faso",
  [COUNTRY_BULGARIA]: "Bulgaria",
  [COUNTRY_BAHRAIN]: "Bahrain",
  [COUNTRY_BURUNDI]: "Burundi",
  [COUNTRY_BENIN]: "Benin",
  [COUNTRY_SAINT_BARTHELEMY]: "Saint Barthelemy",
  [COUNTRY_BERMUDA]: "Bermuda",
  [COUNTRY_BRUNEI_DARUSSALAM]: "Brunei Darussalam",
  [COUNTRY_BOLIVIA]: "Bolivia",
  [COUNTRY_BRAZIL]: "Brazil",
  [COUNTRY_BAHAMAS]: "Bahamas",
  [COUNTRY_BHUTAN]: "Bhutan",
  [COUNTRY_BOUVET_ISLAND]: "Bouvet Island",
  [COUNTRY_BOTSWANA]: "Botswana",
  [COUNTRY_BELARUS]: "Belarus",
  [COUNTRY_BELIZE]: "Belize",
  [COUNTRY_CANADA]: "Canada",
  [COUNTRY_COCOS_KEELING_ISLANDS]: "Cocos (Keeling) Islands",
  [COUNTRY_CONGO_DEMOCRATIC_REPUBLIC_OF_THE]:
    "Congo, Democratic Republic of the",
  [COUNTRY_CENTRAL_AFRICAN_REPUBLIC]: "Central African Republic",
  [COUNTRY_CONGO_REPUBLIC_OF_THE]: "Congo, Republic of the",
  [COUNTRY_SWITZERLAND]: "Switzerland",
  [COUNTRY_COTE_D_IVOIRE]: "Côte d'Ivoire",
  [COUNTRY_COOK_ISLANDS]: "Cook Islands",
  [COUNTRY_CHILE]: "Chile",
  [COUNTRY_CAMEROON]: "Cameroon",
  [COUNTRY_CHINA]: "China",
  [COUNTRY_COLOMBIA]: "Colombia",
  [COUNTRY_COSTA_RICA]: "Costa Rica",
  [COUNTRY_CUBA]: "Cuba",
  [COUNTRY_CAPE_VERDE]: "Cape Verde",
  [COUNTRY_CURACAO]: "Curaçao",
  [COUNTRY_CHRISTMAS_ISLAND]: "Christmas Island",
  [COUNTRY_CYPRUS]: "Cyprus",
  [COUNTRY_CZECH_REPUBLIC]: "Czech Republic",
  [COUNTRY_GERMANY]: "Germany",
  [COUNTRY_DJIBOUTI]: "Djibouti",
  [COUNTRY_DENMARK]: "Denmark",
  [COUNTRY_DOMINICA]: "Dominica",
  [COUNTRY_DOMINICAN_REPUBLIC]: "Dominican Republic",
  [COUNTRY_ALGERIA]: "Algeria",
  [COUNTRY_ECUADOR]: "Ecuador",
  [COUNTRY_ESTONIA]: "Estonia",
  [COUNTRY_EGYPT]: "Egypt",
  [COUNTRY_WESTERN_SAHARA]: "Western Sahara",
  [COUNTRY_ERITREA]: "Eritrea",
  [COUNTRY_SPAIN]: "Spain",
  [COUNTRY_ETHIOPIA]: "Ethiopia",
  [COUNTRY_FINLAND]: "Finland",
  [COUNTRY_FIJI]: "Fiji",
  [COUNTRY_FALKLAND_ISLANDS_MALVINAS]: "Falkland Islands (Malvinas)",
  [COUNTRY_MICRONESIA_FEDERATED_STATES_OF]: "Micronesia, Federated States of",
  [COUNTRY_FAROE_ISLANDS]: "Faroe Islands",
  [COUNTRY_FRANCE]: "France",
  [COUNTRY_GABON]: "Gabon",
  [COUNTRY_UNITED_KINGDOM]: "United Kingdom",
  [COUNTRY_GRENADA]: "Grenada",
  [COUNTRY_GEORGIA]: "Georgia",
  [COUNTRY_FRENCH_GUIANA]: "French Guiana",
  [COUNTRY_GUERNSEY]: "Guernsey",
  [COUNTRY_GHANA]: "Ghana",
  [COUNTRY_GIBRALTAR]: "Gibraltar",
  [COUNTRY_GREENLAND]: "Greenland",
  [COUNTRY_GAMBIA]: "Gambia",
  [COUNTRY_GUINEA]: "Guinea",
  [COUNTRY_GUADELOUPE]: "Guadeloupe",
  [COUNTRY_EQUATORIAL_GUINEA]: "Equatorial Guinea",
  [COUNTRY_GREECE]: "Greece",
  [COUNTRY_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS]:
    "South Georgia and the South Sandwich Islands",
  [COUNTRY_GUATEMALA]: "Guatemala",
  [COUNTRY_GUAM]: "Guam",
  [COUNTRY_GUINEA_BISSAU]: "Guinea-Bissau",
  [COUNTRY_GUYANA]: "Guyana",
  [COUNTRY_HONG_KONG]: "Hong Kong",
  [COUNTRY_HEARD_ISLAND_AND_MCDONALD_ISLANDS]:
    "Heard Island and McDonald Islands",
  [COUNTRY_HONDURAS]: "Honduras",
  [COUNTRY_CROATIA]: "Croatia",
  [COUNTRY_HAITI]: "Haiti",
  [COUNTRY_HUNGARY]: "Hungary",
  [COUNTRY_INDONESIA]: "Indonesia",
  [COUNTRY_IRELAND]: "Ireland",
  [COUNTRY_ISRAEL]: "Israel",
  [COUNTRY_ISLE_OF_MAN]: "Isle of Man",
  [COUNTRY_INDIA]: "India",
  [COUNTRY_BRITISH_INDIAN_OCEAN_TERRITORY]: "British Indian Ocean Territory",
  [COUNTRY_IRAQ]: "Iraq",
  [COUNTRY_IRAN_ISLAMIC_REPUBLIC_OF]: "Iran, Islamic Republic of",
  [COUNTRY_ICELAND]: "Iceland",
  [COUNTRY_ITALY]: "Italy",
  [COUNTRY_JERSEY]: "Jersey",
  [COUNTRY_JAMAICA]: "Jamaica",
  [COUNTRY_JORDAN]: "Jordan",
  [COUNTRY_JAPAN]: "Japan",
  [COUNTRY_KENYA]: "Kenya",
  [COUNTRY_KYRGYZSTAN]: "Kyrgyzstan",
  [COUNTRY_CAMBODIA]: "Cambodia",
  [COUNTRY_KIRIBATI]: "Kiribati",
  [COUNTRY_COMOROS]: "Comoros",
  [COUNTRY_SAINT_KITTS_AND_NEVIS]: "Saint Kitts and Nevis",
  [COUNTRY_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF]:
    "Korea, Democratic People's Republic of",
  [COUNTRY_KOREA_REPUBLIC_OF]: "Korea, Republic of",
  [COUNTRY_KUWAIT]: "Kuwait",
  [COUNTRY_CAYMAN_ISLANDS]: "Cayman Islands",
  [COUNTRY_KAZAKHSTAN]: "Kazakhstan",
  [COUNTRY_LAO_PEOPLES_DEMOCRATIC_REPUBLIC]: "Lao People's Democratic Republic",
  [COUNTRY_LEBANON]: "Lebanon",
  [COUNTRY_SAINT_LUCIA]: "Saint Lucia",
  [COUNTRY_LIECHTENSTEIN]: "Liechtenstein",
  [COUNTRY_SRI_LANKA]: "Sri Lanka",
  [COUNTRY_LIBERIA]: "Liberia",
  [COUNTRY_LESOTHO]: "Lesotho",
  [COUNTRY_LITHUANIA]: "Lithuania",
  [COUNTRY_LUXEMBOURG]: "Luxembourg",
  [COUNTRY_LATVIA]: "Latvia",
  [COUNTRY_LIBYA]: "Libya",
  [COUNTRY_MOROCCO]: "Morocco",
  [COUNTRY_MONACO]: "Monaco",
  [COUNTRY_MOLDOVA_REPUBLIC_OF]: "Moldova, Republic of",
  [COUNTRY_MONTENEGRO]: "Montenegro",
  [COUNTRY_SAINT_MARTIN_FRENCH_PART]: "Saint Martin (French part)",
  [COUNTRY_MADAGASCAR]: "Madagascar",
  [COUNTRY_MARSHALL_ISLANDS]: "Marshall Islands",
  [COUNTRY_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF]:
    "Macedonia, the Former Yugoslav Republic of",
  [COUNTRY_MALI]: "Mali",
  [COUNTRY_MYANMAR]: "Myanmar",
  [COUNTRY_MONGOLIA]: "Mongolia",
  [COUNTRY_MACAO]: "Macao",
  [COUNTRY_NORTHERN_MARIANA_ISLANDS]: "Northern Mariana Islands",
  [COUNTRY_MARTINIQUE]: "Martinique",
  [COUNTRY_MAURITANIA]: "Mauritania",
  [COUNTRY_MONTSERRAT]: "Montserrat",
  [COUNTRY_MALTA]: "Malta",
  [COUNTRY_MAURITIUS]: "Mauritius",
  [COUNTRY_MALDIVES]: "Maldives",
  [COUNTRY_MALAWI]: "Malawi",
  [COUNTRY_MEXICO]: "Mexico",
  [COUNTRY_MALAYSIA]: "Malaysia",
  [COUNTRY_MOZAMBIQUE]: "Mozambique",
  [COUNTRY_NAMIBIA]: "Namibia",
  [COUNTRY_NEW_CALEDONIA]: "New Caledonia",
  [COUNTRY_NIGER]: "Niger",
  [COUNTRY_NORFOLK_ISLAND]: "Norfolk Island",
  [COUNTRY_NIGERIA]: "Nigeria",
  [COUNTRY_NICARAGUA]: "Nicaragua",
  [COUNTRY_NETHERLANDS]: "Netherlands",
  [COUNTRY_NORWAY]: "Norway",
  [COUNTRY_NEPAL]: "Nepal",
  [COUNTRY_NAURU]: "Nauru",
  [COUNTRY_NIUE]: "Niue",
  [COUNTRY_NEW_ZEALAND]: "New Zealand",
  [COUNTRY_OMAN]: "Oman",
  [COUNTRY_PANAMA]: "Panama",
  [COUNTRY_PERU]: "Peru",
  [COUNTRY_FRENCH_POLYNESIA]: "French Polynesia",
  [COUNTRY_PAPUA_NEW_GUINEA]: "Papua New Guinea",
  [COUNTRY_PHILIPPINES]: "Philippines",
  [COUNTRY_PAKISTAN]: "Pakistan",
  [COUNTRY_POLAND]: "Poland",
  [COUNTRY_SAINT_PIERRE_AND_MIQUELON]: "Saint Pierre and Miquelon",
  [COUNTRY_PITCAIRN]: "Pitcairn",
  [COUNTRY_PUERTO_RICO]: "Puerto Rico",
  [COUNTRY_PALESTINE_STATE_OF]: "Palestine, State of",
  [COUNTRY_PORTUGAL]: "Portugal",
  [COUNTRY_PALAU]: "Palau",
  [COUNTRY_PARAGUAY]: "Paraguay",
  [COUNTRY_QATAR]: "Qatar",
  [COUNTRY_REUNION]: "Réunion",
  [COUNTRY_ROMANIA]: "Romania",
  [COUNTRY_SERBIA]: "Serbia",
  [COUNTRY_RUSSIAN_FEDERATION]: "Russian Federation",
  [COUNTRY_RWANDA]: "Rwanda",
  [COUNTRY_SAUDI_ARABIA]: "Saudi Arabia",
  [COUNTRY_SOLOMON_ISLANDS]: "Solomon Islands",
  [COUNTRY_SEYCHELLES]: "Seychelles",
  [COUNTRY_SUDAN]: "Sudan",
  [COUNTRY_SWEDEN]: "Sweden",
  [COUNTRY_SINGAPORE]: "Singapore",
  [COUNTRY_SAINT_HELENA]: "Saint Helena",
  [COUNTRY_SLOVENIA]: "Slovenia",
  [COUNTRY_SVALBARD_AND_JAN_MAYEN]: "Svalbard and Jan Mayen",
  [COUNTRY_SLOVAKIA]: "Slovakia",
  [COUNTRY_SIERRA_LEONE]: "Sierra Leone",
  [COUNTRY_SAN_MARINO]: "San Marino",
  [COUNTRY_SENEGAL]: "Senegal",
  [COUNTRY_SOMALIA]: "Somalia",
  [COUNTRY_SURINAME]: "Suriname",
  [COUNTRY_SOUTH_SUDAN]: "South Sudan",
  [COUNTRY_SAO_TOME_AND_PRINCIPE]: "Sao Tome and Principe",
  [COUNTRY_EL_SALVADOR]: "El Salvador",
  [COUNTRY_SINT_MAARTEN_DUTCH_PART]: "Sint Maarten (Dutch part)",
  [COUNTRY_SYRIAN_ARAB_REPUBLIC]: "Syrian Arab Republic",
  [COUNTRY_SWAZILAND]: "Swaziland",
  [COUNTRY_TURKS_AND_CAICOS_ISLANDS]: "Turks and Caicos Islands",
  [COUNTRY_CHAD]: "Chad",
  [COUNTRY_FRENCH_SOUTHERN_TERRITORIES]: "French Southern Territories",
  [COUNTRY_TOGO]: "Togo",
  [COUNTRY_THAILAND]: "Thailand",
  [COUNTRY_TAJIKISTAN]: "Tajikistan",
  [COUNTRY_TOKELAU]: "Tokelau",
  [COUNTRY_TIMOR_LESTE]: "Timor-Leste",
  [COUNTRY_TURKMENISTAN]: "Turkmenistan",
  [COUNTRY_TUNISIA]: "Tunisia",
  [COUNTRY_TONGA]: "Tonga",
  [COUNTRY_TURKEY]: "Turkey",
  [COUNTRY_TRINIDAD_AND_TOBAGO]: "Trinidad and Tobago",
  [COUNTRY_TUVALU]: "Tuvalu",
  [COUNTRY_TAIWAN]: "Taiwan",
  [COUNTRY_UNITED_REPUBLIC_OF_TANZANIA]: "United Republic of Tanzania",
  [COUNTRY_UKRAINE]: "Ukraine",
  [COUNTRY_UGANDA]: "Uganda",
  [COUNTRY_UNITED_STATES]: "United States",
  [COUNTRY_URUGUAY]: "Uruguay",
  [COUNTRY_UZBEKISTAN]: "Uzbekistan",
  [COUNTRY_HOLY_SEE_VATICAN_CITY_STATE]: "Holy See (Vatican City State)",
  [COUNTRY_SAINT_VINCENT_AND_THE_GRENADINES]:
    "Saint Vincent and the Grenadines",
  [COUNTRY_VENEZUELA]: "Venezuela",
  [COUNTRY_BRITISH_VIRGIN_ISLANDS]: "British Virgin Islands",
  [COUNTRY_US_VIRGIN_ISLANDS]: "US Virgin Islands",
  [COUNTRY_VIETNAM]: "Vietnam",
  [COUNTRY_VANUATU]: "Vanuatu",
  [COUNTRY_WALLIS_AND_FUTUNA]: "Wallis and Futuna",
  [COUNTRY_SAMOA]: "Samoa",
  [COUNTRY_KOSOVO]: "Kosovo",
  [COUNTRY_YEMEN]: "Yemen",
  [COUNTRY_MAYOTTE]: "Mayotte",
  [COUNTRY_SOUTH_AFRICA]: "South Africa",
  [COUNTRY_ZAMBIA]: "Zambia",
  [COUNTRY_ZIMBABWE]: "Zimbabwe",

  // MODAL CREDITS USAGE DETAILED
  [MODAL_CREDITS_USAGE_DETAILED_TITLE]: "Detailed Usage of Credits",
  [MODAL_CREDITS_USAGE_DETAILED_ARIA_LABEL]: "Detailed Usage of Credits",
  [MODAL_CREDITS_USAGE_DETAILED_LINK]: "View detailed usage",
  [MODAL_CREDITS_USAGE_DETAILED_PERIOD]: "Period: {{from}} — {{to}}",
  [MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_ADVERTISER_TITLE]: "Usage by Brand",
  [MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_USER_TITLE]: "Usage by User",
  [MODAL_CREDITS_USAGE_DETAILED_COLUMN_ADVERTISER]: "Brand",
  [MODAL_CREDITS_USAGE_DETAILED_COLUMN_USER]: "User",
  [MODAL_CREDITS_USAGE_DETAILED_COLUMN_CREDITS_SPENT]: "Credits Spent",
  [MODAL_CREDITS_USAGE_DETAILED_COLUMN_VIDEOS_SPENT]: "Videos",
  [MODAL_CREDITS_USAGE_DETAILED_LOADING]: "Loading credits usage...",
  [MODAL_CREDITS_USAGE_DETAILED_EMPTY]: "No spending recorded in this period",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_TOTAL_CREDITS]:
    "Total Credits: {{value}}",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_CREDITS_BY_GROUP_TITLE]:
    "Total Credits by Group",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_GROUP_CREDITS]:
    "{{agencyName}}: {{value}} Credits",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_GROUP_ACCORDION_TITLE]:
    "Detailed usage of {{agencyName}}",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_EMPTY_GROUPS]: "No groups assigned",
  [MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_CALCULATING]:
    "Calculating brand usage...",

  // PRE-ACTIVACIÓN
  [PRE_ACTIVATION_BADGE]: "PRE-ACTIVATION",
  [PRE_ACTIVATION_SECTION_CONTACT]: "01 · Contact details",
  [PRE_ACTIVATION_SECTION_01_BUSINESS]: "02 · Your business",
  [PRE_ACTIVATION_SECTION_02_CURRENT_ADS]: "03 · Current advertising",
  [PRE_ACTIVATION_SECTION_03_OBJECTIVES]: "04 · Goals",
  [PRE_ACTIVATION_SECTION_04_MEETING_ACCESS]: "05 · Meeting access",
  [PRE_ACTIVATION_HERO_TITLE]: "Tell us about<br/>your <em>business</em>",
  [PRE_ACTIVATION_HERO_DESCRIPTION]:
    "To get the most out of your activation call, complete this form before the call. It takes about 10 minutes and helps us arrive prepared with a personalized strategy for you.",
  [PRE_ACTIVATION_HERO_DESCRIPTION_AGENCY]:
    "To get the most out of your activation, complete this form before the first session. It takes about 5 minutes and lets us arrive with your brand already set up on the platform.",
  [PRE_ACTIVATION_FIELD_BUSINESS_NAME]: "Your company or brand name",
  [PRE_ACTIVATION_FIELD_AGENCY_NAME]: "Your agency name",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_NAME]: "E.g. North Digital Agency",
  [PRE_ACTIVATION_FIELD_FULL_NAME]: "Your full name",
  [PRE_ACTIVATION_FIELD_EMAIL]: "Email",
  [PRE_ACTIVATION_FIELD_WHATSAPP]: "WhatsApp (with country code)",
  [PRE_ACTIVATION_FIELD_WHAT_YOU_SELL]:
    "What do you sell? Describe it in 2–3 sentences",
  [PRE_ACTIVATION_HINT_WHAT_YOU_SELL]:
    "Include what makes you different from competitors.",
  [PRE_ACTIVATION_FIELD_AVERAGE_PRICE]:
    "Average price of your product or service",
  [PRE_ACTIVATION_HINT_AVERAGE_PRICE]:
    "Per unit, pack, or monthly subscription. Indicate the currency.",
  [PRE_ACTIVATION_FIELD_IDEAL_CUSTOMER]: "Who is your ideal customer?",
  [PRE_ACTIVATION_HINT_IDEAL_CUSTOMER]:
    "Age, gender, interests, location, socioeconomic level.",
  [PRE_ACTIVATION_FIELD_WHERE_CUSTOMER_BUYS]: "Where does your customer buy?",
  [PRE_ACTIVATION_FIELD_WEBSITE_URL]: "Your website or store URL",
  [PRE_ACTIVATION_PLACEHOLDER_BUSINESS_NAME]: "E.g. Natura Kids Colombia",
  [PRE_ACTIVATION_PLACEHOLDER_FULL_NAME]: "First and last name",
  [PRE_ACTIVATION_PLACEHOLDER_EMAIL]: "email@company.com",
  [PRE_ACTIVATION_PLACEHOLDER_WHATSAPP]: "+57 300 123 4567",
  [PRE_ACTIVATION_PLACEHOLDER_WHAT_YOU_SELL]:
    "E.g. We sell ergonomic kids’ footwear that supports the foot’s natural shape. Unlike many local brands, we match international-brand quality with local manufacturing…",
  [PRE_ACTIVATION_PLACEHOLDER_AVERAGE_PRICE]:
    "E.g. $48,000 COP per pair / USD 25 per unit",
  [PRE_ACTIVATION_PLACEHOLDER_IDEAL_CUSTOMER]:
    "E.g. Moms aged 25–45, upper-middle SES, focused on children’s health, based in Colombia and Mexico…",
  [PRE_ACTIVATION_PLACEHOLDER_WEBSITE_URL]: "https://yourstore.com",
  [PRE_ACTIVATION_SALES_CHANNEL_TIENDA_WEB]: "Online store / e-commerce",
  [PRE_ACTIVATION_SALES_CHANNEL_TIENDA_FISICA]: "Physical store",
  [PRE_ACTIVATION_SALES_CHANNEL_WHATSAPP]: "WhatsApp / direct DM",
  [PRE_ACTIVATION_SALES_CHANNEL_MARKETPLACE]:
    "Marketplace (Mercado Libre, Amazon, etc.)",
  [PRE_ACTIVATION_SALES_CHANNEL_APP]: "Mobile app",
  [PRE_ACTIVATION_FIELD_HAS_ADS]: "Do you already invest in paid advertising?",
  [PRE_ACTIVATION_HAS_ADS_SI]: "Yes, I have active campaigns",
  [PRE_ACTIVATION_HAS_ADS_ANTES]:
    "Yes, but I don’t have active campaigns right now",
  [PRE_ACTIVATION_HAS_ADS_NO]: "No, this is my first time with paid ads",
  [PRE_ACTIVATION_FIELD_AD_PLATFORMS]:
    "Which platforms have you run or run campaigns on?",
  [PRE_ACTIVATION_ADS_PLATFORM_META]: "Meta Ads (Facebook / Instagram)",
  [PRE_ACTIVATION_ADS_PLATFORM_GOOGLE]: "Google Ads",
  [PRE_ACTIVATION_ADS_PLATFORM_TIKTOK]: "TikTok Ads",
  [PRE_ACTIVATION_ADS_PLATFORM_OTHER]: "Other (LinkedIn, X, Pinterest, etc.)",
  [PRE_ACTIVATION_PLACEHOLDER_ADS_PLATFORM_OTHER]: "Specify the platform",
  [PRE_ACTIVATION_FIELD_MONTHLY_AD_SPEND]:
    "How much do you spend on advertising per month?",
  [PRE_ACTIVATION_HINT_MONTHLY_AD_SPEND]:
    "Total across all platforms. Indicate the currency.",
  [PRE_ACTIVATION_FIELD_CURRENT_METRICS]: "Current metrics (if you have them)",
  [PRE_ACTIVATION_HINT_CURRENT_METRICS]:
    "ROAS, CPA, CTR, conversions by platform. Don’t worry if you don’t have them handy.",
  [PRE_ACTIVATION_FIELD_TARGET_CPA]: "What is your target CPA?",
  [PRE_ACTIVATION_HINT_TARGET_CPA]:
    "How much are you willing to pay per sale or lead?",
  [PRE_ACTIVATION_FIELD_BEST_CAMPAIGN_MESSAGES]:
    "Which campaigns or messages have worked best for you?",
  [PRE_ACTIVATION_HINT_BEST_CAMPAIGN_MESSAGES]:
    "Formats (video, image, carousel), audiences, creative angles, etc. If you have no history, leave it blank.",
  [PRE_ACTIVATION_PLACEHOLDER_MONTHLY_AD_SPEND]:
    "E.g. USD 700 / month · $3,000,000 COP / month · I don’t have current ad spend",
  [PRE_ACTIVATION_PLACEHOLDER_CURRENT_METRICS]:
    "E.g. Meta Ads: ROAS 4.5, CPA $15,000 COP · Google Ads Search: ROAS 5.15, 23 conversions · I don’t have data yet",
  [PRE_ACTIVATION_PLACEHOLDER_TARGET_CPA]:
    "E.g. $6,000 COP per purchase / USD 15 per lead",
  [PRE_ACTIVATION_PLACEHOLDER_BEST_CAMPAIGN_MESSAGES]:
    "E.g. Static discount images on Instagram outperform video for us. Audiences of moms aged 28–40 convert much better…",
  [PRE_ACTIVATION_FIELD_MONTHLY_SALES]: "What are your current monthly sales?",
  [PRE_ACTIVATION_FIELD_SALES_GOAL_60_90]:
    "What is your sales goal for the next 60–90 days?",
  [PRE_ACTIVATION_FIELD_BUZZLY_FOCUS]: "What is your main focus with Adle?",
  [PRE_ACTIVATION_BUZZLY_FOCUS_PERFORMANCE]:
    "Performance — I want more sales and measurable results",
  [PRE_ACTIVATION_BUZZLY_FOCUS_CONTENIDO]:
    "Content — I want to generate quality creatives and ads with AI",
  [PRE_ACTIVATION_BUZZLY_FOCUS_AMBOS]:
    "Both — performance and content production",
  [PRE_ACTIVATION_FIELD_CREATIVE_MATERIAL_LEVEL]:
    "Do you have creative assets available?",
  [PRE_ACTIVATION_HINT_CREATIVE_MATERIAL_LEVEL]:
    "Product photos, videos, high-res logo, branding, etc.",
  [PRE_ACTIVATION_CREATIVE_MATERIAL_SI_MUCHO]:
    "Yes, I have plenty of material ready",
  [PRE_ACTIVATION_CREATIVE_MATERIAL_SI_POCO]: "I have some, but not much",
  [PRE_ACTIVATION_CREATIVE_MATERIAL_NO_IA]:
    "No, I prefer to generate everything with AI in Adle",
  [PRE_ACTIVATION_FIELD_CREATIVE_MATERIAL_LOCATION]:
    "Where is your creative material?",
  [PRE_ACTIVATION_FIELD_ADDITIONAL_MEETING_NOTES]:
    "Anything else we should know before the call?",
  [PRE_ACTIVATION_PLACEHOLDER_MONTHLY_SALES]:
    "E.g. 150 pairs / month · $8M COP / month · 50 leads / month",
  [PRE_ACTIVATION_PLACEHOLDER_SALES_GOAL_60_90]:
    "E.g. 300 pairs / month · $20M COP / month · 150 leads / month",
  [PRE_ACTIVATION_PLACEHOLDER_CREATIVE_MATERIAL_LOCATION]:
    "E.g. Google Drive (I’ll share a link) · Dropbox · On my phone · We keep it on social media",
  [PRE_ACTIVATION_PLACEHOLDER_ADDITIONAL_MEETING_NOTES]:
    "Seasonality, upcoming launches, budget limits, something that didn’t work before, anything that helps us prepare better…",
  [PRE_ACTIVATION_MEETING_INTRO]:
    "For the activation call we need you to have access to your advertising platforms ready. Without access, we cannot set up campaigns during the call.",
  [PRE_ACTIVATION_FIELD_MEETING_ACCESS]:
    "Which of these access will you have ready for the call?",
  [PRE_ACTIVATION_MEETING_ACCESS_META_BM]: "Meta Business Manager (admin)",
  [PRE_ACTIVATION_MEETING_ACCESS_GOOGLE_ADS]: "Google Ads (admin)",
  [PRE_ACTIVATION_MEETING_ACCESS_TIKTOK_ADS]: "TikTok Ads Manager",
  [PRE_ACTIVATION_MEETING_ACCESS_GA4]: "Google Analytics 4 / GA4",
  [PRE_ACTIVATION_MEETING_ACCESS_PIXEL]: "Meta Pixel installed on the site",
  [PRE_ACTIVATION_MEETING_ACCESS_GTM]: "Google Tag Manager",
  [PRE_ACTIVATION_FIELD_ACCESS_NOT_READY]:
    "Is there any access you don’t have ready yet?",
  [PRE_ACTIVATION_HINT_ACCESS_NOT_READY]:
    "Tell us so we can help you resolve it before the call.",
  [PRE_ACTIVATION_PLACEHOLDER_ACCESS_NOT_READY]:
    "E.g. Google Ads is managed by our previous agency; I’m coordinating to get access. I’m not sure if the Meta Pixel is installed…",
  [PRE_ACTIVATION_ARIA_REQUIRED]: "required",
  [PRE_ACTIVATION_SUBMIT_BUTTON]: "Submit form →",
  [PRE_ACTIVATION_SUBMIT_SUCCESS_TITLE]: "Form submitted",
  [PRE_ACTIVATION_SUBMIT_SUCCESS_MESSAGE]:
    "Your information was registered successfully. We’ll be in touch soon to schedule the activation meeting.",
  [PRE_ACTIVATION_CONFIDENTIALITY_NOTE]:
    "Your information is 100% confidential and will only be used by the Adle team to prepare your activation.",
  [PRE_ACTIVATION_FIELD_ORGANIZATION_TYPE]: "Are you an agency or a brand?",
  [PRE_ACTIVATION_HINT_ORGANIZATION_TYPE]:
    "Select the profile that best describes your operation so we show the right questions.",
  [PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY_LABEL]: "Agency",
  [PRE_ACTIVATION_ORGANIZATION_TYPE_BRAND_LABEL]: "Brand",
  [PRE_ACTIVATION_FIELD_JOB_TITLE]: "Job title / role",
  [PRE_ACTIVATION_PLACEHOLDER_JOB_TITLE]:
    "E.g. CEO, Media Buyer, Marketing Director",
  [PRE_ACTIVATION_SECTION_AGENCY_01_BASICS]: "02 · Agency basics",
  [PRE_ACTIVATION_SECTION_AGENCY_02_LIVE_EXERCISE]:
    "03 · Brand for the live exercise",
  [PRE_ACTIVATION_SECTION_AGENCY_03_OPERATIONS]: "04 · Current operations",
  [PRE_ACTIVATION_SECTION_AGENCY_04_MEETING_ACCESS]: "05 · Access for the call",
  [PRE_ACTIVATION_FIELD_AGENCY_PLATFORM_USERS_COUNT]:
    "How many team members will use Adle?",
  [PRE_ACTIVATION_HINT_AGENCY_PLATFORM_USERS_COUNT]:
    "So we can prepare seats and user setup.",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_PLATFORM_USERS_COUNT]:
    "E.g. 3 media buyers + 1 creative director",
  [PRE_ACTIVATION_FIELD_AGENCY_AD_PLATFORMS]:
    "Which platforms will you operate in Adle?",
  [PRE_ACTIVATION_FIELD_AGENCY_MODULES]: "Which modules will you use?",
  [PRE_ACTIVATION_HINT_AGENCY_MODULES]:
    "Select all that apply. We use this to shape the content of both sessions.",
  [PRE_ACTIVATION_AGENCY_MODULE_CREATIVE]: "Design and creative generation",
  [PRE_ACTIVATION_AGENCY_MODULE_PAID_MEDIA]:
    "Campaign implementation and optimization and paid media",
  [PRE_ACTIVATION_AGENCY_MODULE_ORGANIC_SOCIAL]: "Social media publishing",
  [PRE_ACTIVATION_AGENCY_MODULE_COMPETITOR_ADS]: "Competitor ads analysis",
  [PRE_ACTIVATION_FIELD_AGENCY_SESSION_BRAND_NAME]:
    "Which brand from your portfolio do you want to use in the sessions?",
  [PRE_ACTIVATION_HINT_AGENCY_SESSION_BRAND_NAME]:
    "It must be a real, active brand with assets available.",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_SESSION_BRAND_NAME]:
    "E.g. Brand X — beauty retail",
  [PRE_ACTIVATION_FIELD_AGENCY_BRAND_ASSETS_READY]:
    "Do you have that brand’s assets ready to share — logos, palettes, product photos?",
  [PRE_ACTIVATION_HINT_AGENCY_BRAND_ASSETS_READY]:
    "This helps us move faster during the live session.",
  [PRE_ACTIVATION_FIELD_AGENCY_CREATIVE_BOTTLENECK]:
    "Which part of the creative process takes the most time today?",
  [PRE_ACTIVATION_HINT_AGENCY_CREATIVE_BOTTLENECK]:
    "Briefs, production, adaptations, approvals, etc.",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_CREATIVE_BOTTLENECK]:
    "E.g. Adapting creatives across formats and brands takes most of our team’s time.",
  [PRE_ACTIVATION_FIELD_AGENCY_USES_AD_AUTOMATION]:
    "Are you currently using any ad automation tools?",
  [PRE_ACTIVATION_HINT_AGENCY_USES_AD_AUTOMATION]:
    "Rules, scripts, bulk edit tools, etc.",
  [PRE_ACTIVATION_OPTION_YES]: "Yes",
  [PRE_ACTIVATION_OPTION_NO]: "No",
  [PRE_ACTIVATION_BEFORE_START_LABEL]: "Before you start",
  [PRE_ACTIVATION_BEFORE_START_TITLE]:
    "How to get the most out of your activation",
  [PRE_ACTIVATION_BEFORE_START_INTRO]:
    "There are two sessions, and the second builds on the first. They are not repeated: what you do not cover is not picked up later. Five things make the difference.",
  [PRE_ACTIVATION_BEFORE_START_TIP_1_TITLE]:
    "Have the people who will operate attend",
  [PRE_ACTIVATION_BEFORE_START_TIP_1_DESCRIPTION]:
    "Training is not delegable. If one person attends and then explains it to the rest, you end up with two ways of working. Make sure that whoever will operate the platform blocks the calendar for both sessions.",
  [PRE_ACTIVATION_BEFORE_START_TIP_2_TITLE]:
    "Have leadership in the first session",
  [PRE_ACTIVATION_BEFORE_START_TIP_2_DESCRIPTION]:
    "This is the most important point on this list. When the owner or agency director joins the first session, the team understands that Adle is the platform they will operate with — not a parallel trial they can drop at the first friction. Without that signal, people go back to their usual way of working within a few days and the activation is left hanging.\n\nIf they can also join the second session, even better: that is the one that shows real results, and the decisions to scale come from there.",
  [PRE_ACTIVATION_BEFORE_START_TIP_3_TITLE]:
    "Have measurement ready before session 2",
  [PRE_ACTIVATION_BEFORE_START_TIP_3_DESCRIPTION]:
    "That is when we launch a real campaign. If the pixel is not installed or conversion events are not configured, there is no launch and it gets rescheduled. Assign this to whoever handles the technical side of that brand.",
  [PRE_ACTIVATION_BEFORE_START_TIP_4_TITLE]: "Have access and assets on hand",
  [PRE_ACTIVATION_BEFORE_START_TIP_4_DESCRIPTION]:
    "You connect your accounts in the first session, so whoever attends needs to be an admin that day. Also have brand assets on hand, such as logos, palette, fonts and product photos, to compare live what the AI generates from your website and correct it on the spot if needed.",
  [PRE_ACTIVATION_BEFORE_START_TIP_5_TITLE]:
    "Choose the exercise brand carefully",
  [PRE_ACTIVATION_BEFORE_START_TIP_5_DESCRIPTION]:
    "Everything is done on a single brand. Pick one that is active, with assets available and measurement working. You can replicate the rest afterward.",
  [PRE_ACTIVATION_BEFORE_START_CALLOUT]:
    "If the form arrives incomplete or access is not ready, the session is rescheduled at no extra cost, but your plan cycle keeps running from the date of your first payment.",
  [PRE_ACTIVATION_ADS_PLATFORM_LINKEDIN]: "LinkedIn Ads",
  [PRE_ACTIVATION_FIELD_AGENCY_PHONE]: "Phone",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_PHONE]: "+57 300 000 0000",
  [PRE_ACTIVATION_FIELD_AGENCY_JOB_TITLE]: "Job title",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_JOB_TITLE]: "E.g. Media Director",
  [PRE_ACTIVATION_FIELD_AGENCY_BACKUP_CONTACT]: "Backup contact",
  [PRE_ACTIVATION_HINT_AGENCY_BACKUP_CONTACT]:
    "A second person with decision-making authority, whom we can contact if the primary contact is unavailable",
  [PRE_ACTIVATION_FIELD_AGENCY_LEADERSHIP_CONTACT]:
    "Who from leadership will join the activation?",
  [PRE_ACTIVATION_HINT_AGENCY_LEADERSHIP_CONTACT]:
    "Their participation in the first session is essential. It is the signal that the team can prioritize the activation",
  [PRE_ACTIVATION_SECTION_CONTACT_DESCRIPTION_AGENCY]:
    "Information about the person responsible for the activation and backup contacts.",
  [PRE_ACTIVATION_SECTION_AGENCY_02_TITLE]: "02 · Modules",
  [PRE_ACTIVATION_SECTION_AGENCY_02_SUBTITLE]:
    "Feeds Session 1 · Configuration",
  [PRE_ACTIVATION_SECTION_AGENCY_03_TITLE]: "03 · Your team",
  [PRE_ACTIVATION_SECTION_AGENCY_03_SUBTITLE]: "Feeds Session 1 · Training",
  [PRE_ACTIVATION_SECTION_AGENCY_04_TITLE]: "04 · The exercise brand",
  [PRE_ACTIVATION_SECTION_AGENCY_04_SUBTITLE]: "Feeds Session 1 · Base setup",
  [PRE_ACTIVATION_SECTION_AGENCY_04_DESCRIPTION]:
    "The entire activation runs on a single brand. You configure the rest afterward, replicating the same flow.",
  [PRE_ACTIVATION_SECTION_AGENCY_05_TITLE]: "05 · Book your first session",
  [PRE_ACTIVATION_SECTION_AGENCY_05_SUBTITLE]:
    "Session 1 · Onboarding and setup",
  [PRE_ACTIVATION_SECTION_AGENCY_05_DESCRIPTION]:
    "Book your onboarding session here. We coordinate the second session with you at the end of the first one, once we know how your setup is going.",
  [PRE_ACTIVATION_SECTION_AGENCY_06_TITLE]: "06 · Confirmations",
  [PRE_ACTIVATION_SECTION_AGENCY_06_HEADING]: "Before submitting",
  [PRE_ACTIVATION_FIELD_AGENCY_USER_FULL_NAME]: "Full name",
  [PRE_ACTIVATION_FIELD_AGENCY_USER_EMAIL]: "Email",
  [PRE_ACTIVATION_FIELD_AGENCY_TEAM_FAMILIARITY]:
    "How familiar is the team with paid media management?",
  [PRE_ACTIVATION_HINT_AGENCY_TEAM_FAMILIARITY]:
    "It lets us adjust the pace and depth of the first session.",
  [PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_ADVANCED]:
    "Advanced — they structure and optimize campaigns daily",
  [PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INTERMEDIATE]:
    "Intermediate — they launch campaigns but do not optimize systematically",
  [PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INITIAL]:
    "Beginner — the team is learning paid media",
  [PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_MIXED]:
    "Mixed — there are profiles at both levels",
  [PRE_ACTIVATION_AGENCY_TEAM_CALLOUT]:
    "Training cannot be delegated: the person who operates the platform is the one who receives the training, and they must attend both sessions.",
  [PRE_ACTIVATION_FIELD_AGENCY_BRAND_WEBSITE]: "Website URL for that brand",
  [PRE_ACTIVATION_HINT_AGENCY_BRAND_WEBSITE]:
    "From here our AI extracts the visual identity, language and business context to leave the brand preconfigured before the first session",
  [PRE_ACTIVATION_PLACEHOLDER_AGENCY_BRAND_WEBSITE]: "https://www.marca.com",
  [PRE_ACTIVATION_AGENCY_SCHEDULE_BUTTON]: "Book my onboarding session →",
  [PRE_ACTIVATION_AGENCY_SCHEDULE_LOCKED_HINT]:
    "To book the session you must complete the information in the previous sections.",
  [PRE_ACTIVATION_ONBOARDING_MODAL_ARIA_LABEL]:
    "Onboarding session booking modal",
  [PRE_ACTIVATION_ONBOARDING_MODAL_TITLE]: "Book onboarding session",
  [PRE_ACTIVATION_ONBOARDING_MODAL_DESCRIPTION]:
    "Choose a date and time for your onboarding session.",
  [PRE_ACTIVATION_SCHEDULED_SESSION_TITLE]: "Session booked",
  [PRE_ACTIVATION_SCHEDULED_SESSION_DATE]: "Date",
  [PRE_ACTIVATION_SCHEDULED_SESSION_TIME]: "Time",
  [PRE_ACTIVATION_SCHEDULED_SESSION_MISSING]:
    "This submission does not have a booked onboarding session.",
  [PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_SINGLE_BRAND]:
    "I understand that the activation covers a single brand, and that I will configure the others myself by replicating the same flow.",
  [PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_ACCOUNT_ADMIN]:
    "I understand that my team connects their own ad accounts during session 1 and keeps their administration.",
  [PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_RESCHEDULE]:
    "I understand that if the information or access is not ready, the session is rescheduled at no extra cost, but my plan cycle keeps running from the date of the first payment.",
  [PRE_ACTIVATION_SUBMIT_SUCCESS_MESSAGE_AGENCY]:
    "Your information was registered successfully.",
  [OWNER_FORM_SUBMISSION_COLUMN_ORGANIZATION_TYPE]: "Profile",

  // TIKTOK ADGROUP PLACEMENTS
  [TIKTOK_ADGROUP_PLACEMENTS_TITLE]: "Placements",
  [TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_LABEL]: "TikTok",
  [TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_DESCRIPTION]: "Show your ads on TikTok",
  [TIKTOK_ADGROUP_PLACEMENTS_PANGLE_LABEL]: "Pangle",
  [TIKTOK_ADGROUP_PLACEMENTS_PANGLE_DESCRIPTION]:
    "Pangle, TikTok for Business's advertising network, lets advertisers reach users in apps and websites outside TikTok.",

  // APPSUMO CALLBACK
  [APPSUMO_CALLBACK_CONNECTING]: "Connecting with AppSumo…",
  [APPSUMO_CALLBACK_ERROR_TITLE]: "Connection error",
  [APPSUMO_CALLBACK_ERROR_DESCRIPTION]:
    "There was an error connecting your AppSumo account. Please try again from AppSumo or contact support.",
  [APPSUMO_CALLBACK_ERROR_CODE_EXPIRED]:
    "This link has expired or has already been used. Please restart the process from AppSumo.",
  [APPSUMO_CALLBACK_ERROR_OAUTH_DENIED]:
    "Access was denied. Please try again from AppSumo.",
  [APPSUMO_CALLBACK_BUTTON_RETURN_TO_APPSUMO]: "Return to AppSumo",
  [APPSUMO_CALLBACK_ERROR_ANOMALOUS]:
    "An unexpected error occurred with your account. Please contact support.",

  // MODAL PERFORMANCE MARKETING SPECIALIST
  [BUTTON_HIRE_PERFORMANCE_SPECIALIST]: "Hire Specialist",
  [MODAL_PERFORMANCE_SPECIALIST_ARIA_LABEL]:
    "Performance Marketing Specialist modal",
  [MODAL_PERFORMANCE_SPECIALIST_TITLE]: "Performance Marketing Specialist",
  [MODAL_PERFORMANCE_SPECIALIST_SUBTITLE]:
    "100% service managed by us: We align on goals with you, then we execute, optimize, and report.",
  [MODAL_PERFORMANCE_SPECIALIST_WHAT_YOU_GET_TITLE]: "What we'll do for you",
  [MODAL_PERFORMANCE_SPECIALIST_FEATURE_1]: "Strategy and KPI definition",
  [MODAL_PERFORMANCE_SPECIALIST_FEATURE_2]:
    "Ongoing optimization in Meta, Google, and TikTok",
  [MODAL_PERFORMANCE_SPECIALIST_FEATURE_3]:
    "Tracking, measurement, and attribution review",
  [MODAL_PERFORMANCE_SPECIALIST_FEATURE_4]:
    "Weekly insights and monthly reporting",
  [MODAL_PERFORMANCE_SPECIALIST_PRICING_TITLE]: "Pricing & conditions",
  [MODAL_PERFORMANCE_SPECIALIST_PRICING_MAIN]:
    "USD 499/month + {{percentage}}% of monthly ad spend",
  [MODAL_PERFORMANCE_SPECIALIST_PRICING_NOTE_1]:
    "Ad spend is not included and is paid directly to the platforms.",
  [MODAL_PERFORMANCE_SPECIALIST_PRICING_NOTE_2]: "3-month minimum commitment.",
  [MODAL_PERFORMANCE_SPECIALIST_CTA]: "Hire Specialist",

  // MODAL AD HOC SUPPORT
  [MODAL_AD_HOC_SUPPORT_ARIA_LABEL]: "Support session modal",
  [MODAL_AD_HOC_SUPPORT_TITLE]: "Support Session",
  [MODAL_AD_HOC_SUPPORT_DESCRIPTION]:
    "Schedule a support session with our team to boost your results.",
  [BILLING_SPECIALIST_PURCHASE_SUCCESS_TITLE]: "Payment Successful",
  [BILLING_SPECIALIST_PURCHASE_SUCCESS_DESCRIPTION]:
    "You have hired a specialist; the next step is to schedule a meeting with our team",
  [BILLING_SPECIALIST_SCHEDULE_MEETING_BUTTON]: "Schedule Meeting",

  // APPSUMO REGISTER
  [APPSUMO_REGISTER_TITLE]: "Create your account",
  [APPSUMO_REGISTER_SUBTITLE]:
    "Complete your registration to activate your AppSumo license.",
  [APPSUMO_REGISTER_BUTTON_SUBMIT]: "Create account",
  [APPSUMO_REGISTER_SESSION_EXPIRED]:
    "Your session has expired. Please restart the process from AppSumo.",
  [APP_SUMO_REACTIVATION_NOT_ELIGIBLE]:
    "This account cannot be reactivated through AppSumo. Try logging in or contact support.",
  [APPSUMO_REACTIVATION_OTP_TITLE]: "Reactivate your account",
  [APPSUMO_REACTIVATION_OTP_EMAIL_SENT]:
    "We sent a reactivation code to {{emailMasked}}.",

  // ENTERPRISE INTAKE
  [ENTERPRISE_INTAKE_BADGE]: "Enterprise Intake",
  [ENTERPRISE_INTAKE_BADGE_AGENCY]: "ENTERPRISE PROPOSAL · AGENCIES",
  [ENTERPRISE_INTAKE_BADGE_BRAND]: "ENTERPRISE PROPOSAL · BRANDS",
  [ENTERPRISE_INTAKE_HERO_TITLE]: "Enterprise Intake Form",
  [ENTERPRISE_INTAKE_HERO_DESCRIPTION]:
    "With these answers we prepare a proposal tailored to your operation. Estimated time: 5 minutes.",
  [ENTERPRISE_INTAKE_SECTION_01_CONTACT]: "Contact",
  [ENTERPRISE_INTAKE_SECTION_02_MODULE_SELECTOR]: "Scope",
  [ENTERPRISE_INTAKE_SECTION_03_USERS]: "Users",
  [ENTERPRISE_INTAKE_SECTION_04_SUPPORT_CONTRACT]: "Plan",
  [ENTERPRISE_INTAKE_SECTION_05_ADDITIONAL_NOTES]: "Additional notes",
  [ENTERPRISE_INTAKE_ARIA_REQUIRED]: "required",
  [ENTERPRISE_INTAKE_SUBMIT_BUTTON]: "Submit form →",
  [ENTERPRISE_INTAKE_SUBMIT_SUCCESS_TITLE]: "Form Submitted",
  [ENTERPRISE_INTAKE_SUBMIT_SUCCESS_MESSAGE]:
    "Your information was registered successfully. We will prepare your Enterprise proposal within 24–48 hours and reach out to you.",
  [ENTERPRISE_INTAKE_CONFIDENTIALITY_NOTE]:
    "Your information is 100% confidential and will only be used by the Adle team to prepare your Enterprise proposal.",
  [ENTERPRISE_INTAKE_OTHER_OPTION]: "Other",
  [ENTERPRISE_INTAKE_OTHER_PLACEHOLDER]: "Specify here…",

  [ENTERPRISE_INTAKE_FIELD_FULL_NAME]: "Full name",
  [ENTERPRISE_INTAKE_FIELD_CORPORATE_EMAIL]: "Corporate email",
  [ENTERPRISE_INTAKE_FIELD_COMPANY_NAME]: "Company",
  [ENTERPRISE_INTAKE_FIELD_JOB_TITLE]: "Job title",
  [ENTERPRISE_INTAKE_FIELD_COMPANY_WEBSITE]: "Company website",
  [ENTERPRISE_INTAKE_PLACEHOLDER_FULL_NAME]: "E.g. Maria Garcia",
  [ENTERPRISE_INTAKE_PLACEHOLDER_CORPORATE_EMAIL]: "E.g. maria@company.com",
  [ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME]: "E.g. Digital Agency Inc.",
  [ENTERPRISE_INTAKE_PLACEHOLDER_JOB_TITLE]: "E.g. Head of Marketing",
  [ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_WEBSITE]:
    "E.g. https://www.company.com",

  [ENTERPRISE_INTAKE_FIELD_PURCHASE_DECISION_MAKER]:
    "Who makes the final purchase decision?",
  [ENTERPRISE_INTAKE_PURCHASE_DECISION_SELF]: "I am the decision maker",
  [ENTERPRISE_INTAKE_PURCHASE_DECISION_COLLECT_INFO]:
    "I gather information; someone else / another area decides",
  [ENTERPRISE_INTAKE_PURCHASE_DECISION_SHARED]:
    "Shared decision across multiple areas",
  [ENTERPRISE_INTAKE_FIELD_CURRENT_TOOL_OR_ADLE_STATUS]:
    "Do you currently use another tool or are you already an Adle client?",
  [ENTERPRISE_INTAKE_CURRENT_TOOL_ADLE_CLIENT]:
    "We are current Adle clients (renewal / expansion)",
  [ENTERPRISE_INTAKE_CURRENT_TOOL_EVALUATING_SWITCH]:
    "We use another tool and are evaluating switching",
  [ENTERPRISE_INTAKE_CURRENT_TOOL_NO_SIMILAR]:
    "We do not use any similar tool today",
  [ENTERPRISE_INTAKE_FIELD_OPERATING_COUNTRIES_COUNT]:
    "How many countries / markets do you operate in?",
  [ENTERPRISE_INTAKE_PLACEHOLDER_OPERATING_COUNTRIES_COUNT]: "E.g.: 3",
  [ENTERPRISE_INTAKE_FIELD_CREATIVES_VARY_BY_MARKET]:
    "If you operate in multiple markets, do creatives vary by country/language?",
  [ENTERPRISE_INTAKE_CREATIVES_VARY_YES_PER_MARKET]:
    "Yes, each market needs its own versions",
  [ENTERPRISE_INTAKE_CREATIVES_VARY_PARTIALLY]:
    "Partially — some assets are adapted per market",
  [ENTERPRISE_INTAKE_CREATIVES_VARY_NO_SAME_MATERIAL]:
    "No, the same material is used everywhere",
  [ENTERPRISE_INTAKE_CREATIVES_VARY_NOT_APPLICABLE]: "Not applicable",

  [ENTERPRISE_INTAKE_HINT_SECTION_02_MODULES]:
    "You can select more than one. Based on your selection, the creative assets and campaigns sections will appear.",
  [ENTERPRISE_INTAKE_FIELD_SELECTED_ADLE_MODULES]:
    "Which Adle modules will you use?",
  [ENTERPRISE_INTAKE_MODULE_CREATIVE_ASSETS]:
    "Module 1 · Creative asset generation: images, adaptations, animations and videos",
  [ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_LAUNCH]:
    "Module 2 · Campaign implementation: create and launch campaigns from Adle",
  [ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_IMPORT]:
    "Module 3 · Monitoring and optimizations: apply optimizations to campaigns",
  [ENTERPRISE_INTAKE_MODULE_ORGANIC_SOCIAL]:
    "Module 6 · Social media: schedule posts on social networks",
  [ENTERPRISE_INTAKE_FIELD_PRIMARY_GOAL]:
    "Main goal you are looking to solve with Adle",
  [ENTERPRISE_INTAKE_PRIMARY_GOAL_CREATIVE_SPEED]:
    "Increase creative speed and volume",
  [ENTERPRISE_INTAKE_PRIMARY_GOAL_PERFORMANCE]:
    "Improve campaign performance / ROI",
  [ENTERPRISE_INTAKE_PRIMARY_GOAL_SCALE_MULTIPLATFORM]:
    "Scale cross-platform campaigns",
  [ENTERPRISE_INTAKE_PRIMARY_GOAL_REDUCE_COSTS]:
    "Reduce asset production costs",
  [ENTERPRISE_INTAKE_PRIMARY_GOAL_CENTRALIZE_OPERATIONS]:
    "Centralize multi-brand / multi-advertiser operations",
  [ENTERPRISE_INTAKE_VOLUME_STABLE_YEAR_ROUND]: "Stable year-round",
  [ENTERPRISE_INTAKE_VOLUME_PEAK_DEMAND]: "Has peak demand periods",

  [ENTERPRISE_INTAKE_SECTION_MODULE_1_CREATIVE_ASSETS]: "Creative assets",
  [ENTERPRISE_INTAKE_MODULE1_INTRO]:
    "Shown and required only if you selected Module 1. Each format and each carousel frame counts as one piece.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_BRANDS_OR_VISUAL_IDENTITIES_COUNT]:
    "How many brands or visual identities will you manage in the creative module?",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_INDEPENDENT_BRAND_CONFIGS_COUNT]:
    "How many INDEPENDENT brand configurations do you need?",
  [ENTERPRISE_INTAKE_MODULE1_HINT_INDEPENDENT_BRAND_CONFIGS]:
    "Each brand or sub-brand with its own brandbook / distinct visual identity requires an independent configuration so AI generates aligned assets. E.g.: one brand with 3 visually distinct sub-brands = 3 configurations.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_NEW_IMAGES_COUNT]:
    "How many static pieces do you need per month?",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_FORMATS_PER_PIECE_AVG]:
    "On average, how many formats / placements do you adapt each piece to?",
  [ENTERPRISE_INTAKE_MODULE1_HINT_FORMATS_PER_PIECE]:
    "E.g.: if one image is published in feed, stories, and a banner, that is 3 formats. When operating across multiple platforms this number is usually between 3 and 5. Each format adaptation counts as an independent action.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_ADDITIONAL_EDITS_COUNT]:
    "How many ADDITIONAL adaptations / edits do you make per month? (optional)",
  [ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_ADDITIONAL_EDITS]:
    "Edits or versions that are not format adaptations — text changes, retouching, etc.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_VIDEOS_COUNT]:
    "How many videos per month?",
  [ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_VIDEOS]:
    "Up to 30 seconds, with script, audio and subtitles.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_IMAGE_ANIMATIONS_COUNT]:
    "How many animations per month?",
  [ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_IMAGE_ANIMATIONS]:
    "Motion over an already approved static piece.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_VERSIONS_PER_PIECE_BEFORE_APPROVAL]:
    "How many versions or adjustments do you make per piece before approval?",
  [ENTERPRISE_INTAKE_MODULE1_HINT_VERSIONS_PER_PIECE]:
    "Each iteration counts as one action.",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_CREATIVE_VOLUME_VARIATION]:
    "Does creative volume vary between months?",
  [ENTERPRISE_INTAKE_MODULE1_FIELD_PEAK_MONTH_PIECES_COUNT]:
    "If there are peaks: how many pieces in a HIGH month?",

  [ENTERPRISE_INTAKE_SECTION_MODULE_2_PAID_MEDIA_LAUNCH]: "Campaigns",
  [ENTERPRISE_INTAKE_MODULE2_INTRO]:
    "Shown and required only if you selected Module 2 or Module 3.",
  [ENTERPRISE_INTAKE_MODULE2_FIELD_AD_ACCOUNTS_OR_ADVERTISERS_COUNT]:
    "How many ad accounts / advertisers will you connect?",
  [ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_CAMPAIGNS_COUNT]:
    "How many campaigns will you implement per month, in total?",
  [ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_CAMPAIGNS]:
    "Each campaign is counted PER PLATFORM. One campaign on Meta, Google, and TikTok counts as 3. Indicate the total activations per channel.",
  [ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_OPTIMIZATIONS_COUNT]:
    "How many optimizations in an average month?",
  [ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_OPTIMIZATIONS]:
    "Performance adjustments on active campaigns. Consider that each active campaign usually requires several adjustments per month to maintain performance; do not underestimate this volume if you manage many campaigns.",
  [ENTERPRISE_INTAKE_MODULE2_FIELD_CAMPAIGN_VOLUME_VARIATION]:
    "Does campaign volume vary between months?",
  [ENTERPRISE_INTAKE_MODULE2_FIELD_PEAK_MONTH_CAMPAIGNS_COUNT]:
    "If there are peaks: how many campaigns in a HIGH month?",

  [ENTERPRISE_INTAKE_SECTION_MODULE_3_PAID_MEDIA_IMPORT]:
    "Module 3 — Paid Media Campaign Import",
  [ENTERPRISE_INTAKE_MODULE3_INTRO]:
    "Answer only if you selected this module. If it does not apply, skip to the next section.",
  [ENTERPRISE_INTAKE_MODULE3_FIELD_CAMPAIGNS_TO_IMPORT]:
    "How many campaigns would you import? (one time, at the start)",
  [ENTERPRISE_INTAKE_MODULE3_FIELD_IMPORT_PLATFORMS]:
    "From which platforms would you import? (select all)",
  [ENTERPRISE_INTAKE_MODULE3_PLATFORM_META]: "Meta",
  [ENTERPRISE_INTAKE_MODULE3_PLATFORM_GOOGLE]: "Google",
  [ENTERPRISE_INTAKE_MODULE3_PLATFORM_TIKTOK]: "TikTok",
  [ENTERPRISE_INTAKE_MODULE3_PLATFORM_LINKEDIN]: "LinkedIn",

  [ENTERPRISE_INTAKE_SECTION_MODULE_4_ORGANIC_SOCIAL]:
    "Module 4 — Social Media / Organic Posts",
  [ENTERPRISE_INTAKE_MODULE4_INTRO]:
    "Answer only if you selected this module. If it does not apply, skip to the next section.",
  [ENTERPRISE_INTAKE_MODULE4_FIELD_MONTHLY_ORGANIC_POSTS]:
    "How many organic posts do you schedule in an average month?",
  [ENTERPRISE_INTAKE_MODULE4_FIELD_SCHEDULING_NETWORKS]:
    "Which networks would you schedule to? (select all)",
  [ENTERPRISE_INTAKE_MODULE4_NETWORK_INSTAGRAM]: "Instagram",
  [ENTERPRISE_INTAKE_MODULE4_NETWORK_FACEBOOK]: "Facebook",
  [ENTERPRISE_INTAKE_MODULE4_NETWORK_TIKTOK]: "TikTok",
  [ENTERPRISE_INTAKE_MODULE4_NETWORK_LINKEDIN]: "LinkedIn",
  [ENTERPRISE_INTAKE_MODULE4_NETWORK_X_TWITTER]: "X / Twitter",
  [ENTERPRISE_INTAKE_MODULE4_FIELD_POST_CREATION_SOURCE]:
    "Are posts created in Adle or do they come ready?",
  [ENTERPRISE_INTAKE_MODULE4_POST_CREATED_IN_ADLE]:
    "Created in Adle (creative + copy)",
  [ENTERPRISE_INTAKE_MODULE4_POST_READY_TO_SCHEDULE]:
    "Ready-made, Adle only schedules",
  [ENTERPRISE_INTAKE_MODULE4_POST_MIXED]: "Mixed",

  [ENTERPRISE_INTAKE_FIELD_ACTIVE_ADVERTISERS_MONTH1]:
    "How many brands will be ACTIVE in Adle during the first month?",
  [ENTERPRISE_INTAKE_HINT_ACTIVE_ADVERTISERS_MONTH1]:
    "Those who will actually operate from day one",
  [ENTERPRISE_INTAKE_FIELD_TOTAL_ADVERTISERS_60_90]:
    "In the next 60–90 days, what will be the TOTAL brands you expect to manage?",
  [ENTERPRISE_INTAKE_HINT_TOTAL_ADVERTISERS_60_90]:
    "Includes month-1 brands + those added later",
  [ENTERPRISE_INTAKE_FIELD_ADMIN_ACCESS_PHASE1]:
    "Do you have admin access to the ad accounts you will connect?",
  [ENTERPRISE_INTAKE_ADMIN_ACCESS_ALL]: "Yes, to all of them",
  [ENTERPRISE_INTAKE_ADMIN_ACCESS_MOST]: "To most of them",
  [ENTERPRISE_INTAKE_ADMIN_ACCESS_SOME]: "To some / not yet",

  [ENTERPRISE_INTAKE_FIELD_PLATFORM_USERS_COUNT]: "How many users need access?",
  [ENTERPRISE_INTAKE_FIELD_PLATFORM_CAPACITY_MANAGEMENT]:
    "How will platform capacity usage be managed?",
  [ENTERPRISE_INTAKE_PLATFORM_CAPACITY_CENTRALIZED_POOL]:
    "Centralized pool (everyone shares the total)",
  [ENTERPRISE_INTAKE_PLATFORM_CAPACITY_ASSIGNED_QUOTAS]:
    "Quotas assigned per account / brand",
  [ENTERPRISE_INTAKE_CREDITS_MIXED]: "Mixed",

  [ENTERPRISE_INTAKE_CREDITS_EQUIVALENCES_TITLE]:
    "Credit equivalences (current Adle model)",
  [ENTERPRISE_INTAKE_CREDITS_RENEWAL_NOTE]:
    "Credits renew monthly and do not roll over.",
  [ENTERPRISE_INTAKE_CREDITS_UNCERTAIN_NOTE]:
    "If you are not 100% sure about volumes, pick the closest range. We will fine-tune the estimate during the validation call.",
  [ENTERPRISE_INTAKE_VOLUME_ZERO]: "0 — won't use",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_ESTIMATED_CREDITS]:
    "Estimated total credits to consume per month",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_ESTIMATED_CREDITS]:
    "If you are not 100% sure about volumes, pick the closest range or leave blank and we will calculate it",

  [ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_IMAGES]: "Estimated AI images per month",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_AI_IMAGES]:
    "Approximate number of AI images generated monthly",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_VIDEOS]: "Estimated AI videos per month",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_AI_VIDEOS]:
    "Approximate number of AI videos generated monthly",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_CAMPAIGNS]:
    "Estimated AI campaigns per month",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_AI_CAMPAIGNS]:
    "Approximate number of AI campaigns created monthly",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_OPTIMIZATIONS]:
    "Estimated AI optimizations per month",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_AI_OPTIMIZATIONS]:
    "Approximate number of AI optimizations run monthly",
  [ENTERPRISE_INTAKE_FIELD_USES_ORGANIC_SCHEDULING]:
    "Will you use organic post scheduling?",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_ORGANIC_POSTS]:
    "Estimated organic posts per month",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_ORGANIC_POSTS]:
    "Approximate number of organic posts scheduled monthly",
  [ENTERPRISE_INTAKE_FIELD_PHASE1_PAID_CHANNELS]:
    "Which channels do you activate campaigns on? (select all)",
  [ENTERPRISE_INTAKE_HINT_PHASE1_PAID_CHANNELS]: "Select all that apply",
  [ENTERPRISE_INTAKE_CHANNEL_META]: "Meta (Facebook / Instagram)",
  [ENTERPRISE_INTAKE_CHANNEL_GOOGLE]: "Google (Ads / Display)",
  [ENTERPRISE_INTAKE_CHANNEL_TIKTOK]: "TikTok",
  [ENTERPRISE_INTAKE_CHANNEL_LINKEDIN]: "LinkedIn",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_AD_SPEND_RANGE]:
    "Monthly ad spend range Adle will manage",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_AD_SPEND_RANGE]:
    "Does not include platform cost",
  [ENTERPRISE_INTAKE_AD_SPEND_LESS_THAN_10K]: "Less than $10k USD",
  [ENTERPRISE_INTAKE_AD_SPEND_MORE_THAN_500K]: "More than $500k USD",

  [ENTERPRISE_INTAKE_FIELD_PLATFORM_MANAGEMENT]:
    "Who will manage the platform?",
  [ENTERPRISE_INTAKE_HINT_PLATFORM_MANAGEMENT]:
    "Indicates whether a paid training kick-off is required",
  [ENTERPRISE_INTAKE_PLATFORM_MGMT_OWN_TEAM]:
    "Our own team (requires training / kick-off)",
  [ENTERPRISE_INTAKE_PLATFORM_MGMT_THIRD_PARTY]:
    "A third party / agency manages it for us",
  [ENTERPRISE_INTAKE_PLATFORM_MGMT_ADLE_OPERATES]:
    "Adle operates the platform for us",
  [ENTERPRISE_INTAKE_FIELD_WHITE_LABEL]: "Do you require white label?",
  [ENTERPRISE_INTAKE_HINT_WHITE_LABEL]:
    "The platform with your own branding. Only with a 12-month contract, and quoted separately.",
  [ENTERPRISE_INTAKE_WHITE_LABEL_ESSENTIAL]: "Yes, it is essential",
  [ENTERPRISE_INTAKE_WHITE_LABEL_INTERESTED]:
    "We are interested, but it is not essential",
  [ENTERPRISE_INTAKE_WHITE_LABEL_NOT_NEEDED]: "We do not need it",
  [ENTERPRISE_INTAKE_WHITE_LABEL_UNSURE]: "I am not sure / let's discuss",
  [ENTERPRISE_INTAKE_FIELD_URGENCY_DEADLINE]:
    "Do you have a deadline or event that creates urgency?",
  [ENTERPRISE_INTAKE_PLACEHOLDER_URGENCY_DEADLINE]:
    "E.g. current contract expiration, campaign launch, client presentation",
  [ENTERPRISE_INTAKE_FIELD_ESTIMATED_TOOL_BUDGET]:
    "Do you have an estimated budget for this tool?",
  [ENTERPRISE_INTAKE_HINT_ESTIMATED_TOOL_BUDGET]:
    "Helps us tailor the proposal to your reality. This is indicative, not a commitment.",
  [ENTERPRISE_INTAKE_BUDGET_LT_1000]: "Less than $1,000 USD/month",
  [ENTERPRISE_INTAKE_BUDGET_1000_2500]: "$1,000 – $2,500 USD/month",
  [ENTERPRISE_INTAKE_BUDGET_2500_5000]: "$2,500 – $5,000 USD/month",
  [ENTERPRISE_INTAKE_BUDGET_5000_10000]: "$5,000 – $10,000 USD/month",
  [ENTERPRISE_INTAKE_BUDGET_GT_10000]: "More than $10,000 USD/month",
  [ENTERPRISE_INTAKE_BUDGET_NOT_DEFINED]: "We do not have a defined budget yet",
  [ENTERPRISE_INTAKE_BUDGET_PREFER_NOT_ANSWER]: "I prefer not to answer",

  [ENTERPRISE_INTAKE_FIELD_SUPPORT_LEVEL]:
    "Level of support and operation required",
  [ENTERPRISE_INTAKE_SUPPORT_TECH_ONLY]:
    "Technology only (self-managed + standard technical support)",
  [ENTERPRISE_INTAKE_SUPPORT_PARTIAL]:
    "Partial support (CSM + adoption / strategy)",
  [ENTERPRISE_INTAKE_SUPPORT_FULL_OPERATION]: "Full operation (Adle executes)",
  [ENTERPRISE_INTAKE_FIELD_CSM_CADENCE]:
    "Contact cadence with the Customer Success Manager (CSM)",
  [ENTERPRISE_INTAKE_CSM_WEEKLY]: "Weekly",
  [ENTERPRISE_INTAKE_CSM_BIWEEKLY]: "Biweekly",
  [ENTERPRISE_INTAKE_CSM_MONTHLY]: "Monthly",
  [ENTERPRISE_INTAKE_CSM_AS_NEEDED]: "Only when needed",
  [ENTERPRISE_INTAKE_FIELD_CONTRACT_FORMAT]: "How long would the contract be?",
  [ENTERPRISE_INTAKE_CONTRACT_MONTHLY]: "Monthly (maximum flexibility)",
  [ENTERPRISE_INTAKE_CONTRACT_QUARTERLY]: "Quarterly",
  [ENTERPRISE_INTAKE_CONTRACT_ANNUAL]: "Annual (best rate)",
  [ENTERPRISE_INTAKE_FIELD_IMPLEMENTATION_TIMELINE]:
    "Desired implementation horizon",
  [ENTERPRISE_INTAKE_HINT_IMPLEMENTATION_TIMELINE]: "From signing to Go-Live",
  [ENTERPRISE_INTAKE_TIMELINE_0_3_DAYS]: "0–3 days",
  [ENTERPRISE_INTAKE_TIMELINE_4_7_DAYS]: "4–7 days",
  [ENTERPRISE_INTAKE_TIMELINE_8_15_DAYS]: "8–15 days",
  [ENTERPRISE_INTAKE_TIMELINE_16_30_DAYS]: "16–30 days",
  [ENTERPRISE_INTAKE_TIMELINE_30_PLUS_DAYS]: "More than 30 days",
  [ENTERPRISE_INTAKE_FIELD_SECURITY_REQUIREMENTS]: "Security / IT requirements",
  [ENTERPRISE_INTAKE_SECURITY_SSO]: "SSO (Single Sign-On) required",
  [ENTERPRISE_INTAKE_SECURITY_AUDIT_LOGS]: "Audit logs and IP control",
  [ENTERPRISE_INTAKE_SECURITY_NOT_APPLICABLE]:
    "Not applicable — email and password access only",

  [ENTERPRISE_INTAKE_FIELD_ADDITIONAL_NOTES]: "Anything else we should know?",
  [ENTERPRISE_INTAKE_HINT_ADDITIONAL_NOTES]:
    "E.g. this is for a bid with a deadline, integrations or IT restrictions.",
  [ENTERPRISE_INTAKE_PLACEHOLDER_ADDITIONAL_NOTES]:
    "E.g. this is for a bid with a deadline, integrations or IT restrictions.",
  [ENTERPRISE_INTAKE_FOOTNOTE_ADDITIONAL_NOTES]:
    "Based on your answers, we will schedule a validation call to refine the estimate before the final proposal.",

  [ENTERPRISE_INTAKE_MODULE_REPORTS]:
    "Module 4 · Reports: view, analyze and download",
  [ENTERPRISE_INTAKE_MODULE_COMPETITORS]:
    "Module 5 · Competitors: analyze competitor ads and use them as reference to generate content",
  [ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT]:
    "How many brands will you set up in Adle?",
  [ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT_AGENCY]:
    "How many brands or advertisers will you set up in Adle?",
  [ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_AGENCY]:
    "Each brand has its own configuration to generate content: brandbook, tone of voice, visual identity, fonts, colors, buyer persona and audience. If a sub-brand has a different style, count it separately. Ad accounts, Facebook pages, Instagram profiles and platforms (Meta, Google, TikTok, LinkedIn) of the same brand do not count separately. If you will only use the campaigns module, count each advertiser.",
  [ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_BRAND]:
    "Each brand has its own configuration to generate content: brandbook, tone of voice, visual identity, fonts, colors, buyer persona and audience. If a sub-brand has a different style, count it separately. Ad accounts, Facebook pages, Instagram profiles and platforms (Meta, Google, TikTok, LinkedIn) of the same brand do not count separately. If you will only use the campaigns module, count each brand that advertises.",
  [ENTERPRISE_INTAKE_PLACEHOLDER_SCOPE_BRANDS_COUNT]: "Number",
  [ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME_BRAND]: "E.g. Brand Inc.",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_STATIC_PIECES]:
    "E.g. 100 pieces in 3 formats are 300 pieces.",
  [ENTERPRISE_INTAKE_FIELD_CREATIVES_BUFFER]:
    "Do you want buffer? For which generations?",
  [ENTERPRISE_INTAKE_HINT_CREATIVES_BUFFER]:
    "Extra margin over the monthly volume for adjustments and new versions: each adjustment consumes the same as generating the piece again. Enterprise plans usually take 15%. E.g. 100 statics with 15% = 115 in the plan.",
  [ENTERPRISE_INTAKE_BUFFER_STATICS]: "Statics",
  [ENTERPRISE_INTAKE_BUFFER_ANIMATIONS]: "Animations",
  [ENTERPRISE_INTAKE_BUFFER_VIDEOS]: "Videos",
  [ENTERPRISE_INTAKE_BUFFER_NONE]: "We do not need buffer",
  [ENTERPRISE_INTAKE_FIELD_CREATIVES_BUFFER_PERCENT]: "How much?",
  [ENTERPRISE_INTAKE_BUFFER_PERCENT_10]: "10%",
  [ENTERPRISE_INTAKE_BUFFER_PERCENT_15]: "15% · recommended",
  [ENTERPRISE_INTAKE_BUFFER_PERCENT_20]: "20%",
  [ENTERPRISE_INTAKE_PLACEHOLDER_BUFFER_PERCENT_OTHER]: "E.g. 25",
  [ENTERPRISE_INTAKE_HINT_CAMPAIGNS_SECTION]:
    "Shown and required only if you selected Module 2 or Module 3.",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_AGENCY]:
    "Adding all platforms and advertisers.",
  [ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_BRAND]:
    "Adding all platforms and brands.",
  [ENTERPRISE_INTAKE_FIELD_OPTIMIZATION_FREQUENCY]:
    "How often do you optimize each campaign?",
  [ENTERPRISE_INTAKE_HINT_OPTIMIZATION_FREQUENCY]:
    "Each AI-suggested optimization that is applied consumes credits; those not applied and manual adjustments do not.",
  [ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_LOW]:
    "Low: once a week (4 per month per campaign)",
  [ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_MEDIUM]:
    "Medium: twice a week (8 per month per campaign) · recommended",
  [ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_HIGH]:
    "High: 3 or more per week (12 per month per campaign)",
  [ENTERPRISE_INTAKE_HINT_PLATFORM_USERS_COUNT]:
    "Anyone who only approves pieces does not need a user.",
  [ENTERPRISE_INTAKE_HINT_CONTRACT_TERM]:
    "Minimum 6 months. With 12 months the monthly rate is lower.",
  [ENTERPRISE_INTAKE_CONTRACT_TERM_6]: "6 months",
  [ENTERPRISE_INTAKE_CONTRACT_TERM_12]: "12 months · better rate",
  [ENTERPRISE_INTAKE_FIELD_MEDIA_MANAGEMENT_ADDON]:
    "Do you want the Adle team to manage strategy and media buying?",
  [ENTERPRISE_INTAKE_HINT_MEDIA_MANAGEMENT_ADDON]:
    "The management add-on equals 15% of monthly media spend.",
  [ENTERPRISE_INTAKE_MEDIA_ADDON_YES]: "Yes, with the management add-on",
  [ENTERPRISE_INTAKE_MEDIA_ADDON_NO]: "No, our team operates the platform",
  [ENTERPRISE_INTAKE_FIELD_MONTHLY_MEDIA_SPEND]:
    "How much do you spend per month on media, across all platforms?",
  [ENTERPRISE_INTAKE_PLACEHOLDER_MONTHLY_MEDIA_SPEND]: "USD per month",
  [ENTERPRISE_INTAKE_WHITE_LABEL_YES]: "Yes",
  [ENTERPRISE_INTAKE_WHITE_LABEL_NO]: "No",
  [ENTERPRISE_INTAKE_SECTION_PLAN]: "Plan",

  [OWNER_FORM_SUBMISSION_TYPE_PRE_ACTIVATION]: "Pre-activation",
  [OWNER_FORM_SUBMISSION_TYPE_ENTERPRISE]: "Enterprise",

  [OPTION_EMAIL]: "Email",
  [OPTION_META]: "Meta (Instagram or Facebook)",
  [OPTION_GOOGLE]: "Google",
  [OPTION_LINKEDIN]: "LinkedIn",
  [OPTION_LLM]: "LLM (ChatGPT, Grok, Claude, Gemini, etc.)",
  [OPTION_OTHER]: "Other",

  [GLOBAL_REPORT_TITLE]: "Reports",
  [GLOBAL_REPORT_DESCRIPTION]:
    "See how your campaigns performed in the selected period.",
  [GLOBAL_REPORT_MENU_GROUP]: "Reports / Metrics",
  [GLOBAL_REPORT_MENU_ITEM]: "Reports",
  [GLOBAL_REPORT_PAGE_TITLE]: "Global Brand Report — {{brandName}}",
  [GLOBAL_REPORT_PERIOD_LAST_7_DAYS]: "Last 7 days",
  [GLOBAL_REPORT_PERIOD_LAST_14_DAYS]: "Last 14 days",
  [GLOBAL_REPORT_PERIOD_LAST_30_DAYS]: "Last 30 days",
  [GLOBAL_REPORT_AI_ANALYSIS]: "Agent",
  [GLOBAL_REPORT_OBJECTIVES_BUTTON]: "Objectives",
  [GLOBAL_REPORT_TOTAL_INVESTMENT]: "Total investment",
  [GLOBAL_REPORT_AVERAGE_ROAS]: "Average ROAS",
  [GLOBAL_REPORT_ACTIVE_CAMPAIGNS]: "Active campaigns",
  [GLOBAL_REPORT_REMAINING_BUDGET]: "Remaining budget",
  [GLOBAL_REPORT_BUDGET_EXPIRES_IN]: "Expires in {{days}} days",
  [GLOBAL_REPORT_PAUSED_CAMPAIGNS]: "{{count}} paused",
  [GLOBAL_REPORT_VS_PREVIOUS_WEEK]: "vs previous week",
  [GLOBAL_REPORT_AGENT_INSIGHTS]: "Insights",
  [GLOBAL_REPORT_NEW_INSIGHTS]: "{{count}} new",
  [GLOBAL_REPORT_NO_INSIGHTS]:
    "No insights available for this period. Try a different date range or check back when your campaigns have more activity.",
  [GLOBAL_REPORT_INSIGHTS_ERROR]:
    "Insights could not be generated. Please try again later.",
  [GLOBAL_REPORT_SUMMARY_TITLE]: "Period summary",
  [GLOBAL_REPORT_SUMMARY_OVERVIEW_TEXT]:
    "How was overall portfolio performance between {{startDateTime}} and {{endDateTime}}? Include how many campaigns ran or were created in the period, aggregated metrics (spend, ROAS, impressions, clicks), and a concise paragraph with the main findings.",
  [GLOBAL_REPORT_INSIGHTS_QUESTION]:
    "Generate portfolio insights for future campaigns: what I should repeat or do again (what worked), what I must avoid or stop doing (what failed), and cautions. Base them on weekly metrics, ad copy (angles, hooks, pain points, CTAs, headlines), and change logs. Be specific and actionable — no generic advice.",
  [GLOBAL_REPORT_GENERATING_SUMMARY]: "Generating summary...",
  [GLOBAL_REPORT_SUMMARY_NOT_GENERATED]:
    "Summary could not be generated for this period.",
  [GLOBAL_REPORT_ASK_QUESTION]: "Ask the agent about this report...",
  [GLOBAL_REPORT_ASK_QUESTION_OPEN]: "Ask me about your campaigns",
  [GLOBAL_REPORT_VIEW_HISTORICAL_INSIGHTS]: "View all historical insights",
  [GLOBAL_REPORT_AGENT_ACTIONS]: "Agent action summary",
  [GLOBAL_REPORT_ACTIONS_PERFORMED]: "Actions performed",
  [GLOBAL_REPORT_ACTION_TYPE_GENERATE_CAMPAIGN]: "{{count}} campaigns created",
  [GLOBAL_REPORT_ACTION_TYPE_CREATIVES]: "{{count}} images generated",
  [GLOBAL_REPORT_ACTION_TYPE_VIDEOS]: "{{count}} videos produced",
  [GLOBAL_REPORT_ACTION_TYPE_MESSAGES]: "{{count}} optimizations applied",
  [GLOBAL_REPORT_ACTION_TYPE_OPTIMIZATIONS_APPLIED]:
    "{{count}} optimizations applied",
  [GLOBAL_REPORT_ACTION_TYPE_GENERIC]: "{{count}} actions performed",
  [GLOBAL_REPORT_ACTION_CREATIVES_SUBTITLE]: "AI-generated creatives",
  [GLOBAL_REPORT_ACTION_VIDEOS_SUBTITLE]: "AI-generated videos",
  [GLOBAL_REPORT_ACTION_MESSAGES_SUBTITLE]: "Agent optimizations and messages",
  [GLOBAL_REPORT_ACTION_GENERIC_SUBTITLE]: "Recorded activity",
  [GLOBAL_REPORT_NO_ACTIONS_IN_PERIOD]: "No actions recorded in this period.",
  [GLOBAL_REPORT_NO_CAMPAIGNS_IN_PERIOD]:
    "No campaigns were found for this date range.",
  [GLOBAL_REPORT_NO_ACTIVITY_IN_PERIOD]:
    "No campaign activity was found in this period.",
  [GLOBAL_REPORT_SELECT_DATES_PROMPT]:
    "Select a date range to generate your report.",
  [GLOBAL_REPORT_MEASURABLE_KPI_LABEL]: "Measurable KPI",
  [GLOBAL_REPORT_MEASURABLE_KPI_ALL]: "All results",
  [GLOBAL_REPORT_NO_CAMPAIGNS_FOR_KPI]:
    "No campaign or platform in this period measures the selected KPI.",
  [GLOBAL_REPORT_DOWNLOAD_NOT_READY]:
    "The report is still being prepared. Wait a moment before downloading.",
  [GLOBAL_REPORT_PDF_OPTION]: "PDF Report",
  [GLOBAL_REPORT_CUSTOM_OPTION]: "Custom Report",
  [GLOBAL_REPORT_SERVER_PDF_BUTTON]: "Download PDF (server)",
  [GLOBAL_REPORT_SERVER_PDF_FOOTER]: "Adle · Leads report · {{dateRange}}",
  [GLOBAL_REPORT_SERVER_PDF_FILE_NAME]: "Report_{{dateRange}}.pdf",
  [MODAL_CUSTOM_REPORT_CTA]: "Customize Report",
  [MODAL_CUSTOM_REPORT_TITLE]: "Generate Custom Report",
  [MODAL_CUSTOM_REPORT_DESCRIPTION]:
    "Choose a template, date range, and format to generate a presentation from your campaign findings.",
  [MODAL_CUSTOM_REPORT_TEMPLATE]: "Template",
  [MODAL_CUSTOM_REPORT_TEMPLATE_GENERAL]: "General",
  [MODAL_CUSTOM_REPORT_TEMPLATE_SALES]: "Sales",
  [MODAL_CUSTOM_REPORT_TEMPLATE_LEADS]: "Leads",
  [MODAL_CUSTOM_REPORT_TEMPLATE_CUSTOM]: "Custom",
  [MODAL_CUSTOM_REPORT_PROMPT]: "Prompt",
  [MODAL_CUSTOM_REPORT_PROMPT_PLACEHOLDER]:
    "Describe what you want the report to focus on. For example: I want the report to focus on creative performance analysis and which communication angles worked best.",
  [MODAL_CUSTOM_REPORT_PROMPT_PLACEHOLDER_CSV]:
    "Describe the CSV rows and metrics. For example: Campaigns and ads, weekly breakdown, spend, impressions, ROAS, and unique outbound clicks.",
  [MODAL_CUSTOM_REPORT_USE_PREVIOUS_PROMPT]: "Use a previous prompt",
  [MODAL_CUSTOM_REPORT_DATES]: "Dates",
  [MODAL_CUSTOM_REPORT_FORMAT]: "Report format",
  [MODAL_CUSTOM_REPORT_LANGUAGE]: "Language",
  [MODAL_CUSTOM_REPORT_FORMAT_PDF]: "PDF",
  [MODAL_CUSTOM_REPORT_FORMAT_PPTX]: "PowerPoint presentation (editable)",
  [MODAL_CUSTOM_REPORT_FORMAT_CSV]: "CSV (Excel)",
  [MODAL_CUSTOM_REPORT_PDF_UNAVAILABLE]: "PDF generation is not available yet.",
  [MODAL_CUSTOM_REPORT_COLLECTING]: "Collecting information",
  [MODAL_CUSTOM_REPORT_ANALYZING]: "Analyzing information",
  [MODAL_CUSTOM_REPORT_RENDERING]: "Preparing presentation",
  [MODAL_CUSTOM_REPORT_ERROR]:
    "Could not generate the report. Please try again.",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_TITLE]: "Previous Prompts",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DESCRIPTION]:
    "Pick a saved prompt or delete it from the list.",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_EMPTY]:
    "There are no saved custom prompts yet.",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE_TITLE]: "Delete this prompt?",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE_DESCRIPTION]:
    "It will be removed from your saved prompts. This cannot be undone.",
  [MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE]: "Delete prompt",
  [GLOBAL_REPORT_HEAVY_LOAD_FETCHING_CAMPAIGNS]:
    "Retrieving your campaign data",
  [GLOBAL_REPORT_HEAVY_LOAD_FETCHING_STATS]: "Fetching performance stats",
  [GLOBAL_REPORT_HEAVY_LOAD_ANALYZING]: "Analyzing the collected data",
  [GLOBAL_REPORT_HEAVY_LOAD_GENERATING_INSIGHTS]:
    "Generating actionable insights",
  [GLOBAL_REPORT_ACTIVE_CAMPAIGNS_TABLE]: "Active campaigns",
  [GLOBAL_REPORT_CAMPAIGNS_TABLE]: "Campaigns",
  [GLOBAL_REPORT_COLUMN_CAMPAIGN]: "Campaign",
  [GLOBAL_REPORT_COLUMN_INVESTMENT]: "Investment",
  [GLOBAL_REPORT_COLUMN_ROAS]: "ROAS",
  [GLOBAL_REPORT_COLUMN_IMPRESSIONS]: "Impressions",
  [GLOBAL_REPORT_COLUMN_CTR]: "CTR",
  [GLOBAL_REPORT_COLUMN_STATUS]: "Status",
  [GLOBAL_REPORT_STATUS_ALERT]: "Alert",
  [GLOBAL_REPORT_STATUS_OPTIMAL]: "Optimal",
  [GLOBAL_REPORT_STATUS_BRAND]: "Brand",
  [GLOBAL_REPORT_INSIGHT_ROAS_DROP_TITLE]: "ROAS drop in Summer Running",
  [GLOBAL_REPORT_INSIGHT_ROAS_DROP_DESCRIPTION]:
    "ROAS fell from 4.2x to 2.9x in 3 days. Possible audience saturation in the 25–34 segment.",
  [GLOBAL_REPORT_INSIGHT_CPC_PEAK_TITLE]: "CPC peak on Tuesdays",
  [GLOBAL_REPORT_INSIGHT_CPC_PEAK_DESCRIPTION]:
    "CPC increases 34% on Tuesday mornings. Consider adjusting bids by schedule.",
  [GLOBAL_REPORT_INSIGHT_VIDEO_OUTPERFORMS_TITLE]:
    "30s video outperforms static image",
  [GLOBAL_REPORT_INSIGHT_VIDEO_OUTPERFORMS_DESCRIPTION]:
    "Video CTR is 2.1x higher on Meta. Opportunity to scale budget on this format.",
  [GLOBAL_REPORT_ACTION_DATE_TODAY]: "Today",
  [GLOBAL_REPORT_ACTION_DATE_YESTERDAY]: "Yesterday",
  [GLOBAL_REPORT_ACTION_DATE_MAR_26]: "Mar 26",
  [GLOBAL_REPORT_ACTION_DATE_MAR_25]: "Mar 25",
  [GLOBAL_REPORT_ACTION_CAMPAIGNS_CREATED]: "2 campaigns created",
  [GLOBAL_REPORT_ACTION_IMAGES_GENERATED]: "5 images generated",
  [GLOBAL_REPORT_ACTION_VIDEOS_PRODUCED]: "3 videos produced",
  [GLOBAL_REPORT_ACTION_OPTIMIZATION_APPLIED]: "1 optimization applied",
  [GLOBAL_REPORT_DEFAULT_BRAND_NAME]: "Brand",
  [GLOBAL_REPORT_STATS_TIME_TITLE]: "Evolution",
  [GLOBAL_REPORT_STATS_TIME_SUBTITLE]: "Daily evolution of spend and results",
  [GLOBAL_REPORT_STATS_DAILY_RESULTS_TITLE]: "Daily evolution of results",
  [GLOBAL_REPORT_STATS_WEEKLY_RESULTS_TITLE]: "Weekly evolution of results",
  [GLOBAL_REPORT_STATS_MONTHLY_RESULTS_TITLE]: "Monthly evolution of results",
  [GLOBAL_REPORT_STATS_DAILY_RESULTS_SUBTITLE]:
    "Results per day in the selected period",
  [GLOBAL_REPORT_STATS_WEEKLY_TIME_SUBTITLE]:
    "Weekly evolution of spend and results",
  [GLOBAL_REPORT_STATS_MONTHLY_TIME_SUBTITLE]:
    "Monthly evolution of spend and results",
  [GLOBAL_REPORT_STATS_IMPRESSIONS_CTR_TITLE]: "Impressions and CTR",
  [GLOBAL_REPORT_STATS_IMPRESSIONS_CTR_SUBTITLE]:
    "Daily evolution of impressions and CTR",
  [GLOBAL_REPORT_STATS_WEEKLY_IMPRESSIONS_CTR_SUBTITLE]:
    "Weekly evolution of impressions and CTR",
  [GLOBAL_REPORT_STATS_MONTHLY_IMPRESSIONS_CTR_SUBTITLE]:
    "Monthly evolution of impressions and CTR",
  [GLOBAL_REPORT_STATS_PLATFORM_TITLE]: "Platforms",
  [GLOBAL_REPORT_STATS_PLATFORM_SUBTITLE]: "Results by platform",
  [GLOBAL_REPORT_STATS_PLATFORM_CPA_TITLE]: "CPA by platform",
  [GLOBAL_REPORT_STATS_PLATFORM_SPEND_TITLE]: "Spend by platform",
  [GLOBAL_REPORT_STATS_CREATIVES_TITLE]: "Ads",
  [GLOBAL_REPORT_STATS_CREATIVES_SUBTITLE]:
    "Ad comparison by efficiency (CPA) and by results volume",
  [GLOBAL_REPORT_STATS_CREATIVES_LOWEST_CPA_TITLE]: "Lowest CPA",
  [GLOBAL_REPORT_STATS_CREATIVES_HIGHEST_VOLUME_TITLE]:
    "Highest results volume",
  [GLOBAL_REPORT_STATS_RADAR_TITLE]: "Multidimensional campaign profile",
  [GLOBAL_REPORT_STATS_RADAR_SUBTITLE]:
    "Normalized comparison of key metrics per campaign",
  [GLOBAL_REPORT_STATS_BELOW_AVERAGE]: "Below average (scale up)",
  [GLOBAL_REPORT_STATS_ABOVE_AVERAGE]: "Above average (review/pause)",
  [GLOBAL_REPORT_STATS_NO_DATA]: "Not enough data to display this chart.",
  [GLOBAL_REPORT_STATS_SPEND_AXIS]: "Spend",
  [GLOBAL_REPORT_STATS_IMPRESSIONS_AXIS]: "Impressions",
  [GLOBAL_REPORT_STATS_SPEND_DISTRIBUTION]: "Spend distribution",
  [GLOBAL_REPORT_GOALS_TITLE]: "Goals",
  [GLOBAL_REPORT_GOALS_SUBTITLE]:
    "Monthly results volume progress and 7-day daily projection",
  [GLOBAL_REPORT_GOALS_STACKED_TITLE]: "Results vs monthly goal",
  [GLOBAL_REPORT_GOALS_STACKED_SUBTITLE]:
    "Sum of results over the last 30 days compared to the configured monthly volume",
  [GLOBAL_REPORT_GOALS_PROJECTION_TITLE]: "Results Projection",
  [GLOBAL_REPORT_GOALS_PROJECTION_SUBTITLE]: "Daily results projection",
  [GLOBAL_REPORT_GOALS_ACHIEVED]: "Achieved",
  [GLOBAL_REPORT_GOALS_REMAINING]: "Remaining",
  [GLOBAL_REPORT_GOALS_EXCEEDED]: "Goal exceeded by {{count}}",
  [GLOBAL_REPORT_GOALS_PROJECTION_ACTUAL]: "Daily results (actual)",
  [GLOBAL_REPORT_GOALS_PROJECTION_FORECAST]: "Daily results (projected)",
  [GLOBAL_REPORT_GOALS_TARGET_LINE]: "Monthly goal",
  [GLOBAL_REPORT_GOALS_CONFIGURE_PROMPT]:
    "Configure your KPI to view goals and projection.",
  [GLOBAL_REPORT_GOALS_CONFIGURE_BUTTON]: "Configure KPI",
  [GLOBAL_REPORT_GOALS_KPI_MISMATCH_PROMPT]:
    "Select {{kpi}} as the measurable KPI to view goals and projection.",
  [CAMPAIGN_APPROVAL_PAGE_TITLE]: "Campaign approval",
  [CAMPAIGN_APPROVAL_PAGE_DESCRIPTION]:
    "Review this campaign's texts and creatives and leave your final approval.",
  [CAMPAIGN_APPROVAL_INVALID_TITLE]: "This link is not valid",
  [CAMPAIGN_APPROVAL_INVALID_DESCRIPTION]:
    "The approval link is invalid or no longer available. Ask your administrator for a new link.",
  [CAMPAIGN_APPROVAL_EXPIRED_TITLE]: "This link expired",
  [CAMPAIGN_APPROVAL_EXPIRED_DESCRIPTION]:
    "The approval link has expired. Ask your agency to share a new one.",
  [CAMPAIGN_APPROVAL_CONTENT_EMPTY]:
    "There is no content available to review for this campaign.",
  [CAMPAIGN_APPROVAL_LOADING_FETCHING_CAMPAIGN_DATA]: "Loading campaign data",
  [CAMPAIGN_APPROVAL_LOADING_PREPARING_REVIEW]: "Preparing review",
  [CAMPAIGN_APPROVAL_GENERAL_COMMENT_TITLE]: "General comment",
  [CAMPAIGN_APPROVAL_GENERAL_COMMENT_DESCRIPTION]:
    "Share general feedback about the campaign before approving or rejecting it.",
  [CAMPAIGN_APPROVAL_COMMENT_PLACEHOLDER]: "Write your general comment here",
  [CAMPAIGN_APPROVAL_COMMENT_BUTTON]: "Send comment",
  [CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_TITLE]: "Specific Comment",
  [CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_DESCRIPTION]:
    "Describe what should change in this text or creative.",
  [CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_PLACEHOLDER]:
    "Write your specific comment here",
  [CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_BUTTON]: "Add comment",
  [CAMPAIGN_APPROVAL_DECISION_TITLE]: "Final decision",
  [CAMPAIGN_APPROVAL_DECISION_DESCRIPTION]:
    "You must leave a summary before approving or rejecting this campaign version.",
  [CAMPAIGN_APPROVAL_DECISION_PLACEHOLDER]:
    "Write a final summary of your decision",
  [CAMPAIGN_APPROVAL_APPROVE_BUTTON]: "Approve",
  [CAMPAIGN_APPROVAL_REJECT_BUTTON]: "Reject",
  [CAMPAIGN_APPROVAL_TEXTS_TITLE]: "Texts",
  [CAMPAIGN_APPROVAL_DESTINATION_TITLE]: "Destination",
  [CAMPAIGN_APPROVAL_LEAD_FORM_PREVIEW_UNAVAILABLE]:
    "We couldn't load the preview for this form.",
  [CAMPAIGN_APPROVAL_CREATIVES_TITLE]: "Creatives",
  [CAMPAIGN_APPROVAL_CREATIVE_TITLE]: "Creative",
  [CAMPAIGN_APPROVAL_SLIDE_LABEL]: "Slide",
  [CAMPAIGN_APPROVAL_FIELD_TITLE_LABEL]: "Title",
  [CAMPAIGN_APPROVAL_FIELD_HEADLINE_LABEL]: "Headline",
  [CAMPAIGN_APPROVAL_FIELD_LONG_HEADLINE_LABEL]: "Long headline",
  [CAMPAIGN_APPROVAL_FIELD_DESCRIPTION_LABEL]: "Description",
  [CAMPAIGN_APPROVAL_FIELD_CREATIVE_LABEL]: "Creative",
  [CAMPAIGN_APPROVAL_LOCKED_STATUS_APPROVED]:
    "This version has already been approved. No more comments can be submitted.",
  [CAMPAIGN_APPROVAL_LOCKED_STATUS_REJECTED]:
    "This version has already been rejected. No more comments can be submitted.",
  [CAMPAIGN_APPROVAL_LOCKED_STATUS_DECIDED]:
    "This version already has a final decision. Comments are closed.",
  [CAMPAIGN_APPROVAL_TARGET_ENTITY_AD]: "Ad",
  [CAMPAIGN_APPROVAL_TARGET_ENTITY_ASSETS_GROUP]: "Assets group",
  [CAMPAIGN_APPROVAL_CONTROLS_TITLE]: "Review",
  [CAMPAIGN_APPROVAL_CONTROLS_DESCRIPTION]:
    "Enable a public link so your client can review texts and creatives before publishing.",
  [CAMPAIGN_APPROVAL_INACTIVE_DESCRIPTION]:
    "Enable this option if you need your client to approve the campaign texts and creatives. Once enabled, a shareable link will be generated for your client to review and leave comments. You will not be able to publish the campaign until your client approves it. This action cannot be undone.",
  [CAMPAIGN_APPROVAL_STATE_INACTIVE]: "Inactive",
  [CAMPAIGN_APPROVAL_STATE_ACTIVE]: "Active",
  [CAMPAIGN_APPROVAL_SHARED_LINK_LABEL]: "Link:",
  [CAMPAIGN_APPROVAL_CONFIRM_ENABLE_TITLE]: "Send for Review",
  [CAMPAIGN_APPROVAL_CONFIRM_ENABLE_DESCRIPTION]:
    "A link will be generated that you can share with your client for them to review the campaign.",
  [CAMPAIGN_APPROVAL_ENABLE_BUTTON]: "Send for Review",
  [CAMPAIGN_APPROVAL_COPY_LINK_BUTTON]: "Copy",
  [CAMPAIGN_APPROVAL_COPY_LINK_COPIED]: "Copied",
  [CAMPAIGN_APPROVAL_REJECTED_DESCRIPTION]:
    "Your client requested changes to the campaign. Review their comments, make the necessary changes, save, and send them the link again.",
  [CAMPAIGN_APPROVAL_APPROVED_DESCRIPTION]:
    "Your client approved the campaign. You can now publish it.",
  [CAMPAIGN_APPROVAL_PENDING_DESCRIPTION]:
    "Waiting for your client to approve the campaign or request changes.",
  [CAMPAIGN_APPROVAL_VIEW_COMMENTS_BUTTON]: "View comments",
  [CAMPAIGN_APPROVAL_VIEW_REVIEW_BUTTON]: "View review",
  [CAMPAIGN_APPROVAL_STATUS_PENDING]: "Pending",
  [CAMPAIGN_APPROVAL_STATUS_APPROVED]: "Approved",
  [CAMPAIGN_APPROVAL_STATUS_REJECTED]: "Changes Requested",
  [GALLERY_CONTENT_APPROVAL_STATUS_REJECTED]: "Changes",
  [CAMPAIGN_APPROVAL_PANEL_TITLE]: "Changes Requested",
  [CAMPAIGN_APPROVAL_PANEL_DESCRIPTION]:
    "Track active comments for the current version and jump to the matching field.",
  [CAMPAIGN_APPROVAL_PANEL_EMPTY]:
    "There are no active comments for this version yet.",
  [CAMPAIGN_APPROVAL_PANEL_STALE_TOGGLE]: "Show previous comments",
  [CAMPAIGN_APPROVAL_PANEL_CURRENT_DRAFT]: "Current version",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_PENDING]: "Review in Progress",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_APPROVED]: "Campaign Approved",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_REJECTED]: "Changes Requested",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_PENDING]:
    "No comments yet. Track each reviewer's status.",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_APPROVED]:
    "Campaign approved. No pending comments for this version.",
  [CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_REJECTED]:
    "No active comments for this version.",
  [CAMPAIGN_APPROVAL_STALE_LABEL]: "Previous",
  [CAMPAIGN_APPROVAL_AD_PREVIEW_TITLE]: "Ad preview",
  [CAMPAIGN_APPROVAL_AD_PREVIEW_ERROR]: "Could not load the ad preview.",
  [CAMPAIGN_APPROVAL_PUBLISH_BLOCKED_BANNER]:
    "Publishing is blocked until the client approves this campaign.",
  [CAMPAIGN_APPROVAL_SEND_FOR_REVIEW]: "Send for Review",
  [CONTENT_APPROVAL_PAGE_TITLE]: "Content approval",
  [CONTENT_APPROVAL_REPLACE_BUTTON]: "Replace",
  [CONTENT_APPROVAL_EDIT_BUTTON]: "Edit",
  [CONTENT_APPROVAL_SAVE_REVISION_BUTTON]: "Save changes",
  [CONTENT_APPROVAL_SAVE_REVISION_SUCCESS_DESCRIPTION]:
    "Your changes have been saved. Copy and send your client the link again.",
  [CONTENT_APPROVAL_APPROVE_CONTENT_BUTTON]: "Approve content",
  [CONTENT_APPROVAL_SIDEBAR_TITLE]: "Comments",
  [CONTENT_APPROVAL_ALL_GOOD_QUESTION]: "Is the content ready?",
  [CONTENT_APPROVAL_CONFIRM_ENABLE_TITLE]: "Send for Review",
  [CONTENT_APPROVAL_CONFIRM_ENABLE_DESCRIPTION]:
    "A link will be generated that you can share with your client so they can review the content.",
  [CONTENT_APPROVAL_ENABLE_SUCCESS_DESCRIPTION]:
    "Copy and send your client the following link so they can review the content:",
  [CAMPAIGN_APPROVAL_ENABLE_SUCCESS_DESCRIPTION]:
    "Copy and send your client the following link so they can review the campaign:",
  [APPROVAL_ENABLE_SUCCESS_OR_SEPARATOR]: "or",
  [APPROVAL_REVIEW_EMAIL_LABEL]: "Send the link by email",
  [APPROVAL_EMAIL_SEND_BUTTON]: "Send",
  [APPROVAL_EMAIL_SEND_SENT]: "Sent",
  [APPROVAL_EMAIL_INVALID]: "Invalid email",
  [APPROVAL_REVIEWER_NOT_FOUND]:
    "No reviewer with that email exists for this approval.",
  [APPROVAL_ADD_REVIEWER]: "Add reviewer",
  [APPROVAL_REVIEWER_LABEL]: "Reviewer {{number}}",
  [APPROVAL_REVIEWER_MAX_REACHED]: "Maximum 10 reviewers",
  [APPROVAL_REVIEWER_EMAIL_DUPLICATED]:
    "This email is already assigned to a reviewer",
  [APPROVAL_REVIEWER_ADDED_SUCCESS]: "Reviewer added",
  [APPROVAL_REVIEWER_STATUS_PENDING]: "Pending",
  [APPROVAL_REVIEWER_STATUS_APPROVED]: "Approved",
  [APPROVAL_REVIEWER_STATUS_REJECTED]: "Rejected",
  [APPROVAL_CURRENT_REVIEWER_LABEL]: "Reviewing as {{email}}",
  [APPROVAL_REVIEWING_AS_PREFIX]: "Reviewing as",
  [APPROVAL_REVIEWERS_SECTION_LABEL]: "Reviewers",
  [APPROVAL_COMMENT_AUTHOR_LABEL]: "{{email}}",
  [CONTENT_APPROVAL_SENT_DATE]: "Sent on {{date}}",
  [CONTENT_APPROVAL_CLIENT_COMMENTS_TITLE]: "Client comments",
  [CONTENT_APPROVAL_CLIENT_COMMENTS_EMPTY]:
    "Your client hasn't left any comments yet.",
  [CONTENT_APPROVAL_REVIEWER_COMMENTS_EMPTY]:
    "You haven't added any comments yet.",
  [CONTENT_APPROVAL_COMMENT_PLACEHOLDER]: "Write your comment here...",
  [CONTENT_APPROVAL_REVIEW_LINK_LABEL]: "Review link",
  [CONTENT_APPROVAL_STATUS_SECTION_LABEL]: "Status",
  [CONTENT_APPROVAL_MAIN_CREATIVE_LABEL]: "Main creative",
  [CONTENT_APPROVAL_CREATIVE_CARD_TITLE]: "Creative {{number}}",
  [CONTENT_APPROVAL_CREATIVE_TYPE_LABEL]: "Type: {{type}}",
  [CONTENT_APPROVAL_COMMENT_CREATIVE_NUMBER]: "Creative {{number}}",
  [CONTENT_APPROVAL_CONFIRM_APPROVE_TITLE]: "Approve content?",
  [CONTENT_APPROVAL_CONFIRM_APPROVE_DESCRIPTION]:
    "The agency will receive a notification that the content has been approved.",
  [CONTENT_APPROVAL_APPROVE_BUTTON]: "Approve",
  [CONTENT_APPROVAL_DECISION_APPROVED_SUCCESS]:
    "The approval notification was sent to the agency.",
  [CONTENT_APPROVAL_CONTENT_APPROVED_TITLE]: "Content Approved",
  [CONTENT_APPROVAL_COMMENT_SENT_SUCCESS]: "Your comment was sent",
  [CONTENT_APPROVAL_REVIEW_NEXT_CONTENT_BUTTON]: "Next Content",
  [CONTENT_APPROVAL_ANOTHER_COMMENT_BUTTON]: "Another Comment",
  [CONTENT_APPROVAL_ALL_CONTENTS_REVIEWED]: "You have reviewed all content",
  [CONTENT_APPROVAL_REVIEW_NEXT_DESCRIPTION]:
    "There are still {{count}} contents to review.",
  [CONTENT_APPROVAL_REVIEW_NEXT_DESCRIPTION_SINGLE]:
    "There is still {{count}} content to review.",
  [CONTENT_APPROVAL_LOCKED_STATUS_APPROVED]:
    "This content has already been approved. No more comments can be submitted.",
  [CONTENT_APPROVAL_INVALID_TITLE]: "This link is not valid",
  [CONTENT_APPROVAL_INVALID_DESCRIPTION]:
    "This content approval link is not valid or is no longer available. Ask your administrator for a new link.",
  [CONTENT_APPROVAL_EXPIRED_TITLE]: "This link expired",
  [CONTENT_APPROVAL_EXPIRED_DESCRIPTION]:
    "The content approval link has expired. Ask your agency to share a new one.",
  [CONTENT_APPROVAL_LOADING_VALIDATING_LINK]: "Validating review link",
  [CONTENT_APPROVAL_LOADING_FETCHING_CREATIVES]: "Loading creatives",
  [CONTENT_APPROVAL_LOADING_PREPARING_REVIEW]: "Preparing review",
  [CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_TITLE]:
    "Campaign is not approved yet",
  [CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_DESCRIPTION]:
    "This campaign was sent to the client for review and has not been approved yet. Do you want to publish it anyway?",
  [CAMPAIGN_APPROVAL_READY_TO_DECIDE]: "Ready to decide?",
  [CAMPAIGN_APPROVAL_COMMENTS_LEFT]: "You have left {{count}} comments",
  [CAMPAIGN_APPROVAL_AD_SET_LABEL]: "AD SET",
  [CAMPAIGN_APPROVAL_ADS_COUNT]: "{{count}} ads",
  [CAMPAIGN_APPROVAL_ADS_COUNT_SINGLE]: "{{count}} ad",
  [CAMPAIGN_APPROVAL_SIDEBAR_CAMPAIGNS]: "Select a platform",
  [CAMPAIGN_APPROVAL_SIDEBAR_AD_SETS]: "{{count}} ad sets",
  [CAMPAIGN_APPROVAL_SIDEBAR_AD_SETS_SINGLE]: "{{count}} ad set",
  [CAMPAIGN_APPROVAL_SIDEBAR_ADS]: "{{count}} ads",
  [CAMPAIGN_APPROVAL_SIDEBAR_ADS_SINGLE]: "{{count}} ad",
  [CAMPAIGN_APPROVAL_SIDEBAR_TEXTS]: "{{count}} texts",
  [CAMPAIGN_APPROVAL_SIDEBAR_TEXTS_SINGLE]: "{{count}} text",
  [CAMPAIGN_APPROVAL_SIDEBAR_CREATIVES]: "{{count}} creatives",
  [CAMPAIGN_APPROVAL_SIDEBAR_CREATIVES_SINGLE]: "{{count}} creative",
  [CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT]: "{{count}} texts",
  [CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT_SINGLE]: "{{count}} text",
  [CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT]: "{{count}} creatives",
  [CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT_SINGLE]: "{{count}} creative",
  [CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT]: "{{count}} comments",
  [CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT_SINGLE]: "{{count}} comment",
  [CAMPAIGN_APPROVAL_REJECT_REQUIRES_COMMENT]:
    "To reject, leave at least one comment on an item or write one here.",
  [CAMPAIGN_APPROVAL_COMMENT_SEND_HINT]: "Ctrl/⌘ + Enter to send",
  [CAMPAIGN_APPROVAL_APPROVE_CAMPAIGN_BUTTON]: "Approve campaign",
  [CAMPAIGN_APPROVAL_CONFIRM_APPROVE_TITLE]: "Approve campaign?",
  [CAMPAIGN_APPROVAL_CONFIRM_APPROVE_DESCRIPTION]:
    "The agency will receive a notification that the campaign has been approved and can publish it",
  [CAMPAIGN_APPROVAL_CONFIRM_REJECT_TITLE]: "Reject campaign?",
  [CAMPAIGN_APPROVAL_CONFIRM_REJECT_DESCRIPTION]:
    "Are you sure you want to reject this campaign? The agency will receive a notification.",
  [CAMPAIGN_APPROVAL_DECISION_APPROVED_SUCCESS]:
    "The approval notification was sent to the agency.",
  [CAMPAIGN_APPROVAL_DECISION_REJECTED_SUCCESS]:
    "The rejection notification was sent to the agency.",
  [TEMPLATES_MENU_ITEM]: "Templates",
  [TEMPLATES_TITLE]: "Templates",
  [TEMPLATE]: "Template",
  [TEMPLATES_SEARCH_PLACEHOLDER]: "Search templates",
  [TEMPLATES_SEARCH_NO_RESULTS]: "No templates matched that name.",
  [TEMPLATES_SORT_NEWEST_FIRST]: "Newest first",
  [TEMPLATES_SORT_OLDEST_FIRST]: "Oldest first",
  [TEMPLATES_SORT_NAME_ASC]: "Name (A–Z)",
  [TEMPLATES_SORT_NAME_DESC]: "Name (Z–A)",
  [TEMPLATES_DESCRIPTION]:
    "Create a template, define layers, groups, and properties, or upload a creative and we’ll analyze it for you.",
  [TEMPLATES_BUTTON_UPLOAD]: "Upload Creative",
  [TEMPLATES_UPLOAD_FROM_GALLERY]: "From Gallery",
  [TEMPLATES_UPLOAD_FROM_DEVICE]: "From Device",
  [TEMPLATES_BUTTON_CREATE]: "Create",
  [TEMPLATES_LAYOUT_KIND_IMAGE]: "Image",
  [TEMPLATES_LAYOUT_KIND_CAROUSEL]: "Carousel",
  [TEMPLATES_CREATE_KIND_TITLE]: "Template type",
  [TEMPLATES_CREATE_KIND_DESCRIPTION]:
    "Choose a single image or a carousel with multiple slides.",
  [TEMPLATES_CREATE_KIND_SINGLE]: "Single image",
  [TEMPLATES_CREATE_KIND_CAROUSEL]: "Carousel",
  [TEMPLATES_CREATE_KIND_SLIDE_COUNT]: "Number of slides",
  [TEMPLATES_SLIDE_LABEL]: "Slide {{index}}",
  [TEMPLATES_ADD_SLIDE]: "Add",
  [TEMPLATES_DUPLICATE_SLIDE]: "Duplicate slide",
  [TEMPLATES_DELETE_SLIDE]: "Delete slide",
  [TEMPLATES_SLIDES_ROW]: "Slides",
  [TEMPLATES_CAROUSEL_TYPE]: "Carousel type",
  [TEMPLATES_CONTINUOUS_SETUP_TITLE]: "Set up continuous carousel",
  [TEMPLATES_CONTINUOUS_SETUP_SLIDES]: "Number of slides",
  [TEMPLATES_CONTINUOUS_SETUP_FORMAT]: "Format of each slide",
  [TEMPLATES_LAYOUT_KIND_CONTINUOUS]: "Continuous",
  [TEMPLATES_LAYOUT_KIND_INDIVIDUAL]: "Individual",
  [TEMPLATES_LAYOUT_KIND_INDIVIDUAL_TOOLTIP]:
    "Individual mode: each carousel slide is designed separately.",
  [TEMPLATES_LAYOUT_KIND_CONTINUOUS_TOOLTIP]:
    "Continuous mode: a single design that spans all slides.",
  [TEMPLATES_LAYOUT_KIND_TO_INDIVIDUAL_HINT]:
    "Click to go back to individual mode (each slide is designed separately).",
  [TEMPLATES_LAYOUT_KIND_TO_CONTINUOUS_HINT]:
    "Click to switch to continuous mode (one design spanning all slides).",
  [TEMPLATES_LAYOUT_KIND_TO_INDIVIDUAL_BLOCKED]:
    "To go back to individual mode (each slide separate) the template must have no layers.",
  [TEMPLATES_LAYOUT_KIND_TO_CONTINUOUS_BLOCKED]:
    "To switch to continuous mode (one design spanning all slides) the template must have no layers.",
  [TEMPLATES_CONFIRM_DELETE_STRIP_SLIDE_DESCRIPTION]:
    "Slide {{index}} and its content will be deleted. Layers that cross it will be trimmed.",
  [TEMPLATES_STRIP_FORMAT_TOO_LARGE]:
    "This format exceeds the maximum continuous strip size",
  [TEMPLATES_FORMATS_ROW]: "Formats",
  [TEMPLATES_CAROUSEL_CHIP]: "Carousel",
  [TEMPLATES_CONTINUOUS_CAROUSEL_CHIP]: "Continuous carousel",
  [TEMPLATES_EMPTY]: "There are no templates yet.",
  [TEMPLATES_FOLDER_EMPTY]: "This folder is empty.",
  [TEMPLATES_EMPTY_CANVAS_HINT]:
    "Start assembling your creative in layers, or upload an image and we’ll do it for you.",
  [TEMPLATES_EMPTY_ADD_LAYER]: "Add layer",
  [TEMPLATES_BACKGROUND_LAYER]: "background",
  [TEMPLATES_OPEN]: "Open",
  [TEMPLATES_DUPLICATE]: "Duplicate",
  [TEMPLATES_DELETE]: "Delete",
  [TEMPLATES_SAVE]: "Save",
  [TEMPLATES_USAGE_GUIDE]: "User guide",
  [TEMPLATES_GUIDE_PDF_URL]:
    "https://clapp-prod.s3.us-east-1.amazonaws.com/docs/templates-guide/EN.pdf",
  [TEMPLATES_GUIDE_VIDEO_URL]:
    "https://clapp-dev.s3.us-east-1.amazonaws.com/socialMedia/-Oqn1dn3aXEtzakQBesw/21102d46-0c5d-4783-bb49-b88e0fe76f46.mp4",
  [TEMPLATES_BACK]: "Go to templates",
  [TEMPLATES_NAME]: "Name",
  [TEMPLATES_UNTITLED]: "Untitled",
  [TEMPLATES_ZONES]: "Layers",
  [TEMPLATES_LAYERS]: "Layers",
  [TEMPLATES_PROPERTIES]: "Properties",
  [TEMPLATES_NO_SELECTION]: "Select a layer to edit it.",
  [TEMPLATES_ADD_LAYER]: "Element",
  [TEMPLATES_ZONE_NAME]: "Layer Name",
  [TEMPLATES_LAYER_NAME]: "Layer Name",
  [TEMPLATES_ZONE_TYPE]: "Layer Type",
  [TEMPLATES_ZONE_SOURCE]: "Behavior",
  [TEMPLATES_TYPE_TEXT]: "Text",
  [TEMPLATES_TYPE_IMAGE]: "Image",
  [TEMPLATES_TYPE_SHAPE]: "Shape",
  [TEMPLATES_TYPE_GROUP]: "Group",
  [TEMPLATES_SOURCE_ASSET]: "Static",
  [TEMPLATES_SOURCE_DATA]: "Variable",
  [TEMPLATES_SOURCE_GENERATED]: "Generated",
  [TEMPLATES_SOURCE_FIXED]: "Static",
  [TEMPLATES_SOURCE_COMPUTED]: "Computed",
  [TEMPLATES_SOURCE_ASSET_HINT]:
    "It always uses the same text or image for all generated images.",
  [TEMPLATES_SOURCE_DATA_HINT]:
    "You can assign a specific value for each generated image.",
  [TEMPLATES_SOURCE_GENERATED_HINT]:
    "AI creates a different text or image for each generated image, based on the instructions.",
  [TEMPLATES_SOURCE_COMPUTED_HINT]:
    "It is calculated with an expression from other variables.",
  [TEMPLATES_FIXED_VALUE]: "Value",
  [TEMPLATES_FIXED_VALUE_PLACEHOLDER]: "Text",
  [TEMPLATES_LAYER_TEXT]: "Text",
  [TEMPLATES_STYLE]: "Style",
  [TEMPLATES_ORIGIN_TEXT]: "Reference",
  [TEMPLATES_EXPRESSION]: "Expression",
  [TEMPLATES_VARIABLE]: "Variable",
  [TEMPLATES_PROMPT]: "Instructions",
  [TEMPLATES_GENERATE_PROMPT]: "Generate Instructions",
  [TEMPLATES_GENERATE_PROMPT_ERROR]: "Could not generate the instructions.",
  [TEMPLATES_GENERATE_PROMPT_NO_EXAMPLE]:
    "Add an Example Text or Image to Generate Instructions.",
  [TEMPLATES_SAVE_PROMPT]: "Save Instructions",
  [TEMPLATES_SAVE_PROMPT_TITLE]: "Save Instructions",
  [TEMPLATES_SAVE_PROMPT_ERROR]: "Could not save the instructions.",
  [TEMPLATES_SAVE_PROMPT_SUCCESS]: "Instruction Saved",
  [TEMPLATES_IMPORT_PROMPT]: "Import Instructions",
  [TEMPLATES_IMPORT_PROMPT_TITLE]: "Saved Instructions",
  [TEMPLATES_IMPORT_SELECTED]: "Import",
  [TEMPLATES_IMPORT_PROMPT_EMPTY]: "There are no saved instructions.",
  [TEMPLATES_IMPORT_PROMPT_ERROR]: "Could not load the instructions.",
  [TEMPLATES_DELETE_PROMPT]: "Delete Instructions",
  [TEMPLATES_DELETE_PROMPT_ERROR]: "Could not delete the instructions.",
  [TEMPLATES_TRY_LAYER]: "Try",
  [TEMPLATES_TRY_LAYER_ERROR]: "Could not generate the layer preview.",
  [TEMPLATES_IS_BACKGROUND]: "Background",
  [TEMPLATES_NEGATIVE_PROMPT]: "Avoid",
  [TEMPLATES_ASSET_REF]: "Asset",
  [TEMPLATES_SELECT_ASSET]: "Select Asset",
  [TEMPLATES_CHANGE_ASSET]: "Change Asset",
  [TEMPLATES_FIT]: "Fit",
  [TEMPLATES_SHAPE_FILL]: "Fill",
  [TEMPLATES_SHAPE_RADIUS]: "Radius",
  [TEMPLATES_FONT_SIZE]: "Size",
  [TEMPLATES_FONT_COLOR]: "Color",
  [TEMPLATES_STROKE_WIDTH]: "Stroke",
  [TEMPLATES_STROKE_METRIC]: "Width",
  [TEMPLATES_SHADOW]: "Shadow",
  [TEMPLATES_SHADOW_ANGLE]: "Direction (°)",
  [TEMPLATES_SHADOW_DISTANCE]: "Distance",
  [TEMPLATES_SHADOW_BLUR]: "Blur",
  [TEMPLATES_PRESETS]: "Presets",
  [TEMPLATES_SHADOW_PRESET_SOFT]: "Soft",
  [TEMPLATES_SHADOW_PRESET_LIFT]: "Lift",
  [TEMPLATES_SHADOW_PRESET_HARD]: "Hard",
  [TEMPLATES_SHADOW_PRESET_GLOW]: "Glow",
  [TEMPLATES_STROKE_COLOR]: "Stroke color",
  [TEMPLATES_BACKGROUND_PADDING]: "Background",
  [TEMPLATES_BACKGROUND_SEPARATION]: "Distance from the letter",
  [TEMPLATES_BACKGROUND_RADIUS]: "Roundness",
  [TEMPLATES_BACKGROUND_COLOR]: "Background color",
  [TEMPLATES_PAINT_SETTINGS]: "Settings",
  [TEMPLATES_HIGHLIGHTS_TITLE]: "Specific Styles",
  [TEMPLATES_HIGHLIGHTS_HINT]:
    "Select a fragment in the text and change color, stroke, or background to highlight it. You can combine all three. With no selection, changes apply to the whole layer.",
  [TEMPLATES_HIGHLIGHTS_ADD]: "Add highlight",
  [TEMPLATES_HIGHLIGHTS_REMOVE]: "Remove highlight",
  [TEMPLATES_HIGHLIGHTS_KIND_FILL]: "Letter",
  [TEMPLATES_HIGHLIGHTS_KIND_STROKE]: "Stroke",
  [TEMPLATES_HIGHLIGHTS_KIND_BACKGROUND]: "Background",
  [TEMPLATES_HIGHLIGHTS_PHRASE]: "Reference phrase",
  [TEMPLATES_HIGHLIGHTS_PHRASE_INVALID]:
    "The phrase must appear in the reference text.",
  [TEMPLATES_HIGHLIGHTS_CAPTURE]: "Select on the canvas",
  [TEMPLATES_HIGHLIGHTS_CAPTURING]: "Select the text…",
  [TEMPLATES_INLINE_REPLACEMENTS_TITLE]: "Replace text with images",
  [TEMPLATES_INLINE_REPLACEMENTS_HINT]:
    "Replace an exact word inside a text with an image",
  [TEMPLATES_INLINE_REPLACEMENTS_ADD]: "Add replacement",
  [TEMPLATES_INLINE_REPLACEMENTS_REMOVE]: "Remove replacement",
  [TEMPLATES_INLINE_REPLACEMENTS_PHRASE]: "Word",
  [TEMPLATES_LINE_SPACING]: "Line Spacing",
  [TEMPLATES_LETTER_SPACING]: "Letter Spacing",
  [TEMPLATES_FONT_FAMILY]: "Typography",
  [TEMPLATES_FONT_FACE]: "Font style",
  [TEMPLATES_TEXT_STYLE]: "Text style",
  [TEMPLATES_TEXT_STYLE_NORMAL]: "Normal",
  [TEMPLATES_TEXT_STYLE_ITALIC]: "Italic",
  [TEMPLATES_TEXT_STYLE_UNDERLINE]: "Underline",
  [TEMPLATES_TEXT_STYLE_ITALIC_UNDERLINE]: "Italic and underline",
  [TEMPLATES_ADD_FONT]: "+ Add Font",
  [TEMPLATES_ADD_FONT_TITLE]: "Add Font",
  [TEMPLATES_ADD_FONT_NAME]: "Font name",
  [TEMPLATES_ADD_FONT_NAME_HINT]: "Family name, e.g. Inter",
  [TEMPLATES_ADD_FONT_MATCH_HINT]: "Will be added as {{style}} of {{family}}.",
  [TEMPLATES_ADD_FONT_PARSE_FAILED]:
    "Could not read font metadata. Enter the family name.",
  [TEMPLATES_ADD_FONT_PARTIAL_ERROR]: "Some fonts could not be uploaded.",
  [TEMPLATES_ADD_FONT_VARIABLE]: "Variable font",
  [TEMPLATES_ADD_FONT_SUMMARY]: "Summary",
  [TEMPLATES_ADD_FONT_SUMMARY_FAMILY]: "Family",
  [TEMPLATES_ADD_FONT_SUMMARY_STYLE]: "Style",
  [TEMPLATES_ADD_FONT_SUMMARY_KIND]: "Type",
  [TEMPLATES_ADD_FONT_SUMMARY_STATIC]: "Static font",
  [TEMPLATES_ADD_FONT_SUMMARY_STYLES]: "Available styles",
  [TEMPLATES_ADD_FONT_SUMMARY_HINT]:
    "Select one or more .ttf, .otf, .woff, or .woff2 files. Styles from the same family are grouped into a single summary.",
  [TEMPLATES_ADD_FONT_CHANGE_FILE]: "Change files",
  [TEMPLATES_ADD_FONT_FILE]: "File",
  [TEMPLATES_ADD_FONT_SELECT_FILE]: "Select files",
  [TEMPLATES_ADD_FONT_ERROR]: "The font could not be uploaded.",
  [TEMPLATES_ADD_FONT_INVALID_FILE]: "Use .ttf, .otf, .woff, or .woff2 files.",
  [TEMPLATES_ADD_FONT_INVALID_NAME]: "The name cannot include . # $ [ ] /",
  [TEMPLATES_ALIGN]: "Alignment",
  [TEMPLATES_ALIGN_LEFT]: "Left",
  [TEMPLATES_ALIGN_CENTER]: "Center",
  [TEMPLATES_ALIGN_RIGHT]: "Right",
  [TEMPLATES_ALIGN_TOP]: "Top",
  [TEMPLATES_ALIGN_MIDDLE]: "Middle",
  [TEMPLATES_ALIGN_BOTTOM]: "Bottom",
  [TEMPLATES_ALIGN_LAYERS]: "Align",
  [TEMPLATES_LOCK_LAYER]: "Lock",
  [TEMPLATES_UNLOCK_LAYER]: "Unlock",
  [TEMPLATES_HIDE_LAYER]: "Hide",
  [TEMPLATES_SHOW_LAYER]: "Show",
  [TEMPLATES_ALIGNMENT_GUIDES]: "Alignment guides",
  [TEMPLATES_GUIDE_OPACITY]: "Guide opacity",
  [TEMPLATES_ORIENTATION]: "Orientation",
  [TEMPLATES_ORIENTATION_HORIZONTAL]: "Horizontal",
  [TEMPLATES_ORIENTATION_VERTICAL]: "Vertical ↓",
  [TEMPLATES_ORIENTATION_VERTICAL_UP]: "Vertical ↑",
  [TEMPLATES_OVERFLOW]: "If it does not fit",
  [TEMPLATES_MAX_LINES]: "Max. Lines",
  [TEMPLATES_MIN_LINES]: "Min. Lines",
  [TEMPLATES_MIN_FONT]: "Minimum",
  [TEMPLATES_POSITION]: "Position",
  [TEMPLATES_SIZE]: "Size",
  [TEMPLATES_POS_X]: "X",
  [TEMPLATES_POS_Y]: "Y",
  [TEMPLATES_POS_W]: "W",
  [TEMPLATES_POS_H]: "H",
  [TEMPLATES_FRAME_W]: "Frame Width",
  [TEMPLATES_FRAME_H]: "Frame Height",
  [TEMPLATES_CLIP]: "Clip Content",
  [TEMPLATES_HIDE]: "Hide",
  [TEMPLATES_SHOW]: "Show",
  [TEMPLATES_MIN_SIZE]: "Min size",
  [TEMPLATES_PADDING]: "Safe area",
  [TEMPLATES_DRAW]: "Draw layer",
  [TEMPLATES_DRAWING]: "Drawing",
  [TEMPLATES_DRAW_HINT]:
    "Drag on the canvas. With a group or a nested layer selected, the new layer is created inside the group.",
  [TEMPLATES_OVERFLOW_SHRINK]: "Shrink",
  [TEMPLATES_OVERFLOW_REJECT]: "Block",
  [TEMPLATES_BACKDROP_NOTE]:
    "Mark the zone; the real logo or seal file is uploaded later. This image is only the editor backdrop.",
  [TEMPLATES_NODE_COUNT]: "{{count}} layers",
  [TEMPLATES_NODE_COUNT_SINGLE]: "{{count}} layer",
  [TEMPLATES_ARTBOARD]: "{{width}}×{{height}}",
  [TEMPLATES_ADD_FORMAT]: "Add",
  [TEMPLATES_CUSTOM_FORMAT]: "Custom",
  [TEMPLATES_CUSTOM_FORMAT_TITLE]: "Custom Size",
  [TEMPLATES_CUSTOM_WIDTH]: "Width",
  [TEMPLATES_CUSTOM_HEIGHT]: "Height",
  [TEMPLATES_CUSTOM_SIZE_INVALID]:
    "Enter a width and height between 1 and 8192.",
  [TEMPLATES_EDIT_PREVIOUS]: "Edit previous",
  [TEMPLATES_NEW_FORMAT_HINT]:
    "Upload an image to separate it into layers, or copy the layers from the previous size.",
  [TEMPLATES_REMOVE_FORMAT]: "Remove size",
  [TEMPLATES_THIS_FORMAT]: "this size",
  [TEMPLATES_UPLOAD_REFERENCE]: "Upload guide",
  [TEMPLATES_CHANGE_REFERENCE]: "Change guide",
  [TEMPLATES_SHOW_GUIDE]: "Show guide",
  [TEMPLATES_HIDE_GUIDE]: "Hide guide",
  [TEMPLATES_GUIDE_HINT]:
    "The guide shows the original creative as a translucent overlay so you can see where each layer should go.",
  [TEMPLATES_EDITOR_PREVIEW_VARIABLES_TITLE]: "Preview variables",
  [TEMPLATES_EDITOR_PREVIEW_VARIABLES_DESCRIPTION]:
    "Fill in the variables and images this template needs.",
  [TEMPLATES_EDITOR_PREVIEW_ERROR]: "The preview could not be generated.",
  [TEMPLATES_EDITOR_PREVIEW_TITLE]: "Preview",
  [TEMPLATES_EDITOR_PREVIEW_USED_VALUES]: "Values used",
  [TEMPLATES_EDITOR_PREVIEW_SAVED_TO_GALLERY]: "Content Saved To Gallery",
  [TEMPLATES_ZOOM_IN]: "Zoom in",
  [TEMPLATES_ZOOM_OUT]: "Zoom out",
  [TEMPLATES_ZOOM_FIT]: "Fit to screen",
  [TEMPLATES_TEXT_COLLISION_ONE]: "1 text may cover another layer",
  [TEMPLATES_TEXT_COLLISION_OTHER]: "{{count}} texts may cover other layers",
  [TEMPLATES_TEXT_COLLISION_UNNAMED_TEXT]: "Text",
  [TEMPLATES_TEXT_COLLISION_UNNAMED_IMAGE]: "Image",
  [CANVAS_TOOLS_BAR_LABEL]: "Tools",
  [CANVAS_TOOL_ERASER]: "Erase object",
  [CANVAS_TOOL_ERASER_HINT]: "Shade the element you want to erase",
  [CANVAS_TOOL_ERASER_BRUSH_SIZE]: "Brush size",
  [CANVAS_TOOL_ERASER_APPLY]: "Erase",
  [TEMPLATES_UNAUTHORIZED]: "You do not have permission to edit templates.",
  [TEMPLATES_ANALYZING_LOCK]: "Separating your creative into layers…",
  [TEMPLATES_SAVE_SUCCESS]: "Template Saved.",
  [TEMPLATES_DELETE_ERROR]: "The template could not be deleted.",
  [TEMPLATES_UPLOAD_ERROR]: "The image could not be uploaded.",
  [TEMPLATES_ANALYZE_ERROR]: "The creative could not be analyzed.",
  [TEMPLATES_ANALYZE_IMAGE_TOO_SMALL]:
    "The image is too small to separate into layers. It must have a resolution of at least 1080 x 1080 (HD).",
  [IMAGE_TOO_SMALL_FOR_LAYERIZE]:
    "The image is too small to separate into layers. It must have a resolution of at least 1080 x 1080 (HD).",
  [TEMPLATES_ANALYZE_RETRY]: "Retry",
  [TEMPLATES_CREATE_ERROR]: "The template could not be created.",
  [TEMPLATES_SAVE_ERROR]: "The template could not be saved.",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_TITLE]:
    "Variables do not match across sizes",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_TITLE_CAROUSEL]:
    "Variables do not match across sizes on the same slide",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_DESCRIPTION]:
    "Every size must have the same variables. The following variables are missing in these sizes:",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_DESCRIPTION_CAROUSEL]:
    "Within each slide, every size must have the same variables. The following variables are missing in these sizes:",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_ARIA_LABEL]: "Missing variables by size",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_FORMAT]: "Size",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_TYPE]: "Layer type",
  [TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_VARIABLE]: "Variable",
  [TEMPLATES_SAVE_TRANSPARENCY_GAP_TITLE]: "Warning",
  [TEMPLATES_SAVE_TRANSPARENCY_GAP_DESCRIPTION]:
    "These sizes have uncovered transparent areas. You can fill them in now, or continue: if you continue, those areas will be filled with white.",
  [TEMPLATES_CONFIRM_DELETE_TITLE]: "Delete Template?",
  [TEMPLATES_CONFIRM_DELETE_DESCRIPTION]: "This cannot be undone.",
  [TEMPLATES_CONFIRM_REMOVE_FORMAT_TITLE]: "Remove size?",
  [TEMPLATES_CONFIRM_REMOVE_FORMAT_DESCRIPTION]:
    "The {{format}} size and all its layers will be removed. This cannot be undone.",
  [TEMPLATES_CONFIRM_ADD_FORMAT]: "Add Format",
  [TEMPLATES_CONFIRM_ADD_FORMAT_DESCRIPTION]:
    "Remember to complete the initial format setup so it's easier to work on new formats.",
  [TEMPLATES_CONFIRM_AI_RESIZE_BACKGROUND]: "Resize Background",
  [TEMPLATES_CONFIRM_AI_RESIZE_BACKGROUND_DESCRIPTION]:
    "Do you want to resize the background image with AI so it fits the new format?",
  [TEMPLATES_AI_RESIZE_BACKGROUND_CONFIRM]: "Resize",
  [TEMPLATES_AI_RESIZE_BACKGROUND_LOCK]: "Resizing the background with AI",
  [TEMPLATES_KEEP_EDITING]: "Keep Editing",
  [TEMPLATES_CLOSE_UNSAVED_DESCRIPTION]:
    "Are you sure you want to leave? All unsaved changes will be lost.",
  [TEMPLATES_PRODUCE_DRAFT_TITLE]: "Incomplete Template",
  [TEMPLATES_PRODUCE_DRAFT_DESCRIPTION]:
    "Complete the template with a name and at least one layer before producing.",
  [TEMPLATES_PRODUCE_DRAFT_COMPLETE]: "Complete",
  [TEMPLATES_SAVE_PRODUCE_TITLE]: "Template Saved",
  [TEMPLATES_SAVE_BLOCKED_PRODUCING]:
    "Creatives are currently being produced with this template. Saving now could cause production errors. You'll be able to save your changes as soon as it finishes.",
  [TEMPLATES_SAVE_PRODUCE_DESCRIPTION]: "You can now produce creatives",
  [TEMPLATES_SAVE_PRODUCE_CONFIRM]: "Produce",
  [TEMPLATES_SAVE_PRODUCE_CANCEL]: "Go Back",
  [TEMPLATES_NEW_ZONE]: "layer",
  [TEMPLATES_NEW_LAYER]: "Layer",
  [TEMPLATES_PRODUCE_MENU_ITEM]: "Produce",
  [TEMPLATES_PRODUCE_TITLE]: "Produce",
  [TEMPLATES_PRODUCE_DESCRIPTION]:
    "Choose a template, a language, and fill in the variables for each row.",
  [TEMPLATES_PRODUCE_CONFIG_KICKER]: "Configuration",
  [TEMPLATES_PRODUCE_SELECTED_TEMPLATE_LABEL]: "Selected template",
  [TEMPLATES_PRODUCE_VARIABLES_EYEBROW]: "Production variables",
  [TEMPLATES_PRODUCE_SUMMARY_IMAGE_UNIT]: "image",
  [TEMPLATES_PRODUCE_SUMMARY_IMAGES_UNIT]: "images",
  [TEMPLATES_PRODUCE_SUMMARY_VARIATION_LABEL]: "{{count}} variation",
  [TEMPLATES_PRODUCE_SUMMARY_VARIATIONS_LABEL]: "{{count}} variations",
  [TEMPLATES_PRODUCE_SUMMARY_COST]: "{{count}} {{unit}}",
  [TEMPLATES_PRODUCE_SUMMARY_COST_LABEL]: "Cost",
  [TEMPLATES_PRODUCE_SUMMARY_RATE]: "{{count}} {{unit}} per image",
  [TEMPLATES_PRODUCE_SUMMARY_FORMAT]: "Format {{size}}",
  [TEMPLATES_PRODUCE_SUMMARY_IMAGES_COUNT]: "{{count}} images",
  [TEMPLATES_PRODUCE_SUMMARY_IMAGES_COUNT_SINGLE]: "{{count}} image",
  [TEMPLATES_PRODUCE_SUMMARY_SIZE_COUNT]: "{{count}} size",
  [TEMPLATES_PRODUCE_SUMMARY_SIZES_COUNT]: "{{count}} sizes",
  [TEMPLATES_PRODUCE_SUMMARY_SLIDE_COUNT]: "{{count}} slide",
  [TEMPLATES_PRODUCE_SUMMARY_SLIDES_COUNT]: "{{count}} slides",
  [TEMPLATES_PRODUCE_ROW_COUNT]: "{{count}} rows",
  [TEMPLATES_PRODUCE_ROW_COUNT_SINGLE]: "{{count}} row",
  [TEMPLATES_PRODUCE_TEMPLATE]: "Template",
  [TEMPLATES_PRODUCE_CHANGE]: "Change",
  [TEMPLATES_PRODUCE_DIMENSIONS]: "Sizes",
  [TEMPLATES_PRODUCE_LANGUAGE]: "Language",
  [TEMPLATES_PRODUCE_VARIATIONS]: "Number of Variations",
  [TEMPLATES_PRODUCE_VARIATIONS_PER_ROW]: "Variations per Row",
  [TEMPLATES_PRODUCE_ROWS]: "Rows",
  [TEMPLATES_PRODUCE_ROWS_HINT]: "Type here. No file needed.",
  [TEMPLATES_PRODUCE_ADD_ROW]: "Add row",
  [TEMPLATES_PRODUCE_LOAD_LAST_CONFIG]: "Load last used data",
  [TEMPLATES_PRODUCE_UPLOAD_CSV]: "Upload CSV",
  [TEMPLATES_PRODUCE_DOWNLOAD_FORMAT]: "Download CSV",
  [TEMPLATES_PRODUCE_CSV_EXAMPLE_FILENAME]: "{{name}}-example-variables.csv",
  [TEMPLATES_PRODUCE_CSV_EXAMPLE_TEXT]: "Example {{label}}",
  [TEMPLATES_PRODUCE_GENERATE]: "Generate {{count}} images",
  [TEMPLATES_PRODUCE_GENERATE_SINGLE]: "Generate {{count}} image",
  [TEMPLATES_PRODUCE_PREVIEW]: "Generate preview",
  [TEMPLATES_PRODUCE_PREVIEW_TOOLTIP]:
    "Generates a test image of this template.",
  [TEMPLATES_PRODUCE_PREVIEW_THIS_SLIDE]: "This slide",
  [TEMPLATES_PRODUCE_PREVIEW_WHOLE_CAROUSEL]: "Entire carousel",
  [TEMPLATES_PRODUCE_SUMMARY]: "Summary",
  [TEMPLATES_PRODUCE_EMPTY_TEMPLATES]:
    "There are no templates with layers to produce yet.",
  [TEMPLATES_PRODUCE_EMPTY_VARIABLES]:
    "This template has no variables to fill in.",
  [TEMPLATES_PRODUCE_SELECT_TEMPLATE]: "Select a Template",
  [TEMPLATES_PRODUCE_CSV_TITLE]: "How Do You Want To Load The CSV?",
  [TEMPLATES_PRODUCE_CSV_DESCRIPTION]:
    "You can replace all current rows or append the file rows at the end.",
  [TEMPLATES_PRODUCE_CSV_REPLACE]: "Replace",
  [TEMPLATES_PRODUCE_CSV_APPEND]: "Append",
  [TEMPLATES_PRODUCE_CSV_ERROR]: "The CSV file could not be read.",
  [TEMPLATES_PRODUCE_CSV_EMPTY]:
    "The CSV has no valid rows for this template's variables.",
  [TEMPLATES_PRODUCE_CHANGE_TEMPLATE_TITLE]: "Change Template?",
  [TEMPLATES_PRODUCE_CHANGE_TEMPLATE_DESCRIPTION]:
    "Current rows will be cleared because the variables may change.",
  [TEMPLATES_PRODUCE_VALIDATION_ERROR]:
    "Fill in every variable. Cells with missing data are marked in red.",
  [TEMPLATES_PRODUCE_VALIDATION_HIGHLIGHT]:
    "Each highlighted phrase must match that row's text exactly. Cells that do not match are marked in red.",
  [TEMPLATES_PRODUCE_VALIDATION_NO_ROWS]:
    "Add at least one row before generating.",
  [TEMPLATES_PRODUCE_VALIDATION_VARIATIONS]: "Enter an integer of at least 1.",
  [TEMPLATES_PRODUCE_VALIDATION_NO_FORMATS]:
    "Select at least one size to generate.",
  [TEMPLATES_PRODUCE_VALIDATION_TOO_MANY_ROWS]:
    "You can generate a maximum of {{max}} rows per production. You requested {{count}}. Reduce the variations or rows.",
  [TEMPLATES_PRODUCE_GENERATE_SUCCESS]:
    "Production started. You can leave this page; results will appear below the table and in the activity panel.",
  [TEMPLATES_PRODUCE_DELETE_ROW]: "Delete row",
  [TEMPLATES_PRODUCE_COPY_TO_COLUMN]: "Copy this value to the whole column",
  [TEMPLATES_PRODUCE_SELECT_IMAGE]: "Select image",
  [TEMPLATES_PRODUCE_REPLACE_IMAGE]: "Replace image",
  [TEMPLATES_PRODUCE_IMAGE_CHECKING]: "Checking that the image can be used",
  [TEMPLATES_PRODUCE_IMAGE_UNUSABLE]:
    "This image cannot be downloaded because it is blocked. Please upload it manually.",
  [TEMPLATES_PRODUCE_IMAGES_PROCESSING]: "Incoming images are being processed.",
  [TEMPLATES_PRODUCE_IMAGES_UNUSABLE]:
    "Some images cannot be downloaded for use. Check the table and upload them manually.",
  [TEMPLATES_PRODUCE_DELETE_IMAGE]: "Delete image",
  [TEMPLATES_PRODUCE_RESULTS]: "Results",
  [TEMPLATES_PRODUCE_RUN_TITLE]: "{{date}}",
  [TEMPLATES_PRODUCE_RUN_LEGACY]: "Previous generations",
  [TEMPLATES_PRODUCE_DELETE_SELECTED]: "Delete ({{count}})",
  [TEMPLATES_PRODUCE_DELETE_CONFIRM_TITLE]:
    "Delete {{count}} generated item(s)?",
  [TEMPLATES_PRODUCE_DELETE_CONFIRM_TEXT]: "This action cannot be undone.",
  [TEMPLATES_PRODUCE_DELETE_ERROR]: "We could not delete the selected items.",
  [TEMPLATES_PRODUCE_DOWNLOAD_CONFIG]: "Download configuration",
  [TEMPLATES_PRODUCE_CONFIG_FILENAME]: "{{name}}-variables.csv",
  [TEMPLATES_PRODUCE_GENERATING]: "Generating…",
  [TEMPLATES_PRODUCE_ACTIVE_RUN]:
    "A production is already running for this set. Wait until it finishes.",
  [TEMPLATES_PRODUCE_EDIT_TITLE]: "Edit Piece",
  [TEMPLATES_PRODUCE_EDIT_NO_INSTANCE]:
    "This piece has no editable layers. Generate it again to enable editing.",
  [TEMPLATES_PRODUCE_ADD_TEXT]: "Text",
  [TEMPLATES_PRODUCE_ADD_IMAGE]: "Image",
  [TEMPLATES_PRODUCE_ADD_SHAPE]: "Shape",
  [TEMPLATES_PRODUCE_ADD_GROUP]: "Group",
  [TEMPLATES_GROUP_LAYERS]: "Group",
  [TEMPLATES_PRODUCE_SAVE_ERROR]: "Could Not Save The Piece",
  [TEMPLATES_PRODUCE_PARTIAL_SUMMARY]:
    "{{succeeded}} of {{requested}} generated. {{failed}} failed.",
  [TEMPLATES_PRODUCE_PARTIAL_TITLE]:
    "Almost ready: {{succeeded}} of {{requested}} creatives generated",
  [TEMPLATES_PRODUCE_PARTIAL_SUBTITLE_SINGULAR]:
    "1 creative could not be generated. You can try again without redoing the others.",
  [TEMPLATES_PRODUCE_PARTIAL_SUBTITLE_PLURAL]:
    "{{failed}} creatives could not be generated. You can try again without redoing the others.",
  [TEMPLATES_PRODUCE_RETRY_FAILED]: "Retry failed",
  [TEMPLATES_PRODUCE_RETRY_FAILED_SINGULAR]: "Retry failed",
  [TEMPLATES_PRODUCE_RETRY_FAILED_PLURAL]: "Retry failed",
  [TEMPLATES_PRODUCE_FAILURE_GENERIC]: "This image could not be generated.",
  [TEMPLATES_PRODUCE_FAILURE_BUSY]: "The service was busy. Please try again.",
  [TEMPLATES_PRODUCE_FAILURE_IMAGE]: "This image could not be generated.",
  [TEMPLATES_PRODUCE_FAILURE_DATA]: "This row is missing required data.",
  [INSIGHTS_PAGE_TITLE]: "Insights",
  [INSIGHTS_HEADER_BRAND]: "leds/insights",
  [INSIGHTS_HEADER_HELP]: "Need help?",
  [INSIGHTS_CONNECT_STEP_NUMBER]: "Step 01 / 04",
  [INSIGHTS_CONNECT_TITLE]: "Connect your",
  [INSIGHTS_CONNECT_MUTED]: "Meta account.",
  [INSIGHTS_CONNECT_DESCRIPTION]:
    "We'll read your campaign data to build a report tailored to your business. We only request read access — we never change campaigns, budgets, or ads.",
  [INSIGHTS_CONNECT_CARD_TITLE]: "Meta Ads Account",
  [INSIGHTS_CONNECT_CARD_SUBTITLE]:
    "Read-only access. No edits, no publishing.",
  [INSIGHTS_CONNECT_CTA]: "Connect with Meta",
  [INSIGHTS_CONNECT_CONNECTING]: "Connecting…",
  [INSIGHTS_CONNECT_CREDENTIALS_NOTE]:
    "Your credentials are never stored, and we cannot modify your account.",
  [INSIGHTS_CONNECT_ERROR_CANCELLED]:
    "Connection cancelled. Try again when you're ready.",
  [INSIGHTS_CONNECT_ERROR_FAILED]:
    "We couldn't connect to Meta. Please try again.",
  [INSIGHTS_CONNECT_ERROR_SDK]:
    "Meta login isn't ready yet. Refresh the page and try again.",
  [INSIGHTS_CONNECT_ERROR_NO_ACCOUNTS]:
    "This Meta user has no ad accounts we can read.",
  [INSIGHTS_CONNECT_ERROR_GENERIC]:
    "Something went wrong while connecting. Please try again.",
  [INSIGHTS_ACCOUNT_BACK]: "Back",
  [INSIGHTS_ACCOUNT_STEP_NUMBER]: "Step 02 / 04",
  [INSIGHTS_ACCOUNT_TITLE]: "Select an",
  [INSIGHTS_ACCOUNT_MUTED]: "advertising account.",
  [INSIGHTS_ACCOUNT_DESCRIPTION]:
    "Choose the account you want to analyze in your report.",
  [INSIGHTS_ACCOUNT_CONTINUE]: "Continue with {{accountName}}",
  [INSIGHTS_ACCOUNT_EMPTY]: "No ad accounts were returned for this connection.",
  [INSIGHTS_ACCOUNT_STATUS_ACTIVE]: "Active",
  [INSIGHTS_ACCOUNT_STATUS_PAUSED]: "Paused",
  [INSIGHTS_GENERATING_STEP_NUMBER]: "Step 03 / 04",
  [INSIGHTS_GENERATING_TITLE]: "We're generating",
  [INSIGHTS_GENERATING_MUTED]: "your report.",
  [INSIGHTS_GENERATING_DESCRIPTION]:
    "Analyzing data from {{accountName}}. This may take about a minute.",
  [INSIGHTS_GENERATING_PROCESSING_LABEL]: "Processing insights",
  [INSIGHTS_GENERATING_ERROR]:
    "We couldn't generate the report. Check the connection and try again.",
  [INSIGHTS_GENERATING_RETRY]: "Try again",
  [INSIGHTS_DONE_STEP_NUMBER]: "Report ready",
  [INSIGHTS_DONE_TITLE]: "Your opportunities",
  [INSIGHTS_DONE_MUTED]: "are waiting.",
  [INSIGHTS_DONE_DESCRIPTION]:
    "We've analyzed {{accountName}}. Discover insights that can grow your campaigns.",
  [INSIGHTS_DONE_REPORT_TITLE]: "Performance report",
  [INSIGHTS_DONE_REPORT_SUBTITLE]: "Executive summary · {{currency}}",
  [INSIGHTS_DONE_CTA_TITLE]: "Want to know more?",
  [INSIGHTS_DONE_CTA_DESCRIPTION]:
    "Schedule a demo and let's review your account insights together. With {{productName}} you'll get access to the following features and much more.",
  [INSIGHTS_DONE_SCHEDULE_DEMO]: "Schedule a demo",
  [INSIGHTS_DONE_RESTART]: "Start over",
  [INSIGHTS_REPORT_WHY]: "Why it matters",
  [INSIGHTS_REPORT_WHAT_TO_DO]: "What to do",
  [INSIGHTS_REPORT_QUICK_WINS]: "Two quick wins you can do today",
  [INSIGHTS_FEATURES_HEADING]: "Features",
  [INSIGHTS_FEATURE_AI_MEDIA_TITLE]: "AI media generation",
  [INSIGHTS_FEATURE_AI_MEDIA_DESCRIPTION]:
    "Create images and videos ready to test new ideas.",
  [INSIGHTS_FEATURE_AI_CAMPAIGNS_TITLE]: "AI campaigns",
  [INSIGHTS_FEATURE_AI_CAMPAIGNS_DESCRIPTION]:
    "Build complete campaigns from a single objective.",
  [INSIGHTS_FEATURE_COMPETITORS_TITLE]: "Competitors",
  [INSIGHTS_FEATURE_COMPETITORS_DESCRIPTION]:
    "Understand which messages and formats are moving the market.",
  [INSIGHTS_FEATURE_REPORTS_TITLE]: "Reports",
  [INSIGHTS_FEATURE_REPORTS_DESCRIPTION]:
    "Analyze your campaign performance and discover improvement opportunities.",

  [AI_COMPETITORS_PAGE_TITLE]: "Competitor analysis",
  [AI_COMPETITORS_URL_STEP_NUMBER]: "Step 01 / 04",
  [AI_COMPETITORS_URL_TITLE]: "Analyze",
  [AI_COMPETITORS_URL_MUTED]: "your competitors.",
  [AI_COMPETITORS_URL_DESCRIPTION]:
    "Paste your business website. In seconds we'll show you who is running ads in your market — and which creatives they're using.",
  [AI_COMPETITORS_URL_PLACEHOLDER]: "Paste your business website",
  [AI_COMPETITORS_URL_CTA]: "See my competitors' ads",
  [AI_COMPETITORS_URL_INVALID]:
    "That doesn't look like a valid URL. Check the spelling and try again.",
  [AI_COMPETITORS_URL_BLOCKED]:
    "We couldn't get the information from your website. Some pages use mechanisms that block automated access (anti-crawlers)",
  [AI_COMPETITORS_URL_NO_COMPETITORS]:
    "We couldn't find competitors for that brand. Try another URL or a more specific domain.",
  [AI_COMPETITORS_ANALYZING_STEP_NUMBER]: "Step 02 / 04",
  [AI_COMPETITORS_ANALYZING_TITLE]: "We're reading",
  [AI_COMPETITORS_ANALYZING_MUTED]: "your market.",
  [AI_COMPETITORS_ANALYZING_DESCRIPTION]:
    "We identify your brand, category, and country to suggest real competitors.",
  [AI_COMPETITORS_PROGRESS_FALLBACK]: "Analyzing your website",
  [AI_COMPETITORS_PROGRESS_REVIEWING_PAGE]: "Reviewing your page",
  [AI_COMPETITORS_PROGRESS_FINDING_COMPETITORS]: "Finding your competitors",
  [AI_COMPETITORS_PROGRESS_CONSOLIDATING_COMPETITORS]:
    "Consolidating your competitors",
  [AI_COMPETITORS_PROGRESS_RESOLVING_ADS]: "Matching your competitors",
  [AI_COMPETITORS_PROGRESS_SEARCHING_ADS]: "Searching active ads",
  [AI_COMPETITORS_PROGRESS_CONSOLIDATING_ADS]: "Consolidating the ads",
  [AI_COMPETITORS_COMPETITORS_STEP_NUMBER]: "Step 03 / 04",
  [AI_COMPETITORS_COMPETITORS_TITLE]: "These are",
  [AI_COMPETITORS_COMPETITORS_MUTED]: "your competitors.",
  [AI_COMPETITORS_COMPETITORS_DESCRIPTION]:
    "Remove the ones that don't apply, edit the name, or paste the domain of the ones you're interested in.",
  [AI_COMPETITORS_COMPETITORS_EMPTY]:
    "We couldn't suggest competitors automatically. Paste the domain of the brands you want to spy on.",
  [AI_COMPETITORS_COMPETITORS_ADD_PLACEHOLDER]:
    "Paste a domain, e.g. competitor.com",
  [AI_COMPETITORS_COMPETITORS_ADD]: "Add",
  [AI_COMPETITORS_COMPETITORS_ADD_INVALID]:
    "Check the domain. It should look like brand.com",
  [AI_COMPETITORS_COMPETITORS_NAME_LABEL]: "Name",
  [AI_COMPETITORS_COMPETITORS_REMOVE]: "Remove",
  [AI_COMPETITORS_COMPETITORS_CTA]: "Search their ads",
  [AI_COMPETITORS_COMPETITORS_NEED_ONE]:
    "Add at least one competitor to search ads.",
  [AI_COMPETITORS_COMPETITORS_ADD_MAX]:
    "You can add up to {{max}} competitors.",
  [AI_COMPETITORS_SEARCHING_STEP_NUMBER]: "Step 04 / 04",
  [AI_COMPETITORS_SEARCHING_TITLE]: "Searching",
  [AI_COMPETITORS_SEARCHING_MUTED]: "active ads.",
  [AI_COMPETITORS_SEARCHING_ERROR]:
    "We couldn't finish the search. Please try again.",
  [AI_COMPETITORS_SEARCHING_RETRY]: "Try again",
  [AI_COMPETITORS_RESULTS_STEP_NUMBER]: "Ads found",
  [AI_COMPETITORS_RESULTS_TITLE]: "This is what",
  [AI_COMPETITORS_RESULTS_MUTED]: "your competitors are running.",
  [AI_COMPETITORS_RESULTS_SUMMARY]:
    "We found {{adsCount}} active ads from {{competitorCount}} competitors.",
  [AI_COMPETITORS_RESULTS_NO_ADS]: "No active ads",
  [AI_COMPETITORS_RESULTS_NO_ADS_ALERT_TITLE]:
    "Your competitors are barely advertising. That's your opening.",
  [AI_COMPETITORS_RESULTS_NO_ADS_ALERT_BODY]:
    "Adle can watch your competitors 24/7 and replicate the ads that actually work.",
  [AI_COMPETITORS_RESULTS_NO_ADS_CTA]: "Book a demo",
  [AI_COMPETITORS_RESULTS_VIEW_MORE]: "See more",
  [AI_COMPETITORS_RESULTS_GENERATE]: "Generate My Version",
  [AI_COMPETITORS_RESULTS_LOCKED_COUNT]: "+{{count}} more ads",
  [AI_COMPETITORS_RESULTS_DOWNLOAD]: "Download",
  [AI_COMPETITORS_RESULTS_FORMAT_IMAGE]: "Image",
  [AI_COMPETITORS_RESULTS_FORMAT_VIDEO]: "Video",
  [AI_COMPETITORS_RESULTS_FORMAT_CAROUSEL]: "Carousel",
  [AI_COMPETITORS_AGENDA_CONFIRM_TITLE]: "Discover Adle",
  [AI_COMPETITORS_AGENDA_CONFIRM_TEXT]:
    "We'll show you all of your competitors' ads and how to replicate them in seconds.",
  [AI_COMPETITORS_AGENDA_CONFIRM_CTA]: "Book a Demo",
  [AI_COMPETITORS_AGENDA_BACK]: "Back",
  [AI_COMPETITORS_AGENDA_STEP_NUMBER]: "Next step",
  [AI_COMPETITORS_AGENDA_TITLE]: "We'll show you",
  [AI_COMPETITORS_AGENDA_MUTED]: "how to replicate them.",
  [AI_COMPETITORS_AGENDA_CONTEXT]:
    "We found {{adsCount}} active ads from {{competitorNames}}. On the call we'll show you how to replicate the ones that work best with {{productName}}.",
  [AI_COMPETITORS_AGENDA_CONTEXT_ZERO]:
    "Your competitors are barely advertising — that's your opening. {{productName}} can watch them 24/7 and replicate ads that work.",
  [AI_COMPETITORS_AGENDA_CONTEXT_FALLBACK]:
    "On the call we'll show you how to replicate the ads that work best with {{productName}}.",
  [AI_COMPETITORS_THANKS_STEP_NUMBER]: "Booking confirmed",
  [AI_COMPETITORS_THANKS_TITLE]: "See you",
  [AI_COMPETITORS_THANKS_MUTED]: "on the call.",
  [AI_COMPETITORS_THANKS_DESCRIPTION]:
    "We sent the confirmation to your email. On the session we'll review your competitors' ads and how to replicate the ones that work best.",
  [NEW_FEATURE_CALLOUT_BADGE]: "NEW FEATURE",
  [NEW_FEATURE_CALLOUT_CLOSE_ARIA]: "Close",
  [NEW_FEATURE_CALLOUT_DEFAULT_CTA]: "Discover",
  [NEW_FEATURE_CALLOUT_INSIGHTS_TITLE]: "Insights",
  [NEW_FEATURE_CALLOUT_INSIGHTS_DESCRIPTION]:
    "Discover the learnings AI identified in your campaign results and apply them to your brand setup.",
  [NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_TITLE]: "Templates",
  [NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_DESCRIPTION]:
    "Generate content from templates: define the layers, or upload a creative and we’ll analyze it for you.",
  [NEW_FEATURE_CALLOUT_AUTOMATIONS_TITLE]: "Automations",
  [NEW_FEATURE_CALLOUT_AUTOMATIONS_DESCRIPTION]:
    "Auto-publish content from your library: pick a folder, platforms, and frequency. We handle the rest.",

  // AUTOMATIONS
  [AUTOMATIONS_MENU_TITLE]: "Automations",
  [AUTOMATIONS_PAGE_TITLE]: "Automated Publishing",
  [AUTOMATIONS_PAGE_DESCRIPTION]:
    "Let {{NAME_BUSINESS}} automatically publish content from your library to your connected social accounts.",
  [BUTTON_NEW_AUTOMATION]: "New",
  [AUTOMATIONS_HERO_TITLE]: "Save time. Keep posting.",
  [AUTOMATIONS_HERO_DESCRIPTION]:
    "Select a folder, choose your platforms, and {{NAME_BUSINESS}} will take care of the rest — from scheduling to publishing.",
  [AUTOMATIONS_STATUS_ACTIVE]: "Active",
  [AUTOMATIONS_STATUS_PAUSED]: "Paused",
  [AUTOMATIONS_LABEL_FOLDER]: "Folder",
  [AUTOMATIONS_LABEL_PLATFORMS]: "Platforms",
  [AUTOMATIONS_LABEL_FREQUENCY]: "Frequency",
  [AUTOMATIONS_LABEL_NEXT_POST]: "Next post",
  [AUTOMATIONS_MOCK_BRAND_CONTENT]: "Brand Content",
  [AUTOMATIONS_MOCK_PRODUCT_LAUNCH]: "Product Launch",
  [AUTOMATIONS_MOCK_THOUGHT_LEADERSHIP]: "Thought Leadership",
  [AUTOMATIONS_MOCK_FOLDER_SOCIAL_SEPTEMBER]: "Social Media September",
  [AUTOMATIONS_MOCK_FOLDER_ALL_CONTENT]: "All Content",
  [AUTOMATIONS_MOCK_FOLDER_LINKEDIN]: "LinkedIn Content",
  [AUTOMATIONS_MOCK_FREQ_ONE_PER_DAY]: "1 post per day",
  [AUTOMATIONS_MOCK_FREQ_FIVE_PER_WEEK]: "5 posts per week",
  [AUTOMATIONS_MOCK_FREQ_THREE_PER_WEEK]: "3 posts per week",
  [AUTOMATIONS_FREQ_ONE_PER_DAY]: "1 post per day",
  [AUTOMATIONS_FREQ_THREE_PER_WEEK]: "3 posts per week",
  [AUTOMATIONS_FREQ_FOUR_PER_WEEK]: "4 posts per week",
  [AUTOMATIONS_FREQ_FIVE_PER_WEEK]: "5 posts per week",
  [AUTOMATIONS_FREQ_SIX_PER_WEEK]: "6 posts per week",
  [AUTOMATIONS_MOCK_NEXT_TODAY]: "Today · 7:00 PM",
  [AUTOMATIONS_MOCK_NEXT_EMPTY]: "—",
  [AUTOMATIONS_MOCK_NEXT_TOMORROW]: "Tomorrow · 9:00 AM",
  [MODAL_CREATE_AUTOMATION_TITLE]: "Create Automation",
  [AUTOMATIONS_STEP_SOURCE]: "Source",
  [AUTOMATIONS_STEP_PLATFORMS]: "Platforms",
  [AUTOMATIONS_STEP_SCHEDULE]: "Schedule",
  [AUTOMATIONS_STEP_CONTENT_AI]: "Content & AI",
  [AUTOMATIONS_STEP_REVIEW]: "Review",
  [AUTOMATIONS_STEP_SOURCE_TITLE]: "Select content source",
  [AUTOMATIONS_STEP_SOURCE_HELP]:
    "Choose which content {{NAME_BUSINESS}} should use for automatic publishing.",
  [AUTOMATIONS_SOURCE_ALL_TITLE]: "All content (root)",
  [AUTOMATIONS_SOURCE_ALL_DESCRIPTION]: "Use all content from your library.",
  [AUTOMATIONS_SOURCE_FOLDER_TITLE]: "Specific folder",
  [AUTOMATIONS_SOURCE_FOLDER_DESCRIPTION]:
    "Use content from a selected folder.",
  [AUTOMATIONS_SOURCE_INCLUDE_SUBFOLDERS]: "Include subfolders",
  [AUTOMATIONS_SOURCE_INCLUDE_SUBFOLDERS_HELP]:
    "Also use content from nested folders.",
  [AUTOMATIONS_STEP_LANGUAGE_TITLE]: "Language",
  [AUTOMATIONS_STEP_LANGUAGE_HELP]:
    "Descriptions for posts will be generated in this language.",
  [AUTOMATIONS_VALIDATION_LANGUAGE]:
    "Select a description language to continue.",
  [AUTOMATIONS_REVIEW_LANGUAGE]: "Language",
  [AUTOMATIONS_CONNECT_ACCOUNTS]: "Connect Accounts",
  [AUTOMATIONS_STEP_PLATFORMS_TITLE]: "Select platforms",
  [AUTOMATIONS_STEP_PLATFORMS_HELP]:
    "Choose the social accounts where {{NAME_BUSINESS}} can publish content.",
  [AUTOMATIONS_PLATFORM_CONNECTED]: "Connected",
  [AUTOMATIONS_STEP_SCHEDULE_TITLE]: "Set publishing schedule",
  [AUTOMATIONS_STEP_SCHEDULE_HELP]:
    "Tell {{NAME_BUSINESS}} how often and when to publish.",
  [AUTOMATIONS_SCHEDULE_FREQUENCY]: "Frequency",
  [AUTOMATIONS_SCHEDULE_PUBLISHING_WINDOW]: "Publishing window",
  [AUTOMATIONS_SCHEDULE_PUBLISHING_WINDOW_HELP]:
    "{{NAME_BUSINESS}} will suggest the best times to publish within this time window.",
  [AUTOMATIONS_SCHEDULE_TIMEZONE]: "Timezone",
  [AUTOMATIONS_SCHEDULE_VALIDITY]: "Duration",
  [AUTOMATIONS_SCHEDULE_VALIDITY_HELP]:
    "Choose when this automation starts and when it should stop.",
  [AUTOMATIONS_SCHEDULE_START]: "Start",
  [AUTOMATIONS_SCHEDULE_START_NOW]: "Start now",
  [AUTOMATIONS_SCHEDULE_START_NOW_HELP]:
    "The automation will start immediately after you create it.",
  [AUTOMATIONS_SCHEDULE_START_SCHEDULED]: "Schedule start",
  [AUTOMATIONS_SCHEDULE_END]: "End",
  [AUTOMATIONS_SCHEDULE_END_ALWAYS_ON]: "Always on",
  [AUTOMATIONS_SCHEDULE_END_ALWAYS_ON_HELP]:
    "The automation will keep running until you pause it.",
  [AUTOMATIONS_SCHEDULE_END_SCHEDULED]: "End on a date",
  [AUTOMATIONS_STEP_CONTENT_AI_TITLE]: "Content & AI",
  [AUTOMATIONS_STEP_CONTENT_AI_HELP]:
    "Choose how {{NAME_BUSINESS}} should prepare each post before publishing.",
  [AUTOMATIONS_CONTENT_ORIGINAL_TITLE]: "Use original content",
  [AUTOMATIONS_CONTENT_ORIGINAL_DESCRIPTION]:
    "Publish the selected assets as they are.",
  [AUTOMATIONS_CONTENT_AI_TITLE]: "Optimize with {{NAME_BUSINESS}} AI",
  [AUTOMATIONS_CONTENT_AI_DESCRIPTION]:
    "Generate captions and adapt content for each platform.",
  [AUTOMATIONS_AI_NOTE_TITLE]: "AI assistance is ready",
  [AUTOMATIONS_AI_NOTE_DESCRIPTION]:
    "{{NAME_BUSINESS}} will keep your brand voice consistent.",
  [AUTOMATIONS_STEP_REVIEW_TITLE]: "Review automation",
  [AUTOMATIONS_STEP_REVIEW_HELP]:
    "Check your settings before creating this automation.",
  [AUTOMATIONS_REVIEW_SOURCE]: "Source",
  [AUTOMATIONS_REVIEW_PLATFORMS]: "Platforms",
  [AUTOMATIONS_REVIEW_SCHEDULE]: "Schedule",
  [AUTOMATIONS_REVIEW_VALIDITY]: "Duration",
  [AUTOMATIONS_REVIEW_VALIDITY_VALUE]: "{{start}} · {{end}}",
  [AUTOMATIONS_REVIEW_VALIDITY_START_NOW]: "Starts now",
  [AUTOMATIONS_REVIEW_VALIDITY_START_AT]: "Starts {{datetime}}",
  [AUTOMATIONS_REVIEW_VALIDITY_ALWAYS_ON]: "Always on",
  [AUTOMATIONS_REVIEW_VALIDITY_END_AT]: "Ends {{datetime}}",
  [AUTOMATIONS_REVIEW_NAME]: "Name",
  [AUTOMATIONS_REVIEW_CONTENT_AI]: "AI-generated content",
  [AUTOMATIONS_DEFAULT_NAME]: "Automation {{date}}",
  [AUTOMATIONS_BUTTON_BACK]: "Back",
  [AUTOMATIONS_BUTTON_CREATE]: "Create",
  [AUTOMATIONS_BUTTON_SAVE]: "Save changes",
  [AUTOMATIONS_REVIEW_SCHEDULE_VALUE]:
    "{{frequency}} · {{startTime}} – {{endTime}}",
  [AUTOMATIONS_STATUS_WAITING]: "Waiting for content",
  [AUTOMATIONS_STATUS_SCHEDULING]: "Scheduling",
  [AUTOMATIONS_STATUS_ATTENTION]: "Needs attention",
  [AUTOMATIONS_STATUS_OFF]: "Off",
  [AUTOMATIONS_STATUS_ENDED]: "Ended",
  [AUTOMATIONS_MENU_EDIT]: "Edit",
  [AUTOMATIONS_MENU_VIEW_CALENDAR]: "View calendar",
  [AUTOMATIONS_MENU_TURN_OFF]: "Turn off",
  [AUTOMATIONS_TURN_OFF_TITLE]: "Turn off automated publishing?",
  [AUTOMATIONS_TURN_OFF_DESCRIPTION]:
    "Existing scheduled posts will not be automatically removed. This will stop {{NAME_BUSINESS}} from creating new automated posts.",
  [AUTOMATIONS_TURN_OFF_CONFIRM]: "Turn off",
  [AUTOMATIONS_WAITING_BANNER]:
    "Automation paused — no unpublished compatible content available.",
  [AUTOMATIONS_ATTENTION_BANNER]:
    "One or more social accounts need attention. Other platforms will keep publishing.",
  [AUTOMATIONS_VALIDATION_FOLDER]: "Select a folder to continue.",
  [AUTOMATIONS_VALIDATION_ACCOUNTS]: "Select at least one connected account.",
  [AUTOMATIONS_VALIDATION_WINDOW]:
    "The publishing window start must be before the end.",
  [AUTOMATIONS_VALIDATION_START_REQUIRED]: "Select a start date and time.",
  [AUTOMATIONS_VALIDATION_START_FUTURE]:
    "The start date must be now or in the future.",
  [AUTOMATIONS_VALIDATION_END_REQUIRED]: "Select an end date and time.",
  [AUTOMATIONS_VALIDATION_END_FUTURE]: "The end date must be in the future.",
  [AUTOMATIONS_VALIDATION_END_AFTER_START]:
    "The end date must be after the start date.",
  [AUTOMATIONS_HERO_QUEUED]: "Queued",
  [AUTOMATIONS_HERO_PUBLISHED]: "Published this week",
  [AUTOMATIONS_HERO_FAILED]: "Failed",
  [AUTOMATIONS_HERO_NEXT]: "Next post",
  [AUTOMATIONS_NEXT_NONE]: "—",
  [AUTOMATIONS_REMAINING_CONTENT]: "{{count}} remaining",
  [CALENDAR_SOURCE_AUTOMATED]: "Automated",
  [CALENDAR_ACTIVE_AUTOMATIONS]: "Active Automations ({{count}})",
  [CALENDAR_AUTOMATION_ENDS]: "Ends {{date}}",
  [CALENDAR_AUTOMATION_FOLDER]: "{{folder}}",
  [CALENDAR_SOURCE_MANUAL]: "Manual",
  [EVENT_DETAILS_AUTOMATION]: "Automation",
  [EVENT_DETAILS_ACCOUNT]: "Account",
  [MODAL_EDIT_AUTOMATION_TITLE]: "Edit automation",
  [AUTOMATIONS_NO_PERMISSION]:
    "You can view automations, but you cannot change them.",
  [OPTIMISTIC_SWITCH_FAILURE_BODY]:
    "Could not {{action}} {{name}} due to the following error:",
  [OPTIMISTIC_SWITCH_FAILURE_EMAIL_SUBJECT]:
    "A problem occurred updating the last status you tried to change.",
  [OPTIMISTIC_SWITCH_ACTIVATE_CAMPAIGN]: "turn on the campaign",
  [OPTIMISTIC_SWITCH_DEACTIVATE_CAMPAIGN]: "turn off the campaign",
  [OPTIMISTIC_SWITCH_ACTIVATE_ASSETS_GROUP]: "turn on the assets group",
  [OPTIMISTIC_SWITCH_DEACTIVATE_ASSETS_GROUP]: "turn off the assets group",
  [OPTIMISTIC_SWITCH_ACTIVATE_AD_GROUP]: "turn on the ad group",
  [OPTIMISTIC_SWITCH_DEACTIVATE_AD_GROUP]: "turn off the ad group",
  [OPTIMISTIC_SWITCH_ACTIVATE_AD]: "turn on the ad",
  [OPTIMISTIC_SWITCH_DEACTIVATE_AD]: "turn off the ad",
  [OPTIMISTIC_SWITCH_ACTIVATE_AUTOMATION]: "resume the automation",
  [OPTIMISTIC_SWITCH_DEACTIVATE_AUTOMATION]: "pause the automation",
  [OPTIMISTIC_SWITCH_ACTIVATE_PROMO_CODE]: "activate the code",
  [OPTIMISTIC_SWITCH_DEACTIVATE_PROMO_CODE]: "deactivate the code",
  [CREATE_CAMPAIGN_WIZARD_ARIA]: "Create campaign",
  [CREATE_CAMPAIGN_SETUP_TITLE]: "Create campaign",
  [CREATE_CAMPAIGN_SETUP_DESCRIPTION]:
    "Choose the language, locations, and a platform. Theme is optional.",
  [CREATE_CAMPAIGN_WIZARD_STEP_INSTRUCTIONS_HELP]:
    "Add optional context or attachments so the campaign matches your goal.",
  [CREATE_CAMPAIGN_WIZARD_STEP_LANGUAGE_HELP]:
    "Choose the language for ads, copy, and recommendations.",
  [CREATE_CAMPAIGN_WIZARD_STEP_LOCATIONS_HELP]:
    "Select the locations where this campaign should run.",
  [CREATE_CAMPAIGN_WIZARD_STEP_PLATFORM_HELP]:
    "Pick a platform to continue. You can go back and change it later.",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_TITLE]: "Exclusions for {{adAccountName}}",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_DESCRIPTION]:
    "Apply different types of exclusions at the account level. They apply to every current and future campaign in the account.",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNELS]: "Excluded Channels",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_VIDEOS]: "Excluded Videos",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CONTENT_CATEGORIES]: "Excluded Categories",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EXCLUDED_APPS]: "Excluded Apps",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_CATEGORIES]: "Excluded Categories",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_LOADING]: "Loading Configuration",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EMPTY_ROW]: "No data yet",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SETTINGS]: "Account exclusions",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORDS]: "Negative Keywords",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_YOUTUBE]: "YouTube",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APPS]: "Apps",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD]: "Keyword",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD_INVALID_CHARS]:
    "The keyword has characters that are not allowed (., -, /, and other symbols)",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD_MATCH_SYNTAX]:
    'Match type must be closed: [keyword] or "keyword". Do not use single quotes',
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_TYPE]: "Match type",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_BROAD]: "Broad",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_PHRASE]: "Phrase",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_EXACT]: "Exact",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNEL]: "YouTube channel",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNEL_INVALID]:
    "Use a YouTube channel link (youtube.com/channel/..., /@handle, /c/... or /user/...)",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_VIDEO]: "YouTube video",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CATEGORIES]: "Categories",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_ID]: "App ID",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_NAME]: "Name",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SEARCH_CATEGORIES]: "Search category",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EMPTY]: "No exclusions yet",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SAVED]: "Exclusions saved",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SAVE_ERROR]: "Could not save the exclusions",
  [GOOGLE_ADS_ACCOUNT_EXCLUSIONS_LOAD_ERROR]:
    "Could not load the account configuration",
  [GOOGLE_ADS_CONTENT_LABEL_BELOW_THE_FOLD]: "Content below the first screen",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_CONTENT_FOR_FAMILIES]:
    "Family content and Made for Kids",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_GAMES_FIGHTING]: "Fighting games",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_GAMES_MATURE]: "Mature games",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_HEALTH_SENSITIVE]:
    "Sensitive health",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_HEALTH_SOURCE_UNDETERMINED]:
    "Health from undetermined sources",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_RECENT]: "Recent news",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_SENSITIVE]: "Sensitive news",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_SOURCE_NOT_FEATURED]:
    "News from non-featured sources",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_POLITICS]: "Politics",
  [GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_RELIGION]: "Religion",
  [GOOGLE_ADS_CONTENT_LABEL_EMBEDDED_VIDEO]: "Embedded video",
  [GOOGLE_ADS_CONTENT_LABEL_JUVENILE]: "Juvenile, gross and bizarre content",
  [GOOGLE_ADS_CONTENT_LABEL_LIVE_STREAMING_VIDEO]: "Live streaming video",
  [GOOGLE_ADS_CONTENT_LABEL_PARKED_DOMAIN]: "Domain without a website",
  [GOOGLE_ADS_CONTENT_LABEL_PROFANITY]: "Profanity and rough language",
  [GOOGLE_ADS_CONTENT_LABEL_SEXUALLY_SUGGESTIVE]: "Sexually suggestive content",
  [GOOGLE_ADS_CONTENT_LABEL_SOCIAL_ISSUES]: "Sensitive social issues",
  [GOOGLE_ADS_CONTENT_LABEL_TRAGEDY]: "Death and tragedy",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO]: "Video",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO_NOT_YET_RATED]: "Video not yet rated",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_G]: "Rating G (general audiences)",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_MA]: "Rating MA (mature audiences)",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_PG]:
    "Rating PG (parental guidance)",
  [GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_T]: "Rating T (teens)",
  [FEATURE_ADDON_PAYWALL_TITLE]: "Upgrade this feature",
  [FEATURE_ADDON_PAYWALL_DESCRIPTION]:
    "You reached the free limit for this AppSumo feature. Choose a monthly tier to continue.",
  [FEATURE_ADDON_PAYWALL_CURRENT_LIMIT]: "Current limit: {{limit}}",
  [FEATURE_ADDON_PAYWALL_TIER_CTA]: "Subscribe",
  [FEATURE_ADDON_PAYWALL_CLOSE]: "Close",
  [FEATURE_ADDON_PAYWALL_FREE]: "Free",
  [FEATURE_ADDON_PAYWALL_INCLUDED]:
    "Your account already includes {{benefits}}",
  [FEATURE_ADDON_INCLUDED_AUTOMATIONS]:
    "{{capacity}} to publish on {{platforms}} up to {{count}} times a week",
  [FEATURE_ADDON_INCLUDED_TEMPLATES]:
    "{{capacity}} and generating up to {{produceLimit}} pieces at a time",
  [FEATURE_ADDON_INCLUDED_COMPETITORS]:
    "seeing {{visibility}} ads on {{platforms}}, saving 1 favorite, and generating 1 version",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_POOL_ONE]:
    "1 favorite or version per month",
  [FEATURE_ADDON_PAYWALL_CURRENT]: "Current",
  [FEATURE_ADDON_PAYWALL_PER_MONTH]: "USD/mo",
  [FEATURE_ADDON_BENEFIT_CAPACITY_AUTOMATIONS]:
    "Up to {{limit}} automations in your account",
  [FEATURE_ADDON_BENEFIT_CAPACITY_AUTOMATIONS_ONE]: "1 automation",
  [FEATURE_ADDON_BENEFIT_CAPACITY_TEMPLATES]:
    "Up to {{limit}} templates in your account",
  [FEATURE_ADDON_BENEFIT_CAPACITY_TEMPLATES_ONE]: "1 template",
  [FEATURE_ADDON_BENEFIT_ACTIONS]:
    "Save or generate up to {{limit}} ads per month",
  [FEATURE_ADDON_BENEFIT_ACTIONS_ONE]: "Save or generate one variation",
  [FEATURE_ADDON_BENEFIT_VISIBILITY]: "See {{limit}} ads from your competitors",
  [FEATURE_ADDON_BENEFIT_VISIBILITY_ALL]: "See all ads from your competitors",
  [FEATURE_ADDON_PAYWALL_TIER_NAME]: "Tier {{index}}",
  [FEATURE_ADDON_HERO_AUTOMATIONS]:
    "Automate publishing content to your social networks.",
  [FEATURE_ADDON_HERO_TEMPLATES]: "Generate content from templates you define.",
  [FEATURE_ADDON_HERO_COMPETITORS]:
    "Review and generate variations of the ads that work for your competitors.",
  [FEATURE_ADDON_BENEFIT_AUTOMATIONS_PUBLISH]:
    "Publish to Facebook, Instagram, Youtube, TikTok, and LinkedIn",
  [FEATURE_ADDON_BENEFIT_AUTOMATIONS_SCHEDULE]:
    "Suggest the best day and time for each type of post",
  [FEATURE_ADDON_BENEFIT_TEMPLATES_LAYERS]:
    "Define layers, groups, and properties",
  [FEATURE_ADDON_BENEFIT_TEMPLATES_ANALYZE]: "Split a creative into layers",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_SAVE]:
    "Save ads and generate your version",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_INSPIRE]:
    "Review competitor ads on Meta, Google, and LinkedIn",
  [FEATURE_ADDON_BENEFIT_AUTOMATIONS_PLATFORMS]: "Publish on {{platforms}}",
  [FEATURE_ADDON_BENEFIT_AUTOMATIONS_FREQUENCY]:
    "Up to {{count}} multiplatform posts per week per automation",
  [FEATURE_ADDON_CLARIFICATION_MULTIPLATFORM_TERM]: "Multiplatform post",
  [FEATURE_ADDON_CLARIFICATION_MULTIPLATFORM_BODY]:
    "The same post on several platforms at once counts as only 1 post.",
  [FEATURE_ADDON_BENEFIT_TEMPLATES_PRODUCE]:
    "Generate up to {{limit}} pieces at a time",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_PLATFORMS]: "Ads on {{platforms}}",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_FAVORITES]:
    "Save up to {{limit}} favorites per month",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_FAVORITES_ONE]: "Save 1 favorite",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_GENERATE]: "Generate your version",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_GENERATE_ONE]: "Generate 1 version",
  [FEATURE_ADDON_BENEFIT_COMPETITORS_POOL]:
    "Up to {{limit}} favorites or versions per month",
  [FEATURE_ADDON_NAME_AUTOMATIONS]: "Automations",
  [FEATURE_ADDON_NAME_TEMPLATES]: "Templates",
  [FEATURE_ADDON_NAME_COMPETITORS]: "Competitors",
  [FEATURE_ADDON_UNPAID_TITLE]: "Payment failed for {{feature}} {{tier}}",
  [FEATURE_ADDON_UNPAID_PERIOD]:
    "{{feature}} {{tier}} payment, from {{startDate, short}} to {{endDate, short}}",
  [FEATURE_ADDON_UNPAID_AMOUNT]: "Pending payment of {{value}} {{currency}}",
  [FEATURE_ADDON_BILLING_TITLE]: "Add-ons",
  [FEATURE_ADDON_BILLING_RENEWS]: "Renews on {{date, short}}",
  [FEATURE_ADDON_BILLING_CANCELS]: "Cancels on {{date, short}}",
  [FEATURE_ADDON_BILLING_UPGRADE]: "Upgrade plan",
  [FEATURE_ADDON_BILLING_CANCEL_TITLE]: "Cancel this addon?",
  [FEATURE_ADDON_BILLING_CANCEL_MODAL_TITLE]: "⚠️ This will cancel the add-on",
  [FEATURE_ADDON_BILLING_CANCEL_MODAL_CONFIRM]: "Cancel add-on",
  [FEATURE_ADDON_BILLING_CANCEL_MODAL_KEEP]: "Keep add-on",
  [FEATURE_ADDON_BILLING_CANCEL_DESCRIPTION]:
    "You keep this addon until {{date, day}} {{date, monthText}}, {{date, year}}. After that you move to the free plan and lose access to your paid plan benefits.",
  [FEATURE_ADDON_BILLING_CANCELLED_TITLE]: "Cancellation scheduled",
  [FEATURE_ADDON_BILLING_REACTIVATED_TITLE]: "Addon reactivated",
  [FEATURE_ADDON_BILLING_MENU]: "Addon options",
  [EXTRA_SEATS_MANAGE]: "Manage",
  [EXTRA_SEATS_MODAL_TITLE]: "Additional Team Users",
  [EXTRA_SEATS_MODAL_SUBTITLE]:
    "Your plan includes {{planUsers}} users. Extra users cost {{price}}/month each.",
  [EXTRA_SEATS_MODAL_SUBTITLE_NO_PRICE]:
    "Your plan includes {{planUsers}} users.",
  [EXTRA_SEATS_QUANTITY_LABEL]: "Extra users",
  [EXTRA_SEATS_DELTA_USERS_ONE]: "{{count}} user × {{price}}",
  [EXTRA_SEATS_DELTA_USERS]: "{{count}} users × {{price}}",
  [EXTRA_SEATS_AMOUNT_PER_MONTH]: "{{amount}}/month",
  [EXTRA_SEATS_DUE_TODAY_LABEL]: "You'll pay today",
  [EXTRA_SEATS_PRORATION_TODAY]:
    "Prorated today ({{start, d MMM}} → {{end, d MMM}})",
  [EXTRA_SEATS_NEXT_TOTAL_FROM]: "From {{date, d MMM}}",
  [EXTRA_SEATS_NEXT_TOTAL_MONTHLY]: "Each month",
  [EXTRA_SEATS_MONTHLY_TOTAL]: "Monthly total",
  [EXTRA_SEATS_KEEP_UNTIL_CYCLE_ONE]:
    "You keep your extra user until the end of the cycle.",
  [EXTRA_SEATS_KEEP_UNTIL_CYCLE]:
    "You keep your {{count}} users until the end of the cycle.",
  [EXTRA_SEATS_PRORATION_NOTE]:
    "You only pay for the days left in this cycle. Next charge: {{date, d MMM}} · {{amount}}",
  [EXTRA_SEATS_NO_CHARGE_NOTE]: "No charge today.",
  [EXTRA_SEATS_ACTIVE_MEMBERS_BLOCK_ONE]:
    "You have {{used}} active members. Remove one in {{section}} before lowering.",
  [EXTRA_SEATS_ACTIVE_MEMBERS_BLOCK]:
    "You have {{used}} active members. Remove {{count}} in {{section}} before lowering.",
  [EXTRA_SEATS_REDUCE_BLOCKED_ONE]:
    "Remove one in {{section}} before lowering.",
  [EXTRA_SEATS_REDUCE_BLOCKED]:
    "Remove {{count}} in {{section}} before lowering.",
  [EXTRA_SEATS_CONFIRM]: "Confirm",
  [EXTRA_SEATS_ADDED]: "Seat added. You can now create the user.",
  [EXTRA_SEATS_CHECKOUT_CANCELLED]: "Payment cancelled. No seat was added.",
  [EXTRA_SEATS_CHECKOUT_INCOMPLETE]:
    "The payment was not completed. No extra seat was added.",
  [EXTRA_SEATS_BILLING_ROW_TITLE]: "Additional Team Users",
  [EXTRA_SEATS_QUANTITY_BADGE]: "{{n}} Additional Users",
  [EXTRA_SEATS_REDUCE_NOTICE]:
    "Your seats will go down to {{n}} on {{date, short}}. No refund for the current period.",
  [EXTRA_SEATS_CANCEL_NOTICE]:
    "Extra seats will be cancelled on {{date, short}}.",
  [EXTRA_SEATS_CHANGE_SAVED]: "Extra seats updated.",
  [EXTRA_SEATS_FORBIDDEN]: "You don't have permission to change extra seats.",
  [EXTRA_SEATS_DECREASE]: "Fewer extra seats",
  [EXTRA_SEATS_INCREASE]: "More extra seats",
  [EXTRA_SEATS_RETRY]: "We couldn't update your extra seats. Try again.",
  [EXTRA_SEATS_REACTIVATE_NOT_ELIGIBLE]:
    "Extra seats can't be reactivated on your current plan.",
  [EXTRA_SEATS_CHECKOUT_FORBIDDEN]:
    "This payment doesn't belong to extra seats.",
  [EXTRA_SEATS_MISSING_AGENCY]:
    "We couldn't find the agency for this account, so extra seats aren't available.",
  [SEAT_LIMIT_REACHED]: "You've reached your plan's user limit.",
  [SEATS_QUANTITY_CHANGED]: "Your seats changed. Please review and try again.",
  [SEATS_OPERATION_IN_PROGRESS]:
    "Another seat change is in progress. Try again in a minute.",
  [SEATS_UNPAID]:
    "Your extra seats have an unpaid invoice. Update your payment method to add more.",
  [SEATS_QUANTITY_OUT_OF_RANGE]:
    "You can choose between {{min}} and {{max}} extra seats.",
  [SEATS_NOT_ELIGIBLE]: "Extra seats aren't available for this account.",
  [SEATS_PRICE_NOT_CONFIGURED]: "Extra seats aren't available right now.",
  [SEATS_SUBSCRIPTION_NOT_FOUND]:
    "We couldn't find your extra seats subscription.",
  [BUTTON_BULK_CREATE_CAMPAIGNS]: "Bulk Generation",
  [BULK_CAMPAIGNS_DESCRIPTION]:
    "Upload the brief of your campaigns and Adle will detect all the campaigns and the structure you want to generate.",
  [BULK_CAMPAIGNS_SUMMARY]:
    "We found a total of {{campaigns}} campaigns to generate, with up to {{maxAdGroups}} ad groups in each of them.",
  [BULK_CAMPAIGNS_LIST_TITLE]: "Campaigns that will be generated",
  [BULK_CAMPAIGNS_GENERATE]: "Generate campaigns",
  [BULK_CAMPAIGNS_GENERATING]: "Generating campaigns...",
  [BULK_CAMPAIGNS_ALERT_ANALYZING]: "Analyzing Your Campaigns Document...",
  [BULK_CAMPAIGNS_ALERT_ANALYSIS_SUCCESS]:
    "Document Analyzed. Review the Campaigns to Generate",
  [BULK_CAMPAIGNS_ALERT_ANALYSIS_ERROR]: "We Could Not Analyze the Document",
  [BULK_CAMPAIGNS_ALERT_GENERATING]: "Generating {{count}} Campaigns...",
  [BULK_CAMPAIGNS_ALERT_GENERATION_SUCCESS]: "{{count}} Campaigns Generated",
  [BULK_CAMPAIGNS_ALERT_GENERATION_ERROR]:
    "We Could Not Generate the Campaigns",
  [BULK_CAMPAIGNS_GENERATE_ERROR]:
    "We could not generate the campaigns. Please try again.",
  [BULK_CAMPAIGNS_PLATFORM_NOT_SUPPORTED]:
    "The platform {{platform}} is not available for bulk generation.",
  [BULK_CAMPAIGNS_PLATFORM_NOT_DETECTED]:
    "We could not detect the platform of this document.",
  [BULK_CAMPAIGNS_TYPE_NOT_SUPPORTED]:
    "This campaign type is not available for bulk generation.",
  [BULK_CAMPAIGNS_TITLE]: "Generate Campaigns in Bulk",
  [BULK_CAMPAIGNS_DROP_TITLE]: "Drop your file here or click to browse",
  [BULK_CAMPAIGNS_DROP_FORMATS]:
    "Excel (.xlsx), CSV, TSV, PDF, Markdown or TXT. Up to 7 MB",
  [BULK_CAMPAIGNS_ANALYZING]: "Analyzing {{fileName}}",
  [BULK_CAMPAIGNS_FILE_NOT_SUPPORTED]:
    "This file type is not supported. Use Excel (.xlsx), CSV, TSV, PDF, Markdown or TXT.",
  [BULK_CAMPAIGNS_FILE_TOO_LARGE]:
    "The file is too large. The maximum size is 7 MB.",
  [BULK_CAMPAIGNS_EXTRACT_ERROR]:
    "We could not read the structure of this file. Try again or use another file.",
  [BULK_CAMPAIGNS_CONTENTS_LOAD_ERROR]:
    "We could not load the content. Try again.",
  [BULK_CAMPAIGNS_NO_CAMPAIGNS_FOUND]:
    "We did not find any campaign structure in this file.",
  [BULK_CAMPAIGNS_CHOOSE_ANOTHER_FILE]: "Choose another file",
  [CAMPAIGN_AGENT_WELCOME_TITLE]:
    "I can apply changes to your campaign for you",
  [CAMPAIGN_AGENT_WELCOME_SUBTITLE]:
    "Ask me for an improvement, review what I propose and apply it in one click. Nothing goes live until you decide.",
  [CAMPAIGN_AGENT_STEP_ASK]: "Ask",
  [CAMPAIGN_AGENT_STEP_REVIEW]: "Review",
  [CAMPAIGN_AGENT_STEP_APPLY]: "Apply",
  [CAMPAIGN_AGENT_WELCOME_HINT]:
    "You can also type the change you want, for example: “Change the audience age to 25 to 45”.",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER]: "Ask me for a change to your campaign",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_1]:
    "Increase the campaign budget by 20%",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_2]:
    "Rewrite the copy to include the 20% off promotion",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_3]:
    "Write shorter, more direct headlines for my ads",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_4]:
    "Change the audience to people aged 25 to 40",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_5]:
    "Change the CTA on all ads to “Shop now”",
  [CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_6]:
    "Add fitness and healthy living interests to the audience",
  [CAMPAIGN_AGENT_CARD_LEARNINGS_TITLE]: "Analyze results and suggest tweaks",
  [CAMPAIGN_AGENT_CARD_LEARNINGS_DESCRIPTION]:
    "I find what works and prepare changes",
  [CAMPAIGN_AGENT_CARD_LEARNINGS_QUESTION]:
    "Analyze my campaign results and prepare specific changes you can apply.",
  [CAMPAIGN_AGENT_CARD_IMPROVE_TITLE]: "Improve my campaign",
  [CAMPAIGN_AGENT_CARD_IMPROVE_DESCRIPTION]:
    "I review targeting, copy and settings",
  [CAMPAIGN_AGENT_CARD_IMPROVE_QUESTION]:
    "Review my campaign and prepare the changes most likely to improve its results.",
  [CAMPAIGN_AGENT_CARD_BUDGET_TITLE]: "Adjust my budget",
  [CAMPAIGN_AGENT_CARD_BUDGET_DESCRIPTION]:
    "I suggest how to better distribute your spend",
  [CAMPAIGN_AGENT_CARD_BUDGET_QUESTION]:
    "Review my campaign budget and prepare the changes to optimize it.",
  [CAMPAIGN_AGENT_CARD_COPY_TITLE]: "Rewrite my ads",
  [CAMPAIGN_AGENT_CARD_COPY_DESCRIPTION]: "I write new copy ready to apply",
  [CAMPAIGN_AGENT_CARD_COPY_QUESTION]:
    "Write new copy for my campaign ads and get it ready to apply.",
  [CAMPAIGN_AGENT_IMPROVEMENTS_READY_ONE]: "1 improvement ready to apply",
  [CAMPAIGN_AGENT_IMPROVEMENTS_READY_MANY]:
    "{{count}} improvements ready to apply",
  [CAMPAIGN_AGENT_IMPROVEMENTS_READY_DESCRIPTION]:
    "Review each one and apply it to your campaign in one click. Nothing goes live until you decide.",
  [CAMPAIGN_AGENT_CHANGES_COUNT_ONE]: "1 change",
  [CAMPAIGN_AGENT_CHANGES_COUNT_MANY]: "{{count}} changes",
  [CAMPAIGN_AGENT_CREATIVE_BADGE]: "Creative",
  [CAMPAIGN_AGENT_SUMMARY_TITLE]: "What I will change",
  [CAMPAIGN_AGENT_SUMMARY_NEW_VALUE]: "New value: {{value}}",
  [CAMPAIGN_AGENT_SUMMARY_NEW_VALUES]: "{{count}} new values",
  [CAMPAIGN_AGENT_SUMMARY_ADD_ONE]: "Adds: {{value}}",
  [CAMPAIGN_AGENT_SUMMARY_ADD_MANY]: "Adds {{count}} items",
  [CAMPAIGN_AGENT_SUMMARY_REMOVE_ONE]: "Removes: {{value}}",
  [CAMPAIGN_AGENT_SUMMARY_REMOVE_ITEM]: "Removes 1 item",
  [CAMPAIGN_AGENT_SUMMARY_REMOVE_MANY]: "Removes {{count}} items",
  [CAMPAIGN_AGENT_SUMMARY_CREATE]: "Creates: {{name}}",
  [CAMPAIGN_AGENT_SUMMARY_CREATE_UNNAMED]: "Creates a new one",
  [CAMPAIGN_AGENT_SUMMARY_CREATIVE]:
    "I'll take you to the ad to change the image or video",
  [CAMPAIGN_AGENT_SUMMARY_MORE_ONE]: "+1 more change",
  [CAMPAIGN_AGENT_SUMMARY_MORE_MANY]: "+{{count}} more changes",
  [CAMPAIGN_AGENT_SUMMARY_FOOTNOTE]:
    "You'll see the full detail before applying.",
  [CAMPAIGN_AGENT_SUMMARY_CREATIVE_FOOTNOTE]:
    "When you click, I apply the changes and take you to the ad to pick the new creative.",
  [CAMPAIGN_AGENT_SUMMARY_MANUAL]:
    "I can't apply this change for you. I'll show you how to do it.",
  [BUTTON_CAMPAIGN_AGENT_REVIEW_AND_APPLY]: "Review and apply",
  [BUTTON_CAMPAIGN_AGENT_APPLY_AND_OPEN_AD]: "Apply and go to the ad",
  [BUTTON_CAMPAIGN_AGENT_VIEW_RECOMMENDATION]: "View recommendation",
  [BUTTON_CAMPAIGN_AGENT_VIEW_CHANGES]: "View Changes",
  [CAMPAIGN_AGENT_APPLIED_BADGE]: "Applied",
  [CAMPAIGN_AGENT_APPLIED_CAPTION]:
    "Applied in the editor. Publish the changes to make it live.",
  [CAMPAIGN_AGENT_DONE_CAPTION]: "Marked as done.",
  [CAMPAIGN_AGENT_DISCARDED_BADGE]: "Discarded",
  [CAMPAIGN_AGENT_DISCARDED_CAPTION]:
    "You discarded this improvement. No changes were applied.",
  [CAMPAIGN_AGENT_RESULT_APPLIED_TITLE]: "Changes applied to your campaign",
  [CAMPAIGN_AGENT_RESULT_APPLIED_DESCRIPTION]:
    "I applied “{{title}}” in the editor. To see it in your ads, publish the changes.",
  [CAMPAIGN_AGENT_RESULT_PARTIAL_TITLE]: "I applied some of the changes",
  [CAMPAIGN_AGENT_RESULT_PARTIAL_DESCRIPTION]:
    "I applied {{applied}} of {{total}} changes from “{{title}}”. Check the rest in the editor or ask me for an alternative. Remember to publish the changes.",
  [CAMPAIGN_AGENT_RESULT_FAILED_TITLE]: "I couldn't apply the changes",
  [CAMPAIGN_AGENT_RESULT_FAILED_DESCRIPTION]:
    "Something prevented applying “{{title}}” to your campaign. No changes were made. I can suggest an alternative.",
  [CAMPAIGN_AGENT_RESULT_CREATIVE_TITLE]: "I took you to the ad",
  [CAMPAIGN_AGENT_RESULT_CREATIVE_DESCRIPTION]:
    "Pick or generate the new creative for “{{title}}” from the ad preview. Then publish the changes.",
  [BUTTON_CAMPAIGN_AGENT_GO_TO_PUBLISH]: "Go to publish",
  [BUTTON_CAMPAIGN_AGENT_NEXT_IMPROVEMENT]: "See next improvement",
  [BUTTON_CAMPAIGN_AGENT_ASK_ALTERNATIVE]: "Ask for an alternative",
  [CAMPAIGN_AGENT_ASK_ALTERNATIVE_MESSAGE]:
    "“{{title}}” couldn't be applied to my campaign. Suggest an alternative you can apply.",
  [CAMPAIGN_AGENT_FOLLOW_UP_MORE_TITLE]: "What else can I improve?",
  [CAMPAIGN_AGENT_FOLLOW_UP_MORE_MESSAGE]:
    "What other change do you recommend applying to this campaign?",
  [CAMPAIGN_AGENT_FOLLOW_UP_BUDGET_TITLE]: "Adjust budget",
  [CAMPAIGN_AGENT_FOLLOW_UP_COPY_TITLE]: "Improve copy",
  [CAMPAIGN_AGENT_BUTTON_TOOLTIP]: "Ask the agent for changes to your campaign",
  [CAMPAIGN_AGENT_BUTTON_TOOLTIP_PENDING_ONE]:
    "You have 1 improvement ready to apply",
  [CAMPAIGN_AGENT_BUTTON_TOOLTIP_PENDING_MANY]:
    "You have {{count}} improvements ready to apply",
  [PAYWALL_INSUFFICIENT_CREDITS_TITLE]: "You've run out of credits!",
  [PAYWALL_INSUFFICIENT_CREDITS_SUBTITLE]:
    "You can't perform more actions for now.",
  [PAYWALL_INSUFFICIENT_CREDITS_UPGRADE_TITLE]: "Upgrade your plan",
  [PAYWALL_INSUFFICIENT_CREDITS_UPGRADE_DESCRIPTION]:
    "Get access to more credits and more features by upgrading your plan.",
  [PAYWALL_INSUFFICIENT_CREDITS_BUY_TITLE]: "Or buy credits",
  [PAYWALL_INSUFFICIENT_CREDITS_BUY_DESCRIPTION]:
    "If you just need a boost, pick a credit pack.",
  [PAYWALL_INSUFFICIENT_CREDITS_ARIA_LABEL]:
    "Out of credits: upgrade your plan or buy credits",
  [BULK_CAMPAIGNS_CONTENTS_COUNTER]: "{{count}}/{{limit}}",
  [BULK_PLATFORM_GOOGLE]: "Google",
  [BULK_PLATFORM_META]: "Meta",
  [BULK_PLATFORM_TIKTOK]: "TikTok",
  [BULK_PLATFORM_LINKEDIN]: "LinkedIn",
  [BULK_FIELD_INSTAGRAM]: "Instagram",
  [BULK_CAMPAIGNS_EMPTY_FILE]: "The file is empty. Choose a file with content.",
  [BULK_CAMPAIGNS_TOO_MANY_CONTENTS]:
    "You can select up to {{limit}} content items.",
  [BULK_CAMPAIGNS_ANALYZE]: "Analyze",
  [BULK_CAMPAIGNS_CANCEL_ANALYSIS]: "Cancel analysis",
  [BULK_CAMPAIGNS_STALE]:
    "You changed the file or the content. The previous analysis no longer applies. Analyze again.",
  [BULK_CAMPAIGNS_SELECT_CONTENTS]: "Select content",
  [BULK_CAMPAIGNS_CONTENTS_HINT]:
    "If the platform needs creatives and you do not choose any, the ads are created empty.",
  [BULK_CAMPAIGNS_REMOVE_CONTENT]: "Remove content",
  [BULK_CAMPAIGNS_FILE_READY]: "{{fileName}} ({{size}})",
  [BULK_CAMPAIGNS_REPLACE_FILE]: "Drop another file to replace it.",
  [BULK_CAMPAIGNS_RESULT_CREATED]: "Campaigns created: {{count}}",
  [BULK_CAMPAIGNS_RESULT_FAILED]: "Campaigns not created: {{count}}",
  [BULK_CAMPAIGNS_RESULT_CLEARED]: "References cleared: {{count}}",
  [BULK_CAMPAIGNS_RESULT_CLEARED_DETAIL]:
    "We removed {{field}} from campaign {{campaign}}.",
  [BULK_CAMPAIGNS_RESULT_TITLE]: "Result",
  [BULK_CAMPAIGNS_VIEW_CAMPAIGNS]: "View campaigns",
  [`${BULK_CAMPAIGNS_SUMMARY_COUNT}_one`]:
    "We found {{count}} campaign to generate.",
  [BULK_CAMPAIGNS_SUMMARY_COUNT]: "We found {{count}} campaigns to generate.",
  [BULK_CAMPAIGNS_ACCOUNTS_UNAVAILABLE]:
    "There are no ad accounts available to create these campaigns. No drafts were created and no credits were used.",
  [BULK_FIELD_PRIMARY_TEXT]: "Primary text",
  [BULK_FIELD_HEADLINE]: "Headline",
  [BULK_FIELD_LONG_HEADLINE]: "Long headline",
  [BULK_FIELD_SEARCH_THEME]: "Search theme",
  [BULK_FIELD_CALL_TO_ACTION]: "Call to action",
  [BULK_FIELD_TITLES]: "Titles",
  [BULK_FIELD_HEADLINES]: "Headlines",
  [BULK_FIELD_LONG_HEADLINES]: "Long headlines",
  [BULK_FIELD_DESCRIPTIONS]: "Descriptions",
  [BULK_FIELD_KEYWORDS]: "Keywords",
  [BULK_FIELD_KEYWORDS_NEGATIVE]: "Negative keywords",
  [BULK_FIELD_DESTINATION_URL]: "Destination URL",
  [BULK_FIELD_DAILY_BUDGET]: "Daily budget",
  [BULK_FIELD_LANGUAGE]: "Language",
  [BULK_FIELD_OBJECTIVE]: "Objective",
  [BULK_FIELD_SEARCH_THEMES]: "Search themes",
  [BULK_FIELD_CALLOUTS]: "Callouts",
  [BULK_FIELD_AUDIENCE]: "Audience",
  [BULK_FIELD_PAGE]: "Page",
  [BULK_FIELD_IDENTITY]: "Identity",
  [BULK_FIELD_APP]: "App",
  [BULK_FIELD_APP_STORE]: "App store",
  [BULK_FIELD_AD_FORMAT]: "Ad format",
  [BULK_FIELD_ACCOUNT]: "Ad account",
  [BULK_FIELD_MERCHANT]: "Merchant Center",
  [BULK_FIELD_LOCATIONS]: "Locations",
  [TIKTOK_INDUSTRY_22102000000]: "Apparel & Accessories / Bags",
  [TIKTOK_INDUSTRY_22101000000]: "Apparel & Accessories / Clothing Accessories",
  [TIKTOK_INDUSTRY_22107000000]: "Apparel & Accessories / High-end Jewelry",
  [TIKTOK_INDUSTRY_22108000000]: "Apparel & Accessories / Men's Clothing",
  [TIKTOK_INDUSTRY_22109000000]: "Apparel & Accessories / Men's Shoes",
  [TIKTOK_INDUSTRY_22106000000]: "Apparel & Accessories / Ordinary Jewelry",
  [TIKTOK_INDUSTRY_22999000000]:
    "Apparel & Accessories / Other Apparel & Accessories",
  [TIKTOK_INDUSTRY_22112000000]:
    "Apparel & Accessories / Traditional & Ceremonial Clothing",
  [TIKTOK_INDUSTRY_22105000000]: "Apparel & Accessories / Watches",
  [TIKTOK_INDUSTRY_22113000000]:
    "Apparel & Accessories / Wearable Tech Devices",
  [TIKTOK_INDUSTRY_22110000000]: "Apparel & Accessories / Women's Clothing",
  [TIKTOK_INDUSTRY_22111000000]: "Apparel & Accessories / Women's Shoes",
  [TIKTOK_INDUSTRY_16105000000]: "Appliances / Digital Devices",
  [TIKTOK_INDUSTRY_16104000000]: "Appliances / Home Appliances",
  [TIKTOK_INDUSTRY_16101000000]: "Appliances / Kitchen & Bathroom Appliances",
  [TIKTOK_INDUSTRY_16102000000]: "Appliances / Large Appliances",
  [TIKTOK_INDUSTRY_16999000000]: "Appliances / Other Appliances",
  [TIKTOK_INDUSTRY_16100000000]: "Appliances / Personal Care Appliances",
  [TIKTOK_INDUSTRY_20101000000]: "Apps / Audio & Video Players",
  [TIKTOK_INDUSTRY_20110000000]: "Apps / Business & Productivity",
  [TIKTOK_INDUSTRY_20104000000]: "Apps / Education",
  [TIKTOK_INDUSTRY_20106000000]: "Apps / Financial Services",
  [TIKTOK_INDUSTRY_20109000000]: "Apps / Health & Fitness",
  [TIKTOK_INDUSTRY_20107000000]: "Apps / Life & Leisure",
  [TIKTOK_INDUSTRY_20102000000]: "Apps / News & Reading",
  [TIKTOK_INDUSTRY_20105000000]: "Apps / Online Shopping",
  [TIKTOK_INDUSTRY_20999000000]: "Apps / Other Apps",
  [TIKTOK_INDUSTRY_20111000000]: "Apps / Parenting",
  [TIKTOK_INDUSTRY_20103000000]: "Apps / Photography",
  [TIKTOK_INDUSTRY_20100000000]: "Apps / Social",
  [TIKTOK_INDUSTRY_20108000000]: "Apps / Travel",
  [TIKTOK_INDUSTRY_20112000000]: "Apps / Utilities",
  [TIKTOK_INDUSTRY_12104000000]: "Baby, Kids & Maternity / Baby Bedding",
  [TIKTOK_INDUSTRY_12108000000]:
    "Baby, Kids & Maternity / Baby Feeding Supplies",
  [TIKTOK_INDUSTRY_12100000000]: "Baby, Kids & Maternity / Baby Food",
  [TIKTOK_INDUSTRY_12102000000]: "Baby, Kids & Maternity / Baby Formula",
  [TIKTOK_INDUSTRY_12110000000]:
    "Baby, Kids & Maternity / Baby Hygiene Products",
  [TIKTOK_INDUSTRY_12105000000]: "Baby, Kids & Maternity / Baby Shoes",
  [TIKTOK_INDUSTRY_12107000000]: "Baby, Kids & Maternity / Child Car Seats",
  [TIKTOK_INDUSTRY_12109000000]: "Baby, Kids & Maternity / Children's Apparel",
  [TIKTOK_INDUSTRY_12103000000]:
    "Baby, Kids & Maternity / Diapers & Baby Wipes",
  [TIKTOK_INDUSTRY_12999000000]:
    "Baby, Kids & Maternity / Other Baby, Kids & Maternity",
  [TIKTOK_INDUSTRY_12101000000]: "Baby, Kids & Maternity / Strollers & Cribs",
  [TIKTOK_INDUSTRY_12106000000]: "Baby, Kids & Maternity / Toys for Kids",
  [TIKTOK_INDUSTRY_14105000000]: "Beauty & Personal Care / Aesthetic Medicine",
  [TIKTOK_INDUSTRY_14104000000]: "Beauty & Personal Care / Cosmetics",
  [TIKTOK_INDUSTRY_14107000000]: "Beauty & Personal Care / Feminine Care",
  [TIKTOK_INDUSTRY_14106000000]:
    "Beauty & Personal Care / Fragrances & Perfumes",
  [TIKTOK_INDUSTRY_14101000000]: "Beauty & Personal Care / Haircare",
  [TIKTOK_INDUSTRY_14100000000]: "Beauty & Personal Care / Oral Care",
  [TIKTOK_INDUSTRY_14999000000]:
    "Beauty & Personal Care / Other Beauty & Personal Care",
  [TIKTOK_INDUSTRY_14103000000]: "Beauty & Personal Care / Skincare",
  [TIKTOK_INDUSTRY_14102000000]: "Beauty & Personal Care / Wig & Hair Styling",
  [TIKTOK_INDUSTRY_24108000000]:
    "Business Services / Agriculture, Forestry, Animal Husbandry & Fishing",
  [TIKTOK_INDUSTRY_24118000000]: "Business Services / Auction Services",
  [TIKTOK_INDUSTRY_24105000000]: "Business Services / Chemical Materials",
  [TIKTOK_INDUSTRY_24103000000]:
    "Business Services / Constructional Engineering",
  [TIKTOK_INDUSTRY_24104000000]: "Business Services / Electronics & Electrical",
  [TIKTOK_INDUSTRY_24109000000]:
    "Business Services / Energy Conservation & Environmental Protection",
  [TIKTOK_INDUSTRY_24114000000]: "Business Services / Exhibition Services",
  [TIKTOK_INDUSTRY_24107000000]: "Business Services / Franchising",
  [TIKTOK_INDUSTRY_24120000000]:
    "Business Services / Individual Entrepreneurship",
  [TIKTOK_INDUSTRY_24119000000]:
    "Business Services / Investment Planning & Management",
  [TIKTOK_INDUSTRY_24116000000]: "Business Services / IT Services",
  [TIKTOK_INDUSTRY_24117000000]: "Business Services / Legal Services",
  [TIKTOK_INDUSTRY_24111000000]: "Business Services / Logistics",
  [TIKTOK_INDUSTRY_24106000000]: "Business Services / Machinery & Equipment",
  [TIKTOK_INDUSTRY_24112000000]: "Business Services / Marketing & Advertising",
  [TIKTOK_INDUSTRY_24101000000]:
    "Business Services / Office Equipment & Supplies",
  [TIKTOK_INDUSTRY_24999000000]: "Business Services / Other Business Services",
  [TIKTOK_INDUSTRY_24113000000]:
    "Business Services / Professional Consultation",
  [TIKTOK_INDUSTRY_24100000000]:
    "Business Services / Real Estate & Home Rentals",
  [TIKTOK_INDUSTRY_24102000000]:
    "Business Services / Recruitment & Job Searching",
  [TIKTOK_INDUSTRY_24110000000]: "Business Services / Safety & Security",
  [TIKTOK_INDUSTRY_24115000000]: "Business Services / Service Outsourcing",
  [TIKTOK_INDUSTRY_30100000000]: "E-Commerce (Non-app) / Big Box Retailers",
  [TIKTOK_INDUSTRY_30102000000]:
    "E-Commerce (Non-app) / Large E-commerce Platforms",
  [TIKTOK_INDUSTRY_30101000000]:
    "E-Commerce (Non-app) / Small & Medium-sized E-commerce Platforms",
  [TIKTOK_INDUSTRY_10100000000]:
    "Education / Early Childhood & Preschool Education",
  [TIKTOK_INDUSTRY_10102000000]: "Education / Higher Education",
  [TIKTOK_INDUSTRY_10105000000]: "Education / Language Training",
  [TIKTOK_INDUSTRY_10106000000]: "Education / Non-academic Training (Hobbies)",
  [TIKTOK_INDUSTRY_10999000000]: "Education / Other Education",
  [TIKTOK_INDUSTRY_10103000000]: "Education / Overseas Education",
  [TIKTOK_INDUSTRY_10101000000]:
    "Education / Primary & Secondary Education & K-12",
  [TIKTOK_INDUSTRY_10104000000]: "Education / Vocational Training",
  [TIKTOK_INDUSTRY_13100000000]: "Financial Services / Commercial Banks",
  [TIKTOK_INDUSTRY_13108000000]: "Financial Services / Credit Bureaus",
  [TIKTOK_INDUSTRY_13117000000]: "Financial Services / Credit Cards",
  [TIKTOK_INDUSTRY_13115000000]: "Financial Services / Crowd Funding",
  [TIKTOK_INDUSTRY_13116000000]: "Financial Services / Cryptocurrencies",
  [TIKTOK_INDUSTRY_13112000000]:
    "Financial Services / Foreign Exchange Transactions",
  [TIKTOK_INDUSTRY_13107000000]: "Financial Services / Funds",
  [TIKTOK_INDUSTRY_13104000000]: "Financial Services / Guarantees",
  [TIKTOK_INDUSTRY_13102000000]: "Financial Services / Insurance",
  [TIKTOK_INDUSTRY_13110000000]: "Financial Services / Investment Advisory",
  [TIKTOK_INDUSTRY_13111000000]: "Financial Services / Loan Services",
  [TIKTOK_INDUSTRY_13109000000]: "Financial Services / Microfinance Companies",
  [TIKTOK_INDUSTRY_13999000000]:
    "Financial Services / Other Financial Services",
  [TIKTOK_INDUSTRY_13105000000]: "Financial Services / Pawn Shops",
  [TIKTOK_INDUSTRY_13113000000]: "Financial Services / Precious Metals",
  [TIKTOK_INDUSTRY_13101000000]: "Financial Services / Securities",
  [TIKTOK_INDUSTRY_13114000000]: "Financial Services / Third-Party Payments",
  [TIKTOK_INDUSTRY_1310300000]: "Financial Services / Trusts",
  [TIKTOK_INDUSTRY_27103000000]: "Food & Beverage / Alcoholic Beverages",
  [TIKTOK_INDUSTRY_27104000000]: "Food & Beverage / Cooking & Recipes",
  [TIKTOK_INDUSTRY_27100000000]: "Food & Beverage / Cuisine",
  [TIKTOK_INDUSTRY_27101000000]: "Food & Beverage / Food & Fresh Produce",
  [TIKTOK_INDUSTRY_27102000000]: "Food & Beverage / Non-alcoholic Beverages",
  [TIKTOK_INDUSTRY_27999000000]: "Food & Beverage / Other Food & Beverage",
  [TIKTOK_INDUSTRY_25301000000]: "Games / Action",
  [TIKTOK_INDUSTRY_25302000000]: "Games / Casino",
  [TIKTOK_INDUSTRY_25300000000]: "Games / Hyper-Casual",
  [TIKTOK_INDUSTRY_25313000000]: "Games / Kids",
  [TIKTOK_INDUSTRY_25303000000]: "Games / Match",
  [TIKTOK_INDUSTRY_25999000000]: "Games / Other",
  [TIKTOK_INDUSTRY_25311000000]: "Games / Party",
  [TIKTOK_INDUSTRY_25304000000]: "Games / Puzzle",
  [TIKTOK_INDUSTRY_25305000000]: "Games / Racing",
  [TIKTOK_INDUSTRY_25306000000]: "Games / RPG",
  [TIKTOK_INDUSTRY_25307000000]: "Games / Shooting",
  [TIKTOK_INDUSTRY_25308000000]: "Games / Simulation",
  [TIKTOK_INDUSTRY_25309000000]: "Games / Sports",
  [TIKTOK_INDUSTRY_25310000000]: "Games / Strategy",
  [TIKTOK_INDUSTRY_25312000000]: "Games / Tabletop",
  [TIKTOK_INDUSTRY_29102000000]: "Health / Dietary Supplements",
  [TIKTOK_INDUSTRY_29101000000]: "Health / Medical Information",
  [TIKTOK_INDUSTRY_29100000000]: "Health / Medical Services",
  [TIKTOK_INDUSTRY_29103000000]: "Health / Medicine",
  [TIKTOK_INDUSTRY_29999000000]: "Health / Other Health",
  [TIKTOK_INDUSTRY_21102000000]:
    "Home Improvement / Construction Materials & Lighting",
  [TIKTOK_INDUSTRY_21101000000]: "Home Improvement / Furniture",
  [TIKTOK_INDUSTRY_21103000000]: "Home Improvement / Hardware & Electrical",
  [TIKTOK_INDUSTRY_21104000000]: "Home Improvement / Home Decor",
  [TIKTOK_INDUSTRY_21100000000]:
    "Home Improvement / Interior Design & Decorating Services",
  [TIKTOK_INDUSTRY_21999000000]: "Home Improvement / Other Home Improvement",
  [TIKTOK_INDUSTRY_21105000000]: "Home Improvement / Power Strips & Socket",
  [TIKTOK_INDUSTRY_18106000000]: "Household Products / Cleaning Appliances",
  [TIKTOK_INDUSTRY_18110000000]: "Household Products / Cleaning Supplies",
  [TIKTOK_INDUSTRY_18104000000]: "Household Products / Coffee Accessories",
  [TIKTOK_INDUSTRY_18101000000]: "Household Products / Daily Essentials",
  [TIKTOK_INDUSTRY_18102000000]: "Household Products / Glasses & Drinkware",
  [TIKTOK_INDUSTRY_18105000000]: "Household Products / Kitchen Accessories",
  [TIKTOK_INDUSTRY_18108000000]: "Household Products / Laundry",
  [TIKTOK_INDUSTRY_18109000000]: "Household Products / Leather Care",
  [TIKTOK_INDUSTRY_18999000000]:
    "Household Products / Other Household Products",
  [TIKTOK_INDUSTRY_18112000000]: "Household Products / Pest Control",
  [TIKTOK_INDUSTRY_18100000000]: "Household Products / Storage Products",
  [TIKTOK_INDUSTRY_18103000000]: "Household Products / Tea Sets",
  [TIKTOK_INDUSTRY_18107000000]: "Household Products / Tissues & Wet Wipes",
  [TIKTOK_INDUSTRY_18111000000]: "Household Products / Toys",
  [TIKTOK_INDUSTRY_26114000000]: "Life Services / Beauty & Personal Care",
  [TIKTOK_INDUSTRY_26112000000]: "Life Services / Consumer Services",
  [TIKTOK_INDUSTRY_26102000000]:
    "Life Services / Dating & Matchmaking Services",
  [TIKTOK_INDUSTRY_26113000000]: "Life Services / Exercise & Fitness",
  [TIKTOK_INDUSTRY_26108000000]: "Life Services / Gardening",
  [TIKTOK_INDUSTRY_26104000000]: "Life Services / Gifts & Flowers",
  [TIKTOK_INDUSTRY_26105000000]: "Life Services / Housekeeping",
  [TIKTOK_INDUSTRY_26111000000]: "Life Services / Internet Services",
  [TIKTOK_INDUSTRY_26999000000]: "Life Services / Other Life Services",
  [TIKTOK_INDUSTRY_26101000000]: "Life Services / Photography",
  [TIKTOK_INDUSTRY_26106000000]: "Life Services / Shopping Services",
  [TIKTOK_INDUSTRY_26107000000]: "Life Services / Used Good Sales Platforms",
  [TIKTOK_INDUSTRY_26109000000]: "Life Services / Utilities Payments",
  [TIKTOK_INDUSTRY_26103000000]: "Life Services / Wedding Celebrations",
  [TIKTOK_INDUSTRY_26100000000]: "Life Services / Wedding Photography",
  [TIKTOK_INDUSTRY_23113000000]: "News & Entertainment / Anime",
  [TIKTOK_INDUSTRY_23114000000]: "News & Entertainment / Astrology",
  [TIKTOK_INDUSTRY_23122000000]:
    "News & Entertainment / Beauty & Personal Care",
  [TIKTOK_INDUSTRY_23102000000]: "News & Entertainment / Business & Economy",
  [TIKTOK_INDUSTRY_23126000000]: "News & Entertainment / Car Information",
  [TIKTOK_INDUSTRY_23108000000]: "News & Entertainment / Celebrities & Gossip",
  [TIKTOK_INDUSTRY_23105000000]:
    "News & Entertainment / Charity & Public Welfare",
  [TIKTOK_INDUSTRY_23111000000]:
    "News & Entertainment / Collectables & Antiques",
  [TIKTOK_INDUSTRY_23116000000]: "News & Entertainment / Culture & Art",
  [TIKTOK_INDUSTRY_23104000000]: "News & Entertainment / Culture & History",
  [TIKTOK_INDUSTRY_23128000000]:
    "News & Entertainment / E-commerce Information",
  [TIKTOK_INDUSTRY_23107000000]:
    "News & Entertainment / Environmental Protection",
  [TIKTOK_INDUSTRY_23124000000]: "News & Entertainment / Food & Cooking",
  [TIKTOK_INDUSTRY_23125000000]:
    "News & Entertainment / Games & Utility Software",
  [TIKTOK_INDUSTRY_23127000000]: "News & Entertainment / General Information",
  [TIKTOK_INDUSTRY_23115000000]: "News & Entertainment / Humor",
  [TIKTOK_INDUSTRY_23106000000]: "News & Entertainment / Law",
  [TIKTOK_INDUSTRY_23109000000]: "News & Entertainment / Lifestyle News",
  [TIKTOK_INDUSTRY_23110000000]: "News & Entertainment / Live Events",
  [TIKTOK_INDUSTRY_23100000000]: "News & Entertainment / Military",
  [TIKTOK_INDUSTRY_23119000000]: "News & Entertainment / Movies",
  [TIKTOK_INDUSTRY_23999000000]:
    "News & Entertainment / Other News & Entertainment",
  [TIKTOK_INDUSTRY_23129000000]: "News & Entertainment / Pet Information",
  [TIKTOK_INDUSTRY_23101000000]: "News & Entertainment / Politics",
  [TIKTOK_INDUSTRY_23118000000]: "News & Entertainment / Reading",
  [TIKTOK_INDUSTRY_23130000000]:
    "News & Entertainment / Real Estate Information",
  [TIKTOK_INDUSTRY_23131000000]:
    "News & Entertainment / Relationship Information",
  [TIKTOK_INDUSTRY_23103000000]: "News & Entertainment / Science & Technology",
  [TIKTOK_INDUSTRY_23134000000]:
    "News & Entertainment / Social Media Account Promotion",
  [TIKTOK_INDUSTRY_23123000000]: "News & Entertainment / Sports & Fitness",
  [TIKTOK_INDUSTRY_23132000000]: "News & Entertainment / Streaming Site",
  [TIKTOK_INDUSTRY_23133000000]: "News & Entertainment / Tourist Information",
  [TIKTOK_INDUSTRY_23112000000]: "News & Entertainment / TV Drama & Series",
  [TIKTOK_INDUSTRY_23117000000]: "News & Entertainment / TV Variety Shows",
  [TIKTOK_INDUSTRY_19999000000]: "Pets / Other Pets",
  [TIKTOK_INDUSTRY_19103000000]: "Pets / Pet Grooming",
  [TIKTOK_INDUSTRY_19101000000]: "Pets / Pet Healthcare",
  [TIKTOK_INDUSTRY_19102000000]: "Pets / Pet Household Products",
  [TIKTOK_INDUSTRY_19105000000]: "Pets / Pet Toys",
  [TIKTOK_INDUSTRY_19106000000]: "Pets / Pet Travel Accessories",
  [TIKTOK_INDUSTRY_19104000000]: "Pets / Pet Treats",
  [TIKTOK_INDUSTRY_19100000000]: "Pets / Petfood",
  [TIKTOK_INDUSTRY_28100000000]: "Sports & Outdoor / Outdoor Equipment",
  [TIKTOK_INDUSTRY_28101000000]: "Sports & Outdoor / Sports & Equipment",
  [TIKTOK_INDUSTRY_15100000000]: "Tech & Electronics / Cell Phones",
  [TIKTOK_INDUSTRY_15105000000]: "Tech & Electronics / Computer Accessories",
  [TIKTOK_INDUSTRY_15103000000]: "Tech & Electronics / Computer Repair",
  [TIKTOK_INDUSTRY_15101000000]: "Tech & Electronics / Computers",
  [TIKTOK_INDUSTRY_15102000000]: "Tech & Electronics / Computers Components",
  [TIKTOK_INDUSTRY_15104000000]: "Tech & Electronics / Gaming Devices",
  [TIKTOK_INDUSTRY_15106000000]: "Tech & Electronics / Network Products",
  [TIKTOK_INDUSTRY_15107000000]: "Tech & Electronics / Office Equipment",
  [TIKTOK_INDUSTRY_15999000000]:
    "Tech & Electronics / Other Tech & Electronics",
  [TIKTOK_INDUSTRY_17103000000]: "Travel / Hotels & Accommodation",
  [TIKTOK_INDUSTRY_17999000000]: "Travel / Other Travel",
  [TIKTOK_INDUSTRY_17105000000]: "Travel / Tours & Attractions",
  [TIKTOK_INDUSTRY_17106000000]: "Travel / Travel Agencies & Services",
  [TIKTOK_INDUSTRY_11111000000]:
    "Vehicle & Transportation / Accessories for 2/3-Wheeled Vehicles",
  [TIKTOK_INDUSTRY_11110000000]: "Vehicle & Transportation / Airplanes",
  [TIKTOK_INDUSTRY_11101000000]: "Vehicle & Transportation / Auto Accessories",
  [TIKTOK_INDUSTRY_11103000000]: "Vehicle & Transportation / Auto Parts",
  [TIKTOK_INDUSTRY_11102000000]: "Vehicle & Transportation / Auto Services",
  [TIKTOK_INDUSTRY_11100000000]: "Vehicle & Transportation / Automobiles",
  [TIKTOK_INDUSTRY_11107000000]: "Vehicle & Transportation / Bicycles",
  [TIKTOK_INDUSTRY_11112000000]: "Vehicle & Transportation / Car Dealerships",
  [TIKTOK_INDUSTRY_11104000000]: "Vehicle & Transportation / Car Rentals",
  [TIKTOK_INDUSTRY_11108000000]: "Vehicle & Transportation / Electric Scooters",
  [TIKTOK_INDUSTRY_11106000000]: "Vehicle & Transportation / Motorcycles",
  [TIKTOK_INDUSTRY_11999000000]:
    "Vehicle & Transportation / Other Vehicle & Transportation",
  [TIKTOK_INDUSTRY_11105000000]: "Vehicle & Transportation / Used Cars",
  [TIKTOK_INDUSTRY_11109000000]: "Vehicle & Transportation / Water Vehicles",
  [META_ATTRIBUTION_WINDOW_TITLE]: "Attribution window",
  [META_ATTRIBUTION_WINDOW_DESCRIPTION]:
    "How many days after someone clicks or views the ad Meta credits a conversion to this ad set.",
  [META_ATTRIBUTION_WINDOW_7D_CLICK_1D_VIEW]: "7-day click + 1-day view",
  [META_ATTRIBUTION_WINDOW_7D_CLICK]: "7-day click",
  [META_ATTRIBUTION_WINDOW_1D_CLICK_1D_VIEW]: "1-day click + 1-day view",
  [META_ATTRIBUTION_WINDOW_1D_CLICK]: "1-day click",
  [META_ATTRIBUTION_WINDOW_DEFAULT_OPTION]: "{{window}} (default)",
  [META_ATTRIBUTION_ENGAGED_VIEW_LABEL]:
    "Include 1-day engaged view (people who interacted with the ad or watched at least 5 seconds of the video)",
  [WHITE_LABEL_TITLE]: "White-label",
  [WHITE_LABEL_BUY]: "Buy",
  [WHITE_LABEL_PRICE_PER_MONTH]: "{{price}}/month",
  [WHITE_LABEL_DIALOG_BODY]:
    "Your own brand on the platform: logo, colors, domain and emails without Adle branding.",
  [WHITE_LABEL_NO_SETUP_FEE]: "No setup fee. Cancel anytime.",
  [WHITE_LABEL_AFTER_PAYMENT]:
    "After payment you complete your brand and our team sets it up.",
  [WHITE_LABEL_APP_SUMO_CONFIRM]:
    "This purchase is made for the whole agency and billed monthly, separately from your AppSumo license. Continue?",
  [WHITE_LABEL_ONLY_OWNER]: "Only the account owner can buy.",
  [WHITE_LABEL_STATUS_PENDING_BRANDING]: "Complete your brand",
  [WHITE_LABEL_STATUS_CONFIGURING]: "Being set up",
  [WHITE_LABEL_STATUS_ACTIVE]: "Active",
  [WHITE_LABEL_STATUS_REVERT_PENDING]: "Cancelled",
  [WHITE_LABEL_ALREADY_ACTIVE]: "Already active",
  [WHITE_LABEL_COMPLETE_BRAND]: "Complete brand",
  [WHITE_LABEL_EDIT_BRAND]: "Edit brand",
  [WHITE_LABEL_FORM_TITLE]: "Set up your brand",
  [WHITE_LABEL_FORM_INTRO]:
    "Customize your space's visual identity and how users will see it.",
  [WHITE_LABEL_FORM_SECTION_GENERAL]: "01 · General information",
  [WHITE_LABEL_FORM_SECTION_VISUAL]: "02 · Visual identity",
  [WHITE_LABEL_FORM_SECTION_VISUAL_HELP]:
    "Upload the graphics your brand will use.",
  [WHITE_LABEL_FORM_SECTION_COLORS]: "03 · Color palette",
  [WHITE_LABEL_FORM_SECTION_COLORS_HELP]:
    "Choose the colors that will represent your brand.",
  [WHITE_LABEL_FORM_SECTION_DOMAIN]: "04 · Domain and notes",
  [WHITE_LABEL_FORM_BADGE_REQUIRED]: "Required",
  [WHITE_LABEL_FORM_BADGE_OPTIONAL]: "Optional",
  [WHITE_LABEL_FORM_DROP_TITLE]: "Drop your logo here",
  [WHITE_LABEL_FORM_DROP_HINT]: "Or choose a file · PNG, JPG or SVG",
  [WHITE_LABEL_FORM_INVALID_FILE]: "Invalid file.",
  [WHITE_LABEL_FORM_DOMAIN_BLOCKED]: "You can't use the adle.ai domain.",
  [WHITE_LABEL_FORM_DOMAIN_INVALID]: "Invalid domain.",
  [WHITE_LABEL_FORM_COLOR_INVALID]: "Use a hex color, for example #1A2B3C.",
  [WHITE_LABEL_FORM_NAME_INVALID]:
    "The name must be between 2 and 60 characters.",
  [WHITE_LABEL_FORM_NOTES_INVALID]:
    "Notes can't be longer than 500 characters.",
  [WHITE_LABEL_FORM_LOGO_NAV_HELP]: "For the left bar.",
  [WHITE_LABEL_FORM_LOGO_LOGIN_HELP]: "For the sign-in screen.",
  [WHITE_LABEL_FORM_FAVICON_CAPTION]: "Browser icon",
  [WHITE_LABEL_FORM_FAVICON_HELP]: "Image shown in the browser tab.",
  [WHITE_LABEL_FORM_NAME_PLACEHOLDER]: "E.g. My Digital Agency",
  [WHITE_LABEL_FORM_DOMAIN_PLACEHOLDER]: "app.youragency.com",
  [WHITE_LABEL_FORM_NOTES_PLACEHOLDER]:
    "Any extra instruction about your brand?",
  [WHITE_LABEL_FORM_COLOR_PRIMARY]: "Primary",
  [WHITE_LABEL_FORM_COLOR_SECONDARY]: "Secondary",
  [WHITE_LABEL_FORM_COLOR_BUTTONS]: "Buttons",
  [WHITE_LABEL_FORM_NAME_BUSINESS]: "Business name",
  [WHITE_LABEL_FORM_LOGO]: "Main logo",
  [WHITE_LABEL_FORM_LOGO_NAVBAR]: "Navigation logo",
  [WHITE_LABEL_FORM_LOGO_LOGIN]: "Sign-in logo",
  [WHITE_LABEL_FORM_FAVICON]: "Favicon",
  [WHITE_LABEL_FORM_PRIMARY_COLOR]: "Primary color",
  [WHITE_LABEL_FORM_SECONDARY_COLOR]: "Secondary color",
  [WHITE_LABEL_FORM_PRIMARY_BUTTON_COLOR]: "Button color (optional)",
  [WHITE_LABEL_FORM_DESIRED_DOMAIN]: "Desired domain",
  [WHITE_LABEL_FORM_DOMAIN_HELP]: "We'll email you how to point your domain.",
  [WHITE_LABEL_FORM_NOTES]: "Notes for the team (optional)",
  [WHITE_LABEL_FORM_SUBMIT]: "Submit brand",
  [WHITE_LABEL_FORM_SUBMITTED]:
    "We got your brand. Our team will set it up and let you know.",
  [WHITE_LABEL_CONFIRMING_PAYMENT]: "Confirming your payment…",
  [WHITE_LABEL_CHECKOUT_CANCELLED]: "Payment cancelled. You were not charged.",
  [WHITE_LABEL_NOT_ELIGIBLE]:
    "Your plan can't buy white-label. Contact us for a quote.",
  [WHITE_LABEL_ERROR_ALREADY_ACTIVE]:
    "White-label is already active on your account.",
  [WHITE_LABEL_NOT_PURCHASED]: "You need to buy white-label first.",
  [WHITE_LABEL_INVALID_BRANDING]: "Please check the highlighted field.",
  [WHITE_LABEL_INVALID_TRANSITION]:
    "This white-label status change is not allowed.",
  [AGENCY_ACCOUNT_LINKING_PICKER_TITLE]: "Your connected ad accounts",
  [AGENCY_ACCOUNT_LINKING_PICKER_SHEET_TITLE]:
    "Get better results and deeper analysis",
  [AGENCY_ACCOUNT_LINKING_PICKER_SHEET_DESCRIPTION]:
    "Let Adle access your ad accounts to analyze and optimize your campaigns. The owners of the ad accounts you choose to connect will receive an email or notification that a connection was established with {{NAME_BUSINESS}}.",
  [AGENCY_ACCOUNT_LINKING_CONSENT]:
    "Let Adle access these accounts to analyze and optimize your campaigns",
  [AGENCY_ACCOUNT_LINKING_CONSENT_TOOLTIP]:
    "Adle uses this to review performance and suggest improvements to your campaigns.",
  [AGENCY_ACCOUNT_LINKING_CONSENT_INFO]: "More information",
  [AGENCY_ACCOUNT_LINKING_CARD_TITLE]:
    "Get better results and deeper analysis.",
  [AGENCY_ACCOUNT_LINKING_CARD_BODY]:
    "Let Adle access your ad accounts to analyze and optimize your campaigns.",
  [AGENCY_ACCOUNT_LINKING_ENABLE]: "Enable",
  [AGENCY_ACCOUNT_LINKING_NOT_NOW]: "Not now",
  [AGENCY_ACCOUNT_LINKING_SHEET_TITLE]:
    "Choose Which Client Accounts to Include",
  [AGENCY_ACCOUNT_LINKING_SHEET_DESCRIPTION]:
    "The owners of the ad accounts you want to connect will get an email or notification that a connection was established with {{NAME_BUSINESS}}.",
  [AGENCY_ACCOUNT_LINKING_CONFIRM_ALERT_TITLE]: "Confirm connection",
  [AGENCY_ACCOUNT_LINKING_CONFIRM_ALERT_BODY]:
    "The owners of the ad accounts will get an email or notification about the connection with {{NAME_BUSINESS}}.",
  [AGENCY_ACCOUNT_LINKING_CONFIRM]: "Confirm ({{count}})",
  [AGENCY_ACCOUNT_LINKING_TOAST_DONE_ONE]:
    "Done, Adle can now help optimize your account",
  [AGENCY_ACCOUNT_LINKING_TOAST_DONE_OTHER]:
    "Done, Adle can now help optimize your {{count}} accounts",
  [AGENCY_ACCOUNT_LINKING_TOAST_PARTIAL]:
    "Done. Adle can help optimize {{linked}} of {{total}} accounts.",
  [AGENCY_ACCOUNT_LINKING_TOAST_LATER]:
    "We couldn't finish this just now. You can try again in a moment.",
  [AGENCY_ACCOUNT_LINKING_PLATFORM_META]: "Meta",
  [AGENCY_ACCOUNT_LINKING_PLATFORM_GOOGLE]: "Google Ads",
  [AGENCY_ACCOUNT_LINKING_PLATFORM_TIKTOK]: "TikTok",
  [AGENCY_ACCOUNT_LINKING_SHEET_LINKING]:
    "Linking accounts, this can take a few seconds…",
  [AGENCY_ACCOUNT_LINKING_SHEET_PARTIAL_TITLE]: "Some accounts were not linked",
  [AGENCY_ACCOUNT_LINKING_SHEET_PARTIAL_BODY]:
    "We linked {{linked}} of {{total}}. Review each account and follow the step shown.",
  [AGENCY_ACCOUNT_LINKING_SHEET_FAILED_TITLE]:
    "We couldn't link these accounts",
  [AGENCY_ACCOUNT_LINKING_SHEET_FAILED_BODY]:
    "No accounts were linked. Review the reason and the next step.",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVAL_TITLE]:
    "The client still needs to approve",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVAL_BODY]:
    "The client must approve the request before Adle can use these accounts.",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_META]:
    "The client must approve the request in Meta Business Settings → Requests.",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_GOOGLE]:
    "The client must approve the request in Google Ads → Admin → Access and security → Managers.",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_TIKTOK]:
    "The client must approve the request in TikTok Ads Manager → Notifications → Business Center.",
  [AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_GENERIC]:
    "The client must approve the request in the ad platform.",
  [AGENCY_ACCOUNT_LINKING_SHEET_NOT_CONFIGURED]:
    "Adle is still finishing the setup for this platform. Our team has been notified and we'll retry automatically, so you don't need to do anything.",
  [AGENCY_ACCOUNT_LINKING_SHEET_RECONNECT]:
    "Reconnect the platform and check that you have admin permissions.",
  [AGENCY_ACCOUNT_LINKING_SHEET_RETRY_STEP]: "You can try again.",
  [AGENCY_ACCOUNT_LINKING_SHEET_REQUEST_AGAIN]:
    "The client rejected or removed access, or the request expired. Ask them to accept it and try again.",
  [AGENCY_ACCOUNT_LINKING_SHEET_SUPPORT]:
    "This account needs a review. Contact Adle support and we'll help you link it.",
  [AGENCY_ACCOUNT_LINKING_SHEET_IN_PROGRESS_TITLE]:
    "Linking already in progress",
  [AGENCY_ACCOUNT_LINKING_SHEET_IN_PROGRESS]:
    "A link is already in progress. Wait a moment and try again.",
  [AGENCY_ACCOUNT_LINKING_SHEET_PROCESSING_TITLE]: "Linking still in progress",
  [AGENCY_ACCOUNT_LINKING_SHEET_PROCESSING]:
    "Linking is still in progress. Wait a moment and try again if it does not finish.",
  [AGENCY_ACCOUNT_LINKING_COLUMN_STATUS]: "Status",
  [AGENCY_ACCOUNT_LINKING_COLUMN_DETAILS]: "Details",
  [AGENCY_ACCOUNT_LINKING_STATUS_UNLINKED]: "Not linked",
  [AGENCY_ACCOUNT_LINKING_STATUS_PENDING]: "Pending",
  [AGENCY_ACCOUNT_LINKING_STATUS_FAILED]: "Failed",
  [AGENCY_ACCOUNT_LINKING_STATUS_LINKED]: "Linked",
  [AGENCY_ACCOUNT_LINKING_DETAIL_NOT_ADMIN]:
    "The connected user is not an admin of this account.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_RECONNECT]:
    "Reconnect the account with admin permissions.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_UNREADABLE]:
    "We could not read this connection.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_NOT_CONFIGURED]:
    "Adle cannot link this platform yet.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_NOT_IN_BUSINESS]:
    "This account is not in a Business Manager or Business Center.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_LIMIT]:
    "This account reached the manager limit.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_MANAGED_ELSEWHERE]:
    "This account is already managed in another hierarchy.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_INCOMPATIBLE]:
    "These accounts cannot be linked to each other.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_REJECTED]:
    "The link was declined on the platform.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_EXPIRED]: "The pending link expired.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_REVOKED]: "The link is no longer active.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_UNSUPPORTED]:
    "This platform cannot be linked yet.",
  [AGENCY_ACCOUNT_LINKING_DETAIL_GENERIC]: "We could not finish this link.",
  [ADLE_CARD_WAITLIST_EYEBROW]: "Coming soon",
  [ADLE_CARD_WAITLIST_TITLE]: "Adle Card: One Card for All Your Campaigns",
  [ADLE_CARD_WAITLIST_SUBTITLE]:
    "Pay Meta, Google, and TikTok from a single balance and stop losing campaign days to declined payments.",
  [ADLE_CARD_WAITLIST_FEATURE_VIRTUAL_CARDS]:
    "One virtual card per brand, created in one click",
  [ADLE_CARD_WAITLIST_FEATURE_SINGLE_BALANCE]:
    "One prepaid balance for Meta, Google, and TikTok",
  [ADLE_CARD_WAITLIST_FEATURE_CASHBACK]: "1.5% cashback on all your ad spend",
  [ADLE_CARD_WAITLIST_FEATURE_NO_FEES]: "No monthly fee and no spend limits",
  [ADLE_CARD_WAITLIST_FEATURE_NO_DECLINES]:
    "No more declined payments that pause your campaigns",
  [ADLE_CARD_WAITLIST_FEATURE_TOP_UPS]:
    "Top-ups by ACH or bank transfer (minimum USD 1,000)",
  [ADLE_CARD_WAITLIST_EMAIL_LABEL]: "Email",
  [ADLE_CARD_WAITLIST_COUNTRY_LABEL]: "Your company's country",
  [ADLE_CARD_WAITLIST_COUNTRY_PLACEHOLDER]: "Select your country",
  [ADLE_CARD_WAITLIST_CTA]: "Join the waitlist",
  [ADLE_CARD_WAITLIST_NOT_NOW]: "Not now",
  [ADLE_CARD_WAITLIST_DISCLAIMER]:
    "No commitment. We'll let you know when Adle Card is available in your country.",
  [ADLE_CARD_WAITLIST_SUCCESS_TITLE]: "You're on the List!",
  [ADLE_CARD_WAITLIST_SUCCESS_DESCRIPTION]:
    "We'll write to {{email}} as soon as we open the first access.",
  [ADLE_CARD_WAITLIST_SUBMIT_ERROR]: "We couldn't save your signup. Try again.",
  [ADLE_CARD_WAITLIST_BANNER]:
    "New: Adle Card, one balance for Meta, Google, and TikTok with 1.5% cashback.",
  [ADLE_CARD_WAITLIST_BANNER_LINK]: "Join the list",
  [ADLE_CARD_WAITLIST_CARD_ARIA]: "Adle Card illustration",
  [ADLE_CARD_WAITLIST_CARD_VIRTUAL]: "Virtual",
  [ADLE_CARD_WAITLIST_CARD_BRAND_FALLBACK]: "Your brand",
  [OWNER_DASHBOARD_NAV_ADLE_CARD_WAITLIST]: "Adle Card waitlist",
  [`${ADLE_CARD_WAITLIST_ADMIN_TOTAL}_one`]: "{{count}} signup",
  [ADLE_CARD_WAITLIST_ADMIN_TOTAL]: "{{count}} signups",
  [ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_ALL_TIME]: "All-time spend (USD)",
  [ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_3M]: "Last 3 months spend (USD)",
  [ADLE_CARD_WAITLIST_ADMIN_SPEND_UNAVAILABLE]: "Ad spend could not be loaded.",
};

export default translation;
